// Generated file with FE Schema. Do not modify manually!
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
// Generated on 2026-10-25T15:02:17-04:00

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  EmailAddress: any;
  JSON: any;
  URL: any;
};

export type AbcModel = {
  __typename?: 'AbcModel';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  a?: Maybe<Scalars['String']>;
  b?: Maybe<Scalars['String']>;
  behaviors?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  emotions: Array<Maybe<Emotion>>;
  feelings: Array<Maybe<Scalars['Int']>>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type AbcModelInput = {
  data: AbcModelInputData;
  where: AbcModelInputWhere;
};

export type AbcModelInputData = {
  a?: InputMaybe<Scalars['String']>;
  b?: InputMaybe<Scalars['String']>;
  behaviors?: InputMaybe<Scalars['String']>;
  emotions: Array<InputMaybe<EmotionInput>>;
  feelings: Array<InputMaybe<Scalars['Int']>>;
};

export type AbcModelInputWhere = {
  _id?: InputMaybe<Scalars['ID']>;
  clientId?: InputMaybe<Scalars['ID']>;
};

export type AbcModelSearch = {
  __typename?: 'AbcModelSearch';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<AbcModel>>>;
};

export type AccountDeletionStatus = {
  __typename?: 'AccountDeletionStatus';
  dueBy?: Maybe<Scalars['DateTime']>;
  pending: Scalars['Boolean'];
  requestedAt?: Maybe<Scalars['DateTime']>;
};

export type ActionOriginInput = {
  kind: Scalars['String'];
  ref: Scalars['String'];
};

export type ActivateExperimentInput = {
  experimentId: Scalars['ID'];
  subject?: InputMaybe<Scalars['ID']>;
};

export type ActivatingEvent = {
  __typename?: 'ActivatingEvent';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  behaviors?: Maybe<Scalars['String']>;
  bodyPartsFeelings: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  emotions: Array<Emotion>;
  feelings: Array<Scalars['Int']>;
  imageUrl?: Maybe<Array<Scalars['URL']>>;
  interval?: Maybe<Interval>;
  location?: Maybe<Location>;
  participantIds?: Maybe<Array<Scalars['String']>>;
  thoughts?: Maybe<Array<Thought>>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type ActivatingEventCreateInput = {
  behaviors?: InputMaybe<Scalars['String']>;
  bodyPartsFeelings: Scalars['Int'];
  description: Scalars['String'];
  emotions: Array<EmotionInput>;
  feelings: Array<Scalars['Int']>;
  imageUrl?: InputMaybe<Array<Scalars['URL']>>;
  interval?: InputMaybe<IntervalInput>;
  locationId?: InputMaybe<Scalars['String']>;
  participantIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ActivatingEventResponse = {
  __typename?: 'ActivatingEventResponse';
  activatingEvent?: Maybe<ActivatingEvent>;
};

export type ActivatingEventUpdateInput = {
  _id: Scalars['ID'];
  behaviors?: InputMaybe<Scalars['String']>;
  bodyPartsFeelings: Scalars['Int'];
  description: Scalars['String'];
  emotions: Array<EmotionInput>;
  feelings: Array<Scalars['Int']>;
  imageUrl?: InputMaybe<Array<Scalars['URL']>>;
  interval?: InputMaybe<IntervalInput>;
  locationId?: InputMaybe<Scalars['String']>;
  participantIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ActivityChoices = {
  __typename?: 'ActivityChoices';
  groups: Array<ValueActivities>;
  subject: Scalars['ID'];
};

export type ActivityDay = {
  __typename?: 'ActivityDay';
  day: Scalars['String'];
  gaps: Array<Scalars['String']>;
  hours: Array<ActivityDayHour>;
  mood?: Maybe<Scalars['Int']>;
  subject: Scalars['ID'];
};

export type ActivityDayHour = {
  __typename?: 'ActivityDayHour';
  activityLogId?: Maybe<Scalars['ID']>;
  endAt?: Maybe<Scalars['DateTime']>;
  enjoyment: Scalars['Int'];
  importance: Scalars['Int'];
  kind: Scalars['String'];
  plannedActivityId?: Maybe<Scalars['ID']>;
  source: Scalars['String'];
  start: Scalars['String'];
  startAt: Scalars['DateTime'];
  title: Scalars['String'];
  valueActivityId?: Maybe<Scalars['ID']>;
};

export type ActivityDaySummaryInput = {
  activeMinutes: Scalars['Int'];
  date: Scalars['String'];
  stepCount: Scalars['Int'];
  workouts: Array<HealthWorkoutInput>;
};

export type ActivityIdea = {
  __typename?: 'ActivityIdea';
  area?: Maybe<Scalars['String']>;
  difficulty?: Maybe<Scalars['Int']>;
  forYourValue?: Maybe<Scalars['String']>;
  ideaId?: Maybe<Scalars['String']>;
  origin: Scalars['String'];
  text: Scalars['String'];
};

export type ActivityIdeas = {
  __typename?: 'ActivityIdeas';
  ideas: Array<ActivityIdea>;
  libraryId?: Maybe<Scalars['String']>;
  subject: Scalars['ID'];
};

export type ActivityLadder = {
  __typename?: 'ActivityLadder';
  rankedAt?: Maybe<Scalars['DateTime']>;
  rankedBy?: Maybe<Scalars['ID']>;
  rankingId?: Maybe<Scalars['ID']>;
  rungs: Array<LadderRung>;
  subject: Scalars['ID'];
};

export type ActivityPlan = {
  __typename?: 'ActivityPlan';
  doneThisWeek: Scalars['Int'];
  plannedThisWeek: Scalars['Int'];
  subject: Scalars['ID'];
  week: Scalars['String'];
  weekPlan: Array<PlanDay>;
};

export type ActivitySuggestionsPayload = {
  __typename?: 'ActivitySuggestionsPayload';
  code?: Maybe<Scalars['String']>;
  recorded: Scalars['Boolean'];
  requestId: Scalars['ID'];
  suggestions: Array<SuggestedActivity>;
};

export type ActivityWeek = {
  __typename?: 'ActivityWeek';
  activityDays: Array<ActivityWeekPhoneDay>;
  byLifeArea: Array<AreaHours>;
  done: Scalars['Int'];
  emptyAreas: Array<Scalars['String']>;
  healthActivity?: Maybe<HealthActivityWeek>;
  hours: Array<ActivityWeekHour>;
  missed: Scalars['Int'];
  moodByDay: Array<MoodByDay>;
  moods: Array<ActivityWeekMood>;
  planned: Scalars['Int'];
  plans: Array<PlanItem>;
  predictedVsActual: PredictedVsActual;
  subject: Scalars['ID'];
  topBarrier?: Maybe<Scalars['String']>;
  week: Scalars['String'];
};

export type ActivityWeekHour = {
  __typename?: 'ActivityWeekHour';
  activityLogId: Scalars['ID'];
  area?: Maybe<Scalars['String']>;
  endAt: Scalars['DateTime'];
  enjoyment: Scalars['Int'];
  importance: Scalars['Int'];
  startAt: Scalars['DateTime'];
  title: Scalars['String'];
  valueActivityId?: Maybe<Scalars['ID']>;
};

export type ActivityWeekMood = {
  __typename?: 'ActivityWeekMood';
  date: Scalars['String'];
  mood: Scalars['Int'];
};

export type ActivityWeekPhoneDay = {
  __typename?: 'ActivityWeekPhoneDay';
  activeMinutes: Scalars['Int'];
  date: Scalars['String'];
};

export type AdaptySyncEventInput = {
  /** a restore: did Adapty's profile carry an active premium */
  hasActivePremium?: InputMaybe<Scalars['Boolean']>;
  /** 'purchase' | 'restore' */
  kind: Scalars['String'];
  /** 'success' | 'user_cancelled' | 'pending' (a purchase); only success is recorded */
  purchaseResultType?: InputMaybe<Scalars['String']>;
  subscriptionExpiredAt?: InputMaybe<Scalars['DateTime']>;
  vendorProductId?: InputMaybe<Scalars['String']>;
};

export type AddCycleThoughtInput = {
  subject?: InputMaybe<Scalars['ID']>;
  thought?: InputMaybe<Scalars['String']>;
  viciousCycleId: Scalars['ID'];
};

export type AllRecordsPage = {
  __typename?: 'AllRecordsPage';
  count: Scalars['Int'];
  rows: Array<AllRecordsRow>;
  toolCounts: Array<AllRecordsToolCount>;
};

export type AllRecordsRow = {
  __typename?: 'AllRecordsRow';
  day?: Maybe<Scalars['String']>;
  hidden: Scalars['Boolean'];
  metric?: Maybe<RecordMetric>;
  nightKind?: Maybe<Scalars['String']>;
  occurredAt: Scalars['DateTime'];
  performer?: Maybe<Scalars['ID']>;
  recordId: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
  subject: Scalars['ID'];
  summary?: Maybe<Scalars['String']>;
  tool: Scalars['String'];
};

export type AllRecordsToolCount = {
  __typename?: 'AllRecordsToolCount';
  count: Scalars['Int'];
  tool: Scalars['String'];
};

export type AmendExpositionReactionInput = {
  expositionId: Scalars['ID'];
  exposureStimulusId: Scalars['ID'];
  reactedAt: Scalars['DateTime'];
  reactionId: Scalars['ID'];
  subject?: InputMaybe<Scalars['ID']>;
  sud: Scalars['Int'];
};

export type AmendHomeworkInput = {
  assignmentId: Scalars['ID'];
  dueAt?: InputMaybe<Scalars['DateTime']>;
  instructions?: InputMaybe<Scalars['String']>;
  paperAllowed?: InputMaybe<Scalars['Boolean']>;
  reminderPolicy?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<EsReminderScheduleInput>;
  title?: InputMaybe<Scalars['String']>;
};

export type AppLock = {
  __typename?: 'AppLock';
  deviceId: Scalars['ID'];
  enabled: Scalars['Boolean'];
  exemptions: Array<Scalars['String']>;
  lockAfterMinutes?: Maybe<Scalars['Int']>;
  method?: Maybe<Scalars['String']>;
  subject: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AppLockCommandPayload = {
  __typename?: 'AppLockCommandPayload';
  deviceId: Scalars['ID'];
  recorded: Scalars['Boolean'];
};

export type AppMinVersion = {
  __typename?: 'AppMinVersion';
  minSupportedVersion?: Maybe<Scalars['String']>;
  minSupportedVersionAndroid?: Maybe<Scalars['String']>;
  minSupportedVersionIos?: Maybe<Scalars['String']>;
};

export type AreaHours = {
  __typename?: 'AreaHours';
  area: Scalars['String'];
  hours: Scalars['Float'];
};

export type AssessmentChange = {
  __typename?: 'AssessmentChange';
  subscales: Array<AssessmentSubscaleChange>;
  total: Scalars['Int'];
};

export type AssessmentCommandPayload = {
  __typename?: 'AssessmentCommandPayload';
  id: Scalars['ID'];
  recorded: Scalars['Boolean'];
};

export type AssessmentInterpretation = {
  __typename?: 'AssessmentInterpretation';
  assessmentId: Scalars['ID'];
  band?: Maybe<Scalars['String']>;
  bandIsWorstSubscale: Scalars['Boolean'];
  bandKey?: Maybe<Scalars['String']>;
  changeSinceLast?: Maybe<AssessmentChange>;
  instrumentId: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  previousSubscales?: Maybe<Array<AssessmentSubscaleReading>>;
  previousTotal?: Maybe<Scalars['Int']>;
  subject: Scalars['ID'];
  subscales: Array<AssessmentSubscaleReading>;
  total: Scalars['Int'];
  totalBand?: Maybe<Scalars['String']>;
  totalBandKey?: Maybe<Scalars['String']>;
  type: Scalars['Int'];
};

export type AssessmentItem9 = {
  __typename?: 'AssessmentItem9';
  answer?: Maybe<Scalars['Int']>;
  answerKey?: Maybe<Scalars['String']>;
  questionKey: Scalars['String'];
};

export type AssessmentSubscaleChange = {
  __typename?: 'AssessmentSubscaleChange';
  change: Scalars['Int'];
  name: Scalars['String'];
};

export type AssessmentSubscaleReading = {
  __typename?: 'AssessmentSubscaleReading';
  band?: Maybe<Scalars['String']>;
  bandKey?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  score: Scalars['Int'];
};

export type AssignHomeworkInput = {
  activityTarget?: InputMaybe<Scalars['JSON']>;
  dueAt?: InputMaybe<Scalars['DateTime']>;
  instructions?: InputMaybe<Scalars['String']>;
  kind: Scalars['String'];
  paperAllowed?: InputMaybe<Scalars['Boolean']>;
  reminderPolicy?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<EsReminderScheduleInput>;
  subject?: InputMaybe<Scalars['ID']>;
  target?: InputMaybe<HomeworkTargetInput>;
  title?: InputMaybe<Scalars['String']>;
  titleName?: InputMaybe<Scalars['String']>;
};

export type AuthTokenPayload = {
  __typename?: 'AuthTokenPayload';
  accessExpiresAt: Scalars['DateTime'];
  accessToken: Scalars['String'];
  refreshExpiresAt: Scalars['DateTime'];
  refreshToken: Scalars['String'];
};

export type BaCommandPayload = {
  __typename?: 'BaCommandPayload';
  assignmentId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  recorded: Scalars['Boolean'];
};

export type BackofficeMember = {
  __typename?: 'BackofficeMember';
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  grantedAt: Scalars['DateTime'];
  grantedBy?: Maybe<Scalars['String']>;
  grantedByEmail?: Maybe<Scalars['String']>;
  isLast: Scalars['Boolean'];
  subject: Scalars['String'];
};

export type BackofficePracticeRow = {
  __typename?: 'BackofficePracticeRow';
  capabilities: Array<PracticeCapabilityRow>;
  clientCount: Scalars['Int'];
  createdAt?: Maybe<Scalars['String']>;
  practiceId: Scalars['ID'];
  practiceName?: Maybe<Scalars['String']>;
};

export enum BackofficePracticesOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export type BackofficePracticesPage = {
  __typename?: 'BackofficePracticesPage';
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  rows: Array<BackofficePracticeRow>;
  total: Scalars['Int'];
};

export enum BackofficePracticesSort {
  Clients = 'clients',
  Created = 'created',
  Name = 'name',
}

export type BackofficeShell = {
  __typename?: 'BackofficeShell';
  isMember: Scalars['Boolean'];
  sections: Array<Scalars['String']>;
};

export type BasicThought = {
  __typename?: 'BasicThought';
  thought: Scalars['String'];
  thoughtBelief: Scalars['Int'];
};

export type BasicThoughtInput = {
  thought: Scalars['String'];
  thoughtBelief: Scalars['Int'];
};

export type BehaviorExperiment = {
  __typename?: 'BehaviorExperiment';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  activatedAt?: Maybe<Scalars['DateTime']>;
  activeSubtype?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  design: Scalars['Int'];
  experimentId?: Maybe<Scalars['ID']>;
  followUpExperimentsIdeas?: Maybe<Scalars['String']>;
  helpfulCopingStrategies?: Maybe<Scalars['String']>;
  hypothesisA?: Maybe<Scalars['String']>;
  hypothesisAConfirmationCriteria?: Maybe<Scalars['String']>;
  hypothesisAStrength?: Maybe<Scalars['Int']>;
  hypothesisB?: Maybe<Scalars['String']>;
  hypothesisBConfirmationCriteria?: Maybe<Scalars['String']>;
  hypothesisBStrength?: Maybe<Scalars['Int']>;
  hypothesisType: Scalars['Int'];
  observationalSubtype?: Maybe<Scalars['Int']>;
  observations?: Maybe<Array<BehaviorExperimentObservation>>;
  outcome: BehaviorExperimentOutcome;
  prediction: BehaviorExperimentPrediction;
  purpose: Scalars['Int'];
  safetyBehaviors?: Maybe<Scalars['String']>;
  settings: BehaviorExperimentSettings;
  status?: Maybe<Scalars['String']>;
  therapistId?: Maybe<Scalars['ID']>;
  type: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type BehaviorExperimentInput = {
  data: BehaviorExperimentInputData;
  where: BehaviorExperimentInputWhere;
};

export type BehaviorExperimentInputData = {
  activeSubtype?: InputMaybe<Scalars['Int']>;
  design: Scalars['Int'];
  followUpExperimentsIdeas?: InputMaybe<Scalars['String']>;
  helpfulCopingStrategies?: InputMaybe<Scalars['String']>;
  hypothesisA?: InputMaybe<Scalars['String']>;
  hypothesisAConfirmationCriteria?: InputMaybe<Scalars['String']>;
  hypothesisAStrength?: InputMaybe<Scalars['Int']>;
  hypothesisB?: InputMaybe<Scalars['String']>;
  hypothesisBConfirmationCriteria?: InputMaybe<Scalars['String']>;
  hypothesisBStrength?: InputMaybe<Scalars['Int']>;
  hypothesisType: Scalars['Int'];
  observationalSubtype?: InputMaybe<Scalars['Int']>;
  outcome: BehaviorExperimentOutcomeInput;
  prediction: BehaviorExperimentPredictionInput;
  purpose: Scalars['Int'];
  safetyBehaviors?: InputMaybe<Scalars['String']>;
  settings: BehaviorExperimentSettingsInput;
  type: Scalars['Int'];
};

export type BehaviorExperimentInputWhere = {
  _id?: InputMaybe<Scalars['ID']>;
  clientId?: InputMaybe<Scalars['ID']>;
};

export type BehaviorExperimentObservation = {
  __typename?: 'BehaviorExperimentObservation';
  behaviors?: Maybe<Scalars['String']>;
  emotions: Array<Emotion>;
  feelings: Array<Scalars['Int']>;
  learnings?: Maybe<Scalars['String']>;
  observationId: Scalars['ID'];
  occurredAt: Scalars['DateTime'];
  rating?: Maybe<Scalars['Int']>;
  whatHappened?: Maybe<Scalars['String']>;
  whichHypothesisHeld?: Maybe<Scalars['Int']>;
};

export type BehaviorExperimentOutcome = {
  __typename?: 'BehaviorExperimentOutcome';
  behaviors?: Maybe<Scalars['String']>;
  emotions: Array<Maybe<Emotion>>;
  feelings: Array<Maybe<Scalars['Int']>>;
  meaningForOriginalBelief?: Maybe<Scalars['String']>;
  newLearnings?: Maybe<Scalars['String']>;
  newThought?: Maybe<Scalars['String']>;
  newThoughtStrength?: Maybe<Scalars['Int']>;
  oldThoughtStrength?: Maybe<Scalars['Int']>;
  otherPredictions?: Maybe<Scalars['String']>;
  patientReflections?: Maybe<Scalars['String']>;
  therapistReflections?: Maybe<Scalars['String']>;
};

export type BehaviorExperimentOutcomeInput = {
  behaviors?: InputMaybe<Scalars['String']>;
  emotions: Array<InputMaybe<EmotionInput>>;
  feelings: Array<InputMaybe<Scalars['Int']>>;
  meaningForOriginalBelief?: InputMaybe<Scalars['String']>;
  newLearnings?: InputMaybe<Scalars['String']>;
  newThought?: InputMaybe<Scalars['String']>;
  newThoughtStrength?: InputMaybe<Scalars['Int']>;
  oldThoughtStrength?: InputMaybe<Scalars['Int']>;
  otherPredictions?: InputMaybe<Scalars['String']>;
  patientReflections?: InputMaybe<Scalars['String']>;
  therapistReflections?: InputMaybe<Scalars['String']>;
};

export type BehaviorExperimentPayload = {
  __typename?: 'BehaviorExperimentPayload';
  behaviorExperiment?: Maybe<BehaviorExperiment>;
  experimentId: Scalars['ID'];
};

export type BehaviorExperimentPrediction = {
  __typename?: 'BehaviorExperimentPrediction';
  behaviors?: Maybe<Scalars['String']>;
  emotions: Array<Maybe<Emotion>>;
  feelings: Array<Maybe<Scalars['Int']>>;
  otherPredictions?: Maybe<Scalars['String']>;
};

export type BehaviorExperimentPredictionInput = {
  behaviors?: InputMaybe<Scalars['String']>;
  emotions: Array<InputMaybe<EmotionInput>>;
  feelings: Array<InputMaybe<Scalars['Int']>>;
  otherPredictions?: InputMaybe<Scalars['String']>;
};

export type BehaviorExperimentPredictionPatchInput = {
  behaviors?: InputMaybe<Scalars['String']>;
  emotions?: InputMaybe<Array<EmotionInput>>;
  feelings?: InputMaybe<Array<Scalars['Int']>>;
  otherPredictions?: InputMaybe<Scalars['String']>;
};

export type BehaviorExperimentSearch = {
  __typename?: 'BehaviorExperimentSearch';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<BehaviorExperiment>>>;
};

export type BehaviorExperimentSettings = {
  __typename?: 'BehaviorExperimentSettings';
  experiment?: Maybe<Scalars['String']>;
  people?: Maybe<Scalars['String']>;
  place?: Maybe<Scalars['String']>;
  resources?: Maybe<Scalars['String']>;
  survey?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
};

export type BehaviorExperimentSettingsInput = {
  experiment?: InputMaybe<Scalars['String']>;
  people?: InputMaybe<Scalars['String']>;
  place?: InputMaybe<Scalars['String']>;
  resources?: InputMaybe<Scalars['String']>;
  survey?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['String']>;
};

export type BehaviorExperimentSuggestions = {
  __typename?: 'BehaviorExperimentSuggestions';
  activeSubtype?: Maybe<Scalars['Int']>;
  design?: Maybe<Scalars['Int']>;
  followUpExperimentsIdeas?: Maybe<Scalars['String']>;
  helpfulCopingStrategies?: Maybe<Scalars['String']>;
  hypothesisA?: Maybe<Scalars['String']>;
  hypothesisAConfirmationCriteria?: Maybe<Scalars['String']>;
  hypothesisAStrength?: Maybe<Scalars['Int']>;
  hypothesisB?: Maybe<Scalars['String']>;
  hypothesisBConfirmationCriteria?: Maybe<Scalars['String']>;
  hypothesisBStrength?: Maybe<Scalars['Int']>;
  hypothesisType?: Maybe<Scalars['Int']>;
  observationalSubtype?: Maybe<Scalars['Int']>;
  prediction?: Maybe<BehaviorExperimentPrediction>;
  purpose?: Maybe<Scalars['Int']>;
  safetyBehaviors?: Maybe<Scalars['String']>;
  settings?: Maybe<BehaviorExperimentSettings>;
  type?: Maybe<Scalars['Int']>;
};

export type BehaviorExperimentSuggestionsPayload = {
  __typename?: 'BehaviorExperimentSuggestionsPayload';
  requestId: Scalars['ID'];
  suggestions?: Maybe<BehaviorExperimentSuggestions>;
};

export type CancelHomeworkInput = {
  assignmentId: Scalars['ID'];
  reason: Scalars['String'];
};

export type CaseloadOverviewRow = {
  __typename?: 'CaseloadOverviewRow';
  checkInsInUse: Scalars['Boolean'];
  daysSinceCheckIn?: Maybe<Scalars['Int']>;
  diaryDaysThisWeek?: Maybe<Scalars['Int']>;
  diaryInUse: Scalars['Boolean'];
  homeworkBehind?: Maybe<Scalars['Int']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  lastCheckInDay?: Maybe<Scalars['String']>;
  lastSession?: Maybe<ClientHeaderSession>;
  latestScores?: Maybe<Array<CaseloadScore>>;
  maxScoreRise?: Maybe<Scalars['Float']>;
  scoreWentUp: Scalars['Boolean'];
  signals: CaseloadSignals;
  subject: Scalars['ID'];
  therapist?: Maybe<Scalars['ID']>;
  therapistName?: Maybe<Scalars['String']>;
  toolsInUse?: Maybe<Array<Scalars['String']>>;
  view: Scalars['Boolean'];
};

export type CaseloadScore = {
  __typename?: 'CaseloadScore';
  at: Scalars['DateTime'];
  change?: Maybe<Scalars['Float']>;
  instrument: Scalars['String'];
  previous?: Maybe<Scalars['Float']>;
  score: Scalars['Float'];
  wentUp: Scalars['Boolean'];
};

export type CaseloadSignals = {
  __typename?: 'CaseloadSignals';
  diaryNotFilledThisWeek: Scalars['Boolean'];
  homeworkBehind: Scalars['Boolean'];
  noCheckIn7Days: Scalars['Boolean'];
  scoreWentUp: Scalars['Boolean'];
};

export type ChangeBalance = {
  __typename?: 'ChangeBalance';
  consOfChange: Array<Scalars['String']>;
  consOfStaying: Array<Scalars['String']>;
  prosOfChange: Array<Scalars['String']>;
  prosOfStaying: Array<Scalars['String']>;
  writtenAt: Scalars['DateTime'];
};

export type ChangeJourney = {
  __typename?: 'ChangeJourney';
  balance?: Maybe<ChangeBalance>;
  changeTalk: Array<Scalars['String']>;
  closedAt?: Maybe<Scalars['DateTime']>;
  closingNote?: Maybe<Scalars['String']>;
  goalId: Scalars['ID'];
  journal: Array<ChangeTalkLine>;
  label: Scalars['String'];
  lastActivityAt: Scalars['DateTime'];
  linkedValues: Array<Scalars['String']>;
  myReasons: Array<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  plan?: Maybe<ChangePlan>;
  rulersOverTime: Array<ChangeRulersAt>;
  setAt: Scalars['DateTime'];
  setBy?: Maybe<Scalars['ID']>;
  status: Scalars['String'];
  subject: Scalars['ID'];
  urica?: Maybe<UricaReading>;
};

export type ChangePlan = {
  __typename?: 'ChangePlan';
  changes: Scalars['String'];
  helpers: Array<Scalars['String']>;
  obstacles: Array<ChangePlanObstacle>;
  planSteps: Array<ChangePlanStep>;
  reasons: Array<Scalars['String']>;
  signsOfSuccess?: Maybe<Scalars['String']>;
  writtenAt: Scalars['DateTime'];
};

export type ChangePlanObstacle = {
  __typename?: 'ChangePlanObstacle';
  obstacle: Scalars['String'];
  response?: Maybe<Scalars['String']>;
};

export type ChangePlanObstacleInput = {
  obstacle: Scalars['String'];
  response?: InputMaybe<Scalars['String']>;
};

export type ChangePlanStep = {
  __typename?: 'ChangePlanStep';
  step: Scalars['String'];
  when?: Maybe<Scalars['String']>;
};

export type ChangePlanStepInput = {
  step: Scalars['String'];
  when?: InputMaybe<Scalars['String']>;
};

export type ChangeRulersAt = {
  __typename?: 'ChangeRulersAt';
  confidence: Scalars['Int'];
  focusedRuler?: Maybe<Scalars['String']>;
  importance: Scalars['Int'];
  occurredAt: Scalars['DateTime'];
  readiness: Scalars['Int'];
};

export type ChangeTalkLine = {
  __typename?: 'ChangeTalkLine';
  kind?: Maybe<Scalars['String']>;
  noteId: Scalars['ID'];
  noticedAt: Scalars['DateTime'];
  talk: Scalars['String'];
};

/** E43 · a day's active minutes from the phone. */
export type CheckInActivityDay = {
  __typename?: 'CheckInActivityDay';
  activeMinutes: Scalars['Int'];
  date: Scalars['String'];
};

export type CheckInCommandPayload = {
  __typename?: 'CheckInCommandPayload';
  checkInId: Scalars['ID'];
  recorded: Scalars['Boolean'];
};

export type CheckInEmotion = {
  __typename?: 'CheckInEmotion';
  id: Scalars['Int'];
  strength: Scalars['Int'];
};

export type CheckInEmotionInput = {
  id: Scalars['Int'];
  strength: Scalars['Int'];
};

/**
 * E37 · one check-in as the views show it. `enteredInSession` marks an entry the client's therapist made in
 * session; the therapist's id is never on a row (a client-facing view carries the mark, not the person).
 * `practiceId` is the entering practice — filled only in the practice's view.
 */
export type CheckInEntry = {
  __typename?: 'CheckInEntry';
  checkInId: Scalars['ID'];
  drivers?: Maybe<Array<Scalars['String']>>;
  emotions?: Maybe<Array<CheckInEmotion>>;
  energy?: Maybe<Scalars['Int']>;
  enteredInSession: Scalars['Boolean'];
  mood: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
  occurredAt: Scalars['DateTime'];
  practiceId?: Maybe<Scalars['ID']>;
  recordedFor: Scalars['String'];
  sleepHours?: Maybe<Scalars['Float']>;
  sleepQuality?: Maybe<Scalars['Int']>;
  socialConnection?: Maybe<Scalars['Int']>;
};

export type CheckInLowestDay = {
  __typename?: 'CheckInLowestDay';
  checkInId: Scalars['ID'];
  day: Scalars['String'];
  mood: Scalars['Int'];
  note?: Maybe<Scalars['String']>;
};

/** E43 · the session recap's phone averages over what the therapist may see (null: not shared, or nothing yet). */
export type CheckInPhoneAverages = {
  __typename?: 'CheckInPhoneAverages';
  activeMinutes?: Maybe<Scalars['Int']>;
  asleepMinutes?: Maybe<Scalars['Int']>;
  efficiency?: Maybe<Scalars['Int']>;
};

/**
 * E37 · CheckInsSinceLastSession — the session form's recap: what happened since the client's previous session
 * (`since`; with none, the last 14 days — `firstSession`). Counts and averages are computed by the query from the
 * rows. Needs a granted relation (HOMEWORK_NOT_YOUR_CLIENT).
 */
export type CheckInRecap = {
  __typename?: 'CheckInRecap';
  activityDays?: Maybe<Array<CheckInActivityDay>>;
  checkIns: Scalars['Int'];
  diaryHighlights?: Maybe<DiaryRecap>;
  entries: Array<CheckInEntry>;
  firstSession: Scalars['Boolean'];
  inSessionCheckIns: Scalars['Int'];
  moodAverage?: Maybe<Scalars['Float']>;
  moodLowest?: Maybe<CheckInLowestDay>;
  phoneAverages: CheckInPhoneAverages;
  sessionId?: Maybe<Scalars['ID']>;
  sharedTypes: CheckInSharedTypes;
  since?: Maybe<Scalars['DateTime']>;
  sleepAverageHours?: Maybe<Scalars['Float']>;
  sleepNights?: Maybe<Array<CheckInSleepNight>>;
  subject: Scalars['ID'];
  topDrivers: Array<CheckInTopDriver>;
};

/** E43 · which of the phone's two check-in rows the caller sees (a therapist: the client's choice for them, default off). */
export type CheckInSharedTypes = {
  __typename?: 'CheckInSharedTypes';
  activity: Scalars['Boolean'];
  sleep: Scalars['Boolean'];
};

/** E43 · a night from the phone beside the check-in of the day the person WOKE (`wakeDay` = the night's evening + 1). */
export type CheckInSleepNight = {
  __typename?: 'CheckInSleepNight';
  asleepMinutes: Scalars['Int'];
  /** asleep ÷ time in bed, whole %; null when the time in bed is unknown */
  efficiency?: Maybe<Scalars['Int']>;
  inBedEnd: Scalars['DateTime'];
  inBedStart: Scalars['DateTime'];
  night: Scalars['String'];
  wakeDay: Scalars['String'];
};

export type CheckInTopDriver = {
  __typename?: 'CheckInTopDriver';
  count: Scalars['Int'];
  driver: Scalars['String'];
};

export type ChooseBehaviorStrategyInSessionInput = {
  beliefs: Array<Scalars['String']>;
  comparedWith: Array<Scalars['ID']>;
  sharedBy: Array<Scalars['String']>;
  strategyId: Scalars['ID'];
  subject: Scalars['ID'];
  value: Scalars['String'];
};

export type ChooseBehaviorStrategyInput = {
  beliefs: Array<Scalars['String']>;
  choiceId: Scalars['ID'];
  comparedWith: Array<Scalars['ID']>;
  sharedBy: Array<Scalars['String']>;
  strategyId: Scalars['ID'];
  value: Scalars['String'];
};

export type ClearSleepWindowInput = {
  reason?: InputMaybe<Scalars['String']>;
  subject: Scalars['ID'];
  windowId: Scalars['ID'];
};

export type Client = {
  __typename?: 'Client';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  access?: Maybe<ClientDataAccess>;
  accessLevel?: Maybe<Scalars['String']>;
  activeSubscriptions?: Maybe<UserSubscriptions>;
  cardsViewedStats?: Maybe<UsageEventStatsResponse>;
  createdAt: Scalars['DateTime'];
  crisisStats?: Maybe<UsageEventStatsResponse>;
  dayRemindersReactedStats?: Maybe<UsageEventStatsResponse>;
  dayRemindersTriggeredStats?: Maybe<UsageEventStatsResponse>;
  diagnoses?: Maybe<Array<Maybe<Scalars['String']>>>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['EmailAddress'];
  enabledDayRemindersCount?: Maybe<EnabledDayRemindersCount>;
  enabledLocationRemindersCount?: Maybe<EnabledLocationRemindersCount>;
  esMode?: Maybe<EsMode>;
  fcmToken?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['Int']>;
  homeworkAppReady?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lng: Scalars['String'];
  locationRemindersReactedStats?: Maybe<UsageEventStatsResponse>;
  locationRemindersTriggeredStats?: Maybe<UsageEventStatsResponse>;
  meditationsStats?: Maybe<UsageEventStatsResponse>;
  mostUsedStats?: Maybe<Array<Maybe<MostUsedStats>>>;
  photoUrl?: Maybe<Scalars['String']>;
  preferredPronouns?: Maybe<Scalars['Int']>;
  providerId: Scalars['String'];
  role: Scalars['Int'];
  stripeCustomerId?: Maybe<Scalars['String']>;
  tests?: Maybe<Array<Maybe<Test>>>;
  thoughts?: Maybe<PortalThoughts>;
  timezone: Scalars['String'];
  uid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  workShared?: Maybe<Scalars['Boolean']>;
};

export type ClientActivityDay = {
  __typename?: 'ClientActivityDay';
  activeMinutes: Scalars['Int'];
  date: Scalars['String'];
  stepCount: Scalars['Int'];
  workouts: Array<HealthWorkout>;
};

/** E43 · ClientActivitySummary — the caller's days of steps, active minutes and workouts, and the averages. */
export type ClientActivitySummary = {
  __typename?: 'ClientActivitySummary';
  activityDays: Array<ClientActivityDay>;
  averageActiveMinutes?: Maybe<Scalars['Int']>;
  averageSteps?: Maybe<Scalars['Int']>;
  days: Scalars['Int'];
  subject: Scalars['ID'];
};

export type ClientAssessmentTrend = {
  __typename?: 'ClientAssessmentTrend';
  definition?: Maybe<InstrumentDefinition>;
  instrumentId?: Maybe<Scalars['String']>;
  rows: Array<ClientAssessmentTrendRow>;
  subject: Scalars['ID'];
};

export type ClientAssessmentTrendRow = {
  __typename?: 'ClientAssessmentTrendRow';
  assessmentId?: Maybe<Scalars['ID']>;
  band?: Maybe<Scalars['String']>;
  bandIsWorstSubscale: Scalars['Boolean'];
  bandKey?: Maybe<Scalars['String']>;
  changeSinceLast?: Maybe<AssessmentChange>;
  externalAssessmentId?: Maybe<Scalars['ID']>;
  instrumentId?: Maybe<Scalars['String']>;
  instrumentName: Scalars['String'];
  item9?: Maybe<AssessmentItem9>;
  maxScore?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  occurredAt: Scalars['DateTime'];
  practiceId?: Maybe<Scalars['ID']>;
  source: Scalars['String'];
  subject: Scalars['ID'];
  subscales: Array<AssessmentSubscaleReading>;
  total: Scalars['Int'];
};

export type ClientChangeGoals = {
  __typename?: 'ClientChangeGoals';
  changes: Array<ChangeJourney>;
  subject: Scalars['ID'];
  urica?: Maybe<UricaReading>;
};

/**
 * E37 · ClientCheckInTrend — the client hub's Check-ins tab: the check-ins in a 14/30/90-day window for the caller's
 * practice (the client's own + the entries THIS practice entered in session; another practice's never). Needs a
 * granted relation (HOMEWORK_NOT_YOUR_CLIENT).
 */
export type ClientCheckInTrend = {
  __typename?: 'ClientCheckInTrend';
  activityDays?: Maybe<Array<CheckInActivityDay>>;
  days: Scalars['Int'];
  daysCheckedIn: Scalars['Int'];
  entries: Array<CheckInEntry>;
  sharedTypes: CheckInSharedTypes;
  sleepNights?: Maybe<Array<CheckInSleepNight>>;
  subject: Scalars['ID'];
};

export type ClientDataAccess = {
  __typename?: 'ClientDataAccess';
  allowAdminEdit: Scalars['Boolean'];
  allowAdminView: Scalars['Boolean'];
  allowEdit: Scalars['Boolean'];
  allowView: Scalars['Boolean'];
};

export type ClientDigest = {
  __typename?: 'ClientDigest';
  cards: Array<DigestCard>;
  noSession: Scalars['Boolean'];
  sinceDate: Scalars['DateTime'];
  subject: Scalars['ID'];
  workShared: Scalars['Boolean'];
};

export type ClientHeader = {
  __typename?: 'ClientHeader';
  accessLevel?: Maybe<Scalars['String']>;
  appClient: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastSession?: Maybe<ClientHeaderSession>;
  reviewSession?: Maybe<ClientHeaderReview>;
  role?: Maybe<Scalars['Int']>;
  subject: Scalars['ID'];
};

export type ClientHeaderReview = {
  __typename?: 'ClientHeaderReview';
  reviewSessionId: Scalars['ID'];
  startedAt: Scalars['DateTime'];
};

export type ClientHeaderSession = {
  __typename?: 'ClientHeaderSession';
  end?: Maybe<Scalars['DateTime']>;
  start: Scalars['DateTime'];
};

/**
 * E43 · ClientHealthTimeline — the client hub's Sleep & activity: the types the client shares with THIS therapist (a type
 * not shared is null — "not shared"), check-in mood by day and PHQ-9 / GAD-7 points, on one axis. Numbers only.
 */
export type ClientHealthTimeline = {
  __typename?: 'ClientHealthTimeline';
  activityDays?: Maybe<Array<ClientActivityDay>>;
  days: Scalars['Int'];
  heartRateDays?: Maybe<Array<ClientHeartRateDay>>;
  moodByDay: Array<HealthTimelineMood>;
  nights?: Maybe<Array<ClientSleepNight>>;
  scores: Array<HealthTimelineScore>;
  sharedTypes: Array<Scalars['String']>;
  subject: Scalars['ID'];
};

export type ClientHeartRateDay = {
  __typename?: 'ClientHeartRateDay';
  date: Scalars['String'];
  hrv?: Maybe<HeartRateVariability>;
  restingHeartRate?: Maybe<Scalars['Int']>;
};

/** E43 · ClientHeartSummary — the caller's resting heart rate and HRV per day, and the average resting heart rate. */
export type ClientHeartSummary = {
  __typename?: 'ClientHeartSummary';
  averageRestingHeartRate?: Maybe<Scalars['Int']>;
  days: Scalars['Int'];
  heartRateDays: Array<ClientHeartRateDay>;
  subject: Scalars['ID'];
};

/**
 * E34 · ClientHomework — one row per assignment on the client hub's Homework tab: the practice's own
 * assignments, and the client's self-set ones while the client shares their record with the caller
 * (read-only). `status`: open · viewed · done · skipped · cancelled (kept, greyed) — a one-off row's is
 * the lifecycle fact it folded last; a RECURRING row reads open while it has an open occurrence (the
 * founder's Q-b1c-6 C), each occurrence's outcome in `outcomes`. `overdue` (a one-off open or viewed
 * past `dueAt`; a recurring row whose open occurrence is due), `nextDueAt` (a schedule row's OPEN
 * occurrence — Q-b1a-4 B), `outcomes` and `awaitingReply` (the latest comment is the client's own) are
 * computed at read time. `requesterName` is looked up at read time from `requester`.
 */
export type ClientHomework = {
  __typename?: 'ClientHomework';
  activityTarget?: Maybe<Scalars['JSON']>;
  assignedAt: Scalars['DateTime'];
  assignmentId: Scalars['ID'];
  awaitingReply: Scalars['Boolean'];
  clientCommentUnanswered: Scalars['Boolean'];
  completedAt?: Maybe<Scalars['DateTime']>;
  dueAt?: Maybe<Scalars['DateTime']>;
  evidence?: Maybe<HomeworkEvidence>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  instructions?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  lastNoticeChannels?: Maybe<Scalars['String']>;
  lastRemindedAt?: Maybe<Scalars['DateTime']>;
  nextDueAt?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  occurrenceAt?: Maybe<Scalars['DateTime']>;
  outcomes: Array<HomeworkOccurrenceOutcome>;
  overdue: Scalars['Boolean'];
  paperAllowed: Scalars['Boolean'];
  paperPhoto?: Maybe<HomeworkPaperPhoto>;
  performer?: Maybe<Scalars['ID']>;
  practiceId?: Maybe<Scalars['ID']>;
  reason?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  reminderPolicy: Scalars['String'];
  requester: Scalars['ID'];
  requesterName?: Maybe<Scalars['String']>;
  schedule?: Maybe<EsReminderScheduleValue>;
  source?: Maybe<HomeworkSource>;
  status: Scalars['String'];
  subject: Scalars['ID'];
  target?: Maybe<HomeworkTarget>;
  title: Scalars['String'];
};

export type ClientHomeworkAccess = {
  __typename?: 'ClientHomeworkAccess';
  canAssign: Scalars['Boolean'];
};

/**
 * E34 · the Homework tab's filter chips (Q-hw-page-2 A) — an enum, so a chip the server does not know is a
 * schema error, never a silent "all".
 */
export enum ClientHomeworkChip {
  All = 'all',
  AwaitingReply = 'awaitingReply',
  Cancelled = 'cancelled',
  Done = 'done',
  Open = 'open',
  Overdue = 'overdue',
  Skipped = 'skipped',
}

/**
 * E34 · ClientHomeworkCounts — the filter chips' numbers for the WHOLE client (Q-hw-page-2 A): every row the
 * caller may see, whatever the chip and the page. open = open or viewed; overdue = open or viewed and past
 * due; awaitingReply never counts a withdrawn row.
 */
export type ClientHomeworkCounts = {
  __typename?: 'ClientHomeworkCounts';
  all: Scalars['Int'];
  awaitingReply: Scalars['Int'];
  cancelled: Scalars['Int'];
  done: Scalars['Int'];
  open: Scalars['Int'];
  overdue: Scalars['Int'];
  skipped: Scalars['Int'];
};

/**
 * E34 · ClientHomeworkPage — one page of the hub's Homework tab (Q-hw-page-2 A, founder 2026-10-04): `rows`
 * in the total order (open and viewed first; then done and skipped, newest finished first; then withdrawn,
 * newest finished first; assignmentId last), `total` (the rows under the chosen chip), `page` (the page
 * SERVED — a page past the end answers the last one), `pageSize` (at most 50) and the whole client's `counts`.
 */
export type ClientHomeworkPage = {
  __typename?: 'ClientHomeworkPage';
  counts: ClientHomeworkCounts;
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  rows: Array<ClientHomework>;
  total: Scalars['Int'];
};

/**
 * E43 · one night as the views show it: time in bed and efficiency (asleep ÷ in bed, %) computed by the query — numbers,
 * not verdicts.
 */
export type ClientSleepNight = {
  __typename?: 'ClientSleepNight';
  asleepMinutes: Scalars['Int'];
  awakenings: Scalars['Int'];
  efficiency?: Maybe<Scalars['Int']>;
  inBedEnd: Scalars['DateTime'];
  inBedMinutes: Scalars['Int'];
  inBedStart: Scalars['DateTime'];
  night: Scalars['String'];
  stages?: Maybe<SleepStages>;
};

/** E43 · ClientSleepSummary — the caller's nights (the last `days`, 30 by default) and the averages over them. */
export type ClientSleepSummary = {
  __typename?: 'ClientSleepSummary';
  averageAsleepMinutes?: Maybe<Scalars['Int']>;
  averageEfficiency?: Maybe<Scalars['Int']>;
  days: Scalars['Int'];
  nights: Array<ClientSleepNight>;
  subject: Scalars['ID'];
};

export type ClientTargetBehavior = {
  __typename?: 'ClientTargetBehavior';
  addedByClient: Scalars['Boolean'];
  changes: Scalars['Int'];
  functionHypotheses: Array<Scalars['String']>;
  measure: Scalars['String'];
  name: Scalars['String'];
  records: Scalars['Int'];
  retired: Scalars['Boolean'];
  targetId: Scalars['ID'];
  threshold: Scalars['Int'];
};

export type ClientToolNavigation = {
  __typename?: 'ClientToolNavigation';
  performer: Scalars['ID'];
  sessionCount: Scalars['Int'];
  sinceDate: Scalars['DateTime'];
  subject: Scalars['ID'];
  tools: Array<ClientToolNavigationItem>;
  workShared: Scalars['Boolean'];
};

export type ClientToolNavigationItem = {
  __typename?: 'ClientToolNavigationItem';
  group: Scalars['String'];
  hiddenByMe: Scalars['Boolean'];
  inUse: Scalars['Boolean'];
  lastRecordedAt?: Maybe<Scalars['DateTime']>;
  newSinceLastSession: Scalars['Int'];
  recordCount: Scalars['Int'];
  tool: Scalars['String'];
};

export type ClientTransferConsentResponse = {
  __typename?: 'ClientTransferConsentResponse';
  /** True only when approval was recorded; a decline succeeds and returns false. */
  consented: Scalars['Boolean'];
  success: Scalars['Boolean'];
};

export type ClientTransferRequestResponse = {
  __typename?: 'ClientTransferRequestResponse';
  /** users/<key> — echoed so the portal can update one row without a refetch. */
  subject?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

/**
 * E34 · ClientWorksheets — the client hub's Worksheets & documents tab: one row per worksheet
 * assignment with its document status (sent · viewed · submitted · signed · paper · cancelled — paper: done on paper, Q-paper-2 A) and the instant of
 * each stage. `name` / `category` are the PINNED version's; `pending` = not yet submitted, or a consent
 * awaiting its signature; `score` the current submission's (a scored template).
 */
export type ClientWorksheet = {
  __typename?: 'ClientWorksheet';
  assignmentId: Scalars['ID'];
  awaitingSignature: Scalars['Boolean'];
  category?: Maybe<Scalars['String']>;
  filledInSession: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  paperAllowed: Scalars['Boolean'];
  paperPhoto?: Maybe<HomeworkPaperPhoto>;
  pending: Scalars['Boolean'];
  score?: Maybe<Scalars['Float']>;
  selfAssigned: Scalars['Boolean'];
  sentAt: Scalars['DateTime'];
  signedAt?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  subject: Scalars['ID'];
  submissionId?: Maybe<Scalars['ID']>;
  submissionIds: Array<Scalars['ID']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  templateId: Scalars['ID'];
  templateVersion?: Maybe<Scalars['Int']>;
  viewedAt?: Maybe<Scalars['DateTime']>;
};

export type CloseChangeGoalInput = {
  goalId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  outcome: Scalars['String'];
};

export type CommentOnHomeworkInput = {
  assignmentId: Scalars['ID'];
  text: Scalars['String'];
};

export type CommentOnHomeworkPayload = {
  __typename?: 'CommentOnHomeworkPayload';
  assignmentId: Scalars['ID'];
  commentId: Scalars['ID'];
  recorded: Scalars['Boolean'];
};

export type CommitToValuedActionInput = {
  actionId: Scalars['ID'];
  dueAt: Scalars['DateTime'];
  origin: ActionOriginInput;
  title: Scalars['String'];
  value: Scalars['String'];
};

export type CompleteExperimentInput = {
  experimentId: Scalars['ID'];
  followUpExperimentsIdeas?: InputMaybe<Scalars['String']>;
  meaningForOriginalBelief?: InputMaybe<Scalars['String']>;
  newLearnings?: InputMaybe<Scalars['String']>;
  newThought?: InputMaybe<Scalars['String']>;
  newThoughtStrength?: InputMaybe<Scalars['Int']>;
  oldThoughtStrength?: InputMaybe<Scalars['Int']>;
  patientReflections?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['ID']>;
  therapistReflections?: InputMaybe<Scalars['String']>;
};

export type CompleteHomeworkInput = {
  assignmentId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  occurrenceAt?: InputMaybe<Scalars['DateTime']>;
  paperPhoto?: InputMaybe<HomeworkPaperPhotoInput>;
};

export type CompletePlannedActivityInput = {
  enjoyment: Scalars['Int'];
  importance: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  plannedActivityId: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type CompleteValuedLivingQuestionnaireInput = {
  areas: Array<VlqAreaInput>;
  vlqId: Scalars['ID'];
};

export type CompleteValuesSortInput = {
  piles: ValuesSortPilesInput;
  ranked: Array<Scalars['String']>;
  sortId: Scalars['ID'];
};

export type Conceptualization = {
  __typename?: 'Conceptualization';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  clientProfileOther?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deepBeliefs?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  education?: Maybe<Scalars['Int']>;
  gender?: Maybe<Scalars['Int']>;
  geneticPredisposition?: Maybe<Scalars['String']>;
  goals?: Maybe<Scalars['String']>;
  lifeRules?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['Int']>;
  negativePastExperience?: Maybe<Scalars['String']>;
  problems?: Maybe<Array<Maybe<Scalars['String']>>>;
  resources?: Maybe<Scalars['String']>;
  triggerEvent?: Maybe<Scalars['String']>;
  triggers?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type ConceptualizationInput = {
  data: ConceptualizationInputData;
  where: ConceptualizationInputWhere;
};

export type ConceptualizationInputData = {
  clientProfileOther?: InputMaybe<Scalars['String']>;
  deepBeliefs?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['DateTime']>;
  education?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['Int']>;
  geneticPredisposition?: InputMaybe<Scalars['String']>;
  goals?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lifeRules?: InputMaybe<Scalars['String']>;
  maritalStatus?: InputMaybe<Scalars['Int']>;
  negativePastExperience?: InputMaybe<Scalars['String']>;
  problems?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resources?: InputMaybe<Scalars['String']>;
  triggerEvent?: InputMaybe<Scalars['String']>;
  triggers?: InputMaybe<Scalars['String']>;
};

export type ConceptualizationInputWhere = {
  clientId: Scalars['ID'];
};

export type ConceptualizationSearch = {
  __typename?: 'ConceptualizationSearch';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<Conceptualization>>>;
};

export type ConfigureModeSetInput = {
  modes: Array<ModeInput>;
  subject?: InputMaybe<Scalars['ID']>;
};

export type ConfigureValuesWheelInput = {
  preset: Scalars['String'];
  sectors: Array<WheelSectorInput>;
  wheelId: Scalars['ID'];
};

export type ConfirmSleepNightInput = {
  awakenings?: InputMaybe<Scalars['Int']>;
  bedTime?: InputMaybe<Scalars['DateTime']>;
  finalWake?: InputMaybe<Scalars['DateTime']>;
  lightsOut?: InputMaybe<Scalars['DateTime']>;
  naps?: InputMaybe<Array<SleepNapInput>>;
  night: Scalars['String'];
  nightKind?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  outOfBed?: InputMaybe<Scalars['DateTime']>;
  quality?: InputMaybe<Scalars['Int']>;
  sleepOnsetMinutes?: InputMaybe<Scalars['Int']>;
  source?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['ID']>;
  substances?: InputMaybe<SleepSubstancesInput>;
  timeZone?: InputMaybe<Scalars['String']>;
  today?: InputMaybe<Scalars['String']>;
  wakeMinutes?: InputMaybe<Scalars['Int']>;
};

export type ConsentToClientTransferInput = {
  /** false records NOTHING — a decline is the absence of consent, not a fact about the person. */
  approved: Scalars['Boolean'];
  /** users/<key> — the member the client is being asked to move to. */
  newAssignee: Scalars['ID'];
};

export type CoursePurchasePayload = {
  __typename?: 'CoursePurchasePayload';
  owned: Scalars['Boolean'];
  recorded: Scalars['Boolean'];
  storeProductId: Scalars['String'];
};

export type CourseReview = {
  __typename?: 'CourseReview';
  approvedVersion?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  pathwayId: Scalars['ID'];
  practiceId: Scalars['ID'];
  practiceName?: Maybe<Scalars['String']>;
  sections: Array<PathwaySection>;
  stepsCount: Scalars['Int'];
  update: Scalars['Boolean'];
  version: Scalars['Int'];
};

export type CreateAssessmentInSessionInput = {
  answers: Array<InputMaybe<Scalars['Int']>>;
  assessmentId: Scalars['ID'];
  score: Scalars['Int'];
  subject: Scalars['ID'];
  type: Scalars['Int'];
};

export type CreateInvite = {
  allowAdminEdit?: InputMaybe<Scalars['Boolean']>;
  allowAdminView?: InputMaybe<Scalars['Boolean']>;
  allowEdit?: InputMaybe<Scalars['Boolean']>;
  allowView?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  expiresAt: Scalars['DateTime'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  type: Scalars['Int'];
};

export type CreateNonAppClientInput = {
  email?: InputMaybe<Scalars['EmailAddress']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type CreateStandaloneCardInput = {
  automaticThought: Scalars['String'];
  cardName?: InputMaybe<Scalars['String']>;
  realisticThoughts: Array<BasicThoughtInput>;
  thoughtTestId: Scalars['ID'];
};

export type CreateStandaloneCardPayload = {
  __typename?: 'CreateStandaloneCardPayload';
  thought?: Maybe<Thought>;
  thoughtTestId: Scalars['ID'];
};

export type CreateViciousCycleInput = {
  name?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['ID']>;
  template?: InputMaybe<Scalars['ID']>;
  thoughts: Array<CycleThoughtInput>;
};

export type CycleThoughtInput = {
  edges: Array<InputMaybe<Scalars['Boolean']>>;
  thought?: InputMaybe<Scalars['String']>;
};

export type DateTimeReminder = {
  __typename?: 'DateTimeReminder';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  createdAt: Scalars['DateTime'];
  date: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  for?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type DateTimeReminderConnection = {
  __typename?: 'DateTimeReminderConnection';
  edges?: Maybe<Array<Maybe<DateTimeReminderEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int'];
};

export type DateTimeReminderCreateInput = {
  date: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  for?: InputMaybe<Scalars['String']>;
};

export type DateTimeReminderDeleteResponse = {
  __typename?: 'DateTimeReminderDeleteResponse';
  old?: Maybe<DateTimeReminder>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DateTimeReminderEdge = {
  __typename?: 'DateTimeReminderEdge';
  cursor: Scalars['String'];
  node?: Maybe<DateTimeReminder>;
};

export type DateTimeReminderResponse = {
  __typename?: 'DateTimeReminderResponse';
  dateTimeReminder?: Maybe<DateTimeReminder>;
};

export type DateTimeReminderUpdateInput = {
  _id: Scalars['ID'];
  date: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
};

export type DayReminders = {
  __typename?: 'DayReminders';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  createdAt: Scalars['DateTime'];
  day: TimeReminder;
  evening: TimeReminder;
  morning: TimeReminder;
  thoughtId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type DayRemindersCreateInput = {
  day: TimeReminderInput;
  evening: TimeReminderInput;
  morning: TimeReminderInput;
  thoughtId: Scalars['ID'];
};

export type DayRemindersCreateInputNoThught = {
  day: TimeReminderInput;
  evening: TimeReminderInput;
  morning: TimeReminderInput;
};

export type DayRemindersResponse = {
  __typename?: 'DayRemindersResponse';
  dayReminders?: Maybe<DayReminders>;
};

export type DayRemindersUpdateInput = {
  _id: Scalars['ID'];
  day: TimeReminderInput;
  evening: TimeReminderInput;
  morning: TimeReminderInput;
};

export type DeckCardInput = {
  card: Scalars['String'];
  en: Scalars['String'];
  ru: Scalars['String'];
};

export type DeckPresetInput = {
  cardIds?: InputMaybe<Array<Scalars['String']>>;
  cards: Scalars['Int'];
  preset: Scalars['String'];
};

export type DefineDiaryCardInput = {
  cardId?: InputMaybe<Scalars['ID']>;
  emotions?: InputMaybe<Array<DiaryCardEmotionRowInput>>;
  skills?: InputMaybe<Array<DiaryCardSkillRowInput>>;
  subject?: InputMaybe<Scalars['ID']>;
  targets: Array<DiaryCardTargetInput>;
  template: Scalars['String'];
};

export type DefineDiaryCardPayload = {
  __typename?: 'DefineDiaryCardPayload';
  cardId: Scalars['ID'];
  recorded: Scalars['Boolean'];
  version: Scalars['Int'];
};

export type DefinePathwayInput = {
  copiedFrom?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  sections: Array<PathwaySectionInput>;
  visibility: Scalars['String'];
};

export type DefineValueActivityInput = {
  activityId: Scalars['ID'];
  difficulty: Scalars['Int'];
  source?: InputMaybe<Scalars['String']>;
  suggestedFrom?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
  value: Scalars['String'];
};

export type DefineWorksheetTemplateInput = {
  category: Scalars['String'];
  copiedFrom?: InputMaybe<Scalars['ID']>;
  importedFrom?: InputMaybe<WorksheetImportedFromInput>;
  language: Scalars['String'];
  name: Scalars['String'];
  repeatable: Scalars['Boolean'];
  rightsConfirmed?: InputMaybe<Scalars['Boolean']>;
  scoring?: InputMaybe<WorksheetScoringInput>;
  sections: Array<WorksheetSectionInput>;
  signatureRequired: Scalars['Boolean'];
};

export type DeleteActivatingEventPayload = {
  __typename?: 'DeleteActivatingEventPayload';
  activatingEventId: Scalars['ID'];
  success: Scalars['Boolean'];
};

export type DeleteCheckInInput = {
  checkInId: Scalars['ID'];
  subject?: InputMaybe<Scalars['ID']>;
};

export type DeleteDayRemindersResponse = {
  __typename?: 'DeleteDayRemindersResponse';
  old?: Maybe<DayReminders>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteInvite = {
  id: Scalars['ID'];
};

export type DeleteModeCheckInInput = {
  checkInId: Scalars['ID'];
};

export type DeleteViciousCycleInput = {
  viciousCycleId: Scalars['ID'];
};

export type DeleteViciousCyclePayload = {
  __typename?: 'DeleteViciousCyclePayload';
  success: Scalars['Boolean'];
  viciousCycleId: Scalars['ID'];
};

export type DescribeBehaviorStrategyInSessionInput = {
  behaviors: Array<Scalars['String']>;
  inspiredBy?: InputMaybe<RoseInspiredByInput>;
  kind: Scalars['String'];
  name: Scalars['String'];
  strategyId: Scalars['ID'];
  subject: Scalars['ID'];
};

export type DescribeBehaviorStrategyInput = {
  behaviors: Array<Scalars['String']>;
  inspiredBy?: InputMaybe<RoseInspiredByInput>;
  kind: Scalars['String'];
  name: Scalars['String'];
  strategyId: Scalars['ID'];
};

export type DesignBehaviorExperimentInput = {
  activate?: InputMaybe<Scalars['Boolean']>;
  activeSubtype?: InputMaybe<Scalars['Int']>;
  design?: InputMaybe<Scalars['Int']>;
  experimentId?: InputMaybe<Scalars['ID']>;
  hypotheses?: InputMaybe<DesignHypothesesInput>;
  hypothesisType?: InputMaybe<Scalars['Int']>;
  observationalSubtype?: InputMaybe<Scalars['Int']>;
  plan?: InputMaybe<DesignPlanInput>;
  prediction?: InputMaybe<BehaviorExperimentPredictionPatchInput>;
  purpose?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type DesignHypothesesInput = {
  hypothesisA?: InputMaybe<Scalars['String']>;
  hypothesisAConfirmationCriteria?: InputMaybe<Scalars['String']>;
  hypothesisAStrength?: InputMaybe<Scalars['Int']>;
  hypothesisB?: InputMaybe<Scalars['String']>;
  hypothesisBConfirmationCriteria?: InputMaybe<Scalars['String']>;
  hypothesisBStrength?: InputMaybe<Scalars['Int']>;
};

export type DesignPlanInput = {
  helpfulCopingStrategies?: InputMaybe<Scalars['String']>;
  safetyBehaviors?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<BehaviorExperimentSettingsInput>;
};

/**
 * E37 · DiaryCard — the client's ONE form for a day: the active cards (each practice's, one per practice, and their own), the
 * union of their rows, whether every card is filled for the day, and the day's fills (a refill replaces them).
 */
export type DiaryCard = {
  __typename?: 'DiaryCard';
  activeCards: Array<DiaryCardActive>;
  day: Scalars['String'];
  filledToday: Scalars['Boolean'];
  fills: Array<DiaryCardDayFill>;
  formRows: Array<DiaryCardFormRow>;
};

/**
 * E37 · one active card of the client. `practiceId` / `practiceName` are the practice that set it up (absent on the
 * client's own card).
 */
export type DiaryCardActive = {
  __typename?: 'DiaryCardActive';
  cardId: Scalars['ID'];
  emotions: Array<DiaryCardEmotionRow>;
  practiceId?: Maybe<Scalars['ID']>;
  practiceName?: Maybe<Scalars['String']>;
  skills: Array<DiaryCardSkillRow>;
  targets: Array<DiaryCardTarget>;
  template: Scalars['String'];
  version: Scalars['Int'];
};

export type DiaryCardDayEntry = {
  __typename?: 'DiaryCardDayEntry';
  cardId: Scalars['ID'];
  day: Scalars['String'];
  emotionRatings: Array<DiaryCardEmotionRating>;
  enteredInSession: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  ratings: Array<DiaryCardRating>;
  skillsPracticed: Array<Scalars['String']>;
  skillsUsed?: Maybe<Scalars['Int']>;
};

export type DiaryCardDayFill = {
  __typename?: 'DiaryCardDayFill';
  cardId: Scalars['ID'];
  emotionRatings: Array<DiaryCardEmotionRating>;
  enteredInSession: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  ratings: Array<DiaryCardRating>;
  skillsPracticed: Array<Scalars['String']>;
  skillsUsed?: Maybe<Scalars['Int']>;
  version: Scalars['Int'];
};

export type DiaryCardEmotionRating = {
  __typename?: 'DiaryCardEmotionRating';
  id: Scalars['String'];
  rating: Scalars['Int'];
};

export type DiaryCardEmotionRatingInput = {
  id: Scalars['String'];
  rating: Scalars['Int'];
};

export type DiaryCardEmotionRow = {
  __typename?: 'DiaryCardEmotionRow';
  id: Scalars['String'];
};

export type DiaryCardEmotionRowInput = {
  id: Scalars['String'];
};

export type DiaryCardFormRow = {
  __typename?: 'DiaryCardFormRow';
  cardIds: Array<Scalars['ID']>;
  countable: Scalars['Boolean'];
  key: Scalars['String'];
  kind: Scalars['String'];
  max?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  ownerCardId?: Maybe<Scalars['ID']>;
  standard: Scalars['Boolean'];
  targetId: Scalars['String'];
};

export type DiaryCardHighlight = {
  __typename?: 'DiaryCardHighlight';
  acted?: Maybe<Scalars['Boolean']>;
  count?: Maybe<Scalars['Int']>;
  day: Scalars['String'];
  targetId: Scalars['String'];
  urge?: Maybe<Scalars['Int']>;
};

export type DiaryCardRating = {
  __typename?: 'DiaryCardRating';
  acted?: Maybe<Scalars['Boolean']>;
  count?: Maybe<Scalars['Int']>;
  scale?: Maybe<Scalars['Int']>;
  targetId: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  urge?: Maybe<Scalars['Int']>;
};

export type DiaryCardRatingInput = {
  acted?: InputMaybe<Scalars['Boolean']>;
  cardId?: InputMaybe<Scalars['ID']>;
  count?: InputMaybe<Scalars['Int']>;
  max?: InputMaybe<Scalars['Int']>;
  scale?: InputMaybe<Scalars['Int']>;
  targetId: Scalars['String'];
  text?: InputMaybe<Scalars['String']>;
  urge?: InputMaybe<Scalars['Int']>;
};

export type DiaryCardSkillRow = {
  __typename?: 'DiaryCardSkillRow';
  module: Scalars['String'];
  skillId: Scalars['String'];
};

export type DiaryCardSkillRowInput = {
  module: Scalars['String'];
  skillId: Scalars['String'];
};

export type DiaryCardTarget = {
  __typename?: 'DiaryCardTarget';
  countable?: Maybe<Scalars['Boolean']>;
  faTargetId?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  max?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  standard?: Maybe<Scalars['Boolean']>;
  targetId: Scalars['String'];
};

export type DiaryCardTargetInput = {
  countable?: InputMaybe<Scalars['Boolean']>;
  faTargetId?: InputMaybe<Scalars['String']>;
  kind: Scalars['String'];
  max?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  standard?: InputMaybe<Scalars['Boolean']>;
  targetId: Scalars['String'];
};

/**
 * E37 · one template of the catalogue. The name, summary and row labels are in the caller's language (i18n content for
 * the seeded templates, the stored words for a later one).
 */
export type DiaryCardTemplate = {
  __typename?: 'DiaryCardTemplate';
  emotions: Array<DiaryCardEmotionRow>;
  name: Scalars['String'];
  skills: Array<DiaryCardSkillRow>;
  summary: Scalars['String'];
  targets: Array<DiaryCardTarget>;
  templateId: Scalars['String'];
};

/**
 * E37 · DiaryCardWeek — the paper card's grid for the week from `weekOf`'s monday: one grid per card. The phone reads every
 * card of the caller; a practice (`subject` given) reads ITS card and, read-only, the client's own — never another practice's.
 */
export type DiaryCardWeek = {
  __typename?: 'DiaryCardWeek';
  cards: Array<DiaryCardWeekGrid>;
  subject: Scalars['ID'];
  weekOf: Scalars['String'];
};

export type DiaryCardWeekGrid = {
  __typename?: 'DiaryCardWeekGrid';
  cardId: Scalars['ID'];
  dayEntries: Array<DiaryCardDayEntry>;
  emotions: Array<DiaryCardEmotionRow>;
  highlights: Array<DiaryCardHighlight>;
  inSessionDays: Array<Scalars['String']>;
  practiceId?: Maybe<Scalars['ID']>;
  setUpBy: Scalars['String'];
  setUpByName?: Maybe<Scalars['String']>;
  skills: Array<DiaryCardSkillRow>;
  targets: Array<DiaryCardTarget>;
  version: Scalars['Int'];
};

export type DiaryRecap = {
  __typename?: 'DiaryRecap';
  days: Scalars['Int'];
  highlights: Array<DiaryRecapHighlight>;
  skillsUsedAverage?: Maybe<Scalars['Float']>;
};

export type DiaryRecapHighlight = {
  __typename?: 'DiaryRecapHighlight';
  acted?: Maybe<Scalars['Boolean']>;
  count?: Maybe<Scalars['Int']>;
  day: Scalars['String'];
  name: Scalars['String'];
  targetId: Scalars['String'];
  urge?: Maybe<Scalars['Int']>;
};

export type DigestCard = {
  __typename?: 'DigestCard';
  count: Scalars['Int'];
  done?: Maybe<Scalars['Int']>;
  group: Scalars['String'];
  hidden: Scalars['Boolean'];
  lastAt?: Maybe<Scalars['DateTime']>;
  lastDay?: Maybe<Scalars['String']>;
  moodMax?: Maybe<Scalars['Int']>;
  moodMin?: Maybe<Scalars['Int']>;
  overdue?: Maybe<Scalars['Int']>;
  scores: Array<DigestScore>;
  tool: Scalars['String'];
  total?: Maybe<Scalars['Int']>;
};

export type DigestScore = {
  __typename?: 'DigestScore';
  at: Scalars['DateTime'];
  change?: Maybe<Scalars['Float']>;
  instrument: Scalars['String'];
  previous?: Maybe<Scalars['Float']>;
  score: Scalars['Float'];
};

export type DisableAppLockInput = {
  deviceId: Scalars['ID'];
};

export type DownwardArrow = {
  __typename?: 'DownwardArrow';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  beliefs: Array<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type DownwardArrowInput = {
  data: DownwardArrowInputData;
  where: DownwardArrowInputWhere;
};

export type DownwardArrowInputData = {
  beliefs: Array<Scalars['String']>;
};

export type DownwardArrowInputWhere = {
  _id?: InputMaybe<Scalars['ID']>;
  clientId?: InputMaybe<Scalars['ID']>;
};

export type DownwardArrowSearch = {
  __typename?: 'DownwardArrowSearch';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<DownwardArrow>>>;
};

export type EditCycleThoughtInput = {
  index: Scalars['Int'];
  subject?: InputMaybe<Scalars['ID']>;
  thought?: InputMaybe<Scalars['String']>;
  viciousCycleId: Scalars['ID'];
};

export type Emotion = {
  __typename?: 'Emotion';
  id: Scalars['Int'];
  strength: Scalars['Int'];
};

export type EmotionInput = {
  id: Scalars['Int'];
  strength: Scalars['Int'];
};

export type EnableAppLockInput = {
  deviceId: Scalars['ID'];
  lockAfterMinutes: Scalars['Int'];
  method: Scalars['String'];
};

export type EnabledDayRemindersCount = {
  __typename?: 'EnabledDayRemindersCount';
  enabled: Scalars['Int'];
};

export type EnabledLocationRemindersCount = {
  __typename?: 'EnabledLocationRemindersCount';
  enabled: Scalars['Int'];
};

export type EnrollInPathwayInput = {
  pathwayId: Scalars['ID'];
  startAt?: InputMaybe<Scalars['DateTime']>;
  subject?: InputMaybe<Scalars['ID']>;
};

export type ErasureCount = {
  __typename?: 'ErasureCount';
  count: Scalars['Int'];
  name: Scalars['String'];
};

export type ErasureExternalProbe = {
  __typename?: 'ErasureExternalProbe';
  accessDoc: Scalars['Boolean'];
  account: Scalars['Boolean'];
  bucket: Scalars['String'];
  files: Array<ErasureCount>;
  onLists: Scalars['Int'];
  urlFiles: Scalars['Int'];
};

export type ErasureInventory = {
  __typename?: 'ErasureInventory';
  affectedPractices: Array<Scalars['String']>;
  blockers: Array<Scalars['String']>;
  byHand: Array<Scalars['String']>;
  cohort: Scalars['Boolean'];
  deletes: Array<ErasureCount>;
  external: ErasureExternalProbe;
  keptRows: Array<ErasureCount>;
  log: ErasureLogCounts;
  mergedIn: Array<Scalars['String']>;
  person: ErasurePersonInfo;
  pilot: Scalars['Boolean'];
  redactions: Array<ErasureCount>;
  targets: Array<ErasureTargetPolicy>;
};

export type ErasureInventoryResult = {
  __typename?: 'ErasureInventoryResult';
  inventory?: Maybe<ErasureInventory>;
  matches: Array<ErasurePersonInfo>;
};

export type ErasureLogCounts = {
  __typename?: 'ErasureLogCounts';
  commandLog: Scalars['Int'];
  eventLog: Scalars['Int'];
  kept: Scalars['Int'];
  usageLog: Scalars['Int'];
  valueHits: Scalars['Int'];
};

export type ErasurePersonInfo = {
  __typename?: 'ErasurePersonInfo';
  email?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  practiceId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['Int']>;
  stripeCustomer: Scalars['Boolean'];
  subject: Scalars['String'];
  uid?: Maybe<Scalars['String']>;
};

export type ErasureRequestRow = {
  __typename?: 'ErasureRequestRow';
  affectedPractices: Array<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  dueBy?: Maybe<Scalars['DateTime']>;
  keptEvents?: Maybe<Scalars['Int']>;
  keptRows?: Maybe<Scalars['String']>;
  notified?: Maybe<Scalars['String']>;
  performer?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  requestedAt?: Maybe<Scalars['DateTime']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  steps: Array<ErasureStep>;
  subject: Scalars['String'];
};

export type ErasureResult = {
  __typename?: 'ErasureResult';
  affectedPractices: Array<Scalars['String']>;
  alreadyErased: Scalars['Boolean'];
  byHand: Array<Scalars['String']>;
  log: ErasureLogCounts;
  steps: Array<ErasureStep>;
  subject: Scalars['String'];
};

export type ErasureStep = {
  __typename?: 'ErasureStep';
  counts: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  outcome: Scalars['String'];
  store: Scalars['String'];
  until?: Maybe<Scalars['String']>;
};

export type ErasureTargetPolicy = {
  __typename?: 'ErasureTargetPolicy';
  detail?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  policy: Scalars['String'];
};

export type EsCardReminders = {
  __typename?: 'EsCardReminders';
  active: Array<EsReminderSchedule>;
  nextOccurrences: Array<EsReminderOccurrence>;
  stopped: Array<EsStoppedReminderSchedule>;
};

export enum EsDomain {
  AbcModel = 'abcModel',
  Assessments = 'assessments',
  BehaviorExperiment = 'behaviorExperiment',
  Conceptualization = 'conceptualization',
  DownwardArrow = 'downwardArrow',
  Exposure = 'exposure',
  Identity = 'identity',
  Messaging = 'messaging',
  Practice = 'practice',
  ProgressNotes = 'progressNotes',
  Reminders = 'reminders',
  Sessions = 'sessions',
  ThoughtTesting = 'thoughtTesting',
  ViciousCycle = 'viciousCycle',
  WorryTree = 'worryTree',
}

export enum EsMode {
  Es = 'es',
  Legacy = 'legacy',
}

export type EsReminderCommandResponse = {
  __typename?: 'EsReminderCommandResponse';
  reminderId: Scalars['ID'];
  success: Scalars['Boolean'];
};

export type EsReminderLegacyBinding = {
  __typename?: 'EsReminderLegacyBinding';
  collection: Scalars['String'];
  key: Scalars['String'];
  slot?: Maybe<Scalars['String']>;
};

export type EsReminderOccurrence = {
  __typename?: 'EsReminderOccurrence';
  local: Scalars['String'];
  reminderId: Scalars['ID'];
  utcIso?: Maybe<Scalars['String']>;
};

export type EsReminderSchedule = {
  __typename?: 'EsReminderSchedule';
  channel: Scalars['String'];
  legacyBinding?: Maybe<EsReminderLegacyBinding>;
  reminderId: Scalars['ID'];
  schedule: EsReminderScheduleValue;
  target: EsReminderTarget;
  updatedAt: Scalars['DateTime'];
};

export type EsReminderScheduleInput = {
  dtstart: Scalars['String'];
  exdates?: InputMaybe<Array<Scalars['String']>>;
  rrule: Scalars['String'];
  tzid?: InputMaybe<Scalars['String']>;
};

export type EsReminderScheduleResponse = {
  __typename?: 'EsReminderScheduleResponse';
  reminderId: Scalars['ID'];
  schedule?: Maybe<EsReminderSchedule>;
  success: Scalars['Boolean'];
};

export type EsReminderScheduleValue = {
  __typename?: 'EsReminderScheduleValue';
  dtstart: Scalars['String'];
  exdates: Array<Scalars['String']>;
  rrule: Scalars['String'];
  tzid?: Maybe<Scalars['String']>;
};

export type EsReminderTarget = {
  __typename?: 'EsReminderTarget';
  kind: Scalars['String'];
  ref?: Maybe<Scalars['String']>;
};

export type EsReminderTargetInput = {
  kind: Scalars['String'];
  ref?: InputMaybe<Scalars['String']>;
};

export type EsStoppedReminderSchedule = {
  __typename?: 'EsStoppedReminderSchedule';
  channel: Scalars['String'];
  legacyBinding?: Maybe<EsReminderLegacyBinding>;
  reason: Scalars['String'];
  reminderId: Scalars['ID'];
  schedule: EsReminderScheduleValue;
  target: EsReminderTarget;
  updatedAt: Scalars['DateTime'];
};

/**
 * E20 · ExpositionHeartRate — the caller's heart rate during one exposition (`window` null: "no heart rate was
 * recorded"); `heartRateShared`: whether heart rate is shared with CopingCard at all (the section is hidden otherwise).
 */
export type ExpositionHeartRate = {
  __typename?: 'ExpositionHeartRate';
  expositionId: Scalars['ID'];
  heartRateShared: Scalars['Boolean'];
  window?: Maybe<ExpositionHeartRateWindow>;
};

export type ExpositionHeartRateWindow = {
  __typename?: 'ExpositionHeartRateWindow';
  bpm: HeartRateStats;
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export enum ExpositionOutcome {
  No = 'no',
  Partly = 'partly',
  Yes = 'yes',
}

export type ExpositionPayload = {
  __typename?: 'ExpositionPayload';
  expositionId: Scalars['ID'];
  exposureStimulus?: Maybe<ExposureStimulus>;
  reactionId?: Maybe<Scalars['ID']>;
};

export type Exposure = {
  __typename?: 'Exposure';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  createdAt: Scalars['DateTime'];
  exposureId?: Maybe<Scalars['ID']>;
  fear?: Maybe<Scalars['String']>;
  hierarchy?: Maybe<Array<Maybe<ExposureStimulus>>>;
  obsession?: Maybe<Scalars['String']>;
  safetyBehaviorsToAvoid?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['ID']>;
};

export type ExposureInput = {
  data: ExposureInputData;
  where: ExposureWhere;
};

export type ExposureInputData = {
  fear?: InputMaybe<Scalars['String']>;
  obsession?: InputMaybe<Scalars['String']>;
  safetyBehaviorsToAvoid?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type ExposureSearch = {
  __typename?: 'ExposureSearch';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<Exposure>>>;
};

export type ExposureStimulus = {
  __typename?: 'ExposureStimulus';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  avoidance?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  expositions?: Maybe<Array<Maybe<ExposureStimulusExposition>>>;
  exposureId?: Maybe<Scalars['ID']>;
  exposureStimulusId?: Maybe<Scalars['ID']>;
  imagePrompt?: Maybe<Scalars['String']>;
  imageUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  rank?: Maybe<Scalars['Int']>;
  sud?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  worstThingThatCouldHappen?: Maybe<Scalars['String']>;
};

export type ExposureStimulusDeleteWhere = {
  id?: InputMaybe<Scalars['ID']>;
};

export type ExposureStimulusExposition = {
  __typename?: 'ExposureStimulusExposition';
  anticipatedSud?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  expectedLikelihood?: Maybe<Scalars['Int']>;
  expectedOutcome?: Maybe<Scalars['String']>;
  expositionId?: Maybe<Scalars['ID']>;
  learned?: Maybe<Scalars['String']>;
  likelihoodAfter?: Maybe<Scalars['Int']>;
  outcomeOccurred?: Maybe<ExpositionOutcome>;
  reactionNotes?: Maybe<Scalars['String']>;
  suds?: Maybe<Array<Maybe<Sud>>>;
};

export type ExposureStimulusExpositionInput = {
  anticipatedSud?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  reactionNotes?: InputMaybe<Scalars['String']>;
  suds?: InputMaybe<Array<InputMaybe<SudInput>>>;
};

export type ExposureStimulusInput = {
  data: ExposureStimulusInputData;
  where: ExposureStimulusWhere;
};

export type ExposureStimulusInputData = {
  _id?: InputMaybe<Scalars['ID']>;
  avoidance?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  expositions?: InputMaybe<Array<InputMaybe<ExposureStimulusExpositionInput>>>;
  exposureId?: InputMaybe<Scalars['ID']>;
  imagePrompt?: InputMaybe<Scalars['String']>;
  imageUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rank?: InputMaybe<Scalars['Int']>;
  sud?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  worstThingThatCouldHappen?: InputMaybe<Scalars['String']>;
};

export type ExposureStimulusSearch = {
  __typename?: 'ExposureStimulusSearch';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<ExposureStimulus>>>;
};

export type ExposureStimulusUpdateWhere = {
  clientId?: InputMaybe<Scalars['ID']>;
};

export type ExposureStimulusWhere = {
  _id?: InputMaybe<Scalars['ID']>;
  clientId?: InputMaybe<Scalars['ID']>;
  exposureId: Scalars['ID'];
};

export type ExposureWhere = {
  _id?: InputMaybe<Scalars['ID']>;
  clientId?: InputMaybe<Scalars['ID']>;
};

export type FaChangeInForce = {
  __typename?: 'FaChangeInForce';
  byMe: Scalars['Boolean'];
  changeId: Scalars['ID'];
  doneDays: FaDoneDays;
  expectedEffect?: Maybe<Scalars['String']>;
  markedDays: Scalars['Int'];
  started: Scalars['Boolean'];
  startsOn: Scalars['String'];
  today?: Maybe<Scalars['String']>;
  whatChanges: Scalars['String'];
};

export type FaCommandPayload = {
  __typename?: 'FaCommandPayload';
  id?: Maybe<Scalars['ID']>;
  recorded: Scalars['Boolean'];
};

export type FaCounted = {
  __typename?: 'FaCounted';
  count: Scalars['Int'];
  text: Scalars['String'];
};

export type FaDay = {
  __typename?: 'FaDay';
  count: Scalars['Int'];
  date: Scalars['String'];
  from: Scalars['String'];
  urge?: Maybe<Scalars['Int']>;
  urgeOnly: Scalars['Int'];
};

export type FaDoneDays = {
  __typename?: 'FaDoneDays';
  no: Scalars['Int'];
  partly: Scalars['Int'];
  yes: Scalars['Int'];
};

export type FaIdea = {
  __typename?: 'FaIdea';
  instead: Scalars['String'];
  times: Scalars['Int'];
  tool?: Maybe<Scalars['String']>;
};

export type FaInstanceBrief = {
  __typename?: 'FaInstanceBrief';
  didBehavior: Scalars['Boolean'];
  happenedAt: Scalars['DateTime'];
  urge?: Maybe<Scalars['Int']>;
};

export type FaLinkCounts = {
  __typename?: 'FaLinkCounts';
  action: Array<FaCounted>;
  body: Array<FaCounted>;
  event: Array<FaCounted>;
  feeling: Array<FaCounted>;
  thought: Array<FaCounted>;
};

export type FaLinkInput = {
  kind: Scalars['String'];
  text: Scalars['String'];
};

export type FaPeriodChangeDays = {
  __typename?: 'FaPeriodChangeDays';
  marked: Scalars['Int'];
  no: Scalars['Int'];
  partly: Scalars['Int'];
  yes: Scalars['Int'];
};

export type FaPeriodTotals = {
  __typename?: 'FaPeriodTotals';
  days: Scalars['Int'];
  done: Scalars['Int'];
  meanUrge?: Maybe<Scalars['Float']>;
  perWeek?: Maybe<Scalars['Float']>;
  urgeOnly: Scalars['Int'];
};

export type FaRecurring = {
  __typename?: 'FaRecurring';
  later: Array<FaCounted>;
  links: FaLinkCounts;
  nextTime: Array<FaIdea>;
  promptingEvents: Array<FaCounted>;
  rightAway: Array<FaCounted>;
  vulnerabilities: Array<FaCounted>;
};

export type FaSolutionInput = {
  instead?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<Scalars['String']>;
  tool?: InputMaybe<Scalars['String']>;
};

export type FaSummaryChange = {
  __typename?: 'FaSummaryChange';
  byClient: Scalars['Boolean'];
  changeId: Scalars['ID'];
  doneDays: FaDoneDays;
  expectedEffect?: Maybe<Scalars['String']>;
  markedDays: Scalars['Int'];
  startsOn: Scalars['String'];
  whatChanges: Scalars['String'];
};

export type FaSummaryPeriod = {
  __typename?: 'FaSummaryPeriod';
  changeDays?: Maybe<FaPeriodChangeDays>;
  changeId?: Maybe<Scalars['ID']>;
  from?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  to?: Maybe<Scalars['String']>;
  totals: FaPeriodTotals;
  weeks: Array<FaSummaryWeek>;
};

export type FaSummaryTarget = {
  __typename?: 'FaSummaryTarget';
  addedByClient: Scalars['Boolean'];
  baselineWeeks: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  functionHypotheses: Array<Scalars['String']>;
  measure: Scalars['String'];
  name: Scalars['String'];
  retired: Scalars['Boolean'];
  retiredReason?: Maybe<Scalars['String']>;
};

export type FaSummaryWeek = {
  __typename?: 'FaSummaryWeek';
  done: Scalars['Int'];
  meanUrge?: Maybe<Scalars['Float']>;
  urgeOnly: Scalars['Int'];
  weekStart: Scalars['String'];
};

export type FaVulnerabilityInput = {
  kind: Scalars['String'];
  text: Scalars['String'];
};

export type FaWeekFigures = {
  __typename?: 'FaWeekFigures';
  done: Scalars['Int'];
  urgeMax?: Maybe<Scalars['Int']>;
  urgeOnly: Scalars['Int'];
};

/**
 * E32 · What's New — ONE variant of an announcement, the one for this person's surface and
 * language (founder 2026-09-21: one variant per announcement per person). `announcementId` is the
 * thing announced and the key the acknowledgement is recorded against; `variantId` is this
 * rendition, sent back as `seenAs`. `acknowledgedAt` is set on history rows only.
 */
export type FeatureAnnouncement = {
  __typename?: 'FeatureAnnouncement';
  acknowledgedAt?: Maybe<Scalars['DateTime']>;
  announcementId: Scalars['ID'];
  articleUrl?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  mediaUrl?: Maybe<Scalars['String']>;
  publishAt: Scalars['DateTime'];
  relatedReleases: Array<Scalars['String']>;
  summary: Scalars['String'];
  surface: Scalars['String'];
  title: Scalars['String'];
  variantId: Scalars['ID'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  count?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  aiImages?: Maybe<FeatureFlag>;
  articlesView?: Maybe<FeatureFlag>;
  behaviorExperiments?: Maybe<FeatureFlag>;
  cardsSearch?: Maybe<FeatureFlag>;
  crisisContact?: Maybe<FeatureFlag>;
  dayReminders?: Maybe<FeatureFlag>;
  downwardArrows?: Maybe<FeatureFlag>;
  exposureSituationReactions?: Maybe<FeatureFlag>;
  exposureSituations?: Maybe<FeatureFlag>;
  exposures?: Maybe<FeatureFlag>;
  gad7?: Maybe<FeatureFlag>;
  locationReminders?: Maybe<FeatureFlag>;
  meditations?: Maybe<FeatureFlag>;
  phq9?: Maybe<FeatureFlag>;
  statsView?: Maybe<FeatureFlag>;
  videoView?: Maybe<FeatureFlag>;
  worryTrees?: Maybe<FeatureFlag>;
};

export type FillDiaryCardInSessionInput = {
  day: Scalars['String'];
  emotionRatings?: InputMaybe<Array<DiaryCardEmotionRatingInput>>;
  fillId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  ratings?: InputMaybe<Array<DiaryCardRatingInput>>;
  skillsPracticed?: InputMaybe<Array<Scalars['String']>>;
  skillsUsed?: InputMaybe<Scalars['Int']>;
  subject: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type FillDiaryCardInput = {
  day: Scalars['String'];
  emotionRatings?: InputMaybe<Array<DiaryCardEmotionRatingInput>>;
  fillId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  ratings?: InputMaybe<Array<DiaryCardRatingInput>>;
  skillsPracticed?: InputMaybe<Array<Scalars['String']>>;
  skillsUsed?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type FillDiaryCardPayload = {
  __typename?: 'FillDiaryCardPayload';
  cards: Scalars['Int'];
  recorded: Scalars['Boolean'];
};

export type FinishExpositionInput = {
  duration?: InputMaybe<Scalars['Int']>;
  expositionId: Scalars['ID'];
  exposureStimulusId: Scalars['ID'];
  learned?: InputMaybe<Scalars['String']>;
  likelihoodAfter?: InputMaybe<Scalars['Int']>;
  notes?: InputMaybe<Scalars['String']>;
  outcomeOccurred?: InputMaybe<ExpositionOutcome>;
  subject?: InputMaybe<Scalars['ID']>;
};

export type FunctionalAnalysisSummary = {
  __typename?: 'FunctionalAnalysisSummary';
  chains: Scalars['Int'];
  changes: Array<FaSummaryChange>;
  days: Array<FaDay>;
  enough: Scalars['Boolean'];
  periods: Array<FaSummaryPeriod>;
  records: Scalars['Int'];
  recurring: FaRecurring;
  subject: Scalars['ID'];
  suggestion?: Maybe<FaIdea>;
  target: FaSummaryTarget;
  targetId: Scalars['ID'];
  threshold: Scalars['Int'];
  urgesOnly: Scalars['Int'];
};

export type GenerateDalleImageResponse = {
  __typename?: 'GenerateDalleImageResponse';
  code?: Maybe<Scalars['String']>;
  contentUrl?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type GeneratedProgressNote = {
  __typename?: 'GeneratedProgressNote';
  isContentFiltered?: Maybe<Scalars['Boolean']>;
  response?: Maybe<Scalars['JSON']>;
};

export type GptBehaviorExperiment = {
  __typename?: 'GptBehaviorExperiment';
  response?: Maybe<Scalars['JSON']>;
};

export type GptExposuresGeneratedImage = {
  __typename?: 'GptExposuresGeneratedImage';
  response?: Maybe<Scalars['JSON']>;
};

export type GptExposuresHierarchy = {
  __typename?: 'GptExposuresHierarchy';
  code?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['JSON']>;
};

export type GptExposuresHierarchyPrompt = {
  __typename?: 'GptExposuresHierarchyPrompt';
  response?: Maybe<Scalars['JSON']>;
};

export type GrantHealthDataAccessInput = {
  disclosureVersion: Scalars['String'];
  source: Scalars['String'];
  types: Array<Scalars['String']>;
};

export type HealthActivitySuggestion = {
  __typename?: 'HealthActivitySuggestion';
  kind: Scalars['String'];
  minutes: Scalars['Int'];
  start: Scalars['String'];
  startAt: Scalars['DateTime'];
};

export type HealthActivitySuggestions = {
  __typename?: 'HealthActivitySuggestions';
  day: Scalars['String'];
  subject: Scalars['ID'];
  suggestions: Array<HealthActivitySuggestion>;
};

export type HealthActivityWeek = {
  __typename?: 'HealthActivityWeek';
  activeDays: Scalars['Int'];
  activeMinutes: Scalars['Int'];
  walks: Scalars['Int'];
};

/**
 * E43 · HealthDataAccess — the caller's own: the types they share with CopingCard and the last night / day that
 * arrived. `connected` is false before the first Connect. `sharedTypes` is what the sync gear reads.
 */
export type HealthDataAccess = {
  __typename?: 'HealthDataAccess';
  connected: Scalars['Boolean'];
  deleteImported?: Maybe<Scalars['Boolean']>;
  lastDay?: Maybe<Scalars['String']>;
  lastHeartRateDay?: Maybe<Scalars['String']>;
  lastImportedAt?: Maybe<Scalars['DateTime']>;
  lastNight?: Maybe<Scalars['String']>;
  sharedTypes: Array<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  subject: Scalars['ID'];
  types: Array<HealthDataTypeAccess>;
};

export type HealthDataCommandPayload = {
  __typename?: 'HealthDataCommandPayload';
  recorded: Scalars['Boolean'];
};

/**
 * E43 · HealthDataSharing — per therapist the client has a relation with, which health types that therapist sees
 * (default off); `canShare` = the types shared with CopingCard now (the only ones that can be turned on).
 */
export type HealthDataSharing = {
  __typename?: 'HealthDataSharing';
  canShare: Array<Scalars['String']>;
  subject: Scalars['ID'];
  therapists: Array<HealthDataSharingRow>;
};

export type HealthDataSharingRow = {
  __typename?: 'HealthDataSharingRow';
  activity: Scalars['Boolean'];
  heartRate: Scalars['Boolean'];
  performer: Scalars['ID'];
  sleep: Scalars['Boolean'];
  therapistName: Scalars['String'];
};

/**
 * E43 · one type in Settings — Health data: whether it is shared now, since when, and the last night (sleep) or day
 * (activity) that arrived.
 */
export type HealthDataTypeAccess = {
  __typename?: 'HealthDataTypeAccess';
  lastDay?: Maybe<Scalars['String']>;
  lastNight?: Maybe<Scalars['String']>;
  shared: Scalars['Boolean'];
  since?: Maybe<Scalars['DateTime']>;
  type: Scalars['String'];
};

export type HealthReadFocus = {
  __typename?: 'HealthReadFocus';
  ref: Scalars['String'];
  type: Scalars['String'];
};

export type HealthReadFocusInput = {
  ref: Scalars['String'];
  type: Scalars['String'];
};

/**
 * E43 · a heart-rate window the sync gear asks the phone's store for: an exposition the caller finished (the last 30
 * days, not yet imported, or finished less than a day ago).
 */
export type HealthReadWindow = {
  __typename?: 'HealthReadWindow';
  focus: HealthReadFocus;
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export type HealthReadWindowInput = {
  focus: HealthReadFocusInput;
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export type HealthTimelineMood = {
  __typename?: 'HealthTimelineMood';
  day: Scalars['String'];
  mood: Scalars['Float'];
};

export type HealthTimelineScore = {
  __typename?: 'HealthTimelineScore';
  instrument: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  score: Scalars['Int'];
};

export type HealthWorkout = {
  __typename?: 'HealthWorkout';
  minutes: Scalars['Int'];
  start: Scalars['String'];
  type: Scalars['String'];
};

export type HealthWorkoutInput = {
  minutes: Scalars['Int'];
  start: Scalars['String'];
  type: Scalars['String'];
};

export type HeartRateDaySummaryInput = {
  date: Scalars['String'];
  hrv?: InputMaybe<HeartRateVariabilityInput>;
  restingHeartRate?: InputMaybe<Scalars['Int']>;
};

export type HeartRateStats = {
  __typename?: 'HeartRateStats';
  max: Scalars['Int'];
  mean: Scalars['Int'];
  min: Scalars['Int'];
  samples: Scalars['Int'];
};

export type HeartRateStatsInput = {
  max: Scalars['Int'];
  mean: Scalars['Int'];
  min: Scalars['Int'];
  samples: Scalars['Int'];
};

/** E43 · heart-rate variability WITH its metric — `sdnn` (Apple Health) or `rmssd` (Health Connect): never comparable. */
export type HeartRateVariability = {
  __typename?: 'HeartRateVariability';
  metric: Scalars['String'];
  value: Scalars['Float'];
};

export type HeartRateVariabilityInput = {
  metric: Scalars['String'];
  value: Scalars['Float'];
};

export type HeartRateWindowSummaryInput = {
  bpm: HeartRateStatsInput;
  focus: HealthReadFocusInput;
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export type HomeworkCommandPayload = {
  __typename?: 'HomeworkCommandPayload';
  assignmentId: Scalars['ID'];
  recorded: Scalars['Boolean'];
};

/**
 * E34 · HomeworkComments — the thread under one assignment: every comment, oldest first. `performer` is
 * `users/<key>` and `performerName` is looked up at read time (empty for an erased person); `fromClient` is
 * which side wrote it, `mine` whether the CALLER wrote it (the phone and the hub draw the two sides from
 * these). Readable by the assignment's client and by a therapist of its practice the client shares with; a
 * stranger gets an empty thread.
 */
export type HomeworkComment = {
  __typename?: 'HomeworkComment';
  assignmentId: Scalars['ID'];
  commentId: Scalars['ID'];
  fromClient: Scalars['Boolean'];
  mine: Scalars['Boolean'];
  occurredAt: Scalars['DateTime'];
  performer: Scalars['ID'];
  performerName?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export type HomeworkEvidence = {
  __typename?: 'HomeworkEvidence';
  focus: Scalars['JSON'];
  focusType: Scalars['String'];
};

export type HomeworkOccurrenceOutcome = {
  __typename?: 'HomeworkOccurrenceOutcome';
  at?: Maybe<Scalars['DateTime']>;
  evidence?: Maybe<HomeworkEvidence>;
  occurrenceAt?: Maybe<Scalars['DateTime']>;
  outcome: Scalars['String'];
  repeats?: Maybe<Scalars['Int']>;
};

export type HomeworkPaperPhoto = {
  __typename?: 'HomeworkPaperPhoto';
  fileRef: Scalars['String'];
  takenAt: Scalars['DateTime'];
};

export type HomeworkPaperPhotoInput = {
  fileRef: Scalars['String'];
  takenAt: Scalars['DateTime'];
};

export type HomeworkPaperPhotoUrl = {
  __typename?: 'HomeworkPaperPhotoUrl';
  expiresAt: Scalars['DateTime'];
  url: Scalars['String'];
};

/**
 * E34 · HomeworkSinceLastSession — the session form's "Homework since last session" panel (E17's Review
 * Homework): the client's assignments with an outcome since the PREVIOUS session (the boundary — the
 * session before the one being written; none on a first session), in completion order, then those still
 * open (overdue first). `status`: open · done · skipped — a one-off's outcome folded after the boundary;
 * a RECURRING row reads open while it has an open occurrence, its answers since the boundary in
 * `outcomes` (the founder's Q-b1c-6 C). `lastSessionStart` is the boundary session's start — the
 * panel's "Since <date>" (Q-b1b-4 A).
 */
export type HomeworkSinceLastSession = {
  __typename?: 'HomeworkSinceLastSession';
  assignmentId: Scalars['ID'];
  completedAt?: Maybe<Scalars['DateTime']>;
  dueAt?: Maybe<Scalars['DateTime']>;
  evidence?: Maybe<HomeworkEvidence>;
  kind: Scalars['String'];
  lastSessionStart?: Maybe<Scalars['DateTime']>;
  outcomeAt?: Maybe<Scalars['DateTime']>;
  outcomes: Array<HomeworkOccurrenceOutcome>;
  overdue: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  reasonCode?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['ID']>;
  status: Scalars['String'];
  subject: Scalars['ID'];
  title: Scalars['String'];
  tzid?: Maybe<Scalars['String']>;
};

export type HomeworkSource = {
  __typename?: 'HomeworkSource';
  enrollmentId: Scalars['ID'];
  stepId: Scalars['ID'];
};

export type HomeworkTarget = {
  __typename?: 'HomeworkTarget';
  ref?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  version?: Maybe<Scalars['Int']>;
};

export type HomeworkTargetInput = {
  ref?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  version?: InputMaybe<Scalars['Int']>;
};

export type ImportWorksheetTemplateInput = {
  files: Array<WorksheetImportFileInput>;
  rightsConfirmed?: InputMaybe<Scalars['Boolean']>;
};

export type InstrumentBand = {
  __typename?: 'InstrumentBand';
  band: Scalars['String'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type InstrumentBandInput = {
  band: Scalars['String'];
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type InstrumentBandSet = {
  __typename?: 'InstrumentBandSet';
  bands: Array<InstrumentBand>;
  subscale?: Maybe<Scalars['String']>;
};

export type InstrumentBandSetInput = {
  bands: Array<InstrumentBandInput>;
  subscale?: InputMaybe<Scalars['String']>;
};

export type InstrumentCatalogItem = {
  __typename?: 'InstrumentCatalogItem';
  assignedBy?: Maybe<Scalars['String']>;
  assignmentId?: Maybe<Scalars['ID']>;
  availability: Scalars['String'];
  definition: InstrumentDefinition;
  dueAt?: Maybe<Scalars['DateTime']>;
  instrumentId: Scalars['String'];
  lastBand?: Maybe<Scalars['String']>;
  lastBandKey?: Maybe<Scalars['String']>;
  lastScore?: Maybe<Scalars['Int']>;
  lastTakenAt?: Maybe<Scalars['DateTime']>;
  requester?: Maybe<Scalars['ID']>;
  type: Scalars['Int'];
};

export type InstrumentDefinition = {
  __typename?: 'InstrumentDefinition';
  availableFor: Scalars['String'];
  bands: Array<InstrumentBandSet>;
  citation: Scalars['String'];
  instrumentId: Scalars['String'];
  itemsCount: Scalars['Int'];
  itemsKey: Scalars['String'];
  languages: Array<Scalars['String']>;
  licenceClass: Scalars['String'];
  name: Scalars['String'];
  nameRu?: Maybe<Scalars['String']>;
  responseScale: InstrumentScale;
  scoringRule: Scalars['String'];
  subscales: Array<InstrumentSubscale>;
};

export type InstrumentScale = {
  __typename?: 'InstrumentScale';
  labels: Array<Scalars['String']>;
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type InstrumentScaleInput = {
  labels: Array<Scalars['String']>;
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type InstrumentSubscale = {
  __typename?: 'InstrumentSubscale';
  items: Array<Scalars['Int']>;
  multiplier?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  reverseItems?: Maybe<Array<Scalars['Int']>>;
};

export type InstrumentSubscaleInput = {
  items: Array<Scalars['Int']>;
  multiplier?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  reverseItems?: InputMaybe<Array<Scalars['Int']>>;
};

export type Interval = {
  __typename?: 'Interval';
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type IntervalInput = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type Invite = {
  __typename?: 'Invite';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  allowAdminEdit?: Maybe<Scalars['Boolean']>;
  allowAdminView?: Maybe<Scalars['Boolean']>;
  allowEdit?: Maybe<Scalars['Boolean']>;
  allowView?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  expiresAt: Scalars['DateTime'];
  firstName?: Maybe<Scalars['String']>;
  from: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  token: Scalars['String'];
  type: Scalars['Int'];
  user?: Maybe<User>;
};

export type JoinPracticeResponse = {
  __typename?: 'JoinPracticeResponse';
  practiceId?: Maybe<Scalars['ID']>;
  practiceName?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type KeepDayRemindersResponse = {
  __typename?: 'KeepDayRemindersResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type KeepLocationRemindersResponse = {
  __typename?: 'KeepLocationRemindersResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type LadderRung = {
  __typename?: 'LadderRung';
  area?: Maybe<Scalars['String']>;
  difficulty: Scalars['Int'];
  rank: Scalars['Int'];
  title: Scalars['String'];
  value: Scalars['String'];
  valueActivityId: Scalars['ID'];
};

export type LibraryCourse = {
  __typename?: 'LibraryCourse';
  accessRule?: Maybe<Scalars['String']>;
  adaptyPlacementId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  pathwayId: Scalars['ID'];
  retired: Scalars['Boolean'];
  stepsCount: Scalars['Int'];
  storeProductId?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
  visibility: Scalars['String'];
};

export type LibraryIdeaInput = {
  area: Scalars['String'];
  difficulty: Scalars['Int'];
  en: Scalars['String'];
  ideaId: Scalars['String'];
  ru: Scalars['String'];
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type License = {
  __typename?: 'License';
  number: Scalars['String'];
  state: Scalars['String'];
};

export type LicenseInput = {
  number: Scalars['String'];
  state: Scalars['String'];
};

export type LinkCardToModeInput = {
  cardId?: InputMaybe<Scalars['ID']>;
  modeId: Scalars['String'];
};

export type LinkRecordToValueInput = {
  focus: Scalars['String'];
  focusType: Scalars['String'];
  value: Scalars['String'];
};

export type Location = {
  __typename?: 'Location';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  createdAt: Scalars['DateTime'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type LocationConnection = {
  __typename?: 'LocationConnection';
  edges?: Maybe<Array<Maybe<LocationEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int'];
};

export type LocationCreateInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
};

export type LocationEdge = {
  __typename?: 'LocationEdge';
  cursor: Scalars['String'];
  node?: Maybe<Location>;
};

export type LocationReminder = {
  __typename?: 'LocationReminder';
  _from: Scalars['ID'];
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  _to: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  enter?: Maybe<Scalars['Boolean']>;
  leave?: Maybe<Scalars['Boolean']>;
  type: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type LocationReminderConnection = {
  __typename?: 'LocationReminderConnection';
  edges?: Maybe<Array<Maybe<LocationReminderEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int'];
};

export type LocationReminderCreateInput = {
  _from: Scalars['ID'];
  _to: Scalars['ID'];
  enter?: InputMaybe<Scalars['Boolean']>;
  leave?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['Int'];
};

export type LocationReminderDeleteResponse = {
  __typename?: 'LocationReminderDeleteResponse';
  old?: Maybe<LocationReminder>;
  success?: Maybe<Scalars['Boolean']>;
};

export type LocationReminderEdge = {
  __typename?: 'LocationReminderEdge';
  cursor: Scalars['String'];
  node?: Maybe<LocationReminder>;
};

export type LocationReminderResponse = {
  __typename?: 'LocationReminderResponse';
  locationReminder?: Maybe<LocationReminder>;
};

export type LocationReminderUpdateInput = {
  _from: Scalars['ID'];
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  _to: Scalars['ID'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  enter?: InputMaybe<Scalars['Boolean']>;
  leave?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationResponse = {
  __typename?: 'LocationResponse';
  location?: Maybe<Location>;
};

export type LocationUpdateInput = {
  _id: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  name: Scalars['String'];
};

export type LogActivityInput = {
  activityLogId: Scalars['ID'];
  endAt: Scalars['DateTime'];
  enjoyment: Scalars['Int'];
  importance: Scalars['Int'];
  source?: InputMaybe<Scalars['String']>;
  startAt: Scalars['DateTime'];
  title: Scalars['String'];
  valueActivityId?: InputMaybe<Scalars['ID']>;
};

export type MakeSupportContractInput = {
  askBy?: InputMaybe<Scalars['DateTime']>;
  contractId: Scalars['ID'];
  supporters: Array<SupporterInput>;
  valueActivityId: Scalars['ID'];
};

export type MarkChangeDayInput = {
  changeId: Scalars['ID'];
  day: Scalars['String'];
  done: Scalars['String'];
  targetId: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type MergeClientsInput = {
  appClientId: Scalars['ID'];
  nonAppClientId: Scalars['ID'];
};

export type Message = {
  __typename?: 'Message';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  createdAt: Scalars['DateTime'];
  from: Scalars['ID'];
  fromUser?: Maybe<User>;
  message: Scalars['String'];
  readAt?: Maybe<Scalars['DateTime']>;
  to: Scalars['ID'];
};

export type MessageCreateUpdateResponse = {
  __typename?: 'MessageCreateUpdateResponse';
  success: Scalars['Boolean'];
};

export type MessageReadInput = {
  where?: InputMaybe<MessageReadWhere>;
};

export type MessageReadWhere = {
  id_eq: Scalars['ID'];
};

export type MessageToTherapistInput = {
  message: Scalars['String'];
  therapistId: Scalars['String'];
};

export type MiCommandPayload = {
  __typename?: 'MiCommandPayload';
  id?: Maybe<Scalars['ID']>;
  recorded: Scalars['Boolean'];
};

export type MissPlannedActivityInput = {
  barrier: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  plannedActivityId: Scalars['ID'];
};

export type ModeCardLink = {
  __typename?: 'ModeCardLink';
  cardId: Scalars['ID'];
  modeId: Scalars['String'];
};

export type ModeCheckInModeValue = {
  __typename?: 'ModeCheckInModeValue';
  intensity: Scalars['Int'];
  modeId: Scalars['String'];
};

export type ModeCommandPayload = {
  __typename?: 'ModeCommandPayload';
  id?: Maybe<Scalars['ID']>;
  recorded: Scalars['Boolean'];
};

export type ModeDay = {
  __typename?: 'ModeDay';
  date: Scalars['String'];
  modes: Array<ModeDayPeak>;
};

export type ModeDayPeak = {
  __typename?: 'ModeDayPeak';
  modeId: Scalars['String'];
  peak: Scalars['Int'];
};

/**
 * E47 · the Healthy Adult in one week (Monday-start): the presence rate (`presentCheckIns` of `checkIns`), the mean intensity when present
 * and the share of all intensity. A week with no intensity at all has no `share` (never 0 %).
 */
export type ModeHealthyAdultWeek = {
  __typename?: 'ModeHealthyAdultWeek';
  checkIns: Scalars['Int'];
  mean?: Maybe<Scalars['Float']>;
  presentCheckIns: Scalars['Int'];
  share?: Maybe<Scalars['Float']>;
  week: Scalars['String'];
};

export type ModeInput = {
  colour?: InputMaybe<Scalars['String']>;
  kind: Scalars['String'];
  label: Scalars['String'];
  modeId: Scalars['String'];
  own?: InputMaybe<Scalars['Boolean']>;
};

export type ModeIntensityInput = {
  intensity: Scalars['Int'];
  modeId: Scalars['String'];
};

/**
 * E47 · one mode of the person's map. `label` is the person's own words; null: the app's default name of a standard mode (the phone and
 * the portal word it in their language). `switchedOff` is only ever true in a timeline: a mode no longer in the set, kept for its past
 * check-ins with the name and colour of the last set that had it (greyed and marked "switched off"). `cardText`: the linked coping card's
 * words, for the hub (null on the phone, which opens the card itself).
 */
export type ModeMapEntry = {
  __typename?: 'ModeMapEntry';
  cardId?: Maybe<Scalars['ID']>;
  cardText?: Maybe<Scalars['String']>;
  colour?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  modeId: Scalars['String'];
  own: Scalars['Boolean'];
  switchedOff: Scalars['Boolean'];
};

/**
 * E47 · ModeSet — the person's modes as they are now (the latest set wins), each in their own words with its colour and the coping card
 * it opens. A person who never configured a set has the common seven in the app's default names (`configured: false`).
 */
export type ModeSet = {
  __typename?: 'ModeSet';
  configured: Scalars['Boolean'];
  lastChange?: Maybe<ModeSetChange>;
  modeMap: Array<ModeMapEntry>;
  subject: Scalars['ID'];
};

/**
 * E47 · who last changed the set and when — "last changed by you" / "last changed by Dr. …" (Q-e47g1-3 A). `performerName` is the
 * therapist's name when they did, null when the client did.
 */
export type ModeSetChange = {
  __typename?: 'ModeSetChange';
  byClient: Scalars['Boolean'];
  occurredAt: Scalars['DateTime'];
  performer: Scalars['ID'];
  performerName?: Maybe<Scalars['String']>;
};

/**
 * E47 · ModeTimeline — the person's mode check-ins over a range: the days with each mode's peak, the triggers written most often, the
 * trigger × mode matrix, the Healthy Adult by week, the counts and the mode map with its cards. The range is `days` (7 · 30 · 90) or
 * `from`–`to` (inclusive local dates). On the phone the free tier sees only the last `historyDays` (7): older days are NOT sent —
 * `olderDays` counts the days with a check-in that the Premium line blurs; `historyDays: null` is the whole log (Premium, and the hub).
 * Display only: no alert, no score, no advice.
 */
export type ModeTimeline = {
  __typename?: 'ModeTimeline';
  cards: Array<ModeCardLink>;
  checkIns: Scalars['Int'];
  checkInsThisWeek: Scalars['Int'];
  entries: Array<ModeTimelineEntry>;
  from: Scalars['String'];
  healthyAdultShare: Array<ModeHealthyAdultWeek>;
  historyDays?: Maybe<Scalars['Int']>;
  lastChange?: Maybe<ModeSetChange>;
  modeDays: Array<ModeDay>;
  modeMap: Array<ModeMapEntry>;
  olderDays: Scalars['Int'];
  subject: Scalars['ID'];
  to: Scalars['String'];
  topTriggers: Array<ModeTriggerCount>;
  triggerMatrix: Array<ModeTriggerRow>;
};

export type ModeTimelineEntry = {
  __typename?: 'ModeTimelineEntry';
  bodyCue?: Maybe<Scalars['String']>;
  checkInId: Scalars['ID'];
  modes: Array<ModeCheckInModeValue>;
  need?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  recordedAt: Scalars['DateTime'];
  trigger?: Maybe<Scalars['String']>;
};

export type ModeTriggerCount = {
  __typename?: 'ModeTriggerCount';
  count: Scalars['Int'];
  trigger: Scalars['String'];
};

export type ModeTriggerModeCount = {
  __typename?: 'ModeTriggerModeCount';
  count: Scalars['Int'];
  modeId: Scalars['String'];
};

export type ModeTriggerRow = {
  __typename?: 'ModeTriggerRow';
  modes: Array<ModeTriggerModeCount>;
  trigger: Scalars['String'];
};

export type MoodByDay = {
  __typename?: 'MoodByDay';
  activitiesDone: Scalars['Int'];
  date: Scalars['String'];
  mood?: Maybe<Scalars['Int']>;
};

export type MostUsedStats = {
  __typename?: 'MostUsedStats';
  count: Scalars['Int'];
  entityId: Scalars['ID'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acknowledgeFeatureAnnouncement?: Maybe<Scalars['Boolean']>;
  acknowledgeHomework: HomeworkCommandPayload;
  activateExperiment?: Maybe<BehaviorExperimentPayload>;
  addCycleThought?: Maybe<ViciousCyclePayload>;
  addPracticeUser?: Maybe<PracticeUserInfoUpdateResponse>;
  adjustStoppedReminderSchedule?: Maybe<EsReminderCommandResponse>;
  amendExpositionReaction?: Maybe<ExpositionPayload>;
  amendHomework: HomeworkCommandPayload;
  assignHomework: HomeworkCommandPayload;
  cancelHomework: HomeworkCommandPayload;
  chooseBehaviorStrategy: ValuesCommandPayload;
  chooseBehaviorStrategyInSession: ValuesCommandPayload;
  clearSleepWindow: SleepCommandPayload;
  closeChangeGoal: MiCommandPayload;
  commentOnHomework: CommentOnHomeworkPayload;
  commitToValuedAction: ValuesCommandPayload;
  completeExperiment?: Maybe<BehaviorExperimentPayload>;
  completeHomework: HomeworkCommandPayload;
  completePlannedActivity: BaCommandPayload;
  completeValuedLivingQuestionnaire: ValuesCommandPayload;
  completeValuesSort: ValuesCommandPayload;
  configureModeSet: ModeCommandPayload;
  configureValuesWheel: ValuesCommandPayload;
  confirmSleepNight: SleepCommandPayload;
  /** Mobile · the client's answer. `approved: false` records nothing and the request stays pending. */
  consentToClientTransfer?: Maybe<ClientTransferConsentResponse>;
  createActivatingEvent?: Maybe<ActivatingEventResponse>;
  createAssessmentInSession: AssessmentCommandPayload;
  createAuthToken?: Maybe<AuthTokenPayload>;
  createDateTimeReminder?: Maybe<DateTimeReminderResponse>;
  createDayReminders?: Maybe<DayRemindersResponse>;
  createInvite?: Maybe<Invite>;
  createLocation?: Maybe<LocationResponse>;
  createLocationReminder?: Maybe<LocationReminderResponse>;
  createMessageToTherapist?: Maybe<MessageCreateUpdateResponse>;
  createNonAppClient?: Maybe<Client>;
  createPortalCard?: Maybe<ThoughtResponse>;
  createPortalThought?: Maybe<ThoughtResponse>;
  createPractice?: Maybe<Practice>;
  createPracticeAndLocation?: Maybe<Practice>;
  createPracticeLocation?: Maybe<PracticeLocation>;
  createStandaloneCard: CreateStandaloneCardPayload;
  createStripePortalSession?: Maybe<StripePortalSessionCreateResult>;
  createStripeSession?: Maybe<StripeSession>;
  createTest?: Maybe<TestResponse>;
  createTherapistClientEdge?: Maybe<TherapistClientEdge>;
  createThought?: Maybe<ThoughtResponse>;
  createUsageEvents?: Maybe<UsageEventsResponse>;
  createUser?: Maybe<UserResponse>;
  createViciousCycle?: Maybe<ViciousCyclePayload>;
  createWorryTree?: Maybe<WorryTree>;
  deferSignOut?: Maybe<Scalars['Boolean']>;
  defineDiaryCard: DefineDiaryCardPayload;
  definePathway: PathwayPayload;
  defineValueActivity: ValuesCommandPayload;
  defineWorksheetTemplate: WorksheetTemplatePayload;
  deleteActivatingEvent: DeleteActivatingEventPayload;
  deleteCheckIn: CheckInCommandPayload;
  deleteClient?: Maybe<Client>;
  deleteDateTimeReminder?: Maybe<DateTimeReminderDeleteResponse>;
  deleteDayReminders?: Maybe<DeleteDayRemindersResponse>;
  deleteExposureStimulus?: Maybe<ExposureStimulus>;
  deleteInvite?: Maybe<Invite>;
  deleteLocationReminder?: Maybe<LocationReminderDeleteResponse>;
  deleteModeCheckIn: ModeCommandPayload;
  deletePracticeUser?: Maybe<User>;
  deleteSupportingCycle?: Maybe<SupportingCycle>;
  deleteThought?: Maybe<ThoughtDeleteResponse>;
  deleteViciousCycle?: Maybe<DeleteViciousCyclePayload>;
  deleteWorryTree?: Maybe<WorryTree>;
  describeBehaviorStrategy: ValuesCommandPayload;
  describeBehaviorStrategyInSession: ValuesCommandPayload;
  designBehaviorExperiment?: Maybe<BehaviorExperimentPayload>;
  disableAppLock: AppLockCommandPayload;
  editCycleThought?: Maybe<ViciousCyclePayload>;
  enableAppLock: AppLockCommandPayload;
  endReminderSchedule?: Maybe<EsReminderCommandResponse>;
  /**
   * E04 · EndReviewSession — closes the caller's open bracket on the client (`endedVia: explicit`;
   * refused when none is open: REVIEW_SESSION_NONE_ACTIVE). The idle-timeout end is the server's own.
   */
  endReviewSession?: Maybe<ReviewSession>;
  enrollInPathway: PathwayEnrollmentPayload;
  eraseUserData: ErasureResult;
  exposureStimulus?: Maybe<ExposureStimulus>;
  fillDiaryCard: FillDiaryCardPayload;
  fillDiaryCardInSession: FillDiaryCardPayload;
  finishErasure: Array<ErasureStep>;
  finishExposition?: Maybe<ExpositionPayload>;
  generateDalleImage?: Maybe<GenerateDalleImageResponse>;
  generateGptExposuresHierarchy?: Maybe<GptExposuresHierarchy>;
  generateGptExposuresHierarchyPrompt?: Maybe<GptExposuresHierarchyPrompt>;
  /** Portal · issue the practice's client-invite link, or rotate it (the old one stops resolving). */
  generatePermanentInviteLink?: Maybe<PermanentInviteLink>;
  grantBackofficeAccess: Array<BackofficeMember>;
  grantHealthDataAccess: HealthDataCommandPayload;
  importWorksheetTemplate: WorksheetImportDraft;
  /** Mobile · join a practice by its link. A guessed, mutated or rotated token is refused. */
  joinPracticeByInviteLink?: Maybe<JoinPracticeResponse>;
  keepDayReminders?: Maybe<KeepDayRemindersResponse>;
  keepLocationReminders?: Maybe<KeepLocationRemindersResponse>;
  linkCardToMode: ModeCommandPayload;
  linkRecordToValue: ValuesCommandPayload;
  logActivity: BaCommandPayload;
  makeSupportContract: BaCommandPayload;
  markChangeDay: FaCommandPayload;
  mergeClients?: Maybe<Client>;
  missPlannedActivity: BaCommandPayload;
  noteChangeTalk: MiCommandPayload;
  noteValuesObstacle: ValuesCommandPayload;
  planActivity: BaCommandPayload;
  planActivityInSession: BaCommandPayload;
  planContingencyChange: FaCommandPayload;
  planExperiment?: Maybe<BehaviorExperimentPayload>;
  practiceUserInfoUpdate?: Maybe<PracticeUserInfoUpdateResponse>;
  predictOutcome?: Maybe<BehaviorExperimentPayload>;
  publishActivityLibrary: BaCommandPayload;
  publishDiaryCardTemplate: DefineDiaryCardPayload;
  publishInstrument: AssessmentCommandPayload;
  publishValuesDeck: ValuesCommandPayload;
  publishWorksheetTemplate: WorksheetTemplatePayload;
  rankActivities: BaCommandPayload;
  rateChange: MiCommandPayload;
  rateStrategyOnNeeds: ValuesCommandPayload;
  rateStrategyOnNeedsInSession: ValuesCommandPayload;
  rateValuesWheel: ValuesCommandPayload;
  rateValuesWheelInSession: ValuesCommandPayload;
  /** Portal · complete a transfer the client approved. Refused without a recorded consent. */
  reassignClient?: Maybe<ClientTransferRequestResponse>;
  recordBehaviorInstance: FaCommandPayload;
  recordCheckIn: CheckInCommandPayload;
  recordCheckInInSession: CheckInCommandPayload;
  recordCoursePurchase: CoursePurchasePayload;
  recordExpositionReaction?: Maybe<ExpositionPayload>;
  recordExternalAssessment: AssessmentCommandPayload;
  recordModeCheckIn: ModeCommandPayload;
  recordObservation?: Maybe<RecordObservationPayload>;
  recordSafetyPlanOpened: SafetyPlanCommandPayload;
  refreshAuthToken?: Maybe<AuthTokenPayload>;
  releasePathwayStep: ReleasePathwayStepPayload;
  removeActivityLog: BaCommandPayload;
  removeCycleThought?: Maybe<ViciousCyclePayload>;
  renameViciousCycle?: Maybe<ViciousCyclePayload>;
  reopenChangeGoal: MiCommandPayload;
  reopenHomework: HomeworkCommandPayload;
  requestAccountDeletion: AccountDeletionStatus;
  requestActivitySuggestions: ActivitySuggestionsPayload;
  requestBehaviorExperimentSuggestions?: Maybe<BehaviorExperimentSuggestionsPayload>;
  /** Portal · ask a client to move to a colleague. Records the request; the CLIENT decides. */
  requestClientTransfer?: Maybe<ClientTransferRequestResponse>;
  requestHealthRead: HealthDataCommandPayload;
  requestHomeworkReminder: HomeworkCommandPayload;
  resetPracticeUserPassword?: Maybe<PracticeResetUserPasswordResponse>;
  restoreTrimmedReminders?: Maybe<RestoreTrimmedRemindersResponse>;
  retirePathway: PathwayPayload;
  retireTargetBehavior: FaCommandPayload;
  retireWorksheetTemplate: WorksheetTemplatePayload;
  reviewPathwayPublication: PathwayPayload;
  reviewSafetyPlan: SafetyPlanCommandPayload;
  revisePathway: PathwayPayload;
  reviseWorksheetTemplate: WorksheetTemplatePayload;
  revokeAuthTokens?: Maybe<Scalars['Boolean']>;
  revokeBackofficeAccess: Array<BackofficeMember>;
  revokeHealthDataAccess: HealthDataCommandPayload;
  rotatePermanentInviteLink?: Maybe<PermanentInviteLink>;
  setChangeGoal: MiCommandPayload;
  setHealthDataSharing: HealthDataCommandPayload;
  setHiddenTools: MyHiddenTools;
  setPathwayAccessRule: PathwayPayload;
  setPracticeCapability: PracticeCapabilityPayload;
  setReminderSchedule?: Maybe<EsReminderScheduleResponse>;
  setSleepWindow: SleepCommandPayload;
  setTargetBehavior: FaCommandPayload;
  signWorksheet: WorksheetSubmissionPayload;
  skipHomework: HomeworkCommandPayload;
  skipReminderOccurrence?: Maybe<EsReminderCommandResponse>;
  startBehaviorExperiment?: Maybe<BehaviorExperimentPayload>;
  startExposition?: Maybe<ExpositionPayload>;
  /**
   * E04 · StartReviewSession — opens the caller's explicit RTM billable bracket on the client
   * (refused while they already hold an open one: REVIEW_SESSION_ALREADY_ACTIVE).
   */
  startReviewSession?: Maybe<ReviewSession>;
  startValuesSort: ValuesCommandPayload;
  stateHypotheses?: Maybe<BehaviorExperimentPayload>;
  submitThoughtTestEvents: SubmitThoughtTestEventsPayload;
  submitWellnessEvents: SubmitWellnessEventsPayload;
  submitWorksheet: WorksheetSubmissionPayload;
  toggleCycleRelation?: Maybe<ViciousCyclePayload>;
  translateHealthSummaries: HealthDataCommandPayload;
  unlinkRecordFromValue: ValuesCommandPayload;
  updateActivatingEvent?: Maybe<ActivatingEventResponse>;
  updateClient?: Maybe<Client>;
  updateClientDiagnoses?: Maybe<Client>;
  updateDateTimeReminder?: Maybe<DateTimeReminderResponse>;
  updateDayReminders?: Maybe<DayRemindersResponse>;
  updateExposureStimuli?: Maybe<Array<Maybe<ExposureStimulus>>>;
  updateExposureStimulus?: Maybe<ExposureStimulus>;
  updateFcmToken?: Maybe<UserResponse>;
  updateLocation?: Maybe<LocationResponse>;
  updateLocationReminder?: Maybe<LocationReminderResponse>;
  updateMessageRead?: Maybe<MessageCreateUpdateResponse>;
  updateObservation?: Maybe<RecordObservationPayload>;
  updatePortalCard?: Maybe<Thought>;
  updatePortalThought?: Maybe<Thought>;
  updatePractice?: Maybe<Practice>;
  updatePracticeLocation?: Maybe<PracticeLocation>;
  updatePracticeUser?: Maybe<User>;
  updateProfile?: Maybe<Profile>;
  updateSafetyPlanSection: SafetyPlanCommandPayload;
  updateSafetyPlanSectionInSession: SafetyPlanCommandPayload;
  updateTherapistClientEdge?: Maybe<TherapistClientEdge>;
  updateThought?: Maybe<ThoughtResponse>;
  updateUserAccessLevel?: Maybe<UserResponse>;
  updateUserPrivacy?: Maybe<UserResponse>;
  updateUserRole?: Maybe<UserResponse>;
  updateUserSetting?: Maybe<UserResponse>;
  upsertAbcModel?: Maybe<AbcModel>;
  upsertBehaviorExperiment?: Maybe<BehaviorExperiment>;
  upsertConceptualization?: Maybe<Conceptualization>;
  upsertDownwardArrow?: Maybe<DownwardArrow>;
  upsertExposure?: Maybe<Exposure>;
  upsertExposureStimulus?: Maybe<ExposureStimulus>;
  upsertPracticeUsageEvents?: Maybe<Array<Maybe<PracticeUsageEvent>>>;
  upsertProgressNote?: Maybe<ProgressNote>;
  upsertSession?: Maybe<Session>;
  upsertSupportingCycle?: Maybe<SupportingCycle>;
  watchAssignedVideo: HomeworkCommandPayload;
  withdrawFromPathway: PathwayEnrollmentPayload;
  writeChangePlan: MiCommandPayload;
  writeDecisionalBalance: MiCommandPayload;
  writeStrategyPlan: ValuesCommandPayload;
};

export type MutationAcknowledgeFeatureAnnouncementArgs = {
  announcementId: Scalars['ID'];
  seenAs: Scalars['ID'];
  surface: Scalars['String'];
};

export type MutationAcknowledgeHomeworkArgs = {
  assignmentId: Scalars['ID'];
};

export type MutationActivateExperimentArgs = {
  input: ActivateExperimentInput;
};

export type MutationAddCycleThoughtArgs = {
  input: AddCycleThoughtInput;
};

export type MutationAddPracticeUserArgs = {
  input: PracticeAddUserInput;
};

export type MutationAdjustStoppedReminderScheduleArgs = {
  reminderId: Scalars['ID'];
  schedule: EsReminderScheduleInput;
  subject?: InputMaybe<Scalars['ID']>;
};

export type MutationAmendExpositionReactionArgs = {
  input: AmendExpositionReactionInput;
};

export type MutationAmendHomeworkArgs = {
  input: AmendHomeworkInput;
};

export type MutationAssignHomeworkArgs = {
  input: AssignHomeworkInput;
};

export type MutationCancelHomeworkArgs = {
  input: CancelHomeworkInput;
};

export type MutationChooseBehaviorStrategyArgs = {
  input: ChooseBehaviorStrategyInput;
};

export type MutationChooseBehaviorStrategyInSessionArgs = {
  input: ChooseBehaviorStrategyInSessionInput;
};

export type MutationClearSleepWindowArgs = {
  input: ClearSleepWindowInput;
};

export type MutationCloseChangeGoalArgs = {
  input: CloseChangeGoalInput;
};

export type MutationCommentOnHomeworkArgs = {
  input: CommentOnHomeworkInput;
};

export type MutationCommitToValuedActionArgs = {
  input: CommitToValuedActionInput;
};

export type MutationCompleteExperimentArgs = {
  input: CompleteExperimentInput;
};

export type MutationCompleteHomeworkArgs = {
  input: CompleteHomeworkInput;
};

export type MutationCompletePlannedActivityArgs = {
  input: CompletePlannedActivityInput;
};

export type MutationCompleteValuedLivingQuestionnaireArgs = {
  input: CompleteValuedLivingQuestionnaireInput;
};

export type MutationCompleteValuesSortArgs = {
  input: CompleteValuesSortInput;
};

export type MutationConfigureModeSetArgs = {
  input: ConfigureModeSetInput;
};

export type MutationConfigureValuesWheelArgs = {
  input: ConfigureValuesWheelInput;
};

export type MutationConfirmSleepNightArgs = {
  input: ConfirmSleepNightInput;
};

export type MutationConsentToClientTransferArgs = {
  input: ConsentToClientTransferInput;
};

export type MutationCreateActivatingEventArgs = {
  activatingEvent: ActivatingEventCreateInput;
};

export type MutationCreateAssessmentInSessionArgs = {
  input: CreateAssessmentInSessionInput;
};

export type MutationCreateAuthTokenArgs = {
  firebaseToken: Scalars['String'];
};

export type MutationCreateDateTimeReminderArgs = {
  dateTimeReminder: DateTimeReminderCreateInput;
};

export type MutationCreateDayRemindersArgs = {
  dayReminders: DayRemindersCreateInput;
};

export type MutationCreateInviteArgs = {
  input?: InputMaybe<CreateInviteInput>;
};

export type MutationCreateLocationArgs = {
  location: LocationCreateInput;
};

export type MutationCreateLocationReminderArgs = {
  locationReminder: LocationReminderCreateInput;
};

export type MutationCreateMessageToTherapistArgs = {
  input: MessageToTherapistInput;
};

export type MutationCreateNonAppClientArgs = {
  input?: InputMaybe<CreateNonAppClientInput>;
};

export type MutationCreatePortalCardArgs = {
  input?: InputMaybe<PortalCardCreateInput>;
};

export type MutationCreatePortalThoughtArgs = {
  input?: InputMaybe<PortalThoughtCreateInput>;
};

export type MutationCreatePracticeArgs = {
  input?: InputMaybe<PracticeCreateInput>;
};

export type MutationCreatePracticeAndLocationArgs = {
  input?: InputMaybe<PracticeAndLocationCreateInput>;
};

export type MutationCreatePracticeLocationArgs = {
  input?: InputMaybe<PracticeLocationCreateInput>;
};

export type MutationCreateStandaloneCardArgs = {
  input: CreateStandaloneCardInput;
};

export type MutationCreateStripePortalSessionArgs = {
  input?: InputMaybe<StripePortalSessionCreateInput>;
};

export type MutationCreateStripeSessionArgs = {
  input?: InputMaybe<StripeSessionCreateInput>;
};

export type MutationCreateTestArgs = {
  test: TestCreateInput;
};

export type MutationCreateTherapistClientEdgeArgs = {
  input?: InputMaybe<TherapistClientECreateInput>;
};

export type MutationCreateThoughtArgs = {
  thought: ThoughtCreateInput;
};

export type MutationCreateUsageEventsArgs = {
  events?: InputMaybe<Array<UsageEventInput>>;
};

export type MutationCreateUserArgs = {
  user: UserInput;
};

export type MutationCreateViciousCycleArgs = {
  input: CreateViciousCycleInput;
};

export type MutationCreateWorryTreeArgs = {
  input?: InputMaybe<WorryTreeInput>;
};

export type MutationDeferSignOutArgs = {
  authSessionId: Scalars['ID'];
  deferredUntil: Scalars['DateTime'];
  platform: Scalars['String'];
};

export type MutationDefineDiaryCardArgs = {
  input: DefineDiaryCardInput;
};

export type MutationDefinePathwayArgs = {
  input: DefinePathwayInput;
};

export type MutationDefineValueActivityArgs = {
  input: DefineValueActivityInput;
};

export type MutationDefineWorksheetTemplateArgs = {
  input: DefineWorksheetTemplateInput;
};

export type MutationDeleteActivatingEventArgs = {
  activatingEventId: Scalars['ID'];
};

export type MutationDeleteCheckInArgs = {
  input: DeleteCheckInInput;
};

export type MutationDeleteClientArgs = {
  input?: InputMaybe<DeleteClientInput>;
};

export type MutationDeleteDateTimeReminderArgs = {
  _id: Scalars['ID'];
};

export type MutationDeleteDayRemindersArgs = {
  _id: Scalars['String'];
};

export type MutationDeleteExposureStimulusArgs = {
  input?: InputMaybe<DeleteExposureStimulusInput>;
};

export type MutationDeleteInviteArgs = {
  input?: InputMaybe<DeleteInviteInput>;
};

export type MutationDeleteLocationReminderArgs = {
  _id: Scalars['ID'];
};

export type MutationDeleteModeCheckInArgs = {
  input: DeleteModeCheckInInput;
};

export type MutationDeletePracticeUserArgs = {
  input?: InputMaybe<DeletePracticeUserInput>;
};

export type MutationDeleteSupportingCycleArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};

export type MutationDeleteThoughtArgs = {
  _id: Scalars['String'];
};

export type MutationDeleteViciousCycleArgs = {
  input: DeleteViciousCycleInput;
};

export type MutationDeleteWorryTreeArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};

export type MutationDescribeBehaviorStrategyArgs = {
  input: DescribeBehaviorStrategyInput;
};

export type MutationDescribeBehaviorStrategyInSessionArgs = {
  input: DescribeBehaviorStrategyInSessionInput;
};

export type MutationDesignBehaviorExperimentArgs = {
  input: DesignBehaviorExperimentInput;
};

export type MutationDisableAppLockArgs = {
  input: DisableAppLockInput;
};

export type MutationEditCycleThoughtArgs = {
  input: EditCycleThoughtInput;
};

export type MutationEnableAppLockArgs = {
  input: EnableAppLockInput;
};

export type MutationEndReminderScheduleArgs = {
  reason: Scalars['String'];
  reminderId: Scalars['ID'];
  subject?: InputMaybe<Scalars['ID']>;
};

export type MutationEndReviewSessionArgs = {
  reviewSessionId?: InputMaybe<Scalars['ID']>;
  subject: Scalars['ID'];
};

export type MutationEnrollInPathwayArgs = {
  input: EnrollInPathwayInput;
};

export type MutationEraseUserDataArgs = {
  confirm: Scalars['String'];
  reason: Scalars['String'];
  subject: Scalars['String'];
};

export type MutationExposureStimulusArgs = {
  input?: InputMaybe<UpdateExposureInput>;
};

export type MutationFillDiaryCardArgs = {
  input: FillDiaryCardInput;
};

export type MutationFillDiaryCardInSessionArgs = {
  input: FillDiaryCardInSessionInput;
};

export type MutationFinishErasureArgs = {
  subject: Scalars['String'];
};

export type MutationFinishExpositionArgs = {
  input: FinishExpositionInput;
};

export type MutationGenerateDalleImageArgs = {
  content: Scalars['String'];
  exposureId?: InputMaybe<Scalars['ID']>;
  lng: Scalars['String'];
  subject?: InputMaybe<Scalars['ID']>;
};

export type MutationGenerateGptExposuresHierarchyArgs = {
  clientId?: InputMaybe<Scalars['ID']>;
  exposureId: Scalars['ID'];
  fear: Scalars['String'];
  lng: Scalars['String'];
  safetyBehaviorsToAvoid?: InputMaybe<Scalars['String']>;
  type: Scalars['Int'];
};

export type MutationGenerateGptExposuresHierarchyPromptArgs = {
  clientId?: InputMaybe<Scalars['ID']>;
  exposureId: Scalars['ID'];
  fear: Scalars['String'];
  lng: Scalars['String'];
  safetyBehaviorsToAvoid?: InputMaybe<Scalars['String']>;
  type: Scalars['Int'];
};

export type MutationGrantBackofficeAccessArgs = {
  email: Scalars['String'];
};

export type MutationGrantHealthDataAccessArgs = {
  input: GrantHealthDataAccessInput;
};

export type MutationImportWorksheetTemplateArgs = {
  input: ImportWorksheetTemplateInput;
};

export type MutationJoinPracticeByInviteLinkArgs = {
  token: Scalars['String'];
};

export type MutationKeepDayRemindersArgs = {
  stringifiedIdsAndKeys: Scalars['String'];
};

export type MutationKeepLocationRemindersArgs = {
  ids: Array<Scalars['ID']>;
};

export type MutationLinkCardToModeArgs = {
  input: LinkCardToModeInput;
};

export type MutationLinkRecordToValueArgs = {
  input: LinkRecordToValueInput;
};

export type MutationLogActivityArgs = {
  input: LogActivityInput;
};

export type MutationMakeSupportContractArgs = {
  input: MakeSupportContractInput;
};

export type MutationMarkChangeDayArgs = {
  input: MarkChangeDayInput;
};

export type MutationMergeClientsArgs = {
  input?: InputMaybe<MergeClientsInput>;
};

export type MutationMissPlannedActivityArgs = {
  input: MissPlannedActivityInput;
};

export type MutationNoteChangeTalkArgs = {
  input: NoteChangeTalkInput;
};

export type MutationNoteValuesObstacleArgs = {
  input: NoteValuesObstacleInput;
};

export type MutationPlanActivityArgs = {
  input: PlanActivityInput;
};

export type MutationPlanActivityInSessionArgs = {
  input: PlanActivityInSessionInput;
};

export type MutationPlanContingencyChangeArgs = {
  input: PlanContingencyChangeInput;
};

export type MutationPlanExperimentArgs = {
  input: PlanExperimentInput;
};

export type MutationPracticeUserInfoUpdateArgs = {
  input: PracticeUserInfoUpdateInput;
};

export type MutationPredictOutcomeArgs = {
  input: PredictOutcomeInput;
};

export type MutationPublishActivityLibraryArgs = {
  input: PublishActivityLibraryInput;
};

export type MutationPublishDiaryCardTemplateArgs = {
  input: PublishDiaryCardTemplateInput;
};

export type MutationPublishInstrumentArgs = {
  input: PublishInstrumentInput;
};

export type MutationPublishValuesDeckArgs = {
  input: PublishValuesDeckInput;
};

export type MutationPublishWorksheetTemplateArgs = {
  input: PublishWorksheetTemplateInput;
};

export type MutationRankActivitiesArgs = {
  input: RankActivitiesInput;
};

export type MutationRateChangeArgs = {
  input: RateChangeInput;
};

export type MutationRateStrategyOnNeedsArgs = {
  input: RateStrategyOnNeedsInput;
};

export type MutationRateStrategyOnNeedsInSessionArgs = {
  input: RateStrategyOnNeedsInSessionInput;
};

export type MutationRateValuesWheelArgs = {
  input: RateValuesWheelInput;
};

export type MutationRateValuesWheelInSessionArgs = {
  input: RateValuesWheelInSessionInput;
};

export type MutationReassignClientArgs = {
  input: ReassignClientInput;
};

export type MutationRecordBehaviorInstanceArgs = {
  input: RecordBehaviorInstanceInput;
};

export type MutationRecordCheckInArgs = {
  input: RecordCheckInInput;
};

export type MutationRecordCheckInInSessionArgs = {
  input: RecordCheckInInSessionInput;
};

export type MutationRecordCoursePurchaseArgs = {
  input: RecordCoursePurchaseInput;
};

export type MutationRecordExpositionReactionArgs = {
  input: RecordExpositionReactionInput;
};

export type MutationRecordExternalAssessmentArgs = {
  input: RecordExternalAssessmentInput;
};

export type MutationRecordModeCheckInArgs = {
  input: RecordModeCheckInInput;
};

export type MutationRecordObservationArgs = {
  input: RecordObservationInput;
};

export type MutationRecordSafetyPlanOpenedArgs = {
  input: RecordSafetyPlanOpenedInput;
};

export type MutationRefreshAuthTokenArgs = {
  refreshToken: Scalars['String'];
};

export type MutationReleasePathwayStepArgs = {
  input: ReleasePathwayStepInput;
};

export type MutationRemoveActivityLogArgs = {
  input: RemoveActivityLogInput;
};

export type MutationRemoveCycleThoughtArgs = {
  input: RemoveCycleThoughtInput;
};

export type MutationRenameViciousCycleArgs = {
  input: RenameViciousCycleInput;
};

export type MutationReopenChangeGoalArgs = {
  input: ReopenChangeGoalInput;
};

export type MutationReopenHomeworkArgs = {
  input: ReopenHomeworkInput;
};

export type MutationRequestAccountDeletionArgs = {
  via: Scalars['String'];
};

export type MutationRequestActivitySuggestionsArgs = {
  input: RequestActivitySuggestionsInput;
};

export type MutationRequestBehaviorExperimentSuggestionsArgs = {
  input: RequestBehaviorExperimentSuggestionsInput;
};

export type MutationRequestClientTransferArgs = {
  input: RequestClientTransferInput;
};

export type MutationRequestHealthReadArgs = {
  input: RequestHealthReadInput;
};

export type MutationRequestHomeworkReminderArgs = {
  input: RequestHomeworkReminderInput;
};

export type MutationResetPracticeUserPasswordArgs = {
  input: PracticeResetUserPasswordInput;
};

export type MutationRetirePathwayArgs = {
  input: RetirePathwayInput;
};

export type MutationRetireTargetBehaviorArgs = {
  input: RetireTargetBehaviorInput;
};

export type MutationRetireWorksheetTemplateArgs = {
  input: RetireWorksheetTemplateInput;
};

export type MutationReviewPathwayPublicationArgs = {
  input: ReviewPathwayPublicationInput;
};

export type MutationReviewSafetyPlanArgs = {
  input: ReviewSafetyPlanInput;
};

export type MutationRevisePathwayArgs = {
  input: RevisePathwayInput;
};

export type MutationReviseWorksheetTemplateArgs = {
  input: ReviseWorksheetTemplateInput;
};

export type MutationRevokeBackofficeAccessArgs = {
  subject: Scalars['String'];
};

export type MutationRevokeHealthDataAccessArgs = {
  input: RevokeHealthDataAccessInput;
};

export type MutationSetChangeGoalArgs = {
  input: SetChangeGoalInput;
};

export type MutationSetHealthDataSharingArgs = {
  input: SetHealthDataSharingInput;
};

export type MutationSetHiddenToolsArgs = {
  input: SetHiddenToolsInput;
};

export type MutationSetPathwayAccessRuleArgs = {
  input: SetPathwayAccessRuleInput;
};

export type MutationSetPracticeCapabilityArgs = {
  input: SetPracticeCapabilityInput;
};

export type MutationSetReminderScheduleArgs = {
  channel?: InputMaybe<Scalars['String']>;
  reminderId?: InputMaybe<Scalars['ID']>;
  schedule: EsReminderScheduleInput;
  subject?: InputMaybe<Scalars['ID']>;
  target: EsReminderTargetInput;
};

export type MutationSetSleepWindowArgs = {
  input: SetSleepWindowInput;
};

export type MutationSetTargetBehaviorArgs = {
  input: SetTargetBehaviorInput;
};

export type MutationSignWorksheetArgs = {
  input: SignWorksheetInput;
};

export type MutationSkipHomeworkArgs = {
  input: SkipHomeworkInput;
};

export type MutationSkipReminderOccurrenceArgs = {
  occurrenceDate: Scalars['String'];
  reminderId: Scalars['ID'];
};

export type MutationStartBehaviorExperimentArgs = {
  input: StartBehaviorExperimentInput;
};

export type MutationStartExpositionArgs = {
  input: StartExpositionInput;
};

export type MutationStartReviewSessionArgs = {
  subject: Scalars['ID'];
};

export type MutationStartValuesSortArgs = {
  input: StartValuesSortInput;
};

export type MutationStateHypothesesArgs = {
  input: StateHypothesesInput;
};

export type MutationSubmitThoughtTestEventsArgs = {
  events: Array<ThoughtTestEventInput>;
  subject?: InputMaybe<Scalars['ID']>;
  thoughtTestId: Scalars['ID'];
};

export type MutationSubmitWellnessEventsArgs = {
  events: Array<WellnessEventInput>;
};

export type MutationSubmitWorksheetArgs = {
  input: SubmitWorksheetInput;
};

export type MutationToggleCycleRelationArgs = {
  input: ToggleCycleRelationInput;
};

export type MutationTranslateHealthSummariesArgs = {
  input: TranslateHealthSummariesInput;
};

export type MutationUnlinkRecordFromValueArgs = {
  input: UnlinkRecordFromValueInput;
};

export type MutationUpdateActivatingEventArgs = {
  activatingEvent: ActivatingEventUpdateInput;
};

export type MutationUpdateClientArgs = {
  input?: InputMaybe<UpdateClientInput>;
};

export type MutationUpdateClientDiagnosesArgs = {
  input?: InputMaybe<UpdateClientDiagnosesInput>;
};

export type MutationUpdateDateTimeReminderArgs = {
  dateTimeReminder: DateTimeReminderUpdateInput;
};

export type MutationUpdateDayRemindersArgs = {
  dayReminders: DayRemindersUpdateInput;
};

export type MutationUpdateExposureStimuliArgs = {
  input?: InputMaybe<UpdateExposureStimuliInput>;
};

export type MutationUpdateExposureStimulusArgs = {
  data: ExposureStimulusInputData;
  id: Scalars['ID'];
};

export type MutationUpdateFcmTokenArgs = {
  fcmToken: UserFcmTokenInput;
};

export type MutationUpdateLocationArgs = {
  location: LocationUpdateInput;
};

export type MutationUpdateLocationReminderArgs = {
  locationReminder: LocationReminderUpdateInput;
};

export type MutationUpdateMessageReadArgs = {
  input: MessageReadInput;
};

export type MutationUpdateObservationArgs = {
  input: UpdateObservationInput;
};

export type MutationUpdatePortalCardArgs = {
  input?: InputMaybe<UpdatePortalCardInput>;
};

export type MutationUpdatePortalThoughtArgs = {
  input?: InputMaybe<UpdatePortalThoughtInput>;
};

export type MutationUpdatePracticeArgs = {
  input?: InputMaybe<UpdatePracticeInput>;
};

export type MutationUpdatePracticeLocationArgs = {
  input?: InputMaybe<PracticeLocationUpdateInput>;
};

export type MutationUpdatePracticeUserArgs = {
  input?: InputMaybe<UpdatePracticeUserInput>;
};

export type MutationUpdateProfileArgs = {
  input?: InputMaybe<UpdateProfileInput>;
};

export type MutationUpdateSafetyPlanSectionArgs = {
  input: UpdateSafetyPlanSectionInput;
};

export type MutationUpdateSafetyPlanSectionInSessionArgs = {
  input: UpdateSafetyPlanSectionInSessionInput;
};

export type MutationUpdateTherapistClientEdgeArgs = {
  input?: InputMaybe<TherapistClientEUpdateInput>;
};

export type MutationUpdateThoughtArgs = {
  thought: ThoughtUpdateInput;
};

export type MutationUpdateUserAccessLevelArgs = {
  accessLevel: UserSubscriptionInput;
};

export type MutationUpdateUserPrivacyArgs = {
  privacySettings: UserPrivacySettingsInput;
};

export type MutationUpdateUserRoleArgs = {
  role: Scalars['Int'];
};

export type MutationUpdateUserSettingArgs = {
  settings: UserSettingInput;
};

export type MutationUpsertAbcModelArgs = {
  input?: InputMaybe<AbcModelInput>;
};

export type MutationUpsertBehaviorExperimentArgs = {
  input?: InputMaybe<BehaviorExperimentInput>;
};

export type MutationUpsertConceptualizationArgs = {
  input?: InputMaybe<ConceptualizationInput>;
};

export type MutationUpsertDownwardArrowArgs = {
  input?: InputMaybe<DownwardArrowInput>;
};

export type MutationUpsertExposureArgs = {
  input?: InputMaybe<ExposureInput>;
};

export type MutationUpsertExposureStimulusArgs = {
  input?: InputMaybe<ExposureStimulusInput>;
};

export type MutationUpsertPracticeUsageEventsArgs = {
  events?: InputMaybe<Array<PracticeUsageEventInput>>;
};

export type MutationUpsertProgressNoteArgs = {
  input?: InputMaybe<ProgressNoteInput>;
};

export type MutationUpsertSessionArgs = {
  input?: InputMaybe<SessionInput>;
};

export type MutationUpsertSupportingCycleArgs = {
  input?: InputMaybe<SupportingCycleInput>;
};

export type MutationWatchAssignedVideoArgs = {
  input: WatchAssignedVideoInput;
};

export type MutationWithdrawFromPathwayArgs = {
  input: WithdrawFromPathwayInput;
};

export type MutationWriteChangePlanArgs = {
  input: WriteChangePlanInput;
};

export type MutationWriteDecisionalBalanceArgs = {
  input: WriteDecisionalBalanceInput;
};

export type MutationWriteStrategyPlanArgs = {
  input: WriteStrategyPlanInput;
};

export type MyChange = {
  __typename?: 'MyChange';
  goalId: Scalars['ID'];
  label: Scalars['String'];
  lastActivityAt: Scalars['DateTime'];
  linkedValues: Array<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type MyChanges = {
  __typename?: 'MyChanges';
  changes: Array<MyChange>;
  subject: Scalars['ID'];
};

/**
 * E37 · MyCheckIns — the caller's check-ins by day for the last 7 or 30 days (newest first); `checkedInToday` and
 * `streakDays` (consecutive days they checked in, ending today — or yesterday while today is open) are derived
 * with the server's now and the caller's zone. Entries a therapist made in session are listed, marked, and are
 * not the client checking in.
 */
export type MyCheckIns = {
  __typename?: 'MyCheckIns';
  activityDays?: Maybe<Array<CheckInActivityDay>>;
  checkedInToday: Scalars['Boolean'];
  days: Scalars['Int'];
  entries: Array<CheckInEntry>;
  sleepNights?: Maybe<Array<CheckInSleepNight>>;
  streakDays: Scalars['Int'];
};

/**
 * E34 · MyFinishedHomework — one page of the caller's finished rows (done · skipped · withdrawn), newest
 * finish first (Q-hw-page-1 B). `nextCursor` is null on the last page.
 */
export type MyFinishedHomeworkPage = {
  __typename?: 'MyFinishedHomeworkPage';
  items: Array<MyHomework>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type MyHiddenTools = {
  __typename?: 'MyHiddenTools';
  hiddenTools: Array<Scalars['String']>;
  performer: Scalars['ID'];
};

/**
 * E34 · MyHomework — the caller's own homework (every practice's assignments and their own): the To do
 * (`myHomework`), the finished rows paged (`myFinishedHomework`, Q-hw-page-1 B), one by id
 * (`myHomeworkItem`). A withdrawn row stays, among the finished (FQ-3 B, 2026-09-29): `status` cancelled, never open or overdue, no `nextDueAt`, read-only
 * on the phone. `status`: open · done · skipped · cancelled — a one-off row's is the lifecycle fact it folded
 * last; a RECURRING row reads open while it has an open occurrence (the founder's Q-b1c-6 C — it stays
 * in To do and the Toolkit badge), each counted occurrence's outcome in `outcomes` ("this week's:
 * done"). `overdue`, `nextDueAt` (a schedule row's open occurrence) and `outcomes` are computed at read
 * time.
 */
export type MyHomework = {
  __typename?: 'MyHomework';
  activityTarget?: Maybe<Scalars['JSON']>;
  assignedAt: Scalars['DateTime'];
  assignmentId: Scalars['ID'];
  completedAt?: Maybe<Scalars['DateTime']>;
  dueAt?: Maybe<Scalars['DateTime']>;
  instructions?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  nextDueAt?: Maybe<Scalars['DateTime']>;
  occurrenceAt?: Maybe<Scalars['DateTime']>;
  outcomes: Array<HomeworkOccurrenceOutcome>;
  overdue: Scalars['Boolean'];
  paperAllowed: Scalars['Boolean'];
  plannedActivityId?: Maybe<Scalars['ID']>;
  reminderMessage?: Maybe<Scalars['String']>;
  requester: Scalars['ID'];
  requesterName?: Maybe<Scalars['String']>;
  schedule?: Maybe<EsReminderScheduleValue>;
  status: Scalars['String'];
  subject: Scalars['ID'];
  target?: Maybe<HomeworkTarget>;
  title: Scalars['String'];
};

export type MyPathway = {
  __typename?: 'MyPathway';
  enrollmentId: Scalars['ID'];
  nextReleaseAt?: Maybe<Scalars['DateTime']>;
  nextStepTitle?: Maybe<Scalars['String']>;
  pathwayId: Scalars['ID'];
  pathwayName: Scalars['String'];
  pathwayVersion: Scalars['Int'];
  percentDone: Scalars['Int'];
  prescribed: Scalars['Boolean'];
  requesterName?: Maybe<Scalars['String']>;
  sections: Array<PathwaySectionProgress>;
  startAt: Scalars['DateTime'];
  status: Scalars['String'];
  stepsDone: Scalars['Int'];
  stepsTotal: Scalars['Int'];
};

export type MyTargetBehavior = {
  __typename?: 'MyTargetBehavior';
  addedByMe: Scalars['Boolean'];
  canClose: Scalars['Boolean'];
  change?: Maybe<FaChangeInForce>;
  days: Array<FaDay>;
  description?: Maybe<Scalars['String']>;
  instances: Array<FaInstanceBrief>;
  measure: Scalars['String'];
  mostMarked?: Maybe<FaIdea>;
  name: Scalars['String'];
  records: Scalars['Int'];
  stage: Scalars['String'];
  targetId: Scalars['ID'];
  thisWeek: FaWeekFigures;
  threshold: Scalars['Int'];
};

export type MyTargetBehaviors = {
  __typename?: 'MyTargetBehaviors';
  subject: Scalars['ID'];
  targets: Array<MyTargetBehavior>;
  today: Scalars['String'];
};

export type MyTherapist = {
  __typename?: 'MyTherapist';
  performer: Scalars['ID'];
  subject: Scalars['ID'];
};

export type NoteChangeTalkInput = {
  goalId: Scalars['ID'];
  kind?: InputMaybe<Scalars['String']>;
  noteId: Scalars['ID'];
  noticedAt?: InputMaybe<Scalars['DateTime']>;
  talk: Scalars['String'];
};

export type NoteValuesObstacleInput = {
  obstacle: Scalars['String'];
  obstacleId: Scalars['ID'];
  sectorId: Scalars['String'];
  severity: Scalars['Int'];
  wheelId: Scalars['ID'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
};

export type Pathway = {
  __typename?: 'Pathway';
  accessRule?: Maybe<Scalars['String']>;
  completedCount: Scalars['Int'];
  copiedFrom?: Maybe<Scalars['ID']>;
  copiedFromName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  enrolledCount: Scalars['Int'];
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  pathwayId: Scalars['ID'];
  practiceId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  reviewStatus?: Maybe<Scalars['String']>;
  runningCount: Scalars['Int'];
  status: Scalars['String'];
  stepsCount: Scalars['Int'];
  version: Scalars['Int'];
  visibility: Scalars['String'];
};

export type PathwayDetail = {
  __typename?: 'PathwayDetail';
  accessRule?: Maybe<Scalars['String']>;
  copiedFrom?: Maybe<Scalars['ID']>;
  copiedFromName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  library: Scalars['Boolean'];
  name: Scalars['String'];
  pathwayId: Scalars['ID'];
  practiceId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  retired: Scalars['Boolean'];
  reviewStatus?: Maybe<Scalars['String']>;
  runningEnrollments: Scalars['Int'];
  sections: Array<PathwaySection>;
  version: Scalars['Int'];
  visibility: Scalars['String'];
};

export type PathwayEnrollmentPayload = {
  __typename?: 'PathwayEnrollmentPayload';
  enrollmentId: Scalars['ID'];
  recorded: Scalars['Boolean'];
};

export type PathwayLibrary = {
  __typename?: 'PathwayLibrary';
  capabilities: Array<Scalars['String']>;
  pathways: Array<Pathway>;
};

export type PathwayOutcome = {
  __typename?: 'PathwayOutcome';
  completedCount: Scalars['Int'];
  completionRate?: Maybe<Scalars['Int']>;
  copiedFrom?: Maybe<Scalars['ID']>;
  copiedFromName?: Maybe<Scalars['String']>;
  depth: Scalars['Int'];
  enrolledCount: Scalars['Int'];
  medianDaysToComplete?: Maybe<Scalars['Int']>;
  pathwayId: Scalars['ID'];
  pathwayName: Scalars['String'];
  retired: Scalars['Boolean'];
  runningCount: Scalars['Int'];
  withdrawnCount: Scalars['Int'];
};

export type PathwayPayload = {
  __typename?: 'PathwayPayload';
  pathwayId: Scalars['ID'];
  recorded: Scalars['Boolean'];
  version?: Maybe<Scalars['Int']>;
};

export type PathwayProgress = {
  __typename?: 'PathwayProgress';
  endedAt?: Maybe<Scalars['DateTime']>;
  enrollmentId: Scalars['ID'];
  pathwayId: Scalars['ID'];
  pathwayName: Scalars['String'];
  pathwayVersion: Scalars['Int'];
  percentDone: Scalars['Int'];
  practiceId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  requester: Scalars['ID'];
  requesterName?: Maybe<Scalars['String']>;
  sections: Array<PathwaySectionProgress>;
  selfEnrolled: Scalars['Boolean'];
  startAt: Scalars['DateTime'];
  status: Scalars['String'];
  stepsDone: Scalars['Int'];
  stepsSkipped: Scalars['Int'];
  stepsTotal: Scalars['Int'];
  subject: Scalars['ID'];
};

export type PathwayReleaseRule = {
  __typename?: 'PathwayReleaseRule';
  day?: Maybe<Scalars['Int']>;
  delayDays?: Maybe<Scalars['Int']>;
  rule: Scalars['String'];
};

export type PathwayReleaseRuleInput = {
  day?: InputMaybe<Scalars['Int']>;
  delayDays?: InputMaybe<Scalars['Int']>;
  rule: Scalars['String'];
};

export type PathwaySection = {
  __typename?: 'PathwaySection';
  section: Scalars['String'];
  steps: Array<PathwayStep>;
};

export type PathwaySectionInput = {
  section: Scalars['String'];
  steps: Array<PathwayStepInput>;
};

export type PathwaySectionProgress = {
  __typename?: 'PathwaySectionProgress';
  section: Scalars['String'];
  steps: Array<PathwayStepProgress>;
};

export type PathwayStep = {
  __typename?: 'PathwayStep';
  dueDays?: Maybe<Scalars['Int']>;
  instructions?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  release: PathwayReleaseRule;
  stepId: Scalars['ID'];
  target?: Maybe<HomeworkTarget>;
  title: Scalars['String'];
};

export type PathwayStepInput = {
  dueDays?: InputMaybe<Scalars['Int']>;
  instructions?: InputMaybe<Scalars['String']>;
  kind: Scalars['String'];
  release: PathwayReleaseRuleInput;
  stepId: Scalars['ID'];
  target?: InputMaybe<HomeworkTargetInput>;
  title: Scalars['String'];
};

export type PathwayStepProgress = {
  __typename?: 'PathwayStepProgress';
  assignmentId?: Maybe<Scalars['ID']>;
  cancelled: Scalars['Boolean'];
  dueDays?: Maybe<Scalars['Int']>;
  evidence?: Maybe<HomeworkEvidence>;
  instructions?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  outcomeAt?: Maybe<Scalars['DateTime']>;
  release: PathwayReleaseRule;
  releaseAt?: Maybe<Scalars['DateTime']>;
  releasedAt?: Maybe<Scalars['DateTime']>;
  state: Scalars['String'];
  stepId: Scalars['ID'];
  target?: Maybe<HomeworkTarget>;
  title: Scalars['String'];
};

/** A transfer request waiting for THIS client's answer — the mobile prompt reads it. */
export type PendingClientTransfer = {
  __typename?: 'PendingClientTransfer';
  newAssignee: Scalars['ID'];
  /** The member's display name, resolved server-side so the prompt names a person, not a key. */
  newAssigneeName?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['ID']>;
  practiceName?: Maybe<Scalars['String']>;
  requestedAt: Scalars['DateTime'];
};

/** The practice's CURRENT client-invite link. The latest token wins; every earlier one stops resolving. */
export type PermanentInviteLink = {
  __typename?: 'PermanentInviteLink';
  issuedAt: Scalars['DateTime'];
  practiceId: Scalars['ID'];
  /** An opaque CSPRNG token — never a row id, so a mutated URL resolves to nothing. */
  token: Scalars['String'];
  /** The full link the portal renders and the person copies. */
  url: Scalars['String'];
};

export type PlanActivityInSessionInput = {
  certainty?: InputMaybe<Scalars['Int']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  plannedFor: Scalars['DateTime'];
  predictedEnjoyment: Scalars['Int'];
  predictedImportance: Scalars['Int'];
  replanOf?: InputMaybe<Scalars['ID']>;
  subject: Scalars['ID'];
  title: Scalars['String'];
  valueActivityId?: InputMaybe<Scalars['ID']>;
};

export type PlanActivityInput = {
  certainty?: InputMaybe<Scalars['Int']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  plannedActivityId: Scalars['ID'];
  plannedFor: Scalars['DateTime'];
  predictedEnjoyment: Scalars['Int'];
  predictedImportance: Scalars['Int'];
  replanOf?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
  valueActivityId?: InputMaybe<Scalars['ID']>;
};

export type PlanContingencyChangeInput = {
  expectedEffect?: InputMaybe<Scalars['String']>;
  startsOn: Scalars['String'];
  subject?: InputMaybe<Scalars['ID']>;
  targetId: Scalars['ID'];
  whatChanges: Scalars['String'];
};

export type PlanDay = {
  __typename?: 'PlanDay';
  day: Scalars['String'];
  items: Array<PlanItem>;
};

export type PlanExperimentInput = {
  experimentId: Scalars['ID'];
  helpfulCopingStrategies?: InputMaybe<Scalars['String']>;
  safetyBehaviors?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<BehaviorExperimentSettingsInput>;
  subject?: InputMaybe<Scalars['ID']>;
};

export type PlanItem = {
  __typename?: 'PlanItem';
  assignmentId: Scalars['ID'];
  barrier?: Maybe<Scalars['String']>;
  certainty?: Maybe<Scalars['Int']>;
  durationMinutes?: Maybe<Scalars['Int']>;
  enjoyment?: Maybe<Scalars['Int']>;
  importance?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  plannedActivityId: Scalars['ID'];
  plannedBy?: Maybe<Scalars['ID']>;
  plannedFor: Scalars['DateTime'];
  predictedEnjoyment: Scalars['Int'];
  predictedImportance: Scalars['Int'];
  replanOf?: Maybe<Scalars['ID']>;
  status: Scalars['String'];
  title: Scalars['String'];
  valueActivityId?: Maybe<Scalars['ID']>;
};

export type PortalCardCreateInput = {
  automaticThought: Scalars['String'];
  clientId: Scalars['ID'];
  dayReminders: DayRemindersCreateInputNoThught;
  realisticThoughts: Array<BasicThoughtInput>;
  thoughtTestId?: InputMaybe<Scalars['ID']>;
};

export type PortalClients = {
  __typename?: 'PortalClients';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<Client>>>;
};

/**
 * E21 · PortalExpositionHeartRate — the client's heart rate during one exposition, only while the client shares heart
 * rate with the caller (`sharedTypes`); "not shared" otherwise.
 */
export type PortalExpositionHeartRate = {
  __typename?: 'PortalExpositionHeartRate';
  expositionId: Scalars['ID'];
  sharedTypes: Array<Scalars['String']>;
  window?: Maybe<ExpositionHeartRateWindow>;
};

export type PortalInvites = {
  __typename?: 'PortalInvites';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<Invite>>>;
};

export type PortalSubscriptionInput = {
  price: Scalars['String'];
  quantity: Scalars['Int'];
};

export type PortalTests = {
  __typename?: 'PortalTests';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<Test>>>;
};

export type PortalThoughtCreateInput = {
  automaticThought: Scalars['String'];
  behaviors?: InputMaybe<Scalars['String']>;
  bodyPartsFeelings: Scalars['Int'];
  cardName?: InputMaybe<Scalars['String']>;
  categoriesIds?: InputMaybe<Array<Scalars['Int']>>;
  clientId: Scalars['ID'];
  cognitiveDistortions?: InputMaybe<Array<Scalars['String']>>;
  dayReminders: DayRemindersCreateInputNoThught;
  description: Scalars['String'];
  emotions: Array<EmotionInput>;
  feelings: Array<Scalars['Int']>;
  imageUrl?: InputMaybe<Array<Scalars['URL']>>;
  interval?: InputMaybe<IntervalInput>;
  participantIds?: InputMaybe<Array<Scalars['String']>>;
  realisticThoughts: Array<BasicThoughtInput>;
  result: ThoughtTestResultInput;
  thoughtBelief: Scalars['Int'];
  thoughtsAgainst: Array<Scalars['String']>;
  thoughtsFor: Array<Scalars['String']>;
  thoughtsForAlternativeThoughts?: InputMaybe<
    Array<InputMaybe<Scalars['String']>>
  >;
};

export type PortalThoughts = {
  __typename?: 'PortalThoughts';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<Thought>>>;
};

export type Practice = {
  __typename?: 'Practice';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  acceptedInsurances?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['DateTime'];
  extension?: Maybe<Scalars['String']>;
  isSaasAgreementAccepted: Scalars['Boolean'];
  npi?: Maybe<Scalars['String']>;
  practiceDescription: Scalars['String'];
  practiceEmail: Scalars['String'];
  practiceLocations?: Maybe<PracticeLocations>;
  practiceName: Scalars['String'];
  practicePhone: Scalars['String'];
  practiceSize: Scalars['String'];
  practiceUrl?: Maybe<Scalars['String']>;
  saasSignedUser: Scalars['String'];
  subscription?: Maybe<SubscriptionInfo>;
  subscriptionWarnings?: Maybe<SubscriptionWarnings>;
  trialDays?: Maybe<Scalars['Int']>;
  trialEndDate?: Maybe<Scalars['DateTime']>;
  trialStartedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type PracticeAddUser = {
  token: Scalars['String'];
};

export type PracticeAddUserInput = {
  data: PracticeAddUser;
};

export type PracticeAndLocationCreate = {
  acceptedInsurances?: InputMaybe<Array<Scalars['String']>>;
  extension?: InputMaybe<Scalars['String']>;
  isSaasAgreementAccepted: Scalars['Boolean'];
  npi?: InputMaybe<Scalars['String']>;
  practiceAddress1: Scalars['String'];
  practiceAddress2?: InputMaybe<Scalars['String']>;
  practiceCity: Scalars['String'];
  practiceCountry: Scalars['String'];
  practiceDescription: Scalars['String'];
  practiceEmail: Scalars['String'];
  practiceName: Scalars['String'];
  practicePhone: Scalars['String'];
  practiceSize: Scalars['String'];
  practiceState: Scalars['String'];
  practiceUrl?: InputMaybe<Scalars['String']>;
  practiceZip: Scalars['String'];
};

export type PracticeAndLocationCreateInput = {
  data?: InputMaybe<PracticeAndLocationCreate>;
};

export type PracticeCapabilities = {
  __typename?: 'PracticeCapabilities';
  capabilities: Array<PracticeCapabilityRow>;
  practiceId: Scalars['ID'];
  practiceName?: Maybe<Scalars['String']>;
  switches: Array<PracticeCapabilitySwitch>;
};

export type PracticeCapabilityPayload = {
  __typename?: 'PracticeCapabilityPayload';
  practiceId: Scalars['ID'];
  recorded: Scalars['Boolean'];
};

export type PracticeCapabilityRow = {
  __typename?: 'PracticeCapabilityRow';
  capability: Scalars['String'];
  practiceId: Scalars['ID'];
  source: Scalars['String'];
};

export type PracticeCapabilitySwitch = {
  __typename?: 'PracticeCapabilitySwitch';
  backoffice: Scalars['Boolean'];
  capability: Scalars['String'];
  fromPlan: Scalars['Boolean'];
  held: Scalars['Boolean'];
};

export type PracticeCreate = {
  acceptedInsurances?: InputMaybe<Array<Scalars['String']>>;
  extension?: InputMaybe<Scalars['String']>;
  isSaasAgreementAccepted: Scalars['Boolean'];
  npi?: InputMaybe<Scalars['String']>;
  practiceDescription: Scalars['String'];
  practiceEmail: Scalars['String'];
  practiceName: Scalars['String'];
  practicePhone: Scalars['String'];
  practiceSize: Scalars['String'];
  practiceUrl?: InputMaybe<Scalars['String']>;
};

export type PracticeCreateInput = {
  data?: InputMaybe<PracticeCreate>;
};

/**
 * E34 · PracticeHomeworkBoard — who is behind: one row per client of the caller's roster (the Clients
 * list's scope), counted over the assignments the PRACTICE gave them, at read time. `pathwayName` /
 * `pathwayPercentDone` stay null and `pendingDocuments` 0 until pathways (block 3) and worksheets
 * (block 2) exist — no enrolment or document can exist before them.
 */
export type PracticeHomeworkBoard = {
  __typename?: 'PracticeHomeworkBoard';
  assignmentIds: Array<Scalars['ID']>;
  awaitingReply: Scalars['Int'];
  clientEmail?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  doneThisWeek: Scalars['Int'];
  enrollmentId?: Maybe<Scalars['ID']>;
  homeworkAppReady: Scalars['Boolean'];
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  lng?: Maybe<Scalars['String']>;
  openCount: Scalars['Int'];
  overdueCount: Scalars['Int'];
  pathwayId?: Maybe<Scalars['ID']>;
  pathwayName?: Maybe<Scalars['String']>;
  pathwayPercentDone?: Maybe<Scalars['Int']>;
  pendingDocuments: Scalars['Int'];
  practiceId: Scalars['ID'];
  subject: Scalars['ID'];
  therapistName?: Maybe<Scalars['String']>;
};

export type PracticeLocation = {
  __typename?: 'PracticeLocation';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  createdAt: Scalars['DateTime'];
  practiceAddress1: Scalars['String'];
  practiceAddress2?: Maybe<Scalars['String']>;
  practiceCity: Scalars['String'];
  practiceCountry: Scalars['String'];
  practiceId: Scalars['ID'];
  practiceState: Scalars['String'];
  practiceZip: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PracticeLocationCreate = {
  practiceAddress1: Scalars['String'];
  practiceAddress2?: InputMaybe<Scalars['String']>;
  practiceCity: Scalars['String'];
  practiceCountry: Scalars['String'];
  practiceId: Scalars['ID'];
  practiceState: Scalars['String'];
  practiceZip: Scalars['String'];
};

export type PracticeLocationCreateInput = {
  data?: InputMaybe<PracticeLocationCreate>;
};

export type PracticeLocationUpdate = {
  _id: Scalars['ID'];
  practiceAddress1?: InputMaybe<Scalars['String']>;
  practiceAddress2?: InputMaybe<Scalars['String']>;
  practiceCity?: InputMaybe<Scalars['String']>;
  practiceCountry?: InputMaybe<Scalars['String']>;
  practiceState?: InputMaybe<Scalars['String']>;
  practiceZip?: InputMaybe<Scalars['String']>;
};

export type PracticeLocationUpdateInput = {
  data?: InputMaybe<PracticeLocationUpdate>;
};

export type PracticeLocations = {
  __typename?: 'PracticeLocations';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<PracticeLocation>>>;
};

export type PracticeRemoveUser = {
  _id: Scalars['ID'];
};

export type PracticeRemoveUserInput = {
  data: PracticeRemoveUser;
};

export type PracticeResetUserPassword = {
  email: Scalars['String'];
};

export type PracticeResetUserPasswordInput = {
  data: Scalars['String'];
};

export type PracticeResetUserPasswordResponse = {
  __typename?: 'PracticeResetUserPasswordResponse';
  success: Scalars['Boolean'];
};

export type PracticeUpdate = {
  acceptedInsurances?: InputMaybe<Array<Scalars['String']>>;
  extension?: InputMaybe<Scalars['String']>;
  isSaasAgreementAccepted?: InputMaybe<Scalars['Boolean']>;
  npi?: InputMaybe<Scalars['String']>;
  practiceDescription?: InputMaybe<Scalars['String']>;
  practiceEmail?: InputMaybe<Scalars['String']>;
  practiceName?: InputMaybe<Scalars['String']>;
  practicePhone?: InputMaybe<Scalars['String']>;
  practiceSize?: InputMaybe<Scalars['String']>;
  practiceUrl?: InputMaybe<Scalars['String']>;
};

export type PracticeUsageEvent = {
  __typename?: 'PracticeUsageEvent';
  _from: Scalars['ID'];
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  _to: Scalars['ID'];
  activity: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  resource: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PracticeUsageEventInput = {
  _key?: InputMaybe<Scalars['ID']>;
  _to: Scalars['ID'];
  activity: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  finishedAt: Scalars['DateTime'];
  resource: Scalars['String'];
};

export type PracticeUsageEventsResponse = {
  __typename?: 'PracticeUsageEventsResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type PracticeUserInfoUpdateInput = {
  clientInviteToken?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  extension?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type PracticeUserInfoUpdateResponse = {
  __typename?: 'PracticeUserInfoUpdateResponse';
  new?: Maybe<User>;
  tokenError?: Maybe<Scalars['String']>;
};

export type PracticeUsers = {
  __typename?: 'PracticeUsers';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<User>>>;
};

export type Practices = {
  __typename?: 'Practices';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<Practice>>>;
};

export type PredictOutcomeInput = {
  experimentId: Scalars['ID'];
  prediction?: InputMaybe<BehaviorExperimentPredictionPatchInput>;
  subject?: InputMaybe<Scalars['ID']>;
};

export type PredictedActual = {
  __typename?: 'PredictedActual';
  actual?: Maybe<Scalars['Float']>;
  predicted?: Maybe<Scalars['Float']>;
};

export type PredictedVsActual = {
  __typename?: 'PredictedVsActual';
  enjoyment: PredictedActual;
  importance: PredictedActual;
};

/** The grant to celebrate, or nothing at all. Both eras answer in this one shape. */
export type PremiumUpgradeToShow = {
  __typename?: 'PremiumUpgradeToShow';
  /** The level the grant confers (`premium`, `premium_practice`); null when the source names none. */
  accessLevel?: Maybe<Scalars['String']>;
  /** Echoed back: the acknowledgement it was judged against, or null when there was none. */
  acknowledgedGrantAt?: Maybe<Scalars['DateTime']>;
  /** `practice` or `personal` — which kind of grant conferred it. */
  grantedVia: Scalars['String'];
  /** The conferral moment the gate orders acknowledgements against. */
  occurredAt: Scalars['DateTime'];
  /** practices/<key> for a practice seat; empty string for a personal subscription. */
  practiceId: Scalars['String'];
  /** users/<key> — whose premium this is. */
  subject: Scalars['ID'];
};

export type PrivacySettings = {
  __typename?: 'PrivacySettings';
  isErrorInfoCollectionOn?: Maybe<Scalars['Boolean']>;
  isGAUsageCollectionOn?: Maybe<Scalars['Boolean']>;
  isKeepLoggedInOn?: Maybe<Scalars['Boolean']>;
  isPrivacyAccepted?: Maybe<Scalars['Boolean']>;
  isProductEmailNotifyOn?: Maybe<Scalars['Boolean']>;
  isProductPushNotifyOn?: Maybe<Scalars['Boolean']>;
  isTermsAccepted?: Maybe<Scalars['Boolean']>;
};

export type Profile = {
  __typename?: 'Profile';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  about: Scalars['String'];
  acceptingClients: Scalars['String'];
  approaches: Array<Scalars['String']>;
  approvedForReferrals: Scalars['Boolean'];
  clientAges: Array<Scalars['String']>;
  clientIssues: Array<Scalars['String']>;
  costPerSessionFrom: Scalars['Int'];
  costPerSessionTo: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  education: Array<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  formats: Array<Scalars['String']>;
  freeInitialConsulation: Scalars['Boolean'];
  imageUrl?: Maybe<Scalars['String']>;
  languages: Array<Scalars['String']>;
  lastLoadedAt?: Maybe<Scalars['DateTime']>;
  licenses?: Maybe<Array<Maybe<License>>>;
  linkToOtherProfile?: Maybe<Scalars['String']>;
  mentalHealthRole: Scalars['String'];
  modalities: Array<Scalars['String']>;
  phone: Scalars['String'];
  practiceCity: Scalars['String'];
  practiceCountry: Scalars['String'];
  practiceState: Scalars['String'];
  practiceZip: Scalars['String'];
  slidingScale: Scalars['Boolean'];
  therapist?: Maybe<User>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
  wantsReferrals: Scalars['Boolean'];
  yearsInPractice: Scalars['Int'];
};

export type ProfilesSearch = {
  __typename?: 'ProfilesSearch';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<Profile>>>;
};

export type ProgressNote = {
  __typename?: 'ProgressNote';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  affect?: Maybe<Scalars['Int']>;
  appearance?: Maybe<Scalars['Int']>;
  attitude?: Maybe<Scalars['Int']>;
  clientProgress?: Maybe<Scalars['Int']>;
  concentration?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  diagnoses?: Maybe<Array<Maybe<Scalars['String']>>>;
  editorState?: Maybe<Scalars['JSON']>;
  insight?: Maybe<Scalars['Int']>;
  interventionsBehavioralActivation?: Maybe<Array<Maybe<Scalars['Int']>>>;
  interventionsCognitive?: Maybe<Array<Maybe<Scalars['Int']>>>;
  interventionsEducation?: Maybe<Array<Maybe<Scalars['Int']>>>;
  interventionsExposures?: Maybe<Array<Maybe<Scalars['Int']>>>;
  interventionsOther?: Maybe<Array<Maybe<Scalars['String']>>>;
  interventionsRelaxation?: Maybe<Array<Maybe<Scalars['Int']>>>;
  interventionsSkillsTraining?: Maybe<Array<Maybe<Scalars['Int']>>>;
  memory?: Maybe<Array<Maybe<Scalars['Int']>>>;
  mood?: Maybe<Scalars['Int']>;
  orientation?: Maybe<Array<Maybe<Scalars['Int']>>>;
  perception?: Maybe<Array<Maybe<Scalars['Int']>>>;
  progressNoteType?: Maybe<Scalars['Int']>;
  sessionId: Scalars['ID'];
  shortSummary?: Maybe<Scalars['String']>;
  speech?: Maybe<Array<Maybe<Scalars['Int']>>>;
  thoughtProcess?: Maybe<Array<Maybe<Scalars['Int']>>>;
  updatedAt: Scalars['DateTime'];
};

export type ProgressNoteInput = {
  data: ProgressNoteInputData;
  where: ProgressNoteInputWhere;
};

export type ProgressNoteInputData = {
  affect?: InputMaybe<Scalars['Int']>;
  appearance?: InputMaybe<Scalars['Int']>;
  attitude?: InputMaybe<Scalars['Int']>;
  clientProgress?: InputMaybe<Scalars['Int']>;
  concentration?: InputMaybe<Scalars['Int']>;
  diagnoses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  editorState?: InputMaybe<Scalars['JSON']>;
  insight?: InputMaybe<Scalars['Int']>;
  interventionsBehavioralActivation?: InputMaybe<
    Array<InputMaybe<Scalars['Int']>>
  >;
  interventionsCognitive?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  interventionsEducation?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  interventionsExposures?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  interventionsOther?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  interventionsRelaxation?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  interventionsSkillsTraining?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  memory?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  mood?: InputMaybe<Scalars['Int']>;
  orientation?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  perception?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  progressNoteType?: InputMaybe<Scalars['Int']>;
  shortSummary?: InputMaybe<Scalars['String']>;
  speech?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  thoughtProcess?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ProgressNoteInputWhere = {
  _id?: InputMaybe<Scalars['ID']>;
  sessionId: Scalars['ID'];
};

export type PublicCourse = {
  __typename?: 'PublicCourse';
  accessRule?: Maybe<Scalars['String']>;
  adaptyPlacementId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  owned: Scalars['Boolean'];
  pathwayId: Scalars['ID'];
  practiceId: Scalars['ID'];
  practiceName?: Maybe<Scalars['String']>;
  sections: Array<PathwaySection>;
  stepsCount: Scalars['Int'];
  storeProductId?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};

export type PublishActivityLibraryInput = {
  citation: Scalars['String'];
  ideas: Array<LibraryIdeaInput>;
  label: Scalars['String'];
  libraryId: Scalars['String'];
  locales: Array<Scalars['String']>;
};

export type PublishDiaryCardTemplateInput = {
  emotions?: InputMaybe<Array<DiaryCardEmotionRowInput>>;
  name: Scalars['String'];
  skills?: InputMaybe<Array<DiaryCardSkillRowInput>>;
  summary: Scalars['String'];
  targets: Array<DiaryCardTargetInput>;
  templateId: Scalars['String'];
};

export type PublishInstrumentInput = {
  availableFor: Scalars['String'];
  bands: Array<InstrumentBandSetInput>;
  citation: Scalars['String'];
  instrumentId: Scalars['String'];
  itemsCount: Scalars['Int'];
  itemsKey: Scalars['String'];
  languages: Array<Scalars['String']>;
  licenceClass: Scalars['String'];
  name: Scalars['String'];
  nameRu?: InputMaybe<Scalars['String']>;
  responseScale: InstrumentScaleInput;
  scoringRule: Scalars['String'];
  subscales: Array<InstrumentSubscaleInput>;
};

export type PublishValuesDeckInput = {
  cards: Array<DeckCardInput>;
  citation: Scalars['String'];
  deckId: Scalars['String'];
  languages: Array<Scalars['String']>;
  licence: Scalars['String'];
  name: Scalars['String'];
  presets: Array<DeckPresetInput>;
};

export type PublishWorksheetTemplateInput = {
  category: Scalars['String'];
  language: Scalars['String'];
  name: Scalars['String'];
  repeatable: Scalars['Boolean'];
  scoring?: InputMaybe<WorksheetScoringInput>;
  sections: Array<WorksheetSectionInput>;
  signatureRequired: Scalars['Boolean'];
  templateId: Scalars['ID'];
};

export type Query = {
  __typename?: 'Query';
  abcModel?: Maybe<AbcModel>;
  abcModels?: Maybe<AbcModelSearch>;
  accountDeletionStatus: AccountDeletionStatus;
  activatingEvent?: Maybe<ActivatingEvent>;
  activityChoices: ActivityChoices;
  activityDay: ActivityDay;
  activityIdeas: ActivityIdeas;
  activityLadder: ActivityLadder;
  activityPlan: ActivityPlan;
  activityWeek: ActivityWeek;
  allRecords: AllRecordsPage;
  appLock: AppLock;
  appMinVersion?: Maybe<AppMinVersion>;
  assessmentInterpretation?: Maybe<AssessmentInterpretation>;
  backofficeMembers: Array<BackofficeMember>;
  backofficePracticesPage: BackofficePracticesPage;
  backofficeShell: BackofficeShell;
  behaviorExperiment?: Maybe<BehaviorExperiment>;
  behaviorExperiments?: Maybe<BehaviorExperimentSearch>;
  caseloadOverview: Array<CaseloadOverviewRow>;
  changeJourney: ChangeJourney;
  checkInsSinceLastSession: CheckInRecap;
  client?: Maybe<Client>;
  clientActivitySummary: ClientActivitySummary;
  clientAssessmentTrend: ClientAssessmentTrend;
  clientChangeGoals: ClientChangeGoals;
  clientCheckInTrend: ClientCheckInTrend;
  clientDigest: ClientDigest;
  clientHeader: ClientHeader;
  clientHealthTimeline: ClientHealthTimeline;
  clientHeartSummary: ClientHeartSummary;
  clientHomework: Array<ClientHomework>;
  clientHomeworkAccess: ClientHomeworkAccess;
  clientHomeworkPage: ClientHomeworkPage;
  clientModeSet: ModeSet;
  clientModeTimeline: ModeTimeline;
  clientPathways: Array<PathwayProgress>;
  clientSleepSummary: ClientSleepSummary;
  clientTargetBehaviors: Array<ClientTargetBehavior>;
  clientToolNavigation: ClientToolNavigation;
  clientWorksheets: Array<ClientWorksheet>;
  /**
   * `search` (the Clients list's one search box, #5 of the 2026-10-03 manual pass): a case-insensitive
   * SUBSTRING of firstName, lastName, "firstName lastName", e-mail or the id. It filters BEFORE
   * start/limit, so `count` counts the filtered rows; blank = no filter; it ANDs with `where`.
   */
  clients?: Maybe<PortalClients>;
  conceptualization?: Maybe<Conceptualization>;
  conceptualizations?: Maybe<ConceptualizationSearch>;
  courseLibrary: Array<LibraryCourse>;
  courseReviewQueue: Array<CourseReview>;
  cursor?: Maybe<Scalars['DateTime']>;
  dateTimeReminder?: Maybe<DateTimeReminder>;
  dateTimeReminders?: Maybe<Array<Maybe<DateTimeReminder>>>;
  dateTimeRemindersForUser?: Maybe<DateTimeReminderConnection>;
  dayReminders?: Maybe<DayReminders>;
  diagramImage: Scalars['String'];
  diaryCard: DiaryCard;
  diaryCardTemplates: Array<DiaryCardTemplate>;
  diaryCardWeek: DiaryCardWeek;
  downwardArrow?: Maybe<DownwardArrow>;
  downwardArrows?: Maybe<DownwardArrowSearch>;
  enabledDayReminders?: Maybe<EnabledDayRemindersCount>;
  enabledLocationRemindersCount?: Maybe<EnabledLocationRemindersCount>;
  erasureInventory: ErasureInventoryResult;
  erasureRequests: Array<ErasureRequestRow>;
  esCardReminders: EsCardReminders;
  esReadyDomains: Array<EsDomain>;
  esReminderSchedules: Array<EsReminderSchedule>;
  expositionHeartRate: ExpositionHeartRate;
  exposure?: Maybe<Exposure>;
  exposureStimuli?: Maybe<ExposureStimulusSearch>;
  exposureStimuliHierarchy?: Maybe<Array<Maybe<ExposureStimulus>>>;
  exposureStimulus?: Maybe<ExposureStimulus>;
  exposures?: Maybe<ExposureSearch>;
  /**
   * E32 · FeatureAnnouncementHistory / PortalFeatureAnnouncementHistory — every announcement that
   * was ever the caller's, one row each (dismissed or not), newest first.
   */
  featureAnnouncementHistory: Array<FeatureAnnouncement>;
  functionalAnalysisSummary: FunctionalAnalysisSummary;
  generateGptBehaviorExperiment?: Maybe<GptBehaviorExperiment>;
  generateGptExposuresGeneratedImage?: Maybe<GptExposuresGeneratedImage>;
  generateProgressNote?: Maybe<GeneratedProgressNote>;
  healthActivitySuggestions: HealthActivitySuggestions;
  healthDataAccess: HealthDataAccess;
  healthDataSharing: HealthDataSharing;
  healthReadWindows: Array<HealthReadWindow>;
  homeworkComments: Array<HomeworkComment>;
  homeworkPaperPhotoUrl: HomeworkPaperPhotoUrl;
  homeworkSinceLastSession: Array<HomeworkSinceLastSession>;
  instrumentCatalog: Array<InstrumentCatalogItem>;
  instrumentDefinitions: Array<InstrumentDefinition>;
  invite?: Maybe<Invite>;
  inviteByToken?: Maybe<Invite>;
  invites?: Maybe<PortalInvites>;
  invitesForYou?: Maybe<PortalInvites>;
  location?: Maybe<Location>;
  locationReminder?: Maybe<LocationReminder>;
  locationReminders?: Maybe<Array<Maybe<LocationReminder>>>;
  locationRemindersForUser?: Maybe<Array<Maybe<LocationReminder>>>;
  locations?: Maybe<Array<Maybe<Location>>>;
  locationsForUser?: Maybe<LocationConnection>;
  mostUsedStats?: Maybe<Array<Maybe<MostUsedStats>>>;
  myChanges: MyChanges;
  myCheckIns: MyCheckIns;
  myFinishedHomework: MyFinishedHomeworkPage;
  myHiddenTools: MyHiddenTools;
  myHomework: Array<MyHomework>;
  myHomeworkItem?: Maybe<MyHomework>;
  myModeSet: ModeSet;
  myModeTimeline: ModeTimeline;
  myPathways: Array<MyPathway>;
  myTargetBehaviors: MyTargetBehaviors;
  myTherapists: Array<MyTherapist>;
  pathway?: Maybe<PathwayDetail>;
  pathwayOutcomes: Array<PathwayOutcome>;
  pathwayProgress?: Maybe<PathwayProgress>;
  pathways: PathwayLibrary;
  /** The transfer request awaiting the CALLER's answer, if any. Mobile. */
  pendingClientTransfer?: Maybe<PendingClientTransfer>;
  /**
   * E32 · PendingFeatureAnnouncements / PortalFeatureAnnouncements — the caller's unacknowledged
   * What's New cards for `surface` (mobile | portal), newest first: live (`publishAt <= now`),
   * released after they registered, aimed at them by the rules each variant carries, in their
   * language (`language` defaults to the row's `lng`). The app version comes from `x-cc-client`.
   */
  pendingFeatureAnnouncements: Array<FeatureAnnouncement>;
  /** The practice's CURRENT client-invite link. Portal; THERAPIST_ADMIN. */
  permanentInviteLink?: Maybe<PermanentInviteLink>;
  portalCard?: Maybe<Thought>;
  portalCards?: Maybe<PortalThoughts>;
  portalExpositionHeartRate: PortalExpositionHeartRate;
  portalTests?: Maybe<PortalTests>;
  portalThought?: Maybe<Thought>;
  portalThoughts?: Maybe<PortalThoughts>;
  practice?: Maybe<Practice>;
  practiceCapabilities: PracticeCapabilities;
  practiceHomeworkBoard: Array<PracticeHomeworkBoard>;
  practiceLocation?: Maybe<PracticeLocation>;
  practiceLocations?: Maybe<PracticeLocations>;
  practiceUsageEvents?: Maybe<Array<Maybe<PracticeUsageEvent>>>;
  practiceUsageEventsForNote?: Maybe<Array<Maybe<Scalars['String']>>>;
  practiceUser?: Maybe<User>;
  practiceUsers?: Maybe<PracticeUsers>;
  practices?: Maybe<Practices>;
  /**
   * The premium grant this person should be congratulated on, or null. ERA-ROUTED: the entitlement
   * fold for a subject across for `identity`, the legacy `subscriptions` rows for everybody else.
   * `acknowledgedGrantAt` is the device's OWN newest acknowledgement (client-only, never stored here)
   * — pass it and a grant at or before it answers null. Mobile.
   */
  premiumUpgradeToShow?: Maybe<PremiumUpgradeToShow>;
  profile?: Maybe<Profile>;
  profiles?: Maybe<ProfilesSearch>;
  progressNote?: Maybe<ProgressNote>;
  publicCourses: Array<PublicCourse>;
  /**
   * E04 · ReviewSessions — a client's review sessions (active + past) within the caller's practice,
   * newest first; `activeOnly` narrows to the open brackets. Guarded like every client read (the
   * practice's own client).
   */
  reviewSessions: Array<ReviewSession>;
  safetyPlan: SafetyPlan;
  safetyPlanHistory: Array<SafetyPlanHistoryRow>;
  safetyPlanOpensByWeek: SafetyPlanOpensByWeek;
  safetyPlanStatus: SafetyPlanStatus;
  session?: Maybe<Session>;
  sessions?: Maybe<Sessions>;
  sleepDiaryWeek: SleepDiaryWeek;
  sleepNightsToConfirm: SleepNightsToConfirm;
  sleepWindow: SleepWindow;
  stripePortalConfigurationProductsAndPrices?: Maybe<StripePortalConfigurationData>;
  supportingCycle?: Maybe<SupportingCycle>;
  supportingCycles?: Maybe<SupportingCycleSearch>;
  test?: Maybe<Test>;
  tests?: Maybe<Array<Maybe<Test>>>;
  testsForUser?: Maybe<TestConnection>;
  therapistClientEdge?: Maybe<TherapistClientEdge>;
  therapistClientEdges?: Maybe<TherapistClientEdges>;
  therapistMessages?: Maybe<TherapistMessages>;
  thought?: Maybe<Thought>;
  thoughtTestDraft?: Maybe<ThoughtTestDraft>;
  thoughts?: Maybe<Array<Maybe<Thought>>>;
  thoughtsForUser?: Maybe<ThoughtConnection>;
  thoughtsSearch?: Maybe<ThoughtSearch>;
  /** The practice pool — clients released by a departing member. Portal; THERAPIST_ADMIN. */
  unassignedClients?: Maybe<UnassignedClients>;
  unfinishedThoughtTests: Array<UnfinishedThoughtTest>;
  usageEvents?: Maybe<Array<Maybe<UsageEvent>>>;
  usageEventsStats?: Maybe<UsageEventStatsResponse>;
  user?: Maybe<User>;
  userSubscriptions?: Maybe<UserSubscriptions>;
  valueActivities: ValueActivities;
  valuedLivingResult?: Maybe<ValuedLivingResult>;
  valuesDeck?: Maybe<ValuesDeck>;
  valuesProfile: ValuesProfile;
  valuesSortProgress: Array<ValuesSortProgressRow>;
  valuesSortResult?: Maybe<ValuesSortResult>;
  valuesWheel?: Maybe<ValuesWheel>;
  weekActivities: WeekActivities;
  whatINoticed: WhatINoticed;
  windRose: WindRose;
  worksheetEntriesOverTime?: Maybe<WorksheetEntriesOverTime>;
  worksheetForm?: Maybe<WorksheetForm>;
  worksheetResponse?: Maybe<WorksheetResponse>;
  worksheetTemplate?: Maybe<WorksheetTemplateDetail>;
  worksheetTemplates: Array<WorksheetTemplate>;
  worryTree?: Maybe<WorryTree>;
  worryTrees?: Maybe<WorryTreeSearch>;
};

export type QueryAbcModelArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};

export type QueryAbcModelsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryActivatingEventArgs = {
  _id: Scalars['String'];
};

export type QueryActivityDayArgs = {
  day?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryActivityIdeasArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export type QueryActivityLadderArgs = {
  subject?: InputMaybe<Scalars['ID']>;
};

export type QueryActivityPlanArgs = {
  subject?: InputMaybe<Scalars['ID']>;
  timeZone?: InputMaybe<Scalars['String']>;
  week?: InputMaybe<Scalars['String']>;
};

export type QueryActivityWeekArgs = {
  subject?: InputMaybe<Scalars['ID']>;
  timeZone?: InputMaybe<Scalars['String']>;
  week?: InputMaybe<Scalars['String']>;
};

export type QueryAllRecordsArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['ID']>;
  therapist?: InputMaybe<Scalars['ID']>;
  to?: InputMaybe<Scalars['DateTime']>;
  tools?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryAppLockArgs = {
  deviceId: Scalars['ID'];
};

export type QueryAssessmentInterpretationArgs = {
  assessmentId: Scalars['ID'];
};

export type QueryBackofficePracticesPageArgs = {
  holdsCapability?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<BackofficePracticesOrder>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<BackofficePracticesSort>;
};

export type QueryBehaviorExperimentArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};

export type QueryBehaviorExperimentsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryCaseloadOverviewArgs = {
  question?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryChangeJourneyArgs = {
  goalId: Scalars['ID'];
};

export type QueryCheckInsSinceLastSessionArgs = {
  sessionId?: InputMaybe<Scalars['ID']>;
  subject: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryClientArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type QueryClientActivitySummaryArgs = {
  days?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryClientAssessmentTrendArgs = {
  instrumentId?: InputMaybe<Scalars['String']>;
  subject: Scalars['ID'];
};

export type QueryClientChangeGoalsArgs = {
  subject: Scalars['ID'];
};

export type QueryClientCheckInTrendArgs = {
  days?: InputMaybe<Scalars['Int']>;
  subject: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryClientDigestArgs = {
  subject: Scalars['ID'];
};

export type QueryClientHeaderArgs = {
  subject: Scalars['ID'];
};

export type QueryClientHealthTimelineArgs = {
  days?: InputMaybe<Scalars['Int']>;
  subject: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryClientHeartSummaryArgs = {
  days?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryClientHomeworkArgs = {
  subject: Scalars['ID'];
};

export type QueryClientHomeworkAccessArgs = {
  subject: Scalars['ID'];
};

export type QueryClientHomeworkPageArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ClientHomeworkChip>;
  subject: Scalars['ID'];
};

export type QueryClientModeSetArgs = {
  subject: Scalars['ID'];
};

export type QueryClientModeTimelineArgs = {
  days?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  subject: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type QueryClientPathwaysArgs = {
  subject: Scalars['ID'];
};

export type QueryClientSleepSummaryArgs = {
  days?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryClientTargetBehaviorsArgs = {
  subject: Scalars['ID'];
};

export type QueryClientToolNavigationArgs = {
  subject: Scalars['ID'];
};

export type QueryClientWorksheetsArgs = {
  filter?: InputMaybe<Scalars['String']>;
  subject: Scalars['ID'];
};

export type QueryClientsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryConceptualizationArgs = {
  clientId?: InputMaybe<Scalars['ID']>;
};

export type QueryConceptualizationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryDateTimeReminderArgs = {
  _id: Scalars['String'];
};

export type QueryDateTimeRemindersArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryDateTimeRemindersForUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type QueryDayRemindersArgs = {
  _id: Scalars['String'];
};

export type QueryDiagramImageArgs = {
  source: Scalars['String'];
};

export type QueryDiaryCardArgs = {
  day?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryDiaryCardTemplatesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type QueryDiaryCardWeekArgs = {
  subject?: InputMaybe<Scalars['ID']>;
  timeZone?: InputMaybe<Scalars['String']>;
  weekOf?: InputMaybe<Scalars['String']>;
};

export type QueryDownwardArrowArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};

export type QueryDownwardArrowsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryErasureInventoryArgs = {
  email?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  uid?: InputMaybe<Scalars['String']>;
};

export type QueryErasureRequestsArgs = {
  status?: InputMaybe<Scalars['String']>;
};

export type QueryEsCardRemindersArgs = {
  subject?: InputMaybe<Scalars['ID']>;
  target: EsReminderTargetInput;
};

export type QueryEsReadyDomainsArgs = {
  subject?: InputMaybe<Scalars['ID']>;
};

export type QueryExpositionHeartRateArgs = {
  expositionId: Scalars['ID'];
};

export type QueryExposureArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};

export type QueryExposureStimuliArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryExposureStimulusArgs = {
  _id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type QueryExposuresArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryFeatureAnnouncementHistoryArgs = {
  language?: InputMaybe<Scalars['String']>;
  surface: Scalars['String'];
};

export type QueryFunctionalAnalysisSummaryArgs = {
  subject: Scalars['ID'];
  targetId: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryGenerateGptBehaviorExperimentArgs = {
  content: Scalars['String'];
  language: Scalars['String'];
};

export type QueryGenerateGptExposuresGeneratedImageArgs = {
  content: Scalars['String'];
  lng: Scalars['String'];
};

export type QueryGenerateProgressNoteArgs = {
  content: Scalars['String'];
  language: Scalars['String'];
  sessionId?: InputMaybe<Scalars['ID']>;
  type: Scalars['Int'];
};

export type QueryHealthActivitySuggestionsArgs = {
  day?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryHomeworkCommentsArgs = {
  assignmentId: Scalars['ID'];
};

export type QueryHomeworkPaperPhotoUrlArgs = {
  assignmentId: Scalars['ID'];
  fileRef: Scalars['String'];
};

export type QueryHomeworkSinceLastSessionArgs = {
  sessionId?: InputMaybe<Scalars['ID']>;
  subject: Scalars['ID'];
};

export type QueryInviteArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type QueryInviteByTokenArgs = {
  token?: InputMaybe<Scalars['String']>;
};

export type QueryInvitesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryInvitesForYouArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryLocationArgs = {
  _id: Scalars['String'];
};

export type QueryLocationReminderArgs = {
  _id: Scalars['String'];
};

export type QueryLocationRemindersArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryLocationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryLocationsForUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type QueryMostUsedStatsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  entityPrefix?: InputMaybe<Scalars['String']>;
  interval: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type QueryMyCheckInsArgs = {
  days?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryMyFinishedHomeworkArgs = {
  after?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export type QueryMyHomeworkItemArgs = {
  assignmentId: Scalars['ID'];
};

export type QueryMyModeTimelineArgs = {
  days?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type QueryMyTargetBehaviorsArgs = {
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryPathwayArgs = {
  pathwayId: Scalars['ID'];
};

export type QueryPathwayProgressArgs = {
  enrollmentId: Scalars['ID'];
};

export type QueryPathwaysArgs = {
  includeRetired?: InputMaybe<Scalars['Boolean']>;
};

export type QueryPendingFeatureAnnouncementsArgs = {
  language?: InputMaybe<Scalars['String']>;
  surface: Scalars['String'];
};

export type QueryPortalCardArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type QueryPortalCardsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryPortalExpositionHeartRateArgs = {
  expositionId: Scalars['ID'];
  subject: Scalars['ID'];
};

export type QueryPortalTestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryPortalThoughtArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type QueryPortalThoughtsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryPracticeArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type QueryPracticeCapabilitiesArgs = {
  practiceId: Scalars['ID'];
};

export type QueryPracticeHomeworkBoardArgs = {
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryPracticeLocationArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type QueryPracticeLocationsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryPracticeUsageEventsArgs = {
  clientId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  entityPrefix?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  showInSessionData?: InputMaybe<Scalars['Boolean']>;
  showOffsessionData?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type QueryPracticeUsageEventsForNoteArgs = {
  clientId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  entityPrefix?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  lng: Scalars['String'];
  showInSessionData?: InputMaybe<Scalars['Boolean']>;
  showOffsessionData?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type QueryPracticeUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type QueryPracticeUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryPracticesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryPremiumUpgradeToShowArgs = {
  acknowledgedGrantAt?: InputMaybe<Scalars['DateTime']>;
};

export type QueryProfileArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type QueryProfilesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryProgressNoteArgs = {
  sessionId?: InputMaybe<Scalars['ID']>;
};

export type QueryReviewSessionsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  subject: Scalars['ID'];
};

export type QuerySafetyPlanArgs = {
  subject?: InputMaybe<Scalars['ID']>;
};

export type QuerySafetyPlanHistoryArgs = {
  subject: Scalars['ID'];
};

export type QuerySafetyPlanOpensByWeekArgs = {
  subject: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QuerySafetyPlanStatusArgs = {
  subject?: InputMaybe<Scalars['ID']>;
};

export type QuerySessionArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type QuerySessionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QuerySleepDiaryWeekArgs = {
  subject?: InputMaybe<Scalars['ID']>;
  timeZone?: InputMaybe<Scalars['String']>;
  week?: InputMaybe<Scalars['String']>;
};

export type QuerySleepNightsToConfirmArgs = {
  timeZone?: InputMaybe<Scalars['String']>;
  today?: InputMaybe<Scalars['String']>;
};

export type QuerySleepWindowArgs = {
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryStripePortalConfigurationProductsAndPricesArgs = {
  locale?: InputMaybe<Scalars['String']>;
};

export type QuerySupportingCycleArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};

export type QuerySupportingCyclesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryTestArgs = {
  _id: Scalars['String'];
};

export type QueryTestsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryTestsForUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type QueryTherapistClientEdgeArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type QueryTherapistClientEdgesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryTherapistMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryThoughtArgs = {
  _id: Scalars['String'];
};

export type QueryThoughtTestDraftArgs = {
  subject?: InputMaybe<Scalars['ID']>;
  thoughtTestId: Scalars['ID'];
};

export type QueryThoughtsArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryThoughtsForUserArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type QueryThoughtsSearchArgs = {
  phrase: Scalars['String'];
};

export type QueryUnassignedClientsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};

export type QueryUnfinishedThoughtTestsArgs = {
  subject?: InputMaybe<Scalars['ID']>;
};

export type QueryUsageEventsArgs = {
  clientId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  entityPrefix?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type QueryUsageEventsStatsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  entityPrefix?: InputMaybe<Scalars['String']>;
  interval: Scalars['Int'];
  type?: InputMaybe<Scalars['Int']>;
};

export type QueryUserSubscriptionsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type QueryValueActivitiesArgs = {
  value: Scalars['String'];
};

export type QueryValuedLivingResultArgs = {
  vlqId?: InputMaybe<Scalars['ID']>;
};

export type QueryValuesDeckArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export type QueryValuesProfileArgs = {
  language?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['ID']>;
};

export type QueryValuesSortResultArgs = {
  language?: InputMaybe<Scalars['String']>;
  sortId: Scalars['ID'];
};

export type QueryValuesWheelArgs = {
  subject?: InputMaybe<Scalars['ID']>;
};

export type QueryWhatINoticedArgs = {
  targetId: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
};

export type QueryWindRoseArgs = {
  subject?: InputMaybe<Scalars['ID']>;
};

export type QueryWorksheetEntriesOverTimeArgs = {
  subject: Scalars['ID'];
  templateId: Scalars['ID'];
};

export type QueryWorksheetFormArgs = {
  assignmentId: Scalars['ID'];
};

export type QueryWorksheetResponseArgs = {
  submissionId: Scalars['ID'];
};

export type QueryWorksheetTemplateArgs = {
  templateId: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};

export type QueryWorksheetTemplatesArgs = {
  category?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
};

export type QueryWorryTreeArgs = {
  _id?: InputMaybe<Scalars['ID']>;
};

export type QueryWorryTreesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Scalars['JSON']>;
};

export type RankActivitiesInput = {
  ranking: Array<RankedRungInput>;
  rankingId: Scalars['ID'];
};

export type RankedRungInput = {
  rank: Scalars['Int'];
  valueActivityId: Scalars['ID'];
};

export type RateChangeInput = {
  confidence: Scalars['Int'];
  focusedRuler?: InputMaybe<Scalars['String']>;
  goalId: Scalars['ID'];
  importance: Scalars['Int'];
  ratingId: Scalars['ID'];
  readiness: Scalars['Int'];
  whatWouldRaise?: InputMaybe<Scalars['String']>;
  whyNotLower?: InputMaybe<Scalars['String']>;
};

export type RateStrategyOnNeedsInSessionInput = {
  basis: Scalars['String'];
  examples?: InputMaybe<RoseExamplesInput>;
  scores: RoseScoresInput;
  strategyId: Scalars['ID'];
  subject: Scalars['ID'];
};

export type RateStrategyOnNeedsInput = {
  basis: Scalars['String'];
  examples?: InputMaybe<RoseExamplesInput>;
  ratingId: Scalars['ID'];
  scores: RoseScoresInput;
  strategyId: Scalars['ID'];
};

export type RateValuesWheelInSessionInput = {
  sectors: Array<SectorRatingInput>;
  subject: Scalars['ID'];
  wheelId: Scalars['ID'];
};

export type RateValuesWheelInput = {
  ratingId: Scalars['ID'];
  sectors: Array<SectorRatingInput>;
  wheelId: Scalars['ID'];
};

export type ReassignClientInput = {
  /** users/<key> — the member the client now belongs to. Requires a recorded consent. */
  newAssignee: Scalars['ID'];
  subject: Scalars['ID'];
};

export type RecordBehaviorInstanceInput = {
  amount?: InputMaybe<Scalars['Float']>;
  consequencesLong?: InputMaybe<Scalars['String']>;
  consequencesShort?: InputMaybe<Scalars['String']>;
  didBehavior: Scalars['Boolean'];
  happenedAt: Scalars['DateTime'];
  instanceId: Scalars['ID'];
  links?: InputMaybe<Array<FaLinkInput>>;
  occurredAt?: InputMaybe<Scalars['DateTime']>;
  promptingEvent?: InputMaybe<Scalars['String']>;
  solution?: InputMaybe<FaSolutionInput>;
  targetId: Scalars['ID'];
  urge?: InputMaybe<Scalars['Int']>;
  vulnerabilities?: InputMaybe<Array<FaVulnerabilityInput>>;
};

export type RecordCheckInInSessionInput = {
  checkInId: Scalars['ID'];
  drivers?: InputMaybe<Array<Scalars['String']>>;
  emotions?: InputMaybe<Array<CheckInEmotionInput>>;
  energy?: InputMaybe<Scalars['Int']>;
  mood: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  recordedFor: Scalars['String'];
  sleepHours?: InputMaybe<Scalars['Float']>;
  sleepQuality?: InputMaybe<Scalars['Int']>;
  socialConnection?: InputMaybe<Scalars['Int']>;
  subject: Scalars['ID'];
};

export type RecordCheckInInput = {
  checkInId: Scalars['ID'];
  drivers?: InputMaybe<Array<Scalars['String']>>;
  emotions?: InputMaybe<Array<CheckInEmotionInput>>;
  energy?: InputMaybe<Scalars['Int']>;
  mood: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['DateTime']>;
  recordedFor: Scalars['String'];
  sleepHours?: InputMaybe<Scalars['Float']>;
  sleepQuality?: InputMaybe<Scalars['Int']>;
  socialConnection?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
};

export type RecordCoursePurchaseInput = {
  adaptyProfileId?: InputMaybe<Scalars['String']>;
  vendorProductId: Scalars['String'];
};

export type RecordExpositionReactionInput = {
  expositionId: Scalars['ID'];
  exposureStimulusId: Scalars['ID'];
  reactedAt?: InputMaybe<Scalars['DateTime']>;
  subject?: InputMaybe<Scalars['ID']>;
  sud: Scalars['Int'];
};

export type RecordExternalAssessmentInput = {
  administeredAt: Scalars['DateTime'];
  externalAssessmentId: Scalars['ID'];
  instrumentName: Scalars['String'];
  maxScore?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  score: Scalars['Int'];
  subject: Scalars['ID'];
};

export type RecordMetric = {
  __typename?: 'RecordMetric';
  higherIsWorse?: Maybe<Scalars['Boolean']>;
  instrument?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  value: Scalars['Float'];
};

export type RecordModeCheckInInput = {
  bodyCue?: InputMaybe<Scalars['String']>;
  checkInId: Scalars['ID'];
  modes: Array<ModeIntensityInput>;
  need?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  occurredAt?: InputMaybe<Scalars['DateTime']>;
  recordedAt: Scalars['DateTime'];
  trigger?: InputMaybe<Scalars['String']>;
};

export type RecordObservationInput = {
  behaviors?: InputMaybe<Scalars['String']>;
  emotions?: InputMaybe<Array<EmotionInput>>;
  experimentId: Scalars['ID'];
  feelings?: InputMaybe<Array<Scalars['Int']>>;
  learnings?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['ID']>;
  whatHappened?: InputMaybe<Scalars['String']>;
  whichHypothesisHeld?: InputMaybe<Scalars['Int']>;
};

export type RecordObservationPayload = {
  __typename?: 'RecordObservationPayload';
  behaviorExperiment?: Maybe<BehaviorExperiment>;
  experimentId: Scalars['ID'];
  observationId: Scalars['ID'];
};

export type RecordSafetyPlanOpenedInput = {
  openedAt?: InputMaybe<Scalars['DateTime']>;
  openedFrom: Scalars['String'];
  openedId: Scalars['ID'];
};

export type ReleasePathwayStepInput = {
  enrollmentId: Scalars['ID'];
  stepId: Scalars['ID'];
};

export type ReleasePathwayStepPayload = {
  __typename?: 'ReleasePathwayStepPayload';
  assignmentId: Scalars['ID'];
  enrollmentId: Scalars['ID'];
  recorded: Scalars['Boolean'];
};

export type ReminderTime = {
  __typename?: 'ReminderTime';
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
};

export type ReminderTimeInput = {
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
};

export type RemoveActivityLogInput = {
  activityLogId: Scalars['ID'];
};

export type RemoveCycleThoughtInput = {
  index: Scalars['Int'];
  subject?: InputMaybe<Scalars['ID']>;
  viciousCycleId: Scalars['ID'];
};

export type RenameViciousCycleInput = {
  name?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['ID']>;
  viciousCycleId: Scalars['ID'];
};

export type ReopenChangeGoalInput = {
  goalId: Scalars['ID'];
};

export type ReopenHomeworkInput = {
  assignmentId: Scalars['ID'];
  dueAt?: InputMaybe<Scalars['DateTime']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type RequestActivitySuggestionsInput = {
  count?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Scalars['String']>;
  requestId: Scalars['ID'];
  value: Scalars['String'];
  valueText: Scalars['String'];
};

export type RequestBehaviorExperimentSuggestionsInput = {
  content: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
};

export type RequestClientTransferInput = {
  /** users/<key> — the member of the SAME practice they would move to. */
  newAssignee: Scalars['ID'];
  /** users/<key> — the CLIENT who would move. */
  subject: Scalars['ID'];
};

export type RequestHealthReadInput = {
  from: Scalars['DateTime'];
  requestId: Scalars['ID'];
  to: Scalars['DateTime'];
  types: Array<Scalars['String']>;
  windows?: InputMaybe<Array<HealthReadWindowInput>>;
};

export type RequestHomeworkReminderInput = {
  assignmentId: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
};

export type RestoreTrimmedRemindersResponse = {
  __typename?: 'RestoreTrimmedRemindersResponse';
  restored: Array<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type RetirePathwayInput = {
  pathwayId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

export type RetireTargetBehaviorInput = {
  reason?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['ID']>;
  targetId: Scalars['ID'];
};

export type RetireWorksheetTemplateInput = {
  reason: Scalars['String'];
  templateId: Scalars['ID'];
};

export type ReviewPathwayPublicationInput = {
  decision: Scalars['String'];
  pathwayId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
  version: Scalars['Int'];
};

export type ReviewSafetyPlanInput = {
  nextReviewBy?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  subject: Scalars['ID'];
};

/**
 * E04 · ReviewSessions — the therapist's explicit RTM billable-time bracket on a client (founder
 * decision 2026-07-18: a first-class domain entity, distinct from the calendar/clinical Session).
 * ACTIVE while `endedAt` is null. `duration` is computed by the reader (endedAt − startedAt).
 */
export type ReviewSession = {
  __typename?: 'ReviewSession';
  endedAt?: Maybe<Scalars['DateTime']>;
  endedVia?: Maybe<Scalars['String']>;
  performer: Scalars['ID'];
  performerName?: Maybe<Scalars['String']>;
  practiceId: Scalars['ID'];
  reviewSessionId: Scalars['ID'];
  startedAt: Scalars['DateTime'];
  subject: Scalars['ID'];
};

export type RevisePathwayInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pathwayId: Scalars['ID'];
  sections: Array<PathwaySectionInput>;
  visibility: Scalars['String'];
};

export type ReviseWorksheetTemplateInput = {
  category: Scalars['String'];
  language: Scalars['String'];
  name: Scalars['String'];
  repeatable: Scalars['Boolean'];
  rightsConfirmed?: InputMaybe<Scalars['Boolean']>;
  scoring?: InputMaybe<WorksheetScoringInput>;
  sections: Array<WorksheetSectionInput>;
  signatureRequired: Scalars['Boolean'];
  templateId: Scalars['ID'];
};

export type RevokeHealthDataAccessInput = {
  deleteImported: Scalars['Boolean'];
  types: Array<Scalars['String']>;
};

export type RoseChoice = {
  __typename?: 'RoseChoice';
  beliefs: Array<Scalars['String']>;
  choiceId: Scalars['ID'];
  chosenAt: Scalars['DateTime'];
  chosenInSession: Scalars['Boolean'];
  comparedWith: Array<Scalars['ID']>;
  sharedBy: Array<Scalars['String']>;
  value: Scalars['String'];
};

export type RoseExamples = {
  __typename?: 'RoseExamples';
  autonomy?: Maybe<Scalars['String']>;
  competence?: Maybe<Scalars['String']>;
  empathyUnderstanding?: Maybe<Scalars['String']>;
  loveAcceptance?: Maybe<Scalars['String']>;
  predictabilityReliability?: Maybe<Scalars['String']>;
  safety?: Maybe<Scalars['String']>;
  selfExpression?: Maybe<Scalars['String']>;
  spontaneity?: Maybe<Scalars['String']>;
};

export type RoseExamplesInput = {
  autonomy?: InputMaybe<Scalars['String']>;
  competence?: InputMaybe<Scalars['String']>;
  empathyUnderstanding?: InputMaybe<Scalars['String']>;
  loveAcceptance?: InputMaybe<Scalars['String']>;
  predictabilityReliability?: InputMaybe<Scalars['String']>;
  safety?: InputMaybe<Scalars['String']>;
  selfExpression?: InputMaybe<Scalars['String']>;
  spontaneity?: InputMaybe<Scalars['String']>;
};

export type RoseInspiredBy = {
  __typename?: 'RoseInspiredBy';
  kind: Scalars['String'];
  ref?: Maybe<Scalars['String']>;
};

export type RoseInspiredByInput = {
  kind: Scalars['String'];
  ref?: InputMaybe<Scalars['String']>;
};

export type RosePlan = {
  __typename?: 'RosePlan';
  planId: Scalars['ID'];
  planMonth: Array<RosePlanItem>;
  planWeek: Array<RosePlanItem>;
  planYear: Array<RosePlanItem>;
  writtenAt: Scalars['DateTime'];
};

export type RosePlanItem = {
  __typename?: 'RosePlanItem';
  resources: Scalars['String'];
  what: Scalars['String'];
  withWhom: Scalars['String'];
};

export type RosePlanItemInput = {
  resources?: InputMaybe<Scalars['String']>;
  what: Scalars['String'];
  withWhom?: InputMaybe<Scalars['String']>;
};

export type RoseProfile = {
  __typename?: 'RoseProfile';
  cappedMean?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  scores?: Maybe<RoseScores>;
  strategyId: Scalars['ID'];
};

export type RoseRating = {
  __typename?: 'RoseRating';
  basis: Scalars['String'];
  cappedMean: Scalars['Float'];
  examples: RoseExamples;
  ratedAt: Scalars['DateTime'];
  ratedInSession: Scalars['Boolean'];
  ratingId: Scalars['ID'];
  rawMean: Scalars['Float'];
  scores: RoseScores;
};

export type RoseScores = {
  __typename?: 'RoseScores';
  autonomy: Scalars['Int'];
  competence: Scalars['Int'];
  empathyUnderstanding: Scalars['Int'];
  loveAcceptance: Scalars['Int'];
  predictabilityReliability: Scalars['Int'];
  safety: Scalars['Int'];
  selfExpression: Scalars['Int'];
  spontaneity: Scalars['Int'];
};

export type RoseScoresInput = {
  autonomy: Scalars['Int'];
  competence: Scalars['Int'];
  empathyUnderstanding: Scalars['Int'];
  loveAcceptance: Scalars['Int'];
  predictabilityReliability: Scalars['Int'];
  safety: Scalars['Int'];
  selfExpression: Scalars['Int'];
  spontaneity: Scalars['Int'];
};

export type RoseStrategy = {
  __typename?: 'RoseStrategy';
  basis?: Maybe<Scalars['String']>;
  behaviors: Array<Scalars['String']>;
  cappedMean?: Maybe<Scalars['Float']>;
  chosen?: Maybe<RoseChoice>;
  describedAt: Scalars['DateTime'];
  describedInSession: Scalars['Boolean'];
  examples: RoseExamples;
  history: Array<RoseRating>;
  inspiredBy?: Maybe<RoseInspiredBy>;
  kind: Scalars['String'];
  name: Scalars['String'];
  plan?: Maybe<RosePlan>;
  ratedAt?: Maybe<Scalars['DateTime']>;
  rawMean?: Maybe<Scalars['Float']>;
  scores?: Maybe<RoseScores>;
  strategyId: Scalars['ID'];
};

export type Sud = {
  __typename?: 'SUD';
  amendedFrom?: Maybe<SudAmendment>;
  reactedAt: Scalars['DateTime'];
  reactionId?: Maybe<Scalars['ID']>;
  sud: Scalars['Int'];
};

export type SudAmendment = {
  __typename?: 'SUDAmendment';
  reactedAt: Scalars['DateTime'];
  sud: Scalars['Int'];
};

export type SudInput = {
  reactedAt: Scalars['DateTime'];
  sud: Scalars['Int'];
};

/**
 * E38 · SafetyPlan — the subject's plan, one field per section, in the order it is used in a crisis (the six steps, then
 * reasons for living). The phone reads its own (no `subject`); the hub reads a client's (a relation with view
 * permission). After an erasure it shows only what is kept (Q-e38g1-2 B).
 */
export type SafetyPlan = {
  __typename?: 'SafetyPlan';
  hasPlan: Scalars['Boolean'];
  mayEdit: Scalars['Boolean'];
  planId: Scalars['ID'];
  sections: Array<SafetyPlanSectionView>;
  subject: Scalars['ID'];
  therapists: Array<SafetyPlanTherapist>;
};

export type SafetyPlanCommandPayload = {
  __typename?: 'SafetyPlanCommandPayload';
  planId: Scalars['ID'];
  recorded: Scalars['Boolean'];
};

export type SafetyPlanEntry = {
  __typename?: 'SafetyPlanEntry';
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type SafetyPlanEntryInput = {
  kind?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

/** E38 · SafetyPlanHistory — every change to the plan, newest first, with its author, and the reviews. */
export type SafetyPlanHistoryRow = {
  __typename?: 'SafetyPlanHistoryRow';
  byClient: Scalars['Boolean'];
  entries?: Maybe<Array<SafetyPlanEntry>>;
  entryId: Scalars['ID'];
  kind: Scalars['String'];
  nextReviewBy?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  occurredAt: Scalars['DateTime'];
  performer: Scalars['ID'];
  performerName?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['DateTime']>;
  section?: Maybe<Scalars['String']>;
};

/**
 * E38 · SafetyPlanOpensByWeek — how often the client opened their plan, per week (Monday–Sunday in the client's zone).
 * A count only: no time of day, no alert, no score.
 */
export type SafetyPlanOpensByWeek = {
  __typename?: 'SafetyPlanOpensByWeek';
  subject: Scalars['ID'];
  thisWeek: Scalars['Int'];
  weeks: Array<SafetyPlanOpensWeek>;
};

export type SafetyPlanOpensWeek = {
  __typename?: 'SafetyPlanOpensWeek';
  count: Scalars['Int'];
  weekStart: Scalars['String'];
};

export type SafetyPlanSectionView = {
  __typename?: 'SafetyPlanSectionView';
  byClient: Scalars['Boolean'];
  entries: Array<SafetyPlanEntry>;
  occurredAt?: Maybe<Scalars['DateTime']>;
  performer?: Maybe<Scalars['ID']>;
  performerName?: Maybe<Scalars['String']>;
  section: Scalars['String'];
};

/**
 * E38 · SafetyPlanStatus — whether the subject has a plan and how complete it is: the Crisis menu's first row, the
 * Toolkit shortcut and the client hub's header.
 */
export type SafetyPlanStatus = {
  __typename?: 'SafetyPlanStatus';
  hasPlan: Scalars['Boolean'];
  nextReviewBy?: Maybe<Scalars['String']>;
  planId: Scalars['ID'];
  reviewedAt?: Maybe<Scalars['DateTime']>;
  reviewedWith?: Maybe<Scalars['ID']>;
  reviewedWithName?: Maybe<Scalars['String']>;
  sectionsFilled: Scalars['Int'];
  subject: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SafetyPlanTherapist = {
  __typename?: 'SafetyPlanTherapist';
  canSee: Scalars['Boolean'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type SectorRatingInput = {
  current: Scalars['Int'];
  ideal: Scalars['Int'];
  sectorId: Scalars['String'];
  valueStatement: Scalars['String'];
};

export type Session = {
  __typename?: 'Session';
  _from: Scalars['ID'];
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  _to: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  placeOfServiceCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type SessionData = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  entityId?: InputMaybe<Scalars['ID']>;
  finishedAt?: InputMaybe<Scalars['DateTime']>;
  placeOfServiceCode?: InputMaybe<Scalars['String']>;
};

export type SessionInput = {
  data: SessionData;
  where: SessionWhere;
};

export type SessionWhere = {
  _id?: InputMaybe<Scalars['ID']>;
  _to: Scalars['ID'];
};

export type Sessions = {
  __typename?: 'Sessions';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<Session>>>;
};

export type SetChangeGoalInput = {
  goalId?: InputMaybe<Scalars['ID']>;
  label: Scalars['String'];
  linkedValues?: InputMaybe<Array<Scalars['String']>>;
  subject?: InputMaybe<Scalars['ID']>;
};

export type SetHealthDataSharingInput = {
  activity: Scalars['Boolean'];
  heartRate: Scalars['Boolean'];
  performer: Scalars['ID'];
  sleep: Scalars['Boolean'];
};

export type SetHiddenToolsInput = {
  hiddenTools: Array<Scalars['String']>;
};

export type SetPathwayAccessRuleInput = {
  accessRule: Scalars['String'];
  adaptyPlacementId?: InputMaybe<Scalars['String']>;
  pathwayId: Scalars['ID'];
  storeProductId?: InputMaybe<Scalars['String']>;
};

export type SetPracticeCapabilityInput = {
  capability: Scalars['String'];
  granted: Scalars['Boolean'];
  practiceId: Scalars['ID'];
};

export type SetSleepWindowInput = {
  basis?: InputMaybe<SleepWindowBasisInput>;
  bedtime: Scalars['String'];
  effectiveFrom: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  protocol?: InputMaybe<Scalars['String']>;
  riseTime: Scalars['String'];
  subject: Scalars['ID'];
};

export type SetTargetBehaviorInput = {
  baselineWeeks?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  functionHypotheses: Array<Scalars['String']>;
  measure: Scalars['String'];
  name: Scalars['String'];
  subject?: InputMaybe<Scalars['ID']>;
  targetId?: InputMaybe<Scalars['ID']>;
};

export type SignWorksheetInput = {
  agreed: Scalars['Boolean'];
  signatureMethod?: InputMaybe<Scalars['String']>;
  signerName: Scalars['String'];
  submissionId: Scalars['ID'];
};

export type SkipHomeworkInput = {
  assignmentId: Scalars['ID'];
  occurrenceAt?: InputMaybe<Scalars['DateTime']>;
  reason?: InputMaybe<Scalars['String']>;
  reasonCode: Scalars['String'];
};

export type SleepCommandPayload = {
  __typename?: 'SleepCommandPayload';
  id?: Maybe<Scalars['ID']>;
  recorded: Scalars['Boolean'];
};

export type SleepDiaryNight = {
  __typename?: 'SleepDiaryNight';
  awakenings?: Maybe<Scalars['Int']>;
  bedTime?: Maybe<Scalars['DateTime']>;
  efficiency?: Maybe<Scalars['Int']>;
  finalWake?: Maybe<Scalars['DateTime']>;
  lightsOut?: Maybe<Scalars['DateTime']>;
  naps?: Maybe<Array<SleepNap>>;
  night: Scalars['String'];
  nightKind: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  outOfBed?: Maybe<Scalars['DateTime']>;
  performer?: Maybe<Scalars['ID']>;
  performerName?: Maybe<Scalars['String']>;
  quality?: Maybe<Scalars['Int']>;
  sleepOnsetMinutes?: Maybe<Scalars['Int']>;
  source: Scalars['String'];
  substances?: Maybe<SleepSubstances>;
  timeInBedMinutes?: Maybe<Scalars['Int']>;
  totalSleepMinutes?: Maybe<Scalars['Int']>;
  wakeMinutes?: Maybe<Scalars['Int']>;
  watchAsleepMinutes?: Maybe<Scalars['Int']>;
};

export type SleepDiaryWeek = {
  __typename?: 'SleepDiaryWeek';
  averages: SleepWeekAverages;
  lastSevenNights?: Maybe<SleepWeekAverages>;
  nights: Array<SleepDiaryNight>;
  subject: Scalars['ID'];
  upcoming: Scalars['Boolean'];
  usualRule?: Maybe<SleepUsualRule>;
  watchShared: Scalars['Boolean'];
  week: Scalars['String'];
  weeks: Array<SleepWeekSummary>;
  window?: Maybe<SleepWindowView>;
  windows: Array<SleepWindowView>;
};

export type SleepNap = {
  __typename?: 'SleepNap';
  minutes: Scalars['Int'];
  start: Scalars['String'];
};

export type SleepNapInput = {
  minutes: Scalars['Int'];
  start: Scalars['String'];
};

export type SleepNightSummaryInput = {
  asleepMinutes: Scalars['Int'];
  awakenings: Scalars['Int'];
  inBedEnd: Scalars['DateTime'];
  inBedStart: Scalars['DateTime'];
  night: Scalars['String'];
  stages?: InputMaybe<SleepStagesInput>;
};

export type SleepNightToConfirm = {
  __typename?: 'SleepNightToConfirm';
  asleepMinutes?: Maybe<Scalars['Int']>;
  inBedEnd?: Maybe<Scalars['DateTime']>;
  inBedStart?: Maybe<Scalars['DateTime']>;
  night: Scalars['String'];
  source?: Maybe<Scalars['String']>;
};

export type SleepNightsToConfirm = {
  __typename?: 'SleepNightsToConfirm';
  nights: Array<SleepNightToConfirm>;
  subject: Scalars['ID'];
  today: Scalars['String'];
};

export type SleepStages = {
  __typename?: 'SleepStages';
  awake: Scalars['Int'];
  core: Scalars['Int'];
  deep: Scalars['Int'];
  rem: Scalars['Int'];
};

export type SleepStagesInput = {
  awake: Scalars['Int'];
  core: Scalars['Int'];
  deep: Scalars['Int'];
  rem: Scalars['Int'];
};

export type SleepSubstances = {
  __typename?: 'SleepSubstances';
  alcoholDrinks?: Maybe<Scalars['Int']>;
  caffeineAfterNoon?: Maybe<Scalars['Int']>;
  sleepAid?: Maybe<Scalars['String']>;
};

export type SleepSubstancesInput = {
  alcoholDrinks?: InputMaybe<Scalars['Int']>;
  caffeineAfterNoon?: InputMaybe<Scalars['Int']>;
  sleepAid?: InputMaybe<Scalars['String']>;
};

export type SleepUsualRule = {
  __typename?: 'SleepUsualRule';
  action: Scalars['String'];
  atFloor: Scalars['Boolean'];
  meanAwakeInNight?: Maybe<Scalars['Int']>;
  meanEfficiency?: Maybe<Scalars['Int']>;
  meanFellAsleep?: Maybe<Scalars['Int']>;
  minutes: Scalars['Int'];
  nights: Scalars['Int'];
  protocol: Scalars['String'];
};

export type SleepWeekAverages = {
  __typename?: 'SleepWeekAverages';
  efficiency?: Maybe<Scalars['Int']>;
  nightsFilled: Scalars['Int'];
  quality?: Maybe<Scalars['Float']>;
  sleepOnsetMinutes?: Maybe<Scalars['Int']>;
  timeInBedMinutes?: Maybe<Scalars['Int']>;
  totalSleepMinutes?: Maybe<Scalars['Int']>;
  wakeMinutes?: Maybe<Scalars['Int']>;
};

export type SleepWeekSummary = {
  __typename?: 'SleepWeekSummary';
  averages: SleepWeekAverages;
  week: Scalars['String'];
};

export type SleepWindow = {
  __typename?: 'SleepWindow';
  next?: Maybe<SleepWindowView>;
  subject: Scalars['ID'];
  upcoming: Scalars['Boolean'];
  window?: Maybe<SleepWindowView>;
  windows: Array<SleepWindowView>;
};

export type SleepWindowBasis = {
  __typename?: 'SleepWindowBasis';
  meanEfficiency: Scalars['Int'];
  meanTimeInBed: Scalars['String'];
  meanTotalSleep: Scalars['String'];
  nights: Scalars['Int'];
};

export type SleepWindowBasisInput = {
  meanEfficiency: Scalars['Int'];
  meanTimeInBed: Scalars['String'];
  meanTotalSleep: Scalars['String'];
  nights: Scalars['Int'];
};

export type SleepWindowView = {
  __typename?: 'SleepWindowView';
  basis?: Maybe<SleepWindowBasis>;
  bedtime: Scalars['String'];
  effectiveFrom: Scalars['String'];
  endedAt?: Maybe<Scalars['DateTime']>;
  lengthMinutes?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  performer: Scalars['ID'];
  performerName?: Maybe<Scalars['String']>;
  protocol: Scalars['String'];
  riseTime: Scalars['String'];
  setAt: Scalars['DateTime'];
  subject: Scalars['ID'];
  windowId: Scalars['ID'];
};

export type StartBehaviorExperimentInput = {
  activeSubtype?: InputMaybe<Scalars['Int']>;
  design?: InputMaybe<Scalars['Int']>;
  hypothesisType?: InputMaybe<Scalars['Int']>;
  observationalSubtype?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type StartExpositionInput = {
  anticipatedSud?: InputMaybe<Scalars['Int']>;
  expectedLikelihood?: InputMaybe<Scalars['Int']>;
  expectedOutcome?: InputMaybe<Scalars['String']>;
  exposureStimulusId: Scalars['ID'];
  subject?: InputMaybe<Scalars['ID']>;
};

export type StartValuesSortInput = {
  cardOrder: Array<Scalars['String']>;
  deckId: Scalars['String'];
  preset: Scalars['String'];
  sortId: Scalars['ID'];
};

export type StateHypothesesInput = {
  experimentId: Scalars['ID'];
  hypothesisA?: InputMaybe<Scalars['String']>;
  hypothesisAConfirmationCriteria?: InputMaybe<Scalars['String']>;
  hypothesisAStrength?: InputMaybe<Scalars['Int']>;
  hypothesisB?: InputMaybe<Scalars['String']>;
  hypothesisBConfirmationCriteria?: InputMaybe<Scalars['String']>;
  hypothesisBStrength?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['ID']>;
};

export type StripeConfigurationProducts = {
  __typename?: 'StripeConfigurationProducts';
  prices?: Maybe<Array<Maybe<StripeProductPrice>>>;
  product?: Maybe<StripeProduct>;
};

export type StripePlan = {
  __typename?: 'StripePlan';
  priceId: Scalars['String'];
  productId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type StripePortalConfigurationData = {
  __typename?: 'StripePortalConfigurationData';
  products?: Maybe<Array<Maybe<StripeConfigurationProducts>>>;
};

export type StripePortalSessionCreate = {
  locale: Scalars['String'];
};

export type StripePortalSessionCreateInput = {
  data?: InputMaybe<StripeSessionCreate>;
};

export type StripePortalSessionCreateResult = {
  __typename?: 'StripePortalSessionCreateResult';
  url?: Maybe<Scalars['String']>;
};

export type StripePriceMeta = {
  __typename?: 'StripePriceMeta';
  locale?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['String']>;
};

export type StripePriceTier = {
  __typename?: 'StripePriceTier';
  flatAmount?: Maybe<Scalars['Int']>;
  unitAmount?: Maybe<Scalars['Int']>;
  upTo?: Maybe<Scalars['Int']>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  metadata?: Maybe<StripeProductMeta>;
  name: Scalars['String'];
};

export type StripeProductMeta = {
  __typename?: 'StripeProductMeta';
  locale?: Maybe<Scalars['String']>;
  metaName?: Maybe<Scalars['String']>;
  tier?: Maybe<Scalars['String']>;
};

export type StripeProductPrice = {
  __typename?: 'StripeProductPrice';
  billingScheme: Scalars['String'];
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  interval?: Maybe<Scalars['String']>;
  intervalCount?: Maybe<Scalars['Int']>;
  lookupKey?: Maybe<Scalars['String']>;
  metadata?: Maybe<StripePriceMeta>;
  tiers?: Maybe<Array<Maybe<StripePriceTier>>>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type StripeSession = {
  __typename?: 'StripeSession';
  url?: Maybe<Scalars['String']>;
};

export type StripeSessionCreate = {
  lineItems?: InputMaybe<Array<PortalSubscriptionInput>>;
  locale: Scalars['String'];
};

export type StripeSessionCreateInput = {
  data?: InputMaybe<StripeSessionCreate>;
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  currentPeriodEnd: Scalars['DateTime'];
  currentPeriodStart: Scalars['DateTime'];
  id: Scalars['String'];
  latestInvoiceId?: Maybe<Scalars['String']>;
  plan?: Maybe<StripePlan>;
  status: Scalars['String'];
};

export type SubmitThoughtTestEventsPayload = {
  __typename?: 'SubmitThoughtTestEventsPayload';
  duplicates: Array<Scalars['ID']>;
  lastPosition: Scalars['Int'];
  thought?: Maybe<Thought>;
};

export type SubmitWellnessEventsPayload = {
  __typename?: 'SubmitWellnessEventsPayload';
  duplicates: Array<Scalars['ID']>;
  lastPosition: Scalars['Int'];
};

export type SubmitWorksheetInput = {
  answers: Scalars['JSON'];
  assignmentId: Scalars['ID'];
  submissionId?: InputMaybe<Scalars['ID']>;
  templateId?: InputMaybe<Scalars['ID']>;
  templateVersion?: InputMaybe<Scalars['Int']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  activatedAt?: Maybe<Scalars['DateTime']>;
  clientsCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isLifetime?: Maybe<Scalars['Boolean']>;
  lastSyncrhonizedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  practiceId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  renewedAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  type: Scalars['Int'];
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
  vendorProductId?: Maybe<Scalars['String']>;
  willRenew?: Maybe<Scalars['Boolean']>;
};

export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  currentPeriodEnd?: Maybe<Scalars['DateTime']>;
  currentPeriodStart?: Maybe<Scalars['DateTime']>;
  currentPriceId?: Maybe<Scalars['String']>;
  currentProductId?: Maybe<Scalars['String']>;
  downgradeWarningSeenAt?: Maybe<Scalars['DateTime']>;
  freeAppsUsed?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Array<Maybe<StripeSubscription>>>;
};

export type SubscriptionWarnings = {
  __typename?: 'SubscriptionWarnings';
  clientsAdded: Scalars['Int'];
  clientsLeft: Scalars['Int'];
  clientsPurchased: Scalars['Int'];
  evaluatedAt: Scalars['DateTime'];
  limitApproaching: Scalars['Boolean'];
  limitReached: Scalars['Boolean'];
  subscriptionExpirationDate?: Maybe<Scalars['DateTime']>;
  subscriptionExpired: Scalars['Boolean'];
};

export type SuggestedActivity = {
  __typename?: 'SuggestedActivity';
  activity: Scalars['String'];
  difficulty: Scalars['Int'];
};

export type Supporter = {
  __typename?: 'Supporter';
  contact?: Maybe<Scalars['String']>;
  howTheyHelp: Scalars['String'];
  name: Scalars['String'];
};

export type SupporterInput = {
  contact?: InputMaybe<Scalars['String']>;
  howTheyHelp: Scalars['String'];
  name: Scalars['String'];
};

export type SupportingCycle = {
  __typename?: 'SupportingCycle';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  createdAt: Scalars['DateTime'];
  isTemplate?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  templateLanguage?: Maybe<Scalars['String']>;
  thoughts: Array<Maybe<SupportingCycleThought>>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['ID']>;
  viciousCycleId?: Maybe<Scalars['ID']>;
};

export type SupportingCycleInput = {
  data: SupportingCycleInputData;
  where?: InputMaybe<SupportingCycleWhere>;
};

export type SupportingCycleInputData = {
  name?: InputMaybe<Scalars['String']>;
  thoughts: Array<InputMaybe<SupportingCycleThoughtInput>>;
};

export type SupportingCycleSearch = {
  __typename?: 'SupportingCycleSearch';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<SupportingCycle>>>;
};

export type SupportingCycleThought = {
  __typename?: 'SupportingCycleThought';
  edges?: Maybe<Array<Maybe<Scalars['Boolean']>>>;
  thought?: Maybe<Scalars['String']>;
};

export type SupportingCycleThoughtInput = {
  edges: Array<InputMaybe<Scalars['Boolean']>>;
  thought?: InputMaybe<Scalars['String']>;
};

export type SupportingCycleWhere = {
  _id?: InputMaybe<Scalars['ID']>;
  clientId?: InputMaybe<Scalars['ID']>;
};

export type Test = {
  __typename?: 'Test';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  actions?: Maybe<Scalars['String']>;
  answers: Array<Maybe<Scalars['Int']>>;
  createdAt: Scalars['DateTime'];
  score: Scalars['Int'];
  severity?: Maybe<Scalars['String']>;
  type: Scalars['Int'];
  userId: Scalars['ID'];
};

export type TestConnection = {
  __typename?: 'TestConnection';
  edges?: Maybe<Array<Maybe<TestEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int'];
};

export type TestCreateInput = {
  answers: Array<InputMaybe<Scalars['Int']>>;
  score: Scalars['Int'];
  type: Scalars['Int'];
};

export type TestEdge = {
  __typename?: 'TestEdge';
  cursor: Scalars['String'];
  node?: Maybe<Test>;
};

export type TestResponse = {
  __typename?: 'TestResponse';
  test?: Maybe<Test>;
};

export type TherapistClientEdge = {
  __typename?: 'TherapistClientEdge';
  _from: Scalars['String'];
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  _to: Scalars['String'];
  allowAdminEdit: Scalars['Boolean'];
  allowAdminView: Scalars['Boolean'];
  allowEdit: Scalars['Boolean'];
  allowView: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  from?: Maybe<User>;
  practiceId?: Maybe<Scalars['String']>;
  to?: Maybe<User>;
  updatedAt: Scalars['DateTime'];
};

export type TherapistClientEdgeCreateInput = {
  allowAdminEdit: Scalars['Boolean'];
  allowAdminView: Scalars['Boolean'];
  allowEdit: Scalars['Boolean'];
  allowView: Scalars['Boolean'];
  from: Scalars['String'];
  /**
   * ADDITIVE (E07 finding 27, 2026-09-13). The invitation token the client is redeeming, when the
   * connection came from one. Before this the wire carried no token at all, so the server could only
   * ever record `grantedVia: 'permanentLink'` — the provenance half of the board's "accept an invite
   * token" scenario was unrepresentable, whatever actually happened. The device already resolves the
   * token (`inviteByToken`); sending it lets the SERVER spend the invitation in the same append as
   * the grant, which is what the slice says and what makes redemption exactly-once.
   * Optional, so a client that does not send it behaves exactly as before: `permanentLink`, and the
   * device cleans the invitation up with its own `deleteInvite` call.
   */
  inviteToken?: InputMaybe<Scalars['String']>;
  practiceId?: InputMaybe<Scalars['String']>;
  to: Scalars['String'];
};

export type TherapistClientEdgeUpdateInput = {
  allowAdminEdit: Scalars['Boolean'];
  allowAdminView: Scalars['Boolean'];
  allowEdit: Scalars['Boolean'];
  allowView: Scalars['Boolean'];
  id: Scalars['ID'];
  practiceId?: InputMaybe<Scalars['String']>;
};

export type TherapistClientEdges = {
  __typename?: 'TherapistClientEdges';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<TherapistClientEdge>>>;
};

export type TherapistMessages = {
  __typename?: 'TherapistMessages';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<Message>>>;
};

export type Thought = {
  __typename?: 'Thought';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  activatingEvent?: Maybe<ActivatingEvent>;
  activatingEventId?: Maybe<Scalars['ID']>;
  automaticThought: Scalars['String'];
  cardName?: Maybe<Scalars['String']>;
  categoriesIds?: Maybe<Array<Scalars['Int']>>;
  cognitiveDistortions?: Maybe<Array<Scalars['String']>>;
  createdAt: Scalars['DateTime'];
  dayReminders?: Maybe<DayReminders>;
  locationReminders?: Maybe<Array<LocationReminder>>;
  realisticThoughts: Array<BasicThought>;
  result: ThoughtTestResult;
  thoughtBelief: Scalars['Int'];
  thoughtsAgainst: Array<Scalars['String']>;
  thoughtsFor: Array<Scalars['String']>;
  thoughtsForAlternativeThoughts?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export type ThoughtConnection = {
  __typename?: 'ThoughtConnection';
  edges?: Maybe<Array<Maybe<ThoughtEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int'];
};

export type ThoughtCreateInput = {
  activatingEventId?: InputMaybe<Scalars['ID']>;
  automaticThought: Scalars['String'];
  cardName?: InputMaybe<Scalars['String']>;
  categoriesIds?: InputMaybe<Array<Scalars['Int']>>;
  cognitiveDistortions?: InputMaybe<Array<Scalars['String']>>;
  realisticThoughts: Array<BasicThoughtInput>;
  result: ThoughtTestResultInput;
  thoughtBelief: Scalars['Int'];
  thoughtsAgainst: Array<Scalars['String']>;
  thoughtsFor: Array<Scalars['String']>;
  thoughtsForAlternativeThoughts?: InputMaybe<
    Array<InputMaybe<Scalars['String']>>
  >;
};

export type ThoughtDeleteResponse = {
  __typename?: 'ThoughtDeleteResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type ThoughtEdge = {
  __typename?: 'ThoughtEdge';
  cursor: Scalars['String'];
  node?: Maybe<Thought>;
};

export type ThoughtResponse = {
  __typename?: 'ThoughtResponse';
  thought?: Maybe<Thought>;
};

export type ThoughtSearch = {
  __typename?: 'ThoughtSearch';
  count: Scalars['Int'];
  thoughts?: Maybe<Array<Maybe<Thought>>>;
};

export type ThoughtTestDraft = {
  __typename?: 'ThoughtTestDraft';
  activatingEventId?: Maybe<Scalars['ID']>;
  automaticThought: Scalars['String'];
  behaviors: Scalars['String'];
  bodyPartsFeelings: Scalars['Int'];
  cognitiveDistortions?: Maybe<Array<Scalars['String']>>;
  description: Scalars['String'];
  emotions: Array<Emotion>;
  feelings: Array<Scalars['Int']>;
  realisticThoughts?: Maybe<Array<BasicThought>>;
  result?: Maybe<ThoughtTestOutcome>;
  resumeStep: ThoughtTestStep;
  subject: Scalars['ID'];
  thought?: Maybe<Thought>;
  thoughtBelief: Scalars['Int'];
  thoughtTestId: Scalars['ID'];
  thoughtsAgainst?: Maybe<Array<Scalars['String']>>;
  thoughtsFor?: Maybe<Array<Scalars['String']>>;
  thoughtsForAlternativeThoughts?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ThoughtTestEventInput = {
  clientSeq: Scalars['Int'];
  eventId: Scalars['ID'];
  occurredAt: Scalars['DateTime'];
  payload: Scalars['JSON'];
  type: ThoughtTestEventType;
};

export enum ThoughtTestEventType {
  ActivatingEventRecorded = 'ActivatingEventRecorded',
  AlternativeThoughtRecorded = 'AlternativeThoughtRecorded',
  AutomaticThoughtRecorded = 'AutomaticThoughtRecorded',
  BehaviorsRecorded = 'BehaviorsRecorded',
  CognitiveDistortionsIdentified = 'CognitiveDistortionsIdentified',
  EvidenceAgainstRecorded = 'EvidenceAgainstRecorded',
  EvidenceForRecorded = 'EvidenceForRecorded',
  LocationReminderSet = 'LocationReminderSet',
  OutcomeRated = 'OutcomeRated',
}

export type ThoughtTestOutcome = {
  __typename?: 'ThoughtTestOutcome';
  initialNegativeEmotionStrength: Scalars['Int'];
  initialThoughtBelief: Scalars['Int'];
};

export type ThoughtTestResult = {
  __typename?: 'ThoughtTestResult';
  initialNegativeEmotionStrenght: Scalars['Int'];
  initialThoughtBelief: Scalars['Int'];
};

export type ThoughtTestResultInput = {
  initialNegativeEmotionStrenght: Scalars['Int'];
  initialThoughtBelief: Scalars['Int'];
};

export enum ThoughtTestStep {
  ActivatingEvent = 'activatingEvent',
  AlternativeThought = 'alternativeThought',
  AutomaticThought = 'automaticThought',
  Behaviors = 'behaviors',
  CognitiveDistortions = 'cognitiveDistortions',
  EvidenceAgainst = 'evidenceAgainst',
  EvidenceFor = 'evidenceFor',
  Outcome = 'outcome',
}

export type ThoughtUpdateInput = {
  _id: Scalars['ID'];
  activatingEventId?: InputMaybe<Scalars['ID']>;
  automaticThought: Scalars['String'];
  cardName?: InputMaybe<Scalars['String']>;
  categoriesIds?: InputMaybe<Array<Scalars['Int']>>;
  cognitiveDistortions?: InputMaybe<Array<Scalars['String']>>;
  realisticThoughts: Array<BasicThoughtInput>;
  result: ThoughtTestResultInput;
  thoughtBelief: Scalars['Int'];
  thoughtsAgainst: Array<Scalars['String']>;
  thoughtsFor: Array<Scalars['String']>;
  thoughtsForAlternativeThoughts?: InputMaybe<
    Array<InputMaybe<Scalars['String']>>
  >;
};

export type TimeReminder = {
  __typename?: 'TimeReminder';
  enabled: Scalars['Boolean'];
  time: ReminderTime;
};

export type TimeReminderInput = {
  enabled: Scalars['Boolean'];
  time: ReminderTimeInput;
};

export type ToggleCycleRelationInput = {
  active: Scalars['Boolean'];
  from: Scalars['Int'];
  subject?: InputMaybe<Scalars['ID']>;
  to: Scalars['Int'];
  viciousCycleId: Scalars['ID'];
};

export type TranslateHealthSummariesInput = {
  activityDays: Array<ActivityDaySummaryInput>;
  heartRateDays?: InputMaybe<Array<HeartRateDaySummaryInput>>;
  heartRateWindows?: InputMaybe<Array<HeartRateWindowSummaryInput>>;
  nights: Array<SleepNightSummaryInput>;
  requestId: Scalars['ID'];
  source: Scalars['String'];
};

/** A client in the practice pool — released by a departing member, not yet reassigned. */
export type UnassignedClient = {
  __typename?: 'UnassignedClient';
  /**
   * The transfer request waiting for this client's answer, if the practice has asked (D-h, P022):
   * Assign on the pool page SENDS the request; the client approves in the app; the move completes by
   * itself. The same rule as the phone's prompt — the newest open request.
   */
  pendingTransfer?: Maybe<PendingClientTransfer>;
  /** users/<key> — the member they were released from. */
  performer?: Maybe<Scalars['ID']>;
  practiceId: Scalars['ID'];
  releasedAt: Scalars['DateTime'];
  /**
   * The member they were released from, as a person — resolved server-side (P022, E07 finding 51):
   * that member has just LEFT the practice, so the roster the page holds cannot name them.
   */
  releasedFrom?: Maybe<User>;
  subject: Scalars['ID'];
  user?: Maybe<User>;
};

export type UnassignedClients = {
  __typename?: 'UnassignedClients';
  count: Scalars['Int'];
  data: Array<Maybe<UnassignedClient>>;
};

export type UnfinishedThoughtTest = {
  __typename?: 'UnfinishedThoughtTest';
  activatingEventId: Scalars['ID'];
  automaticThought: Scalars['String'];
  description: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  resumeStep: ThoughtTestStep;
  subject: Scalars['ID'];
  thoughtTestId: Scalars['ID'];
};

export type UnlinkRecordFromValueInput = {
  linkId: Scalars['ID'];
};

export type UpdateClient = {
  accessLevel?: InputMaybe<Scalars['String']>;
  diagnoses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  preferredPronouns?: InputMaybe<Scalars['Int']>;
};

export type UpdateClientDiagnosesInput = {
  data?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  where?: InputMaybe<UpdateClientWhere>;
};

export type UpdateClientWhere = {
  id: Scalars['ID'];
};

export type UpdateExposureStimuliInput = {
  data: Array<ExposureStimulusInputData>;
  where: ExposureStimulusUpdateWhere;
};

export type UpdateObservationInput = {
  behaviors?: InputMaybe<Scalars['String']>;
  emotions?: InputMaybe<Array<EmotionInput>>;
  experimentId: Scalars['ID'];
  feelings?: InputMaybe<Array<Scalars['Int']>>;
  learnings?: InputMaybe<Scalars['String']>;
  observationId: Scalars['ID'];
  rating?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['ID']>;
  whatHappened?: InputMaybe<Scalars['String']>;
  whichHypothesisHeld?: InputMaybe<Scalars['Int']>;
};

export type UpdatePortalCard = {
  automaticThought?: InputMaybe<Scalars['String']>;
  dayReminders?: InputMaybe<DayRemindersCreateInputNoThught>;
  realisticThoughts?: InputMaybe<Array<BasicThoughtInput>>;
};

export type UpdatePortalThought = {
  automaticThought: Scalars['String'];
  cognitiveDistortions?: InputMaybe<Array<Scalars['String']>>;
  realisticThoughts: Array<BasicThoughtInput>;
  thoughtsAgainst: Array<Scalars['String']>;
  thoughtsFor: Array<Scalars['String']>;
  thoughtsForAlternativeThoughts?: InputMaybe<
    Array<InputMaybe<Scalars['String']>>
  >;
};

export type UpdatePortalThoughtWhere = {
  id: Scalars['ID'];
};

export type UpdatePracticeUser = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['Int']>;
};

export type UpdatePracticeUserWhere = {
  id: Scalars['ID'];
};

export type UpdateProfile = {
  about: Scalars['String'];
  acceptingClients: Scalars['String'];
  approaches: Array<Scalars['String']>;
  approvedForReferrals: Scalars['Boolean'];
  clientAges: Array<Scalars['String']>;
  clientIssues: Array<Scalars['String']>;
  costPerSessionFrom: Scalars['Int'];
  costPerSessionTo: Scalars['Int'];
  currency: Scalars['String'];
  education: Array<Scalars['String']>;
  extension?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  formats: Array<Scalars['String']>;
  freeInitialConsulation: Scalars['Boolean'];
  imageUrl?: InputMaybe<Scalars['String']>;
  languages: Array<Scalars['String']>;
  lastName: Scalars['String'];
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  linkToOtherProfile?: InputMaybe<Scalars['String']>;
  mentalHealthRole: Scalars['String'];
  modalities: Array<Scalars['String']>;
  phone: Scalars['String'];
  slidingScale: Scalars['Boolean'];
  title?: InputMaybe<Scalars['String']>;
  wantsReferrals: Scalars['Boolean'];
  yearsInPractice: Scalars['Int'];
};

export type UpdateSafetyPlanSectionInSessionInput = {
  entries: Array<SafetyPlanEntryInput>;
  section: Scalars['String'];
  subject: Scalars['ID'];
};

export type UpdateSafetyPlanSectionInput = {
  entries: Array<SafetyPlanEntryInput>;
  section: Scalars['String'];
};

export type UricaReading = {
  __typename?: 'UricaReading';
  readiness: Scalars['Float'];
  score: Scalars['Int'];
  stage: Scalars['String'];
  takenAt: Scalars['DateTime'];
  type: Scalars['Int'];
};

export type UsageEvent = {
  __typename?: 'UsageEvent';
  _from: Scalars['ID'];
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  _to: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  extras?: Maybe<Scalars['String']>;
  type: Scalars['Int'];
};

export type UsageEventInput = {
  _to: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  extras?: InputMaybe<Scalars['String']>;
  type: Scalars['Int'];
};

export type UsageEventStats = {
  __typename?: 'UsageEventStats';
  count: Scalars['Int'];
  date: Scalars['DateTime'];
};

export type UsageEventStatsResponse = {
  __typename?: 'UsageEventStatsResponse';
  stats: Array<Maybe<UsageEventStats>>;
};

export type UsageEventsResponse = {
  __typename?: 'UsageEventsResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  accessLevel?: Maybe<Scalars['String']>;
  adaptyProfileId?: Maybe<Scalars['String']>;
  authTokenVersion?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  diagnoses?: Maybe<Array<Maybe<Scalars['String']>>>;
  displayName?: Maybe<Scalars['String']>;
  email: Scalars['EmailAddress'];
  esMode?: Maybe<EsMode>;
  extension?: Maybe<Scalars['String']>;
  fcmToken?: Maybe<Scalars['String']>;
  featureFlags: FeatureFlags;
  firstName?: Maybe<Scalars['String']>;
  hasAdaptyPremiumAccess?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lng: Scalars['String'];
  needsNotificationsSync?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  practice?: Maybe<Practice>;
  practiceId?: Maybe<Scalars['String']>;
  privacySettings?: Maybe<PrivacySettings>;
  providerId: Scalars['String'];
  role: Scalars['Int'];
  state?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  subscriptionExpiredAt?: Maybe<Scalars['DateTime']>;
  timezone: Scalars['String'];
  uid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  utmData?: Maybe<Scalars['JSON']>;
};

export type UserFcmTokenInput = {
  fcmToken: Scalars['String'];
};

export type UserInput = {
  adaptyProfileId?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  displayName?: InputMaybe<Scalars['String']>;
  email: Scalars['EmailAddress'];
  extension?: InputMaybe<Scalars['String']>;
  fcmToken?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  inviteToken?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lng: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  photoUrl?: InputMaybe<Scalars['String']>;
  practiceId?: InputMaybe<Scalars['String']>;
  privacySettings?: InputMaybe<UserPrivacySettingsInput>;
  providerId: Scalars['String'];
  role: Scalars['Int'];
  subscriptionExpiredAt?: InputMaybe<Scalars['DateTime']>;
  timezone: Scalars['String'];
  uid: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  utmData?: InputMaybe<Scalars['JSON']>;
};

export type UserPrivacySettingsInput = {
  isErrorInfoCollectionOn?: InputMaybe<Scalars['Boolean']>;
  isGAUsageCollectionOn?: InputMaybe<Scalars['Boolean']>;
  isKeepLoggedInOn?: InputMaybe<Scalars['Boolean']>;
  isPrivacyAccepted?: InputMaybe<Scalars['Boolean']>;
  isProductEmailNotifyOn?: InputMaybe<Scalars['Boolean']>;
  isProductPushNotifyOn?: InputMaybe<Scalars['Boolean']>;
  isTermsAccepted?: InputMaybe<Scalars['Boolean']>;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  user?: Maybe<User>;
};

export type UserSettingInput = {
  country?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lng: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
};

export type UserSubscriptionInput = {
  accessLevel?: InputMaybe<Scalars['String']>;
  /**
   * E08 (2026-09-21) — the Adapty act this sync relays, so the server can persist it as a fact
   * (AdaptyPurchaseSucceeded / AdaptyPurchasesRestored). Additive: an older app sends none.
   */
  adaptyEvent?: InputMaybe<AdaptySyncEventInput>;
  adaptyProfileId?: InputMaybe<Scalars['String']>;
  needsToSyncAdaptySubscription?: InputMaybe<Scalars['Boolean']>;
};

export type UserSubscriptions = {
  __typename?: 'UserSubscriptions';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<Subscription>>>;
};

/**
 * E36 · ValueActivities — the ladder of a value (activities by difficulty with their state) and the AI suggestions not yet
 * adopted.
 */
export type ValueActivities = {
  __typename?: 'ValueActivities';
  activities: Array<ValueActivityRow>;
  suggested: Array<SuggestedActivity>;
  suggestionRequestId?: Maybe<Scalars['ID']>;
  value: Scalars['String'];
};

export type ValueActivityRow = {
  __typename?: 'ValueActivityRow';
  activity: Scalars['String'];
  activityId: Scalars['ID'];
  difficulty: Scalars['Int'];
  origin: Scalars['String'];
  source: Scalars['String'];
  status: Scalars['String'];
};

export type ValuedLivingArea = {
  __typename?: 'ValuedLivingArea';
  area: Scalars['String'];
  consistency: Scalars['Int'];
  gap: Scalars['Int'];
  importance: Scalars['Int'];
};

/**
 * E36 · ValuedLivingResult — one VLQ take interpreted: the composite, the areas by discrepancy (the largest first) and the
 * change since the previous take.
 */
export type ValuedLivingResult = {
  __typename?: 'ValuedLivingResult';
  areas: Array<ValuedLivingArea>;
  changeSinceLast?: Maybe<Scalars['Int']>;
  composite: Scalars['Int'];
  occurredAt: Scalars['DateTime'];
  previousComposite?: Maybe<Scalars['Int']>;
  vlqId: Scalars['ID'];
};

export type ValuesCommandPayload = {
  __typename?: 'ValuesCommandPayload';
  assignmentId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  recorded: Scalars['Boolean'];
};

/**
 * E36 · ValuesDeck — the published deck in the app's language: its cards, presets (full 83 · quick 30), licence and citation.
 * Content only; names no person.
 */
export type ValuesDeck = {
  __typename?: 'ValuesDeck';
  cards: Array<ValuesDeckCard>;
  citation: Scalars['String'];
  deckId: Scalars['String'];
  language: Scalars['String'];
  licence: Scalars['String'];
  name: Scalars['String'];
  presets: Array<ValuesDeckPreset>;
};

export type ValuesDeckCard = {
  __typename?: 'ValuesDeckCard';
  card: Scalars['String'];
  text: Scalars['String'];
};

export type ValuesDeckPreset = {
  __typename?: 'ValuesDeckPreset';
  cardIds: Array<Scalars['String']>;
  cards: Scalars['Int'];
  preset: Scalars['String'];
};

/**
 * E36 · ValuesProfile — the ONE profile every other tool links to: the ranked values of the latest sort, each with its wheel
 * gap, VLQ gap, committed actions, activities and linked records. The phone reads its own (no `subject`); the hub reads a
 * client's, read-only (a relation with view permission).
 */
export type ValuesProfile = {
  __typename?: 'ValuesProfile';
  lastSortAt?: Maybe<Scalars['DateTime']>;
  subject: Scalars['ID'];
  values: Array<ValuesProfileValue>;
  vlqComposite?: Maybe<Scalars['Int']>;
  wheelRatedAt?: Maybe<Scalars['DateTime']>;
};

export type ValuesProfileAction = {
  __typename?: 'ValuesProfileAction';
  action: Scalars['String'];
  actionId: Scalars['ID'];
  assignmentId: Scalars['ID'];
  dueAt: Scalars['DateTime'];
  status: Scalars['String'];
};

export type ValuesProfileActivity = {
  __typename?: 'ValuesProfileActivity';
  activity: Scalars['String'];
  activityId: Scalars['ID'];
  difficulty: Scalars['Int'];
  status: Scalars['String'];
};

export type ValuesProfileLink = {
  __typename?: 'ValuesProfileLink';
  focus: Scalars['String'];
  focusType: Scalars['String'];
  linkId: Scalars['ID'];
};

export type ValuesProfileValue = {
  __typename?: 'ValuesProfileValue';
  actions: Array<ValuesProfileAction>;
  activities: Array<ValuesProfileActivity>;
  cardText?: Maybe<Scalars['String']>;
  consistency?: Maybe<Scalars['Int']>;
  current?: Maybe<Scalars['Int']>;
  gap?: Maybe<Scalars['Int']>;
  gapArea?: Maybe<Scalars['String']>;
  ideal?: Maybe<Scalars['Int']>;
  importance?: Maybe<Scalars['Int']>;
  links: Array<ValuesProfileLink>;
  rank?: Maybe<Scalars['Int']>;
  rose?: Maybe<RoseProfile>;
  value: Scalars['String'];
  vlqArea?: Maybe<Scalars['String']>;
  vlqGap?: Maybe<Scalars['Int']>;
  vlqGapArea?: Maybe<Scalars['String']>;
  wheelPreset?: Maybe<Scalars['String']>;
  wheelSector?: Maybe<Scalars['String']>;
  wheelSectorName?: Maybe<Scalars['String']>;
};

export type ValuesSortPiles = {
  __typename?: 'ValuesSortPiles';
  important: Array<Scalars['String']>;
  notImportant: Array<Scalars['String']>;
  veryImportant: Array<Scalars['String']>;
};

export type ValuesSortPilesInput = {
  important: Array<Scalars['String']>;
  notImportant: Array<Scalars['String']>;
  veryImportant: Array<Scalars['String']>;
};

export type ValuesSortProgressRow = {
  __typename?: 'ValuesSortProgressRow';
  cardOrder: Array<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  deckId: Scalars['String'];
  preset: Scalars['String'];
  sortId: Scalars['ID'];
  startedAt: Scalars['DateTime'];
  status: Scalars['String'];
};

/**
 * E36 · ValuesSortResult — one completed sort: the ranked top values with their card lines, the piles and the count of
 * very-important cards.
 */
export type ValuesSortResult = {
  __typename?: 'ValuesSortResult';
  cardText: Array<ValuesDeckCard>;
  deckId: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  piles: ValuesSortPiles;
  ranked: Array<Scalars['String']>;
  sortId: Scalars['ID'];
  veryImportantCount: Scalars['Int'];
};

/**
 * E36 · ValuesWheel — the person's latest wheel with everything hung on it: per sector the statement, current vs ideal and
 * the gap, the obstacles and the committed actions (done / open); earlier ratings for the trend. The portal's Client Hub —
 * Values renders the same view, read-only.
 */
export type ValuesWheel = {
  __typename?: 'ValuesWheel';
  preset: Scalars['String'];
  previousRatings: Array<ValuesWheelRating>;
  ratedAt?: Maybe<Scalars['DateTime']>;
  ratedBy?: Maybe<Scalars['ID']>;
  ratedByName?: Maybe<Scalars['String']>;
  ratedInSession: Scalars['Boolean'];
  sectors: Array<ValuesWheelSector>;
  wheelId: Scalars['ID'];
};

export type ValuesWheelAction = {
  __typename?: 'ValuesWheelAction';
  action: Scalars['String'];
  actionId: Scalars['ID'];
  assignmentId: Scalars['ID'];
  dueAt: Scalars['DateTime'];
  status: Scalars['String'];
};

export type ValuesWheelObstacle = {
  __typename?: 'ValuesWheelObstacle';
  obstacle: Scalars['String'];
  obstacleId: Scalars['ID'];
  severity: Scalars['Int'];
};

export type ValuesWheelRating = {
  __typename?: 'ValuesWheelRating';
  ratedAt: Scalars['DateTime'];
  ratedBy?: Maybe<Scalars['ID']>;
  ratedByName?: Maybe<Scalars['String']>;
  ratingId: Scalars['ID'];
  sectors: Array<ValuesWheelSectorMark>;
};

export type ValuesWheelSector = {
  __typename?: 'ValuesWheelSector';
  actions: Array<ValuesWheelAction>;
  current?: Maybe<Scalars['Int']>;
  gap?: Maybe<Scalars['Int']>;
  ideal?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  obstacles: Array<ValuesWheelObstacle>;
  sectorId: Scalars['String'];
  valueStatement?: Maybe<Scalars['String']>;
};

export type ValuesWheelSectorMark = {
  __typename?: 'ValuesWheelSectorMark';
  current: Scalars['Int'];
  ideal: Scalars['Int'];
  sectorId: Scalars['String'];
};

export type ViciousCyclePayload = {
  __typename?: 'ViciousCyclePayload';
  supportingCycle?: Maybe<SupportingCycle>;
  viciousCycleId: Scalars['ID'];
};

export type VlqAreaInput = {
  area: Scalars['String'];
  consistency: Scalars['Int'];
  importance: Scalars['Int'];
};

export type WatchAssignedVideoInput = {
  assignmentId: Scalars['ID'];
  duration: Scalars['Int'];
  occurredAt: Scalars['DateTime'];
  position: Scalars['Int'];
  secondsPlayed: Scalars['Int'];
  target?: InputMaybe<HomeworkTargetInput>;
  viewingId: Scalars['ID'];
};

export type WeekActivities = {
  __typename?: 'WeekActivities';
  activities: Array<WeekActivity>;
  subject: Scalars['ID'];
};

export type WeekActivity = {
  __typename?: 'WeekActivity';
  activityLogId: Scalars['ID'];
  enjoyment: Scalars['Int'];
  importance: Scalars['Int'];
  startAt: Scalars['DateTime'];
  title: Scalars['String'];
  valueActivityId?: Maybe<Scalars['ID']>;
};

export type WellnessEventInput = {
  clientSeq: Scalars['Int'];
  eventId: Scalars['ID'];
  occurredAt: Scalars['DateTime'];
  payload: Scalars['JSON'];
  type: WellnessEventType;
};

export enum WellnessEventType {
  ArticleViewFinished = 'ArticleViewFinished',
  ArticleViewStarted = 'ArticleViewStarted',
  LearnVideoFinished = 'LearnVideoFinished',
  LearnVideoStarted = 'LearnVideoStarted',
  MeditationSessionFinished = 'MeditationSessionFinished',
  MeditationSessionStarted = 'MeditationSessionStarted',
  RelaxationVideoFinished = 'RelaxationVideoFinished',
  RelaxationVideoStarted = 'RelaxationVideoStarted',
}

export type WhatINoticed = {
  __typename?: 'WhatINoticed';
  enough: Scalars['Boolean'];
  later: Array<FaCounted>;
  links: FaLinkCounts;
  name: Scalars['String'];
  nextTime: Array<FaIdea>;
  promptingEvents: Array<FaCounted>;
  records: Scalars['Int'];
  rightAway: Array<FaCounted>;
  subject: Scalars['ID'];
  suggestion?: Maybe<FaIdea>;
  targetId: Scalars['ID'];
  threshold: Scalars['Int'];
  vulnerabilities: Array<FaCounted>;
};

export type WheelSectorInput = {
  name: Scalars['String'];
  sectorId: Scalars['String'];
};

export type WhereInput = {
  id: Scalars['ID'];
};

/**
 * E53 · WindRose — the person's ways of living, each with its latest rating (the eight raw scores that draw the rose), the raw and
 * capped means (Σ min(score, 8) / 8, worked out at read time), the rating history and — on the chosen way — the choice and its plan.
 * The phone reads its own (no `subject`); the hub reads a client's (a relation with view permission).
 */
export type WindRose = {
  __typename?: 'WindRose';
  chosenStrategyId?: Maybe<Scalars['ID']>;
  ratedAt?: Maybe<Scalars['DateTime']>;
  strategies: Array<RoseStrategy>;
  subject: Scalars['ID'];
};

export type WithdrawFromPathwayInput = {
  enrollmentId: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

/**
 * E34 · WorksheetEntriesOverTime (D-entries-over-time-2026-10-07) — a repeated worksheet's numeric answers over
 * time: one series per number / scale field, plus a `score` series where the template scores. `points` is the
 * board's flat list (oldest first; the score's points carry fieldKey `score`); `series` is the same numbers per
 * field with the latest value and the count. A description, never a verdict: no statistics, no threshold, no
 * alert. Text answers are never in it — they stay in the entries list (WorksheetResponse).
 */
export type WorksheetEntriesOverTime = {
  __typename?: 'WorksheetEntriesOverTime';
  entryCount: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  numericFields: Array<WorksheetNumericField>;
  points: Array<WorksheetEntryPoint>;
  scoring?: Maybe<WorksheetScoring>;
  series: Array<WorksheetEntrySeries>;
  subject: Scalars['ID'];
  templateId: Scalars['ID'];
};

export type WorksheetEntryPoint = {
  __typename?: 'WorksheetEntryPoint';
  fieldKey: Scalars['ID'];
  occurredAt: Scalars['DateTime'];
  submissionId: Scalars['ID'];
  value: Scalars['Float'];
};

export type WorksheetEntrySeries = {
  __typename?: 'WorksheetEntrySeries';
  count: Scalars['Int'];
  fieldKey: Scalars['ID'];
  label: Scalars['String'];
  latest?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  points: Array<WorksheetSeriesPoint>;
  type: Scalars['String'];
};

export type WorksheetField = {
  __typename?: 'WorksheetField';
  fieldId: Scalars['ID'];
  label: Scalars['String'];
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  options?: Maybe<Array<Scalars['String']>>;
  required?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type WorksheetFieldInput = {
  fieldId: Scalars['ID'];
  label: Scalars['String'];
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
  options?: InputMaybe<Array<Scalars['String']>>;
  required?: InputMaybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

/**
 * E34 · WorksheetForm — per assignment: the exact template version to render and whether it has been
 * submitted. Read by the phone's form and by the portal's "Fill with the client".
 */
export type WorksheetForm = {
  __typename?: 'WorksheetForm';
  assignmentId: Scalars['ID'];
  awaitingSignature: Scalars['Boolean'];
  cancelled: Scalars['Boolean'];
  category: Scalars['String'];
  language: Scalars['String'];
  name: Scalars['String'];
  repeatable: Scalars['Boolean'];
  sections: Array<WorksheetSection>;
  signatureRequired: Scalars['Boolean'];
  signedAt?: Maybe<Scalars['DateTime']>;
  subject: Scalars['ID'];
  submissionId?: Maybe<Scalars['ID']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  templateId: Scalars['ID'];
  templateVersion: Scalars['Int'];
};

export type WorksheetImportDocuments = {
  __typename?: 'WorksheetImportDocuments';
  knownInstruments: Scalars['Int'];
  skipped: Scalars['Int'];
  templates: Scalars['Int'];
};

/**
 * E34 · WorksheetImportDraft — the import's result as the editor opens it: the drafts, the known questionnaires
 * joined to CopingCard's assessments, the parts left out — or the refusal (`code`: WORKSHEET_IMPORT_TOO_LARGE ·
 * UNREADABLE · FILLED · BUSY). Request-scoped: this answer is the only place a draft exists.
 */
export type WorksheetImportDraft = {
  __typename?: 'WorksheetImportDraft';
  code?: Maybe<Scalars['String']>;
  documents?: Maybe<WorksheetImportDocuments>;
  drafts: Array<WorksheetImportDraftItem>;
  importId: Scalars['ID'];
  importedFrom?: Maybe<WorksheetImportedFrom>;
  instrumentIds: Array<Scalars['String']>;
  practiceId?: Maybe<Scalars['ID']>;
};

export type WorksheetImportDraftItem = {
  __typename?: 'WorksheetImportDraftItem';
  draft?: Maybe<WorksheetImportTemplateDraft>;
  inCatalogue?: Maybe<Scalars['Boolean']>;
  instrument?: Maybe<Scalars['String']>;
  instrumentId?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  notes: Array<WorksheetImportNote>;
  pages: Array<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
};

export type WorksheetImportFileInput = {
  data?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  size: Scalars['Int'];
};

export type WorksheetImportNote = {
  __typename?: 'WorksheetImportNote';
  code: Scalars['String'];
  count?: Maybe<Scalars['Int']>;
  pages?: Maybe<Array<Scalars['Int']>>;
  ref?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

export type WorksheetImportTemplateDraft = {
  __typename?: 'WorksheetImportTemplateDraft';
  category: Scalars['String'];
  language: Scalars['String'];
  name: Scalars['String'];
  repeatable: Scalars['Boolean'];
  scoring?: Maybe<WorksheetScoring>;
  sections: Array<WorksheetSection>;
  signatureRequired: Scalars['Boolean'];
};

export type WorksheetImportedFrom = {
  __typename?: 'WorksheetImportedFrom';
  format: Scalars['String'];
  pages?: Maybe<Scalars['Int']>;
};

export type WorksheetImportedFromInput = {
  format: Scalars['String'];
  pages?: InputMaybe<Scalars['Int']>;
};

export type WorksheetNumericField = {
  __typename?: 'WorksheetNumericField';
  fieldKey: Scalars['ID'];
  label: Scalars['String'];
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
};

/**
 * E34 · WorksheetResponse — one submission rendered against its template version: each field's label
 * beside the answer (`answers` keyed by fieldId), the score and band when the template scores, the
 * signature block for a consent. `performerName` is resolved at read time.
 */
export type WorksheetResponse = {
  __typename?: 'WorksheetResponse';
  answers: Scalars['JSON'];
  assignmentId: Scalars['ID'];
  band?: Maybe<Scalars['String']>;
  filledInSession: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  performer: Scalars['ID'];
  performerName?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  scoring?: Maybe<WorksheetScoring>;
  sections: Array<WorksheetSection>;
  signatureRequired: Scalars['Boolean'];
  signedAt?: Maybe<Scalars['DateTime']>;
  signerName?: Maybe<Scalars['String']>;
  subject: Scalars['ID'];
  submissionId: Scalars['ID'];
  submittedAt: Scalars['DateTime'];
  templateId: Scalars['ID'];
  templateVersion: Scalars['Int'];
};

export type WorksheetScoreBand = {
  __typename?: 'WorksheetScoreBand';
  label: Scalars['String'];
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type WorksheetScoreBandInput = {
  label: Scalars['String'];
  max: Scalars['Float'];
  min: Scalars['Float'];
};

export type WorksheetScoring = {
  __typename?: 'WorksheetScoring';
  bands: Array<WorksheetScoreBand>;
  fields: Array<Scalars['String']>;
  kind: Scalars['String'];
};

export type WorksheetScoringInput = {
  bands: Array<WorksheetScoreBandInput>;
  fields: Array<Scalars['String']>;
  kind: Scalars['String'];
};

export type WorksheetSection = {
  __typename?: 'WorksheetSection';
  fields: Array<WorksheetField>;
  sectionId: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  video?: Maybe<WorksheetVideo>;
};

export type WorksheetSectionInput = {
  fields?: InputMaybe<Array<WorksheetFieldInput>>;
  sectionId: Scalars['ID'];
  text?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  video?: InputMaybe<WorksheetVideoInput>;
};

export type WorksheetSeriesPoint = {
  __typename?: 'WorksheetSeriesPoint';
  occurredAt: Scalars['DateTime'];
  submissionId: Scalars['ID'];
  value: Scalars['Float'];
};

export type WorksheetSubmissionPayload = {
  __typename?: 'WorksheetSubmissionPayload';
  assignmentId?: Maybe<Scalars['ID']>;
  recorded: Scalars['Boolean'];
  submissionId: Scalars['ID'];
};

/**
 * E34 · WorksheetTemplates — one row of the library: the caller's practice's own templates (latest
 * version) and the CopingCard library, retired ones hidden. `owner` practice · library; `assignedCount`
 * the caller's practice's assignments of it; `fieldCount` 0 for a reading or video lesson.
 */
export type WorksheetTemplate = {
  __typename?: 'WorksheetTemplate';
  assignedCount: Scalars['Int'];
  category: Scalars['String'];
  copiedFrom?: Maybe<Scalars['ID']>;
  fieldCount: Scalars['Int'];
  language: Scalars['String'];
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  owner: Scalars['String'];
  paperEligible: Scalars['Boolean'];
  practiceId?: Maybe<Scalars['ID']>;
  repeatable: Scalars['Boolean'];
  signatureRequired: Scalars['Boolean'];
  templateId: Scalars['ID'];
  version: Scalars['Int'];
};

/**
 * E34 · a template's latest version, whole — what the Builder opens to edit (its own) or to copy (a
 * library row — "Use this template"). Null for another practice's template.
 */
export type WorksheetTemplateDetail = {
  __typename?: 'WorksheetTemplateDetail';
  category: Scalars['String'];
  copiedFrom?: Maybe<Scalars['ID']>;
  fieldCount: Scalars['Int'];
  language: Scalars['String'];
  name: Scalars['String'];
  occurredAt: Scalars['DateTime'];
  owner: Scalars['String'];
  paperEligible: Scalars['Boolean'];
  practiceId?: Maybe<Scalars['ID']>;
  repeatable: Scalars['Boolean'];
  retired: Scalars['Boolean'];
  scoring?: Maybe<WorksheetScoring>;
  sections: Array<WorksheetSection>;
  signatureRequired: Scalars['Boolean'];
  templateId: Scalars['ID'];
  version: Scalars['Int'];
};

export type WorksheetTemplatePayload = {
  __typename?: 'WorksheetTemplatePayload';
  recorded: Scalars['Boolean'];
  templateId: Scalars['ID'];
  version?: Maybe<Scalars['Int']>;
};

export type WorksheetVideo = {
  __typename?: 'WorksheetVideo';
  duration?: Maybe<Scalars['Int']>;
  ref: Scalars['String'];
  source: Scalars['String'];
  title: Scalars['String'];
};

export type WorksheetVideoInput = {
  duration?: InputMaybe<Scalars['Int']>;
  ref: Scalars['String'];
  source: Scalars['String'];
  title: Scalars['String'];
};

export type WorryTree = {
  __typename?: 'WorryTree';
  _id: Scalars['ID'];
  _key: Scalars['String'];
  _rev: Scalars['String'];
  createdAt: Scalars['DateTime'];
  immediateAction?: Maybe<Scalars['String']>;
  isNotSolvable: Scalars['Boolean'];
  options?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['String']>;
  selectedActivityIdx?: Maybe<Scalars['Int']>;
  userId: Scalars['ID'];
  worryAbout: Scalars['String'];
};

export type WorryTreeInput = {
  data: WorryTreeInputData;
  where: WorryTreeInputWhere;
};

export type WorryTreeInputData = {
  immediateAction?: InputMaybe<Scalars['String']>;
  isNotSolvable: Scalars['Boolean'];
  options?: InputMaybe<Scalars['String']>;
  plan?: InputMaybe<Scalars['String']>;
  selectedActivityIdx?: InputMaybe<Scalars['Int']>;
  worryAbout: Scalars['String'];
};

export type WorryTreeInputWhere = {
  clientId?: InputMaybe<Scalars['ID']>;
};

export type WorryTreeSearch = {
  __typename?: 'WorryTreeSearch';
  count: Scalars['Int'];
  data?: Maybe<Array<Maybe<WorryTree>>>;
};

export type WriteChangePlanInput = {
  changes: Scalars['String'];
  goalId: Scalars['ID'];
  helpers?: InputMaybe<Array<Scalars['String']>>;
  obstacles?: InputMaybe<Array<ChangePlanObstacleInput>>;
  planSteps?: InputMaybe<Array<ChangePlanStepInput>>;
  reasons?: InputMaybe<Array<Scalars['String']>>;
  signsOfSuccess?: InputMaybe<Scalars['String']>;
};

export type WriteDecisionalBalanceInput = {
  consOfChange?: InputMaybe<Array<Scalars['String']>>;
  consOfStaying?: InputMaybe<Array<Scalars['String']>>;
  goalId: Scalars['ID'];
  prosOfChange?: InputMaybe<Array<Scalars['String']>>;
  prosOfStaying?: InputMaybe<Array<Scalars['String']>>;
};

export type WriteStrategyPlanInput = {
  planId: Scalars['ID'];
  planMonth: Array<RosePlanItemInput>;
  planWeek: Array<RosePlanItemInput>;
  planYear: Array<RosePlanItemInput>;
  strategyId: Scalars['ID'];
};

export type CreateInviteInput = {
  data?: InputMaybe<CreateInvite>;
};

export type DeleteClientInput = {
  where?: InputMaybe<UpdateClientWhere>;
};

export type DeleteExposureStimulusInput = {
  where: ExposureStimulusDeleteWhere;
};

export type DeleteInviteInput = {
  where?: InputMaybe<DeleteInvite>;
};

export type DeletePracticeUserInput = {
  where?: InputMaybe<UpdatePracticeUserWhere>;
};

export type TherapistClientECreateInput = {
  data?: InputMaybe<TherapistClientEdgeCreateInput>;
};

export type TherapistClientEUpdateInput = {
  data?: InputMaybe<TherapistClientEdgeUpdateInput>;
};

export type UpdateClientInput = {
  data?: InputMaybe<UpdateClient>;
  where?: InputMaybe<UpdateClientWhere>;
};

export type UpdateExposureInput = {
  data: ExposureStimulusInputData;
  where: UpdateExposureInputWhere;
};

export type UpdateExposureInputWhere = {
  id: Scalars['ID'];
};

export type UpdatePortalCardInput = {
  data?: InputMaybe<UpdatePortalCard>;
  where?: InputMaybe<UpdatePortalThoughtWhere>;
};

export type UpdatePortalThoughtInput = {
  data?: InputMaybe<UpdatePortalThought>;
  where?: InputMaybe<UpdatePortalThoughtWhere>;
};

export type UpdatePracticeInput = {
  data?: InputMaybe<PracticeUpdate>;
  where?: InputMaybe<UpdateClientWhere>;
};

export type UpdatePracticeUserInput = {
  data?: InputMaybe<UpdatePracticeUser>;
  where?: InputMaybe<UpdatePracticeUserWhere>;
};

export type UpdateProfileInput = {
  data?: InputMaybe<UpdateProfile>;
  where?: InputMaybe<WhereInput>;
};

export type AbcModelDataFragment = {
  __typename?: 'AbcModel';
  userId: string;
  createdAt: any;
  updatedAt: any;
  a?: string | null;
  b?: string | null;
  feelings: Array<number | null>;
  behaviors?: string | null;
  emotions: Array<{
    __typename?: 'Emotion';
    id: number;
    strength: number;
  } | null>;
};

export type AbcModelsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['JSON']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type AbcModelsQuery = {
  __typename?: 'Query';
  abcModels?: {
    __typename?: 'AbcModelSearch';
    count: number;
    data?: Array<{
      __typename?: 'AbcModel';
      _id: string;
      userId: string;
      createdAt: any;
      updatedAt: any;
      a?: string | null;
      b?: string | null;
      feelings: Array<number | null>;
      behaviors?: string | null;
      emotions: Array<{
        __typename?: 'Emotion';
        id: number;
        strength: number;
      } | null>;
    } | null> | null;
  } | null;
};

export type AbcModelQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']>;
}>;

export type AbcModelQuery = {
  __typename?: 'Query';
  abcModel?: {
    __typename?: 'AbcModel';
    _id: string;
    userId: string;
    createdAt: any;
    updatedAt: any;
    a?: string | null;
    b?: string | null;
    feelings: Array<number | null>;
    behaviors?: string | null;
    emotions: Array<{
      __typename?: 'Emotion';
      id: number;
      strength: number;
    } | null>;
  } | null;
};

export type UpsertAbcModelMutationVariables = Exact<{
  input?: InputMaybe<AbcModelInput>;
}>;

export type UpsertAbcModelMutation = {
  __typename?: 'Mutation';
  upsertAbcModel?: {
    __typename?: 'AbcModel';
    _id: string;
    userId: string;
    createdAt: any;
    updatedAt: any;
    a?: string | null;
    b?: string | null;
    feelings: Array<number | null>;
    behaviors?: string | null;
    emotions: Array<{
      __typename?: 'Emotion';
      id: number;
      strength: number;
    } | null>;
  } | null;
};

export type AccountDeletionStatusQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AccountDeletionStatusQuery = {
  __typename?: 'Query';
  accountDeletionStatus: {
    __typename?: 'AccountDeletionStatus';
    pending: boolean;
    requestedAt?: any | null;
    dueBy?: any | null;
  };
};

export type RequestAccountDeletionMutationVariables = Exact<{
  via: Scalars['String'];
}>;

export type RequestAccountDeletionMutation = {
  __typename?: 'Mutation';
  requestAccountDeletion: {
    __typename?: 'AccountDeletionStatus';
    pending: boolean;
    requestedAt?: any | null;
    dueBy?: any | null;
  };
};

export type ActivatingEventDataFragment = {
  __typename?: 'ActivatingEvent';
  _id: string;
  _key: string;
  _rev: string;
  userId: string;
  description: string;
  participantIds?: Array<string> | null;
  imageUrl?: Array<any> | null;
  createdAt: any;
  updatedAt: any;
  feelings: Array<number>;
  bodyPartsFeelings: number;
  behaviors?: string | null;
  location?: {
    __typename?: 'Location';
    _id: string;
    _key: string;
    _rev: string;
    createdAt: any;
    updatedAt: any;
    name: string;
    latitude: number;
    longitude: number;
  } | null;
  interval?: { __typename?: 'Interval'; start: any; end: any } | null;
  emotions: Array<{ __typename?: 'Emotion'; id: number; strength: number }>;
  thoughts?: Array<{
    __typename?: 'Thought';
    _id: string;
    _key: string;
    _rev: string;
    userId: string;
    activatingEventId?: string | null;
    createdAt: any;
    updatedAt: any;
    automaticThought: string;
    thoughtBelief: number;
    thoughtsFor: Array<string>;
    thoughtsForAlternativeThoughts?: Array<string | null> | null;
    thoughtsAgainst: Array<string>;
    cognitiveDistortions?: Array<string> | null;
    cardName?: string | null;
    categoriesIds?: Array<number> | null;
    realisticThoughts: Array<{
      __typename?: 'BasicThought';
      thought: string;
      thoughtBelief: number;
    }>;
    result: {
      __typename?: 'ThoughtTestResult';
      initialThoughtBelief: number;
      initialNegativeEmotionStrenght: number;
    };
    dayReminders?: {
      __typename?: 'DayReminders';
      _id: string;
      _key: string;
      _rev: string;
      thoughtId: string;
      createdAt: any;
      updatedAt: any;
      morning: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
      day: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
      evening: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
    } | null;
    locationReminders?: Array<{
      __typename?: 'LocationReminder';
      _id: string;
      _key: string;
      _rev: string;
      _from: string;
      _to: string;
      createdAt: any;
      updatedAt: any;
      enter?: boolean | null;
      leave?: boolean | null;
      type: number;
    }> | null;
  }> | null;
};

export type ActivatingEventQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type ActivatingEventQuery = {
  __typename?: 'Query';
  activatingEvent?: {
    __typename?: 'ActivatingEvent';
    _id: string;
    _key: string;
    _rev: string;
    userId: string;
    description: string;
    participantIds?: Array<string> | null;
    imageUrl?: Array<any> | null;
    createdAt: any;
    updatedAt: any;
    feelings: Array<number>;
    bodyPartsFeelings: number;
    behaviors?: string | null;
    location?: {
      __typename?: 'Location';
      _id: string;
      _key: string;
      _rev: string;
      createdAt: any;
      updatedAt: any;
      name: string;
      latitude: number;
      longitude: number;
    } | null;
    interval?: { __typename?: 'Interval'; start: any; end: any } | null;
    emotions: Array<{ __typename?: 'Emotion'; id: number; strength: number }>;
    thoughts?: Array<{
      __typename?: 'Thought';
      _id: string;
      _key: string;
      _rev: string;
      userId: string;
      activatingEventId?: string | null;
      createdAt: any;
      updatedAt: any;
      automaticThought: string;
      thoughtBelief: number;
      thoughtsFor: Array<string>;
      thoughtsForAlternativeThoughts?: Array<string | null> | null;
      thoughtsAgainst: Array<string>;
      cognitiveDistortions?: Array<string> | null;
      cardName?: string | null;
      categoriesIds?: Array<number> | null;
      realisticThoughts: Array<{
        __typename?: 'BasicThought';
        thought: string;
        thoughtBelief: number;
      }>;
      result: {
        __typename?: 'ThoughtTestResult';
        initialThoughtBelief: number;
        initialNegativeEmotionStrenght: number;
      };
      dayReminders?: {
        __typename?: 'DayReminders';
        _id: string;
        _key: string;
        _rev: string;
        thoughtId: string;
        createdAt: any;
        updatedAt: any;
        morning: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
        day: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
        evening: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
      } | null;
      locationReminders?: Array<{
        __typename?: 'LocationReminder';
        _id: string;
        _key: string;
        _rev: string;
        _from: string;
        _to: string;
        createdAt: any;
        updatedAt: any;
        enter?: boolean | null;
        leave?: boolean | null;
        type: number;
      }> | null;
    }> | null;
  } | null;
};

export type CreateActivatingEventMutationVariables = Exact<{
  activatingEvent: ActivatingEventCreateInput;
}>;

export type CreateActivatingEventMutation = {
  __typename?: 'Mutation';
  createActivatingEvent?: {
    __typename?: 'ActivatingEventResponse';
    activatingEvent?: {
      __typename?: 'ActivatingEvent';
      _id: string;
      _key: string;
      _rev: string;
      userId: string;
      description: string;
      participantIds?: Array<string> | null;
      imageUrl?: Array<any> | null;
      createdAt: any;
      updatedAt: any;
      feelings: Array<number>;
      bodyPartsFeelings: number;
      behaviors?: string | null;
      location?: {
        __typename?: 'Location';
        _id: string;
        _key: string;
        _rev: string;
        createdAt: any;
        updatedAt: any;
        name: string;
        latitude: number;
        longitude: number;
      } | null;
      interval?: { __typename?: 'Interval'; start: any; end: any } | null;
      emotions: Array<{ __typename?: 'Emotion'; id: number; strength: number }>;
      thoughts?: Array<{
        __typename?: 'Thought';
        _id: string;
        _key: string;
        _rev: string;
        userId: string;
        activatingEventId?: string | null;
        createdAt: any;
        updatedAt: any;
        automaticThought: string;
        thoughtBelief: number;
        thoughtsFor: Array<string>;
        thoughtsForAlternativeThoughts?: Array<string | null> | null;
        thoughtsAgainst: Array<string>;
        cognitiveDistortions?: Array<string> | null;
        cardName?: string | null;
        categoriesIds?: Array<number> | null;
        realisticThoughts: Array<{
          __typename?: 'BasicThought';
          thought: string;
          thoughtBelief: number;
        }>;
        result: {
          __typename?: 'ThoughtTestResult';
          initialThoughtBelief: number;
          initialNegativeEmotionStrenght: number;
        };
        dayReminders?: {
          __typename?: 'DayReminders';
          _id: string;
          _key: string;
          _rev: string;
          thoughtId: string;
          createdAt: any;
          updatedAt: any;
          morning: {
            __typename?: 'TimeReminder';
            enabled: boolean;
            time: {
              __typename?: 'ReminderTime';
              hours: number;
              minutes: number;
            };
          };
          day: {
            __typename?: 'TimeReminder';
            enabled: boolean;
            time: {
              __typename?: 'ReminderTime';
              hours: number;
              minutes: number;
            };
          };
          evening: {
            __typename?: 'TimeReminder';
            enabled: boolean;
            time: {
              __typename?: 'ReminderTime';
              hours: number;
              minutes: number;
            };
          };
        } | null;
        locationReminders?: Array<{
          __typename?: 'LocationReminder';
          _id: string;
          _key: string;
          _rev: string;
          _from: string;
          _to: string;
          createdAt: any;
          updatedAt: any;
          enter?: boolean | null;
          leave?: boolean | null;
          type: number;
        }> | null;
      }> | null;
    } | null;
  } | null;
};

export type UpdateActivatingEventMutationVariables = Exact<{
  activatingEvent: ActivatingEventUpdateInput;
}>;

export type UpdateActivatingEventMutation = {
  __typename?: 'Mutation';
  updateActivatingEvent?: {
    __typename?: 'ActivatingEventResponse';
    activatingEvent?: {
      __typename?: 'ActivatingEvent';
      _id: string;
      _key: string;
      _rev: string;
      userId: string;
      description: string;
      participantIds?: Array<string> | null;
      imageUrl?: Array<any> | null;
      createdAt: any;
      updatedAt: any;
      feelings: Array<number>;
      bodyPartsFeelings: number;
      behaviors?: string | null;
      location?: {
        __typename?: 'Location';
        _id: string;
        _key: string;
        _rev: string;
        createdAt: any;
        updatedAt: any;
        name: string;
        latitude: number;
        longitude: number;
      } | null;
      interval?: { __typename?: 'Interval'; start: any; end: any } | null;
      emotions: Array<{ __typename?: 'Emotion'; id: number; strength: number }>;
      thoughts?: Array<{
        __typename?: 'Thought';
        _id: string;
        _key: string;
        _rev: string;
        userId: string;
        activatingEventId?: string | null;
        createdAt: any;
        updatedAt: any;
        automaticThought: string;
        thoughtBelief: number;
        thoughtsFor: Array<string>;
        thoughtsForAlternativeThoughts?: Array<string | null> | null;
        thoughtsAgainst: Array<string>;
        cognitiveDistortions?: Array<string> | null;
        cardName?: string | null;
        categoriesIds?: Array<number> | null;
        realisticThoughts: Array<{
          __typename?: 'BasicThought';
          thought: string;
          thoughtBelief: number;
        }>;
        result: {
          __typename?: 'ThoughtTestResult';
          initialThoughtBelief: number;
          initialNegativeEmotionStrenght: number;
        };
        dayReminders?: {
          __typename?: 'DayReminders';
          _id: string;
          _key: string;
          _rev: string;
          thoughtId: string;
          createdAt: any;
          updatedAt: any;
          morning: {
            __typename?: 'TimeReminder';
            enabled: boolean;
            time: {
              __typename?: 'ReminderTime';
              hours: number;
              minutes: number;
            };
          };
          day: {
            __typename?: 'TimeReminder';
            enabled: boolean;
            time: {
              __typename?: 'ReminderTime';
              hours: number;
              minutes: number;
            };
          };
          evening: {
            __typename?: 'TimeReminder';
            enabled: boolean;
            time: {
              __typename?: 'ReminderTime';
              hours: number;
              minutes: number;
            };
          };
        } | null;
        locationReminders?: Array<{
          __typename?: 'LocationReminder';
          _id: string;
          _key: string;
          _rev: string;
          _from: string;
          _to: string;
          createdAt: any;
          updatedAt: any;
          enter?: boolean | null;
          leave?: boolean | null;
          type: number;
        }> | null;
      }> | null;
    } | null;
  } | null;
};

export type FeatureAnnouncementFieldsFragment = {
  __typename?: 'FeatureAnnouncement';
  announcementId: string;
  variantId: string;
  title: string;
  summary: string;
  mediaUrl?: string | null;
  articleUrl?: string | null;
  surface: string;
  language: string;
  relatedReleases: Array<string>;
  publishAt: any;
  acknowledgedAt?: any | null;
};

export type PendingFeatureAnnouncementsQueryVariables = Exact<{
  surface: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
}>;

export type PendingFeatureAnnouncementsQuery = {
  __typename?: 'Query';
  pendingFeatureAnnouncements: Array<{
    __typename?: 'FeatureAnnouncement';
    announcementId: string;
    variantId: string;
    title: string;
    summary: string;
    mediaUrl?: string | null;
    articleUrl?: string | null;
    surface: string;
    language: string;
    relatedReleases: Array<string>;
    publishAt: any;
    acknowledgedAt?: any | null;
  }>;
};

export type FeatureAnnouncementHistoryQueryVariables = Exact<{
  surface: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
}>;

export type FeatureAnnouncementHistoryQuery = {
  __typename?: 'Query';
  featureAnnouncementHistory: Array<{
    __typename?: 'FeatureAnnouncement';
    announcementId: string;
    variantId: string;
    title: string;
    summary: string;
    mediaUrl?: string | null;
    articleUrl?: string | null;
    surface: string;
    language: string;
    relatedReleases: Array<string>;
    publishAt: any;
    acknowledgedAt?: any | null;
  }>;
};

export type AcknowledgeFeatureAnnouncementMutationVariables = Exact<{
  announcementId: Scalars['ID'];
  seenAs: Scalars['ID'];
  surface: Scalars['String'];
}>;

export type AcknowledgeFeatureAnnouncementMutation = {
  __typename?: 'Mutation';
  acknowledgeFeatureAnnouncement?: boolean | null;
};

export type AppLockFieldsFragment = {
  __typename?: 'AppLock';
  subject: string;
  deviceId: string;
  enabled: boolean;
  method?: string | null;
  lockAfterMinutes?: number | null;
  exemptions: Array<string>;
  updatedAt?: any | null;
};

export type AppLockQueryVariables = Exact<{
  deviceId: Scalars['ID'];
}>;

export type AppLockQuery = {
  __typename?: 'Query';
  appLock: {
    __typename?: 'AppLock';
    subject: string;
    deviceId: string;
    enabled: boolean;
    method?: string | null;
    lockAfterMinutes?: number | null;
    exemptions: Array<string>;
    updatedAt?: any | null;
  };
};

export type EnableAppLockMutationVariables = Exact<{
  input: EnableAppLockInput;
}>;

export type EnableAppLockMutation = {
  __typename?: 'Mutation';
  enableAppLock: {
    __typename?: 'AppLockCommandPayload';
    deviceId: string;
    recorded: boolean;
  };
};

export type DisableAppLockMutationVariables = Exact<{
  input: DisableAppLockInput;
}>;

export type DisableAppLockMutation = {
  __typename?: 'Mutation';
  disableAppLock: {
    __typename?: 'AppLockCommandPayload';
    deviceId: string;
    recorded: boolean;
  };
};

export type InstrumentDefinitionFieldsFragment = {
  __typename?: 'InstrumentDefinition';
  instrumentId: string;
  name: string;
  nameRu?: string | null;
  itemsCount: number;
  scoringRule: string;
  licenceClass: string;
  availableFor: string;
  languages: Array<string>;
  itemsKey: string;
  citation: string;
  responseScale: {
    __typename?: 'InstrumentScale';
    min: number;
    max: number;
    labels: Array<string>;
  };
  subscales: Array<{
    __typename?: 'InstrumentSubscale';
    name: string;
    items: Array<number>;
    multiplier?: number | null;
    reverseItems?: Array<number> | null;
  }>;
  bands: Array<{
    __typename?: 'InstrumentBandSet';
    subscale?: string | null;
    bands: Array<{
      __typename?: 'InstrumentBand';
      min: number;
      max: number;
      band: string;
    }>;
  }>;
};

export type AssessmentReadingFieldsFragment = {
  __typename?: 'AssessmentSubscaleReading';
  name: string;
  score: number;
  band?: string | null;
  bandKey?: string | null;
};

export type InstrumentCatalogQueryVariables = Exact<{ [key: string]: never }>;

export type InstrumentCatalogQuery = {
  __typename?: 'Query';
  instrumentCatalog: Array<{
    __typename?: 'InstrumentCatalogItem';
    instrumentId: string;
    type: number;
    availability: string;
    assignmentId?: string | null;
    dueAt?: any | null;
    requester?: string | null;
    assignedBy?: string | null;
    lastScore?: number | null;
    lastBand?: string | null;
    lastBandKey?: string | null;
    lastTakenAt?: any | null;
    definition: {
      __typename?: 'InstrumentDefinition';
      instrumentId: string;
      name: string;
      nameRu?: string | null;
      itemsCount: number;
      scoringRule: string;
      licenceClass: string;
      availableFor: string;
      languages: Array<string>;
      itemsKey: string;
      citation: string;
      responseScale: {
        __typename?: 'InstrumentScale';
        min: number;
        max: number;
        labels: Array<string>;
      };
      subscales: Array<{
        __typename?: 'InstrumentSubscale';
        name: string;
        items: Array<number>;
        multiplier?: number | null;
        reverseItems?: Array<number> | null;
      }>;
      bands: Array<{
        __typename?: 'InstrumentBandSet';
        subscale?: string | null;
        bands: Array<{
          __typename?: 'InstrumentBand';
          min: number;
          max: number;
          band: string;
        }>;
      }>;
    };
  }>;
};

export type AssessmentInterpretationQueryVariables = Exact<{
  assessmentId: Scalars['ID'];
}>;

export type AssessmentInterpretationQuery = {
  __typename?: 'Query';
  assessmentInterpretation?: {
    __typename?: 'AssessmentInterpretation';
    assessmentId: string;
    subject: string;
    instrumentId: string;
    type: number;
    occurredAt: any;
    total: number;
    totalBand?: string | null;
    totalBandKey?: string | null;
    band?: string | null;
    bandKey?: string | null;
    bandIsWorstSubscale: boolean;
    previousTotal?: number | null;
    subscales: Array<{
      __typename?: 'AssessmentSubscaleReading';
      name: string;
      score: number;
      band?: string | null;
      bandKey?: string | null;
    }>;
    changeSinceLast?: {
      __typename?: 'AssessmentChange';
      total: number;
      subscales: Array<{
        __typename?: 'AssessmentSubscaleChange';
        name: string;
        change: number;
      }>;
    } | null;
    previousSubscales?: Array<{
      __typename?: 'AssessmentSubscaleReading';
      name: string;
      score: number;
      band?: string | null;
      bandKey?: string | null;
    }> | null;
  } | null;
};

export type ClientAssessmentTrendQueryVariables = Exact<{
  subject: Scalars['ID'];
  instrumentId?: InputMaybe<Scalars['String']>;
}>;

export type ClientAssessmentTrendQuery = {
  __typename?: 'Query';
  clientAssessmentTrend: {
    __typename?: 'ClientAssessmentTrend';
    subject: string;
    instrumentId?: string | null;
    definition?: {
      __typename?: 'InstrumentDefinition';
      instrumentId: string;
      name: string;
      nameRu?: string | null;
      itemsCount: number;
      scoringRule: string;
      licenceClass: string;
      availableFor: string;
      languages: Array<string>;
      itemsKey: string;
      citation: string;
      responseScale: {
        __typename?: 'InstrumentScale';
        min: number;
        max: number;
        labels: Array<string>;
      };
      subscales: Array<{
        __typename?: 'InstrumentSubscale';
        name: string;
        items: Array<number>;
        multiplier?: number | null;
        reverseItems?: Array<number> | null;
      }>;
      bands: Array<{
        __typename?: 'InstrumentBandSet';
        subscale?: string | null;
        bands: Array<{
          __typename?: 'InstrumentBand';
          min: number;
          max: number;
          band: string;
        }>;
      }>;
    } | null;
    rows: Array<{
      __typename?: 'ClientAssessmentTrendRow';
      source: string;
      subject: string;
      practiceId?: string | null;
      instrumentId?: string | null;
      instrumentName: string;
      assessmentId?: string | null;
      externalAssessmentId?: string | null;
      occurredAt: any;
      total: number;
      maxScore?: number | null;
      band?: string | null;
      bandKey?: string | null;
      bandIsWorstSubscale: boolean;
      note?: string | null;
      subscales: Array<{
        __typename?: 'AssessmentSubscaleReading';
        name: string;
        score: number;
        band?: string | null;
        bandKey?: string | null;
      }>;
      changeSinceLast?: {
        __typename?: 'AssessmentChange';
        total: number;
        subscales: Array<{
          __typename?: 'AssessmentSubscaleChange';
          name: string;
          change: number;
        }>;
      } | null;
      item9?: {
        __typename?: 'AssessmentItem9';
        questionKey: string;
        answer?: number | null;
        answerKey?: string | null;
      } | null;
    }>;
  };
};

export type InstrumentDefinitionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type InstrumentDefinitionsQuery = {
  __typename?: 'Query';
  instrumentDefinitions: Array<{
    __typename?: 'InstrumentDefinition';
    instrumentId: string;
    name: string;
    nameRu?: string | null;
    itemsCount: number;
    scoringRule: string;
    licenceClass: string;
    availableFor: string;
    languages: Array<string>;
    itemsKey: string;
    citation: string;
    responseScale: {
      __typename?: 'InstrumentScale';
      min: number;
      max: number;
      labels: Array<string>;
    };
    subscales: Array<{
      __typename?: 'InstrumentSubscale';
      name: string;
      items: Array<number>;
      multiplier?: number | null;
      reverseItems?: Array<number> | null;
    }>;
    bands: Array<{
      __typename?: 'InstrumentBandSet';
      subscale?: string | null;
      bands: Array<{
        __typename?: 'InstrumentBand';
        min: number;
        max: number;
        band: string;
      }>;
    }>;
  }>;
};

export type PublishInstrumentMutationVariables = Exact<{
  input: PublishInstrumentInput;
}>;

export type PublishInstrumentMutation = {
  __typename?: 'Mutation';
  publishInstrument: {
    __typename?: 'AssessmentCommandPayload';
    id: string;
    recorded: boolean;
  };
};

export type RecordExternalAssessmentMutationVariables = Exact<{
  input: RecordExternalAssessmentInput;
}>;

export type RecordExternalAssessmentMutation = {
  __typename?: 'Mutation';
  recordExternalAssessment: {
    __typename?: 'AssessmentCommandPayload';
    id: string;
    recorded: boolean;
  };
};

export type CreateAssessmentInSessionMutationVariables = Exact<{
  input: CreateAssessmentInSessionInput;
}>;

export type CreateAssessmentInSessionMutation = {
  __typename?: 'Mutation';
  createAssessmentInSession: {
    __typename?: 'AssessmentCommandPayload';
    id: string;
    recorded: boolean;
  };
};

export type CreateAuthTokenMutationVariables = Exact<{
  firebaseToken: Scalars['String'];
}>;

export type CreateAuthTokenMutation = {
  __typename?: 'Mutation';
  createAuthToken?: {
    __typename?: 'AuthTokenPayload';
    accessToken: string;
    refreshToken: string;
    accessExpiresAt: any;
    refreshExpiresAt: any;
  } | null;
};

export type RefreshAuthTokenMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;

export type RefreshAuthTokenMutation = {
  __typename?: 'Mutation';
  refreshAuthToken?: {
    __typename?: 'AuthTokenPayload';
    accessToken: string;
    refreshToken: string;
    accessExpiresAt: any;
    refreshExpiresAt: any;
  } | null;
};

export type RevokeAuthTokensMutationVariables = Exact<{ [key: string]: never }>;

export type RevokeAuthTokensMutation = {
  __typename?: 'Mutation';
  revokeAuthTokens?: boolean | null;
};

export type AppMinVersionQueryVariables = Exact<{ [key: string]: never }>;

export type AppMinVersionQuery = {
  __typename?: 'Query';
  appMinVersion?: {
    __typename?: 'AppMinVersion';
    minSupportedVersion?: string | null;
    minSupportedVersionIos?: string | null;
    minSupportedVersionAndroid?: string | null;
  } | null;
};

export type DeferSignOutMutationVariables = Exact<{
  authSessionId: Scalars['ID'];
  platform: Scalars['String'];
  deferredUntil: Scalars['DateTime'];
}>;

export type DeferSignOutMutation = {
  __typename?: 'Mutation';
  deferSignOut?: boolean | null;
};

export type BehaviorExperimentDataFragment = {
  __typename?: 'BehaviorExperiment';
  userId: string;
  therapistId?: string | null;
  createdAt: any;
  updatedAt: any;
  purpose: number;
  design: number;
  hypothesisType: number;
  type: number;
  activeSubtype?: number | null;
  observationalSubtype?: number | null;
  hypothesisA?: string | null;
  hypothesisAStrength?: number | null;
  hypothesisAConfirmationCriteria?: string | null;
  hypothesisB?: string | null;
  hypothesisBStrength?: number | null;
  hypothesisBConfirmationCriteria?: string | null;
  safetyBehaviors?: string | null;
  helpfulCopingStrategies?: string | null;
  followUpExperimentsIdeas?: string | null;
  settings: {
    __typename?: 'BehaviorExperimentSettings';
    experiment?: string | null;
    time?: string | null;
    place?: string | null;
    people?: string | null;
    resources?: string | null;
    survey?: string | null;
  };
  prediction: {
    __typename?: 'BehaviorExperimentPrediction';
    feelings: Array<number | null>;
    behaviors?: string | null;
    otherPredictions?: string | null;
    emotions: Array<{
      __typename?: 'Emotion';
      id: number;
      strength: number;
    } | null>;
  };
  outcome: {
    __typename?: 'BehaviorExperimentOutcome';
    feelings: Array<number | null>;
    behaviors?: string | null;
    otherPredictions?: string | null;
    patientReflections?: string | null;
    therapistReflections?: string | null;
    newLearnings?: string | null;
    meaningForOriginalBelief?: string | null;
    oldThoughtStrength?: number | null;
    newThought?: string | null;
    newThoughtStrength?: number | null;
    emotions: Array<{
      __typename?: 'Emotion';
      id: number;
      strength: number;
    } | null>;
  };
};

export type BehaviorExperimentsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['JSON']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type BehaviorExperimentsQuery = {
  __typename?: 'Query';
  behaviorExperiments?: {
    __typename?: 'BehaviorExperimentSearch';
    count: number;
    data?: Array<{
      __typename?: 'BehaviorExperiment';
      _id: string;
      userId: string;
      therapistId?: string | null;
      createdAt: any;
      updatedAt: any;
      purpose: number;
      design: number;
      hypothesisType: number;
      type: number;
      activeSubtype?: number | null;
      observationalSubtype?: number | null;
      hypothesisA?: string | null;
      hypothesisAStrength?: number | null;
      hypothesisAConfirmationCriteria?: string | null;
      hypothesisB?: string | null;
      hypothesisBStrength?: number | null;
      hypothesisBConfirmationCriteria?: string | null;
      safetyBehaviors?: string | null;
      helpfulCopingStrategies?: string | null;
      followUpExperimentsIdeas?: string | null;
      settings: {
        __typename?: 'BehaviorExperimentSettings';
        experiment?: string | null;
        time?: string | null;
        place?: string | null;
        people?: string | null;
        resources?: string | null;
        survey?: string | null;
      };
      prediction: {
        __typename?: 'BehaviorExperimentPrediction';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
      outcome: {
        __typename?: 'BehaviorExperimentOutcome';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        patientReflections?: string | null;
        therapistReflections?: string | null;
        newLearnings?: string | null;
        meaningForOriginalBelief?: string | null;
        oldThoughtStrength?: number | null;
        newThought?: string | null;
        newThoughtStrength?: number | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
    } | null> | null;
  } | null;
};

export type BehaviorExperimentQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']>;
}>;

export type BehaviorExperimentQuery = {
  __typename?: 'Query';
  behaviorExperiment?: {
    __typename?: 'BehaviorExperiment';
    _id: string;
    userId: string;
    therapistId?: string | null;
    createdAt: any;
    updatedAt: any;
    purpose: number;
    design: number;
    hypothesisType: number;
    type: number;
    activeSubtype?: number | null;
    observationalSubtype?: number | null;
    hypothesisA?: string | null;
    hypothesisAStrength?: number | null;
    hypothesisAConfirmationCriteria?: string | null;
    hypothesisB?: string | null;
    hypothesisBStrength?: number | null;
    hypothesisBConfirmationCriteria?: string | null;
    safetyBehaviors?: string | null;
    helpfulCopingStrategies?: string | null;
    followUpExperimentsIdeas?: string | null;
    settings: {
      __typename?: 'BehaviorExperimentSettings';
      experiment?: string | null;
      time?: string | null;
      place?: string | null;
      people?: string | null;
      resources?: string | null;
      survey?: string | null;
    };
    prediction: {
      __typename?: 'BehaviorExperimentPrediction';
      feelings: Array<number | null>;
      behaviors?: string | null;
      otherPredictions?: string | null;
      emotions: Array<{
        __typename?: 'Emotion';
        id: number;
        strength: number;
      } | null>;
    };
    outcome: {
      __typename?: 'BehaviorExperimentOutcome';
      feelings: Array<number | null>;
      behaviors?: string | null;
      otherPredictions?: string | null;
      patientReflections?: string | null;
      therapistReflections?: string | null;
      newLearnings?: string | null;
      meaningForOriginalBelief?: string | null;
      oldThoughtStrength?: number | null;
      newThought?: string | null;
      newThoughtStrength?: number | null;
      emotions: Array<{
        __typename?: 'Emotion';
        id: number;
        strength: number;
      } | null>;
    };
  } | null;
};

export type UpsertBehaviorExperimentMutationVariables = Exact<{
  input?: InputMaybe<BehaviorExperimentInput>;
}>;

export type UpsertBehaviorExperimentMutation = {
  __typename?: 'Mutation';
  upsertBehaviorExperiment?: {
    __typename?: 'BehaviorExperiment';
    _id: string;
    userId: string;
    therapistId?: string | null;
    createdAt: any;
    updatedAt: any;
    purpose: number;
    design: number;
    hypothesisType: number;
    type: number;
    activeSubtype?: number | null;
    observationalSubtype?: number | null;
    hypothesisA?: string | null;
    hypothesisAStrength?: number | null;
    hypothesisAConfirmationCriteria?: string | null;
    hypothesisB?: string | null;
    hypothesisBStrength?: number | null;
    hypothesisBConfirmationCriteria?: string | null;
    safetyBehaviors?: string | null;
    helpfulCopingStrategies?: string | null;
    followUpExperimentsIdeas?: string | null;
    settings: {
      __typename?: 'BehaviorExperimentSettings';
      experiment?: string | null;
      time?: string | null;
      place?: string | null;
      people?: string | null;
      resources?: string | null;
      survey?: string | null;
    };
    prediction: {
      __typename?: 'BehaviorExperimentPrediction';
      feelings: Array<number | null>;
      behaviors?: string | null;
      otherPredictions?: string | null;
      emotions: Array<{
        __typename?: 'Emotion';
        id: number;
        strength: number;
      } | null>;
    };
    outcome: {
      __typename?: 'BehaviorExperimentOutcome';
      feelings: Array<number | null>;
      behaviors?: string | null;
      otherPredictions?: string | null;
      patientReflections?: string | null;
      therapistReflections?: string | null;
      newLearnings?: string | null;
      meaningForOriginalBelief?: string | null;
      oldThoughtStrength?: number | null;
      newThought?: string | null;
      newThoughtStrength?: number | null;
      emotions: Array<{
        __typename?: 'Emotion';
        id: number;
        strength: number;
      } | null>;
    };
  } | null;
};

export type BehaviorExperimentEsDataFragment = {
  __typename?: 'BehaviorExperiment';
  _id: string;
  experimentId?: string | null;
  status?: string | null;
  activatedAt?: any | null;
  completedAt?: any | null;
  userId: string;
  therapistId?: string | null;
  createdAt: any;
  updatedAt: any;
  purpose: number;
  design: number;
  hypothesisType: number;
  type: number;
  activeSubtype?: number | null;
  observationalSubtype?: number | null;
  hypothesisA?: string | null;
  hypothesisAStrength?: number | null;
  hypothesisAConfirmationCriteria?: string | null;
  hypothesisB?: string | null;
  hypothesisBStrength?: number | null;
  hypothesisBConfirmationCriteria?: string | null;
  safetyBehaviors?: string | null;
  helpfulCopingStrategies?: string | null;
  followUpExperimentsIdeas?: string | null;
  observations?: Array<{
    __typename?: 'BehaviorExperimentObservation';
    observationId: string;
    occurredAt: any;
    whatHappened?: string | null;
    feelings: Array<number>;
    behaviors?: string | null;
    whichHypothesisHeld?: number | null;
    rating?: number | null;
    learnings?: string | null;
    emotions: Array<{ __typename?: 'Emotion'; id: number; strength: number }>;
  }> | null;
  settings: {
    __typename?: 'BehaviorExperimentSettings';
    experiment?: string | null;
    time?: string | null;
    place?: string | null;
    people?: string | null;
    resources?: string | null;
    survey?: string | null;
  };
  prediction: {
    __typename?: 'BehaviorExperimentPrediction';
    feelings: Array<number | null>;
    behaviors?: string | null;
    otherPredictions?: string | null;
    emotions: Array<{
      __typename?: 'Emotion';
      id: number;
      strength: number;
    } | null>;
  };
  outcome: {
    __typename?: 'BehaviorExperimentOutcome';
    feelings: Array<number | null>;
    behaviors?: string | null;
    otherPredictions?: string | null;
    patientReflections?: string | null;
    therapistReflections?: string | null;
    newLearnings?: string | null;
    meaningForOriginalBelief?: string | null;
    oldThoughtStrength?: number | null;
    newThought?: string | null;
    newThoughtStrength?: number | null;
    emotions: Array<{
      __typename?: 'Emotion';
      id: number;
      strength: number;
    } | null>;
  };
};

export type StartBehaviorExperimentMutationVariables = Exact<{
  input: StartBehaviorExperimentInput;
}>;

export type StartBehaviorExperimentMutation = {
  __typename?: 'Mutation';
  startBehaviorExperiment?: {
    __typename?: 'BehaviorExperimentPayload';
    experimentId: string;
    behaviorExperiment?: {
      __typename?: 'BehaviorExperiment';
      _id: string;
      experimentId?: string | null;
      status?: string | null;
      activatedAt?: any | null;
      completedAt?: any | null;
      userId: string;
      therapistId?: string | null;
      createdAt: any;
      updatedAt: any;
      purpose: number;
      design: number;
      hypothesisType: number;
      type: number;
      activeSubtype?: number | null;
      observationalSubtype?: number | null;
      hypothesisA?: string | null;
      hypothesisAStrength?: number | null;
      hypothesisAConfirmationCriteria?: string | null;
      hypothesisB?: string | null;
      hypothesisBStrength?: number | null;
      hypothesisBConfirmationCriteria?: string | null;
      safetyBehaviors?: string | null;
      helpfulCopingStrategies?: string | null;
      followUpExperimentsIdeas?: string | null;
      observations?: Array<{
        __typename?: 'BehaviorExperimentObservation';
        observationId: string;
        occurredAt: any;
        whatHappened?: string | null;
        feelings: Array<number>;
        behaviors?: string | null;
        whichHypothesisHeld?: number | null;
        rating?: number | null;
        learnings?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        }>;
      }> | null;
      settings: {
        __typename?: 'BehaviorExperimentSettings';
        experiment?: string | null;
        time?: string | null;
        place?: string | null;
        people?: string | null;
        resources?: string | null;
        survey?: string | null;
      };
      prediction: {
        __typename?: 'BehaviorExperimentPrediction';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
      outcome: {
        __typename?: 'BehaviorExperimentOutcome';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        patientReflections?: string | null;
        therapistReflections?: string | null;
        newLearnings?: string | null;
        meaningForOriginalBelief?: string | null;
        oldThoughtStrength?: number | null;
        newThought?: string | null;
        newThoughtStrength?: number | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
    } | null;
  } | null;
};

export type StateHypothesesMutationVariables = Exact<{
  input: StateHypothesesInput;
}>;

export type StateHypothesesMutation = {
  __typename?: 'Mutation';
  stateHypotheses?: {
    __typename?: 'BehaviorExperimentPayload';
    experimentId: string;
    behaviorExperiment?: {
      __typename?: 'BehaviorExperiment';
      _id: string;
      experimentId?: string | null;
      status?: string | null;
      activatedAt?: any | null;
      completedAt?: any | null;
      userId: string;
      therapistId?: string | null;
      createdAt: any;
      updatedAt: any;
      purpose: number;
      design: number;
      hypothesisType: number;
      type: number;
      activeSubtype?: number | null;
      observationalSubtype?: number | null;
      hypothesisA?: string | null;
      hypothesisAStrength?: number | null;
      hypothesisAConfirmationCriteria?: string | null;
      hypothesisB?: string | null;
      hypothesisBStrength?: number | null;
      hypothesisBConfirmationCriteria?: string | null;
      safetyBehaviors?: string | null;
      helpfulCopingStrategies?: string | null;
      followUpExperimentsIdeas?: string | null;
      observations?: Array<{
        __typename?: 'BehaviorExperimentObservation';
        observationId: string;
        occurredAt: any;
        whatHappened?: string | null;
        feelings: Array<number>;
        behaviors?: string | null;
        whichHypothesisHeld?: number | null;
        rating?: number | null;
        learnings?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        }>;
      }> | null;
      settings: {
        __typename?: 'BehaviorExperimentSettings';
        experiment?: string | null;
        time?: string | null;
        place?: string | null;
        people?: string | null;
        resources?: string | null;
        survey?: string | null;
      };
      prediction: {
        __typename?: 'BehaviorExperimentPrediction';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
      outcome: {
        __typename?: 'BehaviorExperimentOutcome';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        patientReflections?: string | null;
        therapistReflections?: string | null;
        newLearnings?: string | null;
        meaningForOriginalBelief?: string | null;
        oldThoughtStrength?: number | null;
        newThought?: string | null;
        newThoughtStrength?: number | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
    } | null;
  } | null;
};

export type PlanExperimentMutationVariables = Exact<{
  input: PlanExperimentInput;
}>;

export type PlanExperimentMutation = {
  __typename?: 'Mutation';
  planExperiment?: {
    __typename?: 'BehaviorExperimentPayload';
    experimentId: string;
    behaviorExperiment?: {
      __typename?: 'BehaviorExperiment';
      _id: string;
      experimentId?: string | null;
      status?: string | null;
      activatedAt?: any | null;
      completedAt?: any | null;
      userId: string;
      therapistId?: string | null;
      createdAt: any;
      updatedAt: any;
      purpose: number;
      design: number;
      hypothesisType: number;
      type: number;
      activeSubtype?: number | null;
      observationalSubtype?: number | null;
      hypothesisA?: string | null;
      hypothesisAStrength?: number | null;
      hypothesisAConfirmationCriteria?: string | null;
      hypothesisB?: string | null;
      hypothesisBStrength?: number | null;
      hypothesisBConfirmationCriteria?: string | null;
      safetyBehaviors?: string | null;
      helpfulCopingStrategies?: string | null;
      followUpExperimentsIdeas?: string | null;
      observations?: Array<{
        __typename?: 'BehaviorExperimentObservation';
        observationId: string;
        occurredAt: any;
        whatHappened?: string | null;
        feelings: Array<number>;
        behaviors?: string | null;
        whichHypothesisHeld?: number | null;
        rating?: number | null;
        learnings?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        }>;
      }> | null;
      settings: {
        __typename?: 'BehaviorExperimentSettings';
        experiment?: string | null;
        time?: string | null;
        place?: string | null;
        people?: string | null;
        resources?: string | null;
        survey?: string | null;
      };
      prediction: {
        __typename?: 'BehaviorExperimentPrediction';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
      outcome: {
        __typename?: 'BehaviorExperimentOutcome';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        patientReflections?: string | null;
        therapistReflections?: string | null;
        newLearnings?: string | null;
        meaningForOriginalBelief?: string | null;
        oldThoughtStrength?: number | null;
        newThought?: string | null;
        newThoughtStrength?: number | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
    } | null;
  } | null;
};

export type PredictOutcomeMutationVariables = Exact<{
  input: PredictOutcomeInput;
}>;

export type PredictOutcomeMutation = {
  __typename?: 'Mutation';
  predictOutcome?: {
    __typename?: 'BehaviorExperimentPayload';
    experimentId: string;
    behaviorExperiment?: {
      __typename?: 'BehaviorExperiment';
      _id: string;
      experimentId?: string | null;
      status?: string | null;
      activatedAt?: any | null;
      completedAt?: any | null;
      userId: string;
      therapistId?: string | null;
      createdAt: any;
      updatedAt: any;
      purpose: number;
      design: number;
      hypothesisType: number;
      type: number;
      activeSubtype?: number | null;
      observationalSubtype?: number | null;
      hypothesisA?: string | null;
      hypothesisAStrength?: number | null;
      hypothesisAConfirmationCriteria?: string | null;
      hypothesisB?: string | null;
      hypothesisBStrength?: number | null;
      hypothesisBConfirmationCriteria?: string | null;
      safetyBehaviors?: string | null;
      helpfulCopingStrategies?: string | null;
      followUpExperimentsIdeas?: string | null;
      observations?: Array<{
        __typename?: 'BehaviorExperimentObservation';
        observationId: string;
        occurredAt: any;
        whatHappened?: string | null;
        feelings: Array<number>;
        behaviors?: string | null;
        whichHypothesisHeld?: number | null;
        rating?: number | null;
        learnings?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        }>;
      }> | null;
      settings: {
        __typename?: 'BehaviorExperimentSettings';
        experiment?: string | null;
        time?: string | null;
        place?: string | null;
        people?: string | null;
        resources?: string | null;
        survey?: string | null;
      };
      prediction: {
        __typename?: 'BehaviorExperimentPrediction';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
      outcome: {
        __typename?: 'BehaviorExperimentOutcome';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        patientReflections?: string | null;
        therapistReflections?: string | null;
        newLearnings?: string | null;
        meaningForOriginalBelief?: string | null;
        oldThoughtStrength?: number | null;
        newThought?: string | null;
        newThoughtStrength?: number | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
    } | null;
  } | null;
};

export type ActivateExperimentMutationVariables = Exact<{
  input: ActivateExperimentInput;
}>;

export type ActivateExperimentMutation = {
  __typename?: 'Mutation';
  activateExperiment?: {
    __typename?: 'BehaviorExperimentPayload';
    experimentId: string;
    behaviorExperiment?: {
      __typename?: 'BehaviorExperiment';
      _id: string;
      experimentId?: string | null;
      status?: string | null;
      activatedAt?: any | null;
      completedAt?: any | null;
      userId: string;
      therapistId?: string | null;
      createdAt: any;
      updatedAt: any;
      purpose: number;
      design: number;
      hypothesisType: number;
      type: number;
      activeSubtype?: number | null;
      observationalSubtype?: number | null;
      hypothesisA?: string | null;
      hypothesisAStrength?: number | null;
      hypothesisAConfirmationCriteria?: string | null;
      hypothesisB?: string | null;
      hypothesisBStrength?: number | null;
      hypothesisBConfirmationCriteria?: string | null;
      safetyBehaviors?: string | null;
      helpfulCopingStrategies?: string | null;
      followUpExperimentsIdeas?: string | null;
      observations?: Array<{
        __typename?: 'BehaviorExperimentObservation';
        observationId: string;
        occurredAt: any;
        whatHappened?: string | null;
        feelings: Array<number>;
        behaviors?: string | null;
        whichHypothesisHeld?: number | null;
        rating?: number | null;
        learnings?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        }>;
      }> | null;
      settings: {
        __typename?: 'BehaviorExperimentSettings';
        experiment?: string | null;
        time?: string | null;
        place?: string | null;
        people?: string | null;
        resources?: string | null;
        survey?: string | null;
      };
      prediction: {
        __typename?: 'BehaviorExperimentPrediction';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
      outcome: {
        __typename?: 'BehaviorExperimentOutcome';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        patientReflections?: string | null;
        therapistReflections?: string | null;
        newLearnings?: string | null;
        meaningForOriginalBelief?: string | null;
        oldThoughtStrength?: number | null;
        newThought?: string | null;
        newThoughtStrength?: number | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
    } | null;
  } | null;
};

export type RecordObservationMutationVariables = Exact<{
  input: RecordObservationInput;
}>;

export type RecordObservationMutation = {
  __typename?: 'Mutation';
  recordObservation?: {
    __typename?: 'RecordObservationPayload';
    experimentId: string;
    observationId: string;
    behaviorExperiment?: {
      __typename?: 'BehaviorExperiment';
      _id: string;
      experimentId?: string | null;
      status?: string | null;
      activatedAt?: any | null;
      completedAt?: any | null;
      userId: string;
      therapistId?: string | null;
      createdAt: any;
      updatedAt: any;
      purpose: number;
      design: number;
      hypothesisType: number;
      type: number;
      activeSubtype?: number | null;
      observationalSubtype?: number | null;
      hypothesisA?: string | null;
      hypothesisAStrength?: number | null;
      hypothesisAConfirmationCriteria?: string | null;
      hypothesisB?: string | null;
      hypothesisBStrength?: number | null;
      hypothesisBConfirmationCriteria?: string | null;
      safetyBehaviors?: string | null;
      helpfulCopingStrategies?: string | null;
      followUpExperimentsIdeas?: string | null;
      observations?: Array<{
        __typename?: 'BehaviorExperimentObservation';
        observationId: string;
        occurredAt: any;
        whatHappened?: string | null;
        feelings: Array<number>;
        behaviors?: string | null;
        whichHypothesisHeld?: number | null;
        rating?: number | null;
        learnings?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        }>;
      }> | null;
      settings: {
        __typename?: 'BehaviorExperimentSettings';
        experiment?: string | null;
        time?: string | null;
        place?: string | null;
        people?: string | null;
        resources?: string | null;
        survey?: string | null;
      };
      prediction: {
        __typename?: 'BehaviorExperimentPrediction';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
      outcome: {
        __typename?: 'BehaviorExperimentOutcome';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        patientReflections?: string | null;
        therapistReflections?: string | null;
        newLearnings?: string | null;
        meaningForOriginalBelief?: string | null;
        oldThoughtStrength?: number | null;
        newThought?: string | null;
        newThoughtStrength?: number | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
    } | null;
  } | null;
};

export type UpdateObservationMutationVariables = Exact<{
  input: UpdateObservationInput;
}>;

export type UpdateObservationMutation = {
  __typename?: 'Mutation';
  updateObservation?: {
    __typename?: 'RecordObservationPayload';
    experimentId: string;
    observationId: string;
    behaviorExperiment?: {
      __typename?: 'BehaviorExperiment';
      _id: string;
      experimentId?: string | null;
      status?: string | null;
      activatedAt?: any | null;
      completedAt?: any | null;
      userId: string;
      therapistId?: string | null;
      createdAt: any;
      updatedAt: any;
      purpose: number;
      design: number;
      hypothesisType: number;
      type: number;
      activeSubtype?: number | null;
      observationalSubtype?: number | null;
      hypothesisA?: string | null;
      hypothesisAStrength?: number | null;
      hypothesisAConfirmationCriteria?: string | null;
      hypothesisB?: string | null;
      hypothesisBStrength?: number | null;
      hypothesisBConfirmationCriteria?: string | null;
      safetyBehaviors?: string | null;
      helpfulCopingStrategies?: string | null;
      followUpExperimentsIdeas?: string | null;
      observations?: Array<{
        __typename?: 'BehaviorExperimentObservation';
        observationId: string;
        occurredAt: any;
        whatHappened?: string | null;
        feelings: Array<number>;
        behaviors?: string | null;
        whichHypothesisHeld?: number | null;
        rating?: number | null;
        learnings?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        }>;
      }> | null;
      settings: {
        __typename?: 'BehaviorExperimentSettings';
        experiment?: string | null;
        time?: string | null;
        place?: string | null;
        people?: string | null;
        resources?: string | null;
        survey?: string | null;
      };
      prediction: {
        __typename?: 'BehaviorExperimentPrediction';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
      outcome: {
        __typename?: 'BehaviorExperimentOutcome';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        patientReflections?: string | null;
        therapistReflections?: string | null;
        newLearnings?: string | null;
        meaningForOriginalBelief?: string | null;
        oldThoughtStrength?: number | null;
        newThought?: string | null;
        newThoughtStrength?: number | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
    } | null;
  } | null;
};

export type CompleteExperimentMutationVariables = Exact<{
  input: CompleteExperimentInput;
}>;

export type CompleteExperimentMutation = {
  __typename?: 'Mutation';
  completeExperiment?: {
    __typename?: 'BehaviorExperimentPayload';
    experimentId: string;
    behaviorExperiment?: {
      __typename?: 'BehaviorExperiment';
      _id: string;
      experimentId?: string | null;
      status?: string | null;
      activatedAt?: any | null;
      completedAt?: any | null;
      userId: string;
      therapistId?: string | null;
      createdAt: any;
      updatedAt: any;
      purpose: number;
      design: number;
      hypothesisType: number;
      type: number;
      activeSubtype?: number | null;
      observationalSubtype?: number | null;
      hypothesisA?: string | null;
      hypothesisAStrength?: number | null;
      hypothesisAConfirmationCriteria?: string | null;
      hypothesisB?: string | null;
      hypothesisBStrength?: number | null;
      hypothesisBConfirmationCriteria?: string | null;
      safetyBehaviors?: string | null;
      helpfulCopingStrategies?: string | null;
      followUpExperimentsIdeas?: string | null;
      observations?: Array<{
        __typename?: 'BehaviorExperimentObservation';
        observationId: string;
        occurredAt: any;
        whatHappened?: string | null;
        feelings: Array<number>;
        behaviors?: string | null;
        whichHypothesisHeld?: number | null;
        rating?: number | null;
        learnings?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        }>;
      }> | null;
      settings: {
        __typename?: 'BehaviorExperimentSettings';
        experiment?: string | null;
        time?: string | null;
        place?: string | null;
        people?: string | null;
        resources?: string | null;
        survey?: string | null;
      };
      prediction: {
        __typename?: 'BehaviorExperimentPrediction';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
      outcome: {
        __typename?: 'BehaviorExperimentOutcome';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        patientReflections?: string | null;
        therapistReflections?: string | null;
        newLearnings?: string | null;
        meaningForOriginalBelief?: string | null;
        oldThoughtStrength?: number | null;
        newThought?: string | null;
        newThoughtStrength?: number | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
    } | null;
  } | null;
};

export type DesignBehaviorExperimentMutationVariables = Exact<{
  input: DesignBehaviorExperimentInput;
}>;

export type DesignBehaviorExperimentMutation = {
  __typename?: 'Mutation';
  designBehaviorExperiment?: {
    __typename?: 'BehaviorExperimentPayload';
    experimentId: string;
    behaviorExperiment?: {
      __typename?: 'BehaviorExperiment';
      _id: string;
      experimentId?: string | null;
      status?: string | null;
      activatedAt?: any | null;
      completedAt?: any | null;
      userId: string;
      therapistId?: string | null;
      createdAt: any;
      updatedAt: any;
      purpose: number;
      design: number;
      hypothesisType: number;
      type: number;
      activeSubtype?: number | null;
      observationalSubtype?: number | null;
      hypothesisA?: string | null;
      hypothesisAStrength?: number | null;
      hypothesisAConfirmationCriteria?: string | null;
      hypothesisB?: string | null;
      hypothesisBStrength?: number | null;
      hypothesisBConfirmationCriteria?: string | null;
      safetyBehaviors?: string | null;
      helpfulCopingStrategies?: string | null;
      followUpExperimentsIdeas?: string | null;
      observations?: Array<{
        __typename?: 'BehaviorExperimentObservation';
        observationId: string;
        occurredAt: any;
        whatHappened?: string | null;
        feelings: Array<number>;
        behaviors?: string | null;
        whichHypothesisHeld?: number | null;
        rating?: number | null;
        learnings?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        }>;
      }> | null;
      settings: {
        __typename?: 'BehaviorExperimentSettings';
        experiment?: string | null;
        time?: string | null;
        place?: string | null;
        people?: string | null;
        resources?: string | null;
        survey?: string | null;
      };
      prediction: {
        __typename?: 'BehaviorExperimentPrediction';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
      outcome: {
        __typename?: 'BehaviorExperimentOutcome';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        patientReflections?: string | null;
        therapistReflections?: string | null;
        newLearnings?: string | null;
        meaningForOriginalBelief?: string | null;
        oldThoughtStrength?: number | null;
        newThought?: string | null;
        newThoughtStrength?: number | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
    } | null;
  } | null;
};

export type RequestBehaviorExperimentSuggestionsMutationVariables = Exact<{
  input: RequestBehaviorExperimentSuggestionsInput;
}>;

export type RequestBehaviorExperimentSuggestionsMutation = {
  __typename?: 'Mutation';
  requestBehaviorExperimentSuggestions?: {
    __typename?: 'BehaviorExperimentSuggestionsPayload';
    requestId: string;
    suggestions?: {
      __typename?: 'BehaviorExperimentSuggestions';
      purpose?: number | null;
      design?: number | null;
      hypothesisType?: number | null;
      type?: number | null;
      activeSubtype?: number | null;
      observationalSubtype?: number | null;
      hypothesisA?: string | null;
      hypothesisAStrength?: number | null;
      hypothesisAConfirmationCriteria?: string | null;
      hypothesisB?: string | null;
      hypothesisBStrength?: number | null;
      hypothesisBConfirmationCriteria?: string | null;
      safetyBehaviors?: string | null;
      helpfulCopingStrategies?: string | null;
      followUpExperimentsIdeas?: string | null;
      settings?: {
        __typename?: 'BehaviorExperimentSettings';
        experiment?: string | null;
        time?: string | null;
        place?: string | null;
        people?: string | null;
        resources?: string | null;
        survey?: string | null;
      } | null;
      prediction?: {
        __typename?: 'BehaviorExperimentPrediction';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type BehaviorExperimentEsQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']>;
}>;

export type BehaviorExperimentEsQuery = {
  __typename?: 'Query';
  behaviorExperiment?: {
    __typename?: 'BehaviorExperiment';
    _id: string;
    experimentId?: string | null;
    status?: string | null;
    activatedAt?: any | null;
    completedAt?: any | null;
    userId: string;
    therapistId?: string | null;
    createdAt: any;
    updatedAt: any;
    purpose: number;
    design: number;
    hypothesisType: number;
    type: number;
    activeSubtype?: number | null;
    observationalSubtype?: number | null;
    hypothesisA?: string | null;
    hypothesisAStrength?: number | null;
    hypothesisAConfirmationCriteria?: string | null;
    hypothesisB?: string | null;
    hypothesisBStrength?: number | null;
    hypothesisBConfirmationCriteria?: string | null;
    safetyBehaviors?: string | null;
    helpfulCopingStrategies?: string | null;
    followUpExperimentsIdeas?: string | null;
    observations?: Array<{
      __typename?: 'BehaviorExperimentObservation';
      observationId: string;
      occurredAt: any;
      whatHappened?: string | null;
      feelings: Array<number>;
      behaviors?: string | null;
      whichHypothesisHeld?: number | null;
      rating?: number | null;
      learnings?: string | null;
      emotions: Array<{ __typename?: 'Emotion'; id: number; strength: number }>;
    }> | null;
    settings: {
      __typename?: 'BehaviorExperimentSettings';
      experiment?: string | null;
      time?: string | null;
      place?: string | null;
      people?: string | null;
      resources?: string | null;
      survey?: string | null;
    };
    prediction: {
      __typename?: 'BehaviorExperimentPrediction';
      feelings: Array<number | null>;
      behaviors?: string | null;
      otherPredictions?: string | null;
      emotions: Array<{
        __typename?: 'Emotion';
        id: number;
        strength: number;
      } | null>;
    };
    outcome: {
      __typename?: 'BehaviorExperimentOutcome';
      feelings: Array<number | null>;
      behaviors?: string | null;
      otherPredictions?: string | null;
      patientReflections?: string | null;
      therapistReflections?: string | null;
      newLearnings?: string | null;
      meaningForOriginalBelief?: string | null;
      oldThoughtStrength?: number | null;
      newThought?: string | null;
      newThoughtStrength?: number | null;
      emotions: Array<{
        __typename?: 'Emotion';
        id: number;
        strength: number;
      } | null>;
    };
  } | null;
};

export type BehaviorExperimentsEsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['JSON']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type BehaviorExperimentsEsQuery = {
  __typename?: 'Query';
  behaviorExperiments?: {
    __typename?: 'BehaviorExperimentSearch';
    count: number;
    data?: Array<{
      __typename?: 'BehaviorExperiment';
      _id: string;
      experimentId?: string | null;
      status?: string | null;
      activatedAt?: any | null;
      completedAt?: any | null;
      userId: string;
      therapistId?: string | null;
      createdAt: any;
      updatedAt: any;
      purpose: number;
      design: number;
      hypothesisType: number;
      type: number;
      activeSubtype?: number | null;
      observationalSubtype?: number | null;
      hypothesisA?: string | null;
      hypothesisAStrength?: number | null;
      hypothesisAConfirmationCriteria?: string | null;
      hypothesisB?: string | null;
      hypothesisBStrength?: number | null;
      hypothesisBConfirmationCriteria?: string | null;
      safetyBehaviors?: string | null;
      helpfulCopingStrategies?: string | null;
      followUpExperimentsIdeas?: string | null;
      observations?: Array<{
        __typename?: 'BehaviorExperimentObservation';
        observationId: string;
        occurredAt: any;
        whatHappened?: string | null;
        feelings: Array<number>;
        behaviors?: string | null;
        whichHypothesisHeld?: number | null;
        rating?: number | null;
        learnings?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        }>;
      }> | null;
      settings: {
        __typename?: 'BehaviorExperimentSettings';
        experiment?: string | null;
        time?: string | null;
        place?: string | null;
        people?: string | null;
        resources?: string | null;
        survey?: string | null;
      };
      prediction: {
        __typename?: 'BehaviorExperimentPrediction';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
      outcome: {
        __typename?: 'BehaviorExperimentOutcome';
        feelings: Array<number | null>;
        behaviors?: string | null;
        otherPredictions?: string | null;
        patientReflections?: string | null;
        therapistReflections?: string | null;
        newLearnings?: string | null;
        meaningForOriginalBelief?: string | null;
        oldThoughtStrength?: number | null;
        newThought?: string | null;
        newThoughtStrength?: number | null;
        emotions: Array<{
          __typename?: 'Emotion';
          id: number;
          strength: number;
        } | null>;
      };
    } | null> | null;
  } | null;
};

export type BaCommandFieldsFragment = {
  __typename?: 'BaCommandPayload';
  id: string;
  recorded: boolean;
  assignmentId?: string | null;
};

export type PlanItemFieldsFragment = {
  __typename?: 'PlanItem';
  plannedActivityId: string;
  title: string;
  valueActivityId?: string | null;
  plannedFor: any;
  durationMinutes?: number | null;
  predictedEnjoyment: number;
  predictedImportance: number;
  certainty?: number | null;
  replanOf?: string | null;
  assignmentId: string;
  plannedBy?: string | null;
  status: string;
  enjoyment?: number | null;
  importance?: number | null;
  note?: string | null;
  barrier?: string | null;
};

export type ActivityWeekFieldsFragment = {
  __typename?: 'ActivityWeek';
  subject: string;
  week: string;
  planned: number;
  done: number;
  missed: number;
  emptyAreas: Array<string>;
  topBarrier?: string | null;
  predictedVsActual: {
    __typename?: 'PredictedVsActual';
    enjoyment: {
      __typename?: 'PredictedActual';
      predicted?: number | null;
      actual?: number | null;
    };
    importance: {
      __typename?: 'PredictedActual';
      predicted?: number | null;
      actual?: number | null;
    };
  };
  byLifeArea: Array<{ __typename?: 'AreaHours'; area: string; hours: number }>;
  moodByDay: Array<{
    __typename?: 'MoodByDay';
    date: string;
    mood?: number | null;
    activitiesDone: number;
  }>;
  healthActivity?: {
    __typename?: 'HealthActivityWeek';
    activeDays: number;
    activeMinutes: number;
    walks: number;
  } | null;
  plans: Array<{
    __typename?: 'PlanItem';
    plannedActivityId: string;
    title: string;
    valueActivityId?: string | null;
    plannedFor: any;
    durationMinutes?: number | null;
    predictedEnjoyment: number;
    predictedImportance: number;
    certainty?: number | null;
    replanOf?: string | null;
    assignmentId: string;
    plannedBy?: string | null;
    status: string;
    enjoyment?: number | null;
    importance?: number | null;
    note?: string | null;
    barrier?: string | null;
  }>;
  hours: Array<{
    __typename?: 'ActivityWeekHour';
    activityLogId: string;
    startAt: any;
    endAt: any;
    title: string;
    enjoyment: number;
    importance: number;
    valueActivityId?: string | null;
    area?: string | null;
  }>;
  moods: Array<{ __typename?: 'ActivityWeekMood'; date: string; mood: number }>;
  activityDays: Array<{
    __typename?: 'ActivityWeekPhoneDay';
    date: string;
    activeMinutes: number;
  }>;
};

export type ActivityLadderFieldsFragment = {
  __typename?: 'ActivityLadder';
  subject: string;
  rankingId?: string | null;
  rankedAt?: any | null;
  rankedBy?: string | null;
  rungs: Array<{
    __typename?: 'LadderRung';
    rank: number;
    valueActivityId: string;
    title: string;
    value: string;
    difficulty: number;
    area?: string | null;
  }>;
};

export type ActivityIdeasQueryVariables = Exact<{
  language?: InputMaybe<Scalars['String']>;
}>;

export type ActivityIdeasQuery = {
  __typename?: 'Query';
  activityIdeas: {
    __typename?: 'ActivityIdeas';
    subject: string;
    libraryId?: string | null;
    ideas: Array<{
      __typename?: 'ActivityIdea';
      ideaId?: string | null;
      text: string;
      area?: string | null;
      difficulty?: number | null;
      forYourValue?: string | null;
      origin: string;
    }>;
  };
};

export type WeekActivitiesQueryVariables = Exact<{ [key: string]: never }>;

export type WeekActivitiesQuery = {
  __typename?: 'Query';
  weekActivities: {
    __typename?: 'WeekActivities';
    subject: string;
    activities: Array<{
      __typename?: 'WeekActivity';
      activityLogId: string;
      title: string;
      enjoyment: number;
      importance: number;
      startAt: any;
      valueActivityId?: string | null;
    }>;
  };
};

export type ActivityChoicesQueryVariables = Exact<{ [key: string]: never }>;

export type ActivityChoicesQuery = {
  __typename?: 'Query';
  activityChoices: {
    __typename?: 'ActivityChoices';
    subject: string;
    groups: Array<{
      __typename?: 'ValueActivities';
      value: string;
      suggestionRequestId?: string | null;
      activities: Array<{
        __typename?: 'ValueActivityRow';
        activityId: string;
        activity: string;
        difficulty: number;
        source: string;
        origin: string;
        status: string;
      }>;
      suggested: Array<{
        __typename?: 'SuggestedActivity';
        activity: string;
        difficulty: number;
      }>;
    }>;
  };
};

export type ActivityLadderQueryVariables = Exact<{
  subject?: InputMaybe<Scalars['ID']>;
}>;

export type ActivityLadderQuery = {
  __typename?: 'Query';
  activityLadder: {
    __typename?: 'ActivityLadder';
    subject: string;
    rankingId?: string | null;
    rankedAt?: any | null;
    rankedBy?: string | null;
    rungs: Array<{
      __typename?: 'LadderRung';
      rank: number;
      valueActivityId: string;
      title: string;
      value: string;
      difficulty: number;
      area?: string | null;
    }>;
  };
};

export type ActivityDayQueryVariables = Exact<{
  day?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type ActivityDayQuery = {
  __typename?: 'Query';
  activityDay: {
    __typename?: 'ActivityDay';
    subject: string;
    day: string;
    mood?: number | null;
    gaps: Array<string>;
    hours: Array<{
      __typename?: 'ActivityDayHour';
      kind: string;
      activityLogId?: string | null;
      plannedActivityId?: string | null;
      startAt: any;
      endAt?: any | null;
      start: string;
      title: string;
      enjoyment: number;
      importance: number;
      valueActivityId?: string | null;
      source: string;
    }>;
  };
};

export type HealthActivitySuggestionsQueryVariables = Exact<{
  day?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type HealthActivitySuggestionsQuery = {
  __typename?: 'Query';
  healthActivitySuggestions: {
    __typename?: 'HealthActivitySuggestions';
    subject: string;
    day: string;
    suggestions: Array<{
      __typename?: 'HealthActivitySuggestion';
      start: string;
      startAt: any;
      minutes: number;
      kind: string;
    }>;
  };
};

export type ActivityPlanQueryVariables = Exact<{
  subject?: InputMaybe<Scalars['ID']>;
  week?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type ActivityPlanQuery = {
  __typename?: 'Query';
  activityPlan: {
    __typename?: 'ActivityPlan';
    subject: string;
    week: string;
    plannedThisWeek: number;
    doneThisWeek: number;
    weekPlan: Array<{
      __typename?: 'PlanDay';
      day: string;
      items: Array<{
        __typename?: 'PlanItem';
        plannedActivityId: string;
        title: string;
        valueActivityId?: string | null;
        plannedFor: any;
        durationMinutes?: number | null;
        predictedEnjoyment: number;
        predictedImportance: number;
        certainty?: number | null;
        replanOf?: string | null;
        assignmentId: string;
        plannedBy?: string | null;
        status: string;
        enjoyment?: number | null;
        importance?: number | null;
        note?: string | null;
        barrier?: string | null;
      }>;
    }>;
  };
};

export type ActivityWeekQueryVariables = Exact<{
  subject?: InputMaybe<Scalars['ID']>;
  week?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type ActivityWeekQuery = {
  __typename?: 'Query';
  activityWeek: {
    __typename?: 'ActivityWeek';
    subject: string;
    week: string;
    planned: number;
    done: number;
    missed: number;
    emptyAreas: Array<string>;
    topBarrier?: string | null;
    predictedVsActual: {
      __typename?: 'PredictedVsActual';
      enjoyment: {
        __typename?: 'PredictedActual';
        predicted?: number | null;
        actual?: number | null;
      };
      importance: {
        __typename?: 'PredictedActual';
        predicted?: number | null;
        actual?: number | null;
      };
    };
    byLifeArea: Array<{
      __typename?: 'AreaHours';
      area: string;
      hours: number;
    }>;
    moodByDay: Array<{
      __typename?: 'MoodByDay';
      date: string;
      mood?: number | null;
      activitiesDone: number;
    }>;
    healthActivity?: {
      __typename?: 'HealthActivityWeek';
      activeDays: number;
      activeMinutes: number;
      walks: number;
    } | null;
    plans: Array<{
      __typename?: 'PlanItem';
      plannedActivityId: string;
      title: string;
      valueActivityId?: string | null;
      plannedFor: any;
      durationMinutes?: number | null;
      predictedEnjoyment: number;
      predictedImportance: number;
      certainty?: number | null;
      replanOf?: string | null;
      assignmentId: string;
      plannedBy?: string | null;
      status: string;
      enjoyment?: number | null;
      importance?: number | null;
      note?: string | null;
      barrier?: string | null;
    }>;
    hours: Array<{
      __typename?: 'ActivityWeekHour';
      activityLogId: string;
      startAt: any;
      endAt: any;
      title: string;
      enjoyment: number;
      importance: number;
      valueActivityId?: string | null;
      area?: string | null;
    }>;
    moods: Array<{
      __typename?: 'ActivityWeekMood';
      date: string;
      mood: number;
    }>;
    activityDays: Array<{
      __typename?: 'ActivityWeekPhoneDay';
      date: string;
      activeMinutes: number;
    }>;
  };
};

export type PublishActivityLibraryMutationVariables = Exact<{
  input: PublishActivityLibraryInput;
}>;

export type PublishActivityLibraryMutation = {
  __typename?: 'Mutation';
  publishActivityLibrary: {
    __typename?: 'BaCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type LogActivityMutationVariables = Exact<{
  input: LogActivityInput;
}>;

export type LogActivityMutation = {
  __typename?: 'Mutation';
  logActivity: {
    __typename?: 'BaCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type RemoveActivityLogMutationVariables = Exact<{
  input: RemoveActivityLogInput;
}>;

export type RemoveActivityLogMutation = {
  __typename?: 'Mutation';
  removeActivityLog: {
    __typename?: 'BaCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type RankActivitiesMutationVariables = Exact<{
  input: RankActivitiesInput;
}>;

export type RankActivitiesMutation = {
  __typename?: 'Mutation';
  rankActivities: {
    __typename?: 'BaCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type PlanActivityMutationVariables = Exact<{
  input: PlanActivityInput;
}>;

export type PlanActivityMutation = {
  __typename?: 'Mutation';
  planActivity: {
    __typename?: 'BaCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type PlanActivityInSessionMutationVariables = Exact<{
  input: PlanActivityInSessionInput;
}>;

export type PlanActivityInSessionMutation = {
  __typename?: 'Mutation';
  planActivityInSession: {
    __typename?: 'BaCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type CompletePlannedActivityMutationVariables = Exact<{
  input: CompletePlannedActivityInput;
}>;

export type CompletePlannedActivityMutation = {
  __typename?: 'Mutation';
  completePlannedActivity: {
    __typename?: 'BaCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type MissPlannedActivityMutationVariables = Exact<{
  input: MissPlannedActivityInput;
}>;

export type MissPlannedActivityMutation = {
  __typename?: 'Mutation';
  missPlannedActivity: {
    __typename?: 'BaCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type MakeSupportContractMutationVariables = Exact<{
  input: MakeSupportContractInput;
}>;

export type MakeSupportContractMutation = {
  __typename?: 'Mutation';
  makeSupportContract: {
    __typename?: 'BaCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type CheckInEntryFieldsFragment = {
  __typename?: 'CheckInEntry';
  checkInId: string;
  recordedFor: string;
  occurredAt: any;
  mood: number;
  energy?: number | null;
  sleepQuality?: number | null;
  sleepHours?: number | null;
  socialConnection?: number | null;
  drivers?: Array<string> | null;
  note?: string | null;
  enteredInSession: boolean;
  practiceId?: string | null;
  emotions?: Array<{
    __typename?: 'CheckInEmotion';
    id: number;
    strength: number;
  }> | null;
};

export type RecordCheckInMutationVariables = Exact<{
  input: RecordCheckInInput;
}>;

export type RecordCheckInMutation = {
  __typename?: 'Mutation';
  recordCheckIn: {
    __typename?: 'CheckInCommandPayload';
    checkInId: string;
    recorded: boolean;
  };
};

export type RecordCheckInInSessionMutationVariables = Exact<{
  input: RecordCheckInInSessionInput;
}>;

export type RecordCheckInInSessionMutation = {
  __typename?: 'Mutation';
  recordCheckInInSession: {
    __typename?: 'CheckInCommandPayload';
    checkInId: string;
    recorded: boolean;
  };
};

export type DeleteCheckInMutationVariables = Exact<{
  input: DeleteCheckInInput;
}>;

export type DeleteCheckInMutation = {
  __typename?: 'Mutation';
  deleteCheckIn: {
    __typename?: 'CheckInCommandPayload';
    checkInId: string;
    recorded: boolean;
  };
};

export type MyCheckInsQueryVariables = Exact<{
  days?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type MyCheckInsQuery = {
  __typename?: 'Query';
  myCheckIns: {
    __typename?: 'MyCheckIns';
    days: number;
    checkedInToday: boolean;
    streakDays: number;
    entries: Array<{
      __typename?: 'CheckInEntry';
      checkInId: string;
      recordedFor: string;
      occurredAt: any;
      mood: number;
      energy?: number | null;
      sleepQuality?: number | null;
      sleepHours?: number | null;
      socialConnection?: number | null;
      drivers?: Array<string> | null;
      note?: string | null;
      enteredInSession: boolean;
      practiceId?: string | null;
      emotions?: Array<{
        __typename?: 'CheckInEmotion';
        id: number;
        strength: number;
      }> | null;
    }>;
    sleepNights?: Array<{
      __typename?: 'CheckInSleepNight';
      night: string;
      wakeDay: string;
      inBedStart: any;
      inBedEnd: any;
      asleepMinutes: number;
      efficiency?: number | null;
    }> | null;
    activityDays?: Array<{
      __typename?: 'CheckInActivityDay';
      date: string;
      activeMinutes: number;
    }> | null;
  };
};

export type ClientCheckInTrendQueryVariables = Exact<{
  subject: Scalars['ID'];
  days?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type ClientCheckInTrendQuery = {
  __typename?: 'Query';
  clientCheckInTrend: {
    __typename?: 'ClientCheckInTrend';
    subject: string;
    days: number;
    daysCheckedIn: number;
    entries: Array<{
      __typename?: 'CheckInEntry';
      checkInId: string;
      recordedFor: string;
      occurredAt: any;
      mood: number;
      energy?: number | null;
      sleepQuality?: number | null;
      sleepHours?: number | null;
      socialConnection?: number | null;
      drivers?: Array<string> | null;
      note?: string | null;
      enteredInSession: boolean;
      practiceId?: string | null;
      emotions?: Array<{
        __typename?: 'CheckInEmotion';
        id: number;
        strength: number;
      }> | null;
    }>;
    sharedTypes: {
      __typename?: 'CheckInSharedTypes';
      sleep: boolean;
      activity: boolean;
    };
    sleepNights?: Array<{
      __typename?: 'CheckInSleepNight';
      night: string;
      wakeDay: string;
      inBedStart: any;
      inBedEnd: any;
      asleepMinutes: number;
      efficiency?: number | null;
    }> | null;
    activityDays?: Array<{
      __typename?: 'CheckInActivityDay';
      date: string;
      activeMinutes: number;
    }> | null;
  };
};

export type CheckInsSinceLastSessionQueryVariables = Exact<{
  subject: Scalars['ID'];
  sessionId?: InputMaybe<Scalars['ID']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type CheckInsSinceLastSessionQuery = {
  __typename?: 'Query';
  checkInsSinceLastSession: {
    __typename?: 'CheckInRecap';
    subject: string;
    sessionId?: string | null;
    since?: any | null;
    firstSession: boolean;
    checkIns: number;
    inSessionCheckIns: number;
    moodAverage?: number | null;
    sleepAverageHours?: number | null;
    moodLowest?: {
      __typename?: 'CheckInLowestDay';
      checkInId: string;
      day: string;
      mood: number;
      note?: string | null;
    } | null;
    topDrivers: Array<{
      __typename?: 'CheckInTopDriver';
      driver: string;
      count: number;
    }>;
    entries: Array<{
      __typename?: 'CheckInEntry';
      checkInId: string;
      recordedFor: string;
      occurredAt: any;
      mood: number;
      energy?: number | null;
      sleepQuality?: number | null;
      sleepHours?: number | null;
      socialConnection?: number | null;
      drivers?: Array<string> | null;
      note?: string | null;
      enteredInSession: boolean;
      practiceId?: string | null;
      emotions?: Array<{
        __typename?: 'CheckInEmotion';
        id: number;
        strength: number;
      }> | null;
    }>;
    sharedTypes: {
      __typename?: 'CheckInSharedTypes';
      sleep: boolean;
      activity: boolean;
    };
    phoneAverages: {
      __typename?: 'CheckInPhoneAverages';
      asleepMinutes?: number | null;
      efficiency?: number | null;
      activeMinutes?: number | null;
    };
  };
};

export type SetHiddenToolsMutationVariables = Exact<{
  input: SetHiddenToolsInput;
}>;

export type SetHiddenToolsMutation = {
  __typename?: 'Mutation';
  setHiddenTools: {
    __typename?: 'MyHiddenTools';
    performer: string;
    hiddenTools: Array<string>;
  };
};

export type MyHiddenToolsQueryVariables = Exact<{ [key: string]: never }>;

export type MyHiddenToolsQuery = {
  __typename?: 'Query';
  myHiddenTools: {
    __typename?: 'MyHiddenTools';
    performer: string;
    hiddenTools: Array<string>;
  };
};

export type ClientHeaderQueryVariables = Exact<{
  subject: Scalars['ID'];
}>;

export type ClientHeaderQuery = {
  __typename?: 'Query';
  clientHeader: {
    __typename?: 'ClientHeader';
    subject: string;
    firstName?: string | null;
    lastName?: string | null;
    role?: number | null;
    accessLevel?: string | null;
    appClient: boolean;
    lastSession?: {
      __typename?: 'ClientHeaderSession';
      start: any;
      end?: any | null;
    } | null;
    reviewSession?: {
      __typename?: 'ClientHeaderReview';
      reviewSessionId: string;
      startedAt: any;
    } | null;
  };
};

export type ClientToolNavigationQueryVariables = Exact<{
  subject: Scalars['ID'];
}>;

export type ClientToolNavigationQuery = {
  __typename?: 'Query';
  clientToolNavigation: {
    __typename?: 'ClientToolNavigation';
    subject: string;
    performer: string;
    sinceDate: any;
    workShared: boolean;
    sessionCount: number;
    tools: Array<{
      __typename?: 'ClientToolNavigationItem';
      tool: string;
      group: string;
      inUse: boolean;
      recordCount: number;
      lastRecordedAt?: any | null;
      newSinceLastSession: number;
      hiddenByMe: boolean;
    }>;
  };
};

export type ClientDigestQueryVariables = Exact<{
  subject: Scalars['ID'];
}>;

export type ClientDigestQuery = {
  __typename?: 'Query';
  clientDigest: {
    __typename?: 'ClientDigest';
    subject: string;
    sinceDate: any;
    noSession: boolean;
    workShared: boolean;
    cards: Array<{
      __typename?: 'DigestCard';
      tool: string;
      group: string;
      count: number;
      hidden: boolean;
      lastAt?: any | null;
      lastDay?: string | null;
      done?: number | null;
      total?: number | null;
      overdue?: number | null;
      moodMin?: number | null;
      moodMax?: number | null;
      scores: Array<{
        __typename?: 'DigestScore';
        instrument: string;
        score: number;
        previous?: number | null;
        change?: number | null;
        at: any;
      }>;
    }>;
  };
};

export type AllRecordsQueryVariables = Exact<{
  tools?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  subject?: InputMaybe<Scalars['ID']>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
  therapist?: InputMaybe<Scalars['ID']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type AllRecordsQuery = {
  __typename?: 'Query';
  allRecords: {
    __typename?: 'AllRecordsPage';
    count: number;
    toolCounts: Array<{
      __typename?: 'AllRecordsToolCount';
      tool: string;
      count: number;
    }>;
    rows: Array<{
      __typename?: 'AllRecordsRow';
      subject: string;
      tool: string;
      recordId: string;
      performer?: string | null;
      occurredAt: any;
      summary?: string | null;
      day?: string | null;
      nightKind?: string | null;
      status?: string | null;
      hidden: boolean;
      metric?: {
        __typename?: 'RecordMetric';
        kind: string;
        value: number;
        instrument?: string | null;
        higherIsWorse?: boolean | null;
      } | null;
    }>;
  };
};

export type CaseloadOverviewQueryVariables = Exact<{
  question?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type CaseloadOverviewQuery = {
  __typename?: 'Query';
  caseloadOverview: Array<{
    __typename?: 'CaseloadOverviewRow';
    subject: string;
    view: boolean;
    therapist?: string | null;
    therapistName?: string | null;
    homeworkBehind?: number | null;
    scoreWentUp: boolean;
    maxScoreRise?: number | null;
    checkInsInUse: boolean;
    lastCheckInDay?: string | null;
    daysSinceCheckIn?: number | null;
    diaryInUse: boolean;
    diaryDaysThisWeek?: number | null;
    lastActivityAt?: any | null;
    toolsInUse?: Array<string> | null;
    latestScores?: Array<{
      __typename?: 'CaseloadScore';
      instrument: string;
      score: number;
      previous?: number | null;
      change?: number | null;
      wentUp: boolean;
      at: any;
    }> | null;
    lastSession?: {
      __typename?: 'ClientHeaderSession';
      start: any;
      end?: any | null;
    } | null;
    signals: {
      __typename?: 'CaseloadSignals';
      homeworkBehind: boolean;
      scoreWentUp: boolean;
      noCheckIn7Days: boolean;
      diaryNotFilledThisWeek: boolean;
    };
  }>;
};

export type DateTimeReminderDataFragment = {
  __typename?: 'DateTimeReminder';
  _id: string;
  _key: string;
  _rev: string;
  createdAt: any;
  updatedAt: any;
  userId: string;
  date: any;
  enabled: boolean;
  for?: string | null;
};

export type DateTimeReminderQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type DateTimeReminderQuery = {
  __typename?: 'Query';
  dateTimeReminder?: {
    __typename?: 'DateTimeReminder';
    _id: string;
    _key: string;
    _rev: string;
    createdAt: any;
    updatedAt: any;
    userId: string;
    date: any;
    enabled: boolean;
    for?: string | null;
  } | null;
};

export type DateTimeRemindersQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type DateTimeRemindersQuery = {
  __typename?: 'Query';
  dateTimeReminders?: Array<{
    __typename?: 'DateTimeReminder';
    _id: string;
    _key: string;
    _rev: string;
    createdAt: any;
    updatedAt: any;
    userId: string;
    date: any;
    enabled: boolean;
    for?: string | null;
  } | null> | null;
};

export type DateTimeRemindersForUserQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
}>;

export type DateTimeRemindersForUserQuery = {
  __typename?: 'Query';
  dateTimeRemindersForUser?: {
    __typename?: 'DateTimeReminderConnection';
    totalCount: number;
    edges?: Array<{
      __typename?: 'DateTimeReminderEdge';
      cursor: string;
      node?: {
        __typename?: 'DateTimeReminder';
        _id: string;
        _key: string;
        _rev: string;
        createdAt: any;
        updatedAt: any;
        userId: string;
        date: any;
        enabled: boolean;
        for?: string | null;
      } | null;
    } | null> | null;
    pageInfo?: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    } | null;
  } | null;
};

export type CreateDateTimeReminderMutationVariables = Exact<{
  dateTimeReminder: DateTimeReminderCreateInput;
}>;

export type CreateDateTimeReminderMutation = {
  __typename?: 'Mutation';
  createDateTimeReminder?: {
    __typename?: 'DateTimeReminderResponse';
    dateTimeReminder?: {
      __typename?: 'DateTimeReminder';
      _id: string;
      _key: string;
      _rev: string;
      createdAt: any;
      updatedAt: any;
      userId: string;
      date: any;
      enabled: boolean;
      for?: string | null;
    } | null;
  } | null;
};

export type UpdateDateTimeReminderMutationVariables = Exact<{
  dateTimeReminder: DateTimeReminderUpdateInput;
}>;

export type UpdateDateTimeReminderMutation = {
  __typename?: 'Mutation';
  updateDateTimeReminder?: {
    __typename?: 'DateTimeReminderResponse';
    dateTimeReminder?: {
      __typename?: 'DateTimeReminder';
      _id: string;
      _key: string;
      _rev: string;
      createdAt: any;
      updatedAt: any;
      userId: string;
      date: any;
      enabled: boolean;
      for?: string | null;
    } | null;
  } | null;
};

export type DeleteDateTimeReminderMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;

export type DeleteDateTimeReminderMutation = {
  __typename?: 'Mutation';
  deleteDateTimeReminder?: {
    __typename?: 'DateTimeReminderDeleteResponse';
    success?: boolean | null;
    old?: {
      __typename?: 'DateTimeReminder';
      _id: string;
      _key: string;
      _rev: string;
      createdAt: any;
      updatedAt: any;
      userId: string;
      date: any;
      enabled: boolean;
      for?: string | null;
    } | null;
  } | null;
};

export type DayRemindersDataFragment = {
  __typename?: 'DayReminders';
  _id: string;
  _key: string;
  _rev: string;
  thoughtId: string;
  createdAt: any;
  updatedAt: any;
  morning: {
    __typename?: 'TimeReminder';
    enabled: boolean;
    time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
  };
  day: {
    __typename?: 'TimeReminder';
    enabled: boolean;
    time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
  };
  evening: {
    __typename?: 'TimeReminder';
    enabled: boolean;
    time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
  };
};

export type DayRemindersQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type DayRemindersQuery = {
  __typename?: 'Query';
  dayReminders?: {
    __typename?: 'DayReminders';
    _id: string;
    _key: string;
    _rev: string;
    thoughtId: string;
    createdAt: any;
    updatedAt: any;
    morning: {
      __typename?: 'TimeReminder';
      enabled: boolean;
      time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
    };
    day: {
      __typename?: 'TimeReminder';
      enabled: boolean;
      time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
    };
    evening: {
      __typename?: 'TimeReminder';
      enabled: boolean;
      time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
    };
  } | null;
};

export type DayRemindersForUserQueryVariables = Exact<{ [key: string]: never }>;

export type DayRemindersForUserQuery = {
  __typename?: 'Query';
  thoughtsForUser?: {
    __typename?: 'ThoughtConnection';
    totalCount: number;
    edges?: Array<{
      __typename?: 'ThoughtEdge';
      cursor: string;
      node?: {
        __typename?: 'Thought';
        _id: string;
        dayReminders?: {
          __typename?: 'DayReminders';
          _id: string;
          _key: string;
          _rev: string;
          thoughtId: string;
          createdAt: any;
          updatedAt: any;
          morning: {
            __typename?: 'TimeReminder';
            enabled: boolean;
            time: {
              __typename?: 'ReminderTime';
              hours: number;
              minutes: number;
            };
          };
          day: {
            __typename?: 'TimeReminder';
            enabled: boolean;
            time: {
              __typename?: 'ReminderTime';
              hours: number;
              minutes: number;
            };
          };
          evening: {
            __typename?: 'TimeReminder';
            enabled: boolean;
            time: {
              __typename?: 'ReminderTime';
              hours: number;
              minutes: number;
            };
          };
        } | null;
      } | null;
    } | null> | null;
    pageInfo?: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    } | null;
  } | null;
};

export type EnabledDayRemindersCountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type EnabledDayRemindersCountQuery = {
  __typename?: 'Query';
  enabledDayReminders?: {
    __typename?: 'EnabledDayRemindersCount';
    enabled: number;
  } | null;
};

export type CreateDayRemindersMutationVariables = Exact<{
  dayReminders: DayRemindersCreateInput;
}>;

export type CreateDayRemindersMutation = {
  __typename?: 'Mutation';
  createDayReminders?: {
    __typename?: 'DayRemindersResponse';
    dayReminders?: {
      __typename?: 'DayReminders';
      _id: string;
      _key: string;
      _rev: string;
      thoughtId: string;
      createdAt: any;
      updatedAt: any;
      morning: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
      day: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
      evening: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
    } | null;
  } | null;
};

export type DeleteDayRemindersMutationVariables = Exact<{
  _id: Scalars['String'];
}>;

export type DeleteDayRemindersMutation = {
  __typename?: 'Mutation';
  deleteDayReminders?: {
    __typename?: 'DeleteDayRemindersResponse';
    success?: boolean | null;
    old?: {
      __typename?: 'DayReminders';
      _id: string;
      _key: string;
      _rev: string;
      thoughtId: string;
      createdAt: any;
      updatedAt: any;
      morning: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
      day: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
      evening: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
    } | null;
  } | null;
};

export type UpdateDayRemindersMutationVariables = Exact<{
  dayReminders: DayRemindersUpdateInput;
}>;

export type UpdateDayRemindersMutation = {
  __typename?: 'Mutation';
  updateDayReminders?: {
    __typename?: 'DayRemindersResponse';
    dayReminders?: {
      __typename?: 'DayReminders';
      _id: string;
      _key: string;
      _rev: string;
      thoughtId: string;
      createdAt: any;
      updatedAt: any;
      morning: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
      day: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
      evening: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
    } | null;
  } | null;
};

export type KeepDayRemindersMutationVariables = Exact<{
  stringifiedIdsAndKeys: Scalars['String'];
}>;

export type KeepDayRemindersMutation = {
  __typename?: 'Mutation';
  keepDayReminders?: {
    __typename?: 'KeepDayRemindersResponse';
    success?: boolean | null;
  } | null;
};

export type DiagramImageQueryVariables = Exact<{
  source: Scalars['String'];
}>;

export type DiagramImageQuery = { __typename?: 'Query'; diagramImage: string };

export type DiaryCardRowsFragment = {
  __typename?: 'DiaryCardActive';
  cardId: string;
  practiceId?: string | null;
  practiceName?: string | null;
  version: number;
  template: string;
  targets: Array<{
    __typename?: 'DiaryCardTarget';
    targetId: string;
    name: string;
    kind: string;
    max?: number | null;
    countable?: boolean | null;
    standard?: boolean | null;
    faTargetId?: string | null;
  }>;
  emotions: Array<{ __typename?: 'DiaryCardEmotionRow'; id: string }>;
  skills: Array<{
    __typename?: 'DiaryCardSkillRow';
    skillId: string;
    module: string;
  }>;
};

export type DiaryCardRatingFieldsFragment = {
  __typename?: 'DiaryCardRating';
  targetId: string;
  urge?: number | null;
  scale?: number | null;
  acted?: boolean | null;
  count?: number | null;
  text?: string | null;
};

export type DiaryCardTemplatesQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']>;
}>;

export type DiaryCardTemplatesQuery = {
  __typename?: 'Query';
  diaryCardTemplates: Array<{
    __typename?: 'DiaryCardTemplate';
    templateId: string;
    name: string;
    summary: string;
    targets: Array<{
      __typename?: 'DiaryCardTarget';
      targetId: string;
      name: string;
      kind: string;
      max?: number | null;
      countable?: boolean | null;
      standard?: boolean | null;
      faTargetId?: string | null;
    }>;
    emotions: Array<{ __typename?: 'DiaryCardEmotionRow'; id: string }>;
    skills: Array<{
      __typename?: 'DiaryCardSkillRow';
      skillId: string;
      module: string;
    }>;
  }>;
};

export type DiaryCardQueryVariables = Exact<{
  day?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type DiaryCardQuery = {
  __typename?: 'Query';
  diaryCard: {
    __typename?: 'DiaryCard';
    day: string;
    filledToday: boolean;
    activeCards: Array<{
      __typename?: 'DiaryCardActive';
      cardId: string;
      practiceId?: string | null;
      practiceName?: string | null;
      version: number;
      template: string;
      targets: Array<{
        __typename?: 'DiaryCardTarget';
        targetId: string;
        name: string;
        kind: string;
        max?: number | null;
        countable?: boolean | null;
        standard?: boolean | null;
        faTargetId?: string | null;
      }>;
      emotions: Array<{ __typename?: 'DiaryCardEmotionRow'; id: string }>;
      skills: Array<{
        __typename?: 'DiaryCardSkillRow';
        skillId: string;
        module: string;
      }>;
    }>;
    formRows: Array<{
      __typename?: 'DiaryCardFormRow';
      key: string;
      targetId: string;
      name: string;
      kind: string;
      max?: number | null;
      countable: boolean;
      standard: boolean;
      cardIds: Array<string>;
      ownerCardId?: string | null;
    }>;
    fills: Array<{
      __typename?: 'DiaryCardDayFill';
      cardId: string;
      version: number;
      enteredInSession: boolean;
      skillsUsed?: number | null;
      skillsPracticed: Array<string>;
      note?: string | null;
      ratings: Array<{
        __typename?: 'DiaryCardRating';
        targetId: string;
        urge?: number | null;
        scale?: number | null;
        acted?: boolean | null;
        count?: number | null;
        text?: string | null;
      }>;
      emotionRatings: Array<{
        __typename?: 'DiaryCardEmotionRating';
        id: string;
        rating: number;
      }>;
    }>;
  };
};

export type DiaryCardWeekQueryVariables = Exact<{
  weekOf?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type DiaryCardWeekQuery = {
  __typename?: 'Query';
  diaryCardWeek: {
    __typename?: 'DiaryCardWeek';
    subject: string;
    weekOf: string;
    cards: Array<{
      __typename?: 'DiaryCardWeekGrid';
      cardId: string;
      practiceId?: string | null;
      setUpBy: string;
      setUpByName?: string | null;
      version: number;
      inSessionDays: Array<string>;
      targets: Array<{
        __typename?: 'DiaryCardTarget';
        targetId: string;
        name: string;
        kind: string;
        max?: number | null;
        countable?: boolean | null;
        standard?: boolean | null;
      }>;
      emotions: Array<{ __typename?: 'DiaryCardEmotionRow'; id: string }>;
      skills: Array<{
        __typename?: 'DiaryCardSkillRow';
        skillId: string;
        module: string;
      }>;
      dayEntries: Array<{
        __typename?: 'DiaryCardDayEntry';
        cardId: string;
        day: string;
        enteredInSession: boolean;
        skillsUsed?: number | null;
        skillsPracticed: Array<string>;
        note?: string | null;
        ratings: Array<{
          __typename?: 'DiaryCardRating';
          targetId: string;
          urge?: number | null;
          scale?: number | null;
          acted?: boolean | null;
          count?: number | null;
          text?: string | null;
        }>;
        emotionRatings: Array<{
          __typename?: 'DiaryCardEmotionRating';
          id: string;
          rating: number;
        }>;
      }>;
      highlights: Array<{
        __typename?: 'DiaryCardHighlight';
        day: string;
        targetId: string;
        urge?: number | null;
        acted?: boolean | null;
        count?: number | null;
      }>;
    }>;
  };
};

export type DefineDiaryCardMutationVariables = Exact<{
  input: DefineDiaryCardInput;
}>;

export type DefineDiaryCardMutation = {
  __typename?: 'Mutation';
  defineDiaryCard: {
    __typename?: 'DefineDiaryCardPayload';
    cardId: string;
    version: number;
    recorded: boolean;
  };
};

export type FillDiaryCardMutationVariables = Exact<{
  input: FillDiaryCardInput;
}>;

export type FillDiaryCardMutation = {
  __typename?: 'Mutation';
  fillDiaryCard: {
    __typename?: 'FillDiaryCardPayload';
    cards: number;
    recorded: boolean;
  };
};

export type DownwardArrowDataFragment = {
  __typename?: 'DownwardArrow';
  userId: string;
  createdAt: any;
  updatedAt: any;
  beliefs: Array<string>;
};

export type DownwardArrowsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['JSON']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type DownwardArrowsQuery = {
  __typename?: 'Query';
  downwardArrows?: {
    __typename?: 'DownwardArrowSearch';
    count: number;
    data?: Array<{
      __typename?: 'DownwardArrow';
      _id: string;
      userId: string;
      createdAt: any;
      updatedAt: any;
      beliefs: Array<string>;
    } | null> | null;
  } | null;
};

export type DownwardArrowQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']>;
}>;

export type DownwardArrowQuery = {
  __typename?: 'Query';
  downwardArrow?: {
    __typename?: 'DownwardArrow';
    _id: string;
    userId: string;
    createdAt: any;
    updatedAt: any;
    beliefs: Array<string>;
  } | null;
};

export type UpsertDownwardArrowMutationVariables = Exact<{
  input?: InputMaybe<DownwardArrowInput>;
}>;

export type UpsertDownwardArrowMutation = {
  __typename?: 'Mutation';
  upsertDownwardArrow?: {
    __typename?: 'DownwardArrow';
    _id: string;
    userId: string;
    createdAt: any;
    updatedAt: any;
    beliefs: Array<string>;
  } | null;
};

export type EsReadyDomainsQueryVariables = Exact<{ [key: string]: never }>;

export type EsReadyDomainsQuery = {
  __typename?: 'Query';
  esReadyDomains: Array<EsDomain>;
};

export type EsReminderSchedulesQueryVariables = Exact<{ [key: string]: never }>;

export type EsReminderSchedulesQuery = {
  __typename?: 'Query';
  esReminderSchedules: Array<{
    __typename?: 'EsReminderSchedule';
    reminderId: string;
    channel: string;
    updatedAt: any;
    target: {
      __typename?: 'EsReminderTarget';
      kind: string;
      ref?: string | null;
    };
    schedule: {
      __typename?: 'EsReminderScheduleValue';
      rrule: string;
      dtstart: string;
      tzid?: string | null;
      exdates: Array<string>;
    };
    legacyBinding?: {
      __typename?: 'EsReminderLegacyBinding';
      collection: string;
      key: string;
      slot?: string | null;
    } | null;
  }>;
};

export type RestoreTrimmedRemindersMutationVariables = Exact<{
  [key: string]: never;
}>;

export type RestoreTrimmedRemindersMutation = {
  __typename?: 'Mutation';
  restoreTrimmedReminders?: {
    __typename?: 'RestoreTrimmedRemindersResponse';
    success: boolean;
    restored: Array<string>;
  } | null;
};

export type EsReminderScheduleFieldsFragment = {
  __typename?: 'EsReminderSchedule';
  reminderId: string;
  channel: string;
  updatedAt: any;
  target: {
    __typename?: 'EsReminderTarget';
    kind: string;
    ref?: string | null;
  };
  schedule: {
    __typename?: 'EsReminderScheduleValue';
    rrule: string;
    dtstart: string;
    tzid?: string | null;
    exdates: Array<string>;
  };
  legacyBinding?: {
    __typename?: 'EsReminderLegacyBinding';
    collection: string;
    key: string;
    slot?: string | null;
  } | null;
};

export type EsCardRemindersQueryVariables = Exact<{
  target: EsReminderTargetInput;
  subject?: InputMaybe<Scalars['ID']>;
}>;

export type EsCardRemindersQuery = {
  __typename?: 'Query';
  esCardReminders: {
    __typename?: 'EsCardReminders';
    active: Array<{
      __typename?: 'EsReminderSchedule';
      reminderId: string;
      channel: string;
      updatedAt: any;
      target: {
        __typename?: 'EsReminderTarget';
        kind: string;
        ref?: string | null;
      };
      schedule: {
        __typename?: 'EsReminderScheduleValue';
        rrule: string;
        dtstart: string;
        tzid?: string | null;
        exdates: Array<string>;
      };
      legacyBinding?: {
        __typename?: 'EsReminderLegacyBinding';
        collection: string;
        key: string;
        slot?: string | null;
      } | null;
    }>;
    stopped: Array<{
      __typename?: 'EsStoppedReminderSchedule';
      reminderId: string;
      channel: string;
      reason: string;
      updatedAt: any;
      target: {
        __typename?: 'EsReminderTarget';
        kind: string;
        ref?: string | null;
      };
      schedule: {
        __typename?: 'EsReminderScheduleValue';
        rrule: string;
        dtstart: string;
        tzid?: string | null;
        exdates: Array<string>;
      };
      legacyBinding?: {
        __typename?: 'EsReminderLegacyBinding';
        collection: string;
        key: string;
        slot?: string | null;
      } | null;
    }>;
    nextOccurrences: Array<{
      __typename?: 'EsReminderOccurrence';
      reminderId: string;
      local: string;
      utcIso?: string | null;
    }>;
  };
};

export type SetReminderScheduleMutationVariables = Exact<{
  reminderId?: InputMaybe<Scalars['ID']>;
  target: EsReminderTargetInput;
  schedule: EsReminderScheduleInput;
  channel?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['ID']>;
}>;

export type SetReminderScheduleMutation = {
  __typename?: 'Mutation';
  setReminderSchedule?: {
    __typename?: 'EsReminderScheduleResponse';
    success: boolean;
    reminderId: string;
    schedule?: {
      __typename?: 'EsReminderSchedule';
      reminderId: string;
      channel: string;
      updatedAt: any;
      target: {
        __typename?: 'EsReminderTarget';
        kind: string;
        ref?: string | null;
      };
      schedule: {
        __typename?: 'EsReminderScheduleValue';
        rrule: string;
        dtstart: string;
        tzid?: string | null;
        exdates: Array<string>;
      };
      legacyBinding?: {
        __typename?: 'EsReminderLegacyBinding';
        collection: string;
        key: string;
        slot?: string | null;
      } | null;
    } | null;
  } | null;
};

export type EndReminderScheduleMutationVariables = Exact<{
  reminderId: Scalars['ID'];
  reason: Scalars['String'];
  subject?: InputMaybe<Scalars['ID']>;
}>;

export type EndReminderScheduleMutation = {
  __typename?: 'Mutation';
  endReminderSchedule?: {
    __typename?: 'EsReminderCommandResponse';
    success: boolean;
    reminderId: string;
  } | null;
};

export type SkipReminderOccurrenceMutationVariables = Exact<{
  reminderId: Scalars['ID'];
  occurrenceDate: Scalars['String'];
}>;

export type SkipReminderOccurrenceMutation = {
  __typename?: 'Mutation';
  skipReminderOccurrence?: {
    __typename?: 'EsReminderCommandResponse';
    success: boolean;
    reminderId: string;
  } | null;
};

export type AdjustStoppedReminderScheduleMutationVariables = Exact<{
  reminderId: Scalars['ID'];
  schedule: EsReminderScheduleInput;
  subject?: InputMaybe<Scalars['ID']>;
}>;

export type AdjustStoppedReminderScheduleMutation = {
  __typename?: 'Mutation';
  adjustStoppedReminderSchedule?: {
    __typename?: 'EsReminderCommandResponse';
    success: boolean;
    reminderId: string;
  } | null;
};

export type ExposureDataFragment = {
  __typename?: 'Exposure';
  userId?: string | null;
  createdAt: any;
  updatedAt: any;
  type?: number | null;
  fear?: string | null;
  obsession?: string | null;
  safetyBehaviorsToAvoid?: string | null;
  hierarchy?: Array<{
    __typename?: 'ExposureStimulus';
    _id: string;
    exposureId?: string | null;
    createdAt: any;
    updatedAt: any;
    rank?: number | null;
    title?: string | null;
    description?: string | null;
    imageUrls?: Array<string | null> | null;
    imagePrompt?: string | null;
    sud?: number | null;
    avoidance?: number | null;
    worstThingThatCouldHappen?: string | null;
    expositions?: Array<{
      __typename?: 'ExposureStimulusExposition';
      createdAt?: any | null;
      anticipatedSud?: number | null;
      reactionNotes?: string | null;
      expositionId?: string | null;
      duration?: number | null;
      expectedOutcome?: string | null;
      expectedLikelihood?: number | null;
      outcomeOccurred?: ExpositionOutcome | null;
      likelihoodAfter?: number | null;
      learned?: string | null;
      suds?: Array<{
        __typename?: 'SUD';
        sud: number;
        reactedAt: any;
        reactionId?: string | null;
        amendedFrom?: {
          __typename?: 'SUDAmendment';
          sud: number;
          reactedAt: any;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};

export type ExposuresQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['JSON']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type ExposuresQuery = {
  __typename?: 'Query';
  exposures?: {
    __typename?: 'ExposureSearch';
    count: number;
    data?: Array<{
      __typename?: 'Exposure';
      _id: string;
      userId?: string | null;
      createdAt: any;
      updatedAt: any;
      type?: number | null;
      fear?: string | null;
      obsession?: string | null;
      safetyBehaviorsToAvoid?: string | null;
      hierarchy?: Array<{
        __typename?: 'ExposureStimulus';
        _id: string;
        exposureId?: string | null;
        createdAt: any;
        updatedAt: any;
        rank?: number | null;
        title?: string | null;
        description?: string | null;
        imageUrls?: Array<string | null> | null;
        imagePrompt?: string | null;
        sud?: number | null;
        avoidance?: number | null;
        worstThingThatCouldHappen?: string | null;
        expositions?: Array<{
          __typename?: 'ExposureStimulusExposition';
          createdAt?: any | null;
          anticipatedSud?: number | null;
          reactionNotes?: string | null;
          expositionId?: string | null;
          duration?: number | null;
          expectedOutcome?: string | null;
          expectedLikelihood?: number | null;
          outcomeOccurred?: ExpositionOutcome | null;
          likelihoodAfter?: number | null;
          learned?: string | null;
          suds?: Array<{
            __typename?: 'SUD';
            sud: number;
            reactedAt: any;
            reactionId?: string | null;
            amendedFrom?: {
              __typename?: 'SUDAmendment';
              sud: number;
              reactedAt: any;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ExposureQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']>;
}>;

export type ExposureQuery = {
  __typename?: 'Query';
  exposure?: {
    __typename?: 'Exposure';
    _id: string;
    userId?: string | null;
    createdAt: any;
    updatedAt: any;
    type?: number | null;
    fear?: string | null;
    obsession?: string | null;
    safetyBehaviorsToAvoid?: string | null;
    hierarchy?: Array<{
      __typename?: 'ExposureStimulus';
      _id: string;
      exposureId?: string | null;
      createdAt: any;
      updatedAt: any;
      rank?: number | null;
      title?: string | null;
      description?: string | null;
      imageUrls?: Array<string | null> | null;
      imagePrompt?: string | null;
      sud?: number | null;
      avoidance?: number | null;
      worstThingThatCouldHappen?: string | null;
      expositions?: Array<{
        __typename?: 'ExposureStimulusExposition';
        createdAt?: any | null;
        anticipatedSud?: number | null;
        reactionNotes?: string | null;
        expositionId?: string | null;
        duration?: number | null;
        expectedOutcome?: string | null;
        expectedLikelihood?: number | null;
        outcomeOccurred?: ExpositionOutcome | null;
        likelihoodAfter?: number | null;
        learned?: string | null;
        suds?: Array<{
          __typename?: 'SUD';
          sud: number;
          reactedAt: any;
          reactionId?: string | null;
          amendedFrom?: {
            __typename?: 'SUDAmendment';
            sud: number;
            reactedAt: any;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type UpsertExposureMutationVariables = Exact<{
  input?: InputMaybe<ExposureInput>;
}>;

export type UpsertExposureMutation = {
  __typename?: 'Mutation';
  upsertExposure?: {
    __typename?: 'Exposure';
    _id: string;
    userId?: string | null;
    createdAt: any;
    updatedAt: any;
    type?: number | null;
    fear?: string | null;
    obsession?: string | null;
    safetyBehaviorsToAvoid?: string | null;
    hierarchy?: Array<{
      __typename?: 'ExposureStimulus';
      _id: string;
      exposureId?: string | null;
      createdAt: any;
      updatedAt: any;
      rank?: number | null;
      title?: string | null;
      description?: string | null;
      imageUrls?: Array<string | null> | null;
      imagePrompt?: string | null;
      sud?: number | null;
      avoidance?: number | null;
      worstThingThatCouldHappen?: string | null;
      expositions?: Array<{
        __typename?: 'ExposureStimulusExposition';
        createdAt?: any | null;
        anticipatedSud?: number | null;
        reactionNotes?: string | null;
        expositionId?: string | null;
        duration?: number | null;
        expectedOutcome?: string | null;
        expectedLikelihood?: number | null;
        outcomeOccurred?: ExpositionOutcome | null;
        likelihoodAfter?: number | null;
        learned?: string | null;
        suds?: Array<{
          __typename?: 'SUD';
          sud: number;
          reactedAt: any;
          reactionId?: string | null;
          amendedFrom?: {
            __typename?: 'SUDAmendment';
            sud: number;
            reactedAt: any;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ExposureStimulusEsDataFragment = {
  __typename?: 'ExposureStimulus';
  _id: string;
  exposureId?: string | null;
  createdAt: any;
  updatedAt: any;
  rank?: number | null;
  title?: string | null;
  description?: string | null;
  imageUrls?: Array<string | null> | null;
  imagePrompt?: string | null;
  sud?: number | null;
  avoidance?: number | null;
  worstThingThatCouldHappen?: string | null;
  expositions?: Array<{
    __typename?: 'ExposureStimulusExposition';
    createdAt?: any | null;
    anticipatedSud?: number | null;
    reactionNotes?: string | null;
    expositionId?: string | null;
    duration?: number | null;
    expectedOutcome?: string | null;
    expectedLikelihood?: number | null;
    outcomeOccurred?: ExpositionOutcome | null;
    likelihoodAfter?: number | null;
    learned?: string | null;
    suds?: Array<{
      __typename?: 'SUD';
      sud: number;
      reactedAt: any;
      reactionId?: string | null;
      amendedFrom?: {
        __typename?: 'SUDAmendment';
        sud: number;
        reactedAt: any;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type StartExpositionMutationVariables = Exact<{
  input: StartExpositionInput;
}>;

export type StartExpositionMutation = {
  __typename?: 'Mutation';
  startExposition?: {
    __typename?: 'ExpositionPayload';
    expositionId: string;
    exposureStimulus?: {
      __typename?: 'ExposureStimulus';
      _id: string;
      exposureId?: string | null;
      createdAt: any;
      updatedAt: any;
      rank?: number | null;
      title?: string | null;
      description?: string | null;
      imageUrls?: Array<string | null> | null;
      imagePrompt?: string | null;
      sud?: number | null;
      avoidance?: number | null;
      worstThingThatCouldHappen?: string | null;
      expositions?: Array<{
        __typename?: 'ExposureStimulusExposition';
        createdAt?: any | null;
        anticipatedSud?: number | null;
        reactionNotes?: string | null;
        expositionId?: string | null;
        duration?: number | null;
        expectedOutcome?: string | null;
        expectedLikelihood?: number | null;
        outcomeOccurred?: ExpositionOutcome | null;
        likelihoodAfter?: number | null;
        learned?: string | null;
        suds?: Array<{
          __typename?: 'SUD';
          sud: number;
          reactedAt: any;
          reactionId?: string | null;
          amendedFrom?: {
            __typename?: 'SUDAmendment';
            sud: number;
            reactedAt: any;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type RecordExpositionReactionMutationVariables = Exact<{
  input: RecordExpositionReactionInput;
}>;

export type RecordExpositionReactionMutation = {
  __typename?: 'Mutation';
  recordExpositionReaction?: {
    __typename?: 'ExpositionPayload';
    expositionId: string;
    reactionId?: string | null;
    exposureStimulus?: {
      __typename?: 'ExposureStimulus';
      _id: string;
      exposureId?: string | null;
      createdAt: any;
      updatedAt: any;
      rank?: number | null;
      title?: string | null;
      description?: string | null;
      imageUrls?: Array<string | null> | null;
      imagePrompt?: string | null;
      sud?: number | null;
      avoidance?: number | null;
      worstThingThatCouldHappen?: string | null;
      expositions?: Array<{
        __typename?: 'ExposureStimulusExposition';
        createdAt?: any | null;
        anticipatedSud?: number | null;
        reactionNotes?: string | null;
        expositionId?: string | null;
        duration?: number | null;
        expectedOutcome?: string | null;
        expectedLikelihood?: number | null;
        outcomeOccurred?: ExpositionOutcome | null;
        likelihoodAfter?: number | null;
        learned?: string | null;
        suds?: Array<{
          __typename?: 'SUD';
          sud: number;
          reactedAt: any;
          reactionId?: string | null;
          amendedFrom?: {
            __typename?: 'SUDAmendment';
            sud: number;
            reactedAt: any;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type FinishExpositionMutationVariables = Exact<{
  input: FinishExpositionInput;
}>;

export type FinishExpositionMutation = {
  __typename?: 'Mutation';
  finishExposition?: {
    __typename?: 'ExpositionPayload';
    expositionId: string;
    exposureStimulus?: {
      __typename?: 'ExposureStimulus';
      _id: string;
      exposureId?: string | null;
      createdAt: any;
      updatedAt: any;
      rank?: number | null;
      title?: string | null;
      description?: string | null;
      imageUrls?: Array<string | null> | null;
      imagePrompt?: string | null;
      sud?: number | null;
      avoidance?: number | null;
      worstThingThatCouldHappen?: string | null;
      expositions?: Array<{
        __typename?: 'ExposureStimulusExposition';
        createdAt?: any | null;
        anticipatedSud?: number | null;
        reactionNotes?: string | null;
        expositionId?: string | null;
        duration?: number | null;
        expectedOutcome?: string | null;
        expectedLikelihood?: number | null;
        outcomeOccurred?: ExpositionOutcome | null;
        likelihoodAfter?: number | null;
        learned?: string | null;
        suds?: Array<{
          __typename?: 'SUD';
          sud: number;
          reactedAt: any;
          reactionId?: string | null;
          amendedFrom?: {
            __typename?: 'SUDAmendment';
            sud: number;
            reactedAt: any;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type AmendExpositionReactionMutationVariables = Exact<{
  input: AmendExpositionReactionInput;
}>;

export type AmendExpositionReactionMutation = {
  __typename?: 'Mutation';
  amendExpositionReaction?: {
    __typename?: 'ExpositionPayload';
    expositionId: string;
    reactionId?: string | null;
    exposureStimulus?: {
      __typename?: 'ExposureStimulus';
      _id: string;
      exposureId?: string | null;
      createdAt: any;
      updatedAt: any;
      rank?: number | null;
      title?: string | null;
      description?: string | null;
      imageUrls?: Array<string | null> | null;
      imagePrompt?: string | null;
      sud?: number | null;
      avoidance?: number | null;
      worstThingThatCouldHappen?: string | null;
      expositions?: Array<{
        __typename?: 'ExposureStimulusExposition';
        createdAt?: any | null;
        anticipatedSud?: number | null;
        reactionNotes?: string | null;
        expositionId?: string | null;
        duration?: number | null;
        expectedOutcome?: string | null;
        expectedLikelihood?: number | null;
        outcomeOccurred?: ExpositionOutcome | null;
        likelihoodAfter?: number | null;
        learned?: string | null;
        suds?: Array<{
          __typename?: 'SUD';
          sud: number;
          reactedAt: any;
          reactionId?: string | null;
          amendedFrom?: {
            __typename?: 'SUDAmendment';
            sud: number;
            reactedAt: any;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null;
  } | null;
};

export type SudDataFragment = {
  __typename?: 'SUD';
  sud: number;
  reactedAt: any;
  reactionId?: string | null;
  amendedFrom?: {
    __typename?: 'SUDAmendment';
    sud: number;
    reactedAt: any;
  } | null;
};

export type SudExposureStimulusExpositionDataFragment = {
  __typename?: 'ExposureStimulusExposition';
  createdAt?: any | null;
  anticipatedSud?: number | null;
  reactionNotes?: string | null;
  expositionId?: string | null;
  duration?: number | null;
  expectedOutcome?: string | null;
  expectedLikelihood?: number | null;
  outcomeOccurred?: ExpositionOutcome | null;
  likelihoodAfter?: number | null;
  learned?: string | null;
  suds?: Array<{
    __typename?: 'SUD';
    sud: number;
    reactedAt: any;
    reactionId?: string | null;
    amendedFrom?: {
      __typename?: 'SUDAmendment';
      sud: number;
      reactedAt: any;
    } | null;
  } | null> | null;
};

export type ExposureStimulusDataFragment = {
  __typename?: 'ExposureStimulus';
  exposureId?: string | null;
  createdAt: any;
  updatedAt: any;
  rank?: number | null;
  title?: string | null;
  description?: string | null;
  imageUrls?: Array<string | null> | null;
  imagePrompt?: string | null;
  sud?: number | null;
  avoidance?: number | null;
  worstThingThatCouldHappen?: string | null;
  expositions?: Array<{
    __typename?: 'ExposureStimulusExposition';
    createdAt?: any | null;
    anticipatedSud?: number | null;
    reactionNotes?: string | null;
    expositionId?: string | null;
    duration?: number | null;
    expectedOutcome?: string | null;
    expectedLikelihood?: number | null;
    outcomeOccurred?: ExpositionOutcome | null;
    likelihoodAfter?: number | null;
    learned?: string | null;
    suds?: Array<{
      __typename?: 'SUD';
      sud: number;
      reactedAt: any;
      reactionId?: string | null;
      amendedFrom?: {
        __typename?: 'SUDAmendment';
        sud: number;
        reactedAt: any;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type ExposureStimuliQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['JSON']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type ExposureStimuliQuery = {
  __typename?: 'Query';
  exposureStimuli?: {
    __typename?: 'ExposureStimulusSearch';
    count: number;
    data?: Array<{
      __typename?: 'ExposureStimulus';
      _id: string;
      exposureId?: string | null;
      createdAt: any;
      updatedAt: any;
      rank?: number | null;
      title?: string | null;
      description?: string | null;
      imageUrls?: Array<string | null> | null;
      imagePrompt?: string | null;
      sud?: number | null;
      avoidance?: number | null;
      worstThingThatCouldHappen?: string | null;
      expositions?: Array<{
        __typename?: 'ExposureStimulusExposition';
        createdAt?: any | null;
        anticipatedSud?: number | null;
        reactionNotes?: string | null;
        expositionId?: string | null;
        duration?: number | null;
        expectedOutcome?: string | null;
        expectedLikelihood?: number | null;
        outcomeOccurred?: ExpositionOutcome | null;
        likelihoodAfter?: number | null;
        learned?: string | null;
        suds?: Array<{
          __typename?: 'SUD';
          sud: number;
          reactedAt: any;
          reactionId?: string | null;
          amendedFrom?: {
            __typename?: 'SUDAmendment';
            sud: number;
            reactedAt: any;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ExposureStimulusQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']>;
}>;

export type ExposureStimulusQuery = {
  __typename?: 'Query';
  exposureStimulus?: {
    __typename?: 'ExposureStimulus';
    _id: string;
    exposureId?: string | null;
    createdAt: any;
    updatedAt: any;
    rank?: number | null;
    title?: string | null;
    description?: string | null;
    imageUrls?: Array<string | null> | null;
    imagePrompt?: string | null;
    sud?: number | null;
    avoidance?: number | null;
    worstThingThatCouldHappen?: string | null;
    expositions?: Array<{
      __typename?: 'ExposureStimulusExposition';
      createdAt?: any | null;
      anticipatedSud?: number | null;
      reactionNotes?: string | null;
      expositionId?: string | null;
      duration?: number | null;
      expectedOutcome?: string | null;
      expectedLikelihood?: number | null;
      outcomeOccurred?: ExpositionOutcome | null;
      likelihoodAfter?: number | null;
      learned?: string | null;
      suds?: Array<{
        __typename?: 'SUD';
        sud: number;
        reactedAt: any;
        reactionId?: string | null;
        amendedFrom?: {
          __typename?: 'SUDAmendment';
          sud: number;
          reactedAt: any;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type UpsertExposureStimulusMutationVariables = Exact<{
  input?: InputMaybe<ExposureStimulusInput>;
}>;

export type UpsertExposureStimulusMutation = {
  __typename?: 'Mutation';
  upsertExposureStimulus?: {
    __typename?: 'ExposureStimulus';
    _id: string;
    exposureId?: string | null;
    createdAt: any;
    updatedAt: any;
    rank?: number | null;
    title?: string | null;
    description?: string | null;
    imageUrls?: Array<string | null> | null;
    imagePrompt?: string | null;
    sud?: number | null;
    avoidance?: number | null;
    worstThingThatCouldHappen?: string | null;
    expositions?: Array<{
      __typename?: 'ExposureStimulusExposition';
      createdAt?: any | null;
      anticipatedSud?: number | null;
      reactionNotes?: string | null;
      expositionId?: string | null;
      duration?: number | null;
      expectedOutcome?: string | null;
      expectedLikelihood?: number | null;
      outcomeOccurred?: ExpositionOutcome | null;
      likelihoodAfter?: number | null;
      learned?: string | null;
      suds?: Array<{
        __typename?: 'SUD';
        sud: number;
        reactedAt: any;
        reactionId?: string | null;
        amendedFrom?: {
          __typename?: 'SUDAmendment';
          sud: number;
          reactedAt: any;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type UpdateExposureStimuliMutationVariables = Exact<{
  input?: InputMaybe<UpdateExposureStimuliInput>;
}>;

export type UpdateExposureStimuliMutation = {
  __typename?: 'Mutation';
  updateExposureStimuli?: Array<{
    __typename?: 'ExposureStimulus';
    _id: string;
    exposureId?: string | null;
    createdAt: any;
    updatedAt: any;
    rank?: number | null;
    title?: string | null;
    description?: string | null;
    imageUrls?: Array<string | null> | null;
    imagePrompt?: string | null;
    sud?: number | null;
    avoidance?: number | null;
    worstThingThatCouldHappen?: string | null;
    expositions?: Array<{
      __typename?: 'ExposureStimulusExposition';
      createdAt?: any | null;
      anticipatedSud?: number | null;
      reactionNotes?: string | null;
      expositionId?: string | null;
      duration?: number | null;
      expectedOutcome?: string | null;
      expectedLikelihood?: number | null;
      outcomeOccurred?: ExpositionOutcome | null;
      likelihoodAfter?: number | null;
      learned?: string | null;
      suds?: Array<{
        __typename?: 'SUD';
        sud: number;
        reactedAt: any;
        reactionId?: string | null;
        amendedFrom?: {
          __typename?: 'SUDAmendment';
          sud: number;
          reactedAt: any;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};

export type DeleteExposureStimulusMutationVariables = Exact<{
  input?: InputMaybe<DeleteExposureStimulusInput>;
}>;

export type DeleteExposureStimulusMutation = {
  __typename?: 'Mutation';
  deleteExposureStimulus?: {
    __typename?: 'ExposureStimulus';
    _id: string;
    exposureId?: string | null;
    createdAt: any;
    updatedAt: any;
    rank?: number | null;
    title?: string | null;
    description?: string | null;
    imageUrls?: Array<string | null> | null;
    imagePrompt?: string | null;
    sud?: number | null;
    avoidance?: number | null;
    worstThingThatCouldHappen?: string | null;
    expositions?: Array<{
      __typename?: 'ExposureStimulusExposition';
      createdAt?: any | null;
      anticipatedSud?: number | null;
      reactionNotes?: string | null;
      expositionId?: string | null;
      duration?: number | null;
      expectedOutcome?: string | null;
      expectedLikelihood?: number | null;
      outcomeOccurred?: ExpositionOutcome | null;
      likelihoodAfter?: number | null;
      learned?: string | null;
      suds?: Array<{
        __typename?: 'SUD';
        sud: number;
        reactedAt: any;
        reactionId?: string | null;
        amendedFrom?: {
          __typename?: 'SUDAmendment';
          sud: number;
          reactedAt: any;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type GenerateDalleImageMutationVariables = Exact<{
  content: Scalars['String'];
  lng: Scalars['String'];
  exposureId?: InputMaybe<Scalars['ID']>;
}>;

export type GenerateDalleImageMutation = {
  __typename?: 'Mutation';
  generateDalleImage?: {
    __typename?: 'GenerateDalleImageResponse';
    contentUrl?: string | null;
    status?: string | null;
    errorMessage?: string | null;
    code?: string | null;
  } | null;
};

export type UpdateExposureStimulusMutationVariables = Exact<{
  id: Scalars['ID'];
  data: ExposureStimulusInputData;
}>;

export type UpdateExposureStimulusMutation = {
  __typename?: 'Mutation';
  updateExposureStimulus?: {
    __typename?: 'ExposureStimulus';
    _id: string;
    exposureId?: string | null;
    createdAt: any;
    updatedAt: any;
    rank?: number | null;
    title?: string | null;
    description?: string | null;
    imageUrls?: Array<string | null> | null;
    imagePrompt?: string | null;
    sud?: number | null;
    avoidance?: number | null;
    worstThingThatCouldHappen?: string | null;
    expositions?: Array<{
      __typename?: 'ExposureStimulusExposition';
      createdAt?: any | null;
      anticipatedSud?: number | null;
      reactionNotes?: string | null;
      expositionId?: string | null;
      duration?: number | null;
      expectedOutcome?: string | null;
      expectedLikelihood?: number | null;
      outcomeOccurred?: ExpositionOutcome | null;
      likelihoodAfter?: number | null;
      learned?: string | null;
      suds?: Array<{
        __typename?: 'SUD';
        sud: number;
        reactedAt: any;
        reactionId?: string | null;
        amendedFrom?: {
          __typename?: 'SUDAmendment';
          sud: number;
          reactedAt: any;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type FaCountedFieldsFragment = {
  __typename?: 'FaCounted';
  text: string;
  count: number;
};

export type FaIdeaFieldsFragment = {
  __typename?: 'FaIdea';
  instead: string;
  tool?: string | null;
  times: number;
};

export type FaDayFieldsFragment = {
  __typename?: 'FaDay';
  date: string;
  count: number;
  urge?: number | null;
  urgeOnly: number;
  from: string;
};

export type FaRecurringFieldsFragment = {
  __typename?: 'FaRecurring';
  promptingEvents: Array<{
    __typename?: 'FaCounted';
    text: string;
    count: number;
  }>;
  vulnerabilities: Array<{
    __typename?: 'FaCounted';
    text: string;
    count: number;
  }>;
  links: {
    __typename?: 'FaLinkCounts';
    event: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
    thought: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
    feeling: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
    body: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
    action: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
  };
  rightAway: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
  later: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
  nextTime: Array<{
    __typename?: 'FaIdea';
    instead: string;
    tool?: string | null;
    times: number;
  }>;
};

export type SetTargetBehaviorMutationVariables = Exact<{
  input: SetTargetBehaviorInput;
}>;

export type SetTargetBehaviorMutation = {
  __typename?: 'Mutation';
  setTargetBehavior: {
    __typename?: 'FaCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type RetireTargetBehaviorMutationVariables = Exact<{
  input: RetireTargetBehaviorInput;
}>;

export type RetireTargetBehaviorMutation = {
  __typename?: 'Mutation';
  retireTargetBehavior: {
    __typename?: 'FaCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type RecordBehaviorInstanceMutationVariables = Exact<{
  input: RecordBehaviorInstanceInput;
}>;

export type RecordBehaviorInstanceMutation = {
  __typename?: 'Mutation';
  recordBehaviorInstance: {
    __typename?: 'FaCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type PlanContingencyChangeMutationVariables = Exact<{
  input: PlanContingencyChangeInput;
}>;

export type PlanContingencyChangeMutation = {
  __typename?: 'Mutation';
  planContingencyChange: {
    __typename?: 'FaCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type MarkChangeDayMutationVariables = Exact<{
  input: MarkChangeDayInput;
}>;

export type MarkChangeDayMutation = {
  __typename?: 'Mutation';
  markChangeDay: {
    __typename?: 'FaCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type MyTargetBehaviorsQueryVariables = Exact<{
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type MyTargetBehaviorsQuery = {
  __typename?: 'Query';
  myTargetBehaviors: {
    __typename?: 'MyTargetBehaviors';
    subject: string;
    today: string;
    targets: Array<{
      __typename?: 'MyTargetBehavior';
      targetId: string;
      name: string;
      description?: string | null;
      measure: string;
      addedByMe: boolean;
      canClose: boolean;
      records: number;
      threshold: number;
      stage: string;
      thisWeek: {
        __typename?: 'FaWeekFigures';
        done: number;
        urgeOnly: number;
        urgeMax?: number | null;
      };
      days: Array<{
        __typename?: 'FaDay';
        date: string;
        count: number;
        urge?: number | null;
        urgeOnly: number;
        from: string;
      }>;
      instances: Array<{
        __typename?: 'FaInstanceBrief';
        happenedAt: any;
        didBehavior: boolean;
        urge?: number | null;
      }>;
      change?: {
        __typename?: 'FaChangeInForce';
        changeId: string;
        whatChanges: string;
        expectedEffect?: string | null;
        startsOn: string;
        byMe: boolean;
        started: boolean;
        markedDays: number;
        today?: string | null;
        doneDays: {
          __typename?: 'FaDoneDays';
          yes: number;
          partly: number;
          no: number;
        };
      } | null;
      mostMarked?: {
        __typename?: 'FaIdea';
        instead: string;
        tool?: string | null;
        times: number;
      } | null;
    }>;
  };
};

export type WhatINoticedQueryVariables = Exact<{
  targetId: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type WhatINoticedQuery = {
  __typename?: 'Query';
  whatINoticed: {
    __typename?: 'WhatINoticed';
    targetId: string;
    subject: string;
    name: string;
    records: number;
    threshold: number;
    enough: boolean;
    promptingEvents: Array<{
      __typename?: 'FaCounted';
      text: string;
      count: number;
    }>;
    vulnerabilities: Array<{
      __typename?: 'FaCounted';
      text: string;
      count: number;
    }>;
    links: {
      __typename?: 'FaLinkCounts';
      event: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
      thought: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
      feeling: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
      body: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
      action: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
    };
    rightAway: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
    later: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
    nextTime: Array<{
      __typename?: 'FaIdea';
      instead: string;
      tool?: string | null;
      times: number;
    }>;
    suggestion?: {
      __typename?: 'FaIdea';
      instead: string;
      tool?: string | null;
      times: number;
    } | null;
  };
};

export type ClientTargetBehaviorsQueryVariables = Exact<{
  subject: Scalars['ID'];
}>;

export type ClientTargetBehaviorsQuery = {
  __typename?: 'Query';
  clientTargetBehaviors: Array<{
    __typename?: 'ClientTargetBehavior';
    targetId: string;
    name: string;
    measure: string;
    functionHypotheses: Array<string>;
    addedByClient: boolean;
    retired: boolean;
    records: number;
    threshold: number;
    changes: number;
  }>;
};

export type FunctionalAnalysisSummaryQueryVariables = Exact<{
  subject: Scalars['ID'];
  targetId: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type FunctionalAnalysisSummaryQuery = {
  __typename?: 'Query';
  functionalAnalysisSummary: {
    __typename?: 'FunctionalAnalysisSummary';
    subject: string;
    targetId: string;
    records: number;
    threshold: number;
    enough: boolean;
    chains: number;
    urgesOnly: number;
    target: {
      __typename?: 'FaSummaryTarget';
      name: string;
      description?: string | null;
      measure: string;
      functionHypotheses: Array<string>;
      baselineWeeks: number;
      addedByClient: boolean;
      retired: boolean;
      retiredReason?: string | null;
    };
    periods: Array<{
      __typename?: 'FaSummaryPeriod';
      kind: string;
      changeId?: string | null;
      from?: string | null;
      to?: string | null;
      weeks: Array<{
        __typename?: 'FaSummaryWeek';
        weekStart: string;
        done: number;
        urgeOnly: number;
        meanUrge?: number | null;
      }>;
      totals: {
        __typename?: 'FaPeriodTotals';
        days: number;
        done: number;
        urgeOnly: number;
        meanUrge?: number | null;
        perWeek?: number | null;
      };
      changeDays?: {
        __typename?: 'FaPeriodChangeDays';
        yes: number;
        partly: number;
        no: number;
        marked: number;
      } | null;
    }>;
    changes: Array<{
      __typename?: 'FaSummaryChange';
      changeId: string;
      whatChanges: string;
      expectedEffect?: string | null;
      startsOn: string;
      byClient: boolean;
      markedDays: number;
      doneDays: {
        __typename?: 'FaDoneDays';
        yes: number;
        partly: number;
        no: number;
      };
    }>;
    days: Array<{
      __typename?: 'FaDay';
      date: string;
      count: number;
      urge?: number | null;
      urgeOnly: number;
      from: string;
    }>;
    recurring: {
      __typename?: 'FaRecurring';
      promptingEvents: Array<{
        __typename?: 'FaCounted';
        text: string;
        count: number;
      }>;
      vulnerabilities: Array<{
        __typename?: 'FaCounted';
        text: string;
        count: number;
      }>;
      links: {
        __typename?: 'FaLinkCounts';
        event: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
        thought: Array<{
          __typename?: 'FaCounted';
          text: string;
          count: number;
        }>;
        feeling: Array<{
          __typename?: 'FaCounted';
          text: string;
          count: number;
        }>;
        body: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
        action: Array<{
          __typename?: 'FaCounted';
          text: string;
          count: number;
        }>;
      };
      rightAway: Array<{
        __typename?: 'FaCounted';
        text: string;
        count: number;
      }>;
      later: Array<{ __typename?: 'FaCounted'; text: string; count: number }>;
      nextTime: Array<{
        __typename?: 'FaIdea';
        instead: string;
        tool?: string | null;
        times: number;
      }>;
    };
    suggestion?: {
      __typename?: 'FaIdea';
      instead: string;
      tool?: string | null;
      times: number;
    } | null;
  };
};

export type HealthDataAccessQueryVariables = Exact<{ [key: string]: never }>;

export type HealthDataAccessQuery = {
  __typename?: 'Query';
  healthDataAccess: {
    __typename?: 'HealthDataAccess';
    subject: string;
    connected: boolean;
    source?: string | null;
    sharedTypes: Array<string>;
    lastNight?: string | null;
    lastDay?: string | null;
    lastHeartRateDay?: string | null;
    lastImportedAt?: any | null;
    deleteImported?: boolean | null;
    types: Array<{
      __typename?: 'HealthDataTypeAccess';
      type: string;
      shared: boolean;
      since?: any | null;
      lastNight?: string | null;
      lastDay?: string | null;
    }>;
  };
};

export type GrantHealthDataAccessMutationVariables = Exact<{
  input: GrantHealthDataAccessInput;
}>;

export type GrantHealthDataAccessMutation = {
  __typename?: 'Mutation';
  grantHealthDataAccess: {
    __typename?: 'HealthDataCommandPayload';
    recorded: boolean;
  };
};

export type RevokeHealthDataAccessMutationVariables = Exact<{
  input: RevokeHealthDataAccessInput;
}>;

export type RevokeHealthDataAccessMutation = {
  __typename?: 'Mutation';
  revokeHealthDataAccess: {
    __typename?: 'HealthDataCommandPayload';
    recorded: boolean;
  };
};

export type RequestHealthReadMutationVariables = Exact<{
  input: RequestHealthReadInput;
}>;

export type RequestHealthReadMutation = {
  __typename?: 'Mutation';
  requestHealthRead: {
    __typename?: 'HealthDataCommandPayload';
    recorded: boolean;
  };
};

export type TranslateHealthSummariesMutationVariables = Exact<{
  input: TranslateHealthSummariesInput;
}>;

export type TranslateHealthSummariesMutation = {
  __typename?: 'Mutation';
  translateHealthSummaries: {
    __typename?: 'HealthDataCommandPayload';
    recorded: boolean;
  };
};

export type ClientSleepNightFieldsFragment = {
  __typename?: 'ClientSleepNight';
  night: string;
  inBedStart: any;
  inBedEnd: any;
  inBedMinutes: number;
  asleepMinutes: number;
  awakenings: number;
  efficiency?: number | null;
  stages?: {
    __typename?: 'SleepStages';
    deep: number;
    core: number;
    rem: number;
    awake: number;
  } | null;
};

export type ClientActivityDayFieldsFragment = {
  __typename?: 'ClientActivityDay';
  date: string;
  stepCount: number;
  activeMinutes: number;
  workouts: Array<{
    __typename?: 'HealthWorkout';
    type: string;
    start: string;
    minutes: number;
  }>;
};

export type ClientHeartRateDayFieldsFragment = {
  __typename?: 'ClientHeartRateDay';
  date: string;
  restingHeartRate?: number | null;
  hrv?: {
    __typename?: 'HeartRateVariability';
    value: number;
    metric: string;
  } | null;
};

export type ClientSleepSummaryQueryVariables = Exact<{
  days?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type ClientSleepSummaryQuery = {
  __typename?: 'Query';
  clientSleepSummary: {
    __typename?: 'ClientSleepSummary';
    subject: string;
    days: number;
    averageAsleepMinutes?: number | null;
    averageEfficiency?: number | null;
    nights: Array<{
      __typename?: 'ClientSleepNight';
      night: string;
      inBedStart: any;
      inBedEnd: any;
      inBedMinutes: number;
      asleepMinutes: number;
      awakenings: number;
      efficiency?: number | null;
      stages?: {
        __typename?: 'SleepStages';
        deep: number;
        core: number;
        rem: number;
        awake: number;
      } | null;
    }>;
  };
};

export type ClientActivitySummaryQueryVariables = Exact<{
  days?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type ClientActivitySummaryQuery = {
  __typename?: 'Query';
  clientActivitySummary: {
    __typename?: 'ClientActivitySummary';
    subject: string;
    days: number;
    averageSteps?: number | null;
    averageActiveMinutes?: number | null;
    activityDays: Array<{
      __typename?: 'ClientActivityDay';
      date: string;
      stepCount: number;
      activeMinutes: number;
      workouts: Array<{
        __typename?: 'HealthWorkout';
        type: string;
        start: string;
        minutes: number;
      }>;
    }>;
  };
};

export type ClientHeartSummaryQueryVariables = Exact<{
  days?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type ClientHeartSummaryQuery = {
  __typename?: 'Query';
  clientHeartSummary: {
    __typename?: 'ClientHeartSummary';
    subject: string;
    days: number;
    averageRestingHeartRate?: number | null;
    heartRateDays: Array<{
      __typename?: 'ClientHeartRateDay';
      date: string;
      restingHeartRate?: number | null;
      hrv?: {
        __typename?: 'HeartRateVariability';
        value: number;
        metric: string;
      } | null;
    }>;
  };
};

export type HealthDataSharingQueryVariables = Exact<{ [key: string]: never }>;

export type HealthDataSharingQuery = {
  __typename?: 'Query';
  healthDataSharing: {
    __typename?: 'HealthDataSharing';
    subject: string;
    canShare: Array<string>;
    therapists: Array<{
      __typename?: 'HealthDataSharingRow';
      performer: string;
      therapistName: string;
      sleep: boolean;
      activity: boolean;
      heartRate: boolean;
    }>;
  };
};

export type SetHealthDataSharingMutationVariables = Exact<{
  input: SetHealthDataSharingInput;
}>;

export type SetHealthDataSharingMutation = {
  __typename?: 'Mutation';
  setHealthDataSharing: {
    __typename?: 'HealthDataCommandPayload';
    recorded: boolean;
  };
};

export type ClientHealthTimelineQueryVariables = Exact<{
  subject: Scalars['ID'];
  days?: InputMaybe<Scalars['Int']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type ClientHealthTimelineQuery = {
  __typename?: 'Query';
  clientHealthTimeline: {
    __typename?: 'ClientHealthTimeline';
    subject: string;
    days: number;
    sharedTypes: Array<string>;
    nights?: Array<{
      __typename?: 'ClientSleepNight';
      night: string;
      inBedStart: any;
      inBedEnd: any;
      inBedMinutes: number;
      asleepMinutes: number;
      awakenings: number;
      efficiency?: number | null;
      stages?: {
        __typename?: 'SleepStages';
        deep: number;
        core: number;
        rem: number;
        awake: number;
      } | null;
    }> | null;
    activityDays?: Array<{
      __typename?: 'ClientActivityDay';
      date: string;
      stepCount: number;
      activeMinutes: number;
      workouts: Array<{
        __typename?: 'HealthWorkout';
        type: string;
        start: string;
        minutes: number;
      }>;
    }> | null;
    heartRateDays?: Array<{
      __typename?: 'ClientHeartRateDay';
      date: string;
      restingHeartRate?: number | null;
      hrv?: {
        __typename?: 'HeartRateVariability';
        value: number;
        metric: string;
      } | null;
    }> | null;
    moodByDay: Array<{
      __typename?: 'HealthTimelineMood';
      day: string;
      mood: number;
    }>;
    scores: Array<{
      __typename?: 'HealthTimelineScore';
      occurredAt: any;
      instrument: string;
      score: number;
    }>;
  };
};

export type HealthReadWindowsQueryVariables = Exact<{ [key: string]: never }>;

export type HealthReadWindowsQuery = {
  __typename?: 'Query';
  healthReadWindows: Array<{
    __typename?: 'HealthReadWindow';
    from: any;
    to: any;
    focus: { __typename?: 'HealthReadFocus'; type: string; ref: string };
  }>;
};

export type ExpositionHeartRateQueryVariables = Exact<{
  expositionId: Scalars['ID'];
}>;

export type ExpositionHeartRateQuery = {
  __typename?: 'Query';
  expositionHeartRate: {
    __typename?: 'ExpositionHeartRate';
    expositionId: string;
    heartRateShared: boolean;
    window?: {
      __typename?: 'ExpositionHeartRateWindow';
      from: any;
      to: any;
      bpm: {
        __typename?: 'HeartRateStats';
        min: number;
        max: number;
        mean: number;
        samples: number;
      };
    } | null;
  };
};

export type PortalExpositionHeartRateQueryVariables = Exact<{
  subject: Scalars['ID'];
  expositionId: Scalars['ID'];
}>;

export type PortalExpositionHeartRateQuery = {
  __typename?: 'Query';
  portalExpositionHeartRate: {
    __typename?: 'PortalExpositionHeartRate';
    expositionId: string;
    sharedTypes: Array<string>;
    window?: {
      __typename?: 'ExpositionHeartRateWindow';
      from: any;
      to: any;
      bpm: {
        __typename?: 'HeartRateStats';
        min: number;
        max: number;
        mean: number;
        samples: number;
      };
    } | null;
  };
};

export type CheckInSleepNightFieldsFragment = {
  __typename?: 'CheckInSleepNight';
  night: string;
  wakeDay: string;
  inBedStart: any;
  inBedEnd: any;
  asleepMinutes: number;
  efficiency?: number | null;
};

export type CheckInActivityDayFieldsFragment = {
  __typename?: 'CheckInActivityDay';
  date: string;
  activeMinutes: number;
};

export type HomeworkTargetFieldsFragment = {
  __typename?: 'HomeworkTarget';
  type: string;
  ref?: string | null;
  version?: number | null;
  source?: string | null;
};

export type HomeworkScheduleFieldsFragment = {
  __typename?: 'EsReminderScheduleValue';
  rrule: string;
  dtstart: string;
  tzid?: string | null;
  exdates: Array<string>;
};

export type HomeworkOccurrenceOutcomeFieldsFragment = {
  __typename?: 'HomeworkOccurrenceOutcome';
  occurrenceAt?: any | null;
  outcome: string;
  at?: any | null;
  repeats?: number | null;
  evidence?: {
    __typename?: 'HomeworkEvidence';
    focusType: string;
    focus: any;
  } | null;
};

export type ClientHomeworkFieldsFragment = {
  __typename?: 'ClientHomework';
  assignmentId: string;
  subject: string;
  requester: string;
  requesterName?: string | null;
  practiceId?: string | null;
  kind: string;
  title: string;
  instructions?: string | null;
  activityTarget?: any | null;
  dueAt?: any | null;
  reminderPolicy: string;
  status: string;
  overdue: boolean;
  nextDueAt?: any | null;
  occurrenceAt?: any | null;
  completedAt?: any | null;
  note?: string | null;
  reasonCode?: string | null;
  reason?: string | null;
  performer?: string | null;
  awaitingReply: boolean;
  clientCommentUnanswered: boolean;
  paperAllowed: boolean;
  lastRemindedAt?: any | null;
  assignedAt: any;
  lastNoticeChannels?: string | null;
  finishedAt?: any | null;
  target?: {
    __typename?: 'HomeworkTarget';
    type: string;
    ref?: string | null;
    version?: number | null;
    source?: string | null;
  } | null;
  schedule?: {
    __typename?: 'EsReminderScheduleValue';
    rrule: string;
    dtstart: string;
    tzid?: string | null;
    exdates: Array<string>;
  } | null;
  source?: {
    __typename?: 'HomeworkSource';
    enrollmentId: string;
    stepId: string;
  } | null;
  evidence?: {
    __typename?: 'HomeworkEvidence';
    focusType: string;
    focus: any;
  } | null;
  paperPhoto?: {
    __typename?: 'HomeworkPaperPhoto';
    fileRef: string;
    takenAt: any;
  } | null;
  outcomes: Array<{
    __typename?: 'HomeworkOccurrenceOutcome';
    occurrenceAt?: any | null;
    outcome: string;
    at?: any | null;
    repeats?: number | null;
    evidence?: {
      __typename?: 'HomeworkEvidence';
      focusType: string;
      focus: any;
    } | null;
  }>;
};

export type MyHomeworkFieldsFragment = {
  __typename?: 'MyHomework';
  assignmentId: string;
  subject: string;
  requester: string;
  requesterName?: string | null;
  title: string;
  instructions?: string | null;
  kind: string;
  activityTarget?: any | null;
  dueAt?: any | null;
  occurrenceAt?: any | null;
  nextDueAt?: any | null;
  status: string;
  overdue: boolean;
  assignedAt: any;
  completedAt?: any | null;
  reminderMessage?: string | null;
  paperAllowed: boolean;
  plannedActivityId?: string | null;
  target?: {
    __typename?: 'HomeworkTarget';
    type: string;
    ref?: string | null;
    version?: number | null;
    source?: string | null;
  } | null;
  schedule?: {
    __typename?: 'EsReminderScheduleValue';
    rrule: string;
    dtstart: string;
    tzid?: string | null;
    exdates: Array<string>;
  } | null;
  outcomes: Array<{
    __typename?: 'HomeworkOccurrenceOutcome';
    occurrenceAt?: any | null;
    outcome: string;
    at?: any | null;
    repeats?: number | null;
    evidence?: {
      __typename?: 'HomeworkEvidence';
      focusType: string;
      focus: any;
    } | null;
  }>;
};

export type ClientHomeworkQueryVariables = Exact<{
  subject: Scalars['ID'];
}>;

export type ClientHomeworkQuery = {
  __typename?: 'Query';
  clientHomework: Array<{
    __typename?: 'ClientHomework';
    assignmentId: string;
    subject: string;
    requester: string;
    requesterName?: string | null;
    practiceId?: string | null;
    kind: string;
    title: string;
    instructions?: string | null;
    activityTarget?: any | null;
    dueAt?: any | null;
    reminderPolicy: string;
    status: string;
    overdue: boolean;
    nextDueAt?: any | null;
    occurrenceAt?: any | null;
    completedAt?: any | null;
    note?: string | null;
    reasonCode?: string | null;
    reason?: string | null;
    performer?: string | null;
    awaitingReply: boolean;
    clientCommentUnanswered: boolean;
    paperAllowed: boolean;
    lastRemindedAt?: any | null;
    assignedAt: any;
    lastNoticeChannels?: string | null;
    finishedAt?: any | null;
    target?: {
      __typename?: 'HomeworkTarget';
      type: string;
      ref?: string | null;
      version?: number | null;
      source?: string | null;
    } | null;
    schedule?: {
      __typename?: 'EsReminderScheduleValue';
      rrule: string;
      dtstart: string;
      tzid?: string | null;
      exdates: Array<string>;
    } | null;
    source?: {
      __typename?: 'HomeworkSource';
      enrollmentId: string;
      stepId: string;
    } | null;
    evidence?: {
      __typename?: 'HomeworkEvidence';
      focusType: string;
      focus: any;
    } | null;
    paperPhoto?: {
      __typename?: 'HomeworkPaperPhoto';
      fileRef: string;
      takenAt: any;
    } | null;
    outcomes: Array<{
      __typename?: 'HomeworkOccurrenceOutcome';
      occurrenceAt?: any | null;
      outcome: string;
      at?: any | null;
      repeats?: number | null;
      evidence?: {
        __typename?: 'HomeworkEvidence';
        focusType: string;
        focus: any;
      } | null;
    }>;
  }>;
};

export type ClientHomeworkPageQueryVariables = Exact<{
  subject: Scalars['ID'];
  status?: InputMaybe<ClientHomeworkChip>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;

export type ClientHomeworkPageQuery = {
  __typename?: 'Query';
  clientHomeworkPage: {
    __typename?: 'ClientHomeworkPage';
    total: number;
    page: number;
    pageSize: number;
    rows: Array<{
      __typename?: 'ClientHomework';
      assignmentId: string;
      subject: string;
      requester: string;
      requesterName?: string | null;
      practiceId?: string | null;
      kind: string;
      title: string;
      instructions?: string | null;
      activityTarget?: any | null;
      dueAt?: any | null;
      reminderPolicy: string;
      status: string;
      overdue: boolean;
      nextDueAt?: any | null;
      occurrenceAt?: any | null;
      completedAt?: any | null;
      note?: string | null;
      reasonCode?: string | null;
      reason?: string | null;
      performer?: string | null;
      awaitingReply: boolean;
      clientCommentUnanswered: boolean;
      paperAllowed: boolean;
      lastRemindedAt?: any | null;
      assignedAt: any;
      lastNoticeChannels?: string | null;
      finishedAt?: any | null;
      target?: {
        __typename?: 'HomeworkTarget';
        type: string;
        ref?: string | null;
        version?: number | null;
        source?: string | null;
      } | null;
      schedule?: {
        __typename?: 'EsReminderScheduleValue';
        rrule: string;
        dtstart: string;
        tzid?: string | null;
        exdates: Array<string>;
      } | null;
      source?: {
        __typename?: 'HomeworkSource';
        enrollmentId: string;
        stepId: string;
      } | null;
      evidence?: {
        __typename?: 'HomeworkEvidence';
        focusType: string;
        focus: any;
      } | null;
      paperPhoto?: {
        __typename?: 'HomeworkPaperPhoto';
        fileRef: string;
        takenAt: any;
      } | null;
      outcomes: Array<{
        __typename?: 'HomeworkOccurrenceOutcome';
        occurrenceAt?: any | null;
        outcome: string;
        at?: any | null;
        repeats?: number | null;
        evidence?: {
          __typename?: 'HomeworkEvidence';
          focusType: string;
          focus: any;
        } | null;
      }>;
    }>;
    counts: {
      __typename?: 'ClientHomeworkCounts';
      all: number;
      open: number;
      overdue: number;
      done: number;
      skipped: number;
      cancelled: number;
      awaitingReply: number;
    };
  };
};

export type ClientHomeworkAccessQueryVariables = Exact<{
  subject: Scalars['ID'];
}>;

export type ClientHomeworkAccessQuery = {
  __typename?: 'Query';
  clientHomeworkAccess: {
    __typename?: 'ClientHomeworkAccess';
    canAssign: boolean;
  };
};

export type MyHomeworkQueryVariables = Exact<{ [key: string]: never }>;

export type MyHomeworkQuery = {
  __typename?: 'Query';
  myHomework: Array<{
    __typename?: 'MyHomework';
    assignmentId: string;
    subject: string;
    requester: string;
    requesterName?: string | null;
    title: string;
    instructions?: string | null;
    kind: string;
    activityTarget?: any | null;
    dueAt?: any | null;
    occurrenceAt?: any | null;
    nextDueAt?: any | null;
    status: string;
    overdue: boolean;
    assignedAt: any;
    completedAt?: any | null;
    reminderMessage?: string | null;
    paperAllowed: boolean;
    plannedActivityId?: string | null;
    target?: {
      __typename?: 'HomeworkTarget';
      type: string;
      ref?: string | null;
      version?: number | null;
      source?: string | null;
    } | null;
    schedule?: {
      __typename?: 'EsReminderScheduleValue';
      rrule: string;
      dtstart: string;
      tzid?: string | null;
      exdates: Array<string>;
    } | null;
    outcomes: Array<{
      __typename?: 'HomeworkOccurrenceOutcome';
      occurrenceAt?: any | null;
      outcome: string;
      at?: any | null;
      repeats?: number | null;
      evidence?: {
        __typename?: 'HomeworkEvidence';
        focusType: string;
        focus: any;
      } | null;
    }>;
  }>;
};

export type MyFinishedHomeworkQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;

export type MyFinishedHomeworkQuery = {
  __typename?: 'Query';
  myFinishedHomework: {
    __typename?: 'MyFinishedHomeworkPage';
    nextCursor?: string | null;
    items: Array<{
      __typename?: 'MyHomework';
      assignmentId: string;
      subject: string;
      requester: string;
      requesterName?: string | null;
      title: string;
      instructions?: string | null;
      kind: string;
      activityTarget?: any | null;
      dueAt?: any | null;
      occurrenceAt?: any | null;
      nextDueAt?: any | null;
      status: string;
      overdue: boolean;
      assignedAt: any;
      completedAt?: any | null;
      reminderMessage?: string | null;
      paperAllowed: boolean;
      plannedActivityId?: string | null;
      target?: {
        __typename?: 'HomeworkTarget';
        type: string;
        ref?: string | null;
        version?: number | null;
        source?: string | null;
      } | null;
      schedule?: {
        __typename?: 'EsReminderScheduleValue';
        rrule: string;
        dtstart: string;
        tzid?: string | null;
        exdates: Array<string>;
      } | null;
      outcomes: Array<{
        __typename?: 'HomeworkOccurrenceOutcome';
        occurrenceAt?: any | null;
        outcome: string;
        at?: any | null;
        repeats?: number | null;
        evidence?: {
          __typename?: 'HomeworkEvidence';
          focusType: string;
          focus: any;
        } | null;
      }>;
    }>;
  };
};

export type MyHomeworkItemQueryVariables = Exact<{
  assignmentId: Scalars['ID'];
}>;

export type MyHomeworkItemQuery = {
  __typename?: 'Query';
  myHomeworkItem?: {
    __typename?: 'MyHomework';
    assignmentId: string;
    subject: string;
    requester: string;
    requesterName?: string | null;
    title: string;
    instructions?: string | null;
    kind: string;
    activityTarget?: any | null;
    dueAt?: any | null;
    occurrenceAt?: any | null;
    nextDueAt?: any | null;
    status: string;
    overdue: boolean;
    assignedAt: any;
    completedAt?: any | null;
    reminderMessage?: string | null;
    paperAllowed: boolean;
    plannedActivityId?: string | null;
    target?: {
      __typename?: 'HomeworkTarget';
      type: string;
      ref?: string | null;
      version?: number | null;
      source?: string | null;
    } | null;
    schedule?: {
      __typename?: 'EsReminderScheduleValue';
      rrule: string;
      dtstart: string;
      tzid?: string | null;
      exdates: Array<string>;
    } | null;
    outcomes: Array<{
      __typename?: 'HomeworkOccurrenceOutcome';
      occurrenceAt?: any | null;
      outcome: string;
      at?: any | null;
      repeats?: number | null;
      evidence?: {
        __typename?: 'HomeworkEvidence';
        focusType: string;
        focus: any;
      } | null;
    }>;
  } | null;
};

export type MyTherapistsQueryVariables = Exact<{ [key: string]: never }>;

export type MyTherapistsQuery = {
  __typename?: 'Query';
  myTherapists: Array<{
    __typename?: 'MyTherapist';
    subject: string;
    performer: string;
  }>;
};

export type AssignHomeworkMutationVariables = Exact<{
  input: AssignHomeworkInput;
}>;

export type AssignHomeworkMutation = {
  __typename?: 'Mutation';
  assignHomework: {
    __typename?: 'HomeworkCommandPayload';
    assignmentId: string;
    recorded: boolean;
  };
};

export type AmendHomeworkMutationVariables = Exact<{
  input: AmendHomeworkInput;
}>;

export type AmendHomeworkMutation = {
  __typename?: 'Mutation';
  amendHomework: {
    __typename?: 'HomeworkCommandPayload';
    assignmentId: string;
    recorded: boolean;
  };
};

export type CancelHomeworkMutationVariables = Exact<{
  input: CancelHomeworkInput;
}>;

export type CancelHomeworkMutation = {
  __typename?: 'Mutation';
  cancelHomework: {
    __typename?: 'HomeworkCommandPayload';
    assignmentId: string;
    recorded: boolean;
  };
};

export type ReopenHomeworkMutationVariables = Exact<{
  input: ReopenHomeworkInput;
}>;

export type ReopenHomeworkMutation = {
  __typename?: 'Mutation';
  reopenHomework: {
    __typename?: 'HomeworkCommandPayload';
    assignmentId: string;
    recorded: boolean;
  };
};

export type AcknowledgeHomeworkMutationVariables = Exact<{
  assignmentId: Scalars['ID'];
}>;

export type AcknowledgeHomeworkMutation = {
  __typename?: 'Mutation';
  acknowledgeHomework: {
    __typename?: 'HomeworkCommandPayload';
    assignmentId: string;
    recorded: boolean;
  };
};

export type CompleteHomeworkMutationVariables = Exact<{
  input: CompleteHomeworkInput;
}>;

export type CompleteHomeworkMutation = {
  __typename?: 'Mutation';
  completeHomework: {
    __typename?: 'HomeworkCommandPayload';
    assignmentId: string;
    recorded: boolean;
  };
};

export type SkipHomeworkMutationVariables = Exact<{
  input: SkipHomeworkInput;
}>;

export type SkipHomeworkMutation = {
  __typename?: 'Mutation';
  skipHomework: {
    __typename?: 'HomeworkCommandPayload';
    assignmentId: string;
    recorded: boolean;
  };
};

export type HomeworkSinceLastSessionQueryVariables = Exact<{
  subject: Scalars['ID'];
  sessionId?: InputMaybe<Scalars['ID']>;
}>;

export type HomeworkSinceLastSessionQuery = {
  __typename?: 'Query';
  homeworkSinceLastSession: Array<{
    __typename?: 'HomeworkSinceLastSession';
    subject: string;
    sessionId?: string | null;
    lastSessionStart?: any | null;
    assignmentId: string;
    title: string;
    kind: string;
    dueAt?: any | null;
    tzid?: string | null;
    status: string;
    overdue: boolean;
    reasonCode?: string | null;
    reason?: string | null;
    completedAt?: any | null;
    outcomeAt?: any | null;
    evidence?: {
      __typename?: 'HomeworkEvidence';
      focusType: string;
      focus: any;
    } | null;
    outcomes: Array<{
      __typename?: 'HomeworkOccurrenceOutcome';
      occurrenceAt?: any | null;
      outcome: string;
      at?: any | null;
      repeats?: number | null;
      evidence?: {
        __typename?: 'HomeworkEvidence';
        focusType: string;
        focus: any;
      } | null;
    }>;
  }>;
};

export type PracticeHomeworkBoardQueryVariables = Exact<{
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type PracticeHomeworkBoardQuery = {
  __typename?: 'Query';
  practiceHomeworkBoard: Array<{
    __typename?: 'PracticeHomeworkBoard';
    practiceId: string;
    subject: string;
    clientName?: string | null;
    therapistName?: string | null;
    openCount: number;
    overdueCount: number;
    doneThisWeek: number;
    awaitingReply: number;
    lastActivityAt?: any | null;
    clientEmail?: string | null;
    enrollmentId?: string | null;
    pathwayId?: string | null;
    pathwayName?: string | null;
    pathwayPercentDone?: number | null;
    pendingDocuments: number;
    assignmentIds: Array<string>;
    homeworkAppReady: boolean;
    lng?: string | null;
  }>;
};

export type RequestHomeworkReminderMutationVariables = Exact<{
  input: RequestHomeworkReminderInput;
}>;

export type RequestHomeworkReminderMutation = {
  __typename?: 'Mutation';
  requestHomeworkReminder: {
    __typename?: 'HomeworkCommandPayload';
    assignmentId: string;
    recorded: boolean;
  };
};

export type HomeworkPaperPhotoUrlQueryVariables = Exact<{
  assignmentId: Scalars['ID'];
  fileRef: Scalars['String'];
}>;

export type HomeworkPaperPhotoUrlQuery = {
  __typename?: 'Query';
  homeworkPaperPhotoUrl: {
    __typename?: 'HomeworkPaperPhotoUrl';
    url: string;
    expiresAt: any;
  };
};

export type HomeworkCommentFieldsFragment = {
  __typename?: 'HomeworkComment';
  commentId: string;
  assignmentId: string;
  performer: string;
  performerName?: string | null;
  fromClient: boolean;
  mine: boolean;
  text: string;
  occurredAt: any;
};

export type HomeworkCommentsQueryVariables = Exact<{
  assignmentId: Scalars['ID'];
}>;

export type HomeworkCommentsQuery = {
  __typename?: 'Query';
  homeworkComments: Array<{
    __typename?: 'HomeworkComment';
    commentId: string;
    assignmentId: string;
    performer: string;
    performerName?: string | null;
    fromClient: boolean;
    mine: boolean;
    text: string;
    occurredAt: any;
  }>;
};

export type CommentOnHomeworkMutationVariables = Exact<{
  input: CommentOnHomeworkInput;
}>;

export type CommentOnHomeworkMutation = {
  __typename?: 'Mutation';
  commentOnHomework: {
    __typename?: 'CommentOnHomeworkPayload';
    assignmentId: string;
    commentId: string;
    recorded: boolean;
  };
};

export type WatchAssignedVideoMutationVariables = Exact<{
  input: WatchAssignedVideoInput;
}>;

export type WatchAssignedVideoMutation = {
  __typename?: 'Mutation';
  watchAssignedVideo: {
    __typename?: 'HomeworkCommandPayload';
    assignmentId: string;
    recorded: boolean;
  };
};

export type InviteDataFragment = {
  __typename?: 'Invite';
  type: number;
  token: string;
  from: string;
  to?: string | null;
  firstName?: string | null;
  email?: string | null;
  message?: string | null;
  createdAt: any;
  expiresAt: any;
};

export type CreateInviteMutationVariables = Exact<{
  input: CreateInviteInput;
}>;

export type CreateInviteMutation = {
  __typename?: 'Mutation';
  createInvite?: {
    __typename?: 'Invite';
    _id: string;
    type: number;
    token: string;
    from: string;
    to?: string | null;
    firstName?: string | null;
    email?: string | null;
    message?: string | null;
    createdAt: any;
    expiresAt: any;
  } | null;
};

export type DeleteInviteMutationVariables = Exact<{
  input: DeleteInviteInput;
}>;

export type DeleteInviteMutation = {
  __typename?: 'Mutation';
  deleteInvite?: {
    __typename?: 'Invite';
    _id: string;
    type: number;
    token: string;
    from: string;
    to?: string | null;
    firstName?: string | null;
    email?: string | null;
    message?: string | null;
    createdAt: any;
    expiresAt: any;
  } | null;
};

export type InvitesQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['JSON']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type InvitesQuery = {
  __typename?: 'Query';
  invites?: {
    __typename?: 'PortalInvites';
    count: number;
    data?: Array<{
      __typename?: 'Invite';
      _id: string;
      type: number;
      token: string;
      from: string;
      to?: string | null;
      firstName?: string | null;
      email?: string | null;
      message?: string | null;
      createdAt: any;
      expiresAt: any;
    } | null> | null;
  } | null;
};

export type InvitesForYouQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['JSON']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type InvitesForYouQuery = {
  __typename?: 'Query';
  invitesForYou?: {
    __typename?: 'PortalInvites';
    count: number;
    data?: Array<{
      __typename?: 'Invite';
      _id: string;
      type: number;
      token: string;
      from: string;
      to?: string | null;
      firstName?: string | null;
      email?: string | null;
      message?: string | null;
      createdAt: any;
      expiresAt: any;
      user?: {
        __typename?: 'User';
        _id: string;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type InviteQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type InviteQuery = {
  __typename?: 'Query';
  invite?: {
    __typename?: 'Invite';
    _id: string;
    type: number;
    token: string;
    from: string;
    to?: string | null;
    firstName?: string | null;
    email?: string | null;
    message?: string | null;
    createdAt: any;
    expiresAt: any;
  } | null;
};

export type InviteByTokenQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
}>;

export type InviteByTokenQuery = {
  __typename?: 'Query';
  inviteByToken?: {
    __typename?: 'Invite';
    _id: string;
    type: number;
    token: string;
    from: string;
    to?: string | null;
    firstName?: string | null;
    email?: string | null;
    message?: string | null;
    createdAt: any;
    expiresAt: any;
  } | null;
};

export type InviteSenderQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
}>;

export type InviteSenderQuery = {
  __typename?: 'Query';
  inviteByToken?: {
    __typename?: 'Invite';
    _id: string;
    type: number;
    from: string;
    user?: {
      __typename?: 'User';
      _id: string;
      firstName?: string | null;
      lastName?: string | null;
      displayName?: string | null;
      practice?: {
        __typename?: 'Practice';
        _id: string;
        practiceName: string;
      } | null;
    } | null;
  } | null;
};

export type LocationReminderDataFragment = {
  __typename?: 'LocationReminder';
  _id: string;
  _key: string;
  _rev: string;
  _from: string;
  _to: string;
  createdAt: any;
  updatedAt: any;
  enter?: boolean | null;
  leave?: boolean | null;
  type: number;
};

export type LocationReminderQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type LocationReminderQuery = {
  __typename?: 'Query';
  locationReminder?: {
    __typename?: 'LocationReminder';
    _id: string;
    _key: string;
    _rev: string;
    _from: string;
    _to: string;
    createdAt: any;
    updatedAt: any;
    enter?: boolean | null;
    leave?: boolean | null;
    type: number;
  } | null;
};

export type LocationRemindersQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type LocationRemindersQuery = {
  __typename?: 'Query';
  locationReminders?: Array<{
    __typename?: 'LocationReminder';
    _id: string;
    _key: string;
    _rev: string;
    _from: string;
    _to: string;
    createdAt: any;
    updatedAt: any;
    enter?: boolean | null;
    leave?: boolean | null;
    type: number;
  } | null> | null;
};

export type LocationRemindersForUserQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LocationRemindersForUserQuery = {
  __typename?: 'Query';
  locationRemindersForUser?: Array<{
    __typename?: 'LocationReminder';
    _id: string;
    _key: string;
    _rev: string;
    _from: string;
    _to: string;
    createdAt: any;
    updatedAt: any;
    enter?: boolean | null;
    leave?: boolean | null;
    type: number;
  } | null> | null;
};

export type EnabledLocationRemindersCountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type EnabledLocationRemindersCountQuery = {
  __typename?: 'Query';
  enabledLocationRemindersCount?: {
    __typename?: 'EnabledLocationRemindersCount';
    enabled: number;
  } | null;
};

export type CreateLocationReminderMutationVariables = Exact<{
  locationReminder: LocationReminderCreateInput;
}>;

export type CreateLocationReminderMutation = {
  __typename?: 'Mutation';
  createLocationReminder?: {
    __typename?: 'LocationReminderResponse';
    locationReminder?: {
      __typename?: 'LocationReminder';
      _id: string;
      _key: string;
      _rev: string;
      _from: string;
      _to: string;
      createdAt: any;
      updatedAt: any;
      enter?: boolean | null;
      leave?: boolean | null;
      type: number;
    } | null;
  } | null;
};

export type UpdateLocationReminderMutationVariables = Exact<{
  locationReminder: LocationReminderUpdateInput;
}>;

export type UpdateLocationReminderMutation = {
  __typename?: 'Mutation';
  updateLocationReminder?: {
    __typename?: 'LocationReminderResponse';
    locationReminder?: {
      __typename?: 'LocationReminder';
      _id: string;
      _key: string;
      _rev: string;
      _from: string;
      _to: string;
      createdAt: any;
      updatedAt: any;
      enter?: boolean | null;
      leave?: boolean | null;
      type: number;
    } | null;
  } | null;
};

export type DeleteLocationReminderMutationVariables = Exact<{
  _id: Scalars['ID'];
}>;

export type DeleteLocationReminderMutation = {
  __typename?: 'Mutation';
  deleteLocationReminder?: {
    __typename?: 'LocationReminderDeleteResponse';
    success?: boolean | null;
    old?: {
      __typename?: 'LocationReminder';
      _id: string;
      _key: string;
      _rev: string;
      _from: string;
      _to: string;
      createdAt: any;
      updatedAt: any;
      enter?: boolean | null;
      leave?: boolean | null;
      type: number;
    } | null;
  } | null;
};

export type KeepLocationRemindersMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;

export type KeepLocationRemindersMutation = {
  __typename?: 'Mutation';
  keepLocationReminders?: {
    __typename?: 'KeepLocationRemindersResponse';
    success?: boolean | null;
  } | null;
};

export type LocationDataFragment = {
  __typename?: 'Location';
  _id: string;
  _key: string;
  _rev: string;
  createdAt: any;
  updatedAt: any;
  name: string;
  latitude: number;
  longitude: number;
};

export type LocationQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type LocationQuery = {
  __typename?: 'Query';
  location?: {
    __typename?: 'Location';
    _id: string;
    _key: string;
    _rev: string;
    createdAt: any;
    updatedAt: any;
    name: string;
    latitude: number;
    longitude: number;
  } | null;
};

export type LocationsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type LocationsQuery = {
  __typename?: 'Query';
  locations?: Array<{
    __typename?: 'Location';
    _id: string;
    _key: string;
    _rev: string;
    createdAt: any;
    updatedAt: any;
    name: string;
    latitude: number;
    longitude: number;
  } | null> | null;
};

export type LocationsForUserQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;

export type LocationsForUserQuery = {
  __typename?: 'Query';
  locationsForUser?: {
    __typename?: 'LocationConnection';
    totalCount: number;
    edges?: Array<{
      __typename?: 'LocationEdge';
      cursor: string;
      node?: {
        __typename?: 'Location';
        _id: string;
        _key: string;
        _rev: string;
        createdAt: any;
        updatedAt: any;
        name: string;
        latitude: number;
        longitude: number;
      } | null;
    } | null> | null;
    pageInfo?: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    } | null;
  } | null;
};

export type CreateLocationMutationVariables = Exact<{
  location: LocationCreateInput;
}>;

export type CreateLocationMutation = {
  __typename?: 'Mutation';
  createLocation?: {
    __typename?: 'LocationResponse';
    location?: {
      __typename?: 'Location';
      _id: string;
      _key: string;
      _rev: string;
      createdAt: any;
      updatedAt: any;
      name: string;
      latitude: number;
      longitude: number;
    } | null;
  } | null;
};

export type UpdateLocationMutationVariables = Exact<{
  location: LocationUpdateInput;
}>;

export type UpdateLocationMutation = {
  __typename?: 'Mutation';
  updateLocation?: {
    __typename?: 'LocationResponse';
    location?: {
      __typename?: 'Location';
      _id: string;
      _key: string;
      _rev: string;
      createdAt: any;
      updatedAt: any;
      name: string;
      latitude: number;
      longitude: number;
    } | null;
  } | null;
};

export type CreateMessageToTherapistMutationVariables = Exact<{
  input: MessageToTherapistInput;
}>;

export type CreateMessageToTherapistMutation = {
  __typename?: 'Mutation';
  createMessageToTherapist?: {
    __typename?: 'MessageCreateUpdateResponse';
    success: boolean;
  } | null;
};

export type UpdateMessageReadMutationVariables = Exact<{
  input: MessageReadInput;
}>;

export type UpdateMessageReadMutation = {
  __typename?: 'Mutation';
  updateMessageRead?: {
    __typename?: 'MessageCreateUpdateResponse';
    success: boolean;
  } | null;
};

export type UricaReadingFieldsFragment = {
  __typename?: 'UricaReading';
  type: number;
  score: number;
  readiness: number;
  stage: string;
  takenAt: any;
};

export type ChangeJourneyFieldsFragment = {
  __typename?: 'ChangeJourney';
  goalId: string;
  subject: string;
  label: string;
  linkedValues: Array<string>;
  status: string;
  outcome?: string | null;
  closingNote?: string | null;
  closedAt?: any | null;
  setBy?: string | null;
  setAt: any;
  myReasons: Array<string>;
  changeTalk: Array<string>;
  lastActivityAt: any;
  rulersOverTime: Array<{
    __typename?: 'ChangeRulersAt';
    occurredAt: any;
    importance: number;
    confidence: number;
    readiness: number;
    focusedRuler?: string | null;
  }>;
  balance?: {
    __typename?: 'ChangeBalance';
    prosOfStaying: Array<string>;
    consOfStaying: Array<string>;
    consOfChange: Array<string>;
    prosOfChange: Array<string>;
    writtenAt: any;
  } | null;
  plan?: {
    __typename?: 'ChangePlan';
    changes: string;
    reasons: Array<string>;
    helpers: Array<string>;
    signsOfSuccess?: string | null;
    writtenAt: any;
    planSteps: Array<{
      __typename?: 'ChangePlanStep';
      step: string;
      when?: string | null;
    }>;
    obstacles: Array<{
      __typename?: 'ChangePlanObstacle';
      obstacle: string;
      response?: string | null;
    }>;
  } | null;
  journal: Array<{
    __typename?: 'ChangeTalkLine';
    noteId: string;
    noticedAt: any;
    kind?: string | null;
    talk: string;
  }>;
  urica?: {
    __typename?: 'UricaReading';
    type: number;
    score: number;
    readiness: number;
    stage: string;
    takenAt: any;
  } | null;
};

export type MyChangesQueryVariables = Exact<{ [key: string]: never }>;

export type MyChangesQuery = {
  __typename?: 'Query';
  myChanges: {
    __typename?: 'MyChanges';
    subject: string;
    changes: Array<{
      __typename?: 'MyChange';
      goalId: string;
      label: string;
      linkedValues: Array<string>;
      status: string;
      outcome?: string | null;
      lastActivityAt: any;
    }>;
  };
};

export type ChangeJourneyQueryVariables = Exact<{
  goalId: Scalars['ID'];
}>;

export type ChangeJourneyQuery = {
  __typename?: 'Query';
  changeJourney: {
    __typename?: 'ChangeJourney';
    goalId: string;
    subject: string;
    label: string;
    linkedValues: Array<string>;
    status: string;
    outcome?: string | null;
    closingNote?: string | null;
    closedAt?: any | null;
    setBy?: string | null;
    setAt: any;
    myReasons: Array<string>;
    changeTalk: Array<string>;
    lastActivityAt: any;
    rulersOverTime: Array<{
      __typename?: 'ChangeRulersAt';
      occurredAt: any;
      importance: number;
      confidence: number;
      readiness: number;
      focusedRuler?: string | null;
    }>;
    balance?: {
      __typename?: 'ChangeBalance';
      prosOfStaying: Array<string>;
      consOfStaying: Array<string>;
      consOfChange: Array<string>;
      prosOfChange: Array<string>;
      writtenAt: any;
    } | null;
    plan?: {
      __typename?: 'ChangePlan';
      changes: string;
      reasons: Array<string>;
      helpers: Array<string>;
      signsOfSuccess?: string | null;
      writtenAt: any;
      planSteps: Array<{
        __typename?: 'ChangePlanStep';
        step: string;
        when?: string | null;
      }>;
      obstacles: Array<{
        __typename?: 'ChangePlanObstacle';
        obstacle: string;
        response?: string | null;
      }>;
    } | null;
    journal: Array<{
      __typename?: 'ChangeTalkLine';
      noteId: string;
      noticedAt: any;
      kind?: string | null;
      talk: string;
    }>;
    urica?: {
      __typename?: 'UricaReading';
      type: number;
      score: number;
      readiness: number;
      stage: string;
      takenAt: any;
    } | null;
  };
};

export type ClientChangeGoalsQueryVariables = Exact<{
  subject: Scalars['ID'];
}>;

export type ClientChangeGoalsQuery = {
  __typename?: 'Query';
  clientChangeGoals: {
    __typename?: 'ClientChangeGoals';
    subject: string;
    changes: Array<{
      __typename?: 'ChangeJourney';
      goalId: string;
      subject: string;
      label: string;
      linkedValues: Array<string>;
      status: string;
      outcome?: string | null;
      closingNote?: string | null;
      closedAt?: any | null;
      setBy?: string | null;
      setAt: any;
      myReasons: Array<string>;
      changeTalk: Array<string>;
      lastActivityAt: any;
      rulersOverTime: Array<{
        __typename?: 'ChangeRulersAt';
        occurredAt: any;
        importance: number;
        confidence: number;
        readiness: number;
        focusedRuler?: string | null;
      }>;
      balance?: {
        __typename?: 'ChangeBalance';
        prosOfStaying: Array<string>;
        consOfStaying: Array<string>;
        consOfChange: Array<string>;
        prosOfChange: Array<string>;
        writtenAt: any;
      } | null;
      plan?: {
        __typename?: 'ChangePlan';
        changes: string;
        reasons: Array<string>;
        helpers: Array<string>;
        signsOfSuccess?: string | null;
        writtenAt: any;
        planSteps: Array<{
          __typename?: 'ChangePlanStep';
          step: string;
          when?: string | null;
        }>;
        obstacles: Array<{
          __typename?: 'ChangePlanObstacle';
          obstacle: string;
          response?: string | null;
        }>;
      } | null;
      journal: Array<{
        __typename?: 'ChangeTalkLine';
        noteId: string;
        noticedAt: any;
        kind?: string | null;
        talk: string;
      }>;
      urica?: {
        __typename?: 'UricaReading';
        type: number;
        score: number;
        readiness: number;
        stage: string;
        takenAt: any;
      } | null;
    }>;
    urica?: {
      __typename?: 'UricaReading';
      type: number;
      score: number;
      readiness: number;
      stage: string;
      takenAt: any;
    } | null;
  };
};

export type SetChangeGoalMutationVariables = Exact<{
  input: SetChangeGoalInput;
}>;

export type SetChangeGoalMutation = {
  __typename?: 'Mutation';
  setChangeGoal: {
    __typename?: 'MiCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type RateChangeMutationVariables = Exact<{
  input: RateChangeInput;
}>;

export type RateChangeMutation = {
  __typename?: 'Mutation';
  rateChange: {
    __typename?: 'MiCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type WriteDecisionalBalanceMutationVariables = Exact<{
  input: WriteDecisionalBalanceInput;
}>;

export type WriteDecisionalBalanceMutation = {
  __typename?: 'Mutation';
  writeDecisionalBalance: {
    __typename?: 'MiCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type WriteChangePlanMutationVariables = Exact<{
  input: WriteChangePlanInput;
}>;

export type WriteChangePlanMutation = {
  __typename?: 'Mutation';
  writeChangePlan: {
    __typename?: 'MiCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type NoteChangeTalkMutationVariables = Exact<{
  input: NoteChangeTalkInput;
}>;

export type NoteChangeTalkMutation = {
  __typename?: 'Mutation';
  noteChangeTalk: {
    __typename?: 'MiCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type CloseChangeGoalMutationVariables = Exact<{
  input: CloseChangeGoalInput;
}>;

export type CloseChangeGoalMutation = {
  __typename?: 'Mutation';
  closeChangeGoal: {
    __typename?: 'MiCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type ReopenChangeGoalMutationVariables = Exact<{
  input: ReopenChangeGoalInput;
}>;

export type ReopenChangeGoalMutation = {
  __typename?: 'Mutation';
  reopenChangeGoal: {
    __typename?: 'MiCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type PathwayReleaseRuleFieldsFragment = {
  __typename?: 'PathwayReleaseRule';
  rule: string;
  day?: number | null;
  delayDays?: number | null;
};

export type PathwayStepFieldsFragment = {
  __typename?: 'PathwayStep';
  stepId: string;
  kind: string;
  title: string;
  instructions?: string | null;
  dueDays?: number | null;
  target?: {
    __typename?: 'HomeworkTarget';
    type: string;
    ref?: string | null;
    version?: number | null;
    source?: string | null;
  } | null;
  release: {
    __typename?: 'PathwayReleaseRule';
    rule: string;
    day?: number | null;
    delayDays?: number | null;
  };
};

export type PathwaySectionFieldsFragment = {
  __typename?: 'PathwaySection';
  section: string;
  steps: Array<{
    __typename?: 'PathwayStep';
    stepId: string;
    kind: string;
    title: string;
    instructions?: string | null;
    dueDays?: number | null;
    target?: {
      __typename?: 'HomeworkTarget';
      type: string;
      ref?: string | null;
      version?: number | null;
      source?: string | null;
    } | null;
    release: {
      __typename?: 'PathwayReleaseRule';
      rule: string;
      day?: number | null;
      delayDays?: number | null;
    };
  }>;
};

export type PathwayStepProgressFieldsFragment = {
  __typename?: 'PathwayStepProgress';
  stepId: string;
  kind: string;
  title: string;
  instructions?: string | null;
  dueDays?: number | null;
  state: string;
  releasedAt?: any | null;
  assignmentId?: string | null;
  outcomeAt?: any | null;
  cancelled: boolean;
  releaseAt?: any | null;
  target?: {
    __typename?: 'HomeworkTarget';
    type: string;
    ref?: string | null;
    version?: number | null;
    source?: string | null;
  } | null;
  release: {
    __typename?: 'PathwayReleaseRule';
    rule: string;
    day?: number | null;
    delayDays?: number | null;
  };
  evidence?: {
    __typename?: 'HomeworkEvidence';
    focusType: string;
    focus: any;
  } | null;
};

export type PathwaySectionProgressFieldsFragment = {
  __typename?: 'PathwaySectionProgress';
  section: string;
  steps: Array<{
    __typename?: 'PathwayStepProgress';
    stepId: string;
    kind: string;
    title: string;
    instructions?: string | null;
    dueDays?: number | null;
    state: string;
    releasedAt?: any | null;
    assignmentId?: string | null;
    outcomeAt?: any | null;
    cancelled: boolean;
    releaseAt?: any | null;
    target?: {
      __typename?: 'HomeworkTarget';
      type: string;
      ref?: string | null;
      version?: number | null;
      source?: string | null;
    } | null;
    release: {
      __typename?: 'PathwayReleaseRule';
      rule: string;
      day?: number | null;
      delayDays?: number | null;
    };
    evidence?: {
      __typename?: 'HomeworkEvidence';
      focusType: string;
      focus: any;
    } | null;
  }>;
};

export type PathwayProgressFieldsFragment = {
  __typename?: 'PathwayProgress';
  enrollmentId: string;
  subject: string;
  requester: string;
  requesterName?: string | null;
  practiceId: string;
  pathwayId: string;
  pathwayVersion: number;
  pathwayName: string;
  startAt: any;
  status: string;
  endedAt?: any | null;
  reason?: string | null;
  percentDone: number;
  stepsTotal: number;
  stepsDone: number;
  stepsSkipped: number;
  selfEnrolled: boolean;
  sections: Array<{
    __typename?: 'PathwaySectionProgress';
    section: string;
    steps: Array<{
      __typename?: 'PathwayStepProgress';
      stepId: string;
      kind: string;
      title: string;
      instructions?: string | null;
      dueDays?: number | null;
      state: string;
      releasedAt?: any | null;
      assignmentId?: string | null;
      outcomeAt?: any | null;
      cancelled: boolean;
      releaseAt?: any | null;
      target?: {
        __typename?: 'HomeworkTarget';
        type: string;
        ref?: string | null;
        version?: number | null;
        source?: string | null;
      } | null;
      release: {
        __typename?: 'PathwayReleaseRule';
        rule: string;
        day?: number | null;
        delayDays?: number | null;
      };
      evidence?: {
        __typename?: 'HomeworkEvidence';
        focusType: string;
        focus: any;
      } | null;
    }>;
  }>;
};

export type MyPathwayFieldsFragment = {
  __typename?: 'MyPathway';
  enrollmentId: string;
  pathwayId: string;
  pathwayVersion: number;
  pathwayName: string;
  startAt: any;
  status: string;
  percentDone: number;
  stepsDone: number;
  stepsTotal: number;
  nextStepTitle?: string | null;
  nextReleaseAt?: any | null;
  prescribed: boolean;
  requesterName?: string | null;
  sections: Array<{
    __typename?: 'PathwaySectionProgress';
    section: string;
    steps: Array<{
      __typename?: 'PathwayStepProgress';
      stepId: string;
      kind: string;
      title: string;
      instructions?: string | null;
      dueDays?: number | null;
      state: string;
      releasedAt?: any | null;
      assignmentId?: string | null;
      outcomeAt?: any | null;
      cancelled: boolean;
      releaseAt?: any | null;
      target?: {
        __typename?: 'HomeworkTarget';
        type: string;
        ref?: string | null;
        version?: number | null;
        source?: string | null;
      } | null;
      release: {
        __typename?: 'PathwayReleaseRule';
        rule: string;
        day?: number | null;
        delayDays?: number | null;
      };
      evidence?: {
        __typename?: 'HomeworkEvidence';
        focusType: string;
        focus: any;
      } | null;
    }>;
  }>;
};

export type PublicCourseFieldsFragment = {
  __typename?: 'PublicCourse';
  pathwayId: string;
  practiceId: string;
  practiceName?: string | null;
  version: number;
  name: string;
  description?: string | null;
  stepsCount: number;
  accessRule?: string | null;
  storeProductId?: string | null;
  adaptyPlacementId?: string | null;
  owned: boolean;
  sections: Array<{
    __typename?: 'PathwaySection';
    section: string;
    steps: Array<{
      __typename?: 'PathwayStep';
      stepId: string;
      kind: string;
      title: string;
      instructions?: string | null;
      dueDays?: number | null;
      target?: {
        __typename?: 'HomeworkTarget';
        type: string;
        ref?: string | null;
        version?: number | null;
        source?: string | null;
      } | null;
      release: {
        __typename?: 'PathwayReleaseRule';
        rule: string;
        day?: number | null;
        delayDays?: number | null;
      };
    }>;
  }>;
};

export type PathwaysQueryVariables = Exact<{
  includeRetired?: InputMaybe<Scalars['Boolean']>;
}>;

export type PathwaysQuery = {
  __typename?: 'Query';
  pathways: {
    __typename?: 'PathwayLibrary';
    capabilities: Array<string>;
    pathways: Array<{
      __typename?: 'Pathway';
      pathwayId: string;
      practiceId: string;
      name: string;
      description?: string | null;
      visibility: string;
      version: number;
      stepsCount: number;
      status: string;
      enrolledCount: number;
      runningCount: number;
      completedCount: number;
      copiedFrom?: string | null;
      copiedFromName?: string | null;
      accessRule?: string | null;
      reviewStatus?: string | null;
      reason?: string | null;
      occurredAt: any;
    }>;
  };
};

export type PathwayQueryVariables = Exact<{
  pathwayId: Scalars['ID'];
}>;

export type PathwayQuery = {
  __typename?: 'Query';
  pathway?: {
    __typename?: 'PathwayDetail';
    pathwayId: string;
    practiceId: string;
    name: string;
    description?: string | null;
    visibility: string;
    version: number;
    copiedFrom?: string | null;
    copiedFromName?: string | null;
    retired: boolean;
    library: boolean;
    runningEnrollments: number;
    accessRule?: string | null;
    reviewStatus?: string | null;
    reason?: string | null;
    sections: Array<{
      __typename?: 'PathwaySection';
      section: string;
      steps: Array<{
        __typename?: 'PathwayStep';
        stepId: string;
        kind: string;
        title: string;
        instructions?: string | null;
        dueDays?: number | null;
        target?: {
          __typename?: 'HomeworkTarget';
          type: string;
          ref?: string | null;
          version?: number | null;
          source?: string | null;
        } | null;
        release: {
          __typename?: 'PathwayReleaseRule';
          rule: string;
          day?: number | null;
          delayDays?: number | null;
        };
      }>;
    }>;
  } | null;
};

export type PathwayProgressQueryVariables = Exact<{
  enrollmentId: Scalars['ID'];
}>;

export type PathwayProgressQuery = {
  __typename?: 'Query';
  pathwayProgress?: {
    __typename?: 'PathwayProgress';
    enrollmentId: string;
    subject: string;
    requester: string;
    requesterName?: string | null;
    practiceId: string;
    pathwayId: string;
    pathwayVersion: number;
    pathwayName: string;
    startAt: any;
    status: string;
    endedAt?: any | null;
    reason?: string | null;
    percentDone: number;
    stepsTotal: number;
    stepsDone: number;
    stepsSkipped: number;
    selfEnrolled: boolean;
    sections: Array<{
      __typename?: 'PathwaySectionProgress';
      section: string;
      steps: Array<{
        __typename?: 'PathwayStepProgress';
        stepId: string;
        kind: string;
        title: string;
        instructions?: string | null;
        dueDays?: number | null;
        state: string;
        releasedAt?: any | null;
        assignmentId?: string | null;
        outcomeAt?: any | null;
        cancelled: boolean;
        releaseAt?: any | null;
        target?: {
          __typename?: 'HomeworkTarget';
          type: string;
          ref?: string | null;
          version?: number | null;
          source?: string | null;
        } | null;
        release: {
          __typename?: 'PathwayReleaseRule';
          rule: string;
          day?: number | null;
          delayDays?: number | null;
        };
        evidence?: {
          __typename?: 'HomeworkEvidence';
          focusType: string;
          focus: any;
        } | null;
      }>;
    }>;
  } | null;
};

export type ClientPathwaysQueryVariables = Exact<{
  subject: Scalars['ID'];
}>;

export type ClientPathwaysQuery = {
  __typename?: 'Query';
  clientPathways: Array<{
    __typename?: 'PathwayProgress';
    enrollmentId: string;
    subject: string;
    requester: string;
    requesterName?: string | null;
    practiceId: string;
    pathwayId: string;
    pathwayVersion: number;
    pathwayName: string;
    startAt: any;
    status: string;
    endedAt?: any | null;
    reason?: string | null;
    percentDone: number;
    stepsTotal: number;
    stepsDone: number;
    stepsSkipped: number;
    selfEnrolled: boolean;
    sections: Array<{
      __typename?: 'PathwaySectionProgress';
      section: string;
      steps: Array<{
        __typename?: 'PathwayStepProgress';
        stepId: string;
        kind: string;
        title: string;
        instructions?: string | null;
        dueDays?: number | null;
        state: string;
        releasedAt?: any | null;
        assignmentId?: string | null;
        outcomeAt?: any | null;
        cancelled: boolean;
        releaseAt?: any | null;
        target?: {
          __typename?: 'HomeworkTarget';
          type: string;
          ref?: string | null;
          version?: number | null;
          source?: string | null;
        } | null;
        release: {
          __typename?: 'PathwayReleaseRule';
          rule: string;
          day?: number | null;
          delayDays?: number | null;
        };
        evidence?: {
          __typename?: 'HomeworkEvidence';
          focusType: string;
          focus: any;
        } | null;
      }>;
    }>;
  }>;
};

export type PathwayOutcomesQueryVariables = Exact<{ [key: string]: never }>;

export type PathwayOutcomesQuery = {
  __typename?: 'Query';
  pathwayOutcomes: Array<{
    __typename?: 'PathwayOutcome';
    pathwayId: string;
    pathwayName: string;
    copiedFrom?: string | null;
    copiedFromName?: string | null;
    depth: number;
    retired: boolean;
    enrolledCount: number;
    runningCount: number;
    completedCount: number;
    withdrawnCount: number;
    completionRate?: number | null;
    medianDaysToComplete?: number | null;
  }>;
};

export type MyPathwaysQueryVariables = Exact<{ [key: string]: never }>;

export type MyPathwaysQuery = {
  __typename?: 'Query';
  myPathways: Array<{
    __typename?: 'MyPathway';
    enrollmentId: string;
    pathwayId: string;
    pathwayVersion: number;
    pathwayName: string;
    startAt: any;
    status: string;
    percentDone: number;
    stepsDone: number;
    stepsTotal: number;
    nextStepTitle?: string | null;
    nextReleaseAt?: any | null;
    prescribed: boolean;
    requesterName?: string | null;
    sections: Array<{
      __typename?: 'PathwaySectionProgress';
      section: string;
      steps: Array<{
        __typename?: 'PathwayStepProgress';
        stepId: string;
        kind: string;
        title: string;
        instructions?: string | null;
        dueDays?: number | null;
        state: string;
        releasedAt?: any | null;
        assignmentId?: string | null;
        outcomeAt?: any | null;
        cancelled: boolean;
        releaseAt?: any | null;
        target?: {
          __typename?: 'HomeworkTarget';
          type: string;
          ref?: string | null;
          version?: number | null;
          source?: string | null;
        } | null;
        release: {
          __typename?: 'PathwayReleaseRule';
          rule: string;
          day?: number | null;
          delayDays?: number | null;
        };
        evidence?: {
          __typename?: 'HomeworkEvidence';
          focusType: string;
          focus: any;
        } | null;
      }>;
    }>;
  }>;
};

export type PublicCoursesQueryVariables = Exact<{ [key: string]: never }>;

export type PublicCoursesQuery = {
  __typename?: 'Query';
  publicCourses: Array<{
    __typename?: 'PublicCourse';
    pathwayId: string;
    practiceId: string;
    practiceName?: string | null;
    version: number;
    name: string;
    description?: string | null;
    stepsCount: number;
    accessRule?: string | null;
    storeProductId?: string | null;
    adaptyPlacementId?: string | null;
    owned: boolean;
    sections: Array<{
      __typename?: 'PathwaySection';
      section: string;
      steps: Array<{
        __typename?: 'PathwayStep';
        stepId: string;
        kind: string;
        title: string;
        instructions?: string | null;
        dueDays?: number | null;
        target?: {
          __typename?: 'HomeworkTarget';
          type: string;
          ref?: string | null;
          version?: number | null;
          source?: string | null;
        } | null;
        release: {
          __typename?: 'PathwayReleaseRule';
          rule: string;
          day?: number | null;
          delayDays?: number | null;
        };
      }>;
    }>;
  }>;
};

export type DefinePathwayMutationVariables = Exact<{
  input: DefinePathwayInput;
}>;

export type DefinePathwayMutation = {
  __typename?: 'Mutation';
  definePathway: {
    __typename?: 'PathwayPayload';
    pathwayId: string;
    version?: number | null;
    recorded: boolean;
  };
};

export type RevisePathwayMutationVariables = Exact<{
  input: RevisePathwayInput;
}>;

export type RevisePathwayMutation = {
  __typename?: 'Mutation';
  revisePathway: {
    __typename?: 'PathwayPayload';
    pathwayId: string;
    version?: number | null;
    recorded: boolean;
  };
};

export type RetirePathwayMutationVariables = Exact<{
  input: RetirePathwayInput;
}>;

export type RetirePathwayMutation = {
  __typename?: 'Mutation';
  retirePathway: {
    __typename?: 'PathwayPayload';
    pathwayId: string;
    version?: number | null;
    recorded: boolean;
  };
};

export type EnrollInPathwayMutationVariables = Exact<{
  input: EnrollInPathwayInput;
}>;

export type EnrollInPathwayMutation = {
  __typename?: 'Mutation';
  enrollInPathway: {
    __typename?: 'PathwayEnrollmentPayload';
    enrollmentId: string;
    recorded: boolean;
  };
};

export type ReleasePathwayStepMutationVariables = Exact<{
  input: ReleasePathwayStepInput;
}>;

export type ReleasePathwayStepMutation = {
  __typename?: 'Mutation';
  releasePathwayStep: {
    __typename?: 'ReleasePathwayStepPayload';
    enrollmentId: string;
    assignmentId: string;
    recorded: boolean;
  };
};

export type WithdrawFromPathwayMutationVariables = Exact<{
  input: WithdrawFromPathwayInput;
}>;

export type WithdrawFromPathwayMutation = {
  __typename?: 'Mutation';
  withdrawFromPathway: {
    __typename?: 'PathwayEnrollmentPayload';
    enrollmentId: string;
    recorded: boolean;
  };
};

export type RecordCoursePurchaseMutationVariables = Exact<{
  input: RecordCoursePurchaseInput;
}>;

export type RecordCoursePurchaseMutation = {
  __typename?: 'Mutation';
  recordCoursePurchase: {
    __typename?: 'CoursePurchasePayload';
    storeProductId: string;
    owned: boolean;
    recorded: boolean;
  };
};

export type ProfileDataFragment = {
  __typename?: 'Profile';
  createdAt: any;
  updatedAt: any;
  wantsReferrals: boolean;
  approvedForReferrals: boolean;
  formats: Array<string>;
  mentalHealthRole: string;
  title?: string | null;
  acceptingClients: string;
  yearsInPractice: number;
  about: string;
  education: Array<string>;
  languages: Array<string>;
  approaches: Array<string>;
  costPerSessionFrom: number;
  costPerSessionTo: number;
  currency: string;
  slidingScale: boolean;
  modalities: Array<string>;
  clientAges: Array<string>;
  clientIssues: Array<string>;
  linkToOtherProfile?: string | null;
  imageUrl?: string | null;
  phone: string;
  extension?: string | null;
  freeInitialConsulation: boolean;
  userId: string;
  licenses?: Array<{
    __typename?: 'License';
    state: string;
    number: string;
  } | null> | null;
  therapist?: {
    __typename?: 'User';
    firstName?: string | null;
    lastName?: string | null;
  } | null;
};

export type ProfilesQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['JSON']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type ProfilesQuery = {
  __typename?: 'Query';
  profiles?: {
    __typename?: 'ProfilesSearch';
    count: number;
    data?: Array<{
      __typename?: 'Profile';
      _id: string;
      createdAt: any;
      updatedAt: any;
      wantsReferrals: boolean;
      approvedForReferrals: boolean;
      formats: Array<string>;
      mentalHealthRole: string;
      title?: string | null;
      acceptingClients: string;
      yearsInPractice: number;
      about: string;
      education: Array<string>;
      languages: Array<string>;
      approaches: Array<string>;
      costPerSessionFrom: number;
      costPerSessionTo: number;
      currency: string;
      slidingScale: boolean;
      modalities: Array<string>;
      clientAges: Array<string>;
      clientIssues: Array<string>;
      linkToOtherProfile?: string | null;
      imageUrl?: string | null;
      phone: string;
      extension?: string | null;
      freeInitialConsulation: boolean;
      userId: string;
      licenses?: Array<{
        __typename?: 'License';
        state: string;
        number: string;
      } | null> | null;
      therapist?: {
        __typename?: 'User';
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type ProfileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type ProfileQuery = {
  __typename?: 'Query';
  profile?: {
    __typename?: 'Profile';
    _id: string;
    createdAt: any;
    updatedAt: any;
    wantsReferrals: boolean;
    approvedForReferrals: boolean;
    formats: Array<string>;
    mentalHealthRole: string;
    title?: string | null;
    acceptingClients: string;
    yearsInPractice: number;
    about: string;
    education: Array<string>;
    languages: Array<string>;
    approaches: Array<string>;
    costPerSessionFrom: number;
    costPerSessionTo: number;
    currency: string;
    slidingScale: boolean;
    modalities: Array<string>;
    clientAges: Array<string>;
    clientIssues: Array<string>;
    linkToOtherProfile?: string | null;
    imageUrl?: string | null;
    phone: string;
    extension?: string | null;
    freeInitialConsulation: boolean;
    userId: string;
    licenses?: Array<{
      __typename?: 'License';
      state: string;
      number: string;
    } | null> | null;
    therapist?: {
      __typename?: 'User';
      firstName?: string | null;
      lastName?: string | null;
    } | null;
  } | null;
};

export type SafetyPlanEntryFieldsFragment = {
  __typename?: 'SafetyPlanEntry';
  text?: string | null;
  name?: string | null;
  phone?: string | null;
  kind?: string | null;
};

export type SafetyPlanSectionFieldsFragment = {
  __typename?: 'SafetyPlanSectionView';
  section: string;
  performer?: string | null;
  performerName?: string | null;
  byClient: boolean;
  occurredAt?: any | null;
  entries: Array<{
    __typename?: 'SafetyPlanEntry';
    text?: string | null;
    name?: string | null;
    phone?: string | null;
    kind?: string | null;
  }>;
};

export type UpdateSafetyPlanSectionMutationVariables = Exact<{
  input: UpdateSafetyPlanSectionInput;
}>;

export type UpdateSafetyPlanSectionMutation = {
  __typename?: 'Mutation';
  updateSafetyPlanSection: {
    __typename?: 'SafetyPlanCommandPayload';
    planId: string;
    recorded: boolean;
  };
};

export type UpdateSafetyPlanSectionInSessionMutationVariables = Exact<{
  input: UpdateSafetyPlanSectionInSessionInput;
}>;

export type UpdateSafetyPlanSectionInSessionMutation = {
  __typename?: 'Mutation';
  updateSafetyPlanSectionInSession: {
    __typename?: 'SafetyPlanCommandPayload';
    planId: string;
    recorded: boolean;
  };
};

export type ReviewSafetyPlanMutationVariables = Exact<{
  input: ReviewSafetyPlanInput;
}>;

export type ReviewSafetyPlanMutation = {
  __typename?: 'Mutation';
  reviewSafetyPlan: {
    __typename?: 'SafetyPlanCommandPayload';
    planId: string;
    recorded: boolean;
  };
};

export type RecordSafetyPlanOpenedMutationVariables = Exact<{
  input: RecordSafetyPlanOpenedInput;
}>;

export type RecordSafetyPlanOpenedMutation = {
  __typename?: 'Mutation';
  recordSafetyPlanOpened: {
    __typename?: 'SafetyPlanCommandPayload';
    planId: string;
    recorded: boolean;
  };
};

export type SafetyPlanQueryVariables = Exact<{
  subject?: InputMaybe<Scalars['ID']>;
}>;

export type SafetyPlanQuery = {
  __typename?: 'Query';
  safetyPlan: {
    __typename?: 'SafetyPlan';
    subject: string;
    planId: string;
    hasPlan: boolean;
    mayEdit: boolean;
    sections: Array<{
      __typename?: 'SafetyPlanSectionView';
      section: string;
      performer?: string | null;
      performerName?: string | null;
      byClient: boolean;
      occurredAt?: any | null;
      entries: Array<{
        __typename?: 'SafetyPlanEntry';
        text?: string | null;
        name?: string | null;
        phone?: string | null;
        kind?: string | null;
      }>;
    }>;
    therapists: Array<{
      __typename?: 'SafetyPlanTherapist';
      id: string;
      name?: string | null;
      canSee: boolean;
    }>;
  };
};

export type SafetyPlanStatusQueryVariables = Exact<{
  subject?: InputMaybe<Scalars['ID']>;
}>;

export type SafetyPlanStatusQuery = {
  __typename?: 'Query';
  safetyPlanStatus: {
    __typename?: 'SafetyPlanStatus';
    subject: string;
    planId: string;
    hasPlan: boolean;
    sectionsFilled: number;
    updatedAt?: any | null;
    reviewedAt?: any | null;
    reviewedWith?: string | null;
    reviewedWithName?: string | null;
    nextReviewBy?: string | null;
  };
};

export type SafetyPlanHistoryQueryVariables = Exact<{
  subject: Scalars['ID'];
}>;

export type SafetyPlanHistoryQuery = {
  __typename?: 'Query';
  safetyPlanHistory: Array<{
    __typename?: 'SafetyPlanHistoryRow';
    entryId: string;
    occurredAt: any;
    performer: string;
    performerName?: string | null;
    byClient: boolean;
    kind: string;
    section?: string | null;
    reviewedAt?: any | null;
    nextReviewBy?: string | null;
    note?: string | null;
    entries?: Array<{
      __typename?: 'SafetyPlanEntry';
      text?: string | null;
      name?: string | null;
      phone?: string | null;
      kind?: string | null;
    }> | null;
  }>;
};

export type SafetyPlanOpensByWeekQueryVariables = Exact<{
  subject: Scalars['ID'];
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type SafetyPlanOpensByWeekQuery = {
  __typename?: 'Query';
  safetyPlanOpensByWeek: {
    __typename?: 'SafetyPlanOpensByWeek';
    subject: string;
    thisWeek: number;
    weeks: Array<{
      __typename?: 'SafetyPlanOpensWeek';
      weekStart: string;
      count: number;
    }>;
  };
};

export type ModeMapEntryFieldsFragment = {
  __typename?: 'ModeMapEntry';
  modeId: string;
  kind: string;
  label?: string | null;
  colour?: string | null;
  own: boolean;
  cardId?: string | null;
  cardText?: string | null;
  switchedOff: boolean;
};

export type ModeSetChangeFieldsFragment = {
  __typename?: 'ModeSetChange';
  performer: string;
  byClient: boolean;
  performerName?: string | null;
  occurredAt: any;
};

export type ModeTimelineFieldsFragment = {
  __typename?: 'ModeTimeline';
  subject: string;
  from: string;
  to: string;
  historyDays?: number | null;
  olderDays: number;
  checkIns: number;
  checkInsThisWeek: number;
  modeMap: Array<{
    __typename?: 'ModeMapEntry';
    modeId: string;
    kind: string;
    label?: string | null;
    colour?: string | null;
    own: boolean;
    cardId?: string | null;
    cardText?: string | null;
    switchedOff: boolean;
  }>;
  entries: Array<{
    __typename?: 'ModeTimelineEntry';
    checkInId: string;
    recordedAt: any;
    trigger?: string | null;
    bodyCue?: string | null;
    need?: string | null;
    note?: string | null;
    modes: Array<{
      __typename?: 'ModeCheckInModeValue';
      modeId: string;
      intensity: number;
    }>;
  }>;
  modeDays: Array<{
    __typename?: 'ModeDay';
    date: string;
    modes: Array<{ __typename?: 'ModeDayPeak'; modeId: string; peak: number }>;
  }>;
  topTriggers: Array<{
    __typename?: 'ModeTriggerCount';
    trigger: string;
    count: number;
  }>;
  triggerMatrix: Array<{
    __typename?: 'ModeTriggerRow';
    trigger: string;
    modes: Array<{
      __typename?: 'ModeTriggerModeCount';
      modeId: string;
      count: number;
    }>;
  }>;
  healthyAdultShare: Array<{
    __typename?: 'ModeHealthyAdultWeek';
    week: string;
    share?: number | null;
    presentCheckIns: number;
    checkIns: number;
    mean?: number | null;
  }>;
  cards: Array<{ __typename?: 'ModeCardLink'; modeId: string; cardId: string }>;
  lastChange?: {
    __typename?: 'ModeSetChange';
    performer: string;
    byClient: boolean;
    performerName?: string | null;
    occurredAt: any;
  } | null;
};

export type ConfigureModeSetMutationVariables = Exact<{
  input: ConfigureModeSetInput;
}>;

export type ConfigureModeSetMutation = {
  __typename?: 'Mutation';
  configureModeSet: {
    __typename?: 'ModeCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type RecordModeCheckInMutationVariables = Exact<{
  input: RecordModeCheckInInput;
}>;

export type RecordModeCheckInMutation = {
  __typename?: 'Mutation';
  recordModeCheckIn: {
    __typename?: 'ModeCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type LinkCardToModeMutationVariables = Exact<{
  input: LinkCardToModeInput;
}>;

export type LinkCardToModeMutation = {
  __typename?: 'Mutation';
  linkCardToMode: {
    __typename?: 'ModeCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type DeleteModeCheckInMutationVariables = Exact<{
  input: DeleteModeCheckInInput;
}>;

export type DeleteModeCheckInMutation = {
  __typename?: 'Mutation';
  deleteModeCheckIn: {
    __typename?: 'ModeCommandPayload';
    id?: string | null;
    recorded: boolean;
  };
};

export type MyModeSetQueryVariables = Exact<{ [key: string]: never }>;

export type MyModeSetQuery = {
  __typename?: 'Query';
  myModeSet: {
    __typename?: 'ModeSet';
    subject: string;
    configured: boolean;
    modeMap: Array<{
      __typename?: 'ModeMapEntry';
      modeId: string;
      kind: string;
      label?: string | null;
      colour?: string | null;
      own: boolean;
      cardId?: string | null;
      cardText?: string | null;
      switchedOff: boolean;
    }>;
    lastChange?: {
      __typename?: 'ModeSetChange';
      performer: string;
      byClient: boolean;
      performerName?: string | null;
      occurredAt: any;
    } | null;
  };
};

export type ClientModeSetQueryVariables = Exact<{
  subject: Scalars['ID'];
}>;

export type ClientModeSetQuery = {
  __typename?: 'Query';
  clientModeSet: {
    __typename?: 'ModeSet';
    subject: string;
    configured: boolean;
    modeMap: Array<{
      __typename?: 'ModeMapEntry';
      modeId: string;
      kind: string;
      label?: string | null;
      colour?: string | null;
      own: boolean;
      cardId?: string | null;
      cardText?: string | null;
      switchedOff: boolean;
    }>;
    lastChange?: {
      __typename?: 'ModeSetChange';
      performer: string;
      byClient: boolean;
      performerName?: string | null;
      occurredAt: any;
    } | null;
  };
};

export type MyModeTimelineQueryVariables = Exact<{
  days?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type MyModeTimelineQuery = {
  __typename?: 'Query';
  myModeTimeline: {
    __typename?: 'ModeTimeline';
    subject: string;
    from: string;
    to: string;
    historyDays?: number | null;
    olderDays: number;
    checkIns: number;
    checkInsThisWeek: number;
    modeMap: Array<{
      __typename?: 'ModeMapEntry';
      modeId: string;
      kind: string;
      label?: string | null;
      colour?: string | null;
      own: boolean;
      cardId?: string | null;
      cardText?: string | null;
      switchedOff: boolean;
    }>;
    entries: Array<{
      __typename?: 'ModeTimelineEntry';
      checkInId: string;
      recordedAt: any;
      trigger?: string | null;
      bodyCue?: string | null;
      need?: string | null;
      note?: string | null;
      modes: Array<{
        __typename?: 'ModeCheckInModeValue';
        modeId: string;
        intensity: number;
      }>;
    }>;
    modeDays: Array<{
      __typename?: 'ModeDay';
      date: string;
      modes: Array<{
        __typename?: 'ModeDayPeak';
        modeId: string;
        peak: number;
      }>;
    }>;
    topTriggers: Array<{
      __typename?: 'ModeTriggerCount';
      trigger: string;
      count: number;
    }>;
    triggerMatrix: Array<{
      __typename?: 'ModeTriggerRow';
      trigger: string;
      modes: Array<{
        __typename?: 'ModeTriggerModeCount';
        modeId: string;
        count: number;
      }>;
    }>;
    healthyAdultShare: Array<{
      __typename?: 'ModeHealthyAdultWeek';
      week: string;
      share?: number | null;
      presentCheckIns: number;
      checkIns: number;
      mean?: number | null;
    }>;
    cards: Array<{
      __typename?: 'ModeCardLink';
      modeId: string;
      cardId: string;
    }>;
    lastChange?: {
      __typename?: 'ModeSetChange';
      performer: string;
      byClient: boolean;
      performerName?: string | null;
      occurredAt: any;
    } | null;
  };
};

export type ClientModeTimelineQueryVariables = Exact<{
  subject: Scalars['ID'];
  days?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type ClientModeTimelineQuery = {
  __typename?: 'Query';
  clientModeTimeline: {
    __typename?: 'ModeTimeline';
    subject: string;
    from: string;
    to: string;
    historyDays?: number | null;
    olderDays: number;
    checkIns: number;
    checkInsThisWeek: number;
    modeMap: Array<{
      __typename?: 'ModeMapEntry';
      modeId: string;
      kind: string;
      label?: string | null;
      colour?: string | null;
      own: boolean;
      cardId?: string | null;
      cardText?: string | null;
      switchedOff: boolean;
    }>;
    entries: Array<{
      __typename?: 'ModeTimelineEntry';
      checkInId: string;
      recordedAt: any;
      trigger?: string | null;
      bodyCue?: string | null;
      need?: string | null;
      note?: string | null;
      modes: Array<{
        __typename?: 'ModeCheckInModeValue';
        modeId: string;
        intensity: number;
      }>;
    }>;
    modeDays: Array<{
      __typename?: 'ModeDay';
      date: string;
      modes: Array<{
        __typename?: 'ModeDayPeak';
        modeId: string;
        peak: number;
      }>;
    }>;
    topTriggers: Array<{
      __typename?: 'ModeTriggerCount';
      trigger: string;
      count: number;
    }>;
    triggerMatrix: Array<{
      __typename?: 'ModeTriggerRow';
      trigger: string;
      modes: Array<{
        __typename?: 'ModeTriggerModeCount';
        modeId: string;
        count: number;
      }>;
    }>;
    healthyAdultShare: Array<{
      __typename?: 'ModeHealthyAdultWeek';
      week: string;
      share?: number | null;
      presentCheckIns: number;
      checkIns: number;
      mean?: number | null;
    }>;
    cards: Array<{
      __typename?: 'ModeCardLink';
      modeId: string;
      cardId: string;
    }>;
    lastChange?: {
      __typename?: 'ModeSetChange';
      performer: string;
      byClient: boolean;
      performerName?: string | null;
      occurredAt: any;
    } | null;
  };
};

export type PendingClientTransferQueryVariables = Exact<{
  [key: string]: never;
}>;

export type PendingClientTransferQuery = {
  __typename?: 'Query';
  pendingClientTransfer?: {
    __typename?: 'PendingClientTransfer';
    newAssignee: string;
    newAssigneeName?: string | null;
    practiceId?: string | null;
    practiceName?: string | null;
    requestedAt: any;
  } | null;
};

export type ConsentToClientTransferMutationVariables = Exact<{
  input: ConsentToClientTransferInput;
}>;

export type ConsentToClientTransferMutation = {
  __typename?: 'Mutation';
  consentToClientTransfer?: {
    __typename?: 'ClientTransferConsentResponse';
    success: boolean;
    consented: boolean;
  } | null;
};

export type JoinPracticeByInviteLinkMutationVariables = Exact<{
  token: Scalars['String'];
}>;

export type JoinPracticeByInviteLinkMutation = {
  __typename?: 'Mutation';
  joinPracticeByInviteLink?: {
    __typename?: 'JoinPracticeResponse';
    success: boolean;
    practiceId?: string | null;
    practiceName?: string | null;
  } | null;
};

export type PremiumUpgradeToShowQueryVariables = Exact<{
  acknowledgedGrantAt?: InputMaybe<Scalars['DateTime']>;
}>;

export type PremiumUpgradeToShowQuery = {
  __typename?: 'Query';
  premiumUpgradeToShow?: {
    __typename?: 'PremiumUpgradeToShow';
    subject: string;
    accessLevel?: string | null;
    practiceId: string;
    grantedVia: string;
    occurredAt: any;
    acknowledgedGrantAt?: any | null;
  } | null;
};

export type SleepNightsToConfirmQueryVariables = Exact<{
  today?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type SleepNightsToConfirmQuery = {
  __typename?: 'Query';
  sleepNightsToConfirm: {
    __typename?: 'SleepNightsToConfirm';
    subject: string;
    today: string;
    nights: Array<{
      __typename?: 'SleepNightToConfirm';
      night: string;
      source?: string | null;
      inBedStart?: any | null;
      inBedEnd?: any | null;
      asleepMinutes?: number | null;
    }>;
  };
};

export type SleepWindowViewFieldsFragment = {
  __typename?: 'SleepWindowView';
  windowId: string;
  subject: string;
  performer: string;
  performerName?: string | null;
  bedtime: string;
  riseTime: string;
  effectiveFrom: string;
  protocol: string;
  note?: string | null;
  lengthMinutes?: number | null;
  setAt: any;
  endedAt?: any | null;
  basis?: {
    __typename?: 'SleepWindowBasis';
    nights: number;
    meanTimeInBed: string;
    meanTotalSleep: string;
    meanEfficiency: number;
  } | null;
};

export type SleepWeekAveragesFieldsFragment = {
  __typename?: 'SleepWeekAverages';
  nightsFilled: number;
  timeInBedMinutes?: number | null;
  totalSleepMinutes?: number | null;
  efficiency?: number | null;
  sleepOnsetMinutes?: number | null;
  wakeMinutes?: number | null;
  quality?: number | null;
};

export type SleepDiaryWeekQueryVariables = Exact<{
  subject?: InputMaybe<Scalars['ID']>;
  week?: InputMaybe<Scalars['String']>;
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type SleepDiaryWeekQuery = {
  __typename?: 'Query';
  sleepDiaryWeek: {
    __typename?: 'SleepDiaryWeek';
    subject: string;
    week: string;
    watchShared: boolean;
    upcoming: boolean;
    nights: Array<{
      __typename?: 'SleepDiaryNight';
      night: string;
      nightKind: string;
      source: string;
      performer?: string | null;
      performerName?: string | null;
      bedTime?: any | null;
      lightsOut?: any | null;
      finalWake?: any | null;
      outOfBed?: any | null;
      timeInBedMinutes?: number | null;
      totalSleepMinutes?: number | null;
      efficiency?: number | null;
      sleepOnsetMinutes?: number | null;
      awakenings?: number | null;
      wakeMinutes?: number | null;
      quality?: number | null;
      note?: string | null;
      watchAsleepMinutes?: number | null;
      naps?: Array<{
        __typename?: 'SleepNap';
        start: string;
        minutes: number;
      }> | null;
      substances?: {
        __typename?: 'SleepSubstances';
        caffeineAfterNoon?: number | null;
        alcoholDrinks?: number | null;
        sleepAid?: string | null;
      } | null;
    }>;
    averages: {
      __typename?: 'SleepWeekAverages';
      nightsFilled: number;
      timeInBedMinutes?: number | null;
      totalSleepMinutes?: number | null;
      efficiency?: number | null;
      sleepOnsetMinutes?: number | null;
      wakeMinutes?: number | null;
      quality?: number | null;
    };
    weeks: Array<{
      __typename?: 'SleepWeekSummary';
      week: string;
      averages: {
        __typename?: 'SleepWeekAverages';
        nightsFilled: number;
        timeInBedMinutes?: number | null;
        totalSleepMinutes?: number | null;
        efficiency?: number | null;
        sleepOnsetMinutes?: number | null;
        wakeMinutes?: number | null;
        quality?: number | null;
      };
    }>;
    window?: {
      __typename?: 'SleepWindowView';
      windowId: string;
      subject: string;
      performer: string;
      performerName?: string | null;
      bedtime: string;
      riseTime: string;
      effectiveFrom: string;
      protocol: string;
      note?: string | null;
      lengthMinutes?: number | null;
      setAt: any;
      endedAt?: any | null;
      basis?: {
        __typename?: 'SleepWindowBasis';
        nights: number;
        meanTimeInBed: string;
        meanTotalSleep: string;
        meanEfficiency: number;
      } | null;
    } | null;
    windows: Array<{
      __typename?: 'SleepWindowView';
      windowId: string;
      subject: string;
      performer: string;
      performerName?: string | null;
      bedtime: string;
      riseTime: string;
      effectiveFrom: string;
      protocol: string;
      note?: string | null;
      lengthMinutes?: number | null;
      setAt: any;
      endedAt?: any | null;
      basis?: {
        __typename?: 'SleepWindowBasis';
        nights: number;
        meanTimeInBed: string;
        meanTotalSleep: string;
        meanEfficiency: number;
      } | null;
    }>;
    lastSevenNights?: {
      __typename?: 'SleepWeekAverages';
      nightsFilled: number;
      timeInBedMinutes?: number | null;
      totalSleepMinutes?: number | null;
      efficiency?: number | null;
      sleepOnsetMinutes?: number | null;
      wakeMinutes?: number | null;
      quality?: number | null;
    } | null;
    usualRule?: {
      __typename?: 'SleepUsualRule';
      protocol: string;
      action: string;
      minutes: number;
      atFloor: boolean;
      nights: number;
      meanEfficiency?: number | null;
      meanFellAsleep?: number | null;
      meanAwakeInNight?: number | null;
    } | null;
  };
};

export type SleepWindowQueryVariables = Exact<{
  timeZone?: InputMaybe<Scalars['String']>;
}>;

export type SleepWindowQuery = {
  __typename?: 'Query';
  sleepWindow: {
    __typename?: 'SleepWindow';
    subject: string;
    upcoming: boolean;
    window?: {
      __typename?: 'SleepWindowView';
      windowId: string;
      subject: string;
      performer: string;
      performerName?: string | null;
      bedtime: string;
      riseTime: string;
      effectiveFrom: string;
      protocol: string;
      note?: string | null;
      lengthMinutes?: number | null;
      setAt: any;
      endedAt?: any | null;
      basis?: {
        __typename?: 'SleepWindowBasis';
        nights: number;
        meanTimeInBed: string;
        meanTotalSleep: string;
        meanEfficiency: number;
      } | null;
    } | null;
    next?: {
      __typename?: 'SleepWindowView';
      windowId: string;
      subject: string;
      performer: string;
      performerName?: string | null;
      bedtime: string;
      riseTime: string;
      effectiveFrom: string;
      protocol: string;
      note?: string | null;
      lengthMinutes?: number | null;
      setAt: any;
      endedAt?: any | null;
      basis?: {
        __typename?: 'SleepWindowBasis';
        nights: number;
        meanTimeInBed: string;
        meanTotalSleep: string;
        meanEfficiency: number;
      } | null;
    } | null;
  };
};

export type ConfirmSleepNightMutationVariables = Exact<{
  input: ConfirmSleepNightInput;
}>;

export type ConfirmSleepNightMutation = {
  __typename?: 'Mutation';
  confirmSleepNight: { __typename?: 'SleepCommandPayload'; recorded: boolean };
};

export type SetSleepWindowMutationVariables = Exact<{
  input: SetSleepWindowInput;
}>;

export type SetSleepWindowMutation = {
  __typename?: 'Mutation';
  setSleepWindow: {
    __typename?: 'SleepCommandPayload';
    recorded: boolean;
    id?: string | null;
  };
};

export type ClearSleepWindowMutationVariables = Exact<{
  input: ClearSleepWindowInput;
}>;

export type ClearSleepWindowMutation = {
  __typename?: 'Mutation';
  clearSleepWindow: { __typename?: 'SleepCommandPayload'; recorded: boolean };
};

export type SubscriptionDataFragment = {
  __typename?: 'Subscription';
  createdAt: any;
  updatedAt: any;
  lastSyncrhonizedAt?: any | null;
  startsAt?: any | null;
  expiresAt?: any | null;
  activatedAt?: any | null;
  renewedAt?: any | null;
  unsubscribedAt?: any | null;
  userId: string;
  type: number;
  name?: string | null;
  isActive?: boolean | null;
  isLifetime?: boolean | null;
  vendorProductId?: string | null;
  willRenew?: boolean | null;
  clientsCount?: number | null;
  price?: number | null;
  practiceId?: string | null;
};

export type UserSubscriptionsQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['JSON']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type UserSubscriptionsQuery = {
  __typename?: 'Query';
  userSubscriptions?: {
    __typename?: 'UserSubscriptions';
    count: number;
    data?: Array<{
      __typename?: 'Subscription';
      _id: string;
      createdAt: any;
      updatedAt: any;
      lastSyncrhonizedAt?: any | null;
      startsAt?: any | null;
      expiresAt?: any | null;
      activatedAt?: any | null;
      renewedAt?: any | null;
      unsubscribedAt?: any | null;
      userId: string;
      type: number;
      name?: string | null;
      isActive?: boolean | null;
      isLifetime?: boolean | null;
      vendorProductId?: string | null;
      willRenew?: boolean | null;
      clientsCount?: number | null;
      price?: number | null;
      practiceId?: string | null;
    } | null> | null;
  } | null;
};

export type SupportingCycleDataFragment = {
  __typename?: 'SupportingCycle';
  createdAt: any;
  updatedAt: any;
  userId?: string | null;
  name?: string | null;
  isTemplate?: boolean | null;
  templateLanguage?: string | null;
  viciousCycleId?: string | null;
  thoughts: Array<{
    __typename?: 'SupportingCycleThought';
    thought?: string | null;
    edges?: Array<boolean | null> | null;
  } | null>;
};

export type UserSupportingCyclesQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['JSON']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type UserSupportingCyclesQuery = {
  __typename?: 'Query';
  supportingCycles?: {
    __typename?: 'SupportingCycleSearch';
    count: number;
    data?: Array<{
      __typename?: 'SupportingCycle';
      _id: string;
      createdAt: any;
      updatedAt: any;
      userId?: string | null;
      name?: string | null;
      isTemplate?: boolean | null;
      templateLanguage?: string | null;
      viciousCycleId?: string | null;
      thoughts: Array<{
        __typename?: 'SupportingCycleThought';
        thought?: string | null;
        edges?: Array<boolean | null> | null;
      } | null>;
    } | null> | null;
  } | null;
};

export type SupportingCycleQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']>;
}>;

export type SupportingCycleQuery = {
  __typename?: 'Query';
  supportingCycle?: {
    __typename?: 'SupportingCycle';
    _id: string;
    createdAt: any;
    updatedAt: any;
    userId?: string | null;
    name?: string | null;
    isTemplate?: boolean | null;
    templateLanguage?: string | null;
    viciousCycleId?: string | null;
    thoughts: Array<{
      __typename?: 'SupportingCycleThought';
      thought?: string | null;
      edges?: Array<boolean | null> | null;
    } | null>;
  } | null;
};

export type DeleteSupportingCycleMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']>;
}>;

export type DeleteSupportingCycleMutation = {
  __typename?: 'Mutation';
  deleteSupportingCycle?: {
    __typename?: 'SupportingCycle';
    _id: string;
    createdAt: any;
    updatedAt: any;
    userId?: string | null;
    name?: string | null;
    isTemplate?: boolean | null;
    templateLanguage?: string | null;
    viciousCycleId?: string | null;
    thoughts: Array<{
      __typename?: 'SupportingCycleThought';
      thought?: string | null;
      edges?: Array<boolean | null> | null;
    } | null>;
  } | null;
};

export type UpsertSupportingCycleMutationVariables = Exact<{
  input?: InputMaybe<SupportingCycleInput>;
}>;

export type UpsertSupportingCycleMutation = {
  __typename?: 'Mutation';
  upsertSupportingCycle?: {
    __typename?: 'SupportingCycle';
    _id: string;
    createdAt: any;
    updatedAt: any;
    userId?: string | null;
    name?: string | null;
    isTemplate?: boolean | null;
    templateLanguage?: string | null;
    viciousCycleId?: string | null;
    thoughts: Array<{
      __typename?: 'SupportingCycleThought';
      thought?: string | null;
      edges?: Array<boolean | null> | null;
    } | null>;
  } | null;
};

export type TestDataFragment = {
  __typename?: 'Test';
  _id: string;
  _key: string;
  _rev: string;
  createdAt: any;
  userId: string;
  type: number;
  answers: Array<number | null>;
  score: number;
  severity?: string | null;
  actions?: string | null;
};

export type TestQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type TestQuery = {
  __typename?: 'Query';
  test?: {
    __typename?: 'Test';
    _id: string;
    _key: string;
    _rev: string;
    createdAt: any;
    userId: string;
    type: number;
    answers: Array<number | null>;
    score: number;
    severity?: string | null;
    actions?: string | null;
  } | null;
};

export type TestsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type TestsQuery = {
  __typename?: 'Query';
  tests?: Array<{
    __typename?: 'Test';
    _id: string;
    _key: string;
    _rev: string;
    createdAt: any;
    userId: string;
    type: number;
    answers: Array<number | null>;
    score: number;
    severity?: string | null;
    actions?: string | null;
  } | null> | null;
};

export type TestsForUserQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['Int']>;
}>;

export type TestsForUserQuery = {
  __typename?: 'Query';
  testsForUser?: {
    __typename?: 'TestConnection';
    totalCount: number;
    edges?: Array<{
      __typename?: 'TestEdge';
      cursor: string;
      node?: {
        __typename?: 'Test';
        _id: string;
        _key: string;
        _rev: string;
        createdAt: any;
        userId: string;
        type: number;
        answers: Array<number | null>;
        score: number;
        severity?: string | null;
        actions?: string | null;
      } | null;
    } | null> | null;
    pageInfo?: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    } | null;
  } | null;
};

export type CreateTestMutationVariables = Exact<{
  test: TestCreateInput;
}>;

export type CreateTestMutation = {
  __typename?: 'Mutation';
  createTest?: {
    __typename?: 'TestResponse';
    test?: {
      __typename?: 'Test';
      _id: string;
      _key: string;
      _rev: string;
      createdAt: any;
      userId: string;
      type: number;
      answers: Array<number | null>;
      score: number;
      severity?: string | null;
      actions?: string | null;
    } | null;
  } | null;
};

export type TherapistClientEdgeDataFragment = {
  __typename?: 'TherapistClientEdge';
  practiceId?: string | null;
  allowView: boolean;
  allowEdit: boolean;
  allowAdminView: boolean;
  allowAdminEdit: boolean;
  createdAt: any;
  updatedAt: any;
  from?: {
    __typename?: 'User';
    _id: string;
    firstName?: string | null;
    lastName?: string | null;
  } | null;
  to?: {
    __typename?: 'User';
    _id: string;
    firstName?: string | null;
    lastName?: string | null;
  } | null;
};

export type TherapistClientEdgeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type TherapistClientEdgeQuery = {
  __typename?: 'Query';
  therapistClientEdge?: {
    __typename?: 'TherapistClientEdge';
    _id: string;
    practiceId?: string | null;
    allowView: boolean;
    allowEdit: boolean;
    allowAdminView: boolean;
    allowAdminEdit: boolean;
    createdAt: any;
    updatedAt: any;
    from?: {
      __typename?: 'User';
      _id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
    to?: {
      __typename?: 'User';
      _id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
  } | null;
};

export type TherapistClientEdgesQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['JSON']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type TherapistClientEdgesQuery = {
  __typename?: 'Query';
  therapistClientEdges?: {
    __typename?: 'TherapistClientEdges';
    count: number;
    data?: Array<{
      __typename?: 'TherapistClientEdge';
      _id: string;
      practiceId?: string | null;
      allowView: boolean;
      allowEdit: boolean;
      allowAdminView: boolean;
      allowAdminEdit: boolean;
      createdAt: any;
      updatedAt: any;
      from?: {
        __typename?: 'User';
        _id: string;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      to?: {
        __typename?: 'User';
        _id: string;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CreateTherapistClientEdgeMutationVariables = Exact<{
  input: TherapistClientECreateInput;
}>;

export type CreateTherapistClientEdgeMutation = {
  __typename?: 'Mutation';
  createTherapistClientEdge?: {
    __typename?: 'TherapistClientEdge';
    _id: string;
    practiceId?: string | null;
    allowView: boolean;
    allowEdit: boolean;
    allowAdminView: boolean;
    allowAdminEdit: boolean;
    createdAt: any;
    updatedAt: any;
    from?: {
      __typename?: 'User';
      _id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
    to?: {
      __typename?: 'User';
      _id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
  } | null;
};

export type UpdateTherapistClientEdgeMutationVariables = Exact<{
  input: TherapistClientEUpdateInput;
}>;

export type UpdateTherapistClientEdgeMutation = {
  __typename?: 'Mutation';
  updateTherapistClientEdge?: {
    __typename?: 'TherapistClientEdge';
    _id: string;
    practiceId?: string | null;
    allowView: boolean;
    allowEdit: boolean;
    allowAdminView: boolean;
    allowAdminEdit: boolean;
    createdAt: any;
    updatedAt: any;
    from?: {
      __typename?: 'User';
      _id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
    to?: {
      __typename?: 'User';
      _id: string;
      firstName?: string | null;
      lastName?: string | null;
    } | null;
  } | null;
};

export type ThoughtDataFragment = {
  __typename?: 'Thought';
  _id: string;
  _key: string;
  _rev: string;
  userId: string;
  activatingEventId?: string | null;
  createdAt: any;
  updatedAt: any;
  automaticThought: string;
  thoughtBelief: number;
  thoughtsFor: Array<string>;
  thoughtsForAlternativeThoughts?: Array<string | null> | null;
  thoughtsAgainst: Array<string>;
  cognitiveDistortions?: Array<string> | null;
  cardName?: string | null;
  categoriesIds?: Array<number> | null;
  realisticThoughts: Array<{
    __typename?: 'BasicThought';
    thought: string;
    thoughtBelief: number;
  }>;
  result: {
    __typename?: 'ThoughtTestResult';
    initialThoughtBelief: number;
    initialNegativeEmotionStrenght: number;
  };
  dayReminders?: {
    __typename?: 'DayReminders';
    _id: string;
    _key: string;
    _rev: string;
    thoughtId: string;
    createdAt: any;
    updatedAt: any;
    morning: {
      __typename?: 'TimeReminder';
      enabled: boolean;
      time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
    };
    day: {
      __typename?: 'TimeReminder';
      enabled: boolean;
      time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
    };
    evening: {
      __typename?: 'TimeReminder';
      enabled: boolean;
      time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
    };
  } | null;
  locationReminders?: Array<{
    __typename?: 'LocationReminder';
    _id: string;
    _key: string;
    _rev: string;
    _from: string;
    _to: string;
    createdAt: any;
    updatedAt: any;
    enter?: boolean | null;
    leave?: boolean | null;
    type: number;
  }> | null;
};

export type ThoughtDataShortFragment = {
  __typename?: 'Thought';
  _id: string;
  _key: string;
  _rev: string;
  userId: string;
  activatingEventId?: string | null;
  updatedAt: any;
  automaticThought: string;
  cardName?: string | null;
  categoriesIds?: Array<number> | null;
  realisticThoughts: Array<{ __typename?: 'BasicThought'; thought: string }>;
};

export type ThoughtQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type ThoughtQuery = {
  __typename?: 'Query';
  thought?: {
    __typename?: 'Thought';
    _id: string;
    _key: string;
    _rev: string;
    userId: string;
    activatingEventId?: string | null;
    createdAt: any;
    updatedAt: any;
    automaticThought: string;
    thoughtBelief: number;
    thoughtsFor: Array<string>;
    thoughtsForAlternativeThoughts?: Array<string | null> | null;
    thoughtsAgainst: Array<string>;
    cognitiveDistortions?: Array<string> | null;
    cardName?: string | null;
    categoriesIds?: Array<number> | null;
    realisticThoughts: Array<{
      __typename?: 'BasicThought';
      thought: string;
      thoughtBelief: number;
    }>;
    result: {
      __typename?: 'ThoughtTestResult';
      initialThoughtBelief: number;
      initialNegativeEmotionStrenght: number;
    };
    dayReminders?: {
      __typename?: 'DayReminders';
      _id: string;
      _key: string;
      _rev: string;
      thoughtId: string;
      createdAt: any;
      updatedAt: any;
      morning: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
      day: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
      evening: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
    } | null;
    locationReminders?: Array<{
      __typename?: 'LocationReminder';
      _id: string;
      _key: string;
      _rev: string;
      _from: string;
      _to: string;
      createdAt: any;
      updatedAt: any;
      enter?: boolean | null;
      leave?: boolean | null;
      type: number;
    }> | null;
  } | null;
};

export type ThoughtLocationRemindersQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type ThoughtLocationRemindersQuery = {
  __typename?: 'Query';
  thought?: {
    __typename?: 'Thought';
    _id: string;
    locationReminders?: Array<{
      __typename?: 'LocationReminder';
      _id: string;
      _key: string;
      _rev: string;
      _from: string;
      _to: string;
      createdAt: any;
      updatedAt: any;
      enter?: boolean | null;
      leave?: boolean | null;
      type: number;
    }> | null;
  } | null;
};

export type ThoughtsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type ThoughtsQuery = {
  __typename?: 'Query';
  thoughts?: Array<{
    __typename?: 'Thought';
    _id: string;
    _key: string;
    _rev: string;
    userId: string;
    activatingEventId?: string | null;
    createdAt: any;
    updatedAt: any;
    automaticThought: string;
    thoughtBelief: number;
    thoughtsFor: Array<string>;
    thoughtsForAlternativeThoughts?: Array<string | null> | null;
    thoughtsAgainst: Array<string>;
    cognitiveDistortions?: Array<string> | null;
    cardName?: string | null;
    categoriesIds?: Array<number> | null;
    realisticThoughts: Array<{
      __typename?: 'BasicThought';
      thought: string;
      thoughtBelief: number;
    }>;
    result: {
      __typename?: 'ThoughtTestResult';
      initialThoughtBelief: number;
      initialNegativeEmotionStrenght: number;
    };
    dayReminders?: {
      __typename?: 'DayReminders';
      _id: string;
      _key: string;
      _rev: string;
      thoughtId: string;
      createdAt: any;
      updatedAt: any;
      morning: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
      day: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
      evening: {
        __typename?: 'TimeReminder';
        enabled: boolean;
        time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
      };
    } | null;
    locationReminders?: Array<{
      __typename?: 'LocationReminder';
      _id: string;
      _key: string;
      _rev: string;
      _from: string;
      _to: string;
      createdAt: any;
      updatedAt: any;
      enter?: boolean | null;
      leave?: boolean | null;
      type: number;
    }> | null;
  } | null> | null;
};

export type ThoughtsForUserQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
}>;

export type ThoughtsForUserQuery = {
  __typename?: 'Query';
  thoughtsForUser?: {
    __typename?: 'ThoughtConnection';
    totalCount: number;
    edges?: Array<{
      __typename?: 'ThoughtEdge';
      cursor: string;
      node?: {
        __typename?: 'Thought';
        _id: string;
        _key: string;
        _rev: string;
        userId: string;
        activatingEventId?: string | null;
        createdAt: any;
        updatedAt: any;
        automaticThought: string;
        thoughtBelief: number;
        thoughtsFor: Array<string>;
        thoughtsForAlternativeThoughts?: Array<string | null> | null;
        thoughtsAgainst: Array<string>;
        cognitiveDistortions?: Array<string> | null;
        cardName?: string | null;
        categoriesIds?: Array<number> | null;
        realisticThoughts: Array<{
          __typename?: 'BasicThought';
          thought: string;
          thoughtBelief: number;
        }>;
        result: {
          __typename?: 'ThoughtTestResult';
          initialThoughtBelief: number;
          initialNegativeEmotionStrenght: number;
        };
        dayReminders?: {
          __typename?: 'DayReminders';
          _id: string;
          _key: string;
          _rev: string;
          thoughtId: string;
          createdAt: any;
          updatedAt: any;
          morning: {
            __typename?: 'TimeReminder';
            enabled: boolean;
            time: {
              __typename?: 'ReminderTime';
              hours: number;
              minutes: number;
            };
          };
          day: {
            __typename?: 'TimeReminder';
            enabled: boolean;
            time: {
              __typename?: 'ReminderTime';
              hours: number;
              minutes: number;
            };
          };
          evening: {
            __typename?: 'TimeReminder';
            enabled: boolean;
            time: {
              __typename?: 'ReminderTime';
              hours: number;
              minutes: number;
            };
          };
        } | null;
        locationReminders?: Array<{
          __typename?: 'LocationReminder';
          _id: string;
          _key: string;
          _rev: string;
          _from: string;
          _to: string;
          createdAt: any;
          updatedAt: any;
          enter?: boolean | null;
          leave?: boolean | null;
          type: number;
        }> | null;
      } | null;
    } | null> | null;
    pageInfo?: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    } | null;
  } | null;
};

export type ThoughtsSearchQueryVariables = Exact<{
  phrase: Scalars['String'];
}>;

export type ThoughtsSearchQuery = {
  __typename?: 'Query';
  thoughtsSearch?: {
    __typename?: 'ThoughtSearch';
    count: number;
    thoughts?: Array<{
      __typename?: 'Thought';
      _id: string;
      _key: string;
      _rev: string;
      userId: string;
      activatingEventId?: string | null;
      createdAt: any;
      updatedAt: any;
      automaticThought: string;
      thoughtBelief: number;
      thoughtsFor: Array<string>;
      thoughtsForAlternativeThoughts?: Array<string | null> | null;
      thoughtsAgainst: Array<string>;
      cognitiveDistortions?: Array<string> | null;
      cardName?: string | null;
      categoriesIds?: Array<number> | null;
      realisticThoughts: Array<{
        __typename?: 'BasicThought';
        thought: string;
        thoughtBelief: number;
      }>;
      result: {
        __typename?: 'ThoughtTestResult';
        initialThoughtBelief: number;
        initialNegativeEmotionStrenght: number;
      };
      dayReminders?: {
        __typename?: 'DayReminders';
        _id: string;
        _key: string;
        _rev: string;
        thoughtId: string;
        createdAt: any;
        updatedAt: any;
        morning: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
        day: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
        evening: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
      } | null;
      locationReminders?: Array<{
        __typename?: 'LocationReminder';
        _id: string;
        _key: string;
        _rev: string;
        _from: string;
        _to: string;
        createdAt: any;
        updatedAt: any;
        enter?: boolean | null;
        leave?: boolean | null;
        type: number;
      }> | null;
    } | null> | null;
  } | null;
};

export type CreateThoughtMutationVariables = Exact<{
  thought: ThoughtCreateInput;
}>;

export type CreateThoughtMutation = {
  __typename?: 'Mutation';
  createThought?: {
    __typename?: 'ThoughtResponse';
    thought?: {
      __typename?: 'Thought';
      _id: string;
      _key: string;
      _rev: string;
      userId: string;
      activatingEventId?: string | null;
      createdAt: any;
      updatedAt: any;
      automaticThought: string;
      thoughtBelief: number;
      thoughtsFor: Array<string>;
      thoughtsForAlternativeThoughts?: Array<string | null> | null;
      thoughtsAgainst: Array<string>;
      cognitiveDistortions?: Array<string> | null;
      cardName?: string | null;
      categoriesIds?: Array<number> | null;
      realisticThoughts: Array<{
        __typename?: 'BasicThought';
        thought: string;
        thoughtBelief: number;
      }>;
      result: {
        __typename?: 'ThoughtTestResult';
        initialThoughtBelief: number;
        initialNegativeEmotionStrenght: number;
      };
      dayReminders?: {
        __typename?: 'DayReminders';
        _id: string;
        _key: string;
        _rev: string;
        thoughtId: string;
        createdAt: any;
        updatedAt: any;
        morning: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
        day: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
        evening: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
      } | null;
      locationReminders?: Array<{
        __typename?: 'LocationReminder';
        _id: string;
        _key: string;
        _rev: string;
        _from: string;
        _to: string;
        createdAt: any;
        updatedAt: any;
        enter?: boolean | null;
        leave?: boolean | null;
        type: number;
      }> | null;
    } | null;
  } | null;
};

export type DeleteThoughtMutationVariables = Exact<{
  _id: Scalars['String'];
}>;

export type DeleteThoughtMutation = {
  __typename?: 'Mutation';
  deleteThought?: {
    __typename?: 'ThoughtDeleteResponse';
    success?: boolean | null;
  } | null;
};

export type UpdateThoughtMutationVariables = Exact<{
  thought: ThoughtUpdateInput;
}>;

export type UpdateThoughtMutation = {
  __typename?: 'Mutation';
  updateThought?: {
    __typename?: 'ThoughtResponse';
    thought?: {
      __typename?: 'Thought';
      _id: string;
      _key: string;
      _rev: string;
      userId: string;
      activatingEventId?: string | null;
      createdAt: any;
      updatedAt: any;
      automaticThought: string;
      thoughtBelief: number;
      thoughtsFor: Array<string>;
      thoughtsForAlternativeThoughts?: Array<string | null> | null;
      thoughtsAgainst: Array<string>;
      cognitiveDistortions?: Array<string> | null;
      cardName?: string | null;
      categoriesIds?: Array<number> | null;
      realisticThoughts: Array<{
        __typename?: 'BasicThought';
        thought: string;
        thoughtBelief: number;
      }>;
      result: {
        __typename?: 'ThoughtTestResult';
        initialThoughtBelief: number;
        initialNegativeEmotionStrenght: number;
      };
      dayReminders?: {
        __typename?: 'DayReminders';
        _id: string;
        _key: string;
        _rev: string;
        thoughtId: string;
        createdAt: any;
        updatedAt: any;
        morning: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
        day: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
        evening: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
      } | null;
      locationReminders?: Array<{
        __typename?: 'LocationReminder';
        _id: string;
        _key: string;
        _rev: string;
        _from: string;
        _to: string;
        createdAt: any;
        updatedAt: any;
        enter?: boolean | null;
        leave?: boolean | null;
        type: number;
      }> | null;
    } | null;
  } | null;
};

export type SubmitThoughtTestEventsMutationVariables = Exact<{
  thoughtTestId: Scalars['ID'];
  events: Array<ThoughtTestEventInput> | ThoughtTestEventInput;
  subject?: InputMaybe<Scalars['ID']>;
}>;

export type SubmitThoughtTestEventsMutation = {
  __typename?: 'Mutation';
  submitThoughtTestEvents: {
    __typename?: 'SubmitThoughtTestEventsPayload';
    lastPosition: number;
    duplicates: Array<string>;
    thought?: {
      __typename?: 'Thought';
      _id: string;
      _key: string;
      activatingEventId?: string | null;
      dayReminders?: { __typename?: 'DayReminders'; _id: string } | null;
    } | null;
  };
};

export type CreateStandaloneCardMutationVariables = Exact<{
  input: CreateStandaloneCardInput;
}>;

export type CreateStandaloneCardMutation = {
  __typename?: 'Mutation';
  createStandaloneCard: {
    __typename?: 'CreateStandaloneCardPayload';
    thoughtTestId: string;
    thought?: {
      __typename?: 'Thought';
      _id: string;
      _key: string;
      userId: string;
      cardName?: string | null;
      automaticThought: string;
      createdAt: any;
      updatedAt: any;
      realisticThoughts: Array<{
        __typename?: 'BasicThought';
        thought: string;
        thoughtBelief: number;
      }>;
    } | null;
  };
};

export type ThoughtTestDraftQueryVariables = Exact<{
  thoughtTestId: Scalars['ID'];
  subject?: InputMaybe<Scalars['ID']>;
}>;

export type ThoughtTestDraftQuery = {
  __typename?: 'Query';
  thoughtTestDraft?: {
    __typename?: 'ThoughtTestDraft';
    subject: string;
    thoughtTestId: string;
    activatingEventId?: string | null;
    description: string;
    feelings: Array<number>;
    bodyPartsFeelings: number;
    behaviors: string;
    thoughtsFor?: Array<string> | null;
    thoughtsForAlternativeThoughts?: Array<string | null> | null;
    thoughtsAgainst?: Array<string> | null;
    cognitiveDistortions?: Array<string> | null;
    automaticThought: string;
    thoughtBelief: number;
    resumeStep: ThoughtTestStep;
    emotions: Array<{ __typename?: 'Emotion'; id: number; strength: number }>;
    realisticThoughts?: Array<{
      __typename?: 'BasicThought';
      thought: string;
      thoughtBelief: number;
    }> | null;
    result?: {
      __typename?: 'ThoughtTestOutcome';
      initialThoughtBelief: number;
      initialNegativeEmotionStrength: number;
    } | null;
    thought?: {
      __typename?: 'Thought';
      _id: string;
      _key: string;
      _rev: string;
      userId: string;
      activatingEventId?: string | null;
      createdAt: any;
      updatedAt: any;
      automaticThought: string;
      thoughtBelief: number;
      thoughtsFor: Array<string>;
      thoughtsForAlternativeThoughts?: Array<string | null> | null;
      thoughtsAgainst: Array<string>;
      cognitiveDistortions?: Array<string> | null;
      cardName?: string | null;
      categoriesIds?: Array<number> | null;
      realisticThoughts: Array<{
        __typename?: 'BasicThought';
        thought: string;
        thoughtBelief: number;
      }>;
      result: {
        __typename?: 'ThoughtTestResult';
        initialThoughtBelief: number;
        initialNegativeEmotionStrenght: number;
      };
      dayReminders?: {
        __typename?: 'DayReminders';
        _id: string;
        _key: string;
        _rev: string;
        thoughtId: string;
        createdAt: any;
        updatedAt: any;
        morning: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
        day: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
        evening: {
          __typename?: 'TimeReminder';
          enabled: boolean;
          time: { __typename?: 'ReminderTime'; hours: number; minutes: number };
        };
      } | null;
      locationReminders?: Array<{
        __typename?: 'LocationReminder';
        _id: string;
        _key: string;
        _rev: string;
        _from: string;
        _to: string;
        createdAt: any;
        updatedAt: any;
        enter?: boolean | null;
        leave?: boolean | null;
        type: number;
      }> | null;
    } | null;
  } | null;
};

export type UnfinishedThoughtTestsQueryVariables = Exact<{
  subject?: InputMaybe<Scalars['ID']>;
}>;

export type UnfinishedThoughtTestsQuery = {
  __typename?: 'Query';
  unfinishedThoughtTests: Array<{
    __typename?: 'UnfinishedThoughtTest';
    thoughtTestId: string;
    activatingEventId: string;
    subject: string;
    description: string;
    automaticThought: string;
    occurredAt: any;
    resumeStep: ThoughtTestStep;
  }>;
};

export type DeleteActivatingEventMutationVariables = Exact<{
  activatingEventId: Scalars['ID'];
}>;

export type DeleteActivatingEventMutation = {
  __typename?: 'Mutation';
  deleteActivatingEvent: {
    __typename?: 'DeleteActivatingEventPayload';
    success: boolean;
    activatingEventId: string;
  };
};

export type UsageEventDataFragment = {
  __typename?: 'UsageEvent';
  _id: string;
  _key: string;
  _rev: string;
  _from: string;
  _to: string;
  createdAt: any;
  type: number;
  extras?: string | null;
};

export type UsageEventsQueryVariables = Exact<{
  entityPrefix?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;

export type UsageEventsQuery = {
  __typename?: 'Query';
  usageEvents?: Array<{
    __typename?: 'UsageEvent';
    _id: string;
    _key: string;
    _rev: string;
    _from: string;
    _to: string;
    createdAt: any;
    type: number;
    extras?: string | null;
  } | null> | null;
};

export type UsageEventsStatsQueryVariables = Exact<{
  entityPrefix?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
  interval: Scalars['Int'];
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;

export type UsageEventsStatsQuery = {
  __typename?: 'Query';
  usageEventsStats?: {
    __typename?: 'UsageEventStatsResponse';
    stats: Array<{
      __typename?: 'UsageEventStats';
      date: any;
      count: number;
    } | null>;
  } | null;
};

export type MostUsedStatsQueryVariables = Exact<{
  entityPrefix?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['Int']>;
  interval: Scalars['Int'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type MostUsedStatsQuery = {
  __typename?: 'Query';
  mostUsedStats?: Array<{
    __typename?: 'MostUsedStats';
    entityId: string;
    count: number;
  } | null> | null;
};

export type CreateUsageEventsMutationVariables = Exact<{
  events: Array<UsageEventInput> | UsageEventInput;
}>;

export type CreateUsageEventsMutation = {
  __typename?: 'Mutation';
  createUsageEvents?: {
    __typename?: 'UsageEventsResponse';
    ok?: boolean | null;
  } | null;
};

export type FeatureFragment = {
  __typename?: 'FeatureFlag';
  name: string;
  count?: number | null;
};

export type FeaturesListFragment = {
  __typename?: 'FeatureFlags';
  cardsSearch?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  articlesView?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  statsView?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  locationReminders?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  dayReminders?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  phq9?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  gad7?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  meditations?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  worryTrees?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  downwardArrows?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  crisisContact?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  behaviorExperiments?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  exposures?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  exposureSituations?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  exposureSituationReactions?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  aiImages?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
  videoView?: {
    __typename?: 'FeatureFlag';
    name: string;
    count?: number | null;
  } | null;
};

export type PrivacySettingsFragmentFragment = {
  __typename?: 'PrivacySettings';
  isPrivacyAccepted?: boolean | null;
  isTermsAccepted?: boolean | null;
  isProductEmailNotifyOn?: boolean | null;
  isProductPushNotifyOn?: boolean | null;
  isErrorInfoCollectionOn?: boolean | null;
  isGAUsageCollectionOn?: boolean | null;
  isKeepLoggedInOn?: boolean | null;
};

export type UserDataFragment = {
  __typename?: 'User';
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
  email: any;
  role: number;
  photoUrl?: string | null;
  lng: string;
  timezone: string;
  fcmToken?: string | null;
  accessLevel?: string | null;
  adaptyProfileId?: string | null;
  hasAdaptyPremiumAccess?: boolean | null;
  subscriptionExpiredAt?: any | null;
  country?: string | null;
  state?: string | null;
  esMode?: EsMode | null;
  featureFlags: {
    __typename?: 'FeatureFlags';
    cardsSearch?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    articlesView?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    statsView?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    locationReminders?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    dayReminders?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    phq9?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    gad7?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    meditations?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    worryTrees?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    downwardArrows?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    crisisContact?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    behaviorExperiments?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    exposures?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    exposureSituations?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    exposureSituationReactions?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    aiImages?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
    videoView?: {
      __typename?: 'FeatureFlag';
      name: string;
      count?: number | null;
    } | null;
  };
  privacySettings?: {
    __typename?: 'PrivacySettings';
    isPrivacyAccepted?: boolean | null;
    isTermsAccepted?: boolean | null;
    isProductEmailNotifyOn?: boolean | null;
    isProductPushNotifyOn?: boolean | null;
    isErrorInfoCollectionOn?: boolean | null;
    isGAUsageCollectionOn?: boolean | null;
    isKeepLoggedInOn?: boolean | null;
  } | null;
};

export type UserQueryVariables = Exact<{ [key: string]: never }>;

export type UserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    _id: string;
    firstName?: string | null;
    lastName?: string | null;
    displayName?: string | null;
    email: any;
    role: number;
    photoUrl?: string | null;
    lng: string;
    timezone: string;
    fcmToken?: string | null;
    accessLevel?: string | null;
    adaptyProfileId?: string | null;
    hasAdaptyPremiumAccess?: boolean | null;
    subscriptionExpiredAt?: any | null;
    country?: string | null;
    state?: string | null;
    esMode?: EsMode | null;
    featureFlags: {
      __typename?: 'FeatureFlags';
      cardsSearch?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      articlesView?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      statsView?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      locationReminders?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      dayReminders?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      phq9?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      gad7?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      meditations?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      worryTrees?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      downwardArrows?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      crisisContact?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      behaviorExperiments?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      exposures?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      exposureSituations?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      exposureSituationReactions?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      aiImages?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
      videoView?: {
        __typename?: 'FeatureFlag';
        name: string;
        count?: number | null;
      } | null;
    };
    privacySettings?: {
      __typename?: 'PrivacySettings';
      isPrivacyAccepted?: boolean | null;
      isTermsAccepted?: boolean | null;
      isProductEmailNotifyOn?: boolean | null;
      isProductPushNotifyOn?: boolean | null;
      isErrorInfoCollectionOn?: boolean | null;
      isGAUsageCollectionOn?: boolean | null;
      isKeepLoggedInOn?: boolean | null;
    } | null;
  } | null;
};

export type UserIdQueryVariables = Exact<{ [key: string]: never }>;

export type UserIdQuery = {
  __typename?: 'Query';
  user?: { __typename?: 'User'; _id: string } | null;
};

export type CreateUserMutationVariables = Exact<{
  user: UserInput;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutation';
  createUser?: {
    __typename?: 'UserResponse';
    user?: {
      __typename?: 'User';
      _id: string;
      _key: string;
      firstName?: string | null;
      lastName?: string | null;
      displayName?: string | null;
      email: any;
      role: number;
      photoUrl?: string | null;
      lng: string;
      timezone: string;
      fcmToken?: string | null;
      accessLevel?: string | null;
      adaptyProfileId?: string | null;
      hasAdaptyPremiumAccess?: boolean | null;
      subscriptionExpiredAt?: any | null;
      country?: string | null;
      state?: string | null;
      esMode?: EsMode | null;
      featureFlags: {
        __typename?: 'FeatureFlags';
        cardsSearch?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        articlesView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        statsView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        locationReminders?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        dayReminders?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        phq9?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        gad7?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        meditations?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        worryTrees?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        downwardArrows?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        crisisContact?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        behaviorExperiments?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposures?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposureSituations?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposureSituationReactions?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        aiImages?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        videoView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
      };
      privacySettings?: {
        __typename?: 'PrivacySettings';
        isPrivacyAccepted?: boolean | null;
        isTermsAccepted?: boolean | null;
        isProductEmailNotifyOn?: boolean | null;
        isProductPushNotifyOn?: boolean | null;
        isErrorInfoCollectionOn?: boolean | null;
        isGAUsageCollectionOn?: boolean | null;
        isKeepLoggedInOn?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateUserSettingMutationVariables = Exact<{
  settings: UserSettingInput;
}>;

export type UpdateUserSettingMutation = {
  __typename?: 'Mutation';
  updateUserSetting?: {
    __typename?: 'UserResponse';
    user?: {
      __typename?: 'User';
      _id: string;
      _key: string;
      firstName?: string | null;
      lastName?: string | null;
      displayName?: string | null;
      email: any;
      role: number;
      photoUrl?: string | null;
      lng: string;
      timezone: string;
      fcmToken?: string | null;
      accessLevel?: string | null;
      adaptyProfileId?: string | null;
      hasAdaptyPremiumAccess?: boolean | null;
      subscriptionExpiredAt?: any | null;
      country?: string | null;
      state?: string | null;
      esMode?: EsMode | null;
      featureFlags: {
        __typename?: 'FeatureFlags';
        cardsSearch?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        articlesView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        statsView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        locationReminders?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        dayReminders?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        phq9?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        gad7?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        meditations?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        worryTrees?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        downwardArrows?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        crisisContact?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        behaviorExperiments?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposures?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposureSituations?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposureSituationReactions?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        aiImages?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        videoView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
      };
      privacySettings?: {
        __typename?: 'PrivacySettings';
        isPrivacyAccepted?: boolean | null;
        isTermsAccepted?: boolean | null;
        isProductEmailNotifyOn?: boolean | null;
        isProductPushNotifyOn?: boolean | null;
        isErrorInfoCollectionOn?: boolean | null;
        isGAUsageCollectionOn?: boolean | null;
        isKeepLoggedInOn?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateUserPrivacySettingMutationVariables = Exact<{
  privacySettings: UserPrivacySettingsInput;
}>;

export type UpdateUserPrivacySettingMutation = {
  __typename?: 'Mutation';
  updateUserPrivacy?: {
    __typename?: 'UserResponse';
    user?: {
      __typename?: 'User';
      _id: string;
      _key: string;
      firstName?: string | null;
      lastName?: string | null;
      displayName?: string | null;
      email: any;
      role: number;
      photoUrl?: string | null;
      lng: string;
      timezone: string;
      fcmToken?: string | null;
      accessLevel?: string | null;
      adaptyProfileId?: string | null;
      hasAdaptyPremiumAccess?: boolean | null;
      subscriptionExpiredAt?: any | null;
      country?: string | null;
      state?: string | null;
      esMode?: EsMode | null;
      featureFlags: {
        __typename?: 'FeatureFlags';
        cardsSearch?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        articlesView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        statsView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        locationReminders?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        dayReminders?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        phq9?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        gad7?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        meditations?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        worryTrees?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        downwardArrows?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        crisisContact?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        behaviorExperiments?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposures?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposureSituations?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposureSituationReactions?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        aiImages?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        videoView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
      };
      privacySettings?: {
        __typename?: 'PrivacySettings';
        isPrivacyAccepted?: boolean | null;
        isTermsAccepted?: boolean | null;
        isProductEmailNotifyOn?: boolean | null;
        isProductPushNotifyOn?: boolean | null;
        isErrorInfoCollectionOn?: boolean | null;
        isGAUsageCollectionOn?: boolean | null;
        isKeepLoggedInOn?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateFcmTokenMutationVariables = Exact<{
  fcmToken: UserFcmTokenInput;
}>;

export type UpdateFcmTokenMutation = {
  __typename?: 'Mutation';
  updateFcmToken?: {
    __typename?: 'UserResponse';
    user?: {
      __typename?: 'User';
      _id: string;
      _key: string;
      firstName?: string | null;
      lastName?: string | null;
      displayName?: string | null;
      email: any;
      role: number;
      photoUrl?: string | null;
      lng: string;
      timezone: string;
      fcmToken?: string | null;
      accessLevel?: string | null;
      adaptyProfileId?: string | null;
      hasAdaptyPremiumAccess?: boolean | null;
      subscriptionExpiredAt?: any | null;
      country?: string | null;
      state?: string | null;
      esMode?: EsMode | null;
      featureFlags: {
        __typename?: 'FeatureFlags';
        cardsSearch?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        articlesView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        statsView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        locationReminders?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        dayReminders?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        phq9?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        gad7?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        meditations?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        worryTrees?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        downwardArrows?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        crisisContact?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        behaviorExperiments?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposures?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposureSituations?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposureSituationReactions?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        aiImages?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        videoView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
      };
      privacySettings?: {
        __typename?: 'PrivacySettings';
        isPrivacyAccepted?: boolean | null;
        isTermsAccepted?: boolean | null;
        isProductEmailNotifyOn?: boolean | null;
        isProductPushNotifyOn?: boolean | null;
        isErrorInfoCollectionOn?: boolean | null;
        isGAUsageCollectionOn?: boolean | null;
        isKeepLoggedInOn?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateUserAccessLevelMutationVariables = Exact<{
  accessLevel: UserSubscriptionInput;
}>;

export type UpdateUserAccessLevelMutation = {
  __typename?: 'Mutation';
  updateUserAccessLevel?: {
    __typename?: 'UserResponse';
    user?: {
      __typename?: 'User';
      _id: string;
      _key: string;
      firstName?: string | null;
      lastName?: string | null;
      displayName?: string | null;
      email: any;
      role: number;
      photoUrl?: string | null;
      lng: string;
      timezone: string;
      fcmToken?: string | null;
      accessLevel?: string | null;
      adaptyProfileId?: string | null;
      hasAdaptyPremiumAccess?: boolean | null;
      subscriptionExpiredAt?: any | null;
      country?: string | null;
      state?: string | null;
      esMode?: EsMode | null;
      featureFlags: {
        __typename?: 'FeatureFlags';
        cardsSearch?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        articlesView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        statsView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        locationReminders?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        dayReminders?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        phq9?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        gad7?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        meditations?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        worryTrees?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        downwardArrows?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        crisisContact?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        behaviorExperiments?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposures?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposureSituations?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposureSituationReactions?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        aiImages?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        videoView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
      };
      privacySettings?: {
        __typename?: 'PrivacySettings';
        isPrivacyAccepted?: boolean | null;
        isTermsAccepted?: boolean | null;
        isProductEmailNotifyOn?: boolean | null;
        isProductPushNotifyOn?: boolean | null;
        isErrorInfoCollectionOn?: boolean | null;
        isGAUsageCollectionOn?: boolean | null;
        isKeepLoggedInOn?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type UpdateUserRoleMutationVariables = Exact<{
  role: Scalars['Int'];
}>;

export type UpdateUserRoleMutation = {
  __typename?: 'Mutation';
  updateUserRole?: {
    __typename?: 'UserResponse';
    user?: {
      __typename?: 'User';
      _id: string;
      _key: string;
      firstName?: string | null;
      lastName?: string | null;
      displayName?: string | null;
      email: any;
      role: number;
      photoUrl?: string | null;
      lng: string;
      timezone: string;
      fcmToken?: string | null;
      accessLevel?: string | null;
      adaptyProfileId?: string | null;
      hasAdaptyPremiumAccess?: boolean | null;
      subscriptionExpiredAt?: any | null;
      country?: string | null;
      state?: string | null;
      esMode?: EsMode | null;
      featureFlags: {
        __typename?: 'FeatureFlags';
        cardsSearch?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        articlesView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        statsView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        locationReminders?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        dayReminders?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        phq9?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        gad7?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        meditations?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        worryTrees?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        downwardArrows?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        crisisContact?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        behaviorExperiments?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposures?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposureSituations?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        exposureSituationReactions?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        aiImages?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
        videoView?: {
          __typename?: 'FeatureFlag';
          name: string;
          count?: number | null;
        } | null;
      };
      privacySettings?: {
        __typename?: 'PrivacySettings';
        isPrivacyAccepted?: boolean | null;
        isTermsAccepted?: boolean | null;
        isProductEmailNotifyOn?: boolean | null;
        isProductPushNotifyOn?: boolean | null;
        isErrorInfoCollectionOn?: boolean | null;
        isGAUsageCollectionOn?: boolean | null;
        isKeepLoggedInOn?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type ValuesCommandFieldsFragment = {
  __typename?: 'ValuesCommandPayload';
  id: string;
  recorded: boolean;
  assignmentId?: string | null;
};

export type ValuesWheelFieldsFragment = {
  __typename?: 'ValuesWheel';
  wheelId: string;
  preset: string;
  ratedAt?: any | null;
  ratedBy?: string | null;
  ratedByName?: string | null;
  ratedInSession: boolean;
  sectors: Array<{
    __typename?: 'ValuesWheelSector';
    sectorId: string;
    name: string;
    valueStatement?: string | null;
    current?: number | null;
    ideal?: number | null;
    gap?: number | null;
    obstacles: Array<{
      __typename?: 'ValuesWheelObstacle';
      obstacleId: string;
      obstacle: string;
      severity: number;
    }>;
    actions: Array<{
      __typename?: 'ValuesWheelAction';
      actionId: string;
      action: string;
      dueAt: any;
      assignmentId: string;
      status: string;
    }>;
  }>;
  previousRatings: Array<{
    __typename?: 'ValuesWheelRating';
    ratingId: string;
    ratedAt: any;
    ratedBy?: string | null;
    ratedByName?: string | null;
    sectors: Array<{
      __typename?: 'ValuesWheelSectorMark';
      sectorId: string;
      current: number;
      ideal: number;
    }>;
  }>;
};

export type ValuesProfileFieldsFragment = {
  __typename?: 'ValuesProfile';
  subject: string;
  lastSortAt?: any | null;
  wheelRatedAt?: any | null;
  vlqComposite?: number | null;
  values: Array<{
    __typename?: 'ValuesProfileValue';
    value: string;
    rank?: number | null;
    cardText?: string | null;
    wheelSector?: string | null;
    wheelSectorName?: string | null;
    wheelPreset?: string | null;
    current?: number | null;
    ideal?: number | null;
    gap?: number | null;
    vlqArea?: string | null;
    importance?: number | null;
    consistency?: number | null;
    vlqGap?: number | null;
    gapArea?: string | null;
    vlqGapArea?: string | null;
    rose?: {
      __typename?: 'RoseProfile';
      strategyId: string;
      name: string;
      cappedMean?: number | null;
      scores?: {
        __typename?: 'RoseScores';
        loveAcceptance: number;
        empathyUnderstanding: number;
        predictabilityReliability: number;
        safety: number;
        competence: number;
        autonomy: number;
        selfExpression: number;
        spontaneity: number;
      } | null;
    } | null;
    actions: Array<{
      __typename?: 'ValuesProfileAction';
      actionId: string;
      action: string;
      dueAt: any;
      assignmentId: string;
      status: string;
    }>;
    activities: Array<{
      __typename?: 'ValuesProfileActivity';
      activityId: string;
      activity: string;
      difficulty: number;
      status: string;
    }>;
    links: Array<{
      __typename?: 'ValuesProfileLink';
      linkId: string;
      focusType: string;
      focus: string;
    }>;
  }>;
};

export type PublishValuesDeckMutationVariables = Exact<{
  input: PublishValuesDeckInput;
}>;

export type PublishValuesDeckMutation = {
  __typename?: 'Mutation';
  publishValuesDeck: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type StartValuesSortMutationVariables = Exact<{
  input: StartValuesSortInput;
}>;

export type StartValuesSortMutation = {
  __typename?: 'Mutation';
  startValuesSort: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type CompleteValuesSortMutationVariables = Exact<{
  input: CompleteValuesSortInput;
}>;

export type CompleteValuesSortMutation = {
  __typename?: 'Mutation';
  completeValuesSort: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type ConfigureValuesWheelMutationVariables = Exact<{
  input: ConfigureValuesWheelInput;
}>;

export type ConfigureValuesWheelMutation = {
  __typename?: 'Mutation';
  configureValuesWheel: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type RateValuesWheelMutationVariables = Exact<{
  input: RateValuesWheelInput;
}>;

export type RateValuesWheelMutation = {
  __typename?: 'Mutation';
  rateValuesWheel: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type RateValuesWheelInSessionMutationVariables = Exact<{
  input: RateValuesWheelInSessionInput;
}>;

export type RateValuesWheelInSessionMutation = {
  __typename?: 'Mutation';
  rateValuesWheelInSession: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type NoteValuesObstacleMutationVariables = Exact<{
  input: NoteValuesObstacleInput;
}>;

export type NoteValuesObstacleMutation = {
  __typename?: 'Mutation';
  noteValuesObstacle: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type CommitToValuedActionMutationVariables = Exact<{
  input: CommitToValuedActionInput;
}>;

export type CommitToValuedActionMutation = {
  __typename?: 'Mutation';
  commitToValuedAction: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type CompleteValuedLivingQuestionnaireMutationVariables = Exact<{
  input: CompleteValuedLivingQuestionnaireInput;
}>;

export type CompleteValuedLivingQuestionnaireMutation = {
  __typename?: 'Mutation';
  completeValuedLivingQuestionnaire: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type DefineValueActivityMutationVariables = Exact<{
  input: DefineValueActivityInput;
}>;

export type DefineValueActivityMutation = {
  __typename?: 'Mutation';
  defineValueActivity: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type RequestActivitySuggestionsMutationVariables = Exact<{
  input: RequestActivitySuggestionsInput;
}>;

export type RequestActivitySuggestionsMutation = {
  __typename?: 'Mutation';
  requestActivitySuggestions: {
    __typename?: 'ActivitySuggestionsPayload';
    requestId: string;
    recorded: boolean;
    code?: string | null;
    suggestions: Array<{
      __typename?: 'SuggestedActivity';
      activity: string;
      difficulty: number;
    }>;
  };
};

export type LinkRecordToValueMutationVariables = Exact<{
  input: LinkRecordToValueInput;
}>;

export type LinkRecordToValueMutation = {
  __typename?: 'Mutation';
  linkRecordToValue: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type UnlinkRecordFromValueMutationVariables = Exact<{
  input: UnlinkRecordFromValueInput;
}>;

export type UnlinkRecordFromValueMutation = {
  __typename?: 'Mutation';
  unlinkRecordFromValue: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type ValuesDeckQueryVariables = Exact<{
  language?: InputMaybe<Scalars['String']>;
}>;

export type ValuesDeckQuery = {
  __typename?: 'Query';
  valuesDeck?: {
    __typename?: 'ValuesDeck';
    deckId: string;
    name: string;
    licence: string;
    citation: string;
    language: string;
    cards: Array<{ __typename?: 'ValuesDeckCard'; card: string; text: string }>;
    presets: Array<{
      __typename?: 'ValuesDeckPreset';
      preset: string;
      cards: number;
      cardIds: Array<string>;
    }>;
  } | null;
};

export type ValuesSortProgressQueryVariables = Exact<{ [key: string]: never }>;

export type ValuesSortProgressQuery = {
  __typename?: 'Query';
  valuesSortProgress: Array<{
    __typename?: 'ValuesSortProgressRow';
    sortId: string;
    deckId: string;
    preset: string;
    cardOrder: Array<string>;
    status: string;
    startedAt: any;
    completedAt?: any | null;
  }>;
};

export type ValuesSortResultQueryVariables = Exact<{
  sortId: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
}>;

export type ValuesSortResultQuery = {
  __typename?: 'Query';
  valuesSortResult?: {
    __typename?: 'ValuesSortResult';
    sortId: string;
    deckId: string;
    ranked: Array<string>;
    veryImportantCount: number;
    occurredAt: any;
    piles: {
      __typename?: 'ValuesSortPiles';
      veryImportant: Array<string>;
      important: Array<string>;
      notImportant: Array<string>;
    };
    cardText: Array<{
      __typename?: 'ValuesDeckCard';
      card: string;
      text: string;
    }>;
  } | null;
};

export type ValuesWheelQueryVariables = Exact<{
  subject?: InputMaybe<Scalars['ID']>;
}>;

export type ValuesWheelQuery = {
  __typename?: 'Query';
  valuesWheel?: {
    __typename?: 'ValuesWheel';
    wheelId: string;
    preset: string;
    ratedAt?: any | null;
    ratedBy?: string | null;
    ratedByName?: string | null;
    ratedInSession: boolean;
    sectors: Array<{
      __typename?: 'ValuesWheelSector';
      sectorId: string;
      name: string;
      valueStatement?: string | null;
      current?: number | null;
      ideal?: number | null;
      gap?: number | null;
      obstacles: Array<{
        __typename?: 'ValuesWheelObstacle';
        obstacleId: string;
        obstacle: string;
        severity: number;
      }>;
      actions: Array<{
        __typename?: 'ValuesWheelAction';
        actionId: string;
        action: string;
        dueAt: any;
        assignmentId: string;
        status: string;
      }>;
    }>;
    previousRatings: Array<{
      __typename?: 'ValuesWheelRating';
      ratingId: string;
      ratedAt: any;
      ratedBy?: string | null;
      ratedByName?: string | null;
      sectors: Array<{
        __typename?: 'ValuesWheelSectorMark';
        sectorId: string;
        current: number;
        ideal: number;
      }>;
    }>;
  } | null;
};

export type ValuedLivingResultQueryVariables = Exact<{
  vlqId?: InputMaybe<Scalars['ID']>;
}>;

export type ValuedLivingResultQuery = {
  __typename?: 'Query';
  valuedLivingResult?: {
    __typename?: 'ValuedLivingResult';
    vlqId: string;
    composite: number;
    occurredAt: any;
    previousComposite?: number | null;
    changeSinceLast?: number | null;
    areas: Array<{
      __typename?: 'ValuedLivingArea';
      area: string;
      importance: number;
      consistency: number;
      gap: number;
    }>;
  } | null;
};

export type ValueActivitiesQueryVariables = Exact<{
  value: Scalars['String'];
}>;

export type ValueActivitiesQuery = {
  __typename?: 'Query';
  valueActivities: {
    __typename?: 'ValueActivities';
    value: string;
    suggestionRequestId?: string | null;
    activities: Array<{
      __typename?: 'ValueActivityRow';
      activityId: string;
      activity: string;
      difficulty: number;
      source: string;
      origin: string;
      status: string;
    }>;
    suggested: Array<{
      __typename?: 'SuggestedActivity';
      activity: string;
      difficulty: number;
    }>;
  };
};

export type ValuesProfileQueryVariables = Exact<{
  subject?: InputMaybe<Scalars['ID']>;
  language?: InputMaybe<Scalars['String']>;
}>;

export type ValuesProfileQuery = {
  __typename?: 'Query';
  valuesProfile: {
    __typename?: 'ValuesProfile';
    subject: string;
    lastSortAt?: any | null;
    wheelRatedAt?: any | null;
    vlqComposite?: number | null;
    values: Array<{
      __typename?: 'ValuesProfileValue';
      value: string;
      rank?: number | null;
      cardText?: string | null;
      wheelSector?: string | null;
      wheelSectorName?: string | null;
      wheelPreset?: string | null;
      current?: number | null;
      ideal?: number | null;
      gap?: number | null;
      vlqArea?: string | null;
      importance?: number | null;
      consistency?: number | null;
      vlqGap?: number | null;
      gapArea?: string | null;
      vlqGapArea?: string | null;
      rose?: {
        __typename?: 'RoseProfile';
        strategyId: string;
        name: string;
        cappedMean?: number | null;
        scores?: {
          __typename?: 'RoseScores';
          loveAcceptance: number;
          empathyUnderstanding: number;
          predictabilityReliability: number;
          safety: number;
          competence: number;
          autonomy: number;
          selfExpression: number;
          spontaneity: number;
        } | null;
      } | null;
      actions: Array<{
        __typename?: 'ValuesProfileAction';
        actionId: string;
        action: string;
        dueAt: any;
        assignmentId: string;
        status: string;
      }>;
      activities: Array<{
        __typename?: 'ValuesProfileActivity';
        activityId: string;
        activity: string;
        difficulty: number;
        status: string;
      }>;
      links: Array<{
        __typename?: 'ValuesProfileLink';
        linkId: string;
        focusType: string;
        focus: string;
      }>;
    }>;
  };
};

export type RoseScoresFieldsFragment = {
  __typename?: 'RoseScores';
  loveAcceptance: number;
  empathyUnderstanding: number;
  predictabilityReliability: number;
  safety: number;
  competence: number;
  autonomy: number;
  selfExpression: number;
  spontaneity: number;
};

export type RoseExamplesFieldsFragment = {
  __typename?: 'RoseExamples';
  loveAcceptance?: string | null;
  empathyUnderstanding?: string | null;
  predictabilityReliability?: string | null;
  safety?: string | null;
  competence?: string | null;
  autonomy?: string | null;
  selfExpression?: string | null;
  spontaneity?: string | null;
};

export type RoseStrategyFieldsFragment = {
  __typename?: 'RoseStrategy';
  strategyId: string;
  name: string;
  kind: string;
  behaviors: Array<string>;
  describedAt: any;
  describedInSession: boolean;
  basis?: string | null;
  ratedAt?: any | null;
  rawMean?: number | null;
  cappedMean?: number | null;
  inspiredBy?: {
    __typename?: 'RoseInspiredBy';
    kind: string;
    ref?: string | null;
  } | null;
  scores?: {
    __typename?: 'RoseScores';
    loveAcceptance: number;
    empathyUnderstanding: number;
    predictabilityReliability: number;
    safety: number;
    competence: number;
    autonomy: number;
    selfExpression: number;
    spontaneity: number;
  } | null;
  examples: {
    __typename?: 'RoseExamples';
    loveAcceptance?: string | null;
    empathyUnderstanding?: string | null;
    predictabilityReliability?: string | null;
    safety?: string | null;
    competence?: string | null;
    autonomy?: string | null;
    selfExpression?: string | null;
    spontaneity?: string | null;
  };
  history: Array<{
    __typename?: 'RoseRating';
    ratingId: string;
    ratedAt: any;
    basis: string;
    rawMean: number;
    cappedMean: number;
    ratedInSession: boolean;
    scores: {
      __typename?: 'RoseScores';
      loveAcceptance: number;
      empathyUnderstanding: number;
      predictabilityReliability: number;
      safety: number;
      competence: number;
      autonomy: number;
      selfExpression: number;
      spontaneity: number;
    };
    examples: {
      __typename?: 'RoseExamples';
      loveAcceptance?: string | null;
      empathyUnderstanding?: string | null;
      predictabilityReliability?: string | null;
      safety?: string | null;
      competence?: string | null;
      autonomy?: string | null;
      selfExpression?: string | null;
      spontaneity?: string | null;
    };
  }>;
  chosen?: {
    __typename?: 'RoseChoice';
    choiceId: string;
    chosenAt: any;
    value: string;
    beliefs: Array<string>;
    sharedBy: Array<string>;
    comparedWith: Array<string>;
    chosenInSession: boolean;
  } | null;
  plan?: {
    __typename?: 'RosePlan';
    planId: string;
    writtenAt: any;
    planWeek: Array<{
      __typename?: 'RosePlanItem';
      what: string;
      withWhom: string;
      resources: string;
    }>;
    planMonth: Array<{
      __typename?: 'RosePlanItem';
      what: string;
      withWhom: string;
      resources: string;
    }>;
    planYear: Array<{
      __typename?: 'RosePlanItem';
      what: string;
      withWhom: string;
      resources: string;
    }>;
  } | null;
};

export type WindRoseQueryVariables = Exact<{
  subject?: InputMaybe<Scalars['ID']>;
}>;

export type WindRoseQuery = {
  __typename?: 'Query';
  windRose: {
    __typename?: 'WindRose';
    subject: string;
    ratedAt?: any | null;
    chosenStrategyId?: string | null;
    strategies: Array<{
      __typename?: 'RoseStrategy';
      strategyId: string;
      name: string;
      kind: string;
      behaviors: Array<string>;
      describedAt: any;
      describedInSession: boolean;
      basis?: string | null;
      ratedAt?: any | null;
      rawMean?: number | null;
      cappedMean?: number | null;
      inspiredBy?: {
        __typename?: 'RoseInspiredBy';
        kind: string;
        ref?: string | null;
      } | null;
      scores?: {
        __typename?: 'RoseScores';
        loveAcceptance: number;
        empathyUnderstanding: number;
        predictabilityReliability: number;
        safety: number;
        competence: number;
        autonomy: number;
        selfExpression: number;
        spontaneity: number;
      } | null;
      examples: {
        __typename?: 'RoseExamples';
        loveAcceptance?: string | null;
        empathyUnderstanding?: string | null;
        predictabilityReliability?: string | null;
        safety?: string | null;
        competence?: string | null;
        autonomy?: string | null;
        selfExpression?: string | null;
        spontaneity?: string | null;
      };
      history: Array<{
        __typename?: 'RoseRating';
        ratingId: string;
        ratedAt: any;
        basis: string;
        rawMean: number;
        cappedMean: number;
        ratedInSession: boolean;
        scores: {
          __typename?: 'RoseScores';
          loveAcceptance: number;
          empathyUnderstanding: number;
          predictabilityReliability: number;
          safety: number;
          competence: number;
          autonomy: number;
          selfExpression: number;
          spontaneity: number;
        };
        examples: {
          __typename?: 'RoseExamples';
          loveAcceptance?: string | null;
          empathyUnderstanding?: string | null;
          predictabilityReliability?: string | null;
          safety?: string | null;
          competence?: string | null;
          autonomy?: string | null;
          selfExpression?: string | null;
          spontaneity?: string | null;
        };
      }>;
      chosen?: {
        __typename?: 'RoseChoice';
        choiceId: string;
        chosenAt: any;
        value: string;
        beliefs: Array<string>;
        sharedBy: Array<string>;
        comparedWith: Array<string>;
        chosenInSession: boolean;
      } | null;
      plan?: {
        __typename?: 'RosePlan';
        planId: string;
        writtenAt: any;
        planWeek: Array<{
          __typename?: 'RosePlanItem';
          what: string;
          withWhom: string;
          resources: string;
        }>;
        planMonth: Array<{
          __typename?: 'RosePlanItem';
          what: string;
          withWhom: string;
          resources: string;
        }>;
        planYear: Array<{
          __typename?: 'RosePlanItem';
          what: string;
          withWhom: string;
          resources: string;
        }>;
      } | null;
    }>;
  };
};

export type DescribeBehaviorStrategyMutationVariables = Exact<{
  input: DescribeBehaviorStrategyInput;
}>;

export type DescribeBehaviorStrategyMutation = {
  __typename?: 'Mutation';
  describeBehaviorStrategy: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type DescribeBehaviorStrategyInSessionMutationVariables = Exact<{
  input: DescribeBehaviorStrategyInSessionInput;
}>;

export type DescribeBehaviorStrategyInSessionMutation = {
  __typename?: 'Mutation';
  describeBehaviorStrategyInSession: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type RateStrategyOnNeedsMutationVariables = Exact<{
  input: RateStrategyOnNeedsInput;
}>;

export type RateStrategyOnNeedsMutation = {
  __typename?: 'Mutation';
  rateStrategyOnNeeds: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type RateStrategyOnNeedsInSessionMutationVariables = Exact<{
  input: RateStrategyOnNeedsInSessionInput;
}>;

export type RateStrategyOnNeedsInSessionMutation = {
  __typename?: 'Mutation';
  rateStrategyOnNeedsInSession: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type ChooseBehaviorStrategyMutationVariables = Exact<{
  input: ChooseBehaviorStrategyInput;
}>;

export type ChooseBehaviorStrategyMutation = {
  __typename?: 'Mutation';
  chooseBehaviorStrategy: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type ChooseBehaviorStrategyInSessionMutationVariables = Exact<{
  input: ChooseBehaviorStrategyInSessionInput;
}>;

export type ChooseBehaviorStrategyInSessionMutation = {
  __typename?: 'Mutation';
  chooseBehaviorStrategyInSession: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type WriteStrategyPlanMutationVariables = Exact<{
  input: WriteStrategyPlanInput;
}>;

export type WriteStrategyPlanMutation = {
  __typename?: 'Mutation';
  writeStrategyPlan: {
    __typename?: 'ValuesCommandPayload';
    id: string;
    recorded: boolean;
    assignmentId?: string | null;
  };
};

export type CreateViciousCycleMutationVariables = Exact<{
  input: CreateViciousCycleInput;
}>;

export type CreateViciousCycleMutation = {
  __typename?: 'Mutation';
  createViciousCycle?: {
    __typename?: 'ViciousCyclePayload';
    viciousCycleId: string;
    supportingCycle?: {
      __typename?: 'SupportingCycle';
      _id: string;
      createdAt: any;
      updatedAt: any;
      userId?: string | null;
      name?: string | null;
      isTemplate?: boolean | null;
      templateLanguage?: string | null;
      viciousCycleId?: string | null;
      thoughts: Array<{
        __typename?: 'SupportingCycleThought';
        thought?: string | null;
        edges?: Array<boolean | null> | null;
      } | null>;
    } | null;
  } | null;
};

export type RenameViciousCycleMutationVariables = Exact<{
  input: RenameViciousCycleInput;
}>;

export type RenameViciousCycleMutation = {
  __typename?: 'Mutation';
  renameViciousCycle?: {
    __typename?: 'ViciousCyclePayload';
    viciousCycleId: string;
    supportingCycle?: {
      __typename?: 'SupportingCycle';
      _id: string;
      createdAt: any;
      updatedAt: any;
      userId?: string | null;
      name?: string | null;
      isTemplate?: boolean | null;
      templateLanguage?: string | null;
      viciousCycleId?: string | null;
      thoughts: Array<{
        __typename?: 'SupportingCycleThought';
        thought?: string | null;
        edges?: Array<boolean | null> | null;
      } | null>;
    } | null;
  } | null;
};

export type AddCycleThoughtMutationVariables = Exact<{
  input: AddCycleThoughtInput;
}>;

export type AddCycleThoughtMutation = {
  __typename?: 'Mutation';
  addCycleThought?: {
    __typename?: 'ViciousCyclePayload';
    viciousCycleId: string;
    supportingCycle?: {
      __typename?: 'SupportingCycle';
      _id: string;
      createdAt: any;
      updatedAt: any;
      userId?: string | null;
      name?: string | null;
      isTemplate?: boolean | null;
      templateLanguage?: string | null;
      viciousCycleId?: string | null;
      thoughts: Array<{
        __typename?: 'SupportingCycleThought';
        thought?: string | null;
        edges?: Array<boolean | null> | null;
      } | null>;
    } | null;
  } | null;
};

export type RemoveCycleThoughtMutationVariables = Exact<{
  input: RemoveCycleThoughtInput;
}>;

export type RemoveCycleThoughtMutation = {
  __typename?: 'Mutation';
  removeCycleThought?: {
    __typename?: 'ViciousCyclePayload';
    viciousCycleId: string;
    supportingCycle?: {
      __typename?: 'SupportingCycle';
      _id: string;
      createdAt: any;
      updatedAt: any;
      userId?: string | null;
      name?: string | null;
      isTemplate?: boolean | null;
      templateLanguage?: string | null;
      viciousCycleId?: string | null;
      thoughts: Array<{
        __typename?: 'SupportingCycleThought';
        thought?: string | null;
        edges?: Array<boolean | null> | null;
      } | null>;
    } | null;
  } | null;
};

export type ToggleCycleRelationMutationVariables = Exact<{
  input: ToggleCycleRelationInput;
}>;

export type ToggleCycleRelationMutation = {
  __typename?: 'Mutation';
  toggleCycleRelation?: {
    __typename?: 'ViciousCyclePayload';
    viciousCycleId: string;
    supportingCycle?: {
      __typename?: 'SupportingCycle';
      _id: string;
      createdAt: any;
      updatedAt: any;
      userId?: string | null;
      name?: string | null;
      isTemplate?: boolean | null;
      templateLanguage?: string | null;
      viciousCycleId?: string | null;
      thoughts: Array<{
        __typename?: 'SupportingCycleThought';
        thought?: string | null;
        edges?: Array<boolean | null> | null;
      } | null>;
    } | null;
  } | null;
};

export type EditCycleThoughtMutationVariables = Exact<{
  input: EditCycleThoughtInput;
}>;

export type EditCycleThoughtMutation = {
  __typename?: 'Mutation';
  editCycleThought?: {
    __typename?: 'ViciousCyclePayload';
    viciousCycleId: string;
    supportingCycle?: {
      __typename?: 'SupportingCycle';
      _id: string;
      createdAt: any;
      updatedAt: any;
      userId?: string | null;
      name?: string | null;
      isTemplate?: boolean | null;
      templateLanguage?: string | null;
      viciousCycleId?: string | null;
      thoughts: Array<{
        __typename?: 'SupportingCycleThought';
        thought?: string | null;
        edges?: Array<boolean | null> | null;
      } | null>;
    } | null;
  } | null;
};

export type DeleteViciousCycleMutationVariables = Exact<{
  input: DeleteViciousCycleInput;
}>;

export type DeleteViciousCycleMutation = {
  __typename?: 'Mutation';
  deleteViciousCycle?: {
    __typename?: 'DeleteViciousCyclePayload';
    viciousCycleId: string;
    success: boolean;
  } | null;
};

export type SubmitWellnessEventsMutationVariables = Exact<{
  events: Array<WellnessEventInput> | WellnessEventInput;
}>;

export type SubmitWellnessEventsMutation = {
  __typename?: 'Mutation';
  submitWellnessEvents: {
    __typename?: 'SubmitWellnessEventsPayload';
    lastPosition: number;
    duplicates: Array<string>;
  };
};

export type WorksheetVideoFieldsFragment = {
  __typename?: 'WorksheetVideo';
  source: string;
  ref: string;
  title: string;
  duration?: number | null;
};

export type WorksheetSectionFieldsFragment = {
  __typename?: 'WorksheetSection';
  sectionId: string;
  title?: string | null;
  text?: string | null;
  video?: {
    __typename?: 'WorksheetVideo';
    source: string;
    ref: string;
    title: string;
    duration?: number | null;
  } | null;
  fields: Array<{
    __typename?: 'WorksheetField';
    fieldId: string;
    type: string;
    label: string;
    required?: boolean | null;
    options?: Array<string> | null;
    min?: number | null;
    max?: number | null;
  }>;
};

export type WorksheetScoringFieldsFragment = {
  __typename?: 'WorksheetScoring';
  kind: string;
  fields: Array<string>;
  bands: Array<{
    __typename?: 'WorksheetScoreBand';
    min: number;
    max: number;
    label: string;
  }>;
};

export type WorksheetTemplateFieldsFragment = {
  __typename?: 'WorksheetTemplate';
  templateId: string;
  practiceId?: string | null;
  version: number;
  name: string;
  category: string;
  language: string;
  signatureRequired: boolean;
  repeatable: boolean;
  owner: string;
  assignedCount: number;
  copiedFrom?: string | null;
  fieldCount: number;
  occurredAt: any;
  paperEligible: boolean;
};

export type ClientWorksheetFieldsFragment = {
  __typename?: 'ClientWorksheet';
  assignmentId: string;
  subject: string;
  templateId: string;
  templateVersion?: number | null;
  name?: string | null;
  category?: string | null;
  status: string;
  awaitingSignature: boolean;
  pending: boolean;
  sentAt: any;
  viewedAt?: any | null;
  submittedAt?: any | null;
  signedAt?: any | null;
  submissionId?: string | null;
  submissionIds: Array<string>;
  filledInSession: boolean;
  score?: number | null;
  selfAssigned: boolean;
  paperAllowed: boolean;
  paperPhoto?: {
    __typename?: 'HomeworkPaperPhoto';
    fileRef: string;
    takenAt: any;
  } | null;
};

export type WorksheetTemplatesQueryVariables = Exact<{
  category?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
}>;

export type WorksheetTemplatesQuery = {
  __typename?: 'Query';
  worksheetTemplates: Array<{
    __typename?: 'WorksheetTemplate';
    templateId: string;
    practiceId?: string | null;
    version: number;
    name: string;
    category: string;
    language: string;
    signatureRequired: boolean;
    repeatable: boolean;
    owner: string;
    assignedCount: number;
    copiedFrom?: string | null;
    fieldCount: number;
    occurredAt: any;
    paperEligible: boolean;
  }>;
};

export type WorksheetTemplateQueryVariables = Exact<{
  templateId: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
}>;

export type WorksheetTemplateQuery = {
  __typename?: 'Query';
  worksheetTemplate?: {
    __typename?: 'WorksheetTemplateDetail';
    templateId: string;
    practiceId?: string | null;
    version: number;
    name: string;
    category: string;
    language: string;
    signatureRequired: boolean;
    repeatable: boolean;
    owner: string;
    copiedFrom?: string | null;
    fieldCount: number;
    occurredAt: any;
    retired: boolean;
    paperEligible: boolean;
    sections: Array<{
      __typename?: 'WorksheetSection';
      sectionId: string;
      title?: string | null;
      text?: string | null;
      video?: {
        __typename?: 'WorksheetVideo';
        source: string;
        ref: string;
        title: string;
        duration?: number | null;
      } | null;
      fields: Array<{
        __typename?: 'WorksheetField';
        fieldId: string;
        type: string;
        label: string;
        required?: boolean | null;
        options?: Array<string> | null;
        min?: number | null;
        max?: number | null;
      }>;
    }>;
    scoring?: {
      __typename?: 'WorksheetScoring';
      kind: string;
      fields: Array<string>;
      bands: Array<{
        __typename?: 'WorksheetScoreBand';
        min: number;
        max: number;
        label: string;
      }>;
    } | null;
  } | null;
};

export type ClientWorksheetsQueryVariables = Exact<{
  subject: Scalars['ID'];
  filter?: InputMaybe<Scalars['String']>;
}>;

export type ClientWorksheetsQuery = {
  __typename?: 'Query';
  clientWorksheets: Array<{
    __typename?: 'ClientWorksheet';
    assignmentId: string;
    subject: string;
    templateId: string;
    templateVersion?: number | null;
    name?: string | null;
    category?: string | null;
    status: string;
    awaitingSignature: boolean;
    pending: boolean;
    sentAt: any;
    viewedAt?: any | null;
    submittedAt?: any | null;
    signedAt?: any | null;
    submissionId?: string | null;
    submissionIds: Array<string>;
    filledInSession: boolean;
    score?: number | null;
    selfAssigned: boolean;
    paperAllowed: boolean;
    paperPhoto?: {
      __typename?: 'HomeworkPaperPhoto';
      fileRef: string;
      takenAt: any;
    } | null;
  }>;
};

export type WorksheetFormQueryVariables = Exact<{
  assignmentId: Scalars['ID'];
}>;

export type WorksheetFormQuery = {
  __typename?: 'Query';
  worksheetForm?: {
    __typename?: 'WorksheetForm';
    assignmentId: string;
    subject: string;
    templateId: string;
    templateVersion: number;
    name: string;
    category: string;
    language: string;
    signatureRequired: boolean;
    repeatable: boolean;
    submittedAt?: any | null;
    submissionId?: string | null;
    awaitingSignature: boolean;
    signedAt?: any | null;
    cancelled: boolean;
    sections: Array<{
      __typename?: 'WorksheetSection';
      sectionId: string;
      title?: string | null;
      text?: string | null;
      video?: {
        __typename?: 'WorksheetVideo';
        source: string;
        ref: string;
        title: string;
        duration?: number | null;
      } | null;
      fields: Array<{
        __typename?: 'WorksheetField';
        fieldId: string;
        type: string;
        label: string;
        required?: boolean | null;
        options?: Array<string> | null;
        min?: number | null;
        max?: number | null;
      }>;
    }>;
  } | null;
};

export type WorksheetResponseQueryVariables = Exact<{
  submissionId: Scalars['ID'];
}>;

export type WorksheetResponseQuery = {
  __typename?: 'Query';
  worksheetResponse?: {
    __typename?: 'WorksheetResponse';
    submissionId: string;
    assignmentId: string;
    subject: string;
    templateId: string;
    templateVersion: number;
    name?: string | null;
    answers: any;
    performer: string;
    performerName?: string | null;
    signatureRequired: boolean;
    signerName?: string | null;
    submittedAt: any;
    signedAt?: any | null;
    score?: number | null;
    band?: string | null;
    filledInSession: boolean;
    sections: Array<{
      __typename?: 'WorksheetSection';
      sectionId: string;
      title?: string | null;
      text?: string | null;
      video?: {
        __typename?: 'WorksheetVideo';
        source: string;
        ref: string;
        title: string;
        duration?: number | null;
      } | null;
      fields: Array<{
        __typename?: 'WorksheetField';
        fieldId: string;
        type: string;
        label: string;
        required?: boolean | null;
        options?: Array<string> | null;
        min?: number | null;
        max?: number | null;
      }>;
    }>;
    scoring?: {
      __typename?: 'WorksheetScoring';
      kind: string;
      fields: Array<string>;
      bands: Array<{
        __typename?: 'WorksheetScoreBand';
        min: number;
        max: number;
        label: string;
      }>;
    } | null;
  } | null;
};

export type WorksheetEntriesOverTimeQueryVariables = Exact<{
  subject: Scalars['ID'];
  templateId: Scalars['ID'];
}>;

export type WorksheetEntriesOverTimeQuery = {
  __typename?: 'Query';
  worksheetEntriesOverTime?: {
    __typename?: 'WorksheetEntriesOverTime';
    subject: string;
    templateId: string;
    name?: string | null;
    entryCount: number;
    numericFields: Array<{
      __typename?: 'WorksheetNumericField';
      fieldKey: string;
      label: string;
      type: string;
      min?: number | null;
      max?: number | null;
    }>;
    scoring?: {
      __typename?: 'WorksheetScoring';
      kind: string;
      fields: Array<string>;
      bands: Array<{
        __typename?: 'WorksheetScoreBand';
        min: number;
        max: number;
        label: string;
      }>;
    } | null;
    points: Array<{
      __typename?: 'WorksheetEntryPoint';
      submissionId: string;
      occurredAt: any;
      fieldKey: string;
      value: number;
    }>;
    series: Array<{
      __typename?: 'WorksheetEntrySeries';
      fieldKey: string;
      label: string;
      type: string;
      min?: number | null;
      max?: number | null;
      latest?: number | null;
      count: number;
      points: Array<{
        __typename?: 'WorksheetSeriesPoint';
        submissionId: string;
        occurredAt: any;
        value: number;
      }>;
    }>;
  } | null;
};

export type PublishWorksheetTemplateMutationVariables = Exact<{
  input: PublishWorksheetTemplateInput;
}>;

export type PublishWorksheetTemplateMutation = {
  __typename?: 'Mutation';
  publishWorksheetTemplate: {
    __typename?: 'WorksheetTemplatePayload';
    templateId: string;
    version?: number | null;
    recorded: boolean;
  };
};

export type DefineWorksheetTemplateMutationVariables = Exact<{
  input: DefineWorksheetTemplateInput;
}>;

export type DefineWorksheetTemplateMutation = {
  __typename?: 'Mutation';
  defineWorksheetTemplate: {
    __typename?: 'WorksheetTemplatePayload';
    templateId: string;
    version?: number | null;
    recorded: boolean;
  };
};

export type ReviseWorksheetTemplateMutationVariables = Exact<{
  input: ReviseWorksheetTemplateInput;
}>;

export type ReviseWorksheetTemplateMutation = {
  __typename?: 'Mutation';
  reviseWorksheetTemplate: {
    __typename?: 'WorksheetTemplatePayload';
    templateId: string;
    version?: number | null;
    recorded: boolean;
  };
};

export type RetireWorksheetTemplateMutationVariables = Exact<{
  input: RetireWorksheetTemplateInput;
}>;

export type RetireWorksheetTemplateMutation = {
  __typename?: 'Mutation';
  retireWorksheetTemplate: {
    __typename?: 'WorksheetTemplatePayload';
    templateId: string;
    version?: number | null;
    recorded: boolean;
  };
};

export type SubmitWorksheetMutationVariables = Exact<{
  input: SubmitWorksheetInput;
}>;

export type SubmitWorksheetMutation = {
  __typename?: 'Mutation';
  submitWorksheet: {
    __typename?: 'WorksheetSubmissionPayload';
    assignmentId?: string | null;
    submissionId: string;
    recorded: boolean;
  };
};

export type SignWorksheetMutationVariables = Exact<{
  input: SignWorksheetInput;
}>;

export type SignWorksheetMutation = {
  __typename?: 'Mutation';
  signWorksheet: {
    __typename?: 'WorksheetSubmissionPayload';
    assignmentId?: string | null;
    submissionId: string;
    recorded: boolean;
  };
};

export type ImportWorksheetTemplateMutationVariables = Exact<{
  input: ImportWorksheetTemplateInput;
}>;

export type ImportWorksheetTemplateMutation = {
  __typename?: 'Mutation';
  importWorksheetTemplate: {
    __typename?: 'WorksheetImportDraft';
    importId: string;
    practiceId?: string | null;
    instrumentIds: Array<string>;
    code?: string | null;
    importedFrom?: {
      __typename?: 'WorksheetImportedFrom';
      format: string;
      pages?: number | null;
    } | null;
    documents?: {
      __typename?: 'WorksheetImportDocuments';
      templates: number;
      knownInstruments: number;
      skipped: number;
    } | null;
    drafts: Array<{
      __typename?: 'WorksheetImportDraftItem';
      kind: string;
      pages: Array<number>;
      instrumentId?: string | null;
      instrument?: string | null;
      inCatalogue?: boolean | null;
      reason?: string | null;
      draft?: {
        __typename?: 'WorksheetImportTemplateDraft';
        name: string;
        category: string;
        language: string;
        signatureRequired: boolean;
        repeatable: boolean;
        sections: Array<{
          __typename?: 'WorksheetSection';
          sectionId: string;
          title?: string | null;
          text?: string | null;
          video?: {
            __typename?: 'WorksheetVideo';
            source: string;
            ref: string;
            title: string;
            duration?: number | null;
          } | null;
          fields: Array<{
            __typename?: 'WorksheetField';
            fieldId: string;
            type: string;
            label: string;
            required?: boolean | null;
            options?: Array<string> | null;
            min?: number | null;
            max?: number | null;
          }>;
        }>;
        scoring?: {
          __typename?: 'WorksheetScoring';
          kind: string;
          fields: Array<string>;
          bands: Array<{
            __typename?: 'WorksheetScoreBand';
            min: number;
            max: number;
            label: string;
          }>;
        } | null;
      } | null;
      notes: Array<{
        __typename?: 'WorksheetImportNote';
        code: string;
        pages?: Array<number> | null;
        source?: string | null;
        ref?: string | null;
        count?: number | null;
      }>;
    }>;
  };
};

export type WorryTreeDataFragment = {
  __typename?: 'WorryTree';
  userId: string;
  createdAt: any;
  selectedActivityIdx?: number | null;
  isNotSolvable: boolean;
  worryAbout: string;
  options?: string | null;
  plan?: string | null;
  immediateAction?: string | null;
};

export type WorryTreesQueryVariables = Exact<{
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Scalars['JSON']>;
  start?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type WorryTreesQuery = {
  __typename?: 'Query';
  worryTrees?: {
    __typename?: 'WorryTreeSearch';
    count: number;
    data?: Array<{
      __typename?: 'WorryTree';
      _id: string;
      userId: string;
      createdAt: any;
      selectedActivityIdx?: number | null;
      isNotSolvable: boolean;
      worryAbout: string;
      options?: string | null;
      plan?: string | null;
      immediateAction?: string | null;
    } | null> | null;
  } | null;
};

export type WorryTreeQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']>;
}>;

export type WorryTreeQuery = {
  __typename?: 'Query';
  worryTree?: {
    __typename?: 'WorryTree';
    _id: string;
    userId: string;
    createdAt: any;
    selectedActivityIdx?: number | null;
    isNotSolvable: boolean;
    worryAbout: string;
    options?: string | null;
    plan?: string | null;
    immediateAction?: string | null;
  } | null;
};

export type DeleteWorryTreeMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['ID']>;
}>;

export type DeleteWorryTreeMutation = {
  __typename?: 'Mutation';
  deleteWorryTree?: {
    __typename?: 'WorryTree';
    _id: string;
    userId: string;
    createdAt: any;
    selectedActivityIdx?: number | null;
    isNotSolvable: boolean;
    worryAbout: string;
    options?: string | null;
    plan?: string | null;
    immediateAction?: string | null;
  } | null;
};

export type CreateWorryTreeMutationVariables = Exact<{
  input?: InputMaybe<WorryTreeInput>;
}>;

export type CreateWorryTreeMutation = {
  __typename?: 'Mutation';
  createWorryTree?: {
    __typename?: 'WorryTree';
    _id: string;
    userId: string;
    createdAt: any;
    selectedActivityIdx?: number | null;
    isNotSolvable: boolean;
    worryAbout: string;
    options?: string | null;
    plan?: string | null;
    immediateAction?: string | null;
  } | null;
};

export const AbcModelDataFragmentDoc = gql`
  fragment AbcModelData on AbcModel {
    userId
    createdAt
    updatedAt
    a
    b
    emotions {
      id
      strength
    }
    feelings
    behaviors
  }
`;
export const LocationDataFragmentDoc = gql`
  fragment LocationData on Location {
    _id
    _key
    _rev
    createdAt
    updatedAt
    name
    latitude
    longitude
  }
`;
export const DayRemindersDataFragmentDoc = gql`
  fragment DayRemindersData on DayReminders {
    _id
    _key
    _rev
    thoughtId
    createdAt
    updatedAt
    morning {
      time {
        hours
        minutes
      }
      enabled
    }
    day {
      time {
        hours
        minutes
      }
      enabled
    }
    evening {
      time {
        hours
        minutes
      }
      enabled
    }
  }
`;
export const LocationReminderDataFragmentDoc = gql`
  fragment LocationReminderData on LocationReminder {
    _id
    _key
    _rev
    _from
    _to
    createdAt
    updatedAt
    enter
    leave
    type
  }
`;
export const ThoughtDataFragmentDoc = gql`
  fragment ThoughtData on Thought {
    _id
    _key
    _rev
    userId
    activatingEventId
    createdAt
    updatedAt
    automaticThought
    thoughtBelief
    thoughtsFor
    thoughtsForAlternativeThoughts
    thoughtsAgainst
    cognitiveDistortions
    realisticThoughts {
      thought
      thoughtBelief
    }
    result {
      initialThoughtBelief
      initialNegativeEmotionStrenght
    }
    cardName
    categoriesIds
    dayReminders {
      ...DayRemindersData
    }
    locationReminders {
      ...LocationReminderData
    }
  }
  ${DayRemindersDataFragmentDoc}
  ${LocationReminderDataFragmentDoc}
`;
export const ActivatingEventDataFragmentDoc = gql`
  fragment ActivatingEventData on ActivatingEvent {
    _id
    _key
    _rev
    userId
    description
    location {
      ...LocationData
    }
    interval {
      start
      end
    }
    participantIds
    imageUrl
    createdAt
    updatedAt
    emotions {
      id
      strength
    }
    feelings
    bodyPartsFeelings
    thoughts {
      ...ThoughtData
    }
    behaviors
  }
  ${LocationDataFragmentDoc}
  ${ThoughtDataFragmentDoc}
`;
export const FeatureAnnouncementFieldsFragmentDoc = gql`
  fragment FeatureAnnouncementFields on FeatureAnnouncement {
    announcementId
    variantId
    title
    summary
    mediaUrl
    articleUrl
    surface
    language
    relatedReleases
    publishAt
    acknowledgedAt
  }
`;
export const AppLockFieldsFragmentDoc = gql`
  fragment AppLockFields on AppLock {
    subject
    deviceId
    enabled
    method
    lockAfterMinutes
    exemptions
    updatedAt
  }
`;
export const InstrumentDefinitionFieldsFragmentDoc = gql`
  fragment InstrumentDefinitionFields on InstrumentDefinition {
    instrumentId
    name
    nameRu
    itemsCount
    responseScale {
      min
      max
      labels
    }
    scoringRule
    subscales {
      name
      items
      multiplier
      reverseItems
    }
    bands {
      subscale
      bands {
        min
        max
        band
      }
    }
    licenceClass
    availableFor
    languages
    itemsKey
    citation
  }
`;
export const AssessmentReadingFieldsFragmentDoc = gql`
  fragment AssessmentReadingFields on AssessmentSubscaleReading {
    name
    score
    band
    bandKey
  }
`;
export const BehaviorExperimentDataFragmentDoc = gql`
  fragment BehaviorExperimentData on BehaviorExperiment {
    userId
    therapistId
    createdAt
    updatedAt
    purpose
    design
    hypothesisType
    type
    activeSubtype
    observationalSubtype
    hypothesisA
    hypothesisAStrength
    hypothesisAConfirmationCriteria
    hypothesisB
    hypothesisBStrength
    hypothesisBConfirmationCriteria
    settings {
      experiment
      time
      place
      people
      resources
      survey
    }
    prediction {
      emotions {
        id
        strength
      }
      feelings
      behaviors
      otherPredictions
    }
    safetyBehaviors
    helpfulCopingStrategies
    outcome {
      emotions {
        id
        strength
      }
      feelings
      behaviors
      otherPredictions
      patientReflections
      therapistReflections
      newLearnings
      meaningForOriginalBelief
      oldThoughtStrength
      newThought
      newThoughtStrength
    }
    followUpExperimentsIdeas
  }
`;
export const BehaviorExperimentEsDataFragmentDoc = gql`
  fragment BehaviorExperimentEsData on BehaviorExperiment {
    _id
    ...BehaviorExperimentData
    experimentId
    status
    activatedAt
    completedAt
    observations {
      observationId
      occurredAt
      whatHappened
      emotions {
        id
        strength
      }
      feelings
      behaviors
      whichHypothesisHeld
      rating
      learnings
    }
  }
  ${BehaviorExperimentDataFragmentDoc}
`;
export const BaCommandFieldsFragmentDoc = gql`
  fragment BaCommandFields on BaCommandPayload {
    id
    recorded
    assignmentId
  }
`;
export const PlanItemFieldsFragmentDoc = gql`
  fragment PlanItemFields on PlanItem {
    plannedActivityId
    title
    valueActivityId
    plannedFor
    durationMinutes
    predictedEnjoyment
    predictedImportance
    certainty
    replanOf
    assignmentId
    plannedBy
    status
    enjoyment
    importance
    note
    barrier
  }
`;
export const ActivityWeekFieldsFragmentDoc = gql`
  fragment ActivityWeekFields on ActivityWeek {
    subject
    week
    planned
    done
    missed
    predictedVsActual {
      enjoyment {
        predicted
        actual
      }
      importance {
        predicted
        actual
      }
    }
    byLifeArea {
      area
      hours
    }
    emptyAreas
    moodByDay {
      date
      mood
      activitiesDone
    }
    topBarrier
    healthActivity {
      activeDays
      activeMinutes
      walks
    }
    plans {
      ...PlanItemFields
    }
    hours {
      activityLogId
      startAt
      endAt
      title
      enjoyment
      importance
      valueActivityId
      area
    }
    moods {
      date
      mood
    }
    activityDays {
      date
      activeMinutes
    }
  }
  ${PlanItemFieldsFragmentDoc}
`;
export const ActivityLadderFieldsFragmentDoc = gql`
  fragment ActivityLadderFields on ActivityLadder {
    subject
    rankingId
    rankedAt
    rankedBy
    rungs {
      rank
      valueActivityId
      title
      value
      difficulty
      area
    }
  }
`;
export const CheckInEntryFieldsFragmentDoc = gql`
  fragment CheckInEntryFields on CheckInEntry {
    checkInId
    recordedFor
    occurredAt
    mood
    emotions {
      id
      strength
    }
    energy
    sleepQuality
    sleepHours
    socialConnection
    drivers
    note
    enteredInSession
    practiceId
  }
`;
export const DateTimeReminderDataFragmentDoc = gql`
  fragment DateTimeReminderData on DateTimeReminder {
    _id
    _key
    _rev
    createdAt
    updatedAt
    userId
    date
    enabled
    for
  }
`;
export const DiaryCardRowsFragmentDoc = gql`
  fragment DiaryCardRows on DiaryCardActive {
    cardId
    practiceId
    practiceName
    version
    template
    targets {
      targetId
      name
      kind
      max
      countable
      standard
      faTargetId
    }
    emotions {
      id
    }
    skills {
      skillId
      module
    }
  }
`;
export const DiaryCardRatingFieldsFragmentDoc = gql`
  fragment DiaryCardRatingFields on DiaryCardRating {
    targetId
    urge
    scale
    acted
    count
    text
  }
`;
export const DownwardArrowDataFragmentDoc = gql`
  fragment DownwardArrowData on DownwardArrow {
    userId
    createdAt
    updatedAt
    beliefs
  }
`;
export const EsReminderScheduleFieldsFragmentDoc = gql`
  fragment EsReminderScheduleFields on EsReminderSchedule {
    reminderId
    channel
    updatedAt
    target {
      kind
      ref
    }
    schedule {
      rrule
      dtstart
      tzid
      exdates
    }
    legacyBinding {
      collection
      key
      slot
    }
  }
`;
export const SudDataFragmentDoc = gql`
  fragment SUDData on SUD {
    sud
    reactedAt
    reactionId
    amendedFrom {
      sud
      reactedAt
    }
  }
`;
export const SudExposureStimulusExpositionDataFragmentDoc = gql`
  fragment SUDExposureStimulusExpositionData on ExposureStimulusExposition {
    createdAt
    anticipatedSud
    reactionNotes
    expositionId
    duration
    expectedOutcome
    expectedLikelihood
    outcomeOccurred
    likelihoodAfter
    learned
    suds {
      ...SUDData
    }
  }
  ${SudDataFragmentDoc}
`;
export const ExposureStimulusDataFragmentDoc = gql`
  fragment ExposureStimulusData on ExposureStimulus {
    exposureId
    createdAt
    updatedAt
    rank
    title
    description
    imageUrls
    imagePrompt
    sud
    avoidance
    worstThingThatCouldHappen
    expositions {
      ...SUDExposureStimulusExpositionData
    }
  }
  ${SudExposureStimulusExpositionDataFragmentDoc}
`;
export const ExposureDataFragmentDoc = gql`
  fragment ExposureData on Exposure {
    userId
    createdAt
    updatedAt
    type
    fear
    obsession
    safetyBehaviorsToAvoid
    hierarchy {
      _id
      ...ExposureStimulusData
    }
  }
  ${ExposureStimulusDataFragmentDoc}
`;
export const ExposureStimulusEsDataFragmentDoc = gql`
  fragment ExposureStimulusEsData on ExposureStimulus {
    _id
    ...ExposureStimulusData
  }
  ${ExposureStimulusDataFragmentDoc}
`;
export const FaDayFieldsFragmentDoc = gql`
  fragment FaDayFields on FaDay {
    date
    count
    urge
    urgeOnly
    from
  }
`;
export const FaCountedFieldsFragmentDoc = gql`
  fragment FaCountedFields on FaCounted {
    text
    count
  }
`;
export const FaIdeaFieldsFragmentDoc = gql`
  fragment FaIdeaFields on FaIdea {
    instead
    tool
    times
  }
`;
export const FaRecurringFieldsFragmentDoc = gql`
  fragment FaRecurringFields on FaRecurring {
    promptingEvents {
      ...FaCountedFields
    }
    vulnerabilities {
      ...FaCountedFields
    }
    links {
      event {
        ...FaCountedFields
      }
      thought {
        ...FaCountedFields
      }
      feeling {
        ...FaCountedFields
      }
      body {
        ...FaCountedFields
      }
      action {
        ...FaCountedFields
      }
    }
    rightAway {
      ...FaCountedFields
    }
    later {
      ...FaCountedFields
    }
    nextTime {
      ...FaIdeaFields
    }
  }
  ${FaCountedFieldsFragmentDoc}
  ${FaIdeaFieldsFragmentDoc}
`;
export const ClientSleepNightFieldsFragmentDoc = gql`
  fragment ClientSleepNightFields on ClientSleepNight {
    night
    inBedStart
    inBedEnd
    inBedMinutes
    asleepMinutes
    awakenings
    efficiency
    stages {
      deep
      core
      rem
      awake
    }
  }
`;
export const ClientActivityDayFieldsFragmentDoc = gql`
  fragment ClientActivityDayFields on ClientActivityDay {
    date
    stepCount
    activeMinutes
    workouts {
      type
      start
      minutes
    }
  }
`;
export const ClientHeartRateDayFieldsFragmentDoc = gql`
  fragment ClientHeartRateDayFields on ClientHeartRateDay {
    date
    restingHeartRate
    hrv {
      value
      metric
    }
  }
`;
export const CheckInSleepNightFieldsFragmentDoc = gql`
  fragment CheckInSleepNightFields on CheckInSleepNight {
    night
    wakeDay
    inBedStart
    inBedEnd
    asleepMinutes
    efficiency
  }
`;
export const CheckInActivityDayFieldsFragmentDoc = gql`
  fragment CheckInActivityDayFields on CheckInActivityDay {
    date
    activeMinutes
  }
`;
export const HomeworkTargetFieldsFragmentDoc = gql`
  fragment HomeworkTargetFields on HomeworkTarget {
    type
    ref
    version
    source
  }
`;
export const HomeworkScheduleFieldsFragmentDoc = gql`
  fragment HomeworkScheduleFields on EsReminderScheduleValue {
    rrule
    dtstart
    tzid
    exdates
  }
`;
export const HomeworkOccurrenceOutcomeFieldsFragmentDoc = gql`
  fragment HomeworkOccurrenceOutcomeFields on HomeworkOccurrenceOutcome {
    occurrenceAt
    outcome
    at
    evidence {
      focusType
      focus
    }
    repeats
  }
`;
export const ClientHomeworkFieldsFragmentDoc = gql`
  fragment ClientHomeworkFields on ClientHomework {
    assignmentId
    subject
    requester
    requesterName
    practiceId
    kind
    target {
      ...HomeworkTargetFields
    }
    title
    instructions
    activityTarget
    dueAt
    schedule {
      ...HomeworkScheduleFields
    }
    reminderPolicy
    source {
      enrollmentId
      stepId
    }
    status
    overdue
    nextDueAt
    occurrenceAt
    completedAt
    evidence {
      focusType
      focus
    }
    note
    reasonCode
    reason
    performer
    awaitingReply
    clientCommentUnanswered
    paperAllowed
    paperPhoto {
      fileRef
      takenAt
    }
    lastRemindedAt
    assignedAt
    outcomes {
      ...HomeworkOccurrenceOutcomeFields
    }
    lastNoticeChannels
    finishedAt
  }
  ${HomeworkTargetFieldsFragmentDoc}
  ${HomeworkScheduleFieldsFragmentDoc}
  ${HomeworkOccurrenceOutcomeFieldsFragmentDoc}
`;
export const MyHomeworkFieldsFragmentDoc = gql`
  fragment MyHomeworkFields on MyHomework {
    assignmentId
    subject
    requester
    requesterName
    title
    instructions
    kind
    target {
      ...HomeworkTargetFields
    }
    activityTarget
    dueAt
    schedule {
      ...HomeworkScheduleFields
    }
    occurrenceAt
    nextDueAt
    status
    overdue
    assignedAt
    outcomes {
      ...HomeworkOccurrenceOutcomeFields
    }
    completedAt
    reminderMessage
    paperAllowed
    plannedActivityId
  }
  ${HomeworkTargetFieldsFragmentDoc}
  ${HomeworkScheduleFieldsFragmentDoc}
  ${HomeworkOccurrenceOutcomeFieldsFragmentDoc}
`;
export const HomeworkCommentFieldsFragmentDoc = gql`
  fragment HomeworkCommentFields on HomeworkComment {
    commentId
    assignmentId
    performer
    performerName
    fromClient
    mine
    text
    occurredAt
  }
`;
export const InviteDataFragmentDoc = gql`
  fragment InviteData on Invite {
    type
    token
    from
    to
    firstName
    email
    message
    createdAt
    expiresAt
  }
`;
export const UricaReadingFieldsFragmentDoc = gql`
  fragment UricaReadingFields on UricaReading {
    type
    score
    readiness
    stage
    takenAt
  }
`;
export const ChangeJourneyFieldsFragmentDoc = gql`
  fragment ChangeJourneyFields on ChangeJourney {
    goalId
    subject
    label
    linkedValues
    status
    outcome
    closingNote
    closedAt
    setBy
    setAt
    rulersOverTime {
      occurredAt
      importance
      confidence
      readiness
      focusedRuler
    }
    myReasons
    changeTalk
    balance {
      prosOfStaying
      consOfStaying
      consOfChange
      prosOfChange
      writtenAt
    }
    plan {
      changes
      reasons
      planSteps {
        step
        when
      }
      helpers
      obstacles {
        obstacle
        response
      }
      signsOfSuccess
      writtenAt
    }
    journal {
      noteId
      noticedAt
      kind
      talk
    }
    lastActivityAt
    urica {
      ...UricaReadingFields
    }
  }
  ${UricaReadingFieldsFragmentDoc}
`;
export const PathwayReleaseRuleFieldsFragmentDoc = gql`
  fragment PathwayReleaseRuleFields on PathwayReleaseRule {
    rule
    day
    delayDays
  }
`;
export const PathwayStepProgressFieldsFragmentDoc = gql`
  fragment PathwayStepProgressFields on PathwayStepProgress {
    stepId
    kind
    target {
      type
      ref
      version
      source
    }
    title
    instructions
    release {
      ...PathwayReleaseRuleFields
    }
    dueDays
    state
    releasedAt
    assignmentId
    outcomeAt
    evidence {
      focusType
      focus
    }
    cancelled
    releaseAt
  }
  ${PathwayReleaseRuleFieldsFragmentDoc}
`;
export const PathwaySectionProgressFieldsFragmentDoc = gql`
  fragment PathwaySectionProgressFields on PathwaySectionProgress {
    section
    steps {
      ...PathwayStepProgressFields
    }
  }
  ${PathwayStepProgressFieldsFragmentDoc}
`;
export const PathwayProgressFieldsFragmentDoc = gql`
  fragment PathwayProgressFields on PathwayProgress {
    enrollmentId
    subject
    requester
    requesterName
    practiceId
    pathwayId
    pathwayVersion
    pathwayName
    startAt
    status
    endedAt
    reason
    sections {
      ...PathwaySectionProgressFields
    }
    percentDone
    stepsTotal
    stepsDone
    stepsSkipped
    selfEnrolled
  }
  ${PathwaySectionProgressFieldsFragmentDoc}
`;
export const MyPathwayFieldsFragmentDoc = gql`
  fragment MyPathwayFields on MyPathway {
    enrollmentId
    pathwayId
    pathwayVersion
    pathwayName
    startAt
    status
    sections {
      ...PathwaySectionProgressFields
    }
    percentDone
    stepsDone
    stepsTotal
    nextStepTitle
    nextReleaseAt
    prescribed
    requesterName
  }
  ${PathwaySectionProgressFieldsFragmentDoc}
`;
export const PathwayStepFieldsFragmentDoc = gql`
  fragment PathwayStepFields on PathwayStep {
    stepId
    kind
    target {
      type
      ref
      version
      source
    }
    title
    instructions
    release {
      ...PathwayReleaseRuleFields
    }
    dueDays
  }
  ${PathwayReleaseRuleFieldsFragmentDoc}
`;
export const PathwaySectionFieldsFragmentDoc = gql`
  fragment PathwaySectionFields on PathwaySection {
    section
    steps {
      ...PathwayStepFields
    }
  }
  ${PathwayStepFieldsFragmentDoc}
`;
export const PublicCourseFieldsFragmentDoc = gql`
  fragment PublicCourseFields on PublicCourse {
    pathwayId
    practiceId
    practiceName
    version
    name
    description
    sections {
      ...PathwaySectionFields
    }
    stepsCount
    accessRule
    storeProductId
    adaptyPlacementId
    owned
  }
  ${PathwaySectionFieldsFragmentDoc}
`;
export const ProfileDataFragmentDoc = gql`
  fragment ProfileData on Profile {
    createdAt
    updatedAt
    wantsReferrals
    approvedForReferrals
    formats
    mentalHealthRole
    title
    licenses {
      state
      number
    }
    acceptingClients
    yearsInPractice
    about
    education
    languages
    approaches
    costPerSessionFrom
    costPerSessionTo
    currency
    slidingScale
    modalities
    clientAges
    clientIssues
    linkToOtherProfile
    imageUrl
    phone
    extension
    freeInitialConsulation
    userId
    therapist {
      firstName
      lastName
    }
  }
`;
export const SafetyPlanEntryFieldsFragmentDoc = gql`
  fragment SafetyPlanEntryFields on SafetyPlanEntry {
    text
    name
    phone
    kind
  }
`;
export const SafetyPlanSectionFieldsFragmentDoc = gql`
  fragment SafetyPlanSectionFields on SafetyPlanSectionView {
    section
    entries {
      ...SafetyPlanEntryFields
    }
    performer
    performerName
    byClient
    occurredAt
  }
  ${SafetyPlanEntryFieldsFragmentDoc}
`;
export const ModeMapEntryFieldsFragmentDoc = gql`
  fragment ModeMapEntryFields on ModeMapEntry {
    modeId
    kind
    label
    colour
    own
    cardId
    cardText
    switchedOff
  }
`;
export const ModeSetChangeFieldsFragmentDoc = gql`
  fragment ModeSetChangeFields on ModeSetChange {
    performer
    byClient
    performerName
    occurredAt
  }
`;
export const ModeTimelineFieldsFragmentDoc = gql`
  fragment ModeTimelineFields on ModeTimeline {
    subject
    from
    to
    historyDays
    olderDays
    modeMap {
      ...ModeMapEntryFields
    }
    entries {
      checkInId
      recordedAt
      modes {
        modeId
        intensity
      }
      trigger
      bodyCue
      need
      note
    }
    modeDays {
      date
      modes {
        modeId
        peak
      }
    }
    topTriggers {
      trigger
      count
    }
    triggerMatrix {
      trigger
      modes {
        modeId
        count
      }
    }
    healthyAdultShare {
      week
      share
      presentCheckIns
      checkIns
      mean
    }
    cards {
      modeId
      cardId
    }
    checkIns
    checkInsThisWeek
    lastChange {
      ...ModeSetChangeFields
    }
  }
  ${ModeMapEntryFieldsFragmentDoc}
  ${ModeSetChangeFieldsFragmentDoc}
`;
export const SleepWindowViewFieldsFragmentDoc = gql`
  fragment SleepWindowViewFields on SleepWindowView {
    windowId
    subject
    performer
    performerName
    bedtime
    riseTime
    effectiveFrom
    protocol
    note
    lengthMinutes
    setAt
    endedAt
    basis {
      nights
      meanTimeInBed
      meanTotalSleep
      meanEfficiency
    }
  }
`;
export const SleepWeekAveragesFieldsFragmentDoc = gql`
  fragment SleepWeekAveragesFields on SleepWeekAverages {
    nightsFilled
    timeInBedMinutes
    totalSleepMinutes
    efficiency
    sleepOnsetMinutes
    wakeMinutes
    quality
  }
`;
export const SubscriptionDataFragmentDoc = gql`
  fragment SubscriptionData on Subscription {
    createdAt
    updatedAt
    lastSyncrhonizedAt
    startsAt
    expiresAt
    activatedAt
    renewedAt
    unsubscribedAt
    userId
    type
    name
    isActive
    isLifetime
    vendorProductId
    willRenew
    clientsCount
    price
    practiceId
  }
`;
export const SupportingCycleDataFragmentDoc = gql`
  fragment SupportingCycleData on SupportingCycle {
    createdAt
    updatedAt
    userId
    name
    thoughts {
      thought
      edges
    }
    isTemplate
    templateLanguage
    viciousCycleId
  }
`;
export const TestDataFragmentDoc = gql`
  fragment TestData on Test {
    _id
    _key
    _rev
    createdAt
    userId
    type
    answers
    score
    severity
    actions
  }
`;
export const TherapistClientEdgeDataFragmentDoc = gql`
  fragment TherapistClientEdgeData on TherapistClientEdge {
    practiceId
    allowView
    allowEdit
    allowAdminView
    allowAdminEdit
    createdAt
    updatedAt
    from {
      _id
      firstName
      lastName
    }
    to {
      _id
      firstName
      lastName
    }
  }
`;
export const ThoughtDataShortFragmentDoc = gql`
  fragment ThoughtDataShort on Thought {
    _id
    _key
    _rev
    userId
    activatingEventId
    updatedAt
    automaticThought
    realisticThoughts {
      thought
    }
    cardName
    categoriesIds
  }
`;
export const UsageEventDataFragmentDoc = gql`
  fragment UsageEventData on UsageEvent {
    _id
    _key
    _rev
    _from
    _to
    createdAt
    type
    extras
  }
`;
export const FeatureFragmentDoc = gql`
  fragment Feature on FeatureFlag {
    name
    count
  }
`;
export const FeaturesListFragmentDoc = gql`
  fragment FeaturesList on FeatureFlags {
    cardsSearch {
      ...Feature
    }
    articlesView {
      ...Feature
    }
    statsView {
      ...Feature
    }
    locationReminders {
      ...Feature
    }
    dayReminders {
      ...Feature
    }
    phq9 {
      ...Feature
    }
    gad7 {
      ...Feature
    }
    meditations {
      ...Feature
    }
    worryTrees {
      ...Feature
    }
    downwardArrows {
      ...Feature
    }
    crisisContact {
      ...Feature
    }
    behaviorExperiments {
      ...Feature
    }
    exposures {
      ...Feature
    }
    exposureSituations {
      ...Feature
    }
    exposureSituationReactions {
      ...Feature
    }
    aiImages {
      ...Feature
    }
    videoView {
      ...Feature
    }
  }
  ${FeatureFragmentDoc}
`;
export const PrivacySettingsFragmentFragmentDoc = gql`
  fragment PrivacySettingsFragment on PrivacySettings {
    isPrivacyAccepted
    isTermsAccepted
    isProductEmailNotifyOn
    isProductPushNotifyOn
    isErrorInfoCollectionOn
    isGAUsageCollectionOn
    isKeepLoggedInOn
  }
`;
export const UserDataFragmentDoc = gql`
  fragment UserData on User {
    firstName
    lastName
    displayName
    email
    role
    photoUrl
    lng
    timezone
    fcmToken
    accessLevel
    featureFlags {
      ...FeaturesList
    }
    privacySettings {
      ...PrivacySettingsFragment
    }
    adaptyProfileId
    hasAdaptyPremiumAccess
    subscriptionExpiredAt
    country
    state
    esMode
  }
  ${FeaturesListFragmentDoc}
  ${PrivacySettingsFragmentFragmentDoc}
`;
export const ValuesCommandFieldsFragmentDoc = gql`
  fragment ValuesCommandFields on ValuesCommandPayload {
    id
    recorded
    assignmentId
  }
`;
export const ValuesWheelFieldsFragmentDoc = gql`
  fragment ValuesWheelFields on ValuesWheel {
    wheelId
    preset
    sectors {
      sectorId
      name
      valueStatement
      current
      ideal
      gap
      obstacles {
        obstacleId
        obstacle
        severity
      }
      actions {
        actionId
        action
        dueAt
        assignmentId
        status
      }
    }
    ratedAt
    ratedBy
    ratedByName
    ratedInSession
    previousRatings {
      ratingId
      ratedAt
      ratedBy
      ratedByName
      sectors {
        sectorId
        current
        ideal
      }
    }
  }
`;
export const RoseScoresFieldsFragmentDoc = gql`
  fragment RoseScoresFields on RoseScores {
    loveAcceptance
    empathyUnderstanding
    predictabilityReliability
    safety
    competence
    autonomy
    selfExpression
    spontaneity
  }
`;
export const ValuesProfileFieldsFragmentDoc = gql`
  fragment ValuesProfileFields on ValuesProfile {
    subject
    lastSortAt
    wheelRatedAt
    vlqComposite
    values {
      value
      rank
      cardText
      wheelSector
      wheelSectorName
      wheelPreset
      current
      ideal
      gap
      vlqArea
      importance
      consistency
      vlqGap
      gapArea
      vlqGapArea
      rose {
        strategyId
        name
        cappedMean
        scores {
          ...RoseScoresFields
        }
      }
      actions {
        actionId
        action
        dueAt
        assignmentId
        status
      }
      activities {
        activityId
        activity
        difficulty
        status
      }
      links {
        linkId
        focusType
        focus
      }
    }
  }
  ${RoseScoresFieldsFragmentDoc}
`;
export const RoseExamplesFieldsFragmentDoc = gql`
  fragment RoseExamplesFields on RoseExamples {
    loveAcceptance
    empathyUnderstanding
    predictabilityReliability
    safety
    competence
    autonomy
    selfExpression
    spontaneity
  }
`;
export const RoseStrategyFieldsFragmentDoc = gql`
  fragment RoseStrategyFields on RoseStrategy {
    strategyId
    name
    kind
    behaviors
    inspiredBy {
      kind
      ref
    }
    describedAt
    describedInSession
    scores {
      ...RoseScoresFields
    }
    examples {
      ...RoseExamplesFields
    }
    basis
    ratedAt
    rawMean
    cappedMean
    history {
      ratingId
      ratedAt
      basis
      scores {
        ...RoseScoresFields
      }
      examples {
        ...RoseExamplesFields
      }
      rawMean
      cappedMean
      ratedInSession
    }
    chosen {
      choiceId
      chosenAt
      value
      beliefs
      sharedBy
      comparedWith
      chosenInSession
    }
    plan {
      planId
      writtenAt
      planWeek {
        what
        withWhom
        resources
      }
      planMonth {
        what
        withWhom
        resources
      }
      planYear {
        what
        withWhom
        resources
      }
    }
  }
  ${RoseScoresFieldsFragmentDoc}
  ${RoseExamplesFieldsFragmentDoc}
`;
export const WorksheetVideoFieldsFragmentDoc = gql`
  fragment WorksheetVideoFields on WorksheetVideo {
    source
    ref
    title
    duration
  }
`;
export const WorksheetSectionFieldsFragmentDoc = gql`
  fragment WorksheetSectionFields on WorksheetSection {
    sectionId
    title
    text
    video {
      ...WorksheetVideoFields
    }
    fields {
      fieldId
      type
      label
      required
      options
      min
      max
    }
  }
  ${WorksheetVideoFieldsFragmentDoc}
`;
export const WorksheetScoringFieldsFragmentDoc = gql`
  fragment WorksheetScoringFields on WorksheetScoring {
    kind
    fields
    bands {
      min
      max
      label
    }
  }
`;
export const WorksheetTemplateFieldsFragmentDoc = gql`
  fragment WorksheetTemplateFields on WorksheetTemplate {
    templateId
    practiceId
    version
    name
    category
    language
    signatureRequired
    repeatable
    owner
    assignedCount
    copiedFrom
    fieldCount
    occurredAt
    paperEligible
  }
`;
export const ClientWorksheetFieldsFragmentDoc = gql`
  fragment ClientWorksheetFields on ClientWorksheet {
    assignmentId
    subject
    templateId
    templateVersion
    name
    category
    status
    awaitingSignature
    pending
    sentAt
    viewedAt
    submittedAt
    signedAt
    submissionId
    submissionIds
    filledInSession
    score
    selfAssigned
    paperAllowed
    paperPhoto {
      fileRef
      takenAt
    }
  }
`;
export const WorryTreeDataFragmentDoc = gql`
  fragment WorryTreeData on WorryTree {
    userId
    createdAt
    selectedActivityIdx
    isNotSolvable
    worryAbout
    options
    plan
    immediateAction
  }
`;
export const AbcModelsDocument = gql`
  query AbcModels($sort: String, $where: JSON, $start: Int, $limit: Int) {
    abcModels(sort: $sort, where: $where, start: $start, limit: $limit) {
      data {
        _id
        ...AbcModelData
      }
      count
    }
  }
  ${AbcModelDataFragmentDoc}
`;

/**
 * __useAbcModelsQuery__
 *
 * To run a query within a React component, call `useAbcModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbcModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbcModelsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAbcModelsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AbcModelsQuery,
    AbcModelsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AbcModelsQuery, AbcModelsQueryVariables>(
    AbcModelsDocument,
    options,
  );
}
export function useAbcModelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AbcModelsQuery,
    AbcModelsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AbcModelsQuery, AbcModelsQueryVariables>(
    AbcModelsDocument,
    options,
  );
}
export type AbcModelsQueryHookResult = ReturnType<typeof useAbcModelsQuery>;
export type AbcModelsLazyQueryHookResult = ReturnType<
  typeof useAbcModelsLazyQuery
>;
export type AbcModelsQueryResult = Apollo.QueryResult<
  AbcModelsQuery,
  AbcModelsQueryVariables
>;
export const AbcModelDocument = gql`
  query AbcModel($_id: ID) {
    abcModel(_id: $_id) {
      _id
      ...AbcModelData
    }
  }
  ${AbcModelDataFragmentDoc}
`;

/**
 * __useAbcModelQuery__
 *
 * To run a query within a React component, call `useAbcModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useAbcModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAbcModelQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useAbcModelQuery(
  baseOptions?: Apollo.QueryHookOptions<AbcModelQuery, AbcModelQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AbcModelQuery, AbcModelQueryVariables>(
    AbcModelDocument,
    options,
  );
}
export function useAbcModelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AbcModelQuery,
    AbcModelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AbcModelQuery, AbcModelQueryVariables>(
    AbcModelDocument,
    options,
  );
}
export type AbcModelQueryHookResult = ReturnType<typeof useAbcModelQuery>;
export type AbcModelLazyQueryHookResult = ReturnType<
  typeof useAbcModelLazyQuery
>;
export type AbcModelQueryResult = Apollo.QueryResult<
  AbcModelQuery,
  AbcModelQueryVariables
>;
export const UpsertAbcModelDocument = gql`
  mutation UpsertAbcModel($input: AbcModelInput) {
    upsertAbcModel(input: $input) {
      _id
      ...AbcModelData
    }
  }
  ${AbcModelDataFragmentDoc}
`;
export type UpsertAbcModelMutationFn = Apollo.MutationFunction<
  UpsertAbcModelMutation,
  UpsertAbcModelMutationVariables
>;

/**
 * __useUpsertAbcModelMutation__
 *
 * To run a mutation, you first call `useUpsertAbcModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAbcModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAbcModelMutation, { data, loading, error }] = useUpsertAbcModelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAbcModelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertAbcModelMutation,
    UpsertAbcModelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertAbcModelMutation,
    UpsertAbcModelMutationVariables
  >(UpsertAbcModelDocument, options);
}
export type UpsertAbcModelMutationHookResult = ReturnType<
  typeof useUpsertAbcModelMutation
>;
export type UpsertAbcModelMutationResult =
  Apollo.MutationResult<UpsertAbcModelMutation>;
export type UpsertAbcModelMutationOptions = Apollo.BaseMutationOptions<
  UpsertAbcModelMutation,
  UpsertAbcModelMutationVariables
>;
export const AccountDeletionStatusDocument = gql`
  query AccountDeletionStatus {
    accountDeletionStatus {
      pending
      requestedAt
      dueBy
    }
  }
`;

/**
 * __useAccountDeletionStatusQuery__
 *
 * To run a query within a React component, call `useAccountDeletionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountDeletionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountDeletionStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountDeletionStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AccountDeletionStatusQuery,
    AccountDeletionStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AccountDeletionStatusQuery,
    AccountDeletionStatusQueryVariables
  >(AccountDeletionStatusDocument, options);
}
export function useAccountDeletionStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AccountDeletionStatusQuery,
    AccountDeletionStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AccountDeletionStatusQuery,
    AccountDeletionStatusQueryVariables
  >(AccountDeletionStatusDocument, options);
}
export type AccountDeletionStatusQueryHookResult = ReturnType<
  typeof useAccountDeletionStatusQuery
>;
export type AccountDeletionStatusLazyQueryHookResult = ReturnType<
  typeof useAccountDeletionStatusLazyQuery
>;
export type AccountDeletionStatusQueryResult = Apollo.QueryResult<
  AccountDeletionStatusQuery,
  AccountDeletionStatusQueryVariables
>;
export const RequestAccountDeletionDocument = gql`
  mutation RequestAccountDeletion($via: String!) {
    requestAccountDeletion(via: $via) {
      pending
      requestedAt
      dueBy
    }
  }
`;
export type RequestAccountDeletionMutationFn = Apollo.MutationFunction<
  RequestAccountDeletionMutation,
  RequestAccountDeletionMutationVariables
>;

/**
 * __useRequestAccountDeletionMutation__
 *
 * To run a mutation, you first call `useRequestAccountDeletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAccountDeletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAccountDeletionMutation, { data, loading, error }] = useRequestAccountDeletionMutation({
 *   variables: {
 *      via: // value for 'via'
 *   },
 * });
 */
export function useRequestAccountDeletionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestAccountDeletionMutation,
    RequestAccountDeletionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestAccountDeletionMutation,
    RequestAccountDeletionMutationVariables
  >(RequestAccountDeletionDocument, options);
}
export type RequestAccountDeletionMutationHookResult = ReturnType<
  typeof useRequestAccountDeletionMutation
>;
export type RequestAccountDeletionMutationResult =
  Apollo.MutationResult<RequestAccountDeletionMutation>;
export type RequestAccountDeletionMutationOptions = Apollo.BaseMutationOptions<
  RequestAccountDeletionMutation,
  RequestAccountDeletionMutationVariables
>;
export const ActivatingEventDocument = gql`
  query ActivatingEvent($_id: String!) {
    activatingEvent(_id: $_id) {
      ...ActivatingEventData
    }
  }
  ${ActivatingEventDataFragmentDoc}
`;

/**
 * __useActivatingEventQuery__
 *
 * To run a query within a React component, call `useActivatingEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivatingEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivatingEventQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useActivatingEventQuery(
  baseOptions: Apollo.QueryHookOptions<
    ActivatingEventQuery,
    ActivatingEventQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivatingEventQuery, ActivatingEventQueryVariables>(
    ActivatingEventDocument,
    options,
  );
}
export function useActivatingEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivatingEventQuery,
    ActivatingEventQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ActivatingEventQuery,
    ActivatingEventQueryVariables
  >(ActivatingEventDocument, options);
}
export type ActivatingEventQueryHookResult = ReturnType<
  typeof useActivatingEventQuery
>;
export type ActivatingEventLazyQueryHookResult = ReturnType<
  typeof useActivatingEventLazyQuery
>;
export type ActivatingEventQueryResult = Apollo.QueryResult<
  ActivatingEventQuery,
  ActivatingEventQueryVariables
>;
export const CreateActivatingEventDocument = gql`
  mutation CreateActivatingEvent(
    $activatingEvent: ActivatingEventCreateInput!
  ) {
    createActivatingEvent(activatingEvent: $activatingEvent) {
      activatingEvent {
        ...ActivatingEventData
      }
    }
  }
  ${ActivatingEventDataFragmentDoc}
`;
export type CreateActivatingEventMutationFn = Apollo.MutationFunction<
  CreateActivatingEventMutation,
  CreateActivatingEventMutationVariables
>;

/**
 * __useCreateActivatingEventMutation__
 *
 * To run a mutation, you first call `useCreateActivatingEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActivatingEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActivatingEventMutation, { data, loading, error }] = useCreateActivatingEventMutation({
 *   variables: {
 *      activatingEvent: // value for 'activatingEvent'
 *   },
 * });
 */
export function useCreateActivatingEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateActivatingEventMutation,
    CreateActivatingEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateActivatingEventMutation,
    CreateActivatingEventMutationVariables
  >(CreateActivatingEventDocument, options);
}
export type CreateActivatingEventMutationHookResult = ReturnType<
  typeof useCreateActivatingEventMutation
>;
export type CreateActivatingEventMutationResult =
  Apollo.MutationResult<CreateActivatingEventMutation>;
export type CreateActivatingEventMutationOptions = Apollo.BaseMutationOptions<
  CreateActivatingEventMutation,
  CreateActivatingEventMutationVariables
>;
export const UpdateActivatingEventDocument = gql`
  mutation UpdateActivatingEvent(
    $activatingEvent: ActivatingEventUpdateInput!
  ) {
    updateActivatingEvent(activatingEvent: $activatingEvent) {
      activatingEvent {
        ...ActivatingEventData
      }
    }
  }
  ${ActivatingEventDataFragmentDoc}
`;
export type UpdateActivatingEventMutationFn = Apollo.MutationFunction<
  UpdateActivatingEventMutation,
  UpdateActivatingEventMutationVariables
>;

/**
 * __useUpdateActivatingEventMutation__
 *
 * To run a mutation, you first call `useUpdateActivatingEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivatingEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivatingEventMutation, { data, loading, error }] = useUpdateActivatingEventMutation({
 *   variables: {
 *      activatingEvent: // value for 'activatingEvent'
 *   },
 * });
 */
export function useUpdateActivatingEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateActivatingEventMutation,
    UpdateActivatingEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateActivatingEventMutation,
    UpdateActivatingEventMutationVariables
  >(UpdateActivatingEventDocument, options);
}
export type UpdateActivatingEventMutationHookResult = ReturnType<
  typeof useUpdateActivatingEventMutation
>;
export type UpdateActivatingEventMutationResult =
  Apollo.MutationResult<UpdateActivatingEventMutation>;
export type UpdateActivatingEventMutationOptions = Apollo.BaseMutationOptions<
  UpdateActivatingEventMutation,
  UpdateActivatingEventMutationVariables
>;
export const PendingFeatureAnnouncementsDocument = gql`
  query PendingFeatureAnnouncements($surface: String!, $language: String) {
    pendingFeatureAnnouncements(surface: $surface, language: $language) {
      ...FeatureAnnouncementFields
    }
  }
  ${FeatureAnnouncementFieldsFragmentDoc}
`;

/**
 * __usePendingFeatureAnnouncementsQuery__
 *
 * To run a query within a React component, call `usePendingFeatureAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingFeatureAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingFeatureAnnouncementsQuery({
 *   variables: {
 *      surface: // value for 'surface'
 *      language: // value for 'language'
 *   },
 * });
 */
export function usePendingFeatureAnnouncementsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PendingFeatureAnnouncementsQuery,
    PendingFeatureAnnouncementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PendingFeatureAnnouncementsQuery,
    PendingFeatureAnnouncementsQueryVariables
  >(PendingFeatureAnnouncementsDocument, options);
}
export function usePendingFeatureAnnouncementsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PendingFeatureAnnouncementsQuery,
    PendingFeatureAnnouncementsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PendingFeatureAnnouncementsQuery,
    PendingFeatureAnnouncementsQueryVariables
  >(PendingFeatureAnnouncementsDocument, options);
}
export type PendingFeatureAnnouncementsQueryHookResult = ReturnType<
  typeof usePendingFeatureAnnouncementsQuery
>;
export type PendingFeatureAnnouncementsLazyQueryHookResult = ReturnType<
  typeof usePendingFeatureAnnouncementsLazyQuery
>;
export type PendingFeatureAnnouncementsQueryResult = Apollo.QueryResult<
  PendingFeatureAnnouncementsQuery,
  PendingFeatureAnnouncementsQueryVariables
>;
export const FeatureAnnouncementHistoryDocument = gql`
  query FeatureAnnouncementHistory($surface: String!, $language: String) {
    featureAnnouncementHistory(surface: $surface, language: $language) {
      ...FeatureAnnouncementFields
    }
  }
  ${FeatureAnnouncementFieldsFragmentDoc}
`;

/**
 * __useFeatureAnnouncementHistoryQuery__
 *
 * To run a query within a React component, call `useFeatureAnnouncementHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeatureAnnouncementHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeatureAnnouncementHistoryQuery({
 *   variables: {
 *      surface: // value for 'surface'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useFeatureAnnouncementHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    FeatureAnnouncementHistoryQuery,
    FeatureAnnouncementHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FeatureAnnouncementHistoryQuery,
    FeatureAnnouncementHistoryQueryVariables
  >(FeatureAnnouncementHistoryDocument, options);
}
export function useFeatureAnnouncementHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FeatureAnnouncementHistoryQuery,
    FeatureAnnouncementHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FeatureAnnouncementHistoryQuery,
    FeatureAnnouncementHistoryQueryVariables
  >(FeatureAnnouncementHistoryDocument, options);
}
export type FeatureAnnouncementHistoryQueryHookResult = ReturnType<
  typeof useFeatureAnnouncementHistoryQuery
>;
export type FeatureAnnouncementHistoryLazyQueryHookResult = ReturnType<
  typeof useFeatureAnnouncementHistoryLazyQuery
>;
export type FeatureAnnouncementHistoryQueryResult = Apollo.QueryResult<
  FeatureAnnouncementHistoryQuery,
  FeatureAnnouncementHistoryQueryVariables
>;
export const AcknowledgeFeatureAnnouncementDocument = gql`
  mutation AcknowledgeFeatureAnnouncement(
    $announcementId: ID!
    $seenAs: ID!
    $surface: String!
  ) {
    acknowledgeFeatureAnnouncement(
      announcementId: $announcementId
      seenAs: $seenAs
      surface: $surface
    )
  }
`;
export type AcknowledgeFeatureAnnouncementMutationFn = Apollo.MutationFunction<
  AcknowledgeFeatureAnnouncementMutation,
  AcknowledgeFeatureAnnouncementMutationVariables
>;

/**
 * __useAcknowledgeFeatureAnnouncementMutation__
 *
 * To run a mutation, you first call `useAcknowledgeFeatureAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeFeatureAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeFeatureAnnouncementMutation, { data, loading, error }] = useAcknowledgeFeatureAnnouncementMutation({
 *   variables: {
 *      announcementId: // value for 'announcementId'
 *      seenAs: // value for 'seenAs'
 *      surface: // value for 'surface'
 *   },
 * });
 */
export function useAcknowledgeFeatureAnnouncementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcknowledgeFeatureAnnouncementMutation,
    AcknowledgeFeatureAnnouncementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcknowledgeFeatureAnnouncementMutation,
    AcknowledgeFeatureAnnouncementMutationVariables
  >(AcknowledgeFeatureAnnouncementDocument, options);
}
export type AcknowledgeFeatureAnnouncementMutationHookResult = ReturnType<
  typeof useAcknowledgeFeatureAnnouncementMutation
>;
export type AcknowledgeFeatureAnnouncementMutationResult =
  Apollo.MutationResult<AcknowledgeFeatureAnnouncementMutation>;
export type AcknowledgeFeatureAnnouncementMutationOptions =
  Apollo.BaseMutationOptions<
    AcknowledgeFeatureAnnouncementMutation,
    AcknowledgeFeatureAnnouncementMutationVariables
  >;
export const AppLockDocument = gql`
  query AppLock($deviceId: ID!) {
    appLock(deviceId: $deviceId) {
      ...AppLockFields
    }
  }
  ${AppLockFieldsFragmentDoc}
`;

/**
 * __useAppLockQuery__
 *
 * To run a query within a React component, call `useAppLockQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppLockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppLockQuery({
 *   variables: {
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useAppLockQuery(
  baseOptions: Apollo.QueryHookOptions<AppLockQuery, AppLockQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AppLockQuery, AppLockQueryVariables>(
    AppLockDocument,
    options,
  );
}
export function useAppLockLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AppLockQuery,
    AppLockQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AppLockQuery, AppLockQueryVariables>(
    AppLockDocument,
    options,
  );
}
export type AppLockQueryHookResult = ReturnType<typeof useAppLockQuery>;
export type AppLockLazyQueryHookResult = ReturnType<typeof useAppLockLazyQuery>;
export type AppLockQueryResult = Apollo.QueryResult<
  AppLockQuery,
  AppLockQueryVariables
>;
export const EnableAppLockDocument = gql`
  mutation EnableAppLock($input: EnableAppLockInput!) {
    enableAppLock(input: $input) {
      deviceId
      recorded
    }
  }
`;
export type EnableAppLockMutationFn = Apollo.MutationFunction<
  EnableAppLockMutation,
  EnableAppLockMutationVariables
>;

/**
 * __useEnableAppLockMutation__
 *
 * To run a mutation, you first call `useEnableAppLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableAppLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableAppLockMutation, { data, loading, error }] = useEnableAppLockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableAppLockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnableAppLockMutation,
    EnableAppLockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EnableAppLockMutation,
    EnableAppLockMutationVariables
  >(EnableAppLockDocument, options);
}
export type EnableAppLockMutationHookResult = ReturnType<
  typeof useEnableAppLockMutation
>;
export type EnableAppLockMutationResult =
  Apollo.MutationResult<EnableAppLockMutation>;
export type EnableAppLockMutationOptions = Apollo.BaseMutationOptions<
  EnableAppLockMutation,
  EnableAppLockMutationVariables
>;
export const DisableAppLockDocument = gql`
  mutation DisableAppLock($input: DisableAppLockInput!) {
    disableAppLock(input: $input) {
      deviceId
      recorded
    }
  }
`;
export type DisableAppLockMutationFn = Apollo.MutationFunction<
  DisableAppLockMutation,
  DisableAppLockMutationVariables
>;

/**
 * __useDisableAppLockMutation__
 *
 * To run a mutation, you first call `useDisableAppLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableAppLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableAppLockMutation, { data, loading, error }] = useDisableAppLockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableAppLockMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableAppLockMutation,
    DisableAppLockMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisableAppLockMutation,
    DisableAppLockMutationVariables
  >(DisableAppLockDocument, options);
}
export type DisableAppLockMutationHookResult = ReturnType<
  typeof useDisableAppLockMutation
>;
export type DisableAppLockMutationResult =
  Apollo.MutationResult<DisableAppLockMutation>;
export type DisableAppLockMutationOptions = Apollo.BaseMutationOptions<
  DisableAppLockMutation,
  DisableAppLockMutationVariables
>;
export const InstrumentCatalogDocument = gql`
  query InstrumentCatalog {
    instrumentCatalog {
      instrumentId
      type
      availability
      assignmentId
      dueAt
      requester
      assignedBy
      lastScore
      lastBand
      lastBandKey
      lastTakenAt
      definition {
        ...InstrumentDefinitionFields
      }
    }
  }
  ${InstrumentDefinitionFieldsFragmentDoc}
`;

/**
 * __useInstrumentCatalogQuery__
 *
 * To run a query within a React component, call `useInstrumentCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstrumentCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstrumentCatalogQuery({
 *   variables: {
 *   },
 * });
 */
export function useInstrumentCatalogQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InstrumentCatalogQuery,
    InstrumentCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InstrumentCatalogQuery,
    InstrumentCatalogQueryVariables
  >(InstrumentCatalogDocument, options);
}
export function useInstrumentCatalogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InstrumentCatalogQuery,
    InstrumentCatalogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InstrumentCatalogQuery,
    InstrumentCatalogQueryVariables
  >(InstrumentCatalogDocument, options);
}
export type InstrumentCatalogQueryHookResult = ReturnType<
  typeof useInstrumentCatalogQuery
>;
export type InstrumentCatalogLazyQueryHookResult = ReturnType<
  typeof useInstrumentCatalogLazyQuery
>;
export type InstrumentCatalogQueryResult = Apollo.QueryResult<
  InstrumentCatalogQuery,
  InstrumentCatalogQueryVariables
>;
export const AssessmentInterpretationDocument = gql`
  query AssessmentInterpretation($assessmentId: ID!) {
    assessmentInterpretation(assessmentId: $assessmentId) {
      assessmentId
      subject
      instrumentId
      type
      occurredAt
      total
      totalBand
      totalBandKey
      band
      bandKey
      bandIsWorstSubscale
      subscales {
        ...AssessmentReadingFields
      }
      changeSinceLast {
        total
        subscales {
          name
          change
        }
      }
      previousSubscales {
        ...AssessmentReadingFields
      }
      previousTotal
    }
  }
  ${AssessmentReadingFieldsFragmentDoc}
`;

/**
 * __useAssessmentInterpretationQuery__
 *
 * To run a query within a React component, call `useAssessmentInterpretationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentInterpretationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentInterpretationQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssessmentInterpretationQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssessmentInterpretationQuery,
    AssessmentInterpretationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AssessmentInterpretationQuery,
    AssessmentInterpretationQueryVariables
  >(AssessmentInterpretationDocument, options);
}
export function useAssessmentInterpretationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssessmentInterpretationQuery,
    AssessmentInterpretationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AssessmentInterpretationQuery,
    AssessmentInterpretationQueryVariables
  >(AssessmentInterpretationDocument, options);
}
export type AssessmentInterpretationQueryHookResult = ReturnType<
  typeof useAssessmentInterpretationQuery
>;
export type AssessmentInterpretationLazyQueryHookResult = ReturnType<
  typeof useAssessmentInterpretationLazyQuery
>;
export type AssessmentInterpretationQueryResult = Apollo.QueryResult<
  AssessmentInterpretationQuery,
  AssessmentInterpretationQueryVariables
>;
export const ClientAssessmentTrendDocument = gql`
  query ClientAssessmentTrend($subject: ID!, $instrumentId: String) {
    clientAssessmentTrend(subject: $subject, instrumentId: $instrumentId) {
      subject
      instrumentId
      definition {
        ...InstrumentDefinitionFields
      }
      rows {
        source
        subject
        practiceId
        instrumentId
        instrumentName
        assessmentId
        externalAssessmentId
        occurredAt
        total
        maxScore
        subscales {
          ...AssessmentReadingFields
        }
        band
        bandKey
        bandIsWorstSubscale
        changeSinceLast {
          total
          subscales {
            name
            change
          }
        }
        item9 {
          questionKey
          answer
          answerKey
        }
        note
      }
    }
  }
  ${InstrumentDefinitionFieldsFragmentDoc}
  ${AssessmentReadingFieldsFragmentDoc}
`;

/**
 * __useClientAssessmentTrendQuery__
 *
 * To run a query within a React component, call `useClientAssessmentTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientAssessmentTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientAssessmentTrendQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      instrumentId: // value for 'instrumentId'
 *   },
 * });
 */
export function useClientAssessmentTrendQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientAssessmentTrendQuery,
    ClientAssessmentTrendQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientAssessmentTrendQuery,
    ClientAssessmentTrendQueryVariables
  >(ClientAssessmentTrendDocument, options);
}
export function useClientAssessmentTrendLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientAssessmentTrendQuery,
    ClientAssessmentTrendQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientAssessmentTrendQuery,
    ClientAssessmentTrendQueryVariables
  >(ClientAssessmentTrendDocument, options);
}
export type ClientAssessmentTrendQueryHookResult = ReturnType<
  typeof useClientAssessmentTrendQuery
>;
export type ClientAssessmentTrendLazyQueryHookResult = ReturnType<
  typeof useClientAssessmentTrendLazyQuery
>;
export type ClientAssessmentTrendQueryResult = Apollo.QueryResult<
  ClientAssessmentTrendQuery,
  ClientAssessmentTrendQueryVariables
>;
export const InstrumentDefinitionsDocument = gql`
  query InstrumentDefinitions {
    instrumentDefinitions {
      ...InstrumentDefinitionFields
    }
  }
  ${InstrumentDefinitionFieldsFragmentDoc}
`;

/**
 * __useInstrumentDefinitionsQuery__
 *
 * To run a query within a React component, call `useInstrumentDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstrumentDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstrumentDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInstrumentDefinitionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InstrumentDefinitionsQuery,
    InstrumentDefinitionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    InstrumentDefinitionsQuery,
    InstrumentDefinitionsQueryVariables
  >(InstrumentDefinitionsDocument, options);
}
export function useInstrumentDefinitionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InstrumentDefinitionsQuery,
    InstrumentDefinitionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InstrumentDefinitionsQuery,
    InstrumentDefinitionsQueryVariables
  >(InstrumentDefinitionsDocument, options);
}
export type InstrumentDefinitionsQueryHookResult = ReturnType<
  typeof useInstrumentDefinitionsQuery
>;
export type InstrumentDefinitionsLazyQueryHookResult = ReturnType<
  typeof useInstrumentDefinitionsLazyQuery
>;
export type InstrumentDefinitionsQueryResult = Apollo.QueryResult<
  InstrumentDefinitionsQuery,
  InstrumentDefinitionsQueryVariables
>;
export const PublishInstrumentDocument = gql`
  mutation PublishInstrument($input: PublishInstrumentInput!) {
    publishInstrument(input: $input) {
      id
      recorded
    }
  }
`;
export type PublishInstrumentMutationFn = Apollo.MutationFunction<
  PublishInstrumentMutation,
  PublishInstrumentMutationVariables
>;

/**
 * __usePublishInstrumentMutation__
 *
 * To run a mutation, you first call `usePublishInstrumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishInstrumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishInstrumentMutation, { data, loading, error }] = usePublishInstrumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishInstrumentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishInstrumentMutation,
    PublishInstrumentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishInstrumentMutation,
    PublishInstrumentMutationVariables
  >(PublishInstrumentDocument, options);
}
export type PublishInstrumentMutationHookResult = ReturnType<
  typeof usePublishInstrumentMutation
>;
export type PublishInstrumentMutationResult =
  Apollo.MutationResult<PublishInstrumentMutation>;
export type PublishInstrumentMutationOptions = Apollo.BaseMutationOptions<
  PublishInstrumentMutation,
  PublishInstrumentMutationVariables
>;
export const RecordExternalAssessmentDocument = gql`
  mutation RecordExternalAssessment($input: RecordExternalAssessmentInput!) {
    recordExternalAssessment(input: $input) {
      id
      recorded
    }
  }
`;
export type RecordExternalAssessmentMutationFn = Apollo.MutationFunction<
  RecordExternalAssessmentMutation,
  RecordExternalAssessmentMutationVariables
>;

/**
 * __useRecordExternalAssessmentMutation__
 *
 * To run a mutation, you first call `useRecordExternalAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordExternalAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordExternalAssessmentMutation, { data, loading, error }] = useRecordExternalAssessmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordExternalAssessmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordExternalAssessmentMutation,
    RecordExternalAssessmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordExternalAssessmentMutation,
    RecordExternalAssessmentMutationVariables
  >(RecordExternalAssessmentDocument, options);
}
export type RecordExternalAssessmentMutationHookResult = ReturnType<
  typeof useRecordExternalAssessmentMutation
>;
export type RecordExternalAssessmentMutationResult =
  Apollo.MutationResult<RecordExternalAssessmentMutation>;
export type RecordExternalAssessmentMutationOptions =
  Apollo.BaseMutationOptions<
    RecordExternalAssessmentMutation,
    RecordExternalAssessmentMutationVariables
  >;
export const CreateAssessmentInSessionDocument = gql`
  mutation CreateAssessmentInSession($input: CreateAssessmentInSessionInput!) {
    createAssessmentInSession(input: $input) {
      id
      recorded
    }
  }
`;
export type CreateAssessmentInSessionMutationFn = Apollo.MutationFunction<
  CreateAssessmentInSessionMutation,
  CreateAssessmentInSessionMutationVariables
>;

/**
 * __useCreateAssessmentInSessionMutation__
 *
 * To run a mutation, you first call `useCreateAssessmentInSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssessmentInSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssessmentInSessionMutation, { data, loading, error }] = useCreateAssessmentInSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssessmentInSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAssessmentInSessionMutation,
    CreateAssessmentInSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAssessmentInSessionMutation,
    CreateAssessmentInSessionMutationVariables
  >(CreateAssessmentInSessionDocument, options);
}
export type CreateAssessmentInSessionMutationHookResult = ReturnType<
  typeof useCreateAssessmentInSessionMutation
>;
export type CreateAssessmentInSessionMutationResult =
  Apollo.MutationResult<CreateAssessmentInSessionMutation>;
export type CreateAssessmentInSessionMutationOptions =
  Apollo.BaseMutationOptions<
    CreateAssessmentInSessionMutation,
    CreateAssessmentInSessionMutationVariables
  >;
export const CreateAuthTokenDocument = gql`
  mutation CreateAuthToken($firebaseToken: String!) {
    createAuthToken(firebaseToken: $firebaseToken) {
      accessToken
      refreshToken
      accessExpiresAt
      refreshExpiresAt
    }
  }
`;
export type CreateAuthTokenMutationFn = Apollo.MutationFunction<
  CreateAuthTokenMutation,
  CreateAuthTokenMutationVariables
>;

/**
 * __useCreateAuthTokenMutation__
 *
 * To run a mutation, you first call `useCreateAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthTokenMutation, { data, loading, error }] = useCreateAuthTokenMutation({
 *   variables: {
 *      firebaseToken: // value for 'firebaseToken'
 *   },
 * });
 */
export function useCreateAuthTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAuthTokenMutation,
    CreateAuthTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAuthTokenMutation,
    CreateAuthTokenMutationVariables
  >(CreateAuthTokenDocument, options);
}
export type CreateAuthTokenMutationHookResult = ReturnType<
  typeof useCreateAuthTokenMutation
>;
export type CreateAuthTokenMutationResult =
  Apollo.MutationResult<CreateAuthTokenMutation>;
export type CreateAuthTokenMutationOptions = Apollo.BaseMutationOptions<
  CreateAuthTokenMutation,
  CreateAuthTokenMutationVariables
>;
export const RefreshAuthTokenDocument = gql`
  mutation RefreshAuthToken($refreshToken: String!) {
    refreshAuthToken(refreshToken: $refreshToken) {
      accessToken
      refreshToken
      accessExpiresAt
      refreshExpiresAt
    }
  }
`;
export type RefreshAuthTokenMutationFn = Apollo.MutationFunction<
  RefreshAuthTokenMutation,
  RefreshAuthTokenMutationVariables
>;

/**
 * __useRefreshAuthTokenMutation__
 *
 * To run a mutation, you first call `useRefreshAuthTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAuthTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAuthTokenMutation, { data, loading, error }] = useRefreshAuthTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshAuthTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RefreshAuthTokenMutation,
    RefreshAuthTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RefreshAuthTokenMutation,
    RefreshAuthTokenMutationVariables
  >(RefreshAuthTokenDocument, options);
}
export type RefreshAuthTokenMutationHookResult = ReturnType<
  typeof useRefreshAuthTokenMutation
>;
export type RefreshAuthTokenMutationResult =
  Apollo.MutationResult<RefreshAuthTokenMutation>;
export type RefreshAuthTokenMutationOptions = Apollo.BaseMutationOptions<
  RefreshAuthTokenMutation,
  RefreshAuthTokenMutationVariables
>;
export const RevokeAuthTokensDocument = gql`
  mutation RevokeAuthTokens {
    revokeAuthTokens
  }
`;
export type RevokeAuthTokensMutationFn = Apollo.MutationFunction<
  RevokeAuthTokensMutation,
  RevokeAuthTokensMutationVariables
>;

/**
 * __useRevokeAuthTokensMutation__
 *
 * To run a mutation, you first call `useRevokeAuthTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeAuthTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeAuthTokensMutation, { data, loading, error }] = useRevokeAuthTokensMutation({
 *   variables: {
 *   },
 * });
 */
export function useRevokeAuthTokensMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeAuthTokensMutation,
    RevokeAuthTokensMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevokeAuthTokensMutation,
    RevokeAuthTokensMutationVariables
  >(RevokeAuthTokensDocument, options);
}
export type RevokeAuthTokensMutationHookResult = ReturnType<
  typeof useRevokeAuthTokensMutation
>;
export type RevokeAuthTokensMutationResult =
  Apollo.MutationResult<RevokeAuthTokensMutation>;
export type RevokeAuthTokensMutationOptions = Apollo.BaseMutationOptions<
  RevokeAuthTokensMutation,
  RevokeAuthTokensMutationVariables
>;
export const AppMinVersionDocument = gql`
  query AppMinVersion {
    appMinVersion {
      minSupportedVersion
      minSupportedVersionIos
      minSupportedVersionAndroid
    }
  }
`;

/**
 * __useAppMinVersionQuery__
 *
 * To run a query within a React component, call `useAppMinVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppMinVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppMinVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppMinVersionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AppMinVersionQuery,
    AppMinVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AppMinVersionQuery, AppMinVersionQueryVariables>(
    AppMinVersionDocument,
    options,
  );
}
export function useAppMinVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AppMinVersionQuery,
    AppMinVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AppMinVersionQuery, AppMinVersionQueryVariables>(
    AppMinVersionDocument,
    options,
  );
}
export type AppMinVersionQueryHookResult = ReturnType<
  typeof useAppMinVersionQuery
>;
export type AppMinVersionLazyQueryHookResult = ReturnType<
  typeof useAppMinVersionLazyQuery
>;
export type AppMinVersionQueryResult = Apollo.QueryResult<
  AppMinVersionQuery,
  AppMinVersionQueryVariables
>;
export const DeferSignOutDocument = gql`
  mutation DeferSignOut(
    $authSessionId: ID!
    $platform: String!
    $deferredUntil: DateTime!
  ) {
    deferSignOut(
      authSessionId: $authSessionId
      platform: $platform
      deferredUntil: $deferredUntil
    )
  }
`;
export type DeferSignOutMutationFn = Apollo.MutationFunction<
  DeferSignOutMutation,
  DeferSignOutMutationVariables
>;

/**
 * __useDeferSignOutMutation__
 *
 * To run a mutation, you first call `useDeferSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeferSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deferSignOutMutation, { data, loading, error }] = useDeferSignOutMutation({
 *   variables: {
 *      authSessionId: // value for 'authSessionId'
 *      platform: // value for 'platform'
 *      deferredUntil: // value for 'deferredUntil'
 *   },
 * });
 */
export function useDeferSignOutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeferSignOutMutation,
    DeferSignOutMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeferSignOutMutation,
    DeferSignOutMutationVariables
  >(DeferSignOutDocument, options);
}
export type DeferSignOutMutationHookResult = ReturnType<
  typeof useDeferSignOutMutation
>;
export type DeferSignOutMutationResult =
  Apollo.MutationResult<DeferSignOutMutation>;
export type DeferSignOutMutationOptions = Apollo.BaseMutationOptions<
  DeferSignOutMutation,
  DeferSignOutMutationVariables
>;
export const BehaviorExperimentsDocument = gql`
  query BehaviorExperiments(
    $sort: String
    $where: JSON
    $start: Int
    $limit: Int
  ) {
    behaviorExperiments(
      sort: $sort
      where: $where
      start: $start
      limit: $limit
    ) {
      data {
        _id
        ...BehaviorExperimentData
      }
      count
    }
  }
  ${BehaviorExperimentDataFragmentDoc}
`;

/**
 * __useBehaviorExperimentsQuery__
 *
 * To run a query within a React component, call `useBehaviorExperimentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBehaviorExperimentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBehaviorExperimentsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBehaviorExperimentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BehaviorExperimentsQuery,
    BehaviorExperimentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BehaviorExperimentsQuery,
    BehaviorExperimentsQueryVariables
  >(BehaviorExperimentsDocument, options);
}
export function useBehaviorExperimentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BehaviorExperimentsQuery,
    BehaviorExperimentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BehaviorExperimentsQuery,
    BehaviorExperimentsQueryVariables
  >(BehaviorExperimentsDocument, options);
}
export type BehaviorExperimentsQueryHookResult = ReturnType<
  typeof useBehaviorExperimentsQuery
>;
export type BehaviorExperimentsLazyQueryHookResult = ReturnType<
  typeof useBehaviorExperimentsLazyQuery
>;
export type BehaviorExperimentsQueryResult = Apollo.QueryResult<
  BehaviorExperimentsQuery,
  BehaviorExperimentsQueryVariables
>;
export const BehaviorExperimentDocument = gql`
  query BehaviorExperiment($_id: ID) {
    behaviorExperiment(_id: $_id) {
      _id
      ...BehaviorExperimentData
    }
  }
  ${BehaviorExperimentDataFragmentDoc}
`;

/**
 * __useBehaviorExperimentQuery__
 *
 * To run a query within a React component, call `useBehaviorExperimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useBehaviorExperimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBehaviorExperimentQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useBehaviorExperimentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BehaviorExperimentQuery,
    BehaviorExperimentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BehaviorExperimentQuery,
    BehaviorExperimentQueryVariables
  >(BehaviorExperimentDocument, options);
}
export function useBehaviorExperimentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BehaviorExperimentQuery,
    BehaviorExperimentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BehaviorExperimentQuery,
    BehaviorExperimentQueryVariables
  >(BehaviorExperimentDocument, options);
}
export type BehaviorExperimentQueryHookResult = ReturnType<
  typeof useBehaviorExperimentQuery
>;
export type BehaviorExperimentLazyQueryHookResult = ReturnType<
  typeof useBehaviorExperimentLazyQuery
>;
export type BehaviorExperimentQueryResult = Apollo.QueryResult<
  BehaviorExperimentQuery,
  BehaviorExperimentQueryVariables
>;
export const UpsertBehaviorExperimentDocument = gql`
  mutation UpsertBehaviorExperiment($input: BehaviorExperimentInput) {
    upsertBehaviorExperiment(input: $input) {
      _id
      ...BehaviorExperimentData
    }
  }
  ${BehaviorExperimentDataFragmentDoc}
`;
export type UpsertBehaviorExperimentMutationFn = Apollo.MutationFunction<
  UpsertBehaviorExperimentMutation,
  UpsertBehaviorExperimentMutationVariables
>;

/**
 * __useUpsertBehaviorExperimentMutation__
 *
 * To run a mutation, you first call `useUpsertBehaviorExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBehaviorExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBehaviorExperimentMutation, { data, loading, error }] = useUpsertBehaviorExperimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertBehaviorExperimentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertBehaviorExperimentMutation,
    UpsertBehaviorExperimentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertBehaviorExperimentMutation,
    UpsertBehaviorExperimentMutationVariables
  >(UpsertBehaviorExperimentDocument, options);
}
export type UpsertBehaviorExperimentMutationHookResult = ReturnType<
  typeof useUpsertBehaviorExperimentMutation
>;
export type UpsertBehaviorExperimentMutationResult =
  Apollo.MutationResult<UpsertBehaviorExperimentMutation>;
export type UpsertBehaviorExperimentMutationOptions =
  Apollo.BaseMutationOptions<
    UpsertBehaviorExperimentMutation,
    UpsertBehaviorExperimentMutationVariables
  >;
export const StartBehaviorExperimentDocument = gql`
  mutation StartBehaviorExperiment($input: StartBehaviorExperimentInput!) {
    startBehaviorExperiment(input: $input) {
      experimentId
      behaviorExperiment {
        ...BehaviorExperimentEsData
      }
    }
  }
  ${BehaviorExperimentEsDataFragmentDoc}
`;
export type StartBehaviorExperimentMutationFn = Apollo.MutationFunction<
  StartBehaviorExperimentMutation,
  StartBehaviorExperimentMutationVariables
>;

/**
 * __useStartBehaviorExperimentMutation__
 *
 * To run a mutation, you first call `useStartBehaviorExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartBehaviorExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startBehaviorExperimentMutation, { data, loading, error }] = useStartBehaviorExperimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartBehaviorExperimentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartBehaviorExperimentMutation,
    StartBehaviorExperimentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartBehaviorExperimentMutation,
    StartBehaviorExperimentMutationVariables
  >(StartBehaviorExperimentDocument, options);
}
export type StartBehaviorExperimentMutationHookResult = ReturnType<
  typeof useStartBehaviorExperimentMutation
>;
export type StartBehaviorExperimentMutationResult =
  Apollo.MutationResult<StartBehaviorExperimentMutation>;
export type StartBehaviorExperimentMutationOptions = Apollo.BaseMutationOptions<
  StartBehaviorExperimentMutation,
  StartBehaviorExperimentMutationVariables
>;
export const StateHypothesesDocument = gql`
  mutation StateHypotheses($input: StateHypothesesInput!) {
    stateHypotheses(input: $input) {
      experimentId
      behaviorExperiment {
        ...BehaviorExperimentEsData
      }
    }
  }
  ${BehaviorExperimentEsDataFragmentDoc}
`;
export type StateHypothesesMutationFn = Apollo.MutationFunction<
  StateHypothesesMutation,
  StateHypothesesMutationVariables
>;

/**
 * __useStateHypothesesMutation__
 *
 * To run a mutation, you first call `useStateHypothesesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStateHypothesesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stateHypothesesMutation, { data, loading, error }] = useStateHypothesesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStateHypothesesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StateHypothesesMutation,
    StateHypothesesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StateHypothesesMutation,
    StateHypothesesMutationVariables
  >(StateHypothesesDocument, options);
}
export type StateHypothesesMutationHookResult = ReturnType<
  typeof useStateHypothesesMutation
>;
export type StateHypothesesMutationResult =
  Apollo.MutationResult<StateHypothesesMutation>;
export type StateHypothesesMutationOptions = Apollo.BaseMutationOptions<
  StateHypothesesMutation,
  StateHypothesesMutationVariables
>;
export const PlanExperimentDocument = gql`
  mutation PlanExperiment($input: PlanExperimentInput!) {
    planExperiment(input: $input) {
      experimentId
      behaviorExperiment {
        ...BehaviorExperimentEsData
      }
    }
  }
  ${BehaviorExperimentEsDataFragmentDoc}
`;
export type PlanExperimentMutationFn = Apollo.MutationFunction<
  PlanExperimentMutation,
  PlanExperimentMutationVariables
>;

/**
 * __usePlanExperimentMutation__
 *
 * To run a mutation, you first call `usePlanExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planExperimentMutation, { data, loading, error }] = usePlanExperimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlanExperimentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PlanExperimentMutation,
    PlanExperimentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PlanExperimentMutation,
    PlanExperimentMutationVariables
  >(PlanExperimentDocument, options);
}
export type PlanExperimentMutationHookResult = ReturnType<
  typeof usePlanExperimentMutation
>;
export type PlanExperimentMutationResult =
  Apollo.MutationResult<PlanExperimentMutation>;
export type PlanExperimentMutationOptions = Apollo.BaseMutationOptions<
  PlanExperimentMutation,
  PlanExperimentMutationVariables
>;
export const PredictOutcomeDocument = gql`
  mutation PredictOutcome($input: PredictOutcomeInput!) {
    predictOutcome(input: $input) {
      experimentId
      behaviorExperiment {
        ...BehaviorExperimentEsData
      }
    }
  }
  ${BehaviorExperimentEsDataFragmentDoc}
`;
export type PredictOutcomeMutationFn = Apollo.MutationFunction<
  PredictOutcomeMutation,
  PredictOutcomeMutationVariables
>;

/**
 * __usePredictOutcomeMutation__
 *
 * To run a mutation, you first call `usePredictOutcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePredictOutcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [predictOutcomeMutation, { data, loading, error }] = usePredictOutcomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePredictOutcomeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PredictOutcomeMutation,
    PredictOutcomeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PredictOutcomeMutation,
    PredictOutcomeMutationVariables
  >(PredictOutcomeDocument, options);
}
export type PredictOutcomeMutationHookResult = ReturnType<
  typeof usePredictOutcomeMutation
>;
export type PredictOutcomeMutationResult =
  Apollo.MutationResult<PredictOutcomeMutation>;
export type PredictOutcomeMutationOptions = Apollo.BaseMutationOptions<
  PredictOutcomeMutation,
  PredictOutcomeMutationVariables
>;
export const ActivateExperimentDocument = gql`
  mutation ActivateExperiment($input: ActivateExperimentInput!) {
    activateExperiment(input: $input) {
      experimentId
      behaviorExperiment {
        ...BehaviorExperimentEsData
      }
    }
  }
  ${BehaviorExperimentEsDataFragmentDoc}
`;
export type ActivateExperimentMutationFn = Apollo.MutationFunction<
  ActivateExperimentMutation,
  ActivateExperimentMutationVariables
>;

/**
 * __useActivateExperimentMutation__
 *
 * To run a mutation, you first call `useActivateExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateExperimentMutation, { data, loading, error }] = useActivateExperimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateExperimentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ActivateExperimentMutation,
    ActivateExperimentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ActivateExperimentMutation,
    ActivateExperimentMutationVariables
  >(ActivateExperimentDocument, options);
}
export type ActivateExperimentMutationHookResult = ReturnType<
  typeof useActivateExperimentMutation
>;
export type ActivateExperimentMutationResult =
  Apollo.MutationResult<ActivateExperimentMutation>;
export type ActivateExperimentMutationOptions = Apollo.BaseMutationOptions<
  ActivateExperimentMutation,
  ActivateExperimentMutationVariables
>;
export const RecordObservationDocument = gql`
  mutation RecordObservation($input: RecordObservationInput!) {
    recordObservation(input: $input) {
      experimentId
      observationId
      behaviorExperiment {
        ...BehaviorExperimentEsData
      }
    }
  }
  ${BehaviorExperimentEsDataFragmentDoc}
`;
export type RecordObservationMutationFn = Apollo.MutationFunction<
  RecordObservationMutation,
  RecordObservationMutationVariables
>;

/**
 * __useRecordObservationMutation__
 *
 * To run a mutation, you first call `useRecordObservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordObservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordObservationMutation, { data, loading, error }] = useRecordObservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordObservationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordObservationMutation,
    RecordObservationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordObservationMutation,
    RecordObservationMutationVariables
  >(RecordObservationDocument, options);
}
export type RecordObservationMutationHookResult = ReturnType<
  typeof useRecordObservationMutation
>;
export type RecordObservationMutationResult =
  Apollo.MutationResult<RecordObservationMutation>;
export type RecordObservationMutationOptions = Apollo.BaseMutationOptions<
  RecordObservationMutation,
  RecordObservationMutationVariables
>;
export const UpdateObservationDocument = gql`
  mutation UpdateObservation($input: UpdateObservationInput!) {
    updateObservation(input: $input) {
      experimentId
      observationId
      behaviorExperiment {
        ...BehaviorExperimentEsData
      }
    }
  }
  ${BehaviorExperimentEsDataFragmentDoc}
`;
export type UpdateObservationMutationFn = Apollo.MutationFunction<
  UpdateObservationMutation,
  UpdateObservationMutationVariables
>;

/**
 * __useUpdateObservationMutation__
 *
 * To run a mutation, you first call `useUpdateObservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateObservationMutation, { data, loading, error }] = useUpdateObservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateObservationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateObservationMutation,
    UpdateObservationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateObservationMutation,
    UpdateObservationMutationVariables
  >(UpdateObservationDocument, options);
}
export type UpdateObservationMutationHookResult = ReturnType<
  typeof useUpdateObservationMutation
>;
export type UpdateObservationMutationResult =
  Apollo.MutationResult<UpdateObservationMutation>;
export type UpdateObservationMutationOptions = Apollo.BaseMutationOptions<
  UpdateObservationMutation,
  UpdateObservationMutationVariables
>;
export const CompleteExperimentDocument = gql`
  mutation CompleteExperiment($input: CompleteExperimentInput!) {
    completeExperiment(input: $input) {
      experimentId
      behaviorExperiment {
        ...BehaviorExperimentEsData
      }
    }
  }
  ${BehaviorExperimentEsDataFragmentDoc}
`;
export type CompleteExperimentMutationFn = Apollo.MutationFunction<
  CompleteExperimentMutation,
  CompleteExperimentMutationVariables
>;

/**
 * __useCompleteExperimentMutation__
 *
 * To run a mutation, you first call `useCompleteExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeExperimentMutation, { data, loading, error }] = useCompleteExperimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteExperimentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteExperimentMutation,
    CompleteExperimentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteExperimentMutation,
    CompleteExperimentMutationVariables
  >(CompleteExperimentDocument, options);
}
export type CompleteExperimentMutationHookResult = ReturnType<
  typeof useCompleteExperimentMutation
>;
export type CompleteExperimentMutationResult =
  Apollo.MutationResult<CompleteExperimentMutation>;
export type CompleteExperimentMutationOptions = Apollo.BaseMutationOptions<
  CompleteExperimentMutation,
  CompleteExperimentMutationVariables
>;
export const DesignBehaviorExperimentDocument = gql`
  mutation DesignBehaviorExperiment($input: DesignBehaviorExperimentInput!) {
    designBehaviorExperiment(input: $input) {
      experimentId
      behaviorExperiment {
        ...BehaviorExperimentEsData
      }
    }
  }
  ${BehaviorExperimentEsDataFragmentDoc}
`;
export type DesignBehaviorExperimentMutationFn = Apollo.MutationFunction<
  DesignBehaviorExperimentMutation,
  DesignBehaviorExperimentMutationVariables
>;

/**
 * __useDesignBehaviorExperimentMutation__
 *
 * To run a mutation, you first call `useDesignBehaviorExperimentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesignBehaviorExperimentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [designBehaviorExperimentMutation, { data, loading, error }] = useDesignBehaviorExperimentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDesignBehaviorExperimentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DesignBehaviorExperimentMutation,
    DesignBehaviorExperimentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DesignBehaviorExperimentMutation,
    DesignBehaviorExperimentMutationVariables
  >(DesignBehaviorExperimentDocument, options);
}
export type DesignBehaviorExperimentMutationHookResult = ReturnType<
  typeof useDesignBehaviorExperimentMutation
>;
export type DesignBehaviorExperimentMutationResult =
  Apollo.MutationResult<DesignBehaviorExperimentMutation>;
export type DesignBehaviorExperimentMutationOptions =
  Apollo.BaseMutationOptions<
    DesignBehaviorExperimentMutation,
    DesignBehaviorExperimentMutationVariables
  >;
export const RequestBehaviorExperimentSuggestionsDocument = gql`
  mutation RequestBehaviorExperimentSuggestions(
    $input: RequestBehaviorExperimentSuggestionsInput!
  ) {
    requestBehaviorExperimentSuggestions(input: $input) {
      requestId
      suggestions {
        purpose
        design
        hypothesisType
        type
        activeSubtype
        observationalSubtype
        hypothesisA
        hypothesisAStrength
        hypothesisAConfirmationCriteria
        hypothesisB
        hypothesisBStrength
        hypothesisBConfirmationCriteria
        settings {
          experiment
          time
          place
          people
          resources
          survey
        }
        safetyBehaviors
        helpfulCopingStrategies
        prediction {
          emotions {
            id
            strength
          }
          feelings
          behaviors
          otherPredictions
        }
        followUpExperimentsIdeas
      }
    }
  }
`;
export type RequestBehaviorExperimentSuggestionsMutationFn =
  Apollo.MutationFunction<
    RequestBehaviorExperimentSuggestionsMutation,
    RequestBehaviorExperimentSuggestionsMutationVariables
  >;

/**
 * __useRequestBehaviorExperimentSuggestionsMutation__
 *
 * To run a mutation, you first call `useRequestBehaviorExperimentSuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBehaviorExperimentSuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBehaviorExperimentSuggestionsMutation, { data, loading, error }] = useRequestBehaviorExperimentSuggestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestBehaviorExperimentSuggestionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestBehaviorExperimentSuggestionsMutation,
    RequestBehaviorExperimentSuggestionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestBehaviorExperimentSuggestionsMutation,
    RequestBehaviorExperimentSuggestionsMutationVariables
  >(RequestBehaviorExperimentSuggestionsDocument, options);
}
export type RequestBehaviorExperimentSuggestionsMutationHookResult = ReturnType<
  typeof useRequestBehaviorExperimentSuggestionsMutation
>;
export type RequestBehaviorExperimentSuggestionsMutationResult =
  Apollo.MutationResult<RequestBehaviorExperimentSuggestionsMutation>;
export type RequestBehaviorExperimentSuggestionsMutationOptions =
  Apollo.BaseMutationOptions<
    RequestBehaviorExperimentSuggestionsMutation,
    RequestBehaviorExperimentSuggestionsMutationVariables
  >;
export const BehaviorExperimentEsDocument = gql`
  query BehaviorExperimentEs($_id: ID) {
    behaviorExperiment(_id: $_id) {
      ...BehaviorExperimentEsData
    }
  }
  ${BehaviorExperimentEsDataFragmentDoc}
`;

/**
 * __useBehaviorExperimentEsQuery__
 *
 * To run a query within a React component, call `useBehaviorExperimentEsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBehaviorExperimentEsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBehaviorExperimentEsQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useBehaviorExperimentEsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BehaviorExperimentEsQuery,
    BehaviorExperimentEsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BehaviorExperimentEsQuery,
    BehaviorExperimentEsQueryVariables
  >(BehaviorExperimentEsDocument, options);
}
export function useBehaviorExperimentEsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BehaviorExperimentEsQuery,
    BehaviorExperimentEsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BehaviorExperimentEsQuery,
    BehaviorExperimentEsQueryVariables
  >(BehaviorExperimentEsDocument, options);
}
export type BehaviorExperimentEsQueryHookResult = ReturnType<
  typeof useBehaviorExperimentEsQuery
>;
export type BehaviorExperimentEsLazyQueryHookResult = ReturnType<
  typeof useBehaviorExperimentEsLazyQuery
>;
export type BehaviorExperimentEsQueryResult = Apollo.QueryResult<
  BehaviorExperimentEsQuery,
  BehaviorExperimentEsQueryVariables
>;
export const BehaviorExperimentsEsDocument = gql`
  query BehaviorExperimentsEs(
    $sort: String
    $where: JSON
    $start: Int
    $limit: Int
  ) {
    behaviorExperiments(
      sort: $sort
      where: $where
      start: $start
      limit: $limit
    ) {
      data {
        ...BehaviorExperimentEsData
      }
      count
    }
  }
  ${BehaviorExperimentEsDataFragmentDoc}
`;

/**
 * __useBehaviorExperimentsEsQuery__
 *
 * To run a query within a React component, call `useBehaviorExperimentsEsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBehaviorExperimentsEsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBehaviorExperimentsEsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBehaviorExperimentsEsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BehaviorExperimentsEsQuery,
    BehaviorExperimentsEsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BehaviorExperimentsEsQuery,
    BehaviorExperimentsEsQueryVariables
  >(BehaviorExperimentsEsDocument, options);
}
export function useBehaviorExperimentsEsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BehaviorExperimentsEsQuery,
    BehaviorExperimentsEsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BehaviorExperimentsEsQuery,
    BehaviorExperimentsEsQueryVariables
  >(BehaviorExperimentsEsDocument, options);
}
export type BehaviorExperimentsEsQueryHookResult = ReturnType<
  typeof useBehaviorExperimentsEsQuery
>;
export type BehaviorExperimentsEsLazyQueryHookResult = ReturnType<
  typeof useBehaviorExperimentsEsLazyQuery
>;
export type BehaviorExperimentsEsQueryResult = Apollo.QueryResult<
  BehaviorExperimentsEsQuery,
  BehaviorExperimentsEsQueryVariables
>;
export const ActivityIdeasDocument = gql`
  query ActivityIdeas($language: String) {
    activityIdeas(language: $language) {
      subject
      libraryId
      ideas {
        ideaId
        text
        area
        difficulty
        forYourValue
        origin
      }
    }
  }
`;

/**
 * __useActivityIdeasQuery__
 *
 * To run a query within a React component, call `useActivityIdeasQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityIdeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityIdeasQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useActivityIdeasQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActivityIdeasQuery,
    ActivityIdeasQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivityIdeasQuery, ActivityIdeasQueryVariables>(
    ActivityIdeasDocument,
    options,
  );
}
export function useActivityIdeasLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityIdeasQuery,
    ActivityIdeasQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActivityIdeasQuery, ActivityIdeasQueryVariables>(
    ActivityIdeasDocument,
    options,
  );
}
export type ActivityIdeasQueryHookResult = ReturnType<
  typeof useActivityIdeasQuery
>;
export type ActivityIdeasLazyQueryHookResult = ReturnType<
  typeof useActivityIdeasLazyQuery
>;
export type ActivityIdeasQueryResult = Apollo.QueryResult<
  ActivityIdeasQuery,
  ActivityIdeasQueryVariables
>;
export const WeekActivitiesDocument = gql`
  query WeekActivities {
    weekActivities {
      subject
      activities {
        activityLogId
        title
        enjoyment
        importance
        startAt
        valueActivityId
      }
    }
  }
`;

/**
 * __useWeekActivitiesQuery__
 *
 * To run a query within a React component, call `useWeekActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeekActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeekActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useWeekActivitiesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WeekActivitiesQuery,
    WeekActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WeekActivitiesQuery, WeekActivitiesQueryVariables>(
    WeekActivitiesDocument,
    options,
  );
}
export function useWeekActivitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WeekActivitiesQuery,
    WeekActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WeekActivitiesQuery, WeekActivitiesQueryVariables>(
    WeekActivitiesDocument,
    options,
  );
}
export type WeekActivitiesQueryHookResult = ReturnType<
  typeof useWeekActivitiesQuery
>;
export type WeekActivitiesLazyQueryHookResult = ReturnType<
  typeof useWeekActivitiesLazyQuery
>;
export type WeekActivitiesQueryResult = Apollo.QueryResult<
  WeekActivitiesQuery,
  WeekActivitiesQueryVariables
>;
export const ActivityChoicesDocument = gql`
  query ActivityChoices {
    activityChoices {
      subject
      groups {
        value
        activities {
          activityId
          activity
          difficulty
          source
          origin
          status
        }
        suggested {
          activity
          difficulty
        }
        suggestionRequestId
      }
    }
  }
`;

/**
 * __useActivityChoicesQuery__
 *
 * To run a query within a React component, call `useActivityChoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityChoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityChoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityChoicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActivityChoicesQuery,
    ActivityChoicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivityChoicesQuery, ActivityChoicesQueryVariables>(
    ActivityChoicesDocument,
    options,
  );
}
export function useActivityChoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityChoicesQuery,
    ActivityChoicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ActivityChoicesQuery,
    ActivityChoicesQueryVariables
  >(ActivityChoicesDocument, options);
}
export type ActivityChoicesQueryHookResult = ReturnType<
  typeof useActivityChoicesQuery
>;
export type ActivityChoicesLazyQueryHookResult = ReturnType<
  typeof useActivityChoicesLazyQuery
>;
export type ActivityChoicesQueryResult = Apollo.QueryResult<
  ActivityChoicesQuery,
  ActivityChoicesQueryVariables
>;
export const ActivityLadderDocument = gql`
  query ActivityLadder($subject: ID) {
    activityLadder(subject: $subject) {
      ...ActivityLadderFields
    }
  }
  ${ActivityLadderFieldsFragmentDoc}
`;

/**
 * __useActivityLadderQuery__
 *
 * To run a query within a React component, call `useActivityLadderQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLadderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLadderQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useActivityLadderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActivityLadderQuery,
    ActivityLadderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivityLadderQuery, ActivityLadderQueryVariables>(
    ActivityLadderDocument,
    options,
  );
}
export function useActivityLadderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityLadderQuery,
    ActivityLadderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActivityLadderQuery, ActivityLadderQueryVariables>(
    ActivityLadderDocument,
    options,
  );
}
export type ActivityLadderQueryHookResult = ReturnType<
  typeof useActivityLadderQuery
>;
export type ActivityLadderLazyQueryHookResult = ReturnType<
  typeof useActivityLadderLazyQuery
>;
export type ActivityLadderQueryResult = Apollo.QueryResult<
  ActivityLadderQuery,
  ActivityLadderQueryVariables
>;
export const ActivityDayDocument = gql`
  query ActivityDay($day: String, $timeZone: String) {
    activityDay(day: $day, timeZone: $timeZone) {
      subject
      day
      hours {
        kind
        activityLogId
        plannedActivityId
        startAt
        endAt
        start
        title
        enjoyment
        importance
        valueActivityId
        source
      }
      mood
      gaps
    }
  }
`;

/**
 * __useActivityDayQuery__
 *
 * To run a query within a React component, call `useActivityDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityDayQuery({
 *   variables: {
 *      day: // value for 'day'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useActivityDayQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActivityDayQuery,
    ActivityDayQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivityDayQuery, ActivityDayQueryVariables>(
    ActivityDayDocument,
    options,
  );
}
export function useActivityDayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityDayQuery,
    ActivityDayQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActivityDayQuery, ActivityDayQueryVariables>(
    ActivityDayDocument,
    options,
  );
}
export type ActivityDayQueryHookResult = ReturnType<typeof useActivityDayQuery>;
export type ActivityDayLazyQueryHookResult = ReturnType<
  typeof useActivityDayLazyQuery
>;
export type ActivityDayQueryResult = Apollo.QueryResult<
  ActivityDayQuery,
  ActivityDayQueryVariables
>;
export const HealthActivitySuggestionsDocument = gql`
  query HealthActivitySuggestions($day: String, $timeZone: String) {
    healthActivitySuggestions(day: $day, timeZone: $timeZone) {
      subject
      day
      suggestions {
        start
        startAt
        minutes
        kind
      }
    }
  }
`;

/**
 * __useHealthActivitySuggestionsQuery__
 *
 * To run a query within a React component, call `useHealthActivitySuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthActivitySuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthActivitySuggestionsQuery({
 *   variables: {
 *      day: // value for 'day'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useHealthActivitySuggestionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HealthActivitySuggestionsQuery,
    HealthActivitySuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HealthActivitySuggestionsQuery,
    HealthActivitySuggestionsQueryVariables
  >(HealthActivitySuggestionsDocument, options);
}
export function useHealthActivitySuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HealthActivitySuggestionsQuery,
    HealthActivitySuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HealthActivitySuggestionsQuery,
    HealthActivitySuggestionsQueryVariables
  >(HealthActivitySuggestionsDocument, options);
}
export type HealthActivitySuggestionsQueryHookResult = ReturnType<
  typeof useHealthActivitySuggestionsQuery
>;
export type HealthActivitySuggestionsLazyQueryHookResult = ReturnType<
  typeof useHealthActivitySuggestionsLazyQuery
>;
export type HealthActivitySuggestionsQueryResult = Apollo.QueryResult<
  HealthActivitySuggestionsQuery,
  HealthActivitySuggestionsQueryVariables
>;
export const ActivityPlanDocument = gql`
  query ActivityPlan($subject: ID, $week: String, $timeZone: String) {
    activityPlan(subject: $subject, week: $week, timeZone: $timeZone) {
      subject
      week
      weekPlan {
        day
        items {
          ...PlanItemFields
        }
      }
      plannedThisWeek
      doneThisWeek
    }
  }
  ${PlanItemFieldsFragmentDoc}
`;

/**
 * __useActivityPlanQuery__
 *
 * To run a query within a React component, call `useActivityPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityPlanQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      week: // value for 'week'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useActivityPlanQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActivityPlanQuery,
    ActivityPlanQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivityPlanQuery, ActivityPlanQueryVariables>(
    ActivityPlanDocument,
    options,
  );
}
export function useActivityPlanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityPlanQuery,
    ActivityPlanQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActivityPlanQuery, ActivityPlanQueryVariables>(
    ActivityPlanDocument,
    options,
  );
}
export type ActivityPlanQueryHookResult = ReturnType<
  typeof useActivityPlanQuery
>;
export type ActivityPlanLazyQueryHookResult = ReturnType<
  typeof useActivityPlanLazyQuery
>;
export type ActivityPlanQueryResult = Apollo.QueryResult<
  ActivityPlanQuery,
  ActivityPlanQueryVariables
>;
export const ActivityWeekDocument = gql`
  query ActivityWeek($subject: ID, $week: String, $timeZone: String) {
    activityWeek(subject: $subject, week: $week, timeZone: $timeZone) {
      ...ActivityWeekFields
    }
  }
  ${ActivityWeekFieldsFragmentDoc}
`;

/**
 * __useActivityWeekQuery__
 *
 * To run a query within a React component, call `useActivityWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityWeekQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      week: // value for 'week'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useActivityWeekQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ActivityWeekQuery,
    ActivityWeekQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ActivityWeekQuery, ActivityWeekQueryVariables>(
    ActivityWeekDocument,
    options,
  );
}
export function useActivityWeekLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ActivityWeekQuery,
    ActivityWeekQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ActivityWeekQuery, ActivityWeekQueryVariables>(
    ActivityWeekDocument,
    options,
  );
}
export type ActivityWeekQueryHookResult = ReturnType<
  typeof useActivityWeekQuery
>;
export type ActivityWeekLazyQueryHookResult = ReturnType<
  typeof useActivityWeekLazyQuery
>;
export type ActivityWeekQueryResult = Apollo.QueryResult<
  ActivityWeekQuery,
  ActivityWeekQueryVariables
>;
export const PublishActivityLibraryDocument = gql`
  mutation PublishActivityLibrary($input: PublishActivityLibraryInput!) {
    publishActivityLibrary(input: $input) {
      ...BaCommandFields
    }
  }
  ${BaCommandFieldsFragmentDoc}
`;
export type PublishActivityLibraryMutationFn = Apollo.MutationFunction<
  PublishActivityLibraryMutation,
  PublishActivityLibraryMutationVariables
>;

/**
 * __usePublishActivityLibraryMutation__
 *
 * To run a mutation, you first call `usePublishActivityLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishActivityLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishActivityLibraryMutation, { data, loading, error }] = usePublishActivityLibraryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishActivityLibraryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishActivityLibraryMutation,
    PublishActivityLibraryMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishActivityLibraryMutation,
    PublishActivityLibraryMutationVariables
  >(PublishActivityLibraryDocument, options);
}
export type PublishActivityLibraryMutationHookResult = ReturnType<
  typeof usePublishActivityLibraryMutation
>;
export type PublishActivityLibraryMutationResult =
  Apollo.MutationResult<PublishActivityLibraryMutation>;
export type PublishActivityLibraryMutationOptions = Apollo.BaseMutationOptions<
  PublishActivityLibraryMutation,
  PublishActivityLibraryMutationVariables
>;
export const LogActivityDocument = gql`
  mutation LogActivity($input: LogActivityInput!) {
    logActivity(input: $input) {
      ...BaCommandFields
    }
  }
  ${BaCommandFieldsFragmentDoc}
`;
export type LogActivityMutationFn = Apollo.MutationFunction<
  LogActivityMutation,
  LogActivityMutationVariables
>;

/**
 * __useLogActivityMutation__
 *
 * To run a mutation, you first call `useLogActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logActivityMutation, { data, loading, error }] = useLogActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLogActivityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LogActivityMutation,
    LogActivityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LogActivityMutation, LogActivityMutationVariables>(
    LogActivityDocument,
    options,
  );
}
export type LogActivityMutationHookResult = ReturnType<
  typeof useLogActivityMutation
>;
export type LogActivityMutationResult =
  Apollo.MutationResult<LogActivityMutation>;
export type LogActivityMutationOptions = Apollo.BaseMutationOptions<
  LogActivityMutation,
  LogActivityMutationVariables
>;
export const RemoveActivityLogDocument = gql`
  mutation RemoveActivityLog($input: RemoveActivityLogInput!) {
    removeActivityLog(input: $input) {
      ...BaCommandFields
    }
  }
  ${BaCommandFieldsFragmentDoc}
`;
export type RemoveActivityLogMutationFn = Apollo.MutationFunction<
  RemoveActivityLogMutation,
  RemoveActivityLogMutationVariables
>;

/**
 * __useRemoveActivityLogMutation__
 *
 * To run a mutation, you first call `useRemoveActivityLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveActivityLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeActivityLogMutation, { data, loading, error }] = useRemoveActivityLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveActivityLogMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveActivityLogMutation,
    RemoveActivityLogMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveActivityLogMutation,
    RemoveActivityLogMutationVariables
  >(RemoveActivityLogDocument, options);
}
export type RemoveActivityLogMutationHookResult = ReturnType<
  typeof useRemoveActivityLogMutation
>;
export type RemoveActivityLogMutationResult =
  Apollo.MutationResult<RemoveActivityLogMutation>;
export type RemoveActivityLogMutationOptions = Apollo.BaseMutationOptions<
  RemoveActivityLogMutation,
  RemoveActivityLogMutationVariables
>;
export const RankActivitiesDocument = gql`
  mutation RankActivities($input: RankActivitiesInput!) {
    rankActivities(input: $input) {
      ...BaCommandFields
    }
  }
  ${BaCommandFieldsFragmentDoc}
`;
export type RankActivitiesMutationFn = Apollo.MutationFunction<
  RankActivitiesMutation,
  RankActivitiesMutationVariables
>;

/**
 * __useRankActivitiesMutation__
 *
 * To run a mutation, you first call `useRankActivitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRankActivitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rankActivitiesMutation, { data, loading, error }] = useRankActivitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRankActivitiesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RankActivitiesMutation,
    RankActivitiesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RankActivitiesMutation,
    RankActivitiesMutationVariables
  >(RankActivitiesDocument, options);
}
export type RankActivitiesMutationHookResult = ReturnType<
  typeof useRankActivitiesMutation
>;
export type RankActivitiesMutationResult =
  Apollo.MutationResult<RankActivitiesMutation>;
export type RankActivitiesMutationOptions = Apollo.BaseMutationOptions<
  RankActivitiesMutation,
  RankActivitiesMutationVariables
>;
export const PlanActivityDocument = gql`
  mutation PlanActivity($input: PlanActivityInput!) {
    planActivity(input: $input) {
      ...BaCommandFields
    }
  }
  ${BaCommandFieldsFragmentDoc}
`;
export type PlanActivityMutationFn = Apollo.MutationFunction<
  PlanActivityMutation,
  PlanActivityMutationVariables
>;

/**
 * __usePlanActivityMutation__
 *
 * To run a mutation, you first call `usePlanActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planActivityMutation, { data, loading, error }] = usePlanActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlanActivityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PlanActivityMutation,
    PlanActivityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PlanActivityMutation,
    PlanActivityMutationVariables
  >(PlanActivityDocument, options);
}
export type PlanActivityMutationHookResult = ReturnType<
  typeof usePlanActivityMutation
>;
export type PlanActivityMutationResult =
  Apollo.MutationResult<PlanActivityMutation>;
export type PlanActivityMutationOptions = Apollo.BaseMutationOptions<
  PlanActivityMutation,
  PlanActivityMutationVariables
>;
export const PlanActivityInSessionDocument = gql`
  mutation PlanActivityInSession($input: PlanActivityInSessionInput!) {
    planActivityInSession(input: $input) {
      ...BaCommandFields
    }
  }
  ${BaCommandFieldsFragmentDoc}
`;
export type PlanActivityInSessionMutationFn = Apollo.MutationFunction<
  PlanActivityInSessionMutation,
  PlanActivityInSessionMutationVariables
>;

/**
 * __usePlanActivityInSessionMutation__
 *
 * To run a mutation, you first call `usePlanActivityInSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanActivityInSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planActivityInSessionMutation, { data, loading, error }] = usePlanActivityInSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlanActivityInSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PlanActivityInSessionMutation,
    PlanActivityInSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PlanActivityInSessionMutation,
    PlanActivityInSessionMutationVariables
  >(PlanActivityInSessionDocument, options);
}
export type PlanActivityInSessionMutationHookResult = ReturnType<
  typeof usePlanActivityInSessionMutation
>;
export type PlanActivityInSessionMutationResult =
  Apollo.MutationResult<PlanActivityInSessionMutation>;
export type PlanActivityInSessionMutationOptions = Apollo.BaseMutationOptions<
  PlanActivityInSessionMutation,
  PlanActivityInSessionMutationVariables
>;
export const CompletePlannedActivityDocument = gql`
  mutation CompletePlannedActivity($input: CompletePlannedActivityInput!) {
    completePlannedActivity(input: $input) {
      ...BaCommandFields
    }
  }
  ${BaCommandFieldsFragmentDoc}
`;
export type CompletePlannedActivityMutationFn = Apollo.MutationFunction<
  CompletePlannedActivityMutation,
  CompletePlannedActivityMutationVariables
>;

/**
 * __useCompletePlannedActivityMutation__
 *
 * To run a mutation, you first call `useCompletePlannedActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePlannedActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePlannedActivityMutation, { data, loading, error }] = useCompletePlannedActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompletePlannedActivityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompletePlannedActivityMutation,
    CompletePlannedActivityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompletePlannedActivityMutation,
    CompletePlannedActivityMutationVariables
  >(CompletePlannedActivityDocument, options);
}
export type CompletePlannedActivityMutationHookResult = ReturnType<
  typeof useCompletePlannedActivityMutation
>;
export type CompletePlannedActivityMutationResult =
  Apollo.MutationResult<CompletePlannedActivityMutation>;
export type CompletePlannedActivityMutationOptions = Apollo.BaseMutationOptions<
  CompletePlannedActivityMutation,
  CompletePlannedActivityMutationVariables
>;
export const MissPlannedActivityDocument = gql`
  mutation MissPlannedActivity($input: MissPlannedActivityInput!) {
    missPlannedActivity(input: $input) {
      ...BaCommandFields
    }
  }
  ${BaCommandFieldsFragmentDoc}
`;
export type MissPlannedActivityMutationFn = Apollo.MutationFunction<
  MissPlannedActivityMutation,
  MissPlannedActivityMutationVariables
>;

/**
 * __useMissPlannedActivityMutation__
 *
 * To run a mutation, you first call `useMissPlannedActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMissPlannedActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [missPlannedActivityMutation, { data, loading, error }] = useMissPlannedActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMissPlannedActivityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MissPlannedActivityMutation,
    MissPlannedActivityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MissPlannedActivityMutation,
    MissPlannedActivityMutationVariables
  >(MissPlannedActivityDocument, options);
}
export type MissPlannedActivityMutationHookResult = ReturnType<
  typeof useMissPlannedActivityMutation
>;
export type MissPlannedActivityMutationResult =
  Apollo.MutationResult<MissPlannedActivityMutation>;
export type MissPlannedActivityMutationOptions = Apollo.BaseMutationOptions<
  MissPlannedActivityMutation,
  MissPlannedActivityMutationVariables
>;
export const MakeSupportContractDocument = gql`
  mutation MakeSupportContract($input: MakeSupportContractInput!) {
    makeSupportContract(input: $input) {
      ...BaCommandFields
    }
  }
  ${BaCommandFieldsFragmentDoc}
`;
export type MakeSupportContractMutationFn = Apollo.MutationFunction<
  MakeSupportContractMutation,
  MakeSupportContractMutationVariables
>;

/**
 * __useMakeSupportContractMutation__
 *
 * To run a mutation, you first call `useMakeSupportContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeSupportContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeSupportContractMutation, { data, loading, error }] = useMakeSupportContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeSupportContractMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MakeSupportContractMutation,
    MakeSupportContractMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MakeSupportContractMutation,
    MakeSupportContractMutationVariables
  >(MakeSupportContractDocument, options);
}
export type MakeSupportContractMutationHookResult = ReturnType<
  typeof useMakeSupportContractMutation
>;
export type MakeSupportContractMutationResult =
  Apollo.MutationResult<MakeSupportContractMutation>;
export type MakeSupportContractMutationOptions = Apollo.BaseMutationOptions<
  MakeSupportContractMutation,
  MakeSupportContractMutationVariables
>;
export const RecordCheckInDocument = gql`
  mutation RecordCheckIn($input: RecordCheckInInput!) {
    recordCheckIn(input: $input) {
      checkInId
      recorded
    }
  }
`;
export type RecordCheckInMutationFn = Apollo.MutationFunction<
  RecordCheckInMutation,
  RecordCheckInMutationVariables
>;

/**
 * __useRecordCheckInMutation__
 *
 * To run a mutation, you first call `useRecordCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCheckInMutation, { data, loading, error }] = useRecordCheckInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordCheckInMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordCheckInMutation,
    RecordCheckInMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordCheckInMutation,
    RecordCheckInMutationVariables
  >(RecordCheckInDocument, options);
}
export type RecordCheckInMutationHookResult = ReturnType<
  typeof useRecordCheckInMutation
>;
export type RecordCheckInMutationResult =
  Apollo.MutationResult<RecordCheckInMutation>;
export type RecordCheckInMutationOptions = Apollo.BaseMutationOptions<
  RecordCheckInMutation,
  RecordCheckInMutationVariables
>;
export const RecordCheckInInSessionDocument = gql`
  mutation RecordCheckInInSession($input: RecordCheckInInSessionInput!) {
    recordCheckInInSession(input: $input) {
      checkInId
      recorded
    }
  }
`;
export type RecordCheckInInSessionMutationFn = Apollo.MutationFunction<
  RecordCheckInInSessionMutation,
  RecordCheckInInSessionMutationVariables
>;

/**
 * __useRecordCheckInInSessionMutation__
 *
 * To run a mutation, you first call `useRecordCheckInInSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCheckInInSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCheckInInSessionMutation, { data, loading, error }] = useRecordCheckInInSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordCheckInInSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordCheckInInSessionMutation,
    RecordCheckInInSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordCheckInInSessionMutation,
    RecordCheckInInSessionMutationVariables
  >(RecordCheckInInSessionDocument, options);
}
export type RecordCheckInInSessionMutationHookResult = ReturnType<
  typeof useRecordCheckInInSessionMutation
>;
export type RecordCheckInInSessionMutationResult =
  Apollo.MutationResult<RecordCheckInInSessionMutation>;
export type RecordCheckInInSessionMutationOptions = Apollo.BaseMutationOptions<
  RecordCheckInInSessionMutation,
  RecordCheckInInSessionMutationVariables
>;
export const DeleteCheckInDocument = gql`
  mutation DeleteCheckIn($input: DeleteCheckInInput!) {
    deleteCheckIn(input: $input) {
      checkInId
      recorded
    }
  }
`;
export type DeleteCheckInMutationFn = Apollo.MutationFunction<
  DeleteCheckInMutation,
  DeleteCheckInMutationVariables
>;

/**
 * __useDeleteCheckInMutation__
 *
 * To run a mutation, you first call `useDeleteCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCheckInMutation, { data, loading, error }] = useDeleteCheckInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCheckInMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCheckInMutation,
    DeleteCheckInMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCheckInMutation,
    DeleteCheckInMutationVariables
  >(DeleteCheckInDocument, options);
}
export type DeleteCheckInMutationHookResult = ReturnType<
  typeof useDeleteCheckInMutation
>;
export type DeleteCheckInMutationResult =
  Apollo.MutationResult<DeleteCheckInMutation>;
export type DeleteCheckInMutationOptions = Apollo.BaseMutationOptions<
  DeleteCheckInMutation,
  DeleteCheckInMutationVariables
>;
export const MyCheckInsDocument = gql`
  query MyCheckIns($days: Int, $timeZone: String) {
    myCheckIns(days: $days, timeZone: $timeZone) {
      days
      checkedInToday
      streakDays
      entries {
        ...CheckInEntryFields
      }
      sleepNights {
        ...CheckInSleepNightFields
      }
      activityDays {
        ...CheckInActivityDayFields
      }
    }
  }
  ${CheckInEntryFieldsFragmentDoc}
  ${CheckInSleepNightFieldsFragmentDoc}
  ${CheckInActivityDayFieldsFragmentDoc}
`;

/**
 * __useMyCheckInsQuery__
 *
 * To run a query within a React component, call `useMyCheckInsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCheckInsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCheckInsQuery({
 *   variables: {
 *      days: // value for 'days'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useMyCheckInsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyCheckInsQuery,
    MyCheckInsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyCheckInsQuery, MyCheckInsQueryVariables>(
    MyCheckInsDocument,
    options,
  );
}
export function useMyCheckInsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyCheckInsQuery,
    MyCheckInsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyCheckInsQuery, MyCheckInsQueryVariables>(
    MyCheckInsDocument,
    options,
  );
}
export type MyCheckInsQueryHookResult = ReturnType<typeof useMyCheckInsQuery>;
export type MyCheckInsLazyQueryHookResult = ReturnType<
  typeof useMyCheckInsLazyQuery
>;
export type MyCheckInsQueryResult = Apollo.QueryResult<
  MyCheckInsQuery,
  MyCheckInsQueryVariables
>;
export const ClientCheckInTrendDocument = gql`
  query ClientCheckInTrend($subject: ID!, $days: Int, $timeZone: String) {
    clientCheckInTrend(subject: $subject, days: $days, timeZone: $timeZone) {
      subject
      days
      daysCheckedIn
      entries {
        ...CheckInEntryFields
      }
      sharedTypes {
        sleep
        activity
      }
      sleepNights {
        ...CheckInSleepNightFields
      }
      activityDays {
        ...CheckInActivityDayFields
      }
    }
  }
  ${CheckInEntryFieldsFragmentDoc}
  ${CheckInSleepNightFieldsFragmentDoc}
  ${CheckInActivityDayFieldsFragmentDoc}
`;

/**
 * __useClientCheckInTrendQuery__
 *
 * To run a query within a React component, call `useClientCheckInTrendQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCheckInTrendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCheckInTrendQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      days: // value for 'days'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useClientCheckInTrendQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientCheckInTrendQuery,
    ClientCheckInTrendQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientCheckInTrendQuery,
    ClientCheckInTrendQueryVariables
  >(ClientCheckInTrendDocument, options);
}
export function useClientCheckInTrendLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientCheckInTrendQuery,
    ClientCheckInTrendQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientCheckInTrendQuery,
    ClientCheckInTrendQueryVariables
  >(ClientCheckInTrendDocument, options);
}
export type ClientCheckInTrendQueryHookResult = ReturnType<
  typeof useClientCheckInTrendQuery
>;
export type ClientCheckInTrendLazyQueryHookResult = ReturnType<
  typeof useClientCheckInTrendLazyQuery
>;
export type ClientCheckInTrendQueryResult = Apollo.QueryResult<
  ClientCheckInTrendQuery,
  ClientCheckInTrendQueryVariables
>;
export const CheckInsSinceLastSessionDocument = gql`
  query CheckInsSinceLastSession(
    $subject: ID!
    $sessionId: ID
    $timeZone: String
  ) {
    checkInsSinceLastSession(
      subject: $subject
      sessionId: $sessionId
      timeZone: $timeZone
    ) {
      subject
      sessionId
      since
      firstSession
      checkIns
      inSessionCheckIns
      moodAverage
      moodLowest {
        checkInId
        day
        mood
        note
      }
      sleepAverageHours
      topDrivers {
        driver
        count
      }
      entries {
        ...CheckInEntryFields
      }
      sharedTypes {
        sleep
        activity
      }
      phoneAverages {
        asleepMinutes
        efficiency
        activeMinutes
      }
    }
  }
  ${CheckInEntryFieldsFragmentDoc}
`;

/**
 * __useCheckInsSinceLastSessionQuery__
 *
 * To run a query within a React component, call `useCheckInsSinceLastSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckInsSinceLastSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckInsSinceLastSessionQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      sessionId: // value for 'sessionId'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useCheckInsSinceLastSessionQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckInsSinceLastSessionQuery,
    CheckInsSinceLastSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckInsSinceLastSessionQuery,
    CheckInsSinceLastSessionQueryVariables
  >(CheckInsSinceLastSessionDocument, options);
}
export function useCheckInsSinceLastSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckInsSinceLastSessionQuery,
    CheckInsSinceLastSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckInsSinceLastSessionQuery,
    CheckInsSinceLastSessionQueryVariables
  >(CheckInsSinceLastSessionDocument, options);
}
export type CheckInsSinceLastSessionQueryHookResult = ReturnType<
  typeof useCheckInsSinceLastSessionQuery
>;
export type CheckInsSinceLastSessionLazyQueryHookResult = ReturnType<
  typeof useCheckInsSinceLastSessionLazyQuery
>;
export type CheckInsSinceLastSessionQueryResult = Apollo.QueryResult<
  CheckInsSinceLastSessionQuery,
  CheckInsSinceLastSessionQueryVariables
>;
export const SetHiddenToolsDocument = gql`
  mutation SetHiddenTools($input: SetHiddenToolsInput!) {
    setHiddenTools(input: $input) {
      performer
      hiddenTools
    }
  }
`;
export type SetHiddenToolsMutationFn = Apollo.MutationFunction<
  SetHiddenToolsMutation,
  SetHiddenToolsMutationVariables
>;

/**
 * __useSetHiddenToolsMutation__
 *
 * To run a mutation, you first call `useSetHiddenToolsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHiddenToolsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHiddenToolsMutation, { data, loading, error }] = useSetHiddenToolsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetHiddenToolsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetHiddenToolsMutation,
    SetHiddenToolsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetHiddenToolsMutation,
    SetHiddenToolsMutationVariables
  >(SetHiddenToolsDocument, options);
}
export type SetHiddenToolsMutationHookResult = ReturnType<
  typeof useSetHiddenToolsMutation
>;
export type SetHiddenToolsMutationResult =
  Apollo.MutationResult<SetHiddenToolsMutation>;
export type SetHiddenToolsMutationOptions = Apollo.BaseMutationOptions<
  SetHiddenToolsMutation,
  SetHiddenToolsMutationVariables
>;
export const MyHiddenToolsDocument = gql`
  query MyHiddenTools {
    myHiddenTools {
      performer
      hiddenTools
    }
  }
`;

/**
 * __useMyHiddenToolsQuery__
 *
 * To run a query within a React component, call `useMyHiddenToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyHiddenToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyHiddenToolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyHiddenToolsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyHiddenToolsQuery,
    MyHiddenToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyHiddenToolsQuery, MyHiddenToolsQueryVariables>(
    MyHiddenToolsDocument,
    options,
  );
}
export function useMyHiddenToolsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyHiddenToolsQuery,
    MyHiddenToolsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyHiddenToolsQuery, MyHiddenToolsQueryVariables>(
    MyHiddenToolsDocument,
    options,
  );
}
export type MyHiddenToolsQueryHookResult = ReturnType<
  typeof useMyHiddenToolsQuery
>;
export type MyHiddenToolsLazyQueryHookResult = ReturnType<
  typeof useMyHiddenToolsLazyQuery
>;
export type MyHiddenToolsQueryResult = Apollo.QueryResult<
  MyHiddenToolsQuery,
  MyHiddenToolsQueryVariables
>;
export const ClientHeaderDocument = gql`
  query ClientHeader($subject: ID!) {
    clientHeader(subject: $subject) {
      subject
      firstName
      lastName
      role
      accessLevel
      appClient
      lastSession {
        start
        end
      }
      reviewSession {
        reviewSessionId
        startedAt
      }
    }
  }
`;

/**
 * __useClientHeaderQuery__
 *
 * To run a query within a React component, call `useClientHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientHeaderQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useClientHeaderQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientHeaderQuery,
    ClientHeaderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClientHeaderQuery, ClientHeaderQueryVariables>(
    ClientHeaderDocument,
    options,
  );
}
export function useClientHeaderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientHeaderQuery,
    ClientHeaderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClientHeaderQuery, ClientHeaderQueryVariables>(
    ClientHeaderDocument,
    options,
  );
}
export type ClientHeaderQueryHookResult = ReturnType<
  typeof useClientHeaderQuery
>;
export type ClientHeaderLazyQueryHookResult = ReturnType<
  typeof useClientHeaderLazyQuery
>;
export type ClientHeaderQueryResult = Apollo.QueryResult<
  ClientHeaderQuery,
  ClientHeaderQueryVariables
>;
export const ClientToolNavigationDocument = gql`
  query ClientToolNavigation($subject: ID!) {
    clientToolNavigation(subject: $subject) {
      subject
      performer
      sinceDate
      workShared
      sessionCount
      tools {
        tool
        group
        inUse
        recordCount
        lastRecordedAt
        newSinceLastSession
        hiddenByMe
      }
    }
  }
`;

/**
 * __useClientToolNavigationQuery__
 *
 * To run a query within a React component, call `useClientToolNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientToolNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientToolNavigationQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useClientToolNavigationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientToolNavigationQuery,
    ClientToolNavigationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientToolNavigationQuery,
    ClientToolNavigationQueryVariables
  >(ClientToolNavigationDocument, options);
}
export function useClientToolNavigationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientToolNavigationQuery,
    ClientToolNavigationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientToolNavigationQuery,
    ClientToolNavigationQueryVariables
  >(ClientToolNavigationDocument, options);
}
export type ClientToolNavigationQueryHookResult = ReturnType<
  typeof useClientToolNavigationQuery
>;
export type ClientToolNavigationLazyQueryHookResult = ReturnType<
  typeof useClientToolNavigationLazyQuery
>;
export type ClientToolNavigationQueryResult = Apollo.QueryResult<
  ClientToolNavigationQuery,
  ClientToolNavigationQueryVariables
>;
export const ClientDigestDocument = gql`
  query ClientDigest($subject: ID!) {
    clientDigest(subject: $subject) {
      subject
      sinceDate
      noSession
      workShared
      cards {
        tool
        group
        count
        hidden
        lastAt
        lastDay
        done
        total
        overdue
        moodMin
        moodMax
        scores {
          instrument
          score
          previous
          change
          at
        }
      }
    }
  }
`;

/**
 * __useClientDigestQuery__
 *
 * To run a query within a React component, call `useClientDigestQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDigestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDigestQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useClientDigestQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientDigestQuery,
    ClientDigestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClientDigestQuery, ClientDigestQueryVariables>(
    ClientDigestDocument,
    options,
  );
}
export function useClientDigestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientDigestQuery,
    ClientDigestQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClientDigestQuery, ClientDigestQueryVariables>(
    ClientDigestDocument,
    options,
  );
}
export type ClientDigestQueryHookResult = ReturnType<
  typeof useClientDigestQuery
>;
export type ClientDigestLazyQueryHookResult = ReturnType<
  typeof useClientDigestLazyQuery
>;
export type ClientDigestQueryResult = Apollo.QueryResult<
  ClientDigestQuery,
  ClientDigestQueryVariables
>;
export const AllRecordsDocument = gql`
  query AllRecords(
    $tools: [String!]
    $subject: ID
    $from: DateTime
    $to: DateTime
    $therapist: ID
    $start: Int
    $limit: Int
  ) {
    allRecords(
      tools: $tools
      subject: $subject
      from: $from
      to: $to
      therapist: $therapist
      start: $start
      limit: $limit
    ) {
      count
      toolCounts {
        tool
        count
      }
      rows {
        subject
        tool
        recordId
        performer
        occurredAt
        summary
        metric {
          kind
          value
          instrument
          higherIsWorse
        }
        day
        nightKind
        status
        hidden
      }
    }
  }
`;

/**
 * __useAllRecordsQuery__
 *
 * To run a query within a React component, call `useAllRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllRecordsQuery({
 *   variables: {
 *      tools: // value for 'tools'
 *      subject: // value for 'subject'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      therapist: // value for 'therapist'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAllRecordsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AllRecordsQuery,
    AllRecordsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AllRecordsQuery, AllRecordsQueryVariables>(
    AllRecordsDocument,
    options,
  );
}
export function useAllRecordsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AllRecordsQuery,
    AllRecordsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AllRecordsQuery, AllRecordsQueryVariables>(
    AllRecordsDocument,
    options,
  );
}
export type AllRecordsQueryHookResult = ReturnType<typeof useAllRecordsQuery>;
export type AllRecordsLazyQueryHookResult = ReturnType<
  typeof useAllRecordsLazyQuery
>;
export type AllRecordsQueryResult = Apollo.QueryResult<
  AllRecordsQuery,
  AllRecordsQueryVariables
>;
export const CaseloadOverviewDocument = gql`
  query CaseloadOverview($question: String, $timeZone: String) {
    caseloadOverview(question: $question, timeZone: $timeZone) {
      subject
      view
      therapist
      therapistName
      homeworkBehind
      latestScores {
        instrument
        score
        previous
        change
        wentUp
        at
      }
      scoreWentUp
      maxScoreRise
      checkInsInUse
      lastCheckInDay
      daysSinceCheckIn
      diaryInUse
      diaryDaysThisWeek
      lastSession {
        start
        end
      }
      lastActivityAt
      toolsInUse
      signals {
        homeworkBehind
        scoreWentUp
        noCheckIn7Days
        diaryNotFilledThisWeek
      }
    }
  }
`;

/**
 * __useCaseloadOverviewQuery__
 *
 * To run a query within a React component, call `useCaseloadOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseloadOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseloadOverviewQuery({
 *   variables: {
 *      question: // value for 'question'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useCaseloadOverviewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CaseloadOverviewQuery,
    CaseloadOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CaseloadOverviewQuery, CaseloadOverviewQueryVariables>(
    CaseloadOverviewDocument,
    options,
  );
}
export function useCaseloadOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CaseloadOverviewQuery,
    CaseloadOverviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CaseloadOverviewQuery,
    CaseloadOverviewQueryVariables
  >(CaseloadOverviewDocument, options);
}
export type CaseloadOverviewQueryHookResult = ReturnType<
  typeof useCaseloadOverviewQuery
>;
export type CaseloadOverviewLazyQueryHookResult = ReturnType<
  typeof useCaseloadOverviewLazyQuery
>;
export type CaseloadOverviewQueryResult = Apollo.QueryResult<
  CaseloadOverviewQuery,
  CaseloadOverviewQueryVariables
>;
export const DateTimeReminderDocument = gql`
  query DateTimeReminder($_id: String!) {
    dateTimeReminder(_id: $_id) {
      ...DateTimeReminderData
    }
  }
  ${DateTimeReminderDataFragmentDoc}
`;

/**
 * __useDateTimeReminderQuery__
 *
 * To run a query within a React component, call `useDateTimeReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useDateTimeReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDateTimeReminderQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDateTimeReminderQuery(
  baseOptions: Apollo.QueryHookOptions<
    DateTimeReminderQuery,
    DateTimeReminderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DateTimeReminderQuery, DateTimeReminderQueryVariables>(
    DateTimeReminderDocument,
    options,
  );
}
export function useDateTimeReminderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DateTimeReminderQuery,
    DateTimeReminderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DateTimeReminderQuery,
    DateTimeReminderQueryVariables
  >(DateTimeReminderDocument, options);
}
export type DateTimeReminderQueryHookResult = ReturnType<
  typeof useDateTimeReminderQuery
>;
export type DateTimeReminderLazyQueryHookResult = ReturnType<
  typeof useDateTimeReminderLazyQuery
>;
export type DateTimeReminderQueryResult = Apollo.QueryResult<
  DateTimeReminderQuery,
  DateTimeReminderQueryVariables
>;
export const DateTimeRemindersDocument = gql`
  query DateTimeReminders($ids: [String!]) {
    dateTimeReminders(ids: $ids) {
      ...DateTimeReminderData
    }
  }
  ${DateTimeReminderDataFragmentDoc}
`;

/**
 * __useDateTimeRemindersQuery__
 *
 * To run a query within a React component, call `useDateTimeRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDateTimeRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDateTimeRemindersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDateTimeRemindersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DateTimeRemindersQuery,
    DateTimeRemindersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DateTimeRemindersQuery,
    DateTimeRemindersQueryVariables
  >(DateTimeRemindersDocument, options);
}
export function useDateTimeRemindersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DateTimeRemindersQuery,
    DateTimeRemindersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DateTimeRemindersQuery,
    DateTimeRemindersQueryVariables
  >(DateTimeRemindersDocument, options);
}
export type DateTimeRemindersQueryHookResult = ReturnType<
  typeof useDateTimeRemindersQuery
>;
export type DateTimeRemindersLazyQueryHookResult = ReturnType<
  typeof useDateTimeRemindersLazyQuery
>;
export type DateTimeRemindersQueryResult = Apollo.QueryResult<
  DateTimeRemindersQuery,
  DateTimeRemindersQueryVariables
>;
export const DateTimeRemindersForUserDocument = gql`
  query DateTimeRemindersForUser(
    $after: String
    $before: String
    $sort: String
    $first: Int
    $last: Int
    $enabled: Boolean
  ) {
    dateTimeRemindersForUser(
      after: $after
      before: $before
      sort: $sort
      first: $first
      last: $last
      enabled: $enabled
    ) {
      totalCount
      edges {
        cursor
        node {
          ...DateTimeReminderData
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${DateTimeReminderDataFragmentDoc}
`;

/**
 * __useDateTimeRemindersForUserQuery__
 *
 * To run a query within a React component, call `useDateTimeRemindersForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useDateTimeRemindersForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDateTimeRemindersForUserQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useDateTimeRemindersForUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DateTimeRemindersForUserQuery,
    DateTimeRemindersForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DateTimeRemindersForUserQuery,
    DateTimeRemindersForUserQueryVariables
  >(DateTimeRemindersForUserDocument, options);
}
export function useDateTimeRemindersForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DateTimeRemindersForUserQuery,
    DateTimeRemindersForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DateTimeRemindersForUserQuery,
    DateTimeRemindersForUserQueryVariables
  >(DateTimeRemindersForUserDocument, options);
}
export type DateTimeRemindersForUserQueryHookResult = ReturnType<
  typeof useDateTimeRemindersForUserQuery
>;
export type DateTimeRemindersForUserLazyQueryHookResult = ReturnType<
  typeof useDateTimeRemindersForUserLazyQuery
>;
export type DateTimeRemindersForUserQueryResult = Apollo.QueryResult<
  DateTimeRemindersForUserQuery,
  DateTimeRemindersForUserQueryVariables
>;
export const CreateDateTimeReminderDocument = gql`
  mutation CreateDateTimeReminder(
    $dateTimeReminder: DateTimeReminderCreateInput!
  ) {
    createDateTimeReminder(dateTimeReminder: $dateTimeReminder) {
      dateTimeReminder {
        ...DateTimeReminderData
      }
    }
  }
  ${DateTimeReminderDataFragmentDoc}
`;
export type CreateDateTimeReminderMutationFn = Apollo.MutationFunction<
  CreateDateTimeReminderMutation,
  CreateDateTimeReminderMutationVariables
>;

/**
 * __useCreateDateTimeReminderMutation__
 *
 * To run a mutation, you first call `useCreateDateTimeReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDateTimeReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDateTimeReminderMutation, { data, loading, error }] = useCreateDateTimeReminderMutation({
 *   variables: {
 *      dateTimeReminder: // value for 'dateTimeReminder'
 *   },
 * });
 */
export function useCreateDateTimeReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDateTimeReminderMutation,
    CreateDateTimeReminderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDateTimeReminderMutation,
    CreateDateTimeReminderMutationVariables
  >(CreateDateTimeReminderDocument, options);
}
export type CreateDateTimeReminderMutationHookResult = ReturnType<
  typeof useCreateDateTimeReminderMutation
>;
export type CreateDateTimeReminderMutationResult =
  Apollo.MutationResult<CreateDateTimeReminderMutation>;
export type CreateDateTimeReminderMutationOptions = Apollo.BaseMutationOptions<
  CreateDateTimeReminderMutation,
  CreateDateTimeReminderMutationVariables
>;
export const UpdateDateTimeReminderDocument = gql`
  mutation UpdateDateTimeReminder(
    $dateTimeReminder: DateTimeReminderUpdateInput!
  ) {
    updateDateTimeReminder(dateTimeReminder: $dateTimeReminder) {
      dateTimeReminder {
        ...DateTimeReminderData
      }
    }
  }
  ${DateTimeReminderDataFragmentDoc}
`;
export type UpdateDateTimeReminderMutationFn = Apollo.MutationFunction<
  UpdateDateTimeReminderMutation,
  UpdateDateTimeReminderMutationVariables
>;

/**
 * __useUpdateDateTimeReminderMutation__
 *
 * To run a mutation, you first call `useUpdateDateTimeReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDateTimeReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDateTimeReminderMutation, { data, loading, error }] = useUpdateDateTimeReminderMutation({
 *   variables: {
 *      dateTimeReminder: // value for 'dateTimeReminder'
 *   },
 * });
 */
export function useUpdateDateTimeReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDateTimeReminderMutation,
    UpdateDateTimeReminderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDateTimeReminderMutation,
    UpdateDateTimeReminderMutationVariables
  >(UpdateDateTimeReminderDocument, options);
}
export type UpdateDateTimeReminderMutationHookResult = ReturnType<
  typeof useUpdateDateTimeReminderMutation
>;
export type UpdateDateTimeReminderMutationResult =
  Apollo.MutationResult<UpdateDateTimeReminderMutation>;
export type UpdateDateTimeReminderMutationOptions = Apollo.BaseMutationOptions<
  UpdateDateTimeReminderMutation,
  UpdateDateTimeReminderMutationVariables
>;
export const DeleteDateTimeReminderDocument = gql`
  mutation DeleteDateTimeReminder($_id: ID!) {
    deleteDateTimeReminder(_id: $_id) {
      success
      old {
        ...DateTimeReminderData
      }
    }
  }
  ${DateTimeReminderDataFragmentDoc}
`;
export type DeleteDateTimeReminderMutationFn = Apollo.MutationFunction<
  DeleteDateTimeReminderMutation,
  DeleteDateTimeReminderMutationVariables
>;

/**
 * __useDeleteDateTimeReminderMutation__
 *
 * To run a mutation, you first call `useDeleteDateTimeReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDateTimeReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDateTimeReminderMutation, { data, loading, error }] = useDeleteDateTimeReminderMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteDateTimeReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDateTimeReminderMutation,
    DeleteDateTimeReminderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDateTimeReminderMutation,
    DeleteDateTimeReminderMutationVariables
  >(DeleteDateTimeReminderDocument, options);
}
export type DeleteDateTimeReminderMutationHookResult = ReturnType<
  typeof useDeleteDateTimeReminderMutation
>;
export type DeleteDateTimeReminderMutationResult =
  Apollo.MutationResult<DeleteDateTimeReminderMutation>;
export type DeleteDateTimeReminderMutationOptions = Apollo.BaseMutationOptions<
  DeleteDateTimeReminderMutation,
  DeleteDateTimeReminderMutationVariables
>;
export const DayRemindersDocument = gql`
  query DayReminders($_id: String!) {
    dayReminders(_id: $_id) {
      ...DayRemindersData
    }
  }
  ${DayRemindersDataFragmentDoc}
`;

/**
 * __useDayRemindersQuery__
 *
 * To run a query within a React component, call `useDayRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDayRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDayRemindersQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDayRemindersQuery(
  baseOptions: Apollo.QueryHookOptions<
    DayRemindersQuery,
    DayRemindersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DayRemindersQuery, DayRemindersQueryVariables>(
    DayRemindersDocument,
    options,
  );
}
export function useDayRemindersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DayRemindersQuery,
    DayRemindersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DayRemindersQuery, DayRemindersQueryVariables>(
    DayRemindersDocument,
    options,
  );
}
export type DayRemindersQueryHookResult = ReturnType<
  typeof useDayRemindersQuery
>;
export type DayRemindersLazyQueryHookResult = ReturnType<
  typeof useDayRemindersLazyQuery
>;
export type DayRemindersQueryResult = Apollo.QueryResult<
  DayRemindersQuery,
  DayRemindersQueryVariables
>;
export const DayRemindersForUserDocument = gql`
  query DayRemindersForUser {
    thoughtsForUser(first: 150) {
      totalCount
      edges {
        cursor
        node {
          _id
          dayReminders {
            ...DayRemindersData
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${DayRemindersDataFragmentDoc}
`;

/**
 * __useDayRemindersForUserQuery__
 *
 * To run a query within a React component, call `useDayRemindersForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useDayRemindersForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDayRemindersForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useDayRemindersForUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DayRemindersForUserQuery,
    DayRemindersForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DayRemindersForUserQuery,
    DayRemindersForUserQueryVariables
  >(DayRemindersForUserDocument, options);
}
export function useDayRemindersForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DayRemindersForUserQuery,
    DayRemindersForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DayRemindersForUserQuery,
    DayRemindersForUserQueryVariables
  >(DayRemindersForUserDocument, options);
}
export type DayRemindersForUserQueryHookResult = ReturnType<
  typeof useDayRemindersForUserQuery
>;
export type DayRemindersForUserLazyQueryHookResult = ReturnType<
  typeof useDayRemindersForUserLazyQuery
>;
export type DayRemindersForUserQueryResult = Apollo.QueryResult<
  DayRemindersForUserQuery,
  DayRemindersForUserQueryVariables
>;
export const EnabledDayRemindersCountDocument = gql`
  query EnabledDayRemindersCount {
    enabledDayReminders {
      enabled
    }
  }
`;

/**
 * __useEnabledDayRemindersCountQuery__
 *
 * To run a query within a React component, call `useEnabledDayRemindersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnabledDayRemindersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledDayRemindersCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnabledDayRemindersCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EnabledDayRemindersCountQuery,
    EnabledDayRemindersCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnabledDayRemindersCountQuery,
    EnabledDayRemindersCountQueryVariables
  >(EnabledDayRemindersCountDocument, options);
}
export function useEnabledDayRemindersCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnabledDayRemindersCountQuery,
    EnabledDayRemindersCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnabledDayRemindersCountQuery,
    EnabledDayRemindersCountQueryVariables
  >(EnabledDayRemindersCountDocument, options);
}
export type EnabledDayRemindersCountQueryHookResult = ReturnType<
  typeof useEnabledDayRemindersCountQuery
>;
export type EnabledDayRemindersCountLazyQueryHookResult = ReturnType<
  typeof useEnabledDayRemindersCountLazyQuery
>;
export type EnabledDayRemindersCountQueryResult = Apollo.QueryResult<
  EnabledDayRemindersCountQuery,
  EnabledDayRemindersCountQueryVariables
>;
export const CreateDayRemindersDocument = gql`
  mutation CreateDayReminders($dayReminders: DayRemindersCreateInput!) {
    createDayReminders(dayReminders: $dayReminders) {
      dayReminders {
        ...DayRemindersData
      }
    }
  }
  ${DayRemindersDataFragmentDoc}
`;
export type CreateDayRemindersMutationFn = Apollo.MutationFunction<
  CreateDayRemindersMutation,
  CreateDayRemindersMutationVariables
>;

/**
 * __useCreateDayRemindersMutation__
 *
 * To run a mutation, you first call `useCreateDayRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDayRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDayRemindersMutation, { data, loading, error }] = useCreateDayRemindersMutation({
 *   variables: {
 *      dayReminders: // value for 'dayReminders'
 *   },
 * });
 */
export function useCreateDayRemindersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDayRemindersMutation,
    CreateDayRemindersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDayRemindersMutation,
    CreateDayRemindersMutationVariables
  >(CreateDayRemindersDocument, options);
}
export type CreateDayRemindersMutationHookResult = ReturnType<
  typeof useCreateDayRemindersMutation
>;
export type CreateDayRemindersMutationResult =
  Apollo.MutationResult<CreateDayRemindersMutation>;
export type CreateDayRemindersMutationOptions = Apollo.BaseMutationOptions<
  CreateDayRemindersMutation,
  CreateDayRemindersMutationVariables
>;
export const DeleteDayRemindersDocument = gql`
  mutation DeleteDayReminders($_id: String!) {
    deleteDayReminders(_id: $_id) {
      success
      old {
        ...DayRemindersData
      }
    }
  }
  ${DayRemindersDataFragmentDoc}
`;
export type DeleteDayRemindersMutationFn = Apollo.MutationFunction<
  DeleteDayRemindersMutation,
  DeleteDayRemindersMutationVariables
>;

/**
 * __useDeleteDayRemindersMutation__
 *
 * To run a mutation, you first call `useDeleteDayRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDayRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDayRemindersMutation, { data, loading, error }] = useDeleteDayRemindersMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteDayRemindersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDayRemindersMutation,
    DeleteDayRemindersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDayRemindersMutation,
    DeleteDayRemindersMutationVariables
  >(DeleteDayRemindersDocument, options);
}
export type DeleteDayRemindersMutationHookResult = ReturnType<
  typeof useDeleteDayRemindersMutation
>;
export type DeleteDayRemindersMutationResult =
  Apollo.MutationResult<DeleteDayRemindersMutation>;
export type DeleteDayRemindersMutationOptions = Apollo.BaseMutationOptions<
  DeleteDayRemindersMutation,
  DeleteDayRemindersMutationVariables
>;
export const UpdateDayRemindersDocument = gql`
  mutation UpdateDayReminders($dayReminders: DayRemindersUpdateInput!) {
    updateDayReminders(dayReminders: $dayReminders) {
      dayReminders {
        ...DayRemindersData
      }
    }
  }
  ${DayRemindersDataFragmentDoc}
`;
export type UpdateDayRemindersMutationFn = Apollo.MutationFunction<
  UpdateDayRemindersMutation,
  UpdateDayRemindersMutationVariables
>;

/**
 * __useUpdateDayRemindersMutation__
 *
 * To run a mutation, you first call `useUpdateDayRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDayRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDayRemindersMutation, { data, loading, error }] = useUpdateDayRemindersMutation({
 *   variables: {
 *      dayReminders: // value for 'dayReminders'
 *   },
 * });
 */
export function useUpdateDayRemindersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateDayRemindersMutation,
    UpdateDayRemindersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateDayRemindersMutation,
    UpdateDayRemindersMutationVariables
  >(UpdateDayRemindersDocument, options);
}
export type UpdateDayRemindersMutationHookResult = ReturnType<
  typeof useUpdateDayRemindersMutation
>;
export type UpdateDayRemindersMutationResult =
  Apollo.MutationResult<UpdateDayRemindersMutation>;
export type UpdateDayRemindersMutationOptions = Apollo.BaseMutationOptions<
  UpdateDayRemindersMutation,
  UpdateDayRemindersMutationVariables
>;
export const KeepDayRemindersDocument = gql`
  mutation KeepDayReminders($stringifiedIdsAndKeys: String!) {
    keepDayReminders(stringifiedIdsAndKeys: $stringifiedIdsAndKeys) {
      success
    }
  }
`;
export type KeepDayRemindersMutationFn = Apollo.MutationFunction<
  KeepDayRemindersMutation,
  KeepDayRemindersMutationVariables
>;

/**
 * __useKeepDayRemindersMutation__
 *
 * To run a mutation, you first call `useKeepDayRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKeepDayRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [keepDayRemindersMutation, { data, loading, error }] = useKeepDayRemindersMutation({
 *   variables: {
 *      stringifiedIdsAndKeys: // value for 'stringifiedIdsAndKeys'
 *   },
 * });
 */
export function useKeepDayRemindersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    KeepDayRemindersMutation,
    KeepDayRemindersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    KeepDayRemindersMutation,
    KeepDayRemindersMutationVariables
  >(KeepDayRemindersDocument, options);
}
export type KeepDayRemindersMutationHookResult = ReturnType<
  typeof useKeepDayRemindersMutation
>;
export type KeepDayRemindersMutationResult =
  Apollo.MutationResult<KeepDayRemindersMutation>;
export type KeepDayRemindersMutationOptions = Apollo.BaseMutationOptions<
  KeepDayRemindersMutation,
  KeepDayRemindersMutationVariables
>;
export const DiagramImageDocument = gql`
  query DiagramImage($source: String!) {
    diagramImage(source: $source)
  }
`;

/**
 * __useDiagramImageQuery__
 *
 * To run a query within a React component, call `useDiagramImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagramImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiagramImageQuery({
 *   variables: {
 *      source: // value for 'source'
 *   },
 * });
 */
export function useDiagramImageQuery(
  baseOptions: Apollo.QueryHookOptions<
    DiagramImageQuery,
    DiagramImageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DiagramImageQuery, DiagramImageQueryVariables>(
    DiagramImageDocument,
    options,
  );
}
export function useDiagramImageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiagramImageQuery,
    DiagramImageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DiagramImageQuery, DiagramImageQueryVariables>(
    DiagramImageDocument,
    options,
  );
}
export type DiagramImageQueryHookResult = ReturnType<
  typeof useDiagramImageQuery
>;
export type DiagramImageLazyQueryHookResult = ReturnType<
  typeof useDiagramImageLazyQuery
>;
export type DiagramImageQueryResult = Apollo.QueryResult<
  DiagramImageQuery,
  DiagramImageQueryVariables
>;
export const DiaryCardTemplatesDocument = gql`
  query DiaryCardTemplates($locale: String) {
    diaryCardTemplates(locale: $locale) {
      templateId
      name
      summary
      targets {
        targetId
        name
        kind
        max
        countable
        standard
        faTargetId
      }
      emotions {
        id
      }
      skills {
        skillId
        module
      }
    }
  }
`;

/**
 * __useDiaryCardTemplatesQuery__
 *
 * To run a query within a React component, call `useDiaryCardTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiaryCardTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiaryCardTemplatesQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useDiaryCardTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DiaryCardTemplatesQuery,
    DiaryCardTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DiaryCardTemplatesQuery,
    DiaryCardTemplatesQueryVariables
  >(DiaryCardTemplatesDocument, options);
}
export function useDiaryCardTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiaryCardTemplatesQuery,
    DiaryCardTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DiaryCardTemplatesQuery,
    DiaryCardTemplatesQueryVariables
  >(DiaryCardTemplatesDocument, options);
}
export type DiaryCardTemplatesQueryHookResult = ReturnType<
  typeof useDiaryCardTemplatesQuery
>;
export type DiaryCardTemplatesLazyQueryHookResult = ReturnType<
  typeof useDiaryCardTemplatesLazyQuery
>;
export type DiaryCardTemplatesQueryResult = Apollo.QueryResult<
  DiaryCardTemplatesQuery,
  DiaryCardTemplatesQueryVariables
>;
export const DiaryCardDocument = gql`
  query DiaryCard($day: String, $timeZone: String) {
    diaryCard(day: $day, timeZone: $timeZone) {
      day
      filledToday
      activeCards {
        ...DiaryCardRows
      }
      formRows {
        key
        targetId
        name
        kind
        max
        countable
        standard
        cardIds
        ownerCardId
      }
      fills {
        cardId
        version
        enteredInSession
        ratings {
          ...DiaryCardRatingFields
        }
        emotionRatings {
          id
          rating
        }
        skillsUsed
        skillsPracticed
        note
      }
    }
  }
  ${DiaryCardRowsFragmentDoc}
  ${DiaryCardRatingFieldsFragmentDoc}
`;

/**
 * __useDiaryCardQuery__
 *
 * To run a query within a React component, call `useDiaryCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiaryCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiaryCardQuery({
 *   variables: {
 *      day: // value for 'day'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useDiaryCardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DiaryCardQuery,
    DiaryCardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DiaryCardQuery, DiaryCardQueryVariables>(
    DiaryCardDocument,
    options,
  );
}
export function useDiaryCardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiaryCardQuery,
    DiaryCardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DiaryCardQuery, DiaryCardQueryVariables>(
    DiaryCardDocument,
    options,
  );
}
export type DiaryCardQueryHookResult = ReturnType<typeof useDiaryCardQuery>;
export type DiaryCardLazyQueryHookResult = ReturnType<
  typeof useDiaryCardLazyQuery
>;
export type DiaryCardQueryResult = Apollo.QueryResult<
  DiaryCardQuery,
  DiaryCardQueryVariables
>;
export const DiaryCardWeekDocument = gql`
  query DiaryCardWeek($weekOf: String, $timeZone: String) {
    diaryCardWeek(weekOf: $weekOf, timeZone: $timeZone) {
      subject
      weekOf
      cards {
        cardId
        practiceId
        setUpBy
        setUpByName
        version
        targets {
          targetId
          name
          kind
          max
          countable
          standard
        }
        emotions {
          id
        }
        skills {
          skillId
          module
        }
        dayEntries {
          cardId
          day
          enteredInSession
          ratings {
            ...DiaryCardRatingFields
          }
          emotionRatings {
            id
            rating
          }
          skillsUsed
          skillsPracticed
          note
        }
        inSessionDays
        highlights {
          day
          targetId
          urge
          acted
          count
        }
      }
    }
  }
  ${DiaryCardRatingFieldsFragmentDoc}
`;

/**
 * __useDiaryCardWeekQuery__
 *
 * To run a query within a React component, call `useDiaryCardWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiaryCardWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiaryCardWeekQuery({
 *   variables: {
 *      weekOf: // value for 'weekOf'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useDiaryCardWeekQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DiaryCardWeekQuery,
    DiaryCardWeekQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DiaryCardWeekQuery, DiaryCardWeekQueryVariables>(
    DiaryCardWeekDocument,
    options,
  );
}
export function useDiaryCardWeekLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DiaryCardWeekQuery,
    DiaryCardWeekQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DiaryCardWeekQuery, DiaryCardWeekQueryVariables>(
    DiaryCardWeekDocument,
    options,
  );
}
export type DiaryCardWeekQueryHookResult = ReturnType<
  typeof useDiaryCardWeekQuery
>;
export type DiaryCardWeekLazyQueryHookResult = ReturnType<
  typeof useDiaryCardWeekLazyQuery
>;
export type DiaryCardWeekQueryResult = Apollo.QueryResult<
  DiaryCardWeekQuery,
  DiaryCardWeekQueryVariables
>;
export const DefineDiaryCardDocument = gql`
  mutation DefineDiaryCard($input: DefineDiaryCardInput!) {
    defineDiaryCard(input: $input) {
      cardId
      version
      recorded
    }
  }
`;
export type DefineDiaryCardMutationFn = Apollo.MutationFunction<
  DefineDiaryCardMutation,
  DefineDiaryCardMutationVariables
>;

/**
 * __useDefineDiaryCardMutation__
 *
 * To run a mutation, you first call `useDefineDiaryCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefineDiaryCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [defineDiaryCardMutation, { data, loading, error }] = useDefineDiaryCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefineDiaryCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DefineDiaryCardMutation,
    DefineDiaryCardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DefineDiaryCardMutation,
    DefineDiaryCardMutationVariables
  >(DefineDiaryCardDocument, options);
}
export type DefineDiaryCardMutationHookResult = ReturnType<
  typeof useDefineDiaryCardMutation
>;
export type DefineDiaryCardMutationResult =
  Apollo.MutationResult<DefineDiaryCardMutation>;
export type DefineDiaryCardMutationOptions = Apollo.BaseMutationOptions<
  DefineDiaryCardMutation,
  DefineDiaryCardMutationVariables
>;
export const FillDiaryCardDocument = gql`
  mutation FillDiaryCard($input: FillDiaryCardInput!) {
    fillDiaryCard(input: $input) {
      cards
      recorded
    }
  }
`;
export type FillDiaryCardMutationFn = Apollo.MutationFunction<
  FillDiaryCardMutation,
  FillDiaryCardMutationVariables
>;

/**
 * __useFillDiaryCardMutation__
 *
 * To run a mutation, you first call `useFillDiaryCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFillDiaryCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fillDiaryCardMutation, { data, loading, error }] = useFillDiaryCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFillDiaryCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FillDiaryCardMutation,
    FillDiaryCardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FillDiaryCardMutation,
    FillDiaryCardMutationVariables
  >(FillDiaryCardDocument, options);
}
export type FillDiaryCardMutationHookResult = ReturnType<
  typeof useFillDiaryCardMutation
>;
export type FillDiaryCardMutationResult =
  Apollo.MutationResult<FillDiaryCardMutation>;
export type FillDiaryCardMutationOptions = Apollo.BaseMutationOptions<
  FillDiaryCardMutation,
  FillDiaryCardMutationVariables
>;
export const DownwardArrowsDocument = gql`
  query DownwardArrows($sort: String, $where: JSON, $start: Int, $limit: Int) {
    downwardArrows(sort: $sort, where: $where, start: $start, limit: $limit) {
      data {
        _id
        ...DownwardArrowData
      }
      count
    }
  }
  ${DownwardArrowDataFragmentDoc}
`;

/**
 * __useDownwardArrowsQuery__
 *
 * To run a query within a React component, call `useDownwardArrowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownwardArrowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownwardArrowsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDownwardArrowsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DownwardArrowsQuery,
    DownwardArrowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DownwardArrowsQuery, DownwardArrowsQueryVariables>(
    DownwardArrowsDocument,
    options,
  );
}
export function useDownwardArrowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DownwardArrowsQuery,
    DownwardArrowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DownwardArrowsQuery, DownwardArrowsQueryVariables>(
    DownwardArrowsDocument,
    options,
  );
}
export type DownwardArrowsQueryHookResult = ReturnType<
  typeof useDownwardArrowsQuery
>;
export type DownwardArrowsLazyQueryHookResult = ReturnType<
  typeof useDownwardArrowsLazyQuery
>;
export type DownwardArrowsQueryResult = Apollo.QueryResult<
  DownwardArrowsQuery,
  DownwardArrowsQueryVariables
>;
export const DownwardArrowDocument = gql`
  query DownwardArrow($_id: ID) {
    downwardArrow(_id: $_id) {
      _id
      ...DownwardArrowData
    }
  }
  ${DownwardArrowDataFragmentDoc}
`;

/**
 * __useDownwardArrowQuery__
 *
 * To run a query within a React component, call `useDownwardArrowQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownwardArrowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownwardArrowQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDownwardArrowQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DownwardArrowQuery,
    DownwardArrowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DownwardArrowQuery, DownwardArrowQueryVariables>(
    DownwardArrowDocument,
    options,
  );
}
export function useDownwardArrowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DownwardArrowQuery,
    DownwardArrowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DownwardArrowQuery, DownwardArrowQueryVariables>(
    DownwardArrowDocument,
    options,
  );
}
export type DownwardArrowQueryHookResult = ReturnType<
  typeof useDownwardArrowQuery
>;
export type DownwardArrowLazyQueryHookResult = ReturnType<
  typeof useDownwardArrowLazyQuery
>;
export type DownwardArrowQueryResult = Apollo.QueryResult<
  DownwardArrowQuery,
  DownwardArrowQueryVariables
>;
export const UpsertDownwardArrowDocument = gql`
  mutation UpsertDownwardArrow($input: DownwardArrowInput) {
    upsertDownwardArrow(input: $input) {
      _id
      ...DownwardArrowData
    }
  }
  ${DownwardArrowDataFragmentDoc}
`;
export type UpsertDownwardArrowMutationFn = Apollo.MutationFunction<
  UpsertDownwardArrowMutation,
  UpsertDownwardArrowMutationVariables
>;

/**
 * __useUpsertDownwardArrowMutation__
 *
 * To run a mutation, you first call `useUpsertDownwardArrowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDownwardArrowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDownwardArrowMutation, { data, loading, error }] = useUpsertDownwardArrowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertDownwardArrowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertDownwardArrowMutation,
    UpsertDownwardArrowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertDownwardArrowMutation,
    UpsertDownwardArrowMutationVariables
  >(UpsertDownwardArrowDocument, options);
}
export type UpsertDownwardArrowMutationHookResult = ReturnType<
  typeof useUpsertDownwardArrowMutation
>;
export type UpsertDownwardArrowMutationResult =
  Apollo.MutationResult<UpsertDownwardArrowMutation>;
export type UpsertDownwardArrowMutationOptions = Apollo.BaseMutationOptions<
  UpsertDownwardArrowMutation,
  UpsertDownwardArrowMutationVariables
>;
export const EsReadyDomainsDocument = gql`
  query EsReadyDomains {
    esReadyDomains
  }
`;

/**
 * __useEsReadyDomainsQuery__
 *
 * To run a query within a React component, call `useEsReadyDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsReadyDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsReadyDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEsReadyDomainsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EsReadyDomainsQuery,
    EsReadyDomainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EsReadyDomainsQuery, EsReadyDomainsQueryVariables>(
    EsReadyDomainsDocument,
    options,
  );
}
export function useEsReadyDomainsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EsReadyDomainsQuery,
    EsReadyDomainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EsReadyDomainsQuery, EsReadyDomainsQueryVariables>(
    EsReadyDomainsDocument,
    options,
  );
}
export type EsReadyDomainsQueryHookResult = ReturnType<
  typeof useEsReadyDomainsQuery
>;
export type EsReadyDomainsLazyQueryHookResult = ReturnType<
  typeof useEsReadyDomainsLazyQuery
>;
export type EsReadyDomainsQueryResult = Apollo.QueryResult<
  EsReadyDomainsQuery,
  EsReadyDomainsQueryVariables
>;
export const EsReminderSchedulesDocument = gql`
  query EsReminderSchedules {
    esReminderSchedules {
      reminderId
      channel
      updatedAt
      target {
        kind
        ref
      }
      schedule {
        rrule
        dtstart
        tzid
        exdates
      }
      legacyBinding {
        collection
        key
        slot
      }
    }
  }
`;

/**
 * __useEsReminderSchedulesQuery__
 *
 * To run a query within a React component, call `useEsReminderSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsReminderSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsReminderSchedulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEsReminderSchedulesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EsReminderSchedulesQuery,
    EsReminderSchedulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EsReminderSchedulesQuery,
    EsReminderSchedulesQueryVariables
  >(EsReminderSchedulesDocument, options);
}
export function useEsReminderSchedulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EsReminderSchedulesQuery,
    EsReminderSchedulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EsReminderSchedulesQuery,
    EsReminderSchedulesQueryVariables
  >(EsReminderSchedulesDocument, options);
}
export type EsReminderSchedulesQueryHookResult = ReturnType<
  typeof useEsReminderSchedulesQuery
>;
export type EsReminderSchedulesLazyQueryHookResult = ReturnType<
  typeof useEsReminderSchedulesLazyQuery
>;
export type EsReminderSchedulesQueryResult = Apollo.QueryResult<
  EsReminderSchedulesQuery,
  EsReminderSchedulesQueryVariables
>;
export const RestoreTrimmedRemindersDocument = gql`
  mutation RestoreTrimmedReminders {
    restoreTrimmedReminders {
      success
      restored
    }
  }
`;
export type RestoreTrimmedRemindersMutationFn = Apollo.MutationFunction<
  RestoreTrimmedRemindersMutation,
  RestoreTrimmedRemindersMutationVariables
>;

/**
 * __useRestoreTrimmedRemindersMutation__
 *
 * To run a mutation, you first call `useRestoreTrimmedRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreTrimmedRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreTrimmedRemindersMutation, { data, loading, error }] = useRestoreTrimmedRemindersMutation({
 *   variables: {
 *   },
 * });
 */
export function useRestoreTrimmedRemindersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RestoreTrimmedRemindersMutation,
    RestoreTrimmedRemindersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RestoreTrimmedRemindersMutation,
    RestoreTrimmedRemindersMutationVariables
  >(RestoreTrimmedRemindersDocument, options);
}
export type RestoreTrimmedRemindersMutationHookResult = ReturnType<
  typeof useRestoreTrimmedRemindersMutation
>;
export type RestoreTrimmedRemindersMutationResult =
  Apollo.MutationResult<RestoreTrimmedRemindersMutation>;
export type RestoreTrimmedRemindersMutationOptions = Apollo.BaseMutationOptions<
  RestoreTrimmedRemindersMutation,
  RestoreTrimmedRemindersMutationVariables
>;
export const EsCardRemindersDocument = gql`
  query EsCardReminders($target: EsReminderTargetInput!, $subject: ID) {
    esCardReminders(target: $target, subject: $subject) {
      active {
        ...EsReminderScheduleFields
      }
      stopped {
        reminderId
        channel
        reason
        updatedAt
        target {
          kind
          ref
        }
        schedule {
          rrule
          dtstart
          tzid
          exdates
        }
        legacyBinding {
          collection
          key
          slot
        }
      }
      nextOccurrences {
        reminderId
        local
        utcIso
      }
    }
  }
  ${EsReminderScheduleFieldsFragmentDoc}
`;

/**
 * __useEsCardRemindersQuery__
 *
 * To run a query within a React component, call `useEsCardRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsCardRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsCardRemindersQuery({
 *   variables: {
 *      target: // value for 'target'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useEsCardRemindersQuery(
  baseOptions: Apollo.QueryHookOptions<
    EsCardRemindersQuery,
    EsCardRemindersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EsCardRemindersQuery, EsCardRemindersQueryVariables>(
    EsCardRemindersDocument,
    options,
  );
}
export function useEsCardRemindersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EsCardRemindersQuery,
    EsCardRemindersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EsCardRemindersQuery,
    EsCardRemindersQueryVariables
  >(EsCardRemindersDocument, options);
}
export type EsCardRemindersQueryHookResult = ReturnType<
  typeof useEsCardRemindersQuery
>;
export type EsCardRemindersLazyQueryHookResult = ReturnType<
  typeof useEsCardRemindersLazyQuery
>;
export type EsCardRemindersQueryResult = Apollo.QueryResult<
  EsCardRemindersQuery,
  EsCardRemindersQueryVariables
>;
export const SetReminderScheduleDocument = gql`
  mutation SetReminderSchedule(
    $reminderId: ID
    $target: EsReminderTargetInput!
    $schedule: EsReminderScheduleInput!
    $channel: String
    $subject: ID
  ) {
    setReminderSchedule(
      reminderId: $reminderId
      target: $target
      schedule: $schedule
      channel: $channel
      subject: $subject
    ) {
      success
      reminderId
      schedule {
        ...EsReminderScheduleFields
      }
    }
  }
  ${EsReminderScheduleFieldsFragmentDoc}
`;
export type SetReminderScheduleMutationFn = Apollo.MutationFunction<
  SetReminderScheduleMutation,
  SetReminderScheduleMutationVariables
>;

/**
 * __useSetReminderScheduleMutation__
 *
 * To run a mutation, you first call `useSetReminderScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReminderScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReminderScheduleMutation, { data, loading, error }] = useSetReminderScheduleMutation({
 *   variables: {
 *      reminderId: // value for 'reminderId'
 *      target: // value for 'target'
 *      schedule: // value for 'schedule'
 *      channel: // value for 'channel'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useSetReminderScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetReminderScheduleMutation,
    SetReminderScheduleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetReminderScheduleMutation,
    SetReminderScheduleMutationVariables
  >(SetReminderScheduleDocument, options);
}
export type SetReminderScheduleMutationHookResult = ReturnType<
  typeof useSetReminderScheduleMutation
>;
export type SetReminderScheduleMutationResult =
  Apollo.MutationResult<SetReminderScheduleMutation>;
export type SetReminderScheduleMutationOptions = Apollo.BaseMutationOptions<
  SetReminderScheduleMutation,
  SetReminderScheduleMutationVariables
>;
export const EndReminderScheduleDocument = gql`
  mutation EndReminderSchedule(
    $reminderId: ID!
    $reason: String!
    $subject: ID
  ) {
    endReminderSchedule(
      reminderId: $reminderId
      reason: $reason
      subject: $subject
    ) {
      success
      reminderId
    }
  }
`;
export type EndReminderScheduleMutationFn = Apollo.MutationFunction<
  EndReminderScheduleMutation,
  EndReminderScheduleMutationVariables
>;

/**
 * __useEndReminderScheduleMutation__
 *
 * To run a mutation, you first call `useEndReminderScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndReminderScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endReminderScheduleMutation, { data, loading, error }] = useEndReminderScheduleMutation({
 *   variables: {
 *      reminderId: // value for 'reminderId'
 *      reason: // value for 'reason'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useEndReminderScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EndReminderScheduleMutation,
    EndReminderScheduleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EndReminderScheduleMutation,
    EndReminderScheduleMutationVariables
  >(EndReminderScheduleDocument, options);
}
export type EndReminderScheduleMutationHookResult = ReturnType<
  typeof useEndReminderScheduleMutation
>;
export type EndReminderScheduleMutationResult =
  Apollo.MutationResult<EndReminderScheduleMutation>;
export type EndReminderScheduleMutationOptions = Apollo.BaseMutationOptions<
  EndReminderScheduleMutation,
  EndReminderScheduleMutationVariables
>;
export const SkipReminderOccurrenceDocument = gql`
  mutation SkipReminderOccurrence($reminderId: ID!, $occurrenceDate: String!) {
    skipReminderOccurrence(
      reminderId: $reminderId
      occurrenceDate: $occurrenceDate
    ) {
      success
      reminderId
    }
  }
`;
export type SkipReminderOccurrenceMutationFn = Apollo.MutationFunction<
  SkipReminderOccurrenceMutation,
  SkipReminderOccurrenceMutationVariables
>;

/**
 * __useSkipReminderOccurrenceMutation__
 *
 * To run a mutation, you first call `useSkipReminderOccurrenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipReminderOccurrenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipReminderOccurrenceMutation, { data, loading, error }] = useSkipReminderOccurrenceMutation({
 *   variables: {
 *      reminderId: // value for 'reminderId'
 *      occurrenceDate: // value for 'occurrenceDate'
 *   },
 * });
 */
export function useSkipReminderOccurrenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SkipReminderOccurrenceMutation,
    SkipReminderOccurrenceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SkipReminderOccurrenceMutation,
    SkipReminderOccurrenceMutationVariables
  >(SkipReminderOccurrenceDocument, options);
}
export type SkipReminderOccurrenceMutationHookResult = ReturnType<
  typeof useSkipReminderOccurrenceMutation
>;
export type SkipReminderOccurrenceMutationResult =
  Apollo.MutationResult<SkipReminderOccurrenceMutation>;
export type SkipReminderOccurrenceMutationOptions = Apollo.BaseMutationOptions<
  SkipReminderOccurrenceMutation,
  SkipReminderOccurrenceMutationVariables
>;
export const AdjustStoppedReminderScheduleDocument = gql`
  mutation AdjustStoppedReminderSchedule(
    $reminderId: ID!
    $schedule: EsReminderScheduleInput!
    $subject: ID
  ) {
    adjustStoppedReminderSchedule(
      reminderId: $reminderId
      schedule: $schedule
      subject: $subject
    ) {
      success
      reminderId
    }
  }
`;
export type AdjustStoppedReminderScheduleMutationFn = Apollo.MutationFunction<
  AdjustStoppedReminderScheduleMutation,
  AdjustStoppedReminderScheduleMutationVariables
>;

/**
 * __useAdjustStoppedReminderScheduleMutation__
 *
 * To run a mutation, you first call `useAdjustStoppedReminderScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdjustStoppedReminderScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adjustStoppedReminderScheduleMutation, { data, loading, error }] = useAdjustStoppedReminderScheduleMutation({
 *   variables: {
 *      reminderId: // value for 'reminderId'
 *      schedule: // value for 'schedule'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useAdjustStoppedReminderScheduleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdjustStoppedReminderScheduleMutation,
    AdjustStoppedReminderScheduleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdjustStoppedReminderScheduleMutation,
    AdjustStoppedReminderScheduleMutationVariables
  >(AdjustStoppedReminderScheduleDocument, options);
}
export type AdjustStoppedReminderScheduleMutationHookResult = ReturnType<
  typeof useAdjustStoppedReminderScheduleMutation
>;
export type AdjustStoppedReminderScheduleMutationResult =
  Apollo.MutationResult<AdjustStoppedReminderScheduleMutation>;
export type AdjustStoppedReminderScheduleMutationOptions =
  Apollo.BaseMutationOptions<
    AdjustStoppedReminderScheduleMutation,
    AdjustStoppedReminderScheduleMutationVariables
  >;
export const ExposuresDocument = gql`
  query Exposures($sort: String, $where: JSON, $start: Int, $limit: Int) {
    exposures(sort: $sort, where: $where, start: $start, limit: $limit) {
      data {
        _id
        ...ExposureData
      }
      count
    }
  }
  ${ExposureDataFragmentDoc}
`;

/**
 * __useExposuresQuery__
 *
 * To run a query within a React component, call `useExposuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useExposuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExposuresQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useExposuresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExposuresQuery,
    ExposuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExposuresQuery, ExposuresQueryVariables>(
    ExposuresDocument,
    options,
  );
}
export function useExposuresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExposuresQuery,
    ExposuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExposuresQuery, ExposuresQueryVariables>(
    ExposuresDocument,
    options,
  );
}
export type ExposuresQueryHookResult = ReturnType<typeof useExposuresQuery>;
export type ExposuresLazyQueryHookResult = ReturnType<
  typeof useExposuresLazyQuery
>;
export type ExposuresQueryResult = Apollo.QueryResult<
  ExposuresQuery,
  ExposuresQueryVariables
>;
export const ExposureDocument = gql`
  query Exposure($_id: ID) {
    exposure(_id: $_id) {
      _id
      ...ExposureData
    }
  }
  ${ExposureDataFragmentDoc}
`;

/**
 * __useExposureQuery__
 *
 * To run a query within a React component, call `useExposureQuery` and pass it any options that fit your needs.
 * When your component renders, `useExposureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExposureQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useExposureQuery(
  baseOptions?: Apollo.QueryHookOptions<ExposureQuery, ExposureQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExposureQuery, ExposureQueryVariables>(
    ExposureDocument,
    options,
  );
}
export function useExposureLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExposureQuery,
    ExposureQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ExposureQuery, ExposureQueryVariables>(
    ExposureDocument,
    options,
  );
}
export type ExposureQueryHookResult = ReturnType<typeof useExposureQuery>;
export type ExposureLazyQueryHookResult = ReturnType<
  typeof useExposureLazyQuery
>;
export type ExposureQueryResult = Apollo.QueryResult<
  ExposureQuery,
  ExposureQueryVariables
>;
export const UpsertExposureDocument = gql`
  mutation UpsertExposure($input: ExposureInput) {
    upsertExposure(input: $input) {
      _id
      ...ExposureData
    }
  }
  ${ExposureDataFragmentDoc}
`;
export type UpsertExposureMutationFn = Apollo.MutationFunction<
  UpsertExposureMutation,
  UpsertExposureMutationVariables
>;

/**
 * __useUpsertExposureMutation__
 *
 * To run a mutation, you first call `useUpsertExposureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertExposureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertExposureMutation, { data, loading, error }] = useUpsertExposureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertExposureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertExposureMutation,
    UpsertExposureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertExposureMutation,
    UpsertExposureMutationVariables
  >(UpsertExposureDocument, options);
}
export type UpsertExposureMutationHookResult = ReturnType<
  typeof useUpsertExposureMutation
>;
export type UpsertExposureMutationResult =
  Apollo.MutationResult<UpsertExposureMutation>;
export type UpsertExposureMutationOptions = Apollo.BaseMutationOptions<
  UpsertExposureMutation,
  UpsertExposureMutationVariables
>;
export const StartExpositionDocument = gql`
  mutation StartExposition($input: StartExpositionInput!) {
    startExposition(input: $input) {
      expositionId
      exposureStimulus {
        ...ExposureStimulusEsData
      }
    }
  }
  ${ExposureStimulusEsDataFragmentDoc}
`;
export type StartExpositionMutationFn = Apollo.MutationFunction<
  StartExpositionMutation,
  StartExpositionMutationVariables
>;

/**
 * __useStartExpositionMutation__
 *
 * To run a mutation, you first call `useStartExpositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartExpositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startExpositionMutation, { data, loading, error }] = useStartExpositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartExpositionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartExpositionMutation,
    StartExpositionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartExpositionMutation,
    StartExpositionMutationVariables
  >(StartExpositionDocument, options);
}
export type StartExpositionMutationHookResult = ReturnType<
  typeof useStartExpositionMutation
>;
export type StartExpositionMutationResult =
  Apollo.MutationResult<StartExpositionMutation>;
export type StartExpositionMutationOptions = Apollo.BaseMutationOptions<
  StartExpositionMutation,
  StartExpositionMutationVariables
>;
export const RecordExpositionReactionDocument = gql`
  mutation RecordExpositionReaction($input: RecordExpositionReactionInput!) {
    recordExpositionReaction(input: $input) {
      expositionId
      reactionId
      exposureStimulus {
        ...ExposureStimulusEsData
      }
    }
  }
  ${ExposureStimulusEsDataFragmentDoc}
`;
export type RecordExpositionReactionMutationFn = Apollo.MutationFunction<
  RecordExpositionReactionMutation,
  RecordExpositionReactionMutationVariables
>;

/**
 * __useRecordExpositionReactionMutation__
 *
 * To run a mutation, you first call `useRecordExpositionReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordExpositionReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordExpositionReactionMutation, { data, loading, error }] = useRecordExpositionReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordExpositionReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordExpositionReactionMutation,
    RecordExpositionReactionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordExpositionReactionMutation,
    RecordExpositionReactionMutationVariables
  >(RecordExpositionReactionDocument, options);
}
export type RecordExpositionReactionMutationHookResult = ReturnType<
  typeof useRecordExpositionReactionMutation
>;
export type RecordExpositionReactionMutationResult =
  Apollo.MutationResult<RecordExpositionReactionMutation>;
export type RecordExpositionReactionMutationOptions =
  Apollo.BaseMutationOptions<
    RecordExpositionReactionMutation,
    RecordExpositionReactionMutationVariables
  >;
export const FinishExpositionDocument = gql`
  mutation FinishExposition($input: FinishExpositionInput!) {
    finishExposition(input: $input) {
      expositionId
      exposureStimulus {
        ...ExposureStimulusEsData
      }
    }
  }
  ${ExposureStimulusEsDataFragmentDoc}
`;
export type FinishExpositionMutationFn = Apollo.MutationFunction<
  FinishExpositionMutation,
  FinishExpositionMutationVariables
>;

/**
 * __useFinishExpositionMutation__
 *
 * To run a mutation, you first call `useFinishExpositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishExpositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishExpositionMutation, { data, loading, error }] = useFinishExpositionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinishExpositionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FinishExpositionMutation,
    FinishExpositionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FinishExpositionMutation,
    FinishExpositionMutationVariables
  >(FinishExpositionDocument, options);
}
export type FinishExpositionMutationHookResult = ReturnType<
  typeof useFinishExpositionMutation
>;
export type FinishExpositionMutationResult =
  Apollo.MutationResult<FinishExpositionMutation>;
export type FinishExpositionMutationOptions = Apollo.BaseMutationOptions<
  FinishExpositionMutation,
  FinishExpositionMutationVariables
>;
export const AmendExpositionReactionDocument = gql`
  mutation AmendExpositionReaction($input: AmendExpositionReactionInput!) {
    amendExpositionReaction(input: $input) {
      expositionId
      reactionId
      exposureStimulus {
        ...ExposureStimulusEsData
      }
    }
  }
  ${ExposureStimulusEsDataFragmentDoc}
`;
export type AmendExpositionReactionMutationFn = Apollo.MutationFunction<
  AmendExpositionReactionMutation,
  AmendExpositionReactionMutationVariables
>;

/**
 * __useAmendExpositionReactionMutation__
 *
 * To run a mutation, you first call `useAmendExpositionReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAmendExpositionReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [amendExpositionReactionMutation, { data, loading, error }] = useAmendExpositionReactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAmendExpositionReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AmendExpositionReactionMutation,
    AmendExpositionReactionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AmendExpositionReactionMutation,
    AmendExpositionReactionMutationVariables
  >(AmendExpositionReactionDocument, options);
}
export type AmendExpositionReactionMutationHookResult = ReturnType<
  typeof useAmendExpositionReactionMutation
>;
export type AmendExpositionReactionMutationResult =
  Apollo.MutationResult<AmendExpositionReactionMutation>;
export type AmendExpositionReactionMutationOptions = Apollo.BaseMutationOptions<
  AmendExpositionReactionMutation,
  AmendExpositionReactionMutationVariables
>;
export const ExposureStimuliDocument = gql`
  query ExposureStimuli($sort: String, $where: JSON, $start: Int, $limit: Int) {
    exposureStimuli(sort: $sort, where: $where, start: $start, limit: $limit) {
      data {
        _id
        ...ExposureStimulusData
      }
      count
    }
  }
  ${ExposureStimulusDataFragmentDoc}
`;

/**
 * __useExposureStimuliQuery__
 *
 * To run a query within a React component, call `useExposureStimuliQuery` and pass it any options that fit your needs.
 * When your component renders, `useExposureStimuliQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExposureStimuliQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useExposureStimuliQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExposureStimuliQuery,
    ExposureStimuliQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExposureStimuliQuery, ExposureStimuliQueryVariables>(
    ExposureStimuliDocument,
    options,
  );
}
export function useExposureStimuliLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExposureStimuliQuery,
    ExposureStimuliQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExposureStimuliQuery,
    ExposureStimuliQueryVariables
  >(ExposureStimuliDocument, options);
}
export type ExposureStimuliQueryHookResult = ReturnType<
  typeof useExposureStimuliQuery
>;
export type ExposureStimuliLazyQueryHookResult = ReturnType<
  typeof useExposureStimuliLazyQuery
>;
export type ExposureStimuliQueryResult = Apollo.QueryResult<
  ExposureStimuliQuery,
  ExposureStimuliQueryVariables
>;
export const ExposureStimulusDocument = gql`
  query ExposureStimulus($_id: ID) {
    exposureStimulus(_id: $_id) {
      _id
      ...ExposureStimulusData
    }
  }
  ${ExposureStimulusDataFragmentDoc}
`;

/**
 * __useExposureStimulusQuery__
 *
 * To run a query within a React component, call `useExposureStimulusQuery` and pass it any options that fit your needs.
 * When your component renders, `useExposureStimulusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExposureStimulusQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useExposureStimulusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ExposureStimulusQuery,
    ExposureStimulusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ExposureStimulusQuery, ExposureStimulusQueryVariables>(
    ExposureStimulusDocument,
    options,
  );
}
export function useExposureStimulusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExposureStimulusQuery,
    ExposureStimulusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExposureStimulusQuery,
    ExposureStimulusQueryVariables
  >(ExposureStimulusDocument, options);
}
export type ExposureStimulusQueryHookResult = ReturnType<
  typeof useExposureStimulusQuery
>;
export type ExposureStimulusLazyQueryHookResult = ReturnType<
  typeof useExposureStimulusLazyQuery
>;
export type ExposureStimulusQueryResult = Apollo.QueryResult<
  ExposureStimulusQuery,
  ExposureStimulusQueryVariables
>;
export const UpsertExposureStimulusDocument = gql`
  mutation UpsertExposureStimulus($input: ExposureStimulusInput) {
    upsertExposureStimulus(input: $input) {
      _id
      ...ExposureStimulusData
    }
  }
  ${ExposureStimulusDataFragmentDoc}
`;
export type UpsertExposureStimulusMutationFn = Apollo.MutationFunction<
  UpsertExposureStimulusMutation,
  UpsertExposureStimulusMutationVariables
>;

/**
 * __useUpsertExposureStimulusMutation__
 *
 * To run a mutation, you first call `useUpsertExposureStimulusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertExposureStimulusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertExposureStimulusMutation, { data, loading, error }] = useUpsertExposureStimulusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertExposureStimulusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertExposureStimulusMutation,
    UpsertExposureStimulusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertExposureStimulusMutation,
    UpsertExposureStimulusMutationVariables
  >(UpsertExposureStimulusDocument, options);
}
export type UpsertExposureStimulusMutationHookResult = ReturnType<
  typeof useUpsertExposureStimulusMutation
>;
export type UpsertExposureStimulusMutationResult =
  Apollo.MutationResult<UpsertExposureStimulusMutation>;
export type UpsertExposureStimulusMutationOptions = Apollo.BaseMutationOptions<
  UpsertExposureStimulusMutation,
  UpsertExposureStimulusMutationVariables
>;
export const UpdateExposureStimuliDocument = gql`
  mutation UpdateExposureStimuli($input: UpdateExposureStimuliInput) {
    updateExposureStimuli(input: $input) {
      _id
      ...ExposureStimulusData
    }
  }
  ${ExposureStimulusDataFragmentDoc}
`;
export type UpdateExposureStimuliMutationFn = Apollo.MutationFunction<
  UpdateExposureStimuliMutation,
  UpdateExposureStimuliMutationVariables
>;

/**
 * __useUpdateExposureStimuliMutation__
 *
 * To run a mutation, you first call `useUpdateExposureStimuliMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExposureStimuliMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExposureStimuliMutation, { data, loading, error }] = useUpdateExposureStimuliMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExposureStimuliMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateExposureStimuliMutation,
    UpdateExposureStimuliMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateExposureStimuliMutation,
    UpdateExposureStimuliMutationVariables
  >(UpdateExposureStimuliDocument, options);
}
export type UpdateExposureStimuliMutationHookResult = ReturnType<
  typeof useUpdateExposureStimuliMutation
>;
export type UpdateExposureStimuliMutationResult =
  Apollo.MutationResult<UpdateExposureStimuliMutation>;
export type UpdateExposureStimuliMutationOptions = Apollo.BaseMutationOptions<
  UpdateExposureStimuliMutation,
  UpdateExposureStimuliMutationVariables
>;
export const DeleteExposureStimulusDocument = gql`
  mutation DeleteExposureStimulus($input: deleteExposureStimulusInput) {
    deleteExposureStimulus(input: $input) {
      _id
      ...ExposureStimulusData
    }
  }
  ${ExposureStimulusDataFragmentDoc}
`;
export type DeleteExposureStimulusMutationFn = Apollo.MutationFunction<
  DeleteExposureStimulusMutation,
  DeleteExposureStimulusMutationVariables
>;

/**
 * __useDeleteExposureStimulusMutation__
 *
 * To run a mutation, you first call `useDeleteExposureStimulusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExposureStimulusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExposureStimulusMutation, { data, loading, error }] = useDeleteExposureStimulusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteExposureStimulusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteExposureStimulusMutation,
    DeleteExposureStimulusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteExposureStimulusMutation,
    DeleteExposureStimulusMutationVariables
  >(DeleteExposureStimulusDocument, options);
}
export type DeleteExposureStimulusMutationHookResult = ReturnType<
  typeof useDeleteExposureStimulusMutation
>;
export type DeleteExposureStimulusMutationResult =
  Apollo.MutationResult<DeleteExposureStimulusMutation>;
export type DeleteExposureStimulusMutationOptions = Apollo.BaseMutationOptions<
  DeleteExposureStimulusMutation,
  DeleteExposureStimulusMutationVariables
>;
export const GenerateDalleImageDocument = gql`
  mutation GenerateDalleImage(
    $content: String!
    $lng: String!
    $exposureId: ID
  ) {
    generateDalleImage(content: $content, lng: $lng, exposureId: $exposureId) {
      contentUrl
      status
      errorMessage
      code
    }
  }
`;
export type GenerateDalleImageMutationFn = Apollo.MutationFunction<
  GenerateDalleImageMutation,
  GenerateDalleImageMutationVariables
>;

/**
 * __useGenerateDalleImageMutation__
 *
 * To run a mutation, you first call `useGenerateDalleImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDalleImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDalleImageMutation, { data, loading, error }] = useGenerateDalleImageMutation({
 *   variables: {
 *      content: // value for 'content'
 *      lng: // value for 'lng'
 *      exposureId: // value for 'exposureId'
 *   },
 * });
 */
export function useGenerateDalleImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GenerateDalleImageMutation,
    GenerateDalleImageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GenerateDalleImageMutation,
    GenerateDalleImageMutationVariables
  >(GenerateDalleImageDocument, options);
}
export type GenerateDalleImageMutationHookResult = ReturnType<
  typeof useGenerateDalleImageMutation
>;
export type GenerateDalleImageMutationResult =
  Apollo.MutationResult<GenerateDalleImageMutation>;
export type GenerateDalleImageMutationOptions = Apollo.BaseMutationOptions<
  GenerateDalleImageMutation,
  GenerateDalleImageMutationVariables
>;
export const UpdateExposureStimulusDocument = gql`
  mutation UpdateExposureStimulus($id: ID!, $data: ExposureStimulusInputData!) {
    updateExposureStimulus(id: $id, data: $data) {
      _id
      ...ExposureStimulusData
    }
  }
  ${ExposureStimulusDataFragmentDoc}
`;
export type UpdateExposureStimulusMutationFn = Apollo.MutationFunction<
  UpdateExposureStimulusMutation,
  UpdateExposureStimulusMutationVariables
>;

/**
 * __useUpdateExposureStimulusMutation__
 *
 * To run a mutation, you first call `useUpdateExposureStimulusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExposureStimulusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExposureStimulusMutation, { data, loading, error }] = useUpdateExposureStimulusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateExposureStimulusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateExposureStimulusMutation,
    UpdateExposureStimulusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateExposureStimulusMutation,
    UpdateExposureStimulusMutationVariables
  >(UpdateExposureStimulusDocument, options);
}
export type UpdateExposureStimulusMutationHookResult = ReturnType<
  typeof useUpdateExposureStimulusMutation
>;
export type UpdateExposureStimulusMutationResult =
  Apollo.MutationResult<UpdateExposureStimulusMutation>;
export type UpdateExposureStimulusMutationOptions = Apollo.BaseMutationOptions<
  UpdateExposureStimulusMutation,
  UpdateExposureStimulusMutationVariables
>;
export const SetTargetBehaviorDocument = gql`
  mutation SetTargetBehavior($input: SetTargetBehaviorInput!) {
    setTargetBehavior(input: $input) {
      id
      recorded
    }
  }
`;
export type SetTargetBehaviorMutationFn = Apollo.MutationFunction<
  SetTargetBehaviorMutation,
  SetTargetBehaviorMutationVariables
>;

/**
 * __useSetTargetBehaviorMutation__
 *
 * To run a mutation, you first call `useSetTargetBehaviorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTargetBehaviorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTargetBehaviorMutation, { data, loading, error }] = useSetTargetBehaviorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTargetBehaviorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetTargetBehaviorMutation,
    SetTargetBehaviorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetTargetBehaviorMutation,
    SetTargetBehaviorMutationVariables
  >(SetTargetBehaviorDocument, options);
}
export type SetTargetBehaviorMutationHookResult = ReturnType<
  typeof useSetTargetBehaviorMutation
>;
export type SetTargetBehaviorMutationResult =
  Apollo.MutationResult<SetTargetBehaviorMutation>;
export type SetTargetBehaviorMutationOptions = Apollo.BaseMutationOptions<
  SetTargetBehaviorMutation,
  SetTargetBehaviorMutationVariables
>;
export const RetireTargetBehaviorDocument = gql`
  mutation RetireTargetBehavior($input: RetireTargetBehaviorInput!) {
    retireTargetBehavior(input: $input) {
      id
      recorded
    }
  }
`;
export type RetireTargetBehaviorMutationFn = Apollo.MutationFunction<
  RetireTargetBehaviorMutation,
  RetireTargetBehaviorMutationVariables
>;

/**
 * __useRetireTargetBehaviorMutation__
 *
 * To run a mutation, you first call `useRetireTargetBehaviorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetireTargetBehaviorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retireTargetBehaviorMutation, { data, loading, error }] = useRetireTargetBehaviorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetireTargetBehaviorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetireTargetBehaviorMutation,
    RetireTargetBehaviorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetireTargetBehaviorMutation,
    RetireTargetBehaviorMutationVariables
  >(RetireTargetBehaviorDocument, options);
}
export type RetireTargetBehaviorMutationHookResult = ReturnType<
  typeof useRetireTargetBehaviorMutation
>;
export type RetireTargetBehaviorMutationResult =
  Apollo.MutationResult<RetireTargetBehaviorMutation>;
export type RetireTargetBehaviorMutationOptions = Apollo.BaseMutationOptions<
  RetireTargetBehaviorMutation,
  RetireTargetBehaviorMutationVariables
>;
export const RecordBehaviorInstanceDocument = gql`
  mutation RecordBehaviorInstance($input: RecordBehaviorInstanceInput!) {
    recordBehaviorInstance(input: $input) {
      id
      recorded
    }
  }
`;
export type RecordBehaviorInstanceMutationFn = Apollo.MutationFunction<
  RecordBehaviorInstanceMutation,
  RecordBehaviorInstanceMutationVariables
>;

/**
 * __useRecordBehaviorInstanceMutation__
 *
 * To run a mutation, you first call `useRecordBehaviorInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordBehaviorInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordBehaviorInstanceMutation, { data, loading, error }] = useRecordBehaviorInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordBehaviorInstanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordBehaviorInstanceMutation,
    RecordBehaviorInstanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordBehaviorInstanceMutation,
    RecordBehaviorInstanceMutationVariables
  >(RecordBehaviorInstanceDocument, options);
}
export type RecordBehaviorInstanceMutationHookResult = ReturnType<
  typeof useRecordBehaviorInstanceMutation
>;
export type RecordBehaviorInstanceMutationResult =
  Apollo.MutationResult<RecordBehaviorInstanceMutation>;
export type RecordBehaviorInstanceMutationOptions = Apollo.BaseMutationOptions<
  RecordBehaviorInstanceMutation,
  RecordBehaviorInstanceMutationVariables
>;
export const PlanContingencyChangeDocument = gql`
  mutation PlanContingencyChange($input: PlanContingencyChangeInput!) {
    planContingencyChange(input: $input) {
      id
      recorded
    }
  }
`;
export type PlanContingencyChangeMutationFn = Apollo.MutationFunction<
  PlanContingencyChangeMutation,
  PlanContingencyChangeMutationVariables
>;

/**
 * __usePlanContingencyChangeMutation__
 *
 * To run a mutation, you first call `usePlanContingencyChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlanContingencyChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [planContingencyChangeMutation, { data, loading, error }] = usePlanContingencyChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlanContingencyChangeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PlanContingencyChangeMutation,
    PlanContingencyChangeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PlanContingencyChangeMutation,
    PlanContingencyChangeMutationVariables
  >(PlanContingencyChangeDocument, options);
}
export type PlanContingencyChangeMutationHookResult = ReturnType<
  typeof usePlanContingencyChangeMutation
>;
export type PlanContingencyChangeMutationResult =
  Apollo.MutationResult<PlanContingencyChangeMutation>;
export type PlanContingencyChangeMutationOptions = Apollo.BaseMutationOptions<
  PlanContingencyChangeMutation,
  PlanContingencyChangeMutationVariables
>;
export const MarkChangeDayDocument = gql`
  mutation MarkChangeDay($input: MarkChangeDayInput!) {
    markChangeDay(input: $input) {
      id
      recorded
    }
  }
`;
export type MarkChangeDayMutationFn = Apollo.MutationFunction<
  MarkChangeDayMutation,
  MarkChangeDayMutationVariables
>;

/**
 * __useMarkChangeDayMutation__
 *
 * To run a mutation, you first call `useMarkChangeDayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkChangeDayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markChangeDayMutation, { data, loading, error }] = useMarkChangeDayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkChangeDayMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkChangeDayMutation,
    MarkChangeDayMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkChangeDayMutation,
    MarkChangeDayMutationVariables
  >(MarkChangeDayDocument, options);
}
export type MarkChangeDayMutationHookResult = ReturnType<
  typeof useMarkChangeDayMutation
>;
export type MarkChangeDayMutationResult =
  Apollo.MutationResult<MarkChangeDayMutation>;
export type MarkChangeDayMutationOptions = Apollo.BaseMutationOptions<
  MarkChangeDayMutation,
  MarkChangeDayMutationVariables
>;
export const MyTargetBehaviorsDocument = gql`
  query MyTargetBehaviors($timeZone: String) {
    myTargetBehaviors(timeZone: $timeZone) {
      subject
      today
      targets {
        targetId
        name
        description
        measure
        addedByMe
        canClose
        records
        threshold
        stage
        thisWeek {
          done
          urgeOnly
          urgeMax
        }
        days {
          ...FaDayFields
        }
        instances {
          happenedAt
          didBehavior
          urge
        }
        change {
          changeId
          whatChanges
          expectedEffect
          startsOn
          byMe
          started
          doneDays {
            yes
            partly
            no
          }
          markedDays
          today
        }
        mostMarked {
          ...FaIdeaFields
        }
      }
    }
  }
  ${FaDayFieldsFragmentDoc}
  ${FaIdeaFieldsFragmentDoc}
`;

/**
 * __useMyTargetBehaviorsQuery__
 *
 * To run a query within a React component, call `useMyTargetBehaviorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTargetBehaviorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTargetBehaviorsQuery({
 *   variables: {
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useMyTargetBehaviorsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyTargetBehaviorsQuery,
    MyTargetBehaviorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MyTargetBehaviorsQuery,
    MyTargetBehaviorsQueryVariables
  >(MyTargetBehaviorsDocument, options);
}
export function useMyTargetBehaviorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyTargetBehaviorsQuery,
    MyTargetBehaviorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MyTargetBehaviorsQuery,
    MyTargetBehaviorsQueryVariables
  >(MyTargetBehaviorsDocument, options);
}
export type MyTargetBehaviorsQueryHookResult = ReturnType<
  typeof useMyTargetBehaviorsQuery
>;
export type MyTargetBehaviorsLazyQueryHookResult = ReturnType<
  typeof useMyTargetBehaviorsLazyQuery
>;
export type MyTargetBehaviorsQueryResult = Apollo.QueryResult<
  MyTargetBehaviorsQuery,
  MyTargetBehaviorsQueryVariables
>;
export const WhatINoticedDocument = gql`
  query WhatINoticed($targetId: ID!, $timeZone: String) {
    whatINoticed(targetId: $targetId, timeZone: $timeZone) {
      targetId
      subject
      name
      records
      threshold
      enough
      promptingEvents {
        ...FaCountedFields
      }
      vulnerabilities {
        ...FaCountedFields
      }
      links {
        event {
          ...FaCountedFields
        }
        thought {
          ...FaCountedFields
        }
        feeling {
          ...FaCountedFields
        }
        body {
          ...FaCountedFields
        }
        action {
          ...FaCountedFields
        }
      }
      rightAway {
        ...FaCountedFields
      }
      later {
        ...FaCountedFields
      }
      nextTime {
        ...FaIdeaFields
      }
      suggestion {
        ...FaIdeaFields
      }
    }
  }
  ${FaCountedFieldsFragmentDoc}
  ${FaIdeaFieldsFragmentDoc}
`;

/**
 * __useWhatINoticedQuery__
 *
 * To run a query within a React component, call `useWhatINoticedQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhatINoticedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhatINoticedQuery({
 *   variables: {
 *      targetId: // value for 'targetId'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useWhatINoticedQuery(
  baseOptions: Apollo.QueryHookOptions<
    WhatINoticedQuery,
    WhatINoticedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WhatINoticedQuery, WhatINoticedQueryVariables>(
    WhatINoticedDocument,
    options,
  );
}
export function useWhatINoticedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WhatINoticedQuery,
    WhatINoticedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WhatINoticedQuery, WhatINoticedQueryVariables>(
    WhatINoticedDocument,
    options,
  );
}
export type WhatINoticedQueryHookResult = ReturnType<
  typeof useWhatINoticedQuery
>;
export type WhatINoticedLazyQueryHookResult = ReturnType<
  typeof useWhatINoticedLazyQuery
>;
export type WhatINoticedQueryResult = Apollo.QueryResult<
  WhatINoticedQuery,
  WhatINoticedQueryVariables
>;
export const ClientTargetBehaviorsDocument = gql`
  query ClientTargetBehaviors($subject: ID!) {
    clientTargetBehaviors(subject: $subject) {
      targetId
      name
      measure
      functionHypotheses
      addedByClient
      retired
      records
      threshold
      changes
    }
  }
`;

/**
 * __useClientTargetBehaviorsQuery__
 *
 * To run a query within a React component, call `useClientTargetBehaviorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientTargetBehaviorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientTargetBehaviorsQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useClientTargetBehaviorsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientTargetBehaviorsQuery,
    ClientTargetBehaviorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientTargetBehaviorsQuery,
    ClientTargetBehaviorsQueryVariables
  >(ClientTargetBehaviorsDocument, options);
}
export function useClientTargetBehaviorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientTargetBehaviorsQuery,
    ClientTargetBehaviorsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientTargetBehaviorsQuery,
    ClientTargetBehaviorsQueryVariables
  >(ClientTargetBehaviorsDocument, options);
}
export type ClientTargetBehaviorsQueryHookResult = ReturnType<
  typeof useClientTargetBehaviorsQuery
>;
export type ClientTargetBehaviorsLazyQueryHookResult = ReturnType<
  typeof useClientTargetBehaviorsLazyQuery
>;
export type ClientTargetBehaviorsQueryResult = Apollo.QueryResult<
  ClientTargetBehaviorsQuery,
  ClientTargetBehaviorsQueryVariables
>;
export const FunctionalAnalysisSummaryDocument = gql`
  query FunctionalAnalysisSummary(
    $subject: ID!
    $targetId: ID!
    $timeZone: String
  ) {
    functionalAnalysisSummary(
      subject: $subject
      targetId: $targetId
      timeZone: $timeZone
    ) {
      subject
      targetId
      target {
        name
        description
        measure
        functionHypotheses
        baselineWeeks
        addedByClient
        retired
        retiredReason
      }
      records
      threshold
      enough
      chains
      urgesOnly
      periods {
        kind
        changeId
        from
        to
        weeks {
          weekStart
          done
          urgeOnly
          meanUrge
        }
        totals {
          days
          done
          urgeOnly
          meanUrge
          perWeek
        }
        changeDays {
          yes
          partly
          no
          marked
        }
      }
      changes {
        changeId
        whatChanges
        expectedEffect
        startsOn
        byClient
        doneDays {
          yes
          partly
          no
        }
        markedDays
      }
      days {
        ...FaDayFields
      }
      recurring {
        ...FaRecurringFields
      }
      suggestion {
        ...FaIdeaFields
      }
    }
  }
  ${FaDayFieldsFragmentDoc}
  ${FaRecurringFieldsFragmentDoc}
  ${FaIdeaFieldsFragmentDoc}
`;

/**
 * __useFunctionalAnalysisSummaryQuery__
 *
 * To run a query within a React component, call `useFunctionalAnalysisSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFunctionalAnalysisSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFunctionalAnalysisSummaryQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      targetId: // value for 'targetId'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useFunctionalAnalysisSummaryQuery(
  baseOptions: Apollo.QueryHookOptions<
    FunctionalAnalysisSummaryQuery,
    FunctionalAnalysisSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FunctionalAnalysisSummaryQuery,
    FunctionalAnalysisSummaryQueryVariables
  >(FunctionalAnalysisSummaryDocument, options);
}
export function useFunctionalAnalysisSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FunctionalAnalysisSummaryQuery,
    FunctionalAnalysisSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FunctionalAnalysisSummaryQuery,
    FunctionalAnalysisSummaryQueryVariables
  >(FunctionalAnalysisSummaryDocument, options);
}
export type FunctionalAnalysisSummaryQueryHookResult = ReturnType<
  typeof useFunctionalAnalysisSummaryQuery
>;
export type FunctionalAnalysisSummaryLazyQueryHookResult = ReturnType<
  typeof useFunctionalAnalysisSummaryLazyQuery
>;
export type FunctionalAnalysisSummaryQueryResult = Apollo.QueryResult<
  FunctionalAnalysisSummaryQuery,
  FunctionalAnalysisSummaryQueryVariables
>;
export const HealthDataAccessDocument = gql`
  query HealthDataAccess {
    healthDataAccess {
      subject
      connected
      source
      sharedTypes
      lastNight
      lastDay
      lastHeartRateDay
      lastImportedAt
      deleteImported
      types {
        type
        shared
        since
        lastNight
        lastDay
      }
    }
  }
`;

/**
 * __useHealthDataAccessQuery__
 *
 * To run a query within a React component, call `useHealthDataAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthDataAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthDataAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useHealthDataAccessQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HealthDataAccessQuery,
    HealthDataAccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HealthDataAccessQuery, HealthDataAccessQueryVariables>(
    HealthDataAccessDocument,
    options,
  );
}
export function useHealthDataAccessLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HealthDataAccessQuery,
    HealthDataAccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HealthDataAccessQuery,
    HealthDataAccessQueryVariables
  >(HealthDataAccessDocument, options);
}
export type HealthDataAccessQueryHookResult = ReturnType<
  typeof useHealthDataAccessQuery
>;
export type HealthDataAccessLazyQueryHookResult = ReturnType<
  typeof useHealthDataAccessLazyQuery
>;
export type HealthDataAccessQueryResult = Apollo.QueryResult<
  HealthDataAccessQuery,
  HealthDataAccessQueryVariables
>;
export const GrantHealthDataAccessDocument = gql`
  mutation GrantHealthDataAccess($input: GrantHealthDataAccessInput!) {
    grantHealthDataAccess(input: $input) {
      recorded
    }
  }
`;
export type GrantHealthDataAccessMutationFn = Apollo.MutationFunction<
  GrantHealthDataAccessMutation,
  GrantHealthDataAccessMutationVariables
>;

/**
 * __useGrantHealthDataAccessMutation__
 *
 * To run a mutation, you first call `useGrantHealthDataAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantHealthDataAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantHealthDataAccessMutation, { data, loading, error }] = useGrantHealthDataAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGrantHealthDataAccessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GrantHealthDataAccessMutation,
    GrantHealthDataAccessMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GrantHealthDataAccessMutation,
    GrantHealthDataAccessMutationVariables
  >(GrantHealthDataAccessDocument, options);
}
export type GrantHealthDataAccessMutationHookResult = ReturnType<
  typeof useGrantHealthDataAccessMutation
>;
export type GrantHealthDataAccessMutationResult =
  Apollo.MutationResult<GrantHealthDataAccessMutation>;
export type GrantHealthDataAccessMutationOptions = Apollo.BaseMutationOptions<
  GrantHealthDataAccessMutation,
  GrantHealthDataAccessMutationVariables
>;
export const RevokeHealthDataAccessDocument = gql`
  mutation RevokeHealthDataAccess($input: RevokeHealthDataAccessInput!) {
    revokeHealthDataAccess(input: $input) {
      recorded
    }
  }
`;
export type RevokeHealthDataAccessMutationFn = Apollo.MutationFunction<
  RevokeHealthDataAccessMutation,
  RevokeHealthDataAccessMutationVariables
>;

/**
 * __useRevokeHealthDataAccessMutation__
 *
 * To run a mutation, you first call `useRevokeHealthDataAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeHealthDataAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeHealthDataAccessMutation, { data, loading, error }] = useRevokeHealthDataAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevokeHealthDataAccessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevokeHealthDataAccessMutation,
    RevokeHealthDataAccessMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevokeHealthDataAccessMutation,
    RevokeHealthDataAccessMutationVariables
  >(RevokeHealthDataAccessDocument, options);
}
export type RevokeHealthDataAccessMutationHookResult = ReturnType<
  typeof useRevokeHealthDataAccessMutation
>;
export type RevokeHealthDataAccessMutationResult =
  Apollo.MutationResult<RevokeHealthDataAccessMutation>;
export type RevokeHealthDataAccessMutationOptions = Apollo.BaseMutationOptions<
  RevokeHealthDataAccessMutation,
  RevokeHealthDataAccessMutationVariables
>;
export const RequestHealthReadDocument = gql`
  mutation RequestHealthRead($input: RequestHealthReadInput!) {
    requestHealthRead(input: $input) {
      recorded
    }
  }
`;
export type RequestHealthReadMutationFn = Apollo.MutationFunction<
  RequestHealthReadMutation,
  RequestHealthReadMutationVariables
>;

/**
 * __useRequestHealthReadMutation__
 *
 * To run a mutation, you first call `useRequestHealthReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestHealthReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestHealthReadMutation, { data, loading, error }] = useRequestHealthReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestHealthReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestHealthReadMutation,
    RequestHealthReadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestHealthReadMutation,
    RequestHealthReadMutationVariables
  >(RequestHealthReadDocument, options);
}
export type RequestHealthReadMutationHookResult = ReturnType<
  typeof useRequestHealthReadMutation
>;
export type RequestHealthReadMutationResult =
  Apollo.MutationResult<RequestHealthReadMutation>;
export type RequestHealthReadMutationOptions = Apollo.BaseMutationOptions<
  RequestHealthReadMutation,
  RequestHealthReadMutationVariables
>;
export const TranslateHealthSummariesDocument = gql`
  mutation TranslateHealthSummaries($input: TranslateHealthSummariesInput!) {
    translateHealthSummaries(input: $input) {
      recorded
    }
  }
`;
export type TranslateHealthSummariesMutationFn = Apollo.MutationFunction<
  TranslateHealthSummariesMutation,
  TranslateHealthSummariesMutationVariables
>;

/**
 * __useTranslateHealthSummariesMutation__
 *
 * To run a mutation, you first call `useTranslateHealthSummariesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTranslateHealthSummariesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [translateHealthSummariesMutation, { data, loading, error }] = useTranslateHealthSummariesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTranslateHealthSummariesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TranslateHealthSummariesMutation,
    TranslateHealthSummariesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TranslateHealthSummariesMutation,
    TranslateHealthSummariesMutationVariables
  >(TranslateHealthSummariesDocument, options);
}
export type TranslateHealthSummariesMutationHookResult = ReturnType<
  typeof useTranslateHealthSummariesMutation
>;
export type TranslateHealthSummariesMutationResult =
  Apollo.MutationResult<TranslateHealthSummariesMutation>;
export type TranslateHealthSummariesMutationOptions =
  Apollo.BaseMutationOptions<
    TranslateHealthSummariesMutation,
    TranslateHealthSummariesMutationVariables
  >;
export const ClientSleepSummaryDocument = gql`
  query ClientSleepSummary($days: Int, $timeZone: String) {
    clientSleepSummary(days: $days, timeZone: $timeZone) {
      subject
      days
      averageAsleepMinutes
      averageEfficiency
      nights {
        ...ClientSleepNightFields
      }
    }
  }
  ${ClientSleepNightFieldsFragmentDoc}
`;

/**
 * __useClientSleepSummaryQuery__
 *
 * To run a query within a React component, call `useClientSleepSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientSleepSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientSleepSummaryQuery({
 *   variables: {
 *      days: // value for 'days'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useClientSleepSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ClientSleepSummaryQuery,
    ClientSleepSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientSleepSummaryQuery,
    ClientSleepSummaryQueryVariables
  >(ClientSleepSummaryDocument, options);
}
export function useClientSleepSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientSleepSummaryQuery,
    ClientSleepSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientSleepSummaryQuery,
    ClientSleepSummaryQueryVariables
  >(ClientSleepSummaryDocument, options);
}
export type ClientSleepSummaryQueryHookResult = ReturnType<
  typeof useClientSleepSummaryQuery
>;
export type ClientSleepSummaryLazyQueryHookResult = ReturnType<
  typeof useClientSleepSummaryLazyQuery
>;
export type ClientSleepSummaryQueryResult = Apollo.QueryResult<
  ClientSleepSummaryQuery,
  ClientSleepSummaryQueryVariables
>;
export const ClientActivitySummaryDocument = gql`
  query ClientActivitySummary($days: Int, $timeZone: String) {
    clientActivitySummary(days: $days, timeZone: $timeZone) {
      subject
      days
      averageSteps
      averageActiveMinutes
      activityDays {
        ...ClientActivityDayFields
      }
    }
  }
  ${ClientActivityDayFieldsFragmentDoc}
`;

/**
 * __useClientActivitySummaryQuery__
 *
 * To run a query within a React component, call `useClientActivitySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientActivitySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientActivitySummaryQuery({
 *   variables: {
 *      days: // value for 'days'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useClientActivitySummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ClientActivitySummaryQuery,
    ClientActivitySummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientActivitySummaryQuery,
    ClientActivitySummaryQueryVariables
  >(ClientActivitySummaryDocument, options);
}
export function useClientActivitySummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientActivitySummaryQuery,
    ClientActivitySummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientActivitySummaryQuery,
    ClientActivitySummaryQueryVariables
  >(ClientActivitySummaryDocument, options);
}
export type ClientActivitySummaryQueryHookResult = ReturnType<
  typeof useClientActivitySummaryQuery
>;
export type ClientActivitySummaryLazyQueryHookResult = ReturnType<
  typeof useClientActivitySummaryLazyQuery
>;
export type ClientActivitySummaryQueryResult = Apollo.QueryResult<
  ClientActivitySummaryQuery,
  ClientActivitySummaryQueryVariables
>;
export const ClientHeartSummaryDocument = gql`
  query ClientHeartSummary($days: Int, $timeZone: String) {
    clientHeartSummary(days: $days, timeZone: $timeZone) {
      subject
      days
      averageRestingHeartRate
      heartRateDays {
        ...ClientHeartRateDayFields
      }
    }
  }
  ${ClientHeartRateDayFieldsFragmentDoc}
`;

/**
 * __useClientHeartSummaryQuery__
 *
 * To run a query within a React component, call `useClientHeartSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientHeartSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientHeartSummaryQuery({
 *   variables: {
 *      days: // value for 'days'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useClientHeartSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ClientHeartSummaryQuery,
    ClientHeartSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientHeartSummaryQuery,
    ClientHeartSummaryQueryVariables
  >(ClientHeartSummaryDocument, options);
}
export function useClientHeartSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientHeartSummaryQuery,
    ClientHeartSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientHeartSummaryQuery,
    ClientHeartSummaryQueryVariables
  >(ClientHeartSummaryDocument, options);
}
export type ClientHeartSummaryQueryHookResult = ReturnType<
  typeof useClientHeartSummaryQuery
>;
export type ClientHeartSummaryLazyQueryHookResult = ReturnType<
  typeof useClientHeartSummaryLazyQuery
>;
export type ClientHeartSummaryQueryResult = Apollo.QueryResult<
  ClientHeartSummaryQuery,
  ClientHeartSummaryQueryVariables
>;
export const HealthDataSharingDocument = gql`
  query HealthDataSharing {
    healthDataSharing {
      subject
      canShare
      therapists {
        performer
        therapistName
        sleep
        activity
        heartRate
      }
    }
  }
`;

/**
 * __useHealthDataSharingQuery__
 *
 * To run a query within a React component, call `useHealthDataSharingQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthDataSharingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthDataSharingQuery({
 *   variables: {
 *   },
 * });
 */
export function useHealthDataSharingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HealthDataSharingQuery,
    HealthDataSharingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HealthDataSharingQuery,
    HealthDataSharingQueryVariables
  >(HealthDataSharingDocument, options);
}
export function useHealthDataSharingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HealthDataSharingQuery,
    HealthDataSharingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HealthDataSharingQuery,
    HealthDataSharingQueryVariables
  >(HealthDataSharingDocument, options);
}
export type HealthDataSharingQueryHookResult = ReturnType<
  typeof useHealthDataSharingQuery
>;
export type HealthDataSharingLazyQueryHookResult = ReturnType<
  typeof useHealthDataSharingLazyQuery
>;
export type HealthDataSharingQueryResult = Apollo.QueryResult<
  HealthDataSharingQuery,
  HealthDataSharingQueryVariables
>;
export const SetHealthDataSharingDocument = gql`
  mutation SetHealthDataSharing($input: SetHealthDataSharingInput!) {
    setHealthDataSharing(input: $input) {
      recorded
    }
  }
`;
export type SetHealthDataSharingMutationFn = Apollo.MutationFunction<
  SetHealthDataSharingMutation,
  SetHealthDataSharingMutationVariables
>;

/**
 * __useSetHealthDataSharingMutation__
 *
 * To run a mutation, you first call `useSetHealthDataSharingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHealthDataSharingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHealthDataSharingMutation, { data, loading, error }] = useSetHealthDataSharingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetHealthDataSharingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetHealthDataSharingMutation,
    SetHealthDataSharingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetHealthDataSharingMutation,
    SetHealthDataSharingMutationVariables
  >(SetHealthDataSharingDocument, options);
}
export type SetHealthDataSharingMutationHookResult = ReturnType<
  typeof useSetHealthDataSharingMutation
>;
export type SetHealthDataSharingMutationResult =
  Apollo.MutationResult<SetHealthDataSharingMutation>;
export type SetHealthDataSharingMutationOptions = Apollo.BaseMutationOptions<
  SetHealthDataSharingMutation,
  SetHealthDataSharingMutationVariables
>;
export const ClientHealthTimelineDocument = gql`
  query ClientHealthTimeline($subject: ID!, $days: Int, $timeZone: String) {
    clientHealthTimeline(subject: $subject, days: $days, timeZone: $timeZone) {
      subject
      days
      sharedTypes
      nights {
        ...ClientSleepNightFields
      }
      activityDays {
        ...ClientActivityDayFields
      }
      heartRateDays {
        ...ClientHeartRateDayFields
      }
      moodByDay {
        day
        mood
      }
      scores {
        occurredAt
        instrument
        score
      }
    }
  }
  ${ClientSleepNightFieldsFragmentDoc}
  ${ClientActivityDayFieldsFragmentDoc}
  ${ClientHeartRateDayFieldsFragmentDoc}
`;

/**
 * __useClientHealthTimelineQuery__
 *
 * To run a query within a React component, call `useClientHealthTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientHealthTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientHealthTimelineQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      days: // value for 'days'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useClientHealthTimelineQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientHealthTimelineQuery,
    ClientHealthTimelineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientHealthTimelineQuery,
    ClientHealthTimelineQueryVariables
  >(ClientHealthTimelineDocument, options);
}
export function useClientHealthTimelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientHealthTimelineQuery,
    ClientHealthTimelineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientHealthTimelineQuery,
    ClientHealthTimelineQueryVariables
  >(ClientHealthTimelineDocument, options);
}
export type ClientHealthTimelineQueryHookResult = ReturnType<
  typeof useClientHealthTimelineQuery
>;
export type ClientHealthTimelineLazyQueryHookResult = ReturnType<
  typeof useClientHealthTimelineLazyQuery
>;
export type ClientHealthTimelineQueryResult = Apollo.QueryResult<
  ClientHealthTimelineQuery,
  ClientHealthTimelineQueryVariables
>;
export const HealthReadWindowsDocument = gql`
  query HealthReadWindows {
    healthReadWindows {
      focus {
        type
        ref
      }
      from
      to
    }
  }
`;

/**
 * __useHealthReadWindowsQuery__
 *
 * To run a query within a React component, call `useHealthReadWindowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthReadWindowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthReadWindowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHealthReadWindowsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HealthReadWindowsQuery,
    HealthReadWindowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HealthReadWindowsQuery,
    HealthReadWindowsQueryVariables
  >(HealthReadWindowsDocument, options);
}
export function useHealthReadWindowsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HealthReadWindowsQuery,
    HealthReadWindowsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HealthReadWindowsQuery,
    HealthReadWindowsQueryVariables
  >(HealthReadWindowsDocument, options);
}
export type HealthReadWindowsQueryHookResult = ReturnType<
  typeof useHealthReadWindowsQuery
>;
export type HealthReadWindowsLazyQueryHookResult = ReturnType<
  typeof useHealthReadWindowsLazyQuery
>;
export type HealthReadWindowsQueryResult = Apollo.QueryResult<
  HealthReadWindowsQuery,
  HealthReadWindowsQueryVariables
>;
export const ExpositionHeartRateDocument = gql`
  query ExpositionHeartRate($expositionId: ID!) {
    expositionHeartRate(expositionId: $expositionId) {
      expositionId
      heartRateShared
      window {
        from
        to
        bpm {
          min
          max
          mean
          samples
        }
      }
    }
  }
`;

/**
 * __useExpositionHeartRateQuery__
 *
 * To run a query within a React component, call `useExpositionHeartRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpositionHeartRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpositionHeartRateQuery({
 *   variables: {
 *      expositionId: // value for 'expositionId'
 *   },
 * });
 */
export function useExpositionHeartRateQuery(
  baseOptions: Apollo.QueryHookOptions<
    ExpositionHeartRateQuery,
    ExpositionHeartRateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ExpositionHeartRateQuery,
    ExpositionHeartRateQueryVariables
  >(ExpositionHeartRateDocument, options);
}
export function useExpositionHeartRateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ExpositionHeartRateQuery,
    ExpositionHeartRateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ExpositionHeartRateQuery,
    ExpositionHeartRateQueryVariables
  >(ExpositionHeartRateDocument, options);
}
export type ExpositionHeartRateQueryHookResult = ReturnType<
  typeof useExpositionHeartRateQuery
>;
export type ExpositionHeartRateLazyQueryHookResult = ReturnType<
  typeof useExpositionHeartRateLazyQuery
>;
export type ExpositionHeartRateQueryResult = Apollo.QueryResult<
  ExpositionHeartRateQuery,
  ExpositionHeartRateQueryVariables
>;
export const PortalExpositionHeartRateDocument = gql`
  query PortalExpositionHeartRate($subject: ID!, $expositionId: ID!) {
    portalExpositionHeartRate(subject: $subject, expositionId: $expositionId) {
      expositionId
      sharedTypes
      window {
        from
        to
        bpm {
          min
          max
          mean
          samples
        }
      }
    }
  }
`;

/**
 * __usePortalExpositionHeartRateQuery__
 *
 * To run a query within a React component, call `usePortalExpositionHeartRateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalExpositionHeartRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalExpositionHeartRateQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      expositionId: // value for 'expositionId'
 *   },
 * });
 */
export function usePortalExpositionHeartRateQuery(
  baseOptions: Apollo.QueryHookOptions<
    PortalExpositionHeartRateQuery,
    PortalExpositionHeartRateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PortalExpositionHeartRateQuery,
    PortalExpositionHeartRateQueryVariables
  >(PortalExpositionHeartRateDocument, options);
}
export function usePortalExpositionHeartRateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PortalExpositionHeartRateQuery,
    PortalExpositionHeartRateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PortalExpositionHeartRateQuery,
    PortalExpositionHeartRateQueryVariables
  >(PortalExpositionHeartRateDocument, options);
}
export type PortalExpositionHeartRateQueryHookResult = ReturnType<
  typeof usePortalExpositionHeartRateQuery
>;
export type PortalExpositionHeartRateLazyQueryHookResult = ReturnType<
  typeof usePortalExpositionHeartRateLazyQuery
>;
export type PortalExpositionHeartRateQueryResult = Apollo.QueryResult<
  PortalExpositionHeartRateQuery,
  PortalExpositionHeartRateQueryVariables
>;
export const ClientHomeworkDocument = gql`
  query ClientHomework($subject: ID!) {
    clientHomework(subject: $subject) {
      ...ClientHomeworkFields
    }
  }
  ${ClientHomeworkFieldsFragmentDoc}
`;

/**
 * __useClientHomeworkQuery__
 *
 * To run a query within a React component, call `useClientHomeworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientHomeworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientHomeworkQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useClientHomeworkQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientHomeworkQuery,
    ClientHomeworkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClientHomeworkQuery, ClientHomeworkQueryVariables>(
    ClientHomeworkDocument,
    options,
  );
}
export function useClientHomeworkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientHomeworkQuery,
    ClientHomeworkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClientHomeworkQuery, ClientHomeworkQueryVariables>(
    ClientHomeworkDocument,
    options,
  );
}
export type ClientHomeworkQueryHookResult = ReturnType<
  typeof useClientHomeworkQuery
>;
export type ClientHomeworkLazyQueryHookResult = ReturnType<
  typeof useClientHomeworkLazyQuery
>;
export type ClientHomeworkQueryResult = Apollo.QueryResult<
  ClientHomeworkQuery,
  ClientHomeworkQueryVariables
>;
export const ClientHomeworkPageDocument = gql`
  query ClientHomeworkPage(
    $subject: ID!
    $status: ClientHomeworkChip
    $page: Int
    $pageSize: Int
  ) {
    clientHomeworkPage(
      subject: $subject
      status: $status
      page: $page
      pageSize: $pageSize
    ) {
      rows {
        ...ClientHomeworkFields
      }
      total
      page
      pageSize
      counts {
        all
        open
        overdue
        done
        skipped
        cancelled
        awaitingReply
      }
    }
  }
  ${ClientHomeworkFieldsFragmentDoc}
`;

/**
 * __useClientHomeworkPageQuery__
 *
 * To run a query within a React component, call `useClientHomeworkPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientHomeworkPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientHomeworkPageQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      status: // value for 'status'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useClientHomeworkPageQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientHomeworkPageQuery,
    ClientHomeworkPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientHomeworkPageQuery,
    ClientHomeworkPageQueryVariables
  >(ClientHomeworkPageDocument, options);
}
export function useClientHomeworkPageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientHomeworkPageQuery,
    ClientHomeworkPageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientHomeworkPageQuery,
    ClientHomeworkPageQueryVariables
  >(ClientHomeworkPageDocument, options);
}
export type ClientHomeworkPageQueryHookResult = ReturnType<
  typeof useClientHomeworkPageQuery
>;
export type ClientHomeworkPageLazyQueryHookResult = ReturnType<
  typeof useClientHomeworkPageLazyQuery
>;
export type ClientHomeworkPageQueryResult = Apollo.QueryResult<
  ClientHomeworkPageQuery,
  ClientHomeworkPageQueryVariables
>;
export const ClientHomeworkAccessDocument = gql`
  query ClientHomeworkAccess($subject: ID!) {
    clientHomeworkAccess(subject: $subject) {
      canAssign
    }
  }
`;

/**
 * __useClientHomeworkAccessQuery__
 *
 * To run a query within a React component, call `useClientHomeworkAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientHomeworkAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientHomeworkAccessQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useClientHomeworkAccessQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientHomeworkAccessQuery,
    ClientHomeworkAccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientHomeworkAccessQuery,
    ClientHomeworkAccessQueryVariables
  >(ClientHomeworkAccessDocument, options);
}
export function useClientHomeworkAccessLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientHomeworkAccessQuery,
    ClientHomeworkAccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientHomeworkAccessQuery,
    ClientHomeworkAccessQueryVariables
  >(ClientHomeworkAccessDocument, options);
}
export type ClientHomeworkAccessQueryHookResult = ReturnType<
  typeof useClientHomeworkAccessQuery
>;
export type ClientHomeworkAccessLazyQueryHookResult = ReturnType<
  typeof useClientHomeworkAccessLazyQuery
>;
export type ClientHomeworkAccessQueryResult = Apollo.QueryResult<
  ClientHomeworkAccessQuery,
  ClientHomeworkAccessQueryVariables
>;
export const MyHomeworkDocument = gql`
  query MyHomework {
    myHomework {
      ...MyHomeworkFields
    }
  }
  ${MyHomeworkFieldsFragmentDoc}
`;

/**
 * __useMyHomeworkQuery__
 *
 * To run a query within a React component, call `useMyHomeworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyHomeworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyHomeworkQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyHomeworkQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyHomeworkQuery,
    MyHomeworkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyHomeworkQuery, MyHomeworkQueryVariables>(
    MyHomeworkDocument,
    options,
  );
}
export function useMyHomeworkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyHomeworkQuery,
    MyHomeworkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyHomeworkQuery, MyHomeworkQueryVariables>(
    MyHomeworkDocument,
    options,
  );
}
export type MyHomeworkQueryHookResult = ReturnType<typeof useMyHomeworkQuery>;
export type MyHomeworkLazyQueryHookResult = ReturnType<
  typeof useMyHomeworkLazyQuery
>;
export type MyHomeworkQueryResult = Apollo.QueryResult<
  MyHomeworkQuery,
  MyHomeworkQueryVariables
>;
export const MyFinishedHomeworkDocument = gql`
  query MyFinishedHomework($after: String, $pageSize: Int) {
    myFinishedHomework(after: $after, pageSize: $pageSize) {
      items {
        ...MyHomeworkFields
      }
      nextCursor
    }
  }
  ${MyHomeworkFieldsFragmentDoc}
`;

/**
 * __useMyFinishedHomeworkQuery__
 *
 * To run a query within a React component, call `useMyFinishedHomeworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyFinishedHomeworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyFinishedHomeworkQuery({
 *   variables: {
 *      after: // value for 'after'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useMyFinishedHomeworkQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyFinishedHomeworkQuery,
    MyFinishedHomeworkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MyFinishedHomeworkQuery,
    MyFinishedHomeworkQueryVariables
  >(MyFinishedHomeworkDocument, options);
}
export function useMyFinishedHomeworkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyFinishedHomeworkQuery,
    MyFinishedHomeworkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MyFinishedHomeworkQuery,
    MyFinishedHomeworkQueryVariables
  >(MyFinishedHomeworkDocument, options);
}
export type MyFinishedHomeworkQueryHookResult = ReturnType<
  typeof useMyFinishedHomeworkQuery
>;
export type MyFinishedHomeworkLazyQueryHookResult = ReturnType<
  typeof useMyFinishedHomeworkLazyQuery
>;
export type MyFinishedHomeworkQueryResult = Apollo.QueryResult<
  MyFinishedHomeworkQuery,
  MyFinishedHomeworkQueryVariables
>;
export const MyHomeworkItemDocument = gql`
  query MyHomeworkItem($assignmentId: ID!) {
    myHomeworkItem(assignmentId: $assignmentId) {
      ...MyHomeworkFields
    }
  }
  ${MyHomeworkFieldsFragmentDoc}
`;

/**
 * __useMyHomeworkItemQuery__
 *
 * To run a query within a React component, call `useMyHomeworkItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyHomeworkItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyHomeworkItemQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useMyHomeworkItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    MyHomeworkItemQuery,
    MyHomeworkItemQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyHomeworkItemQuery, MyHomeworkItemQueryVariables>(
    MyHomeworkItemDocument,
    options,
  );
}
export function useMyHomeworkItemLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyHomeworkItemQuery,
    MyHomeworkItemQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyHomeworkItemQuery, MyHomeworkItemQueryVariables>(
    MyHomeworkItemDocument,
    options,
  );
}
export type MyHomeworkItemQueryHookResult = ReturnType<
  typeof useMyHomeworkItemQuery
>;
export type MyHomeworkItemLazyQueryHookResult = ReturnType<
  typeof useMyHomeworkItemLazyQuery
>;
export type MyHomeworkItemQueryResult = Apollo.QueryResult<
  MyHomeworkItemQuery,
  MyHomeworkItemQueryVariables
>;
export const MyTherapistsDocument = gql`
  query MyTherapists {
    myTherapists {
      subject
      performer
    }
  }
`;

/**
 * __useMyTherapistsQuery__
 *
 * To run a query within a React component, call `useMyTherapistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTherapistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTherapistsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyTherapistsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyTherapistsQuery,
    MyTherapistsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyTherapistsQuery, MyTherapistsQueryVariables>(
    MyTherapistsDocument,
    options,
  );
}
export function useMyTherapistsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyTherapistsQuery,
    MyTherapistsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyTherapistsQuery, MyTherapistsQueryVariables>(
    MyTherapistsDocument,
    options,
  );
}
export type MyTherapistsQueryHookResult = ReturnType<
  typeof useMyTherapistsQuery
>;
export type MyTherapistsLazyQueryHookResult = ReturnType<
  typeof useMyTherapistsLazyQuery
>;
export type MyTherapistsQueryResult = Apollo.QueryResult<
  MyTherapistsQuery,
  MyTherapistsQueryVariables
>;
export const AssignHomeworkDocument = gql`
  mutation AssignHomework($input: AssignHomeworkInput!) {
    assignHomework(input: $input) {
      assignmentId
      recorded
    }
  }
`;
export type AssignHomeworkMutationFn = Apollo.MutationFunction<
  AssignHomeworkMutation,
  AssignHomeworkMutationVariables
>;

/**
 * __useAssignHomeworkMutation__
 *
 * To run a mutation, you first call `useAssignHomeworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignHomeworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignHomeworkMutation, { data, loading, error }] = useAssignHomeworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignHomeworkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignHomeworkMutation,
    AssignHomeworkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AssignHomeworkMutation,
    AssignHomeworkMutationVariables
  >(AssignHomeworkDocument, options);
}
export type AssignHomeworkMutationHookResult = ReturnType<
  typeof useAssignHomeworkMutation
>;
export type AssignHomeworkMutationResult =
  Apollo.MutationResult<AssignHomeworkMutation>;
export type AssignHomeworkMutationOptions = Apollo.BaseMutationOptions<
  AssignHomeworkMutation,
  AssignHomeworkMutationVariables
>;
export const AmendHomeworkDocument = gql`
  mutation AmendHomework($input: AmendHomeworkInput!) {
    amendHomework(input: $input) {
      assignmentId
      recorded
    }
  }
`;
export type AmendHomeworkMutationFn = Apollo.MutationFunction<
  AmendHomeworkMutation,
  AmendHomeworkMutationVariables
>;

/**
 * __useAmendHomeworkMutation__
 *
 * To run a mutation, you first call `useAmendHomeworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAmendHomeworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [amendHomeworkMutation, { data, loading, error }] = useAmendHomeworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAmendHomeworkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AmendHomeworkMutation,
    AmendHomeworkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AmendHomeworkMutation,
    AmendHomeworkMutationVariables
  >(AmendHomeworkDocument, options);
}
export type AmendHomeworkMutationHookResult = ReturnType<
  typeof useAmendHomeworkMutation
>;
export type AmendHomeworkMutationResult =
  Apollo.MutationResult<AmendHomeworkMutation>;
export type AmendHomeworkMutationOptions = Apollo.BaseMutationOptions<
  AmendHomeworkMutation,
  AmendHomeworkMutationVariables
>;
export const CancelHomeworkDocument = gql`
  mutation CancelHomework($input: CancelHomeworkInput!) {
    cancelHomework(input: $input) {
      assignmentId
      recorded
    }
  }
`;
export type CancelHomeworkMutationFn = Apollo.MutationFunction<
  CancelHomeworkMutation,
  CancelHomeworkMutationVariables
>;

/**
 * __useCancelHomeworkMutation__
 *
 * To run a mutation, you first call `useCancelHomeworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelHomeworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelHomeworkMutation, { data, loading, error }] = useCancelHomeworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelHomeworkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CancelHomeworkMutation,
    CancelHomeworkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CancelHomeworkMutation,
    CancelHomeworkMutationVariables
  >(CancelHomeworkDocument, options);
}
export type CancelHomeworkMutationHookResult = ReturnType<
  typeof useCancelHomeworkMutation
>;
export type CancelHomeworkMutationResult =
  Apollo.MutationResult<CancelHomeworkMutation>;
export type CancelHomeworkMutationOptions = Apollo.BaseMutationOptions<
  CancelHomeworkMutation,
  CancelHomeworkMutationVariables
>;
export const ReopenHomeworkDocument = gql`
  mutation ReopenHomework($input: ReopenHomeworkInput!) {
    reopenHomework(input: $input) {
      assignmentId
      recorded
    }
  }
`;
export type ReopenHomeworkMutationFn = Apollo.MutationFunction<
  ReopenHomeworkMutation,
  ReopenHomeworkMutationVariables
>;

/**
 * __useReopenHomeworkMutation__
 *
 * To run a mutation, you first call `useReopenHomeworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenHomeworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenHomeworkMutation, { data, loading, error }] = useReopenHomeworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReopenHomeworkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReopenHomeworkMutation,
    ReopenHomeworkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReopenHomeworkMutation,
    ReopenHomeworkMutationVariables
  >(ReopenHomeworkDocument, options);
}
export type ReopenHomeworkMutationHookResult = ReturnType<
  typeof useReopenHomeworkMutation
>;
export type ReopenHomeworkMutationResult =
  Apollo.MutationResult<ReopenHomeworkMutation>;
export type ReopenHomeworkMutationOptions = Apollo.BaseMutationOptions<
  ReopenHomeworkMutation,
  ReopenHomeworkMutationVariables
>;
export const AcknowledgeHomeworkDocument = gql`
  mutation AcknowledgeHomework($assignmentId: ID!) {
    acknowledgeHomework(assignmentId: $assignmentId) {
      assignmentId
      recorded
    }
  }
`;
export type AcknowledgeHomeworkMutationFn = Apollo.MutationFunction<
  AcknowledgeHomeworkMutation,
  AcknowledgeHomeworkMutationVariables
>;

/**
 * __useAcknowledgeHomeworkMutation__
 *
 * To run a mutation, you first call `useAcknowledgeHomeworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeHomeworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeHomeworkMutation, { data, loading, error }] = useAcknowledgeHomeworkMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useAcknowledgeHomeworkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcknowledgeHomeworkMutation,
    AcknowledgeHomeworkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcknowledgeHomeworkMutation,
    AcknowledgeHomeworkMutationVariables
  >(AcknowledgeHomeworkDocument, options);
}
export type AcknowledgeHomeworkMutationHookResult = ReturnType<
  typeof useAcknowledgeHomeworkMutation
>;
export type AcknowledgeHomeworkMutationResult =
  Apollo.MutationResult<AcknowledgeHomeworkMutation>;
export type AcknowledgeHomeworkMutationOptions = Apollo.BaseMutationOptions<
  AcknowledgeHomeworkMutation,
  AcknowledgeHomeworkMutationVariables
>;
export const CompleteHomeworkDocument = gql`
  mutation CompleteHomework($input: CompleteHomeworkInput!) {
    completeHomework(input: $input) {
      assignmentId
      recorded
    }
  }
`;
export type CompleteHomeworkMutationFn = Apollo.MutationFunction<
  CompleteHomeworkMutation,
  CompleteHomeworkMutationVariables
>;

/**
 * __useCompleteHomeworkMutation__
 *
 * To run a mutation, you first call `useCompleteHomeworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteHomeworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeHomeworkMutation, { data, loading, error }] = useCompleteHomeworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteHomeworkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteHomeworkMutation,
    CompleteHomeworkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteHomeworkMutation,
    CompleteHomeworkMutationVariables
  >(CompleteHomeworkDocument, options);
}
export type CompleteHomeworkMutationHookResult = ReturnType<
  typeof useCompleteHomeworkMutation
>;
export type CompleteHomeworkMutationResult =
  Apollo.MutationResult<CompleteHomeworkMutation>;
export type CompleteHomeworkMutationOptions = Apollo.BaseMutationOptions<
  CompleteHomeworkMutation,
  CompleteHomeworkMutationVariables
>;
export const SkipHomeworkDocument = gql`
  mutation SkipHomework($input: SkipHomeworkInput!) {
    skipHomework(input: $input) {
      assignmentId
      recorded
    }
  }
`;
export type SkipHomeworkMutationFn = Apollo.MutationFunction<
  SkipHomeworkMutation,
  SkipHomeworkMutationVariables
>;

/**
 * __useSkipHomeworkMutation__
 *
 * To run a mutation, you first call `useSkipHomeworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipHomeworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipHomeworkMutation, { data, loading, error }] = useSkipHomeworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSkipHomeworkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SkipHomeworkMutation,
    SkipHomeworkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SkipHomeworkMutation,
    SkipHomeworkMutationVariables
  >(SkipHomeworkDocument, options);
}
export type SkipHomeworkMutationHookResult = ReturnType<
  typeof useSkipHomeworkMutation
>;
export type SkipHomeworkMutationResult =
  Apollo.MutationResult<SkipHomeworkMutation>;
export type SkipHomeworkMutationOptions = Apollo.BaseMutationOptions<
  SkipHomeworkMutation,
  SkipHomeworkMutationVariables
>;
export const HomeworkSinceLastSessionDocument = gql`
  query HomeworkSinceLastSession($subject: ID!, $sessionId: ID) {
    homeworkSinceLastSession(subject: $subject, sessionId: $sessionId) {
      subject
      sessionId
      lastSessionStart
      assignmentId
      title
      kind
      dueAt
      tzid
      status
      overdue
      evidence {
        focusType
        focus
      }
      reasonCode
      reason
      completedAt
      outcomeAt
      outcomes {
        ...HomeworkOccurrenceOutcomeFields
      }
    }
  }
  ${HomeworkOccurrenceOutcomeFieldsFragmentDoc}
`;

/**
 * __useHomeworkSinceLastSessionQuery__
 *
 * To run a query within a React component, call `useHomeworkSinceLastSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeworkSinceLastSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeworkSinceLastSessionQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useHomeworkSinceLastSessionQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomeworkSinceLastSessionQuery,
    HomeworkSinceLastSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HomeworkSinceLastSessionQuery,
    HomeworkSinceLastSessionQueryVariables
  >(HomeworkSinceLastSessionDocument, options);
}
export function useHomeworkSinceLastSessionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeworkSinceLastSessionQuery,
    HomeworkSinceLastSessionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HomeworkSinceLastSessionQuery,
    HomeworkSinceLastSessionQueryVariables
  >(HomeworkSinceLastSessionDocument, options);
}
export type HomeworkSinceLastSessionQueryHookResult = ReturnType<
  typeof useHomeworkSinceLastSessionQuery
>;
export type HomeworkSinceLastSessionLazyQueryHookResult = ReturnType<
  typeof useHomeworkSinceLastSessionLazyQuery
>;
export type HomeworkSinceLastSessionQueryResult = Apollo.QueryResult<
  HomeworkSinceLastSessionQuery,
  HomeworkSinceLastSessionQueryVariables
>;
export const PracticeHomeworkBoardDocument = gql`
  query PracticeHomeworkBoard($timeZone: String) {
    practiceHomeworkBoard(timeZone: $timeZone) {
      practiceId
      subject
      clientName
      therapistName
      openCount
      overdueCount
      doneThisWeek
      awaitingReply
      lastActivityAt
      clientEmail
      enrollmentId
      pathwayId
      pathwayName
      pathwayPercentDone
      pendingDocuments
      assignmentIds
      homeworkAppReady
      lng
    }
  }
`;

/**
 * __usePracticeHomeworkBoardQuery__
 *
 * To run a query within a React component, call `usePracticeHomeworkBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePracticeHomeworkBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePracticeHomeworkBoardQuery({
 *   variables: {
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function usePracticeHomeworkBoardQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PracticeHomeworkBoardQuery,
    PracticeHomeworkBoardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PracticeHomeworkBoardQuery,
    PracticeHomeworkBoardQueryVariables
  >(PracticeHomeworkBoardDocument, options);
}
export function usePracticeHomeworkBoardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PracticeHomeworkBoardQuery,
    PracticeHomeworkBoardQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PracticeHomeworkBoardQuery,
    PracticeHomeworkBoardQueryVariables
  >(PracticeHomeworkBoardDocument, options);
}
export type PracticeHomeworkBoardQueryHookResult = ReturnType<
  typeof usePracticeHomeworkBoardQuery
>;
export type PracticeHomeworkBoardLazyQueryHookResult = ReturnType<
  typeof usePracticeHomeworkBoardLazyQuery
>;
export type PracticeHomeworkBoardQueryResult = Apollo.QueryResult<
  PracticeHomeworkBoardQuery,
  PracticeHomeworkBoardQueryVariables
>;
export const RequestHomeworkReminderDocument = gql`
  mutation RequestHomeworkReminder($input: RequestHomeworkReminderInput!) {
    requestHomeworkReminder(input: $input) {
      assignmentId
      recorded
    }
  }
`;
export type RequestHomeworkReminderMutationFn = Apollo.MutationFunction<
  RequestHomeworkReminderMutation,
  RequestHomeworkReminderMutationVariables
>;

/**
 * __useRequestHomeworkReminderMutation__
 *
 * To run a mutation, you first call `useRequestHomeworkReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestHomeworkReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestHomeworkReminderMutation, { data, loading, error }] = useRequestHomeworkReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestHomeworkReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestHomeworkReminderMutation,
    RequestHomeworkReminderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestHomeworkReminderMutation,
    RequestHomeworkReminderMutationVariables
  >(RequestHomeworkReminderDocument, options);
}
export type RequestHomeworkReminderMutationHookResult = ReturnType<
  typeof useRequestHomeworkReminderMutation
>;
export type RequestHomeworkReminderMutationResult =
  Apollo.MutationResult<RequestHomeworkReminderMutation>;
export type RequestHomeworkReminderMutationOptions = Apollo.BaseMutationOptions<
  RequestHomeworkReminderMutation,
  RequestHomeworkReminderMutationVariables
>;
export const HomeworkPaperPhotoUrlDocument = gql`
  query HomeworkPaperPhotoUrl($assignmentId: ID!, $fileRef: String!) {
    homeworkPaperPhotoUrl(assignmentId: $assignmentId, fileRef: $fileRef) {
      url
      expiresAt
    }
  }
`;

/**
 * __useHomeworkPaperPhotoUrlQuery__
 *
 * To run a query within a React component, call `useHomeworkPaperPhotoUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeworkPaperPhotoUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeworkPaperPhotoUrlQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      fileRef: // value for 'fileRef'
 *   },
 * });
 */
export function useHomeworkPaperPhotoUrlQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomeworkPaperPhotoUrlQuery,
    HomeworkPaperPhotoUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HomeworkPaperPhotoUrlQuery,
    HomeworkPaperPhotoUrlQueryVariables
  >(HomeworkPaperPhotoUrlDocument, options);
}
export function useHomeworkPaperPhotoUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeworkPaperPhotoUrlQuery,
    HomeworkPaperPhotoUrlQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HomeworkPaperPhotoUrlQuery,
    HomeworkPaperPhotoUrlQueryVariables
  >(HomeworkPaperPhotoUrlDocument, options);
}
export type HomeworkPaperPhotoUrlQueryHookResult = ReturnType<
  typeof useHomeworkPaperPhotoUrlQuery
>;
export type HomeworkPaperPhotoUrlLazyQueryHookResult = ReturnType<
  typeof useHomeworkPaperPhotoUrlLazyQuery
>;
export type HomeworkPaperPhotoUrlQueryResult = Apollo.QueryResult<
  HomeworkPaperPhotoUrlQuery,
  HomeworkPaperPhotoUrlQueryVariables
>;
export const HomeworkCommentsDocument = gql`
  query HomeworkComments($assignmentId: ID!) {
    homeworkComments(assignmentId: $assignmentId) {
      ...HomeworkCommentFields
    }
  }
  ${HomeworkCommentFieldsFragmentDoc}
`;

/**
 * __useHomeworkCommentsQuery__
 *
 * To run a query within a React component, call `useHomeworkCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeworkCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeworkCommentsQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useHomeworkCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    HomeworkCommentsQuery,
    HomeworkCommentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<HomeworkCommentsQuery, HomeworkCommentsQueryVariables>(
    HomeworkCommentsDocument,
    options,
  );
}
export function useHomeworkCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HomeworkCommentsQuery,
    HomeworkCommentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HomeworkCommentsQuery,
    HomeworkCommentsQueryVariables
  >(HomeworkCommentsDocument, options);
}
export type HomeworkCommentsQueryHookResult = ReturnType<
  typeof useHomeworkCommentsQuery
>;
export type HomeworkCommentsLazyQueryHookResult = ReturnType<
  typeof useHomeworkCommentsLazyQuery
>;
export type HomeworkCommentsQueryResult = Apollo.QueryResult<
  HomeworkCommentsQuery,
  HomeworkCommentsQueryVariables
>;
export const CommentOnHomeworkDocument = gql`
  mutation CommentOnHomework($input: CommentOnHomeworkInput!) {
    commentOnHomework(input: $input) {
      assignmentId
      commentId
      recorded
    }
  }
`;
export type CommentOnHomeworkMutationFn = Apollo.MutationFunction<
  CommentOnHomeworkMutation,
  CommentOnHomeworkMutationVariables
>;

/**
 * __useCommentOnHomeworkMutation__
 *
 * To run a mutation, you first call `useCommentOnHomeworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentOnHomeworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentOnHomeworkMutation, { data, loading, error }] = useCommentOnHomeworkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommentOnHomeworkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CommentOnHomeworkMutation,
    CommentOnHomeworkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CommentOnHomeworkMutation,
    CommentOnHomeworkMutationVariables
  >(CommentOnHomeworkDocument, options);
}
export type CommentOnHomeworkMutationHookResult = ReturnType<
  typeof useCommentOnHomeworkMutation
>;
export type CommentOnHomeworkMutationResult =
  Apollo.MutationResult<CommentOnHomeworkMutation>;
export type CommentOnHomeworkMutationOptions = Apollo.BaseMutationOptions<
  CommentOnHomeworkMutation,
  CommentOnHomeworkMutationVariables
>;
export const WatchAssignedVideoDocument = gql`
  mutation WatchAssignedVideo($input: WatchAssignedVideoInput!) {
    watchAssignedVideo(input: $input) {
      assignmentId
      recorded
    }
  }
`;
export type WatchAssignedVideoMutationFn = Apollo.MutationFunction<
  WatchAssignedVideoMutation,
  WatchAssignedVideoMutationVariables
>;

/**
 * __useWatchAssignedVideoMutation__
 *
 * To run a mutation, you first call `useWatchAssignedVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWatchAssignedVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [watchAssignedVideoMutation, { data, loading, error }] = useWatchAssignedVideoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWatchAssignedVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WatchAssignedVideoMutation,
    WatchAssignedVideoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WatchAssignedVideoMutation,
    WatchAssignedVideoMutationVariables
  >(WatchAssignedVideoDocument, options);
}
export type WatchAssignedVideoMutationHookResult = ReturnType<
  typeof useWatchAssignedVideoMutation
>;
export type WatchAssignedVideoMutationResult =
  Apollo.MutationResult<WatchAssignedVideoMutation>;
export type WatchAssignedVideoMutationOptions = Apollo.BaseMutationOptions<
  WatchAssignedVideoMutation,
  WatchAssignedVideoMutationVariables
>;
export const CreateInviteDocument = gql`
  mutation CreateInvite($input: createInviteInput!) {
    createInvite(input: $input) {
      _id
      ...InviteData
    }
  }
  ${InviteDataFragmentDoc}
`;
export type CreateInviteMutationFn = Apollo.MutationFunction<
  CreateInviteMutation,
  CreateInviteMutationVariables
>;

/**
 * __useCreateInviteMutation__
 *
 * To run a mutation, you first call `useCreateInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInviteMutation, { data, loading, error }] = useCreateInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInviteMutation,
    CreateInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateInviteMutation,
    CreateInviteMutationVariables
  >(CreateInviteDocument, options);
}
export type CreateInviteMutationHookResult = ReturnType<
  typeof useCreateInviteMutation
>;
export type CreateInviteMutationResult =
  Apollo.MutationResult<CreateInviteMutation>;
export type CreateInviteMutationOptions = Apollo.BaseMutationOptions<
  CreateInviteMutation,
  CreateInviteMutationVariables
>;
export const DeleteInviteDocument = gql`
  mutation DeleteInvite($input: deleteInviteInput!) {
    deleteInvite(input: $input) {
      _id
      ...InviteData
    }
  }
  ${InviteDataFragmentDoc}
`;
export type DeleteInviteMutationFn = Apollo.MutationFunction<
  DeleteInviteMutation,
  DeleteInviteMutationVariables
>;

/**
 * __useDeleteInviteMutation__
 *
 * To run a mutation, you first call `useDeleteInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInviteMutation, { data, loading, error }] = useDeleteInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInviteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteInviteMutation,
    DeleteInviteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteInviteMutation,
    DeleteInviteMutationVariables
  >(DeleteInviteDocument, options);
}
export type DeleteInviteMutationHookResult = ReturnType<
  typeof useDeleteInviteMutation
>;
export type DeleteInviteMutationResult =
  Apollo.MutationResult<DeleteInviteMutation>;
export type DeleteInviteMutationOptions = Apollo.BaseMutationOptions<
  DeleteInviteMutation,
  DeleteInviteMutationVariables
>;
export const InvitesDocument = gql`
  query Invites($sort: String, $where: JSON, $start: Int, $limit: Int) {
    invites(sort: $sort, where: $where, start: $start, limit: $limit) {
      data {
        _id
        ...InviteData
      }
      count
    }
  }
  ${InviteDataFragmentDoc}
`;

/**
 * __useInvitesQuery__
 *
 * To run a query within a React component, call `useInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useInvitesQuery(
  baseOptions?: Apollo.QueryHookOptions<InvitesQuery, InvitesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InvitesQuery, InvitesQueryVariables>(
    InvitesDocument,
    options,
  );
}
export function useInvitesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvitesQuery,
    InvitesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InvitesQuery, InvitesQueryVariables>(
    InvitesDocument,
    options,
  );
}
export type InvitesQueryHookResult = ReturnType<typeof useInvitesQuery>;
export type InvitesLazyQueryHookResult = ReturnType<typeof useInvitesLazyQuery>;
export type InvitesQueryResult = Apollo.QueryResult<
  InvitesQuery,
  InvitesQueryVariables
>;
export const InvitesForYouDocument = gql`
  query InvitesForYou($sort: String, $where: JSON, $start: Int, $limit: Int) {
    invitesForYou(sort: $sort, where: $where, start: $start, limit: $limit) {
      data {
        _id
        ...InviteData
        user {
          _id
          firstName
          lastName
        }
      }
      count
    }
  }
  ${InviteDataFragmentDoc}
`;

/**
 * __useInvitesForYouQuery__
 *
 * To run a query within a React component, call `useInvitesForYouQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitesForYouQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitesForYouQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useInvitesForYouQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InvitesForYouQuery,
    InvitesForYouQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InvitesForYouQuery, InvitesForYouQueryVariables>(
    InvitesForYouDocument,
    options,
  );
}
export function useInvitesForYouLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InvitesForYouQuery,
    InvitesForYouQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InvitesForYouQuery, InvitesForYouQueryVariables>(
    InvitesForYouDocument,
    options,
  );
}
export type InvitesForYouQueryHookResult = ReturnType<
  typeof useInvitesForYouQuery
>;
export type InvitesForYouLazyQueryHookResult = ReturnType<
  typeof useInvitesForYouLazyQuery
>;
export type InvitesForYouQueryResult = Apollo.QueryResult<
  InvitesForYouQuery,
  InvitesForYouQueryVariables
>;
export const InviteDocument = gql`
  query Invite($id: ID!) {
    invite(id: $id) {
      _id
      ...InviteData
    }
  }
  ${InviteDataFragmentDoc}
`;

/**
 * __useInviteQuery__
 *
 * To run a query within a React component, call `useInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInviteQuery(
  baseOptions: Apollo.QueryHookOptions<InviteQuery, InviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InviteQuery, InviteQueryVariables>(
    InviteDocument,
    options,
  );
}
export function useInviteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<InviteQuery, InviteQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InviteQuery, InviteQueryVariables>(
    InviteDocument,
    options,
  );
}
export type InviteQueryHookResult = ReturnType<typeof useInviteQuery>;
export type InviteLazyQueryHookResult = ReturnType<typeof useInviteLazyQuery>;
export type InviteQueryResult = Apollo.QueryResult<
  InviteQuery,
  InviteQueryVariables
>;
export const InviteByTokenDocument = gql`
  query InviteByToken($token: String) {
    inviteByToken(token: $token) {
      _id
      ...InviteData
    }
  }
  ${InviteDataFragmentDoc}
`;

/**
 * __useInviteByTokenQuery__
 *
 * To run a query within a React component, call `useInviteByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useInviteByTokenQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InviteByTokenQuery,
    InviteByTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InviteByTokenQuery, InviteByTokenQueryVariables>(
    InviteByTokenDocument,
    options,
  );
}
export function useInviteByTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InviteByTokenQuery,
    InviteByTokenQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InviteByTokenQuery, InviteByTokenQueryVariables>(
    InviteByTokenDocument,
    options,
  );
}
export type InviteByTokenQueryHookResult = ReturnType<
  typeof useInviteByTokenQuery
>;
export type InviteByTokenLazyQueryHookResult = ReturnType<
  typeof useInviteByTokenLazyQuery
>;
export type InviteByTokenQueryResult = Apollo.QueryResult<
  InviteByTokenQuery,
  InviteByTokenQueryVariables
>;
export const InviteSenderDocument = gql`
  query InviteSender($token: String) {
    inviteByToken(token: $token) {
      _id
      type
      from
      user {
        _id
        firstName
        lastName
        displayName
        practice {
          _id
          practiceName
        }
      }
    }
  }
`;

/**
 * __useInviteSenderQuery__
 *
 * To run a query within a React component, call `useInviteSenderQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteSenderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteSenderQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useInviteSenderQuery(
  baseOptions?: Apollo.QueryHookOptions<
    InviteSenderQuery,
    InviteSenderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InviteSenderQuery, InviteSenderQueryVariables>(
    InviteSenderDocument,
    options,
  );
}
export function useInviteSenderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    InviteSenderQuery,
    InviteSenderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InviteSenderQuery, InviteSenderQueryVariables>(
    InviteSenderDocument,
    options,
  );
}
export type InviteSenderQueryHookResult = ReturnType<
  typeof useInviteSenderQuery
>;
export type InviteSenderLazyQueryHookResult = ReturnType<
  typeof useInviteSenderLazyQuery
>;
export type InviteSenderQueryResult = Apollo.QueryResult<
  InviteSenderQuery,
  InviteSenderQueryVariables
>;
export const LocationReminderDocument = gql`
  query LocationReminder($_id: String!) {
    locationReminder(_id: $_id) {
      ...LocationReminderData
    }
  }
  ${LocationReminderDataFragmentDoc}
`;

/**
 * __useLocationReminderQuery__
 *
 * To run a query within a React component, call `useLocationReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationReminderQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useLocationReminderQuery(
  baseOptions: Apollo.QueryHookOptions<
    LocationReminderQuery,
    LocationReminderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LocationReminderQuery, LocationReminderQueryVariables>(
    LocationReminderDocument,
    options,
  );
}
export function useLocationReminderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LocationReminderQuery,
    LocationReminderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LocationReminderQuery,
    LocationReminderQueryVariables
  >(LocationReminderDocument, options);
}
export type LocationReminderQueryHookResult = ReturnType<
  typeof useLocationReminderQuery
>;
export type LocationReminderLazyQueryHookResult = ReturnType<
  typeof useLocationReminderLazyQuery
>;
export type LocationReminderQueryResult = Apollo.QueryResult<
  LocationReminderQuery,
  LocationReminderQueryVariables
>;
export const LocationRemindersDocument = gql`
  query LocationReminders($ids: [String!]) {
    locationReminders(ids: $ids) {
      ...LocationReminderData
    }
  }
  ${LocationReminderDataFragmentDoc}
`;

/**
 * __useLocationRemindersQuery__
 *
 * To run a query within a React component, call `useLocationRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationRemindersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLocationRemindersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LocationRemindersQuery,
    LocationRemindersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LocationRemindersQuery,
    LocationRemindersQueryVariables
  >(LocationRemindersDocument, options);
}
export function useLocationRemindersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LocationRemindersQuery,
    LocationRemindersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LocationRemindersQuery,
    LocationRemindersQueryVariables
  >(LocationRemindersDocument, options);
}
export type LocationRemindersQueryHookResult = ReturnType<
  typeof useLocationRemindersQuery
>;
export type LocationRemindersLazyQueryHookResult = ReturnType<
  typeof useLocationRemindersLazyQuery
>;
export type LocationRemindersQueryResult = Apollo.QueryResult<
  LocationRemindersQuery,
  LocationRemindersQueryVariables
>;
export const LocationRemindersForUserDocument = gql`
  query LocationRemindersForUser {
    locationRemindersForUser {
      ...LocationReminderData
    }
  }
  ${LocationReminderDataFragmentDoc}
`;

/**
 * __useLocationRemindersForUserQuery__
 *
 * To run a query within a React component, call `useLocationRemindersForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationRemindersForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationRemindersForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationRemindersForUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LocationRemindersForUserQuery,
    LocationRemindersForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LocationRemindersForUserQuery,
    LocationRemindersForUserQueryVariables
  >(LocationRemindersForUserDocument, options);
}
export function useLocationRemindersForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LocationRemindersForUserQuery,
    LocationRemindersForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LocationRemindersForUserQuery,
    LocationRemindersForUserQueryVariables
  >(LocationRemindersForUserDocument, options);
}
export type LocationRemindersForUserQueryHookResult = ReturnType<
  typeof useLocationRemindersForUserQuery
>;
export type LocationRemindersForUserLazyQueryHookResult = ReturnType<
  typeof useLocationRemindersForUserLazyQuery
>;
export type LocationRemindersForUserQueryResult = Apollo.QueryResult<
  LocationRemindersForUserQuery,
  LocationRemindersForUserQueryVariables
>;
export const EnabledLocationRemindersCountDocument = gql`
  query EnabledLocationRemindersCount {
    enabledLocationRemindersCount {
      enabled
    }
  }
`;

/**
 * __useEnabledLocationRemindersCountQuery__
 *
 * To run a query within a React component, call `useEnabledLocationRemindersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnabledLocationRemindersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledLocationRemindersCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnabledLocationRemindersCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EnabledLocationRemindersCountQuery,
    EnabledLocationRemindersCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    EnabledLocationRemindersCountQuery,
    EnabledLocationRemindersCountQueryVariables
  >(EnabledLocationRemindersCountDocument, options);
}
export function useEnabledLocationRemindersCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EnabledLocationRemindersCountQuery,
    EnabledLocationRemindersCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    EnabledLocationRemindersCountQuery,
    EnabledLocationRemindersCountQueryVariables
  >(EnabledLocationRemindersCountDocument, options);
}
export type EnabledLocationRemindersCountQueryHookResult = ReturnType<
  typeof useEnabledLocationRemindersCountQuery
>;
export type EnabledLocationRemindersCountLazyQueryHookResult = ReturnType<
  typeof useEnabledLocationRemindersCountLazyQuery
>;
export type EnabledLocationRemindersCountQueryResult = Apollo.QueryResult<
  EnabledLocationRemindersCountQuery,
  EnabledLocationRemindersCountQueryVariables
>;
export const CreateLocationReminderDocument = gql`
  mutation CreateLocationReminder(
    $locationReminder: LocationReminderCreateInput!
  ) {
    createLocationReminder(locationReminder: $locationReminder) {
      locationReminder {
        ...LocationReminderData
      }
    }
  }
  ${LocationReminderDataFragmentDoc}
`;
export type CreateLocationReminderMutationFn = Apollo.MutationFunction<
  CreateLocationReminderMutation,
  CreateLocationReminderMutationVariables
>;

/**
 * __useCreateLocationReminderMutation__
 *
 * To run a mutation, you first call `useCreateLocationReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationReminderMutation, { data, loading, error }] = useCreateLocationReminderMutation({
 *   variables: {
 *      locationReminder: // value for 'locationReminder'
 *   },
 * });
 */
export function useCreateLocationReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLocationReminderMutation,
    CreateLocationReminderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateLocationReminderMutation,
    CreateLocationReminderMutationVariables
  >(CreateLocationReminderDocument, options);
}
export type CreateLocationReminderMutationHookResult = ReturnType<
  typeof useCreateLocationReminderMutation
>;
export type CreateLocationReminderMutationResult =
  Apollo.MutationResult<CreateLocationReminderMutation>;
export type CreateLocationReminderMutationOptions = Apollo.BaseMutationOptions<
  CreateLocationReminderMutation,
  CreateLocationReminderMutationVariables
>;
export const UpdateLocationReminderDocument = gql`
  mutation UpdateLocationReminder(
    $locationReminder: LocationReminderUpdateInput!
  ) {
    updateLocationReminder(locationReminder: $locationReminder) {
      locationReminder {
        ...LocationReminderData
      }
    }
  }
  ${LocationReminderDataFragmentDoc}
`;
export type UpdateLocationReminderMutationFn = Apollo.MutationFunction<
  UpdateLocationReminderMutation,
  UpdateLocationReminderMutationVariables
>;

/**
 * __useUpdateLocationReminderMutation__
 *
 * To run a mutation, you first call `useUpdateLocationReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationReminderMutation, { data, loading, error }] = useUpdateLocationReminderMutation({
 *   variables: {
 *      locationReminder: // value for 'locationReminder'
 *   },
 * });
 */
export function useUpdateLocationReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLocationReminderMutation,
    UpdateLocationReminderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateLocationReminderMutation,
    UpdateLocationReminderMutationVariables
  >(UpdateLocationReminderDocument, options);
}
export type UpdateLocationReminderMutationHookResult = ReturnType<
  typeof useUpdateLocationReminderMutation
>;
export type UpdateLocationReminderMutationResult =
  Apollo.MutationResult<UpdateLocationReminderMutation>;
export type UpdateLocationReminderMutationOptions = Apollo.BaseMutationOptions<
  UpdateLocationReminderMutation,
  UpdateLocationReminderMutationVariables
>;
export const DeleteLocationReminderDocument = gql`
  mutation DeleteLocationReminder($_id: ID!) {
    deleteLocationReminder(_id: $_id) {
      success
      old {
        ...LocationReminderData
      }
    }
  }
  ${LocationReminderDataFragmentDoc}
`;
export type DeleteLocationReminderMutationFn = Apollo.MutationFunction<
  DeleteLocationReminderMutation,
  DeleteLocationReminderMutationVariables
>;

/**
 * __useDeleteLocationReminderMutation__
 *
 * To run a mutation, you first call `useDeleteLocationReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationReminderMutation, { data, loading, error }] = useDeleteLocationReminderMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteLocationReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteLocationReminderMutation,
    DeleteLocationReminderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteLocationReminderMutation,
    DeleteLocationReminderMutationVariables
  >(DeleteLocationReminderDocument, options);
}
export type DeleteLocationReminderMutationHookResult = ReturnType<
  typeof useDeleteLocationReminderMutation
>;
export type DeleteLocationReminderMutationResult =
  Apollo.MutationResult<DeleteLocationReminderMutation>;
export type DeleteLocationReminderMutationOptions = Apollo.BaseMutationOptions<
  DeleteLocationReminderMutation,
  DeleteLocationReminderMutationVariables
>;
export const KeepLocationRemindersDocument = gql`
  mutation KeepLocationReminders($ids: [ID!]!) {
    keepLocationReminders(ids: $ids) {
      success
    }
  }
`;
export type KeepLocationRemindersMutationFn = Apollo.MutationFunction<
  KeepLocationRemindersMutation,
  KeepLocationRemindersMutationVariables
>;

/**
 * __useKeepLocationRemindersMutation__
 *
 * To run a mutation, you first call `useKeepLocationRemindersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKeepLocationRemindersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [keepLocationRemindersMutation, { data, loading, error }] = useKeepLocationRemindersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useKeepLocationRemindersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    KeepLocationRemindersMutation,
    KeepLocationRemindersMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    KeepLocationRemindersMutation,
    KeepLocationRemindersMutationVariables
  >(KeepLocationRemindersDocument, options);
}
export type KeepLocationRemindersMutationHookResult = ReturnType<
  typeof useKeepLocationRemindersMutation
>;
export type KeepLocationRemindersMutationResult =
  Apollo.MutationResult<KeepLocationRemindersMutation>;
export type KeepLocationRemindersMutationOptions = Apollo.BaseMutationOptions<
  KeepLocationRemindersMutation,
  KeepLocationRemindersMutationVariables
>;
export const LocationDocument = gql`
  query Location($_id: String!) {
    location(_id: $_id) {
      ...LocationData
    }
  }
  ${LocationDataFragmentDoc}
`;

/**
 * __useLocationQuery__
 *
 * To run a query within a React component, call `useLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useLocationQuery(
  baseOptions: Apollo.QueryHookOptions<LocationQuery, LocationQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LocationQuery, LocationQueryVariables>(
    LocationDocument,
    options,
  );
}
export function useLocationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LocationQuery,
    LocationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LocationQuery, LocationQueryVariables>(
    LocationDocument,
    options,
  );
}
export type LocationQueryHookResult = ReturnType<typeof useLocationQuery>;
export type LocationLazyQueryHookResult = ReturnType<
  typeof useLocationLazyQuery
>;
export type LocationQueryResult = Apollo.QueryResult<
  LocationQuery,
  LocationQueryVariables
>;
export const LocationsDocument = gql`
  query Locations($ids: [String!]) {
    locations(ids: $ids) {
      ...LocationData
    }
  }
  ${LocationDataFragmentDoc}
`;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLocationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LocationsQuery,
    LocationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(
    LocationsDocument,
    options,
  );
}
export function useLocationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LocationsQuery,
    LocationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(
    LocationsDocument,
    options,
  );
}
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<
  typeof useLocationsLazyQuery
>;
export type LocationsQueryResult = Apollo.QueryResult<
  LocationsQuery,
  LocationsQueryVariables
>;
export const LocationsForUserDocument = gql`
  query LocationsForUser(
    $after: String
    $before: String
    $sort: String
    $first: Int
    $last: Int
  ) {
    locationsForUser(
      after: $after
      before: $before
      sort: $sort
      first: $first
      last: $last
    ) {
      totalCount
      edges {
        cursor
        node {
          ...LocationData
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${LocationDataFragmentDoc}
`;

/**
 * __useLocationsForUserQuery__
 *
 * To run a query within a React component, call `useLocationsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsForUserQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useLocationsForUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    LocationsForUserQuery,
    LocationsForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<LocationsForUserQuery, LocationsForUserQueryVariables>(
    LocationsForUserDocument,
    options,
  );
}
export function useLocationsForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LocationsForUserQuery,
    LocationsForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LocationsForUserQuery,
    LocationsForUserQueryVariables
  >(LocationsForUserDocument, options);
}
export type LocationsForUserQueryHookResult = ReturnType<
  typeof useLocationsForUserQuery
>;
export type LocationsForUserLazyQueryHookResult = ReturnType<
  typeof useLocationsForUserLazyQuery
>;
export type LocationsForUserQueryResult = Apollo.QueryResult<
  LocationsForUserQuery,
  LocationsForUserQueryVariables
>;
export const CreateLocationDocument = gql`
  mutation CreateLocation($location: LocationCreateInput!) {
    createLocation(location: $location) {
      location {
        ...LocationData
      }
    }
  }
  ${LocationDataFragmentDoc}
`;
export type CreateLocationMutationFn = Apollo.MutationFunction<
  CreateLocationMutation,
  CreateLocationMutationVariables
>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useCreateLocationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLocationMutation,
    CreateLocationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateLocationMutation,
    CreateLocationMutationVariables
  >(CreateLocationDocument, options);
}
export type CreateLocationMutationHookResult = ReturnType<
  typeof useCreateLocationMutation
>;
export type CreateLocationMutationResult =
  Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<
  CreateLocationMutation,
  CreateLocationMutationVariables
>;
export const UpdateLocationDocument = gql`
  mutation UpdateLocation($location: LocationUpdateInput!) {
    updateLocation(location: $location) {
      location {
        ...LocationData
      }
    }
  }
  ${LocationDataFragmentDoc}
`;
export type UpdateLocationMutationFn = Apollo.MutationFunction<
  UpdateLocationMutation,
  UpdateLocationMutationVariables
>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useUpdateLocationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLocationMutation,
    UpdateLocationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateLocationMutation,
    UpdateLocationMutationVariables
  >(UpdateLocationDocument, options);
}
export type UpdateLocationMutationHookResult = ReturnType<
  typeof useUpdateLocationMutation
>;
export type UpdateLocationMutationResult =
  Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<
  UpdateLocationMutation,
  UpdateLocationMutationVariables
>;
export const CreateMessageToTherapistDocument = gql`
  mutation CreateMessageToTherapist($input: MessageToTherapistInput!) {
    createMessageToTherapist(input: $input) {
      success
    }
  }
`;
export type CreateMessageToTherapistMutationFn = Apollo.MutationFunction<
  CreateMessageToTherapistMutation,
  CreateMessageToTherapistMutationVariables
>;

/**
 * __useCreateMessageToTherapistMutation__
 *
 * To run a mutation, you first call `useCreateMessageToTherapistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageToTherapistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageToTherapistMutation, { data, loading, error }] = useCreateMessageToTherapistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessageToTherapistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateMessageToTherapistMutation,
    CreateMessageToTherapistMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateMessageToTherapistMutation,
    CreateMessageToTherapistMutationVariables
  >(CreateMessageToTherapistDocument, options);
}
export type CreateMessageToTherapistMutationHookResult = ReturnType<
  typeof useCreateMessageToTherapistMutation
>;
export type CreateMessageToTherapistMutationResult =
  Apollo.MutationResult<CreateMessageToTherapistMutation>;
export type CreateMessageToTherapistMutationOptions =
  Apollo.BaseMutationOptions<
    CreateMessageToTherapistMutation,
    CreateMessageToTherapistMutationVariables
  >;
export const UpdateMessageReadDocument = gql`
  mutation updateMessageRead($input: MessageReadInput!) {
    updateMessageRead(input: $input) {
      success
    }
  }
`;
export type UpdateMessageReadMutationFn = Apollo.MutationFunction<
  UpdateMessageReadMutation,
  UpdateMessageReadMutationVariables
>;

/**
 * __useUpdateMessageReadMutation__
 *
 * To run a mutation, you first call `useUpdateMessageReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageReadMutation, { data, loading, error }] = useUpdateMessageReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMessageReadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateMessageReadMutation,
    UpdateMessageReadMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateMessageReadMutation,
    UpdateMessageReadMutationVariables
  >(UpdateMessageReadDocument, options);
}
export type UpdateMessageReadMutationHookResult = ReturnType<
  typeof useUpdateMessageReadMutation
>;
export type UpdateMessageReadMutationResult =
  Apollo.MutationResult<UpdateMessageReadMutation>;
export type UpdateMessageReadMutationOptions = Apollo.BaseMutationOptions<
  UpdateMessageReadMutation,
  UpdateMessageReadMutationVariables
>;
export const MyChangesDocument = gql`
  query MyChanges {
    myChanges {
      subject
      changes {
        goalId
        label
        linkedValues
        status
        outcome
        lastActivityAt
      }
    }
  }
`;

/**
 * __useMyChangesQuery__
 *
 * To run a query within a React component, call `useMyChangesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyChangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyChangesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyChangesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyChangesQuery,
    MyChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyChangesQuery, MyChangesQueryVariables>(
    MyChangesDocument,
    options,
  );
}
export function useMyChangesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyChangesQuery,
    MyChangesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyChangesQuery, MyChangesQueryVariables>(
    MyChangesDocument,
    options,
  );
}
export type MyChangesQueryHookResult = ReturnType<typeof useMyChangesQuery>;
export type MyChangesLazyQueryHookResult = ReturnType<
  typeof useMyChangesLazyQuery
>;
export type MyChangesQueryResult = Apollo.QueryResult<
  MyChangesQuery,
  MyChangesQueryVariables
>;
export const ChangeJourneyDocument = gql`
  query ChangeJourney($goalId: ID!) {
    changeJourney(goalId: $goalId) {
      ...ChangeJourneyFields
    }
  }
  ${ChangeJourneyFieldsFragmentDoc}
`;

/**
 * __useChangeJourneyQuery__
 *
 * To run a query within a React component, call `useChangeJourneyQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeJourneyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeJourneyQuery({
 *   variables: {
 *      goalId: // value for 'goalId'
 *   },
 * });
 */
export function useChangeJourneyQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChangeJourneyQuery,
    ChangeJourneyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChangeJourneyQuery, ChangeJourneyQueryVariables>(
    ChangeJourneyDocument,
    options,
  );
}
export function useChangeJourneyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChangeJourneyQuery,
    ChangeJourneyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChangeJourneyQuery, ChangeJourneyQueryVariables>(
    ChangeJourneyDocument,
    options,
  );
}
export type ChangeJourneyQueryHookResult = ReturnType<
  typeof useChangeJourneyQuery
>;
export type ChangeJourneyLazyQueryHookResult = ReturnType<
  typeof useChangeJourneyLazyQuery
>;
export type ChangeJourneyQueryResult = Apollo.QueryResult<
  ChangeJourneyQuery,
  ChangeJourneyQueryVariables
>;
export const ClientChangeGoalsDocument = gql`
  query ClientChangeGoals($subject: ID!) {
    clientChangeGoals(subject: $subject) {
      subject
      changes {
        ...ChangeJourneyFields
      }
      urica {
        ...UricaReadingFields
      }
    }
  }
  ${ChangeJourneyFieldsFragmentDoc}
  ${UricaReadingFieldsFragmentDoc}
`;

/**
 * __useClientChangeGoalsQuery__
 *
 * To run a query within a React component, call `useClientChangeGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientChangeGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientChangeGoalsQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useClientChangeGoalsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientChangeGoalsQuery,
    ClientChangeGoalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientChangeGoalsQuery,
    ClientChangeGoalsQueryVariables
  >(ClientChangeGoalsDocument, options);
}
export function useClientChangeGoalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientChangeGoalsQuery,
    ClientChangeGoalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientChangeGoalsQuery,
    ClientChangeGoalsQueryVariables
  >(ClientChangeGoalsDocument, options);
}
export type ClientChangeGoalsQueryHookResult = ReturnType<
  typeof useClientChangeGoalsQuery
>;
export type ClientChangeGoalsLazyQueryHookResult = ReturnType<
  typeof useClientChangeGoalsLazyQuery
>;
export type ClientChangeGoalsQueryResult = Apollo.QueryResult<
  ClientChangeGoalsQuery,
  ClientChangeGoalsQueryVariables
>;
export const SetChangeGoalDocument = gql`
  mutation SetChangeGoal($input: SetChangeGoalInput!) {
    setChangeGoal(input: $input) {
      id
      recorded
    }
  }
`;
export type SetChangeGoalMutationFn = Apollo.MutationFunction<
  SetChangeGoalMutation,
  SetChangeGoalMutationVariables
>;

/**
 * __useSetChangeGoalMutation__
 *
 * To run a mutation, you first call `useSetChangeGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChangeGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChangeGoalMutation, { data, loading, error }] = useSetChangeGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetChangeGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetChangeGoalMutation,
    SetChangeGoalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetChangeGoalMutation,
    SetChangeGoalMutationVariables
  >(SetChangeGoalDocument, options);
}
export type SetChangeGoalMutationHookResult = ReturnType<
  typeof useSetChangeGoalMutation
>;
export type SetChangeGoalMutationResult =
  Apollo.MutationResult<SetChangeGoalMutation>;
export type SetChangeGoalMutationOptions = Apollo.BaseMutationOptions<
  SetChangeGoalMutation,
  SetChangeGoalMutationVariables
>;
export const RateChangeDocument = gql`
  mutation RateChange($input: RateChangeInput!) {
    rateChange(input: $input) {
      id
      recorded
    }
  }
`;
export type RateChangeMutationFn = Apollo.MutationFunction<
  RateChangeMutation,
  RateChangeMutationVariables
>;

/**
 * __useRateChangeMutation__
 *
 * To run a mutation, you first call `useRateChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateChangeMutation, { data, loading, error }] = useRateChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRateChangeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RateChangeMutation,
    RateChangeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RateChangeMutation, RateChangeMutationVariables>(
    RateChangeDocument,
    options,
  );
}
export type RateChangeMutationHookResult = ReturnType<
  typeof useRateChangeMutation
>;
export type RateChangeMutationResult =
  Apollo.MutationResult<RateChangeMutation>;
export type RateChangeMutationOptions = Apollo.BaseMutationOptions<
  RateChangeMutation,
  RateChangeMutationVariables
>;
export const WriteDecisionalBalanceDocument = gql`
  mutation WriteDecisionalBalance($input: WriteDecisionalBalanceInput!) {
    writeDecisionalBalance(input: $input) {
      id
      recorded
    }
  }
`;
export type WriteDecisionalBalanceMutationFn = Apollo.MutationFunction<
  WriteDecisionalBalanceMutation,
  WriteDecisionalBalanceMutationVariables
>;

/**
 * __useWriteDecisionalBalanceMutation__
 *
 * To run a mutation, you first call `useWriteDecisionalBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteDecisionalBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeDecisionalBalanceMutation, { data, loading, error }] = useWriteDecisionalBalanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWriteDecisionalBalanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WriteDecisionalBalanceMutation,
    WriteDecisionalBalanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WriteDecisionalBalanceMutation,
    WriteDecisionalBalanceMutationVariables
  >(WriteDecisionalBalanceDocument, options);
}
export type WriteDecisionalBalanceMutationHookResult = ReturnType<
  typeof useWriteDecisionalBalanceMutation
>;
export type WriteDecisionalBalanceMutationResult =
  Apollo.MutationResult<WriteDecisionalBalanceMutation>;
export type WriteDecisionalBalanceMutationOptions = Apollo.BaseMutationOptions<
  WriteDecisionalBalanceMutation,
  WriteDecisionalBalanceMutationVariables
>;
export const WriteChangePlanDocument = gql`
  mutation WriteChangePlan($input: WriteChangePlanInput!) {
    writeChangePlan(input: $input) {
      id
      recorded
    }
  }
`;
export type WriteChangePlanMutationFn = Apollo.MutationFunction<
  WriteChangePlanMutation,
  WriteChangePlanMutationVariables
>;

/**
 * __useWriteChangePlanMutation__
 *
 * To run a mutation, you first call `useWriteChangePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteChangePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeChangePlanMutation, { data, loading, error }] = useWriteChangePlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWriteChangePlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WriteChangePlanMutation,
    WriteChangePlanMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WriteChangePlanMutation,
    WriteChangePlanMutationVariables
  >(WriteChangePlanDocument, options);
}
export type WriteChangePlanMutationHookResult = ReturnType<
  typeof useWriteChangePlanMutation
>;
export type WriteChangePlanMutationResult =
  Apollo.MutationResult<WriteChangePlanMutation>;
export type WriteChangePlanMutationOptions = Apollo.BaseMutationOptions<
  WriteChangePlanMutation,
  WriteChangePlanMutationVariables
>;
export const NoteChangeTalkDocument = gql`
  mutation NoteChangeTalk($input: NoteChangeTalkInput!) {
    noteChangeTalk(input: $input) {
      id
      recorded
    }
  }
`;
export type NoteChangeTalkMutationFn = Apollo.MutationFunction<
  NoteChangeTalkMutation,
  NoteChangeTalkMutationVariables
>;

/**
 * __useNoteChangeTalkMutation__
 *
 * To run a mutation, you first call `useNoteChangeTalkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteChangeTalkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteChangeTalkMutation, { data, loading, error }] = useNoteChangeTalkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNoteChangeTalkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NoteChangeTalkMutation,
    NoteChangeTalkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    NoteChangeTalkMutation,
    NoteChangeTalkMutationVariables
  >(NoteChangeTalkDocument, options);
}
export type NoteChangeTalkMutationHookResult = ReturnType<
  typeof useNoteChangeTalkMutation
>;
export type NoteChangeTalkMutationResult =
  Apollo.MutationResult<NoteChangeTalkMutation>;
export type NoteChangeTalkMutationOptions = Apollo.BaseMutationOptions<
  NoteChangeTalkMutation,
  NoteChangeTalkMutationVariables
>;
export const CloseChangeGoalDocument = gql`
  mutation CloseChangeGoal($input: CloseChangeGoalInput!) {
    closeChangeGoal(input: $input) {
      id
      recorded
    }
  }
`;
export type CloseChangeGoalMutationFn = Apollo.MutationFunction<
  CloseChangeGoalMutation,
  CloseChangeGoalMutationVariables
>;

/**
 * __useCloseChangeGoalMutation__
 *
 * To run a mutation, you first call `useCloseChangeGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseChangeGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeChangeGoalMutation, { data, loading, error }] = useCloseChangeGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseChangeGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloseChangeGoalMutation,
    CloseChangeGoalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CloseChangeGoalMutation,
    CloseChangeGoalMutationVariables
  >(CloseChangeGoalDocument, options);
}
export type CloseChangeGoalMutationHookResult = ReturnType<
  typeof useCloseChangeGoalMutation
>;
export type CloseChangeGoalMutationResult =
  Apollo.MutationResult<CloseChangeGoalMutation>;
export type CloseChangeGoalMutationOptions = Apollo.BaseMutationOptions<
  CloseChangeGoalMutation,
  CloseChangeGoalMutationVariables
>;
export const ReopenChangeGoalDocument = gql`
  mutation ReopenChangeGoal($input: ReopenChangeGoalInput!) {
    reopenChangeGoal(input: $input) {
      id
      recorded
    }
  }
`;
export type ReopenChangeGoalMutationFn = Apollo.MutationFunction<
  ReopenChangeGoalMutation,
  ReopenChangeGoalMutationVariables
>;

/**
 * __useReopenChangeGoalMutation__
 *
 * To run a mutation, you first call `useReopenChangeGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenChangeGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenChangeGoalMutation, { data, loading, error }] = useReopenChangeGoalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReopenChangeGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReopenChangeGoalMutation,
    ReopenChangeGoalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReopenChangeGoalMutation,
    ReopenChangeGoalMutationVariables
  >(ReopenChangeGoalDocument, options);
}
export type ReopenChangeGoalMutationHookResult = ReturnType<
  typeof useReopenChangeGoalMutation
>;
export type ReopenChangeGoalMutationResult =
  Apollo.MutationResult<ReopenChangeGoalMutation>;
export type ReopenChangeGoalMutationOptions = Apollo.BaseMutationOptions<
  ReopenChangeGoalMutation,
  ReopenChangeGoalMutationVariables
>;
export const PathwaysDocument = gql`
  query Pathways($includeRetired: Boolean) {
    pathways(includeRetired: $includeRetired) {
      capabilities
      pathways {
        pathwayId
        practiceId
        name
        description
        visibility
        version
        stepsCount
        status
        enrolledCount
        runningCount
        completedCount
        copiedFrom
        copiedFromName
        accessRule
        reviewStatus
        reason
        occurredAt
      }
    }
  }
`;

/**
 * __usePathwaysQuery__
 *
 * To run a query within a React component, call `usePathwaysQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwaysQuery({
 *   variables: {
 *      includeRetired: // value for 'includeRetired'
 *   },
 * });
 */
export function usePathwaysQuery(
  baseOptions?: Apollo.QueryHookOptions<PathwaysQuery, PathwaysQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PathwaysQuery, PathwaysQueryVariables>(
    PathwaysDocument,
    options,
  );
}
export function usePathwaysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathwaysQuery,
    PathwaysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PathwaysQuery, PathwaysQueryVariables>(
    PathwaysDocument,
    options,
  );
}
export type PathwaysQueryHookResult = ReturnType<typeof usePathwaysQuery>;
export type PathwaysLazyQueryHookResult = ReturnType<
  typeof usePathwaysLazyQuery
>;
export type PathwaysQueryResult = Apollo.QueryResult<
  PathwaysQuery,
  PathwaysQueryVariables
>;
export const PathwayDocument = gql`
  query Pathway($pathwayId: ID!) {
    pathway(pathwayId: $pathwayId) {
      pathwayId
      practiceId
      name
      description
      visibility
      version
      sections {
        ...PathwaySectionFields
      }
      copiedFrom
      copiedFromName
      retired
      library
      runningEnrollments
      accessRule
      reviewStatus
      reason
    }
  }
  ${PathwaySectionFieldsFragmentDoc}
`;

/**
 * __usePathwayQuery__
 *
 * To run a query within a React component, call `usePathwayQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwayQuery({
 *   variables: {
 *      pathwayId: // value for 'pathwayId'
 *   },
 * });
 */
export function usePathwayQuery(
  baseOptions: Apollo.QueryHookOptions<PathwayQuery, PathwayQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PathwayQuery, PathwayQueryVariables>(
    PathwayDocument,
    options,
  );
}
export function usePathwayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathwayQuery,
    PathwayQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PathwayQuery, PathwayQueryVariables>(
    PathwayDocument,
    options,
  );
}
export type PathwayQueryHookResult = ReturnType<typeof usePathwayQuery>;
export type PathwayLazyQueryHookResult = ReturnType<typeof usePathwayLazyQuery>;
export type PathwayQueryResult = Apollo.QueryResult<
  PathwayQuery,
  PathwayQueryVariables
>;
export const PathwayProgressDocument = gql`
  query PathwayProgress($enrollmentId: ID!) {
    pathwayProgress(enrollmentId: $enrollmentId) {
      ...PathwayProgressFields
    }
  }
  ${PathwayProgressFieldsFragmentDoc}
`;

/**
 * __usePathwayProgressQuery__
 *
 * To run a query within a React component, call `usePathwayProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwayProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwayProgressQuery({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *   },
 * });
 */
export function usePathwayProgressQuery(
  baseOptions: Apollo.QueryHookOptions<
    PathwayProgressQuery,
    PathwayProgressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PathwayProgressQuery, PathwayProgressQueryVariables>(
    PathwayProgressDocument,
    options,
  );
}
export function usePathwayProgressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathwayProgressQuery,
    PathwayProgressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PathwayProgressQuery,
    PathwayProgressQueryVariables
  >(PathwayProgressDocument, options);
}
export type PathwayProgressQueryHookResult = ReturnType<
  typeof usePathwayProgressQuery
>;
export type PathwayProgressLazyQueryHookResult = ReturnType<
  typeof usePathwayProgressLazyQuery
>;
export type PathwayProgressQueryResult = Apollo.QueryResult<
  PathwayProgressQuery,
  PathwayProgressQueryVariables
>;
export const ClientPathwaysDocument = gql`
  query ClientPathways($subject: ID!) {
    clientPathways(subject: $subject) {
      ...PathwayProgressFields
    }
  }
  ${PathwayProgressFieldsFragmentDoc}
`;

/**
 * __useClientPathwaysQuery__
 *
 * To run a query within a React component, call `useClientPathwaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientPathwaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientPathwaysQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useClientPathwaysQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientPathwaysQuery,
    ClientPathwaysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClientPathwaysQuery, ClientPathwaysQueryVariables>(
    ClientPathwaysDocument,
    options,
  );
}
export function useClientPathwaysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientPathwaysQuery,
    ClientPathwaysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClientPathwaysQuery, ClientPathwaysQueryVariables>(
    ClientPathwaysDocument,
    options,
  );
}
export type ClientPathwaysQueryHookResult = ReturnType<
  typeof useClientPathwaysQuery
>;
export type ClientPathwaysLazyQueryHookResult = ReturnType<
  typeof useClientPathwaysLazyQuery
>;
export type ClientPathwaysQueryResult = Apollo.QueryResult<
  ClientPathwaysQuery,
  ClientPathwaysQueryVariables
>;
export const PathwayOutcomesDocument = gql`
  query PathwayOutcomes {
    pathwayOutcomes {
      pathwayId
      pathwayName
      copiedFrom
      copiedFromName
      depth
      retired
      enrolledCount
      runningCount
      completedCount
      withdrawnCount
      completionRate
      medianDaysToComplete
    }
  }
`;

/**
 * __usePathwayOutcomesQuery__
 *
 * To run a query within a React component, call `usePathwayOutcomesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePathwayOutcomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePathwayOutcomesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePathwayOutcomesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PathwayOutcomesQuery,
    PathwayOutcomesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PathwayOutcomesQuery, PathwayOutcomesQueryVariables>(
    PathwayOutcomesDocument,
    options,
  );
}
export function usePathwayOutcomesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PathwayOutcomesQuery,
    PathwayOutcomesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PathwayOutcomesQuery,
    PathwayOutcomesQueryVariables
  >(PathwayOutcomesDocument, options);
}
export type PathwayOutcomesQueryHookResult = ReturnType<
  typeof usePathwayOutcomesQuery
>;
export type PathwayOutcomesLazyQueryHookResult = ReturnType<
  typeof usePathwayOutcomesLazyQuery
>;
export type PathwayOutcomesQueryResult = Apollo.QueryResult<
  PathwayOutcomesQuery,
  PathwayOutcomesQueryVariables
>;
export const MyPathwaysDocument = gql`
  query MyPathways {
    myPathways {
      ...MyPathwayFields
    }
  }
  ${MyPathwayFieldsFragmentDoc}
`;

/**
 * __useMyPathwaysQuery__
 *
 * To run a query within a React component, call `useMyPathwaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPathwaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPathwaysQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPathwaysQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyPathwaysQuery,
    MyPathwaysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyPathwaysQuery, MyPathwaysQueryVariables>(
    MyPathwaysDocument,
    options,
  );
}
export function useMyPathwaysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyPathwaysQuery,
    MyPathwaysQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyPathwaysQuery, MyPathwaysQueryVariables>(
    MyPathwaysDocument,
    options,
  );
}
export type MyPathwaysQueryHookResult = ReturnType<typeof useMyPathwaysQuery>;
export type MyPathwaysLazyQueryHookResult = ReturnType<
  typeof useMyPathwaysLazyQuery
>;
export type MyPathwaysQueryResult = Apollo.QueryResult<
  MyPathwaysQuery,
  MyPathwaysQueryVariables
>;
export const PublicCoursesDocument = gql`
  query PublicCourses {
    publicCourses {
      ...PublicCourseFields
    }
  }
  ${PublicCourseFieldsFragmentDoc}
`;

/**
 * __usePublicCoursesQuery__
 *
 * To run a query within a React component, call `usePublicCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicCoursesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PublicCoursesQuery,
    PublicCoursesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PublicCoursesQuery, PublicCoursesQueryVariables>(
    PublicCoursesDocument,
    options,
  );
}
export function usePublicCoursesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PublicCoursesQuery,
    PublicCoursesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PublicCoursesQuery, PublicCoursesQueryVariables>(
    PublicCoursesDocument,
    options,
  );
}
export type PublicCoursesQueryHookResult = ReturnType<
  typeof usePublicCoursesQuery
>;
export type PublicCoursesLazyQueryHookResult = ReturnType<
  typeof usePublicCoursesLazyQuery
>;
export type PublicCoursesQueryResult = Apollo.QueryResult<
  PublicCoursesQuery,
  PublicCoursesQueryVariables
>;
export const DefinePathwayDocument = gql`
  mutation DefinePathway($input: DefinePathwayInput!) {
    definePathway(input: $input) {
      pathwayId
      version
      recorded
    }
  }
`;
export type DefinePathwayMutationFn = Apollo.MutationFunction<
  DefinePathwayMutation,
  DefinePathwayMutationVariables
>;

/**
 * __useDefinePathwayMutation__
 *
 * To run a mutation, you first call `useDefinePathwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefinePathwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [definePathwayMutation, { data, loading, error }] = useDefinePathwayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefinePathwayMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DefinePathwayMutation,
    DefinePathwayMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DefinePathwayMutation,
    DefinePathwayMutationVariables
  >(DefinePathwayDocument, options);
}
export type DefinePathwayMutationHookResult = ReturnType<
  typeof useDefinePathwayMutation
>;
export type DefinePathwayMutationResult =
  Apollo.MutationResult<DefinePathwayMutation>;
export type DefinePathwayMutationOptions = Apollo.BaseMutationOptions<
  DefinePathwayMutation,
  DefinePathwayMutationVariables
>;
export const RevisePathwayDocument = gql`
  mutation RevisePathway($input: RevisePathwayInput!) {
    revisePathway(input: $input) {
      pathwayId
      version
      recorded
    }
  }
`;
export type RevisePathwayMutationFn = Apollo.MutationFunction<
  RevisePathwayMutation,
  RevisePathwayMutationVariables
>;

/**
 * __useRevisePathwayMutation__
 *
 * To run a mutation, you first call `useRevisePathwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevisePathwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revisePathwayMutation, { data, loading, error }] = useRevisePathwayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevisePathwayMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RevisePathwayMutation,
    RevisePathwayMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RevisePathwayMutation,
    RevisePathwayMutationVariables
  >(RevisePathwayDocument, options);
}
export type RevisePathwayMutationHookResult = ReturnType<
  typeof useRevisePathwayMutation
>;
export type RevisePathwayMutationResult =
  Apollo.MutationResult<RevisePathwayMutation>;
export type RevisePathwayMutationOptions = Apollo.BaseMutationOptions<
  RevisePathwayMutation,
  RevisePathwayMutationVariables
>;
export const RetirePathwayDocument = gql`
  mutation RetirePathway($input: RetirePathwayInput!) {
    retirePathway(input: $input) {
      pathwayId
      version
      recorded
    }
  }
`;
export type RetirePathwayMutationFn = Apollo.MutationFunction<
  RetirePathwayMutation,
  RetirePathwayMutationVariables
>;

/**
 * __useRetirePathwayMutation__
 *
 * To run a mutation, you first call `useRetirePathwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetirePathwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retirePathwayMutation, { data, loading, error }] = useRetirePathwayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetirePathwayMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetirePathwayMutation,
    RetirePathwayMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetirePathwayMutation,
    RetirePathwayMutationVariables
  >(RetirePathwayDocument, options);
}
export type RetirePathwayMutationHookResult = ReturnType<
  typeof useRetirePathwayMutation
>;
export type RetirePathwayMutationResult =
  Apollo.MutationResult<RetirePathwayMutation>;
export type RetirePathwayMutationOptions = Apollo.BaseMutationOptions<
  RetirePathwayMutation,
  RetirePathwayMutationVariables
>;
export const EnrollInPathwayDocument = gql`
  mutation EnrollInPathway($input: EnrollInPathwayInput!) {
    enrollInPathway(input: $input) {
      enrollmentId
      recorded
    }
  }
`;
export type EnrollInPathwayMutationFn = Apollo.MutationFunction<
  EnrollInPathwayMutation,
  EnrollInPathwayMutationVariables
>;

/**
 * __useEnrollInPathwayMutation__
 *
 * To run a mutation, you first call `useEnrollInPathwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollInPathwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollInPathwayMutation, { data, loading, error }] = useEnrollInPathwayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnrollInPathwayMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnrollInPathwayMutation,
    EnrollInPathwayMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EnrollInPathwayMutation,
    EnrollInPathwayMutationVariables
  >(EnrollInPathwayDocument, options);
}
export type EnrollInPathwayMutationHookResult = ReturnType<
  typeof useEnrollInPathwayMutation
>;
export type EnrollInPathwayMutationResult =
  Apollo.MutationResult<EnrollInPathwayMutation>;
export type EnrollInPathwayMutationOptions = Apollo.BaseMutationOptions<
  EnrollInPathwayMutation,
  EnrollInPathwayMutationVariables
>;
export const ReleasePathwayStepDocument = gql`
  mutation ReleasePathwayStep($input: ReleasePathwayStepInput!) {
    releasePathwayStep(input: $input) {
      enrollmentId
      assignmentId
      recorded
    }
  }
`;
export type ReleasePathwayStepMutationFn = Apollo.MutationFunction<
  ReleasePathwayStepMutation,
  ReleasePathwayStepMutationVariables
>;

/**
 * __useReleasePathwayStepMutation__
 *
 * To run a mutation, you first call `useReleasePathwayStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleasePathwayStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releasePathwayStepMutation, { data, loading, error }] = useReleasePathwayStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReleasePathwayStepMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReleasePathwayStepMutation,
    ReleasePathwayStepMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReleasePathwayStepMutation,
    ReleasePathwayStepMutationVariables
  >(ReleasePathwayStepDocument, options);
}
export type ReleasePathwayStepMutationHookResult = ReturnType<
  typeof useReleasePathwayStepMutation
>;
export type ReleasePathwayStepMutationResult =
  Apollo.MutationResult<ReleasePathwayStepMutation>;
export type ReleasePathwayStepMutationOptions = Apollo.BaseMutationOptions<
  ReleasePathwayStepMutation,
  ReleasePathwayStepMutationVariables
>;
export const WithdrawFromPathwayDocument = gql`
  mutation WithdrawFromPathway($input: WithdrawFromPathwayInput!) {
    withdrawFromPathway(input: $input) {
      enrollmentId
      recorded
    }
  }
`;
export type WithdrawFromPathwayMutationFn = Apollo.MutationFunction<
  WithdrawFromPathwayMutation,
  WithdrawFromPathwayMutationVariables
>;

/**
 * __useWithdrawFromPathwayMutation__
 *
 * To run a mutation, you first call `useWithdrawFromPathwayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawFromPathwayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawFromPathwayMutation, { data, loading, error }] = useWithdrawFromPathwayMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWithdrawFromPathwayMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WithdrawFromPathwayMutation,
    WithdrawFromPathwayMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WithdrawFromPathwayMutation,
    WithdrawFromPathwayMutationVariables
  >(WithdrawFromPathwayDocument, options);
}
export type WithdrawFromPathwayMutationHookResult = ReturnType<
  typeof useWithdrawFromPathwayMutation
>;
export type WithdrawFromPathwayMutationResult =
  Apollo.MutationResult<WithdrawFromPathwayMutation>;
export type WithdrawFromPathwayMutationOptions = Apollo.BaseMutationOptions<
  WithdrawFromPathwayMutation,
  WithdrawFromPathwayMutationVariables
>;
export const RecordCoursePurchaseDocument = gql`
  mutation RecordCoursePurchase($input: RecordCoursePurchaseInput!) {
    recordCoursePurchase(input: $input) {
      storeProductId
      owned
      recorded
    }
  }
`;
export type RecordCoursePurchaseMutationFn = Apollo.MutationFunction<
  RecordCoursePurchaseMutation,
  RecordCoursePurchaseMutationVariables
>;

/**
 * __useRecordCoursePurchaseMutation__
 *
 * To run a mutation, you first call `useRecordCoursePurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordCoursePurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordCoursePurchaseMutation, { data, loading, error }] = useRecordCoursePurchaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordCoursePurchaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordCoursePurchaseMutation,
    RecordCoursePurchaseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordCoursePurchaseMutation,
    RecordCoursePurchaseMutationVariables
  >(RecordCoursePurchaseDocument, options);
}
export type RecordCoursePurchaseMutationHookResult = ReturnType<
  typeof useRecordCoursePurchaseMutation
>;
export type RecordCoursePurchaseMutationResult =
  Apollo.MutationResult<RecordCoursePurchaseMutation>;
export type RecordCoursePurchaseMutationOptions = Apollo.BaseMutationOptions<
  RecordCoursePurchaseMutation,
  RecordCoursePurchaseMutationVariables
>;
export const ProfilesDocument = gql`
  query Profiles($sort: String, $where: JSON, $start: Int, $limit: Int) {
    profiles(sort: $sort, where: $where, start: $start, limit: $limit) {
      data {
        _id
        ...ProfileData
      }
      count
    }
  }
  ${ProfileDataFragmentDoc}
`;

/**
 * __useProfilesQuery__
 *
 * To run a query within a React component, call `useProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProfilesQuery(
  baseOptions?: Apollo.QueryHookOptions<ProfilesQuery, ProfilesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProfilesQuery, ProfilesQueryVariables>(
    ProfilesDocument,
    options,
  );
}
export function useProfilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProfilesQuery,
    ProfilesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProfilesQuery, ProfilesQueryVariables>(
    ProfilesDocument,
    options,
  );
}
export type ProfilesQueryHookResult = ReturnType<typeof useProfilesQuery>;
export type ProfilesLazyQueryHookResult = ReturnType<
  typeof useProfilesLazyQuery
>;
export type ProfilesQueryResult = Apollo.QueryResult<
  ProfilesQuery,
  ProfilesQueryVariables
>;
export const ProfileDocument = gql`
  query Profile($id: ID!) {
    profile(id: $id) {
      _id
      ...ProfileData
    }
  }
  ${ProfileDataFragmentDoc}
`;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileQuery(
  baseOptions: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(
    ProfileDocument,
    options,
  );
}
export function useProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProfileQuery,
    ProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(
    ProfileDocument,
    options,
  );
}
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = Apollo.QueryResult<
  ProfileQuery,
  ProfileQueryVariables
>;
export const UpdateSafetyPlanSectionDocument = gql`
  mutation UpdateSafetyPlanSection($input: UpdateSafetyPlanSectionInput!) {
    updateSafetyPlanSection(input: $input) {
      planId
      recorded
    }
  }
`;
export type UpdateSafetyPlanSectionMutationFn = Apollo.MutationFunction<
  UpdateSafetyPlanSectionMutation,
  UpdateSafetyPlanSectionMutationVariables
>;

/**
 * __useUpdateSafetyPlanSectionMutation__
 *
 * To run a mutation, you first call `useUpdateSafetyPlanSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSafetyPlanSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSafetyPlanSectionMutation, { data, loading, error }] = useUpdateSafetyPlanSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSafetyPlanSectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSafetyPlanSectionMutation,
    UpdateSafetyPlanSectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSafetyPlanSectionMutation,
    UpdateSafetyPlanSectionMutationVariables
  >(UpdateSafetyPlanSectionDocument, options);
}
export type UpdateSafetyPlanSectionMutationHookResult = ReturnType<
  typeof useUpdateSafetyPlanSectionMutation
>;
export type UpdateSafetyPlanSectionMutationResult =
  Apollo.MutationResult<UpdateSafetyPlanSectionMutation>;
export type UpdateSafetyPlanSectionMutationOptions = Apollo.BaseMutationOptions<
  UpdateSafetyPlanSectionMutation,
  UpdateSafetyPlanSectionMutationVariables
>;
export const UpdateSafetyPlanSectionInSessionDocument = gql`
  mutation UpdateSafetyPlanSectionInSession(
    $input: UpdateSafetyPlanSectionInSessionInput!
  ) {
    updateSafetyPlanSectionInSession(input: $input) {
      planId
      recorded
    }
  }
`;
export type UpdateSafetyPlanSectionInSessionMutationFn =
  Apollo.MutationFunction<
    UpdateSafetyPlanSectionInSessionMutation,
    UpdateSafetyPlanSectionInSessionMutationVariables
  >;

/**
 * __useUpdateSafetyPlanSectionInSessionMutation__
 *
 * To run a mutation, you first call `useUpdateSafetyPlanSectionInSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSafetyPlanSectionInSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSafetyPlanSectionInSessionMutation, { data, loading, error }] = useUpdateSafetyPlanSectionInSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSafetyPlanSectionInSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSafetyPlanSectionInSessionMutation,
    UpdateSafetyPlanSectionInSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSafetyPlanSectionInSessionMutation,
    UpdateSafetyPlanSectionInSessionMutationVariables
  >(UpdateSafetyPlanSectionInSessionDocument, options);
}
export type UpdateSafetyPlanSectionInSessionMutationHookResult = ReturnType<
  typeof useUpdateSafetyPlanSectionInSessionMutation
>;
export type UpdateSafetyPlanSectionInSessionMutationResult =
  Apollo.MutationResult<UpdateSafetyPlanSectionInSessionMutation>;
export type UpdateSafetyPlanSectionInSessionMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateSafetyPlanSectionInSessionMutation,
    UpdateSafetyPlanSectionInSessionMutationVariables
  >;
export const ReviewSafetyPlanDocument = gql`
  mutation ReviewSafetyPlan($input: ReviewSafetyPlanInput!) {
    reviewSafetyPlan(input: $input) {
      planId
      recorded
    }
  }
`;
export type ReviewSafetyPlanMutationFn = Apollo.MutationFunction<
  ReviewSafetyPlanMutation,
  ReviewSafetyPlanMutationVariables
>;

/**
 * __useReviewSafetyPlanMutation__
 *
 * To run a mutation, you first call `useReviewSafetyPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewSafetyPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewSafetyPlanMutation, { data, loading, error }] = useReviewSafetyPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewSafetyPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReviewSafetyPlanMutation,
    ReviewSafetyPlanMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReviewSafetyPlanMutation,
    ReviewSafetyPlanMutationVariables
  >(ReviewSafetyPlanDocument, options);
}
export type ReviewSafetyPlanMutationHookResult = ReturnType<
  typeof useReviewSafetyPlanMutation
>;
export type ReviewSafetyPlanMutationResult =
  Apollo.MutationResult<ReviewSafetyPlanMutation>;
export type ReviewSafetyPlanMutationOptions = Apollo.BaseMutationOptions<
  ReviewSafetyPlanMutation,
  ReviewSafetyPlanMutationVariables
>;
export const RecordSafetyPlanOpenedDocument = gql`
  mutation RecordSafetyPlanOpened($input: RecordSafetyPlanOpenedInput!) {
    recordSafetyPlanOpened(input: $input) {
      planId
      recorded
    }
  }
`;
export type RecordSafetyPlanOpenedMutationFn = Apollo.MutationFunction<
  RecordSafetyPlanOpenedMutation,
  RecordSafetyPlanOpenedMutationVariables
>;

/**
 * __useRecordSafetyPlanOpenedMutation__
 *
 * To run a mutation, you first call `useRecordSafetyPlanOpenedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordSafetyPlanOpenedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordSafetyPlanOpenedMutation, { data, loading, error }] = useRecordSafetyPlanOpenedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordSafetyPlanOpenedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordSafetyPlanOpenedMutation,
    RecordSafetyPlanOpenedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordSafetyPlanOpenedMutation,
    RecordSafetyPlanOpenedMutationVariables
  >(RecordSafetyPlanOpenedDocument, options);
}
export type RecordSafetyPlanOpenedMutationHookResult = ReturnType<
  typeof useRecordSafetyPlanOpenedMutation
>;
export type RecordSafetyPlanOpenedMutationResult =
  Apollo.MutationResult<RecordSafetyPlanOpenedMutation>;
export type RecordSafetyPlanOpenedMutationOptions = Apollo.BaseMutationOptions<
  RecordSafetyPlanOpenedMutation,
  RecordSafetyPlanOpenedMutationVariables
>;
export const SafetyPlanDocument = gql`
  query SafetyPlan($subject: ID) {
    safetyPlan(subject: $subject) {
      subject
      planId
      hasPlan
      sections {
        ...SafetyPlanSectionFields
      }
      therapists {
        id
        name
        canSee
      }
      mayEdit
    }
  }
  ${SafetyPlanSectionFieldsFragmentDoc}
`;

/**
 * __useSafetyPlanQuery__
 *
 * To run a query within a React component, call `useSafetyPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyPlanQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useSafetyPlanQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SafetyPlanQuery,
    SafetyPlanQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SafetyPlanQuery, SafetyPlanQueryVariables>(
    SafetyPlanDocument,
    options,
  );
}
export function useSafetyPlanLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SafetyPlanQuery,
    SafetyPlanQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SafetyPlanQuery, SafetyPlanQueryVariables>(
    SafetyPlanDocument,
    options,
  );
}
export type SafetyPlanQueryHookResult = ReturnType<typeof useSafetyPlanQuery>;
export type SafetyPlanLazyQueryHookResult = ReturnType<
  typeof useSafetyPlanLazyQuery
>;
export type SafetyPlanQueryResult = Apollo.QueryResult<
  SafetyPlanQuery,
  SafetyPlanQueryVariables
>;
export const SafetyPlanStatusDocument = gql`
  query SafetyPlanStatus($subject: ID) {
    safetyPlanStatus(subject: $subject) {
      subject
      planId
      hasPlan
      sectionsFilled
      updatedAt
      reviewedAt
      reviewedWith
      reviewedWithName
      nextReviewBy
    }
  }
`;

/**
 * __useSafetyPlanStatusQuery__
 *
 * To run a query within a React component, call `useSafetyPlanStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyPlanStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyPlanStatusQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useSafetyPlanStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SafetyPlanStatusQuery,
    SafetyPlanStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SafetyPlanStatusQuery, SafetyPlanStatusQueryVariables>(
    SafetyPlanStatusDocument,
    options,
  );
}
export function useSafetyPlanStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SafetyPlanStatusQuery,
    SafetyPlanStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SafetyPlanStatusQuery,
    SafetyPlanStatusQueryVariables
  >(SafetyPlanStatusDocument, options);
}
export type SafetyPlanStatusQueryHookResult = ReturnType<
  typeof useSafetyPlanStatusQuery
>;
export type SafetyPlanStatusLazyQueryHookResult = ReturnType<
  typeof useSafetyPlanStatusLazyQuery
>;
export type SafetyPlanStatusQueryResult = Apollo.QueryResult<
  SafetyPlanStatusQuery,
  SafetyPlanStatusQueryVariables
>;
export const SafetyPlanHistoryDocument = gql`
  query SafetyPlanHistory($subject: ID!) {
    safetyPlanHistory(subject: $subject) {
      entryId
      occurredAt
      performer
      performerName
      byClient
      kind
      section
      entries {
        ...SafetyPlanEntryFields
      }
      reviewedAt
      nextReviewBy
      note
    }
  }
  ${SafetyPlanEntryFieldsFragmentDoc}
`;

/**
 * __useSafetyPlanHistoryQuery__
 *
 * To run a query within a React component, call `useSafetyPlanHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyPlanHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyPlanHistoryQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useSafetyPlanHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    SafetyPlanHistoryQuery,
    SafetyPlanHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SafetyPlanHistoryQuery,
    SafetyPlanHistoryQueryVariables
  >(SafetyPlanHistoryDocument, options);
}
export function useSafetyPlanHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SafetyPlanHistoryQuery,
    SafetyPlanHistoryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SafetyPlanHistoryQuery,
    SafetyPlanHistoryQueryVariables
  >(SafetyPlanHistoryDocument, options);
}
export type SafetyPlanHistoryQueryHookResult = ReturnType<
  typeof useSafetyPlanHistoryQuery
>;
export type SafetyPlanHistoryLazyQueryHookResult = ReturnType<
  typeof useSafetyPlanHistoryLazyQuery
>;
export type SafetyPlanHistoryQueryResult = Apollo.QueryResult<
  SafetyPlanHistoryQuery,
  SafetyPlanHistoryQueryVariables
>;
export const SafetyPlanOpensByWeekDocument = gql`
  query SafetyPlanOpensByWeek($subject: ID!, $timeZone: String) {
    safetyPlanOpensByWeek(subject: $subject, timeZone: $timeZone) {
      subject
      thisWeek
      weeks {
        weekStart
        count
      }
    }
  }
`;

/**
 * __useSafetyPlanOpensByWeekQuery__
 *
 * To run a query within a React component, call `useSafetyPlanOpensByWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyPlanOpensByWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyPlanOpensByWeekQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useSafetyPlanOpensByWeekQuery(
  baseOptions: Apollo.QueryHookOptions<
    SafetyPlanOpensByWeekQuery,
    SafetyPlanOpensByWeekQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SafetyPlanOpensByWeekQuery,
    SafetyPlanOpensByWeekQueryVariables
  >(SafetyPlanOpensByWeekDocument, options);
}
export function useSafetyPlanOpensByWeekLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SafetyPlanOpensByWeekQuery,
    SafetyPlanOpensByWeekQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SafetyPlanOpensByWeekQuery,
    SafetyPlanOpensByWeekQueryVariables
  >(SafetyPlanOpensByWeekDocument, options);
}
export type SafetyPlanOpensByWeekQueryHookResult = ReturnType<
  typeof useSafetyPlanOpensByWeekQuery
>;
export type SafetyPlanOpensByWeekLazyQueryHookResult = ReturnType<
  typeof useSafetyPlanOpensByWeekLazyQuery
>;
export type SafetyPlanOpensByWeekQueryResult = Apollo.QueryResult<
  SafetyPlanOpensByWeekQuery,
  SafetyPlanOpensByWeekQueryVariables
>;
export const ConfigureModeSetDocument = gql`
  mutation ConfigureModeSet($input: ConfigureModeSetInput!) {
    configureModeSet(input: $input) {
      id
      recorded
    }
  }
`;
export type ConfigureModeSetMutationFn = Apollo.MutationFunction<
  ConfigureModeSetMutation,
  ConfigureModeSetMutationVariables
>;

/**
 * __useConfigureModeSetMutation__
 *
 * To run a mutation, you first call `useConfigureModeSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureModeSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureModeSetMutation, { data, loading, error }] = useConfigureModeSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureModeSetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfigureModeSetMutation,
    ConfigureModeSetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConfigureModeSetMutation,
    ConfigureModeSetMutationVariables
  >(ConfigureModeSetDocument, options);
}
export type ConfigureModeSetMutationHookResult = ReturnType<
  typeof useConfigureModeSetMutation
>;
export type ConfigureModeSetMutationResult =
  Apollo.MutationResult<ConfigureModeSetMutation>;
export type ConfigureModeSetMutationOptions = Apollo.BaseMutationOptions<
  ConfigureModeSetMutation,
  ConfigureModeSetMutationVariables
>;
export const RecordModeCheckInDocument = gql`
  mutation RecordModeCheckIn($input: RecordModeCheckInInput!) {
    recordModeCheckIn(input: $input) {
      id
      recorded
    }
  }
`;
export type RecordModeCheckInMutationFn = Apollo.MutationFunction<
  RecordModeCheckInMutation,
  RecordModeCheckInMutationVariables
>;

/**
 * __useRecordModeCheckInMutation__
 *
 * To run a mutation, you first call `useRecordModeCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordModeCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordModeCheckInMutation, { data, loading, error }] = useRecordModeCheckInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordModeCheckInMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecordModeCheckInMutation,
    RecordModeCheckInMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecordModeCheckInMutation,
    RecordModeCheckInMutationVariables
  >(RecordModeCheckInDocument, options);
}
export type RecordModeCheckInMutationHookResult = ReturnType<
  typeof useRecordModeCheckInMutation
>;
export type RecordModeCheckInMutationResult =
  Apollo.MutationResult<RecordModeCheckInMutation>;
export type RecordModeCheckInMutationOptions = Apollo.BaseMutationOptions<
  RecordModeCheckInMutation,
  RecordModeCheckInMutationVariables
>;
export const LinkCardToModeDocument = gql`
  mutation LinkCardToMode($input: LinkCardToModeInput!) {
    linkCardToMode(input: $input) {
      id
      recorded
    }
  }
`;
export type LinkCardToModeMutationFn = Apollo.MutationFunction<
  LinkCardToModeMutation,
  LinkCardToModeMutationVariables
>;

/**
 * __useLinkCardToModeMutation__
 *
 * To run a mutation, you first call `useLinkCardToModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkCardToModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkCardToModeMutation, { data, loading, error }] = useLinkCardToModeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkCardToModeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LinkCardToModeMutation,
    LinkCardToModeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LinkCardToModeMutation,
    LinkCardToModeMutationVariables
  >(LinkCardToModeDocument, options);
}
export type LinkCardToModeMutationHookResult = ReturnType<
  typeof useLinkCardToModeMutation
>;
export type LinkCardToModeMutationResult =
  Apollo.MutationResult<LinkCardToModeMutation>;
export type LinkCardToModeMutationOptions = Apollo.BaseMutationOptions<
  LinkCardToModeMutation,
  LinkCardToModeMutationVariables
>;
export const DeleteModeCheckInDocument = gql`
  mutation DeleteModeCheckIn($input: DeleteModeCheckInInput!) {
    deleteModeCheckIn(input: $input) {
      id
      recorded
    }
  }
`;
export type DeleteModeCheckInMutationFn = Apollo.MutationFunction<
  DeleteModeCheckInMutation,
  DeleteModeCheckInMutationVariables
>;

/**
 * __useDeleteModeCheckInMutation__
 *
 * To run a mutation, you first call `useDeleteModeCheckInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteModeCheckInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteModeCheckInMutation, { data, loading, error }] = useDeleteModeCheckInMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteModeCheckInMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteModeCheckInMutation,
    DeleteModeCheckInMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteModeCheckInMutation,
    DeleteModeCheckInMutationVariables
  >(DeleteModeCheckInDocument, options);
}
export type DeleteModeCheckInMutationHookResult = ReturnType<
  typeof useDeleteModeCheckInMutation
>;
export type DeleteModeCheckInMutationResult =
  Apollo.MutationResult<DeleteModeCheckInMutation>;
export type DeleteModeCheckInMutationOptions = Apollo.BaseMutationOptions<
  DeleteModeCheckInMutation,
  DeleteModeCheckInMutationVariables
>;
export const MyModeSetDocument = gql`
  query MyModeSet {
    myModeSet {
      subject
      configured
      modeMap {
        ...ModeMapEntryFields
      }
      lastChange {
        ...ModeSetChangeFields
      }
    }
  }
  ${ModeMapEntryFieldsFragmentDoc}
  ${ModeSetChangeFieldsFragmentDoc}
`;

/**
 * __useMyModeSetQuery__
 *
 * To run a query within a React component, call `useMyModeSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyModeSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyModeSetQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyModeSetQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyModeSetQuery,
    MyModeSetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyModeSetQuery, MyModeSetQueryVariables>(
    MyModeSetDocument,
    options,
  );
}
export function useMyModeSetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyModeSetQuery,
    MyModeSetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyModeSetQuery, MyModeSetQueryVariables>(
    MyModeSetDocument,
    options,
  );
}
export type MyModeSetQueryHookResult = ReturnType<typeof useMyModeSetQuery>;
export type MyModeSetLazyQueryHookResult = ReturnType<
  typeof useMyModeSetLazyQuery
>;
export type MyModeSetQueryResult = Apollo.QueryResult<
  MyModeSetQuery,
  MyModeSetQueryVariables
>;
export const ClientModeSetDocument = gql`
  query ClientModeSet($subject: ID!) {
    clientModeSet(subject: $subject) {
      subject
      configured
      modeMap {
        ...ModeMapEntryFields
      }
      lastChange {
        ...ModeSetChangeFields
      }
    }
  }
  ${ModeMapEntryFieldsFragmentDoc}
  ${ModeSetChangeFieldsFragmentDoc}
`;

/**
 * __useClientModeSetQuery__
 *
 * To run a query within a React component, call `useClientModeSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientModeSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientModeSetQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useClientModeSetQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientModeSetQuery,
    ClientModeSetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClientModeSetQuery, ClientModeSetQueryVariables>(
    ClientModeSetDocument,
    options,
  );
}
export function useClientModeSetLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientModeSetQuery,
    ClientModeSetQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ClientModeSetQuery, ClientModeSetQueryVariables>(
    ClientModeSetDocument,
    options,
  );
}
export type ClientModeSetQueryHookResult = ReturnType<
  typeof useClientModeSetQuery
>;
export type ClientModeSetLazyQueryHookResult = ReturnType<
  typeof useClientModeSetLazyQuery
>;
export type ClientModeSetQueryResult = Apollo.QueryResult<
  ClientModeSetQuery,
  ClientModeSetQueryVariables
>;
export const MyModeTimelineDocument = gql`
  query MyModeTimeline(
    $days: Int
    $from: String
    $to: String
    $timeZone: String
  ) {
    myModeTimeline(days: $days, from: $from, to: $to, timeZone: $timeZone) {
      ...ModeTimelineFields
    }
  }
  ${ModeTimelineFieldsFragmentDoc}
`;

/**
 * __useMyModeTimelineQuery__
 *
 * To run a query within a React component, call `useMyModeTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyModeTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyModeTimelineQuery({
 *   variables: {
 *      days: // value for 'days'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useMyModeTimelineQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MyModeTimelineQuery,
    MyModeTimelineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MyModeTimelineQuery, MyModeTimelineQueryVariables>(
    MyModeTimelineDocument,
    options,
  );
}
export function useMyModeTimelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MyModeTimelineQuery,
    MyModeTimelineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MyModeTimelineQuery, MyModeTimelineQueryVariables>(
    MyModeTimelineDocument,
    options,
  );
}
export type MyModeTimelineQueryHookResult = ReturnType<
  typeof useMyModeTimelineQuery
>;
export type MyModeTimelineLazyQueryHookResult = ReturnType<
  typeof useMyModeTimelineLazyQuery
>;
export type MyModeTimelineQueryResult = Apollo.QueryResult<
  MyModeTimelineQuery,
  MyModeTimelineQueryVariables
>;
export const ClientModeTimelineDocument = gql`
  query ClientModeTimeline(
    $subject: ID!
    $days: Int
    $from: String
    $to: String
    $timeZone: String
  ) {
    clientModeTimeline(
      subject: $subject
      days: $days
      from: $from
      to: $to
      timeZone: $timeZone
    ) {
      ...ModeTimelineFields
    }
  }
  ${ModeTimelineFieldsFragmentDoc}
`;

/**
 * __useClientModeTimelineQuery__
 *
 * To run a query within a React component, call `useClientModeTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientModeTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientModeTimelineQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      days: // value for 'days'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useClientModeTimelineQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientModeTimelineQuery,
    ClientModeTimelineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ClientModeTimelineQuery,
    ClientModeTimelineQueryVariables
  >(ClientModeTimelineDocument, options);
}
export function useClientModeTimelineLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientModeTimelineQuery,
    ClientModeTimelineQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientModeTimelineQuery,
    ClientModeTimelineQueryVariables
  >(ClientModeTimelineDocument, options);
}
export type ClientModeTimelineQueryHookResult = ReturnType<
  typeof useClientModeTimelineQuery
>;
export type ClientModeTimelineLazyQueryHookResult = ReturnType<
  typeof useClientModeTimelineLazyQuery
>;
export type ClientModeTimelineQueryResult = Apollo.QueryResult<
  ClientModeTimelineQuery,
  ClientModeTimelineQueryVariables
>;
export const PendingClientTransferDocument = gql`
  query PendingClientTransfer {
    pendingClientTransfer {
      newAssignee
      newAssigneeName
      practiceId
      practiceName
      requestedAt
    }
  }
`;

/**
 * __usePendingClientTransferQuery__
 *
 * To run a query within a React component, call `usePendingClientTransferQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingClientTransferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingClientTransferQuery({
 *   variables: {
 *   },
 * });
 */
export function usePendingClientTransferQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PendingClientTransferQuery,
    PendingClientTransferQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PendingClientTransferQuery,
    PendingClientTransferQueryVariables
  >(PendingClientTransferDocument, options);
}
export function usePendingClientTransferLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PendingClientTransferQuery,
    PendingClientTransferQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PendingClientTransferQuery,
    PendingClientTransferQueryVariables
  >(PendingClientTransferDocument, options);
}
export type PendingClientTransferQueryHookResult = ReturnType<
  typeof usePendingClientTransferQuery
>;
export type PendingClientTransferLazyQueryHookResult = ReturnType<
  typeof usePendingClientTransferLazyQuery
>;
export type PendingClientTransferQueryResult = Apollo.QueryResult<
  PendingClientTransferQuery,
  PendingClientTransferQueryVariables
>;
export const ConsentToClientTransferDocument = gql`
  mutation ConsentToClientTransfer($input: ConsentToClientTransferInput!) {
    consentToClientTransfer(input: $input) {
      success
      consented
    }
  }
`;
export type ConsentToClientTransferMutationFn = Apollo.MutationFunction<
  ConsentToClientTransferMutation,
  ConsentToClientTransferMutationVariables
>;

/**
 * __useConsentToClientTransferMutation__
 *
 * To run a mutation, you first call `useConsentToClientTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsentToClientTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consentToClientTransferMutation, { data, loading, error }] = useConsentToClientTransferMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConsentToClientTransferMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConsentToClientTransferMutation,
    ConsentToClientTransferMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConsentToClientTransferMutation,
    ConsentToClientTransferMutationVariables
  >(ConsentToClientTransferDocument, options);
}
export type ConsentToClientTransferMutationHookResult = ReturnType<
  typeof useConsentToClientTransferMutation
>;
export type ConsentToClientTransferMutationResult =
  Apollo.MutationResult<ConsentToClientTransferMutation>;
export type ConsentToClientTransferMutationOptions = Apollo.BaseMutationOptions<
  ConsentToClientTransferMutation,
  ConsentToClientTransferMutationVariables
>;
export const JoinPracticeByInviteLinkDocument = gql`
  mutation JoinPracticeByInviteLink($token: String!) {
    joinPracticeByInviteLink(token: $token) {
      success
      practiceId
      practiceName
    }
  }
`;
export type JoinPracticeByInviteLinkMutationFn = Apollo.MutationFunction<
  JoinPracticeByInviteLinkMutation,
  JoinPracticeByInviteLinkMutationVariables
>;

/**
 * __useJoinPracticeByInviteLinkMutation__
 *
 * To run a mutation, you first call `useJoinPracticeByInviteLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinPracticeByInviteLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinPracticeByInviteLinkMutation, { data, loading, error }] = useJoinPracticeByInviteLinkMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useJoinPracticeByInviteLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JoinPracticeByInviteLinkMutation,
    JoinPracticeByInviteLinkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    JoinPracticeByInviteLinkMutation,
    JoinPracticeByInviteLinkMutationVariables
  >(JoinPracticeByInviteLinkDocument, options);
}
export type JoinPracticeByInviteLinkMutationHookResult = ReturnType<
  typeof useJoinPracticeByInviteLinkMutation
>;
export type JoinPracticeByInviteLinkMutationResult =
  Apollo.MutationResult<JoinPracticeByInviteLinkMutation>;
export type JoinPracticeByInviteLinkMutationOptions =
  Apollo.BaseMutationOptions<
    JoinPracticeByInviteLinkMutation,
    JoinPracticeByInviteLinkMutationVariables
  >;
export const PremiumUpgradeToShowDocument = gql`
  query PremiumUpgradeToShow($acknowledgedGrantAt: DateTime) {
    premiumUpgradeToShow(acknowledgedGrantAt: $acknowledgedGrantAt) {
      subject
      accessLevel
      practiceId
      grantedVia
      occurredAt
      acknowledgedGrantAt
    }
  }
`;

/**
 * __usePremiumUpgradeToShowQuery__
 *
 * To run a query within a React component, call `usePremiumUpgradeToShowQuery` and pass it any options that fit your needs.
 * When your component renders, `usePremiumUpgradeToShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePremiumUpgradeToShowQuery({
 *   variables: {
 *      acknowledgedGrantAt: // value for 'acknowledgedGrantAt'
 *   },
 * });
 */
export function usePremiumUpgradeToShowQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PremiumUpgradeToShowQuery,
    PremiumUpgradeToShowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PremiumUpgradeToShowQuery,
    PremiumUpgradeToShowQueryVariables
  >(PremiumUpgradeToShowDocument, options);
}
export function usePremiumUpgradeToShowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PremiumUpgradeToShowQuery,
    PremiumUpgradeToShowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PremiumUpgradeToShowQuery,
    PremiumUpgradeToShowQueryVariables
  >(PremiumUpgradeToShowDocument, options);
}
export type PremiumUpgradeToShowQueryHookResult = ReturnType<
  typeof usePremiumUpgradeToShowQuery
>;
export type PremiumUpgradeToShowLazyQueryHookResult = ReturnType<
  typeof usePremiumUpgradeToShowLazyQuery
>;
export type PremiumUpgradeToShowQueryResult = Apollo.QueryResult<
  PremiumUpgradeToShowQuery,
  PremiumUpgradeToShowQueryVariables
>;
export const SleepNightsToConfirmDocument = gql`
  query SleepNightsToConfirm($today: String, $timeZone: String) {
    sleepNightsToConfirm(today: $today, timeZone: $timeZone) {
      subject
      today
      nights {
        night
        source
        inBedStart
        inBedEnd
        asleepMinutes
      }
    }
  }
`;

/**
 * __useSleepNightsToConfirmQuery__
 *
 * To run a query within a React component, call `useSleepNightsToConfirmQuery` and pass it any options that fit your needs.
 * When your component renders, `useSleepNightsToConfirmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSleepNightsToConfirmQuery({
 *   variables: {
 *      today: // value for 'today'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useSleepNightsToConfirmQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SleepNightsToConfirmQuery,
    SleepNightsToConfirmQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SleepNightsToConfirmQuery,
    SleepNightsToConfirmQueryVariables
  >(SleepNightsToConfirmDocument, options);
}
export function useSleepNightsToConfirmLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SleepNightsToConfirmQuery,
    SleepNightsToConfirmQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SleepNightsToConfirmQuery,
    SleepNightsToConfirmQueryVariables
  >(SleepNightsToConfirmDocument, options);
}
export type SleepNightsToConfirmQueryHookResult = ReturnType<
  typeof useSleepNightsToConfirmQuery
>;
export type SleepNightsToConfirmLazyQueryHookResult = ReturnType<
  typeof useSleepNightsToConfirmLazyQuery
>;
export type SleepNightsToConfirmQueryResult = Apollo.QueryResult<
  SleepNightsToConfirmQuery,
  SleepNightsToConfirmQueryVariables
>;
export const SleepDiaryWeekDocument = gql`
  query SleepDiaryWeek($subject: ID, $week: String, $timeZone: String) {
    sleepDiaryWeek(subject: $subject, week: $week, timeZone: $timeZone) {
      subject
      week
      watchShared
      upcoming
      nights {
        night
        nightKind
        source
        performer
        performerName
        bedTime
        lightsOut
        finalWake
        outOfBed
        timeInBedMinutes
        totalSleepMinutes
        efficiency
        sleepOnsetMinutes
        awakenings
        wakeMinutes
        quality
        naps {
          start
          minutes
        }
        substances {
          caffeineAfterNoon
          alcoholDrinks
          sleepAid
        }
        note
        watchAsleepMinutes
      }
      averages {
        ...SleepWeekAveragesFields
      }
      weeks {
        week
        averages {
          ...SleepWeekAveragesFields
        }
      }
      window {
        ...SleepWindowViewFields
      }
      windows {
        ...SleepWindowViewFields
      }
      lastSevenNights {
        ...SleepWeekAveragesFields
      }
      usualRule {
        protocol
        action
        minutes
        atFloor
        nights
        meanEfficiency
        meanFellAsleep
        meanAwakeInNight
      }
    }
  }
  ${SleepWeekAveragesFieldsFragmentDoc}
  ${SleepWindowViewFieldsFragmentDoc}
`;

/**
 * __useSleepDiaryWeekQuery__
 *
 * To run a query within a React component, call `useSleepDiaryWeekQuery` and pass it any options that fit your needs.
 * When your component renders, `useSleepDiaryWeekQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSleepDiaryWeekQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      week: // value for 'week'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useSleepDiaryWeekQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SleepDiaryWeekQuery,
    SleepDiaryWeekQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SleepDiaryWeekQuery, SleepDiaryWeekQueryVariables>(
    SleepDiaryWeekDocument,
    options,
  );
}
export function useSleepDiaryWeekLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SleepDiaryWeekQuery,
    SleepDiaryWeekQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SleepDiaryWeekQuery, SleepDiaryWeekQueryVariables>(
    SleepDiaryWeekDocument,
    options,
  );
}
export type SleepDiaryWeekQueryHookResult = ReturnType<
  typeof useSleepDiaryWeekQuery
>;
export type SleepDiaryWeekLazyQueryHookResult = ReturnType<
  typeof useSleepDiaryWeekLazyQuery
>;
export type SleepDiaryWeekQueryResult = Apollo.QueryResult<
  SleepDiaryWeekQuery,
  SleepDiaryWeekQueryVariables
>;
export const SleepWindowDocument = gql`
  query SleepWindow($timeZone: String) {
    sleepWindow(timeZone: $timeZone) {
      subject
      upcoming
      window {
        ...SleepWindowViewFields
      }
      next {
        ...SleepWindowViewFields
      }
    }
  }
  ${SleepWindowViewFieldsFragmentDoc}
`;

/**
 * __useSleepWindowQuery__
 *
 * To run a query within a React component, call `useSleepWindowQuery` and pass it any options that fit your needs.
 * When your component renders, `useSleepWindowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSleepWindowQuery({
 *   variables: {
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useSleepWindowQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SleepWindowQuery,
    SleepWindowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SleepWindowQuery, SleepWindowQueryVariables>(
    SleepWindowDocument,
    options,
  );
}
export function useSleepWindowLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SleepWindowQuery,
    SleepWindowQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SleepWindowQuery, SleepWindowQueryVariables>(
    SleepWindowDocument,
    options,
  );
}
export type SleepWindowQueryHookResult = ReturnType<typeof useSleepWindowQuery>;
export type SleepWindowLazyQueryHookResult = ReturnType<
  typeof useSleepWindowLazyQuery
>;
export type SleepWindowQueryResult = Apollo.QueryResult<
  SleepWindowQuery,
  SleepWindowQueryVariables
>;
export const ConfirmSleepNightDocument = gql`
  mutation ConfirmSleepNight($input: ConfirmSleepNightInput!) {
    confirmSleepNight(input: $input) {
      recorded
    }
  }
`;
export type ConfirmSleepNightMutationFn = Apollo.MutationFunction<
  ConfirmSleepNightMutation,
  ConfirmSleepNightMutationVariables
>;

/**
 * __useConfirmSleepNightMutation__
 *
 * To run a mutation, you first call `useConfirmSleepNightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmSleepNightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmSleepNightMutation, { data, loading, error }] = useConfirmSleepNightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmSleepNightMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmSleepNightMutation,
    ConfirmSleepNightMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConfirmSleepNightMutation,
    ConfirmSleepNightMutationVariables
  >(ConfirmSleepNightDocument, options);
}
export type ConfirmSleepNightMutationHookResult = ReturnType<
  typeof useConfirmSleepNightMutation
>;
export type ConfirmSleepNightMutationResult =
  Apollo.MutationResult<ConfirmSleepNightMutation>;
export type ConfirmSleepNightMutationOptions = Apollo.BaseMutationOptions<
  ConfirmSleepNightMutation,
  ConfirmSleepNightMutationVariables
>;
export const SetSleepWindowDocument = gql`
  mutation SetSleepWindow($input: SetSleepWindowInput!) {
    setSleepWindow(input: $input) {
      recorded
      id
    }
  }
`;
export type SetSleepWindowMutationFn = Apollo.MutationFunction<
  SetSleepWindowMutation,
  SetSleepWindowMutationVariables
>;

/**
 * __useSetSleepWindowMutation__
 *
 * To run a mutation, you first call `useSetSleepWindowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSleepWindowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSleepWindowMutation, { data, loading, error }] = useSetSleepWindowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSleepWindowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetSleepWindowMutation,
    SetSleepWindowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetSleepWindowMutation,
    SetSleepWindowMutationVariables
  >(SetSleepWindowDocument, options);
}
export type SetSleepWindowMutationHookResult = ReturnType<
  typeof useSetSleepWindowMutation
>;
export type SetSleepWindowMutationResult =
  Apollo.MutationResult<SetSleepWindowMutation>;
export type SetSleepWindowMutationOptions = Apollo.BaseMutationOptions<
  SetSleepWindowMutation,
  SetSleepWindowMutationVariables
>;
export const ClearSleepWindowDocument = gql`
  mutation ClearSleepWindow($input: ClearSleepWindowInput!) {
    clearSleepWindow(input: $input) {
      recorded
    }
  }
`;
export type ClearSleepWindowMutationFn = Apollo.MutationFunction<
  ClearSleepWindowMutation,
  ClearSleepWindowMutationVariables
>;

/**
 * __useClearSleepWindowMutation__
 *
 * To run a mutation, you first call `useClearSleepWindowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearSleepWindowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearSleepWindowMutation, { data, loading, error }] = useClearSleepWindowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearSleepWindowMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClearSleepWindowMutation,
    ClearSleepWindowMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ClearSleepWindowMutation,
    ClearSleepWindowMutationVariables
  >(ClearSleepWindowDocument, options);
}
export type ClearSleepWindowMutationHookResult = ReturnType<
  typeof useClearSleepWindowMutation
>;
export type ClearSleepWindowMutationResult =
  Apollo.MutationResult<ClearSleepWindowMutation>;
export type ClearSleepWindowMutationOptions = Apollo.BaseMutationOptions<
  ClearSleepWindowMutation,
  ClearSleepWindowMutationVariables
>;
export const UserSubscriptionsDocument = gql`
  query UserSubscriptions(
    $sort: String
    $where: JSON
    $start: Int
    $limit: Int
  ) {
    userSubscriptions(
      sort: $sort
      where: $where
      start: $start
      limit: $limit
    ) {
      data {
        _id
        ...SubscriptionData
      }
      count
    }
  }
  ${SubscriptionDataFragmentDoc}
`;

/**
 * __useUserSubscriptionsQuery__
 *
 * To run a query within a React component, call `useUserSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSubscriptionsQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUserSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserSubscriptionsQuery,
    UserSubscriptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserSubscriptionsQuery,
    UserSubscriptionsQueryVariables
  >(UserSubscriptionsDocument, options);
}
export function useUserSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserSubscriptionsQuery,
    UserSubscriptionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserSubscriptionsQuery,
    UserSubscriptionsQueryVariables
  >(UserSubscriptionsDocument, options);
}
export type UserSubscriptionsQueryHookResult = ReturnType<
  typeof useUserSubscriptionsQuery
>;
export type UserSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useUserSubscriptionsLazyQuery
>;
export type UserSubscriptionsQueryResult = Apollo.QueryResult<
  UserSubscriptionsQuery,
  UserSubscriptionsQueryVariables
>;
export const UserSupportingCyclesDocument = gql`
  query UserSupportingCycles(
    $sort: String
    $where: JSON
    $start: Int
    $limit: Int
  ) {
    supportingCycles(sort: $sort, where: $where, start: $start, limit: $limit) {
      data {
        _id
        ...SupportingCycleData
      }
      count
    }
  }
  ${SupportingCycleDataFragmentDoc}
`;

/**
 * __useUserSupportingCyclesQuery__
 *
 * To run a query within a React component, call `useUserSupportingCyclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSupportingCyclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSupportingCyclesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUserSupportingCyclesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserSupportingCyclesQuery,
    UserSupportingCyclesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserSupportingCyclesQuery,
    UserSupportingCyclesQueryVariables
  >(UserSupportingCyclesDocument, options);
}
export function useUserSupportingCyclesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserSupportingCyclesQuery,
    UserSupportingCyclesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserSupportingCyclesQuery,
    UserSupportingCyclesQueryVariables
  >(UserSupportingCyclesDocument, options);
}
export type UserSupportingCyclesQueryHookResult = ReturnType<
  typeof useUserSupportingCyclesQuery
>;
export type UserSupportingCyclesLazyQueryHookResult = ReturnType<
  typeof useUserSupportingCyclesLazyQuery
>;
export type UserSupportingCyclesQueryResult = Apollo.QueryResult<
  UserSupportingCyclesQuery,
  UserSupportingCyclesQueryVariables
>;
export const SupportingCycleDocument = gql`
  query SupportingCycle($_id: ID) {
    supportingCycle(_id: $_id) {
      _id
      ...SupportingCycleData
    }
  }
  ${SupportingCycleDataFragmentDoc}
`;

/**
 * __useSupportingCycleQuery__
 *
 * To run a query within a React component, call `useSupportingCycleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportingCycleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportingCycleQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useSupportingCycleQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SupportingCycleQuery,
    SupportingCycleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SupportingCycleQuery, SupportingCycleQueryVariables>(
    SupportingCycleDocument,
    options,
  );
}
export function useSupportingCycleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SupportingCycleQuery,
    SupportingCycleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SupportingCycleQuery,
    SupportingCycleQueryVariables
  >(SupportingCycleDocument, options);
}
export type SupportingCycleQueryHookResult = ReturnType<
  typeof useSupportingCycleQuery
>;
export type SupportingCycleLazyQueryHookResult = ReturnType<
  typeof useSupportingCycleLazyQuery
>;
export type SupportingCycleQueryResult = Apollo.QueryResult<
  SupportingCycleQuery,
  SupportingCycleQueryVariables
>;
export const DeleteSupportingCycleDocument = gql`
  mutation DeleteSupportingCycle($_id: ID) {
    deleteSupportingCycle(_id: $_id) {
      _id
      ...SupportingCycleData
    }
  }
  ${SupportingCycleDataFragmentDoc}
`;
export type DeleteSupportingCycleMutationFn = Apollo.MutationFunction<
  DeleteSupportingCycleMutation,
  DeleteSupportingCycleMutationVariables
>;

/**
 * __useDeleteSupportingCycleMutation__
 *
 * To run a mutation, you first call `useDeleteSupportingCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSupportingCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSupportingCycleMutation, { data, loading, error }] = useDeleteSupportingCycleMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteSupportingCycleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteSupportingCycleMutation,
    DeleteSupportingCycleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteSupportingCycleMutation,
    DeleteSupportingCycleMutationVariables
  >(DeleteSupportingCycleDocument, options);
}
export type DeleteSupportingCycleMutationHookResult = ReturnType<
  typeof useDeleteSupportingCycleMutation
>;
export type DeleteSupportingCycleMutationResult =
  Apollo.MutationResult<DeleteSupportingCycleMutation>;
export type DeleteSupportingCycleMutationOptions = Apollo.BaseMutationOptions<
  DeleteSupportingCycleMutation,
  DeleteSupportingCycleMutationVariables
>;
export const UpsertSupportingCycleDocument = gql`
  mutation UpsertSupportingCycle($input: SupportingCycleInput) {
    upsertSupportingCycle(input: $input) {
      _id
      ...SupportingCycleData
    }
  }
  ${SupportingCycleDataFragmentDoc}
`;
export type UpsertSupportingCycleMutationFn = Apollo.MutationFunction<
  UpsertSupportingCycleMutation,
  UpsertSupportingCycleMutationVariables
>;

/**
 * __useUpsertSupportingCycleMutation__
 *
 * To run a mutation, you first call `useUpsertSupportingCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSupportingCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSupportingCycleMutation, { data, loading, error }] = useUpsertSupportingCycleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSupportingCycleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertSupportingCycleMutation,
    UpsertSupportingCycleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertSupportingCycleMutation,
    UpsertSupportingCycleMutationVariables
  >(UpsertSupportingCycleDocument, options);
}
export type UpsertSupportingCycleMutationHookResult = ReturnType<
  typeof useUpsertSupportingCycleMutation
>;
export type UpsertSupportingCycleMutationResult =
  Apollo.MutationResult<UpsertSupportingCycleMutation>;
export type UpsertSupportingCycleMutationOptions = Apollo.BaseMutationOptions<
  UpsertSupportingCycleMutation,
  UpsertSupportingCycleMutationVariables
>;
export const TestDocument = gql`
  query Test($_id: String!) {
    test(_id: $_id) {
      ...TestData
    }
  }
  ${TestDataFragmentDoc}
`;

/**
 * __useTestQuery__
 *
 * To run a query within a React component, call `useTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useTestQuery(
  baseOptions: Apollo.QueryHookOptions<TestQuery, TestQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TestQuery, TestQueryVariables>(TestDocument, options);
}
export function useTestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TestQuery, TestQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TestQuery, TestQueryVariables>(
    TestDocument,
    options,
  );
}
export type TestQueryHookResult = ReturnType<typeof useTestQuery>;
export type TestLazyQueryHookResult = ReturnType<typeof useTestLazyQuery>;
export type TestQueryResult = Apollo.QueryResult<TestQuery, TestQueryVariables>;
export const TestsDocument = gql`
  query Tests($ids: [String!]) {
    tests(ids: $ids) {
      ...TestData
    }
  }
  ${TestDataFragmentDoc}
`;

/**
 * __useTestsQuery__
 *
 * To run a query within a React component, call `useTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useTestsQuery(
  baseOptions?: Apollo.QueryHookOptions<TestsQuery, TestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TestsQuery, TestsQueryVariables>(
    TestsDocument,
    options,
  );
}
export function useTestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TestsQuery, TestsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TestsQuery, TestsQueryVariables>(
    TestsDocument,
    options,
  );
}
export type TestsQueryHookResult = ReturnType<typeof useTestsQuery>;
export type TestsLazyQueryHookResult = ReturnType<typeof useTestsLazyQuery>;
export type TestsQueryResult = Apollo.QueryResult<
  TestsQuery,
  TestsQueryVariables
>;
export const TestsForUserDocument = gql`
  query testsForUser(
    $after: String
    $before: String
    $sort: String
    $first: Int
    $last: Int
    $type: Int
  ) {
    testsForUser(
      after: $after
      before: $before
      sort: $sort
      first: $first
      last: $last
      type: $type
    ) {
      totalCount
      edges {
        cursor
        node {
          ...TestData
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${TestDataFragmentDoc}
`;

/**
 * __useTestsForUserQuery__
 *
 * To run a query within a React component, call `useTestsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestsForUserQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useTestsForUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TestsForUserQuery,
    TestsForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TestsForUserQuery, TestsForUserQueryVariables>(
    TestsForUserDocument,
    options,
  );
}
export function useTestsForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TestsForUserQuery,
    TestsForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TestsForUserQuery, TestsForUserQueryVariables>(
    TestsForUserDocument,
    options,
  );
}
export type TestsForUserQueryHookResult = ReturnType<
  typeof useTestsForUserQuery
>;
export type TestsForUserLazyQueryHookResult = ReturnType<
  typeof useTestsForUserLazyQuery
>;
export type TestsForUserQueryResult = Apollo.QueryResult<
  TestsForUserQuery,
  TestsForUserQueryVariables
>;
export const CreateTestDocument = gql`
  mutation CreateTest($test: TestCreateInput!) {
    createTest(test: $test) {
      test {
        ...TestData
      }
    }
  }
  ${TestDataFragmentDoc}
`;
export type CreateTestMutationFn = Apollo.MutationFunction<
  CreateTestMutation,
  CreateTestMutationVariables
>;

/**
 * __useCreateTestMutation__
 *
 * To run a mutation, you first call `useCreateTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestMutation, { data, loading, error }] = useCreateTestMutation({
 *   variables: {
 *      test: // value for 'test'
 *   },
 * });
 */
export function useCreateTestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTestMutation,
    CreateTestMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTestMutation, CreateTestMutationVariables>(
    CreateTestDocument,
    options,
  );
}
export type CreateTestMutationHookResult = ReturnType<
  typeof useCreateTestMutation
>;
export type CreateTestMutationResult =
  Apollo.MutationResult<CreateTestMutation>;
export type CreateTestMutationOptions = Apollo.BaseMutationOptions<
  CreateTestMutation,
  CreateTestMutationVariables
>;
export const TherapistClientEdgeDocument = gql`
  query TherapistClientEdge($id: ID!) {
    therapistClientEdge(id: $id) {
      _id
      ...TherapistClientEdgeData
    }
  }
  ${TherapistClientEdgeDataFragmentDoc}
`;

/**
 * __useTherapistClientEdgeQuery__
 *
 * To run a query within a React component, call `useTherapistClientEdgeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTherapistClientEdgeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTherapistClientEdgeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTherapistClientEdgeQuery(
  baseOptions: Apollo.QueryHookOptions<
    TherapistClientEdgeQuery,
    TherapistClientEdgeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TherapistClientEdgeQuery,
    TherapistClientEdgeQueryVariables
  >(TherapistClientEdgeDocument, options);
}
export function useTherapistClientEdgeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TherapistClientEdgeQuery,
    TherapistClientEdgeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TherapistClientEdgeQuery,
    TherapistClientEdgeQueryVariables
  >(TherapistClientEdgeDocument, options);
}
export type TherapistClientEdgeQueryHookResult = ReturnType<
  typeof useTherapistClientEdgeQuery
>;
export type TherapistClientEdgeLazyQueryHookResult = ReturnType<
  typeof useTherapistClientEdgeLazyQuery
>;
export type TherapistClientEdgeQueryResult = Apollo.QueryResult<
  TherapistClientEdgeQuery,
  TherapistClientEdgeQueryVariables
>;
export const TherapistClientEdgesDocument = gql`
  query TherapistClientEdges(
    $sort: String
    $where: JSON
    $start: Int
    $limit: Int
  ) {
    therapistClientEdges(
      sort: $sort
      where: $where
      start: $start
      limit: $limit
    ) {
      data {
        _id
        ...TherapistClientEdgeData
      }
      count
    }
  }
  ${TherapistClientEdgeDataFragmentDoc}
`;

/**
 * __useTherapistClientEdgesQuery__
 *
 * To run a query within a React component, call `useTherapistClientEdgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTherapistClientEdgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTherapistClientEdgesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useTherapistClientEdgesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    TherapistClientEdgesQuery,
    TherapistClientEdgesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TherapistClientEdgesQuery,
    TherapistClientEdgesQueryVariables
  >(TherapistClientEdgesDocument, options);
}
export function useTherapistClientEdgesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TherapistClientEdgesQuery,
    TherapistClientEdgesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TherapistClientEdgesQuery,
    TherapistClientEdgesQueryVariables
  >(TherapistClientEdgesDocument, options);
}
export type TherapistClientEdgesQueryHookResult = ReturnType<
  typeof useTherapistClientEdgesQuery
>;
export type TherapistClientEdgesLazyQueryHookResult = ReturnType<
  typeof useTherapistClientEdgesLazyQuery
>;
export type TherapistClientEdgesQueryResult = Apollo.QueryResult<
  TherapistClientEdgesQuery,
  TherapistClientEdgesQueryVariables
>;
export const CreateTherapistClientEdgeDocument = gql`
  mutation CreateTherapistClientEdge($input: therapistClientECreateInput!) {
    createTherapistClientEdge(input: $input) {
      _id
      ...TherapistClientEdgeData
    }
  }
  ${TherapistClientEdgeDataFragmentDoc}
`;
export type CreateTherapistClientEdgeMutationFn = Apollo.MutationFunction<
  CreateTherapistClientEdgeMutation,
  CreateTherapistClientEdgeMutationVariables
>;

/**
 * __useCreateTherapistClientEdgeMutation__
 *
 * To run a mutation, you first call `useCreateTherapistClientEdgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTherapistClientEdgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTherapistClientEdgeMutation, { data, loading, error }] = useCreateTherapistClientEdgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTherapistClientEdgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTherapistClientEdgeMutation,
    CreateTherapistClientEdgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateTherapistClientEdgeMutation,
    CreateTherapistClientEdgeMutationVariables
  >(CreateTherapistClientEdgeDocument, options);
}
export type CreateTherapistClientEdgeMutationHookResult = ReturnType<
  typeof useCreateTherapistClientEdgeMutation
>;
export type CreateTherapistClientEdgeMutationResult =
  Apollo.MutationResult<CreateTherapistClientEdgeMutation>;
export type CreateTherapistClientEdgeMutationOptions =
  Apollo.BaseMutationOptions<
    CreateTherapistClientEdgeMutation,
    CreateTherapistClientEdgeMutationVariables
  >;
export const UpdateTherapistClientEdgeDocument = gql`
  mutation UpdateTherapistClientEdge($input: therapistClientEUpdateInput!) {
    updateTherapistClientEdge(input: $input) {
      _id
      ...TherapistClientEdgeData
    }
  }
  ${TherapistClientEdgeDataFragmentDoc}
`;
export type UpdateTherapistClientEdgeMutationFn = Apollo.MutationFunction<
  UpdateTherapistClientEdgeMutation,
  UpdateTherapistClientEdgeMutationVariables
>;

/**
 * __useUpdateTherapistClientEdgeMutation__
 *
 * To run a mutation, you first call `useUpdateTherapistClientEdgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTherapistClientEdgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTherapistClientEdgeMutation, { data, loading, error }] = useUpdateTherapistClientEdgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTherapistClientEdgeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTherapistClientEdgeMutation,
    UpdateTherapistClientEdgeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateTherapistClientEdgeMutation,
    UpdateTherapistClientEdgeMutationVariables
  >(UpdateTherapistClientEdgeDocument, options);
}
export type UpdateTherapistClientEdgeMutationHookResult = ReturnType<
  typeof useUpdateTherapistClientEdgeMutation
>;
export type UpdateTherapistClientEdgeMutationResult =
  Apollo.MutationResult<UpdateTherapistClientEdgeMutation>;
export type UpdateTherapistClientEdgeMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateTherapistClientEdgeMutation,
    UpdateTherapistClientEdgeMutationVariables
  >;
export const ThoughtDocument = gql`
  query Thought($_id: String!) {
    thought(_id: $_id) {
      ...ThoughtData
    }
  }
  ${ThoughtDataFragmentDoc}
`;

/**
 * __useThoughtQuery__
 *
 * To run a query within a React component, call `useThoughtQuery` and pass it any options that fit your needs.
 * When your component renders, `useThoughtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThoughtQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useThoughtQuery(
  baseOptions: Apollo.QueryHookOptions<ThoughtQuery, ThoughtQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ThoughtQuery, ThoughtQueryVariables>(
    ThoughtDocument,
    options,
  );
}
export function useThoughtLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThoughtQuery,
    ThoughtQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ThoughtQuery, ThoughtQueryVariables>(
    ThoughtDocument,
    options,
  );
}
export type ThoughtQueryHookResult = ReturnType<typeof useThoughtQuery>;
export type ThoughtLazyQueryHookResult = ReturnType<typeof useThoughtLazyQuery>;
export type ThoughtQueryResult = Apollo.QueryResult<
  ThoughtQuery,
  ThoughtQueryVariables
>;
export const ThoughtLocationRemindersDocument = gql`
  query ThoughtLocationReminders($_id: String!) {
    thought(_id: $_id) {
      _id
      locationReminders {
        ...LocationReminderData
      }
    }
  }
  ${LocationReminderDataFragmentDoc}
`;

/**
 * __useThoughtLocationRemindersQuery__
 *
 * To run a query within a React component, call `useThoughtLocationRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useThoughtLocationRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThoughtLocationRemindersQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useThoughtLocationRemindersQuery(
  baseOptions: Apollo.QueryHookOptions<
    ThoughtLocationRemindersQuery,
    ThoughtLocationRemindersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ThoughtLocationRemindersQuery,
    ThoughtLocationRemindersQueryVariables
  >(ThoughtLocationRemindersDocument, options);
}
export function useThoughtLocationRemindersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThoughtLocationRemindersQuery,
    ThoughtLocationRemindersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ThoughtLocationRemindersQuery,
    ThoughtLocationRemindersQueryVariables
  >(ThoughtLocationRemindersDocument, options);
}
export type ThoughtLocationRemindersQueryHookResult = ReturnType<
  typeof useThoughtLocationRemindersQuery
>;
export type ThoughtLocationRemindersLazyQueryHookResult = ReturnType<
  typeof useThoughtLocationRemindersLazyQuery
>;
export type ThoughtLocationRemindersQueryResult = Apollo.QueryResult<
  ThoughtLocationRemindersQuery,
  ThoughtLocationRemindersQueryVariables
>;
export const ThoughtsDocument = gql`
  query Thoughts($ids: [String!]) {
    thoughts(ids: $ids) {
      ...ThoughtData
    }
  }
  ${ThoughtDataFragmentDoc}
`;

/**
 * __useThoughtsQuery__
 *
 * To run a query within a React component, call `useThoughtsQuery` and pass it any options that fit your needs.
 * When your component renders, `useThoughtsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThoughtsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useThoughtsQuery(
  baseOptions?: Apollo.QueryHookOptions<ThoughtsQuery, ThoughtsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ThoughtsQuery, ThoughtsQueryVariables>(
    ThoughtsDocument,
    options,
  );
}
export function useThoughtsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThoughtsQuery,
    ThoughtsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ThoughtsQuery, ThoughtsQueryVariables>(
    ThoughtsDocument,
    options,
  );
}
export type ThoughtsQueryHookResult = ReturnType<typeof useThoughtsQuery>;
export type ThoughtsLazyQueryHookResult = ReturnType<
  typeof useThoughtsLazyQuery
>;
export type ThoughtsQueryResult = Apollo.QueryResult<
  ThoughtsQuery,
  ThoughtsQueryVariables
>;
export const ThoughtsForUserDocument = gql`
  query ThoughtsForUser(
    $after: String
    $before: String
    $sort: String
    $first: Int
    $last: Int
  ) {
    thoughtsForUser(
      after: $after
      before: $before
      sort: $sort
      first: $first
      last: $last
    ) {
      totalCount
      edges {
        cursor
        node {
          ...ThoughtData
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
  ${ThoughtDataFragmentDoc}
`;

/**
 * __useThoughtsForUserQuery__
 *
 * To run a query within a React component, call `useThoughtsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useThoughtsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThoughtsForUserQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useThoughtsForUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ThoughtsForUserQuery,
    ThoughtsForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ThoughtsForUserQuery, ThoughtsForUserQueryVariables>(
    ThoughtsForUserDocument,
    options,
  );
}
export function useThoughtsForUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThoughtsForUserQuery,
    ThoughtsForUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ThoughtsForUserQuery,
    ThoughtsForUserQueryVariables
  >(ThoughtsForUserDocument, options);
}
export type ThoughtsForUserQueryHookResult = ReturnType<
  typeof useThoughtsForUserQuery
>;
export type ThoughtsForUserLazyQueryHookResult = ReturnType<
  typeof useThoughtsForUserLazyQuery
>;
export type ThoughtsForUserQueryResult = Apollo.QueryResult<
  ThoughtsForUserQuery,
  ThoughtsForUserQueryVariables
>;
export const ThoughtsSearchDocument = gql`
  query ThoughtsSearch($phrase: String!) {
    thoughtsSearch(phrase: $phrase) {
      thoughts {
        ...ThoughtData
      }
      count
    }
  }
  ${ThoughtDataFragmentDoc}
`;

/**
 * __useThoughtsSearchQuery__
 *
 * To run a query within a React component, call `useThoughtsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useThoughtsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThoughtsSearchQuery({
 *   variables: {
 *      phrase: // value for 'phrase'
 *   },
 * });
 */
export function useThoughtsSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    ThoughtsSearchQuery,
    ThoughtsSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ThoughtsSearchQuery, ThoughtsSearchQueryVariables>(
    ThoughtsSearchDocument,
    options,
  );
}
export function useThoughtsSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThoughtsSearchQuery,
    ThoughtsSearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ThoughtsSearchQuery, ThoughtsSearchQueryVariables>(
    ThoughtsSearchDocument,
    options,
  );
}
export type ThoughtsSearchQueryHookResult = ReturnType<
  typeof useThoughtsSearchQuery
>;
export type ThoughtsSearchLazyQueryHookResult = ReturnType<
  typeof useThoughtsSearchLazyQuery
>;
export type ThoughtsSearchQueryResult = Apollo.QueryResult<
  ThoughtsSearchQuery,
  ThoughtsSearchQueryVariables
>;
export const CreateThoughtDocument = gql`
  mutation CreateThought($thought: ThoughtCreateInput!) {
    createThought(thought: $thought) {
      thought {
        ...ThoughtData
      }
    }
  }
  ${ThoughtDataFragmentDoc}
`;
export type CreateThoughtMutationFn = Apollo.MutationFunction<
  CreateThoughtMutation,
  CreateThoughtMutationVariables
>;

/**
 * __useCreateThoughtMutation__
 *
 * To run a mutation, you first call `useCreateThoughtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThoughtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThoughtMutation, { data, loading, error }] = useCreateThoughtMutation({
 *   variables: {
 *      thought: // value for 'thought'
 *   },
 * });
 */
export function useCreateThoughtMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateThoughtMutation,
    CreateThoughtMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateThoughtMutation,
    CreateThoughtMutationVariables
  >(CreateThoughtDocument, options);
}
export type CreateThoughtMutationHookResult = ReturnType<
  typeof useCreateThoughtMutation
>;
export type CreateThoughtMutationResult =
  Apollo.MutationResult<CreateThoughtMutation>;
export type CreateThoughtMutationOptions = Apollo.BaseMutationOptions<
  CreateThoughtMutation,
  CreateThoughtMutationVariables
>;
export const DeleteThoughtDocument = gql`
  mutation DeleteThought($_id: String!) {
    deleteThought(_id: $_id) {
      success
    }
  }
`;
export type DeleteThoughtMutationFn = Apollo.MutationFunction<
  DeleteThoughtMutation,
  DeleteThoughtMutationVariables
>;

/**
 * __useDeleteThoughtMutation__
 *
 * To run a mutation, you first call `useDeleteThoughtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThoughtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThoughtMutation, { data, loading, error }] = useDeleteThoughtMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteThoughtMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteThoughtMutation,
    DeleteThoughtMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteThoughtMutation,
    DeleteThoughtMutationVariables
  >(DeleteThoughtDocument, options);
}
export type DeleteThoughtMutationHookResult = ReturnType<
  typeof useDeleteThoughtMutation
>;
export type DeleteThoughtMutationResult =
  Apollo.MutationResult<DeleteThoughtMutation>;
export type DeleteThoughtMutationOptions = Apollo.BaseMutationOptions<
  DeleteThoughtMutation,
  DeleteThoughtMutationVariables
>;
export const UpdateThoughtDocument = gql`
  mutation UpdateThought($thought: ThoughtUpdateInput!) {
    updateThought(thought: $thought) {
      thought {
        ...ThoughtData
      }
    }
  }
  ${ThoughtDataFragmentDoc}
`;
export type UpdateThoughtMutationFn = Apollo.MutationFunction<
  UpdateThoughtMutation,
  UpdateThoughtMutationVariables
>;

/**
 * __useUpdateThoughtMutation__
 *
 * To run a mutation, you first call `useUpdateThoughtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThoughtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThoughtMutation, { data, loading, error }] = useUpdateThoughtMutation({
 *   variables: {
 *      thought: // value for 'thought'
 *   },
 * });
 */
export function useUpdateThoughtMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateThoughtMutation,
    UpdateThoughtMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateThoughtMutation,
    UpdateThoughtMutationVariables
  >(UpdateThoughtDocument, options);
}
export type UpdateThoughtMutationHookResult = ReturnType<
  typeof useUpdateThoughtMutation
>;
export type UpdateThoughtMutationResult =
  Apollo.MutationResult<UpdateThoughtMutation>;
export type UpdateThoughtMutationOptions = Apollo.BaseMutationOptions<
  UpdateThoughtMutation,
  UpdateThoughtMutationVariables
>;
export const SubmitThoughtTestEventsDocument = gql`
  mutation SubmitThoughtTestEvents(
    $thoughtTestId: ID!
    $events: [ThoughtTestEventInput!]!
    $subject: ID
  ) {
    submitThoughtTestEvents(
      thoughtTestId: $thoughtTestId
      events: $events
      subject: $subject
    ) {
      lastPosition
      duplicates
      thought {
        _id
        _key
        activatingEventId
        dayReminders {
          _id
        }
      }
    }
  }
`;
export type SubmitThoughtTestEventsMutationFn = Apollo.MutationFunction<
  SubmitThoughtTestEventsMutation,
  SubmitThoughtTestEventsMutationVariables
>;

/**
 * __useSubmitThoughtTestEventsMutation__
 *
 * To run a mutation, you first call `useSubmitThoughtTestEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitThoughtTestEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitThoughtTestEventsMutation, { data, loading, error }] = useSubmitThoughtTestEventsMutation({
 *   variables: {
 *      thoughtTestId: // value for 'thoughtTestId'
 *      events: // value for 'events'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useSubmitThoughtTestEventsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitThoughtTestEventsMutation,
    SubmitThoughtTestEventsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitThoughtTestEventsMutation,
    SubmitThoughtTestEventsMutationVariables
  >(SubmitThoughtTestEventsDocument, options);
}
export type SubmitThoughtTestEventsMutationHookResult = ReturnType<
  typeof useSubmitThoughtTestEventsMutation
>;
export type SubmitThoughtTestEventsMutationResult =
  Apollo.MutationResult<SubmitThoughtTestEventsMutation>;
export type SubmitThoughtTestEventsMutationOptions = Apollo.BaseMutationOptions<
  SubmitThoughtTestEventsMutation,
  SubmitThoughtTestEventsMutationVariables
>;
export const CreateStandaloneCardDocument = gql`
  mutation CreateStandaloneCard($input: CreateStandaloneCardInput!) {
    createStandaloneCard(input: $input) {
      thoughtTestId
      thought {
        _id
        _key
        userId
        cardName
        automaticThought
        realisticThoughts {
          thought
          thoughtBelief
        }
        createdAt
        updatedAt
      }
    }
  }
`;
export type CreateStandaloneCardMutationFn = Apollo.MutationFunction<
  CreateStandaloneCardMutation,
  CreateStandaloneCardMutationVariables
>;

/**
 * __useCreateStandaloneCardMutation__
 *
 * To run a mutation, you first call `useCreateStandaloneCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStandaloneCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStandaloneCardMutation, { data, loading, error }] = useCreateStandaloneCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStandaloneCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateStandaloneCardMutation,
    CreateStandaloneCardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateStandaloneCardMutation,
    CreateStandaloneCardMutationVariables
  >(CreateStandaloneCardDocument, options);
}
export type CreateStandaloneCardMutationHookResult = ReturnType<
  typeof useCreateStandaloneCardMutation
>;
export type CreateStandaloneCardMutationResult =
  Apollo.MutationResult<CreateStandaloneCardMutation>;
export type CreateStandaloneCardMutationOptions = Apollo.BaseMutationOptions<
  CreateStandaloneCardMutation,
  CreateStandaloneCardMutationVariables
>;
export const ThoughtTestDraftDocument = gql`
  query ThoughtTestDraft($thoughtTestId: ID!, $subject: ID) {
    thoughtTestDraft(thoughtTestId: $thoughtTestId, subject: $subject) {
      subject
      thoughtTestId
      activatingEventId
      description
      emotions {
        id
        strength
      }
      feelings
      bodyPartsFeelings
      behaviors
      thoughtsFor
      thoughtsForAlternativeThoughts
      thoughtsAgainst
      cognitiveDistortions
      realisticThoughts {
        thought
        thoughtBelief
      }
      result {
        initialThoughtBelief
        initialNegativeEmotionStrength
      }
      automaticThought
      thoughtBelief
      resumeStep
      thought {
        ...ThoughtData
      }
    }
  }
  ${ThoughtDataFragmentDoc}
`;

/**
 * __useThoughtTestDraftQuery__
 *
 * To run a query within a React component, call `useThoughtTestDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useThoughtTestDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThoughtTestDraftQuery({
 *   variables: {
 *      thoughtTestId: // value for 'thoughtTestId'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useThoughtTestDraftQuery(
  baseOptions: Apollo.QueryHookOptions<
    ThoughtTestDraftQuery,
    ThoughtTestDraftQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ThoughtTestDraftQuery, ThoughtTestDraftQueryVariables>(
    ThoughtTestDraftDocument,
    options,
  );
}
export function useThoughtTestDraftLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ThoughtTestDraftQuery,
    ThoughtTestDraftQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ThoughtTestDraftQuery,
    ThoughtTestDraftQueryVariables
  >(ThoughtTestDraftDocument, options);
}
export type ThoughtTestDraftQueryHookResult = ReturnType<
  typeof useThoughtTestDraftQuery
>;
export type ThoughtTestDraftLazyQueryHookResult = ReturnType<
  typeof useThoughtTestDraftLazyQuery
>;
export type ThoughtTestDraftQueryResult = Apollo.QueryResult<
  ThoughtTestDraftQuery,
  ThoughtTestDraftQueryVariables
>;
export const UnfinishedThoughtTestsDocument = gql`
  query UnfinishedThoughtTests($subject: ID) {
    unfinishedThoughtTests(subject: $subject) {
      thoughtTestId
      activatingEventId
      subject
      description
      automaticThought
      occurredAt
      resumeStep
    }
  }
`;

/**
 * __useUnfinishedThoughtTestsQuery__
 *
 * To run a query within a React component, call `useUnfinishedThoughtTestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnfinishedThoughtTestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnfinishedThoughtTestsQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useUnfinishedThoughtTestsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UnfinishedThoughtTestsQuery,
    UnfinishedThoughtTestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UnfinishedThoughtTestsQuery,
    UnfinishedThoughtTestsQueryVariables
  >(UnfinishedThoughtTestsDocument, options);
}
export function useUnfinishedThoughtTestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UnfinishedThoughtTestsQuery,
    UnfinishedThoughtTestsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UnfinishedThoughtTestsQuery,
    UnfinishedThoughtTestsQueryVariables
  >(UnfinishedThoughtTestsDocument, options);
}
export type UnfinishedThoughtTestsQueryHookResult = ReturnType<
  typeof useUnfinishedThoughtTestsQuery
>;
export type UnfinishedThoughtTestsLazyQueryHookResult = ReturnType<
  typeof useUnfinishedThoughtTestsLazyQuery
>;
export type UnfinishedThoughtTestsQueryResult = Apollo.QueryResult<
  UnfinishedThoughtTestsQuery,
  UnfinishedThoughtTestsQueryVariables
>;
export const DeleteActivatingEventDocument = gql`
  mutation DeleteActivatingEvent($activatingEventId: ID!) {
    deleteActivatingEvent(activatingEventId: $activatingEventId) {
      success
      activatingEventId
    }
  }
`;
export type DeleteActivatingEventMutationFn = Apollo.MutationFunction<
  DeleteActivatingEventMutation,
  DeleteActivatingEventMutationVariables
>;

/**
 * __useDeleteActivatingEventMutation__
 *
 * To run a mutation, you first call `useDeleteActivatingEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActivatingEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActivatingEventMutation, { data, loading, error }] = useDeleteActivatingEventMutation({
 *   variables: {
 *      activatingEventId: // value for 'activatingEventId'
 *   },
 * });
 */
export function useDeleteActivatingEventMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteActivatingEventMutation,
    DeleteActivatingEventMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteActivatingEventMutation,
    DeleteActivatingEventMutationVariables
  >(DeleteActivatingEventDocument, options);
}
export type DeleteActivatingEventMutationHookResult = ReturnType<
  typeof useDeleteActivatingEventMutation
>;
export type DeleteActivatingEventMutationResult =
  Apollo.MutationResult<DeleteActivatingEventMutation>;
export type DeleteActivatingEventMutationOptions = Apollo.BaseMutationOptions<
  DeleteActivatingEventMutation,
  DeleteActivatingEventMutationVariables
>;
export const UsageEventsDocument = gql`
  query UsageEvents(
    $entityPrefix: String
    $type: Int
    $startDate: DateTime
    $endDate: DateTime
    $limit: Int
    $sort: String
  ) {
    usageEvents(
      entityPrefix: $entityPrefix
      type: $type
      startDate: $startDate
      endDate: $endDate
      limit: $limit
      sort: $sort
    ) {
      ...UsageEventData
    }
  }
  ${UsageEventDataFragmentDoc}
`;

/**
 * __useUsageEventsQuery__
 *
 * To run a query within a React component, call `useUsageEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageEventsQuery({
 *   variables: {
 *      entityPrefix: // value for 'entityPrefix'
 *      type: // value for 'type'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useUsageEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UsageEventsQuery,
    UsageEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UsageEventsQuery, UsageEventsQueryVariables>(
    UsageEventsDocument,
    options,
  );
}
export function useUsageEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UsageEventsQuery,
    UsageEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UsageEventsQuery, UsageEventsQueryVariables>(
    UsageEventsDocument,
    options,
  );
}
export type UsageEventsQueryHookResult = ReturnType<typeof useUsageEventsQuery>;
export type UsageEventsLazyQueryHookResult = ReturnType<
  typeof useUsageEventsLazyQuery
>;
export type UsageEventsQueryResult = Apollo.QueryResult<
  UsageEventsQuery,
  UsageEventsQueryVariables
>;
export const UsageEventsStatsDocument = gql`
  query UsageEventsStats(
    $entityPrefix: String
    $type: Int
    $interval: Int!
    $endDate: DateTime
  ) {
    usageEventsStats(
      entityPrefix: $entityPrefix
      type: $type
      interval: $interval
      endDate: $endDate
    ) {
      stats {
        date
        count
      }
    }
  }
`;

/**
 * __useUsageEventsStatsQuery__
 *
 * To run a query within a React component, call `useUsageEventsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageEventsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageEventsStatsQuery({
 *   variables: {
 *      entityPrefix: // value for 'entityPrefix'
 *      type: // value for 'type'
 *      interval: // value for 'interval'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useUsageEventsStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UsageEventsStatsQuery,
    UsageEventsStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UsageEventsStatsQuery, UsageEventsStatsQueryVariables>(
    UsageEventsStatsDocument,
    options,
  );
}
export function useUsageEventsStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UsageEventsStatsQuery,
    UsageEventsStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UsageEventsStatsQuery,
    UsageEventsStatsQueryVariables
  >(UsageEventsStatsDocument, options);
}
export type UsageEventsStatsQueryHookResult = ReturnType<
  typeof useUsageEventsStatsQuery
>;
export type UsageEventsStatsLazyQueryHookResult = ReturnType<
  typeof useUsageEventsStatsLazyQuery
>;
export type UsageEventsStatsQueryResult = Apollo.QueryResult<
  UsageEventsStatsQuery,
  UsageEventsStatsQueryVariables
>;
export const MostUsedStatsDocument = gql`
  query MostUsedStats(
    $entityPrefix: String
    $type: Int
    $interval: Int!
    $endDate: DateTime
    $limit: Int
  ) {
    mostUsedStats(
      entityPrefix: $entityPrefix
      type: $type
      interval: $interval
      endDate: $endDate
      limit: $limit
    ) {
      entityId
      count
    }
  }
`;

/**
 * __useMostUsedStatsQuery__
 *
 * To run a query within a React component, call `useMostUsedStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMostUsedStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMostUsedStatsQuery({
 *   variables: {
 *      entityPrefix: // value for 'entityPrefix'
 *      type: // value for 'type'
 *      interval: // value for 'interval'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useMostUsedStatsQuery(
  baseOptions: Apollo.QueryHookOptions<
    MostUsedStatsQuery,
    MostUsedStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MostUsedStatsQuery, MostUsedStatsQueryVariables>(
    MostUsedStatsDocument,
    options,
  );
}
export function useMostUsedStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MostUsedStatsQuery,
    MostUsedStatsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MostUsedStatsQuery, MostUsedStatsQueryVariables>(
    MostUsedStatsDocument,
    options,
  );
}
export type MostUsedStatsQueryHookResult = ReturnType<
  typeof useMostUsedStatsQuery
>;
export type MostUsedStatsLazyQueryHookResult = ReturnType<
  typeof useMostUsedStatsLazyQuery
>;
export type MostUsedStatsQueryResult = Apollo.QueryResult<
  MostUsedStatsQuery,
  MostUsedStatsQueryVariables
>;
export const CreateUsageEventsDocument = gql`
  mutation CreateUsageEvents($events: [UsageEventInput!]!) {
    createUsageEvents(events: $events) {
      ok
    }
  }
`;
export type CreateUsageEventsMutationFn = Apollo.MutationFunction<
  CreateUsageEventsMutation,
  CreateUsageEventsMutationVariables
>;

/**
 * __useCreateUsageEventsMutation__
 *
 * To run a mutation, you first call `useCreateUsageEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUsageEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUsageEventsMutation, { data, loading, error }] = useCreateUsageEventsMutation({
 *   variables: {
 *      events: // value for 'events'
 *   },
 * });
 */
export function useCreateUsageEventsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUsageEventsMutation,
    CreateUsageEventsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateUsageEventsMutation,
    CreateUsageEventsMutationVariables
  >(CreateUsageEventsDocument, options);
}
export type CreateUsageEventsMutationHookResult = ReturnType<
  typeof useCreateUsageEventsMutation
>;
export type CreateUsageEventsMutationResult =
  Apollo.MutationResult<CreateUsageEventsMutation>;
export type CreateUsageEventsMutationOptions = Apollo.BaseMutationOptions<
  CreateUsageEventsMutation,
  CreateUsageEventsMutationVariables
>;
export const UserDocument = gql`
  query User {
    user {
      _id
      ...UserData
    }
  }
  ${UserDataFragmentDoc}
`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(
  baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
}
export function useUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(
    UserDocument,
    options,
  );
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserIdDocument = gql`
  query UserId {
    user {
      _id
    }
  }
`;

/**
 * __useUserIdQuery__
 *
 * To run a query within a React component, call `useUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserIdQuery(
  baseOptions?: Apollo.QueryHookOptions<UserIdQuery, UserIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserIdQuery, UserIdQueryVariables>(
    UserIdDocument,
    options,
  );
}
export function useUserIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserIdQuery, UserIdQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<UserIdQuery, UserIdQueryVariables>(
    UserIdDocument,
    options,
  );
}
export type UserIdQueryHookResult = ReturnType<typeof useUserIdQuery>;
export type UserIdLazyQueryHookResult = ReturnType<typeof useUserIdLazyQuery>;
export type UserIdQueryResult = Apollo.QueryResult<
  UserIdQuery,
  UserIdQueryVariables
>;
export const CreateUserDocument = gql`
  mutation CreateUser($user: UserInput!) {
    createUser(user: $user) {
      user {
        _id
        _key
        ...UserData
      }
    }
  }
  ${UserDataFragmentDoc}
`;
export type CreateUserMutationFn = Apollo.MutationFunction<
  CreateUserMutation,
  CreateUserMutationVariables
>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateUserMutation,
    CreateUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(
    CreateUserDocument,
    options,
  );
}
export type CreateUserMutationHookResult = ReturnType<
  typeof useCreateUserMutation
>;
export type CreateUserMutationResult =
  Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<
  CreateUserMutation,
  CreateUserMutationVariables
>;
export const UpdateUserSettingDocument = gql`
  mutation UpdateUserSetting($settings: UserSettingInput!) {
    updateUserSetting(settings: $settings) {
      user {
        _id
        _key
        ...UserData
      }
    }
  }
  ${UserDataFragmentDoc}
`;
export type UpdateUserSettingMutationFn = Apollo.MutationFunction<
  UpdateUserSettingMutation,
  UpdateUserSettingMutationVariables
>;

/**
 * __useUpdateUserSettingMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingMutation, { data, loading, error }] = useUpdateUserSettingMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateUserSettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserSettingMutation,
    UpdateUserSettingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserSettingMutation,
    UpdateUserSettingMutationVariables
  >(UpdateUserSettingDocument, options);
}
export type UpdateUserSettingMutationHookResult = ReturnType<
  typeof useUpdateUserSettingMutation
>;
export type UpdateUserSettingMutationResult =
  Apollo.MutationResult<UpdateUserSettingMutation>;
export type UpdateUserSettingMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserSettingMutation,
  UpdateUserSettingMutationVariables
>;
export const UpdateUserPrivacySettingDocument = gql`
  mutation UpdateUserPrivacySetting(
    $privacySettings: UserPrivacySettingsInput!
  ) {
    updateUserPrivacy(privacySettings: $privacySettings) {
      user {
        _id
        _key
        ...UserData
      }
    }
  }
  ${UserDataFragmentDoc}
`;
export type UpdateUserPrivacySettingMutationFn = Apollo.MutationFunction<
  UpdateUserPrivacySettingMutation,
  UpdateUserPrivacySettingMutationVariables
>;

/**
 * __useUpdateUserPrivacySettingMutation__
 *
 * To run a mutation, you first call `useUpdateUserPrivacySettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPrivacySettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPrivacySettingMutation, { data, loading, error }] = useUpdateUserPrivacySettingMutation({
 *   variables: {
 *      privacySettings: // value for 'privacySettings'
 *   },
 * });
 */
export function useUpdateUserPrivacySettingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserPrivacySettingMutation,
    UpdateUserPrivacySettingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserPrivacySettingMutation,
    UpdateUserPrivacySettingMutationVariables
  >(UpdateUserPrivacySettingDocument, options);
}
export type UpdateUserPrivacySettingMutationHookResult = ReturnType<
  typeof useUpdateUserPrivacySettingMutation
>;
export type UpdateUserPrivacySettingMutationResult =
  Apollo.MutationResult<UpdateUserPrivacySettingMutation>;
export type UpdateUserPrivacySettingMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateUserPrivacySettingMutation,
    UpdateUserPrivacySettingMutationVariables
  >;
export const UpdateFcmTokenDocument = gql`
  mutation UpdateFcmToken($fcmToken: UserFcmTokenInput!) {
    updateFcmToken(fcmToken: $fcmToken) {
      user {
        _id
        _key
        ...UserData
      }
    }
  }
  ${UserDataFragmentDoc}
`;
export type UpdateFcmTokenMutationFn = Apollo.MutationFunction<
  UpdateFcmTokenMutation,
  UpdateFcmTokenMutationVariables
>;

/**
 * __useUpdateFcmTokenMutation__
 *
 * To run a mutation, you first call `useUpdateFcmTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFcmTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFcmTokenMutation, { data, loading, error }] = useUpdateFcmTokenMutation({
 *   variables: {
 *      fcmToken: // value for 'fcmToken'
 *   },
 * });
 */
export function useUpdateFcmTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateFcmTokenMutation,
    UpdateFcmTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateFcmTokenMutation,
    UpdateFcmTokenMutationVariables
  >(UpdateFcmTokenDocument, options);
}
export type UpdateFcmTokenMutationHookResult = ReturnType<
  typeof useUpdateFcmTokenMutation
>;
export type UpdateFcmTokenMutationResult =
  Apollo.MutationResult<UpdateFcmTokenMutation>;
export type UpdateFcmTokenMutationOptions = Apollo.BaseMutationOptions<
  UpdateFcmTokenMutation,
  UpdateFcmTokenMutationVariables
>;
export const UpdateUserAccessLevelDocument = gql`
  mutation UpdateUserAccessLevel($accessLevel: UserSubscriptionInput!) {
    updateUserAccessLevel(accessLevel: $accessLevel) {
      user {
        _id
        _key
        ...UserData
      }
    }
  }
  ${UserDataFragmentDoc}
`;
export type UpdateUserAccessLevelMutationFn = Apollo.MutationFunction<
  UpdateUserAccessLevelMutation,
  UpdateUserAccessLevelMutationVariables
>;

/**
 * __useUpdateUserAccessLevelMutation__
 *
 * To run a mutation, you first call `useUpdateUserAccessLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAccessLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAccessLevelMutation, { data, loading, error }] = useUpdateUserAccessLevelMutation({
 *   variables: {
 *      accessLevel: // value for 'accessLevel'
 *   },
 * });
 */
export function useUpdateUserAccessLevelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserAccessLevelMutation,
    UpdateUserAccessLevelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserAccessLevelMutation,
    UpdateUserAccessLevelMutationVariables
  >(UpdateUserAccessLevelDocument, options);
}
export type UpdateUserAccessLevelMutationHookResult = ReturnType<
  typeof useUpdateUserAccessLevelMutation
>;
export type UpdateUserAccessLevelMutationResult =
  Apollo.MutationResult<UpdateUserAccessLevelMutation>;
export type UpdateUserAccessLevelMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserAccessLevelMutation,
  UpdateUserAccessLevelMutationVariables
>;
export const UpdateUserRoleDocument = gql`
  mutation UpdateUserRole($role: Int!) {
    updateUserRole(role: $role) {
      user {
        _id
        _key
        ...UserData
      }
    }
  }
  ${UserDataFragmentDoc}
`;
export type UpdateUserRoleMutationFn = Apollo.MutationFunction<
  UpdateUserRoleMutation,
  UpdateUserRoleMutationVariables
>;

/**
 * __useUpdateUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserRoleMutation, { data, loading, error }] = useUpdateUserRoleMutation({
 *   variables: {
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateUserRoleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserRoleMutation,
    UpdateUserRoleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUserRoleMutation,
    UpdateUserRoleMutationVariables
  >(UpdateUserRoleDocument, options);
}
export type UpdateUserRoleMutationHookResult = ReturnType<
  typeof useUpdateUserRoleMutation
>;
export type UpdateUserRoleMutationResult =
  Apollo.MutationResult<UpdateUserRoleMutation>;
export type UpdateUserRoleMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserRoleMutation,
  UpdateUserRoleMutationVariables
>;
export const PublishValuesDeckDocument = gql`
  mutation PublishValuesDeck($input: PublishValuesDeckInput!) {
    publishValuesDeck(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type PublishValuesDeckMutationFn = Apollo.MutationFunction<
  PublishValuesDeckMutation,
  PublishValuesDeckMutationVariables
>;

/**
 * __usePublishValuesDeckMutation__
 *
 * To run a mutation, you first call `usePublishValuesDeckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishValuesDeckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishValuesDeckMutation, { data, loading, error }] = usePublishValuesDeckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishValuesDeckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishValuesDeckMutation,
    PublishValuesDeckMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishValuesDeckMutation,
    PublishValuesDeckMutationVariables
  >(PublishValuesDeckDocument, options);
}
export type PublishValuesDeckMutationHookResult = ReturnType<
  typeof usePublishValuesDeckMutation
>;
export type PublishValuesDeckMutationResult =
  Apollo.MutationResult<PublishValuesDeckMutation>;
export type PublishValuesDeckMutationOptions = Apollo.BaseMutationOptions<
  PublishValuesDeckMutation,
  PublishValuesDeckMutationVariables
>;
export const StartValuesSortDocument = gql`
  mutation StartValuesSort($input: StartValuesSortInput!) {
    startValuesSort(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type StartValuesSortMutationFn = Apollo.MutationFunction<
  StartValuesSortMutation,
  StartValuesSortMutationVariables
>;

/**
 * __useStartValuesSortMutation__
 *
 * To run a mutation, you first call `useStartValuesSortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartValuesSortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startValuesSortMutation, { data, loading, error }] = useStartValuesSortMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartValuesSortMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartValuesSortMutation,
    StartValuesSortMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartValuesSortMutation,
    StartValuesSortMutationVariables
  >(StartValuesSortDocument, options);
}
export type StartValuesSortMutationHookResult = ReturnType<
  typeof useStartValuesSortMutation
>;
export type StartValuesSortMutationResult =
  Apollo.MutationResult<StartValuesSortMutation>;
export type StartValuesSortMutationOptions = Apollo.BaseMutationOptions<
  StartValuesSortMutation,
  StartValuesSortMutationVariables
>;
export const CompleteValuesSortDocument = gql`
  mutation CompleteValuesSort($input: CompleteValuesSortInput!) {
    completeValuesSort(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type CompleteValuesSortMutationFn = Apollo.MutationFunction<
  CompleteValuesSortMutation,
  CompleteValuesSortMutationVariables
>;

/**
 * __useCompleteValuesSortMutation__
 *
 * To run a mutation, you first call `useCompleteValuesSortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteValuesSortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeValuesSortMutation, { data, loading, error }] = useCompleteValuesSortMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteValuesSortMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteValuesSortMutation,
    CompleteValuesSortMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteValuesSortMutation,
    CompleteValuesSortMutationVariables
  >(CompleteValuesSortDocument, options);
}
export type CompleteValuesSortMutationHookResult = ReturnType<
  typeof useCompleteValuesSortMutation
>;
export type CompleteValuesSortMutationResult =
  Apollo.MutationResult<CompleteValuesSortMutation>;
export type CompleteValuesSortMutationOptions = Apollo.BaseMutationOptions<
  CompleteValuesSortMutation,
  CompleteValuesSortMutationVariables
>;
export const ConfigureValuesWheelDocument = gql`
  mutation ConfigureValuesWheel($input: ConfigureValuesWheelInput!) {
    configureValuesWheel(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type ConfigureValuesWheelMutationFn = Apollo.MutationFunction<
  ConfigureValuesWheelMutation,
  ConfigureValuesWheelMutationVariables
>;

/**
 * __useConfigureValuesWheelMutation__
 *
 * To run a mutation, you first call `useConfigureValuesWheelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigureValuesWheelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configureValuesWheelMutation, { data, loading, error }] = useConfigureValuesWheelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigureValuesWheelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfigureValuesWheelMutation,
    ConfigureValuesWheelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConfigureValuesWheelMutation,
    ConfigureValuesWheelMutationVariables
  >(ConfigureValuesWheelDocument, options);
}
export type ConfigureValuesWheelMutationHookResult = ReturnType<
  typeof useConfigureValuesWheelMutation
>;
export type ConfigureValuesWheelMutationResult =
  Apollo.MutationResult<ConfigureValuesWheelMutation>;
export type ConfigureValuesWheelMutationOptions = Apollo.BaseMutationOptions<
  ConfigureValuesWheelMutation,
  ConfigureValuesWheelMutationVariables
>;
export const RateValuesWheelDocument = gql`
  mutation RateValuesWheel($input: RateValuesWheelInput!) {
    rateValuesWheel(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type RateValuesWheelMutationFn = Apollo.MutationFunction<
  RateValuesWheelMutation,
  RateValuesWheelMutationVariables
>;

/**
 * __useRateValuesWheelMutation__
 *
 * To run a mutation, you first call `useRateValuesWheelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateValuesWheelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateValuesWheelMutation, { data, loading, error }] = useRateValuesWheelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRateValuesWheelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RateValuesWheelMutation,
    RateValuesWheelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RateValuesWheelMutation,
    RateValuesWheelMutationVariables
  >(RateValuesWheelDocument, options);
}
export type RateValuesWheelMutationHookResult = ReturnType<
  typeof useRateValuesWheelMutation
>;
export type RateValuesWheelMutationResult =
  Apollo.MutationResult<RateValuesWheelMutation>;
export type RateValuesWheelMutationOptions = Apollo.BaseMutationOptions<
  RateValuesWheelMutation,
  RateValuesWheelMutationVariables
>;
export const RateValuesWheelInSessionDocument = gql`
  mutation RateValuesWheelInSession($input: RateValuesWheelInSessionInput!) {
    rateValuesWheelInSession(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type RateValuesWheelInSessionMutationFn = Apollo.MutationFunction<
  RateValuesWheelInSessionMutation,
  RateValuesWheelInSessionMutationVariables
>;

/**
 * __useRateValuesWheelInSessionMutation__
 *
 * To run a mutation, you first call `useRateValuesWheelInSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateValuesWheelInSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateValuesWheelInSessionMutation, { data, loading, error }] = useRateValuesWheelInSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRateValuesWheelInSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RateValuesWheelInSessionMutation,
    RateValuesWheelInSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RateValuesWheelInSessionMutation,
    RateValuesWheelInSessionMutationVariables
  >(RateValuesWheelInSessionDocument, options);
}
export type RateValuesWheelInSessionMutationHookResult = ReturnType<
  typeof useRateValuesWheelInSessionMutation
>;
export type RateValuesWheelInSessionMutationResult =
  Apollo.MutationResult<RateValuesWheelInSessionMutation>;
export type RateValuesWheelInSessionMutationOptions =
  Apollo.BaseMutationOptions<
    RateValuesWheelInSessionMutation,
    RateValuesWheelInSessionMutationVariables
  >;
export const NoteValuesObstacleDocument = gql`
  mutation NoteValuesObstacle($input: NoteValuesObstacleInput!) {
    noteValuesObstacle(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type NoteValuesObstacleMutationFn = Apollo.MutationFunction<
  NoteValuesObstacleMutation,
  NoteValuesObstacleMutationVariables
>;

/**
 * __useNoteValuesObstacleMutation__
 *
 * To run a mutation, you first call `useNoteValuesObstacleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteValuesObstacleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteValuesObstacleMutation, { data, loading, error }] = useNoteValuesObstacleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNoteValuesObstacleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    NoteValuesObstacleMutation,
    NoteValuesObstacleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    NoteValuesObstacleMutation,
    NoteValuesObstacleMutationVariables
  >(NoteValuesObstacleDocument, options);
}
export type NoteValuesObstacleMutationHookResult = ReturnType<
  typeof useNoteValuesObstacleMutation
>;
export type NoteValuesObstacleMutationResult =
  Apollo.MutationResult<NoteValuesObstacleMutation>;
export type NoteValuesObstacleMutationOptions = Apollo.BaseMutationOptions<
  NoteValuesObstacleMutation,
  NoteValuesObstacleMutationVariables
>;
export const CommitToValuedActionDocument = gql`
  mutation CommitToValuedAction($input: CommitToValuedActionInput!) {
    commitToValuedAction(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type CommitToValuedActionMutationFn = Apollo.MutationFunction<
  CommitToValuedActionMutation,
  CommitToValuedActionMutationVariables
>;

/**
 * __useCommitToValuedActionMutation__
 *
 * To run a mutation, you first call `useCommitToValuedActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommitToValuedActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commitToValuedActionMutation, { data, loading, error }] = useCommitToValuedActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCommitToValuedActionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CommitToValuedActionMutation,
    CommitToValuedActionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CommitToValuedActionMutation,
    CommitToValuedActionMutationVariables
  >(CommitToValuedActionDocument, options);
}
export type CommitToValuedActionMutationHookResult = ReturnType<
  typeof useCommitToValuedActionMutation
>;
export type CommitToValuedActionMutationResult =
  Apollo.MutationResult<CommitToValuedActionMutation>;
export type CommitToValuedActionMutationOptions = Apollo.BaseMutationOptions<
  CommitToValuedActionMutation,
  CommitToValuedActionMutationVariables
>;
export const CompleteValuedLivingQuestionnaireDocument = gql`
  mutation CompleteValuedLivingQuestionnaire(
    $input: CompleteValuedLivingQuestionnaireInput!
  ) {
    completeValuedLivingQuestionnaire(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type CompleteValuedLivingQuestionnaireMutationFn =
  Apollo.MutationFunction<
    CompleteValuedLivingQuestionnaireMutation,
    CompleteValuedLivingQuestionnaireMutationVariables
  >;

/**
 * __useCompleteValuedLivingQuestionnaireMutation__
 *
 * To run a mutation, you first call `useCompleteValuedLivingQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteValuedLivingQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeValuedLivingQuestionnaireMutation, { data, loading, error }] = useCompleteValuedLivingQuestionnaireMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteValuedLivingQuestionnaireMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CompleteValuedLivingQuestionnaireMutation,
    CompleteValuedLivingQuestionnaireMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CompleteValuedLivingQuestionnaireMutation,
    CompleteValuedLivingQuestionnaireMutationVariables
  >(CompleteValuedLivingQuestionnaireDocument, options);
}
export type CompleteValuedLivingQuestionnaireMutationHookResult = ReturnType<
  typeof useCompleteValuedLivingQuestionnaireMutation
>;
export type CompleteValuedLivingQuestionnaireMutationResult =
  Apollo.MutationResult<CompleteValuedLivingQuestionnaireMutation>;
export type CompleteValuedLivingQuestionnaireMutationOptions =
  Apollo.BaseMutationOptions<
    CompleteValuedLivingQuestionnaireMutation,
    CompleteValuedLivingQuestionnaireMutationVariables
  >;
export const DefineValueActivityDocument = gql`
  mutation DefineValueActivity($input: DefineValueActivityInput!) {
    defineValueActivity(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type DefineValueActivityMutationFn = Apollo.MutationFunction<
  DefineValueActivityMutation,
  DefineValueActivityMutationVariables
>;

/**
 * __useDefineValueActivityMutation__
 *
 * To run a mutation, you first call `useDefineValueActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefineValueActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [defineValueActivityMutation, { data, loading, error }] = useDefineValueActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefineValueActivityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DefineValueActivityMutation,
    DefineValueActivityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DefineValueActivityMutation,
    DefineValueActivityMutationVariables
  >(DefineValueActivityDocument, options);
}
export type DefineValueActivityMutationHookResult = ReturnType<
  typeof useDefineValueActivityMutation
>;
export type DefineValueActivityMutationResult =
  Apollo.MutationResult<DefineValueActivityMutation>;
export type DefineValueActivityMutationOptions = Apollo.BaseMutationOptions<
  DefineValueActivityMutation,
  DefineValueActivityMutationVariables
>;
export const RequestActivitySuggestionsDocument = gql`
  mutation RequestActivitySuggestions(
    $input: RequestActivitySuggestionsInput!
  ) {
    requestActivitySuggestions(input: $input) {
      requestId
      recorded
      code
      suggestions {
        activity
        difficulty
      }
    }
  }
`;
export type RequestActivitySuggestionsMutationFn = Apollo.MutationFunction<
  RequestActivitySuggestionsMutation,
  RequestActivitySuggestionsMutationVariables
>;

/**
 * __useRequestActivitySuggestionsMutation__
 *
 * To run a mutation, you first call `useRequestActivitySuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestActivitySuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestActivitySuggestionsMutation, { data, loading, error }] = useRequestActivitySuggestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestActivitySuggestionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestActivitySuggestionsMutation,
    RequestActivitySuggestionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RequestActivitySuggestionsMutation,
    RequestActivitySuggestionsMutationVariables
  >(RequestActivitySuggestionsDocument, options);
}
export type RequestActivitySuggestionsMutationHookResult = ReturnType<
  typeof useRequestActivitySuggestionsMutation
>;
export type RequestActivitySuggestionsMutationResult =
  Apollo.MutationResult<RequestActivitySuggestionsMutation>;
export type RequestActivitySuggestionsMutationOptions =
  Apollo.BaseMutationOptions<
    RequestActivitySuggestionsMutation,
    RequestActivitySuggestionsMutationVariables
  >;
export const LinkRecordToValueDocument = gql`
  mutation LinkRecordToValue($input: LinkRecordToValueInput!) {
    linkRecordToValue(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type LinkRecordToValueMutationFn = Apollo.MutationFunction<
  LinkRecordToValueMutation,
  LinkRecordToValueMutationVariables
>;

/**
 * __useLinkRecordToValueMutation__
 *
 * To run a mutation, you first call `useLinkRecordToValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkRecordToValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkRecordToValueMutation, { data, loading, error }] = useLinkRecordToValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkRecordToValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LinkRecordToValueMutation,
    LinkRecordToValueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LinkRecordToValueMutation,
    LinkRecordToValueMutationVariables
  >(LinkRecordToValueDocument, options);
}
export type LinkRecordToValueMutationHookResult = ReturnType<
  typeof useLinkRecordToValueMutation
>;
export type LinkRecordToValueMutationResult =
  Apollo.MutationResult<LinkRecordToValueMutation>;
export type LinkRecordToValueMutationOptions = Apollo.BaseMutationOptions<
  LinkRecordToValueMutation,
  LinkRecordToValueMutationVariables
>;
export const UnlinkRecordFromValueDocument = gql`
  mutation UnlinkRecordFromValue($input: UnlinkRecordFromValueInput!) {
    unlinkRecordFromValue(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type UnlinkRecordFromValueMutationFn = Apollo.MutationFunction<
  UnlinkRecordFromValueMutation,
  UnlinkRecordFromValueMutationVariables
>;

/**
 * __useUnlinkRecordFromValueMutation__
 *
 * To run a mutation, you first call `useUnlinkRecordFromValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkRecordFromValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkRecordFromValueMutation, { data, loading, error }] = useUnlinkRecordFromValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkRecordFromValueMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnlinkRecordFromValueMutation,
    UnlinkRecordFromValueMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnlinkRecordFromValueMutation,
    UnlinkRecordFromValueMutationVariables
  >(UnlinkRecordFromValueDocument, options);
}
export type UnlinkRecordFromValueMutationHookResult = ReturnType<
  typeof useUnlinkRecordFromValueMutation
>;
export type UnlinkRecordFromValueMutationResult =
  Apollo.MutationResult<UnlinkRecordFromValueMutation>;
export type UnlinkRecordFromValueMutationOptions = Apollo.BaseMutationOptions<
  UnlinkRecordFromValueMutation,
  UnlinkRecordFromValueMutationVariables
>;
export const ValuesDeckDocument = gql`
  query ValuesDeck($language: String) {
    valuesDeck(language: $language) {
      deckId
      name
      licence
      citation
      language
      cards {
        card
        text
      }
      presets {
        preset
        cards
        cardIds
      }
    }
  }
`;

/**
 * __useValuesDeckQuery__
 *
 * To run a query within a React component, call `useValuesDeckQuery` and pass it any options that fit your needs.
 * When your component renders, `useValuesDeckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValuesDeckQuery({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useValuesDeckQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ValuesDeckQuery,
    ValuesDeckQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValuesDeckQuery, ValuesDeckQueryVariables>(
    ValuesDeckDocument,
    options,
  );
}
export function useValuesDeckLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValuesDeckQuery,
    ValuesDeckQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ValuesDeckQuery, ValuesDeckQueryVariables>(
    ValuesDeckDocument,
    options,
  );
}
export type ValuesDeckQueryHookResult = ReturnType<typeof useValuesDeckQuery>;
export type ValuesDeckLazyQueryHookResult = ReturnType<
  typeof useValuesDeckLazyQuery
>;
export type ValuesDeckQueryResult = Apollo.QueryResult<
  ValuesDeckQuery,
  ValuesDeckQueryVariables
>;
export const ValuesSortProgressDocument = gql`
  query ValuesSortProgress {
    valuesSortProgress {
      sortId
      deckId
      preset
      cardOrder
      status
      startedAt
      completedAt
    }
  }
`;

/**
 * __useValuesSortProgressQuery__
 *
 * To run a query within a React component, call `useValuesSortProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useValuesSortProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValuesSortProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useValuesSortProgressQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ValuesSortProgressQuery,
    ValuesSortProgressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ValuesSortProgressQuery,
    ValuesSortProgressQueryVariables
  >(ValuesSortProgressDocument, options);
}
export function useValuesSortProgressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValuesSortProgressQuery,
    ValuesSortProgressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ValuesSortProgressQuery,
    ValuesSortProgressQueryVariables
  >(ValuesSortProgressDocument, options);
}
export type ValuesSortProgressQueryHookResult = ReturnType<
  typeof useValuesSortProgressQuery
>;
export type ValuesSortProgressLazyQueryHookResult = ReturnType<
  typeof useValuesSortProgressLazyQuery
>;
export type ValuesSortProgressQueryResult = Apollo.QueryResult<
  ValuesSortProgressQuery,
  ValuesSortProgressQueryVariables
>;
export const ValuesSortResultDocument = gql`
  query ValuesSortResult($sortId: ID!, $language: String) {
    valuesSortResult(sortId: $sortId, language: $language) {
      sortId
      deckId
      ranked
      piles {
        veryImportant
        important
        notImportant
      }
      veryImportantCount
      occurredAt
      cardText {
        card
        text
      }
    }
  }
`;

/**
 * __useValuesSortResultQuery__
 *
 * To run a query within a React component, call `useValuesSortResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useValuesSortResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValuesSortResultQuery({
 *   variables: {
 *      sortId: // value for 'sortId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useValuesSortResultQuery(
  baseOptions: Apollo.QueryHookOptions<
    ValuesSortResultQuery,
    ValuesSortResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValuesSortResultQuery, ValuesSortResultQueryVariables>(
    ValuesSortResultDocument,
    options,
  );
}
export function useValuesSortResultLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValuesSortResultQuery,
    ValuesSortResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ValuesSortResultQuery,
    ValuesSortResultQueryVariables
  >(ValuesSortResultDocument, options);
}
export type ValuesSortResultQueryHookResult = ReturnType<
  typeof useValuesSortResultQuery
>;
export type ValuesSortResultLazyQueryHookResult = ReturnType<
  typeof useValuesSortResultLazyQuery
>;
export type ValuesSortResultQueryResult = Apollo.QueryResult<
  ValuesSortResultQuery,
  ValuesSortResultQueryVariables
>;
export const ValuesWheelDocument = gql`
  query ValuesWheel($subject: ID) {
    valuesWheel(subject: $subject) {
      ...ValuesWheelFields
    }
  }
  ${ValuesWheelFieldsFragmentDoc}
`;

/**
 * __useValuesWheelQuery__
 *
 * To run a query within a React component, call `useValuesWheelQuery` and pass it any options that fit your needs.
 * When your component renders, `useValuesWheelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValuesWheelQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useValuesWheelQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ValuesWheelQuery,
    ValuesWheelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValuesWheelQuery, ValuesWheelQueryVariables>(
    ValuesWheelDocument,
    options,
  );
}
export function useValuesWheelLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValuesWheelQuery,
    ValuesWheelQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ValuesWheelQuery, ValuesWheelQueryVariables>(
    ValuesWheelDocument,
    options,
  );
}
export type ValuesWheelQueryHookResult = ReturnType<typeof useValuesWheelQuery>;
export type ValuesWheelLazyQueryHookResult = ReturnType<
  typeof useValuesWheelLazyQuery
>;
export type ValuesWheelQueryResult = Apollo.QueryResult<
  ValuesWheelQuery,
  ValuesWheelQueryVariables
>;
export const ValuedLivingResultDocument = gql`
  query ValuedLivingResult($vlqId: ID) {
    valuedLivingResult(vlqId: $vlqId) {
      vlqId
      composite
      areas {
        area
        importance
        consistency
        gap
      }
      occurredAt
      previousComposite
      changeSinceLast
    }
  }
`;

/**
 * __useValuedLivingResultQuery__
 *
 * To run a query within a React component, call `useValuedLivingResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useValuedLivingResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValuedLivingResultQuery({
 *   variables: {
 *      vlqId: // value for 'vlqId'
 *   },
 * });
 */
export function useValuedLivingResultQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ValuedLivingResultQuery,
    ValuedLivingResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ValuedLivingResultQuery,
    ValuedLivingResultQueryVariables
  >(ValuedLivingResultDocument, options);
}
export function useValuedLivingResultLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValuedLivingResultQuery,
    ValuedLivingResultQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ValuedLivingResultQuery,
    ValuedLivingResultQueryVariables
  >(ValuedLivingResultDocument, options);
}
export type ValuedLivingResultQueryHookResult = ReturnType<
  typeof useValuedLivingResultQuery
>;
export type ValuedLivingResultLazyQueryHookResult = ReturnType<
  typeof useValuedLivingResultLazyQuery
>;
export type ValuedLivingResultQueryResult = Apollo.QueryResult<
  ValuedLivingResultQuery,
  ValuedLivingResultQueryVariables
>;
export const ValueActivitiesDocument = gql`
  query ValueActivities($value: String!) {
    valueActivities(value: $value) {
      value
      activities {
        activityId
        activity
        difficulty
        source
        origin
        status
      }
      suggested {
        activity
        difficulty
      }
      suggestionRequestId
    }
  }
`;

/**
 * __useValueActivitiesQuery__
 *
 * To run a query within a React component, call `useValueActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useValueActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValueActivitiesQuery({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useValueActivitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ValueActivitiesQuery,
    ValueActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValueActivitiesQuery, ValueActivitiesQueryVariables>(
    ValueActivitiesDocument,
    options,
  );
}
export function useValueActivitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValueActivitiesQuery,
    ValueActivitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ValueActivitiesQuery,
    ValueActivitiesQueryVariables
  >(ValueActivitiesDocument, options);
}
export type ValueActivitiesQueryHookResult = ReturnType<
  typeof useValueActivitiesQuery
>;
export type ValueActivitiesLazyQueryHookResult = ReturnType<
  typeof useValueActivitiesLazyQuery
>;
export type ValueActivitiesQueryResult = Apollo.QueryResult<
  ValueActivitiesQuery,
  ValueActivitiesQueryVariables
>;
export const ValuesProfileDocument = gql`
  query ValuesProfile($subject: ID, $language: String) {
    valuesProfile(subject: $subject, language: $language) {
      ...ValuesProfileFields
    }
  }
  ${ValuesProfileFieldsFragmentDoc}
`;

/**
 * __useValuesProfileQuery__
 *
 * To run a query within a React component, call `useValuesProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useValuesProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValuesProfileQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useValuesProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ValuesProfileQuery,
    ValuesProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ValuesProfileQuery, ValuesProfileQueryVariables>(
    ValuesProfileDocument,
    options,
  );
}
export function useValuesProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ValuesProfileQuery,
    ValuesProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ValuesProfileQuery, ValuesProfileQueryVariables>(
    ValuesProfileDocument,
    options,
  );
}
export type ValuesProfileQueryHookResult = ReturnType<
  typeof useValuesProfileQuery
>;
export type ValuesProfileLazyQueryHookResult = ReturnType<
  typeof useValuesProfileLazyQuery
>;
export type ValuesProfileQueryResult = Apollo.QueryResult<
  ValuesProfileQuery,
  ValuesProfileQueryVariables
>;
export const WindRoseDocument = gql`
  query WindRose($subject: ID) {
    windRose(subject: $subject) {
      subject
      ratedAt
      chosenStrategyId
      strategies {
        ...RoseStrategyFields
      }
    }
  }
  ${RoseStrategyFieldsFragmentDoc}
`;

/**
 * __useWindRoseQuery__
 *
 * To run a query within a React component, call `useWindRoseQuery` and pass it any options that fit your needs.
 * When your component renders, `useWindRoseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWindRoseQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useWindRoseQuery(
  baseOptions?: Apollo.QueryHookOptions<WindRoseQuery, WindRoseQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WindRoseQuery, WindRoseQueryVariables>(
    WindRoseDocument,
    options,
  );
}
export function useWindRoseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WindRoseQuery,
    WindRoseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WindRoseQuery, WindRoseQueryVariables>(
    WindRoseDocument,
    options,
  );
}
export type WindRoseQueryHookResult = ReturnType<typeof useWindRoseQuery>;
export type WindRoseLazyQueryHookResult = ReturnType<
  typeof useWindRoseLazyQuery
>;
export type WindRoseQueryResult = Apollo.QueryResult<
  WindRoseQuery,
  WindRoseQueryVariables
>;
export const DescribeBehaviorStrategyDocument = gql`
  mutation DescribeBehaviorStrategy($input: DescribeBehaviorStrategyInput!) {
    describeBehaviorStrategy(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type DescribeBehaviorStrategyMutationFn = Apollo.MutationFunction<
  DescribeBehaviorStrategyMutation,
  DescribeBehaviorStrategyMutationVariables
>;

/**
 * __useDescribeBehaviorStrategyMutation__
 *
 * To run a mutation, you first call `useDescribeBehaviorStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDescribeBehaviorStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [describeBehaviorStrategyMutation, { data, loading, error }] = useDescribeBehaviorStrategyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDescribeBehaviorStrategyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DescribeBehaviorStrategyMutation,
    DescribeBehaviorStrategyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DescribeBehaviorStrategyMutation,
    DescribeBehaviorStrategyMutationVariables
  >(DescribeBehaviorStrategyDocument, options);
}
export type DescribeBehaviorStrategyMutationHookResult = ReturnType<
  typeof useDescribeBehaviorStrategyMutation
>;
export type DescribeBehaviorStrategyMutationResult =
  Apollo.MutationResult<DescribeBehaviorStrategyMutation>;
export type DescribeBehaviorStrategyMutationOptions =
  Apollo.BaseMutationOptions<
    DescribeBehaviorStrategyMutation,
    DescribeBehaviorStrategyMutationVariables
  >;
export const DescribeBehaviorStrategyInSessionDocument = gql`
  mutation DescribeBehaviorStrategyInSession(
    $input: DescribeBehaviorStrategyInSessionInput!
  ) {
    describeBehaviorStrategyInSession(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type DescribeBehaviorStrategyInSessionMutationFn =
  Apollo.MutationFunction<
    DescribeBehaviorStrategyInSessionMutation,
    DescribeBehaviorStrategyInSessionMutationVariables
  >;

/**
 * __useDescribeBehaviorStrategyInSessionMutation__
 *
 * To run a mutation, you first call `useDescribeBehaviorStrategyInSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDescribeBehaviorStrategyInSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [describeBehaviorStrategyInSessionMutation, { data, loading, error }] = useDescribeBehaviorStrategyInSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDescribeBehaviorStrategyInSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DescribeBehaviorStrategyInSessionMutation,
    DescribeBehaviorStrategyInSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DescribeBehaviorStrategyInSessionMutation,
    DescribeBehaviorStrategyInSessionMutationVariables
  >(DescribeBehaviorStrategyInSessionDocument, options);
}
export type DescribeBehaviorStrategyInSessionMutationHookResult = ReturnType<
  typeof useDescribeBehaviorStrategyInSessionMutation
>;
export type DescribeBehaviorStrategyInSessionMutationResult =
  Apollo.MutationResult<DescribeBehaviorStrategyInSessionMutation>;
export type DescribeBehaviorStrategyInSessionMutationOptions =
  Apollo.BaseMutationOptions<
    DescribeBehaviorStrategyInSessionMutation,
    DescribeBehaviorStrategyInSessionMutationVariables
  >;
export const RateStrategyOnNeedsDocument = gql`
  mutation RateStrategyOnNeeds($input: RateStrategyOnNeedsInput!) {
    rateStrategyOnNeeds(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type RateStrategyOnNeedsMutationFn = Apollo.MutationFunction<
  RateStrategyOnNeedsMutation,
  RateStrategyOnNeedsMutationVariables
>;

/**
 * __useRateStrategyOnNeedsMutation__
 *
 * To run a mutation, you first call `useRateStrategyOnNeedsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateStrategyOnNeedsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateStrategyOnNeedsMutation, { data, loading, error }] = useRateStrategyOnNeedsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRateStrategyOnNeedsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RateStrategyOnNeedsMutation,
    RateStrategyOnNeedsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RateStrategyOnNeedsMutation,
    RateStrategyOnNeedsMutationVariables
  >(RateStrategyOnNeedsDocument, options);
}
export type RateStrategyOnNeedsMutationHookResult = ReturnType<
  typeof useRateStrategyOnNeedsMutation
>;
export type RateStrategyOnNeedsMutationResult =
  Apollo.MutationResult<RateStrategyOnNeedsMutation>;
export type RateStrategyOnNeedsMutationOptions = Apollo.BaseMutationOptions<
  RateStrategyOnNeedsMutation,
  RateStrategyOnNeedsMutationVariables
>;
export const RateStrategyOnNeedsInSessionDocument = gql`
  mutation RateStrategyOnNeedsInSession(
    $input: RateStrategyOnNeedsInSessionInput!
  ) {
    rateStrategyOnNeedsInSession(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type RateStrategyOnNeedsInSessionMutationFn = Apollo.MutationFunction<
  RateStrategyOnNeedsInSessionMutation,
  RateStrategyOnNeedsInSessionMutationVariables
>;

/**
 * __useRateStrategyOnNeedsInSessionMutation__
 *
 * To run a mutation, you first call `useRateStrategyOnNeedsInSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateStrategyOnNeedsInSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateStrategyOnNeedsInSessionMutation, { data, loading, error }] = useRateStrategyOnNeedsInSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRateStrategyOnNeedsInSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RateStrategyOnNeedsInSessionMutation,
    RateStrategyOnNeedsInSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RateStrategyOnNeedsInSessionMutation,
    RateStrategyOnNeedsInSessionMutationVariables
  >(RateStrategyOnNeedsInSessionDocument, options);
}
export type RateStrategyOnNeedsInSessionMutationHookResult = ReturnType<
  typeof useRateStrategyOnNeedsInSessionMutation
>;
export type RateStrategyOnNeedsInSessionMutationResult =
  Apollo.MutationResult<RateStrategyOnNeedsInSessionMutation>;
export type RateStrategyOnNeedsInSessionMutationOptions =
  Apollo.BaseMutationOptions<
    RateStrategyOnNeedsInSessionMutation,
    RateStrategyOnNeedsInSessionMutationVariables
  >;
export const ChooseBehaviorStrategyDocument = gql`
  mutation ChooseBehaviorStrategy($input: ChooseBehaviorStrategyInput!) {
    chooseBehaviorStrategy(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type ChooseBehaviorStrategyMutationFn = Apollo.MutationFunction<
  ChooseBehaviorStrategyMutation,
  ChooseBehaviorStrategyMutationVariables
>;

/**
 * __useChooseBehaviorStrategyMutation__
 *
 * To run a mutation, you first call `useChooseBehaviorStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseBehaviorStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseBehaviorStrategyMutation, { data, loading, error }] = useChooseBehaviorStrategyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChooseBehaviorStrategyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChooseBehaviorStrategyMutation,
    ChooseBehaviorStrategyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChooseBehaviorStrategyMutation,
    ChooseBehaviorStrategyMutationVariables
  >(ChooseBehaviorStrategyDocument, options);
}
export type ChooseBehaviorStrategyMutationHookResult = ReturnType<
  typeof useChooseBehaviorStrategyMutation
>;
export type ChooseBehaviorStrategyMutationResult =
  Apollo.MutationResult<ChooseBehaviorStrategyMutation>;
export type ChooseBehaviorStrategyMutationOptions = Apollo.BaseMutationOptions<
  ChooseBehaviorStrategyMutation,
  ChooseBehaviorStrategyMutationVariables
>;
export const ChooseBehaviorStrategyInSessionDocument = gql`
  mutation ChooseBehaviorStrategyInSession(
    $input: ChooseBehaviorStrategyInSessionInput!
  ) {
    chooseBehaviorStrategyInSession(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type ChooseBehaviorStrategyInSessionMutationFn = Apollo.MutationFunction<
  ChooseBehaviorStrategyInSessionMutation,
  ChooseBehaviorStrategyInSessionMutationVariables
>;

/**
 * __useChooseBehaviorStrategyInSessionMutation__
 *
 * To run a mutation, you first call `useChooseBehaviorStrategyInSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChooseBehaviorStrategyInSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chooseBehaviorStrategyInSessionMutation, { data, loading, error }] = useChooseBehaviorStrategyInSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChooseBehaviorStrategyInSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ChooseBehaviorStrategyInSessionMutation,
    ChooseBehaviorStrategyInSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ChooseBehaviorStrategyInSessionMutation,
    ChooseBehaviorStrategyInSessionMutationVariables
  >(ChooseBehaviorStrategyInSessionDocument, options);
}
export type ChooseBehaviorStrategyInSessionMutationHookResult = ReturnType<
  typeof useChooseBehaviorStrategyInSessionMutation
>;
export type ChooseBehaviorStrategyInSessionMutationResult =
  Apollo.MutationResult<ChooseBehaviorStrategyInSessionMutation>;
export type ChooseBehaviorStrategyInSessionMutationOptions =
  Apollo.BaseMutationOptions<
    ChooseBehaviorStrategyInSessionMutation,
    ChooseBehaviorStrategyInSessionMutationVariables
  >;
export const WriteStrategyPlanDocument = gql`
  mutation WriteStrategyPlan($input: WriteStrategyPlanInput!) {
    writeStrategyPlan(input: $input) {
      ...ValuesCommandFields
    }
  }
  ${ValuesCommandFieldsFragmentDoc}
`;
export type WriteStrategyPlanMutationFn = Apollo.MutationFunction<
  WriteStrategyPlanMutation,
  WriteStrategyPlanMutationVariables
>;

/**
 * __useWriteStrategyPlanMutation__
 *
 * To run a mutation, you first call `useWriteStrategyPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteStrategyPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeStrategyPlanMutation, { data, loading, error }] = useWriteStrategyPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWriteStrategyPlanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WriteStrategyPlanMutation,
    WriteStrategyPlanMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    WriteStrategyPlanMutation,
    WriteStrategyPlanMutationVariables
  >(WriteStrategyPlanDocument, options);
}
export type WriteStrategyPlanMutationHookResult = ReturnType<
  typeof useWriteStrategyPlanMutation
>;
export type WriteStrategyPlanMutationResult =
  Apollo.MutationResult<WriteStrategyPlanMutation>;
export type WriteStrategyPlanMutationOptions = Apollo.BaseMutationOptions<
  WriteStrategyPlanMutation,
  WriteStrategyPlanMutationVariables
>;
export const CreateViciousCycleDocument = gql`
  mutation CreateViciousCycle($input: CreateViciousCycleInput!) {
    createViciousCycle(input: $input) {
      viciousCycleId
      supportingCycle {
        _id
        ...SupportingCycleData
      }
    }
  }
  ${SupportingCycleDataFragmentDoc}
`;
export type CreateViciousCycleMutationFn = Apollo.MutationFunction<
  CreateViciousCycleMutation,
  CreateViciousCycleMutationVariables
>;

/**
 * __useCreateViciousCycleMutation__
 *
 * To run a mutation, you first call `useCreateViciousCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateViciousCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createViciousCycleMutation, { data, loading, error }] = useCreateViciousCycleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateViciousCycleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateViciousCycleMutation,
    CreateViciousCycleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateViciousCycleMutation,
    CreateViciousCycleMutationVariables
  >(CreateViciousCycleDocument, options);
}
export type CreateViciousCycleMutationHookResult = ReturnType<
  typeof useCreateViciousCycleMutation
>;
export type CreateViciousCycleMutationResult =
  Apollo.MutationResult<CreateViciousCycleMutation>;
export type CreateViciousCycleMutationOptions = Apollo.BaseMutationOptions<
  CreateViciousCycleMutation,
  CreateViciousCycleMutationVariables
>;
export const RenameViciousCycleDocument = gql`
  mutation RenameViciousCycle($input: RenameViciousCycleInput!) {
    renameViciousCycle(input: $input) {
      viciousCycleId
      supportingCycle {
        _id
        ...SupportingCycleData
      }
    }
  }
  ${SupportingCycleDataFragmentDoc}
`;
export type RenameViciousCycleMutationFn = Apollo.MutationFunction<
  RenameViciousCycleMutation,
  RenameViciousCycleMutationVariables
>;

/**
 * __useRenameViciousCycleMutation__
 *
 * To run a mutation, you first call `useRenameViciousCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameViciousCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameViciousCycleMutation, { data, loading, error }] = useRenameViciousCycleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameViciousCycleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RenameViciousCycleMutation,
    RenameViciousCycleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RenameViciousCycleMutation,
    RenameViciousCycleMutationVariables
  >(RenameViciousCycleDocument, options);
}
export type RenameViciousCycleMutationHookResult = ReturnType<
  typeof useRenameViciousCycleMutation
>;
export type RenameViciousCycleMutationResult =
  Apollo.MutationResult<RenameViciousCycleMutation>;
export type RenameViciousCycleMutationOptions = Apollo.BaseMutationOptions<
  RenameViciousCycleMutation,
  RenameViciousCycleMutationVariables
>;
export const AddCycleThoughtDocument = gql`
  mutation AddCycleThought($input: AddCycleThoughtInput!) {
    addCycleThought(input: $input) {
      viciousCycleId
      supportingCycle {
        _id
        ...SupportingCycleData
      }
    }
  }
  ${SupportingCycleDataFragmentDoc}
`;
export type AddCycleThoughtMutationFn = Apollo.MutationFunction<
  AddCycleThoughtMutation,
  AddCycleThoughtMutationVariables
>;

/**
 * __useAddCycleThoughtMutation__
 *
 * To run a mutation, you first call `useAddCycleThoughtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCycleThoughtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCycleThoughtMutation, { data, loading, error }] = useAddCycleThoughtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCycleThoughtMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddCycleThoughtMutation,
    AddCycleThoughtMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddCycleThoughtMutation,
    AddCycleThoughtMutationVariables
  >(AddCycleThoughtDocument, options);
}
export type AddCycleThoughtMutationHookResult = ReturnType<
  typeof useAddCycleThoughtMutation
>;
export type AddCycleThoughtMutationResult =
  Apollo.MutationResult<AddCycleThoughtMutation>;
export type AddCycleThoughtMutationOptions = Apollo.BaseMutationOptions<
  AddCycleThoughtMutation,
  AddCycleThoughtMutationVariables
>;
export const RemoveCycleThoughtDocument = gql`
  mutation RemoveCycleThought($input: RemoveCycleThoughtInput!) {
    removeCycleThought(input: $input) {
      viciousCycleId
      supportingCycle {
        _id
        ...SupportingCycleData
      }
    }
  }
  ${SupportingCycleDataFragmentDoc}
`;
export type RemoveCycleThoughtMutationFn = Apollo.MutationFunction<
  RemoveCycleThoughtMutation,
  RemoveCycleThoughtMutationVariables
>;

/**
 * __useRemoveCycleThoughtMutation__
 *
 * To run a mutation, you first call `useRemoveCycleThoughtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCycleThoughtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCycleThoughtMutation, { data, loading, error }] = useRemoveCycleThoughtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCycleThoughtMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveCycleThoughtMutation,
    RemoveCycleThoughtMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveCycleThoughtMutation,
    RemoveCycleThoughtMutationVariables
  >(RemoveCycleThoughtDocument, options);
}
export type RemoveCycleThoughtMutationHookResult = ReturnType<
  typeof useRemoveCycleThoughtMutation
>;
export type RemoveCycleThoughtMutationResult =
  Apollo.MutationResult<RemoveCycleThoughtMutation>;
export type RemoveCycleThoughtMutationOptions = Apollo.BaseMutationOptions<
  RemoveCycleThoughtMutation,
  RemoveCycleThoughtMutationVariables
>;
export const ToggleCycleRelationDocument = gql`
  mutation ToggleCycleRelation($input: ToggleCycleRelationInput!) {
    toggleCycleRelation(input: $input) {
      viciousCycleId
      supportingCycle {
        _id
        ...SupportingCycleData
      }
    }
  }
  ${SupportingCycleDataFragmentDoc}
`;
export type ToggleCycleRelationMutationFn = Apollo.MutationFunction<
  ToggleCycleRelationMutation,
  ToggleCycleRelationMutationVariables
>;

/**
 * __useToggleCycleRelationMutation__
 *
 * To run a mutation, you first call `useToggleCycleRelationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCycleRelationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCycleRelationMutation, { data, loading, error }] = useToggleCycleRelationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleCycleRelationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleCycleRelationMutation,
    ToggleCycleRelationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleCycleRelationMutation,
    ToggleCycleRelationMutationVariables
  >(ToggleCycleRelationDocument, options);
}
export type ToggleCycleRelationMutationHookResult = ReturnType<
  typeof useToggleCycleRelationMutation
>;
export type ToggleCycleRelationMutationResult =
  Apollo.MutationResult<ToggleCycleRelationMutation>;
export type ToggleCycleRelationMutationOptions = Apollo.BaseMutationOptions<
  ToggleCycleRelationMutation,
  ToggleCycleRelationMutationVariables
>;
export const EditCycleThoughtDocument = gql`
  mutation EditCycleThought($input: EditCycleThoughtInput!) {
    editCycleThought(input: $input) {
      viciousCycleId
      supportingCycle {
        _id
        ...SupportingCycleData
      }
    }
  }
  ${SupportingCycleDataFragmentDoc}
`;
export type EditCycleThoughtMutationFn = Apollo.MutationFunction<
  EditCycleThoughtMutation,
  EditCycleThoughtMutationVariables
>;

/**
 * __useEditCycleThoughtMutation__
 *
 * To run a mutation, you first call `useEditCycleThoughtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCycleThoughtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCycleThoughtMutation, { data, loading, error }] = useEditCycleThoughtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditCycleThoughtMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditCycleThoughtMutation,
    EditCycleThoughtMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EditCycleThoughtMutation,
    EditCycleThoughtMutationVariables
  >(EditCycleThoughtDocument, options);
}
export type EditCycleThoughtMutationHookResult = ReturnType<
  typeof useEditCycleThoughtMutation
>;
export type EditCycleThoughtMutationResult =
  Apollo.MutationResult<EditCycleThoughtMutation>;
export type EditCycleThoughtMutationOptions = Apollo.BaseMutationOptions<
  EditCycleThoughtMutation,
  EditCycleThoughtMutationVariables
>;
export const DeleteViciousCycleDocument = gql`
  mutation DeleteViciousCycle($input: DeleteViciousCycleInput!) {
    deleteViciousCycle(input: $input) {
      viciousCycleId
      success
    }
  }
`;
export type DeleteViciousCycleMutationFn = Apollo.MutationFunction<
  DeleteViciousCycleMutation,
  DeleteViciousCycleMutationVariables
>;

/**
 * __useDeleteViciousCycleMutation__
 *
 * To run a mutation, you first call `useDeleteViciousCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteViciousCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteViciousCycleMutation, { data, loading, error }] = useDeleteViciousCycleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteViciousCycleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteViciousCycleMutation,
    DeleteViciousCycleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteViciousCycleMutation,
    DeleteViciousCycleMutationVariables
  >(DeleteViciousCycleDocument, options);
}
export type DeleteViciousCycleMutationHookResult = ReturnType<
  typeof useDeleteViciousCycleMutation
>;
export type DeleteViciousCycleMutationResult =
  Apollo.MutationResult<DeleteViciousCycleMutation>;
export type DeleteViciousCycleMutationOptions = Apollo.BaseMutationOptions<
  DeleteViciousCycleMutation,
  DeleteViciousCycleMutationVariables
>;
export const SubmitWellnessEventsDocument = gql`
  mutation SubmitWellnessEvents($events: [WellnessEventInput!]!) {
    submitWellnessEvents(events: $events) {
      lastPosition
      duplicates
    }
  }
`;
export type SubmitWellnessEventsMutationFn = Apollo.MutationFunction<
  SubmitWellnessEventsMutation,
  SubmitWellnessEventsMutationVariables
>;

/**
 * __useSubmitWellnessEventsMutation__
 *
 * To run a mutation, you first call `useSubmitWellnessEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitWellnessEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitWellnessEventsMutation, { data, loading, error }] = useSubmitWellnessEventsMutation({
 *   variables: {
 *      events: // value for 'events'
 *   },
 * });
 */
export function useSubmitWellnessEventsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitWellnessEventsMutation,
    SubmitWellnessEventsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitWellnessEventsMutation,
    SubmitWellnessEventsMutationVariables
  >(SubmitWellnessEventsDocument, options);
}
export type SubmitWellnessEventsMutationHookResult = ReturnType<
  typeof useSubmitWellnessEventsMutation
>;
export type SubmitWellnessEventsMutationResult =
  Apollo.MutationResult<SubmitWellnessEventsMutation>;
export type SubmitWellnessEventsMutationOptions = Apollo.BaseMutationOptions<
  SubmitWellnessEventsMutation,
  SubmitWellnessEventsMutationVariables
>;
export const WorksheetTemplatesDocument = gql`
  query WorksheetTemplates($category: String, $language: String) {
    worksheetTemplates(category: $category, language: $language) {
      ...WorksheetTemplateFields
    }
  }
  ${WorksheetTemplateFieldsFragmentDoc}
`;

/**
 * __useWorksheetTemplatesQuery__
 *
 * To run a query within a React component, call `useWorksheetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorksheetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksheetTemplatesQuery({
 *   variables: {
 *      category: // value for 'category'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useWorksheetTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WorksheetTemplatesQuery,
    WorksheetTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WorksheetTemplatesQuery,
    WorksheetTemplatesQueryVariables
  >(WorksheetTemplatesDocument, options);
}
export function useWorksheetTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorksheetTemplatesQuery,
    WorksheetTemplatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorksheetTemplatesQuery,
    WorksheetTemplatesQueryVariables
  >(WorksheetTemplatesDocument, options);
}
export type WorksheetTemplatesQueryHookResult = ReturnType<
  typeof useWorksheetTemplatesQuery
>;
export type WorksheetTemplatesLazyQueryHookResult = ReturnType<
  typeof useWorksheetTemplatesLazyQuery
>;
export type WorksheetTemplatesQueryResult = Apollo.QueryResult<
  WorksheetTemplatesQuery,
  WorksheetTemplatesQueryVariables
>;
export const WorksheetTemplateDocument = gql`
  query WorksheetTemplate($templateId: ID!, $version: Int) {
    worksheetTemplate(templateId: $templateId, version: $version) {
      templateId
      practiceId
      version
      name
      category
      language
      signatureRequired
      repeatable
      owner
      copiedFrom
      fieldCount
      occurredAt
      retired
      paperEligible
      sections {
        ...WorksheetSectionFields
      }
      scoring {
        ...WorksheetScoringFields
      }
    }
  }
  ${WorksheetSectionFieldsFragmentDoc}
  ${WorksheetScoringFieldsFragmentDoc}
`;

/**
 * __useWorksheetTemplateQuery__
 *
 * To run a query within a React component, call `useWorksheetTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorksheetTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksheetTemplateQuery({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useWorksheetTemplateQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorksheetTemplateQuery,
    WorksheetTemplateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WorksheetTemplateQuery,
    WorksheetTemplateQueryVariables
  >(WorksheetTemplateDocument, options);
}
export function useWorksheetTemplateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorksheetTemplateQuery,
    WorksheetTemplateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorksheetTemplateQuery,
    WorksheetTemplateQueryVariables
  >(WorksheetTemplateDocument, options);
}
export type WorksheetTemplateQueryHookResult = ReturnType<
  typeof useWorksheetTemplateQuery
>;
export type WorksheetTemplateLazyQueryHookResult = ReturnType<
  typeof useWorksheetTemplateLazyQuery
>;
export type WorksheetTemplateQueryResult = Apollo.QueryResult<
  WorksheetTemplateQuery,
  WorksheetTemplateQueryVariables
>;
export const ClientWorksheetsDocument = gql`
  query ClientWorksheets($subject: ID!, $filter: String) {
    clientWorksheets(subject: $subject, filter: $filter) {
      ...ClientWorksheetFields
    }
  }
  ${ClientWorksheetFieldsFragmentDoc}
`;

/**
 * __useClientWorksheetsQuery__
 *
 * To run a query within a React component, call `useClientWorksheetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientWorksheetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientWorksheetsQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useClientWorksheetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ClientWorksheetsQuery,
    ClientWorksheetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ClientWorksheetsQuery, ClientWorksheetsQueryVariables>(
    ClientWorksheetsDocument,
    options,
  );
}
export function useClientWorksheetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ClientWorksheetsQuery,
    ClientWorksheetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ClientWorksheetsQuery,
    ClientWorksheetsQueryVariables
  >(ClientWorksheetsDocument, options);
}
export type ClientWorksheetsQueryHookResult = ReturnType<
  typeof useClientWorksheetsQuery
>;
export type ClientWorksheetsLazyQueryHookResult = ReturnType<
  typeof useClientWorksheetsLazyQuery
>;
export type ClientWorksheetsQueryResult = Apollo.QueryResult<
  ClientWorksheetsQuery,
  ClientWorksheetsQueryVariables
>;
export const WorksheetFormDocument = gql`
  query WorksheetForm($assignmentId: ID!) {
    worksheetForm(assignmentId: $assignmentId) {
      assignmentId
      subject
      templateId
      templateVersion
      name
      category
      language
      sections {
        ...WorksheetSectionFields
      }
      signatureRequired
      repeatable
      submittedAt
      submissionId
      awaitingSignature
      signedAt
      cancelled
    }
  }
  ${WorksheetSectionFieldsFragmentDoc}
`;

/**
 * __useWorksheetFormQuery__
 *
 * To run a query within a React component, call `useWorksheetFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorksheetFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksheetFormQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *   },
 * });
 */
export function useWorksheetFormQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorksheetFormQuery,
    WorksheetFormQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorksheetFormQuery, WorksheetFormQueryVariables>(
    WorksheetFormDocument,
    options,
  );
}
export function useWorksheetFormLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorksheetFormQuery,
    WorksheetFormQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorksheetFormQuery, WorksheetFormQueryVariables>(
    WorksheetFormDocument,
    options,
  );
}
export type WorksheetFormQueryHookResult = ReturnType<
  typeof useWorksheetFormQuery
>;
export type WorksheetFormLazyQueryHookResult = ReturnType<
  typeof useWorksheetFormLazyQuery
>;
export type WorksheetFormQueryResult = Apollo.QueryResult<
  WorksheetFormQuery,
  WorksheetFormQueryVariables
>;
export const WorksheetResponseDocument = gql`
  query WorksheetResponse($submissionId: ID!) {
    worksheetResponse(submissionId: $submissionId) {
      submissionId
      assignmentId
      subject
      templateId
      templateVersion
      name
      sections {
        ...WorksheetSectionFields
      }
      scoring {
        ...WorksheetScoringFields
      }
      answers
      performer
      performerName
      signatureRequired
      signerName
      submittedAt
      signedAt
      score
      band
      filledInSession
    }
  }
  ${WorksheetSectionFieldsFragmentDoc}
  ${WorksheetScoringFieldsFragmentDoc}
`;

/**
 * __useWorksheetResponseQuery__
 *
 * To run a query within a React component, call `useWorksheetResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorksheetResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksheetResponseQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useWorksheetResponseQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorksheetResponseQuery,
    WorksheetResponseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WorksheetResponseQuery,
    WorksheetResponseQueryVariables
  >(WorksheetResponseDocument, options);
}
export function useWorksheetResponseLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorksheetResponseQuery,
    WorksheetResponseQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorksheetResponseQuery,
    WorksheetResponseQueryVariables
  >(WorksheetResponseDocument, options);
}
export type WorksheetResponseQueryHookResult = ReturnType<
  typeof useWorksheetResponseQuery
>;
export type WorksheetResponseLazyQueryHookResult = ReturnType<
  typeof useWorksheetResponseLazyQuery
>;
export type WorksheetResponseQueryResult = Apollo.QueryResult<
  WorksheetResponseQuery,
  WorksheetResponseQueryVariables
>;
export const WorksheetEntriesOverTimeDocument = gql`
  query WorksheetEntriesOverTime($subject: ID!, $templateId: ID!) {
    worksheetEntriesOverTime(subject: $subject, templateId: $templateId) {
      subject
      templateId
      name
      numericFields {
        fieldKey
        label
        type
        min
        max
      }
      scoring {
        ...WorksheetScoringFields
      }
      points {
        submissionId
        occurredAt
        fieldKey
        value
      }
      series {
        fieldKey
        label
        type
        min
        max
        points {
          submissionId
          occurredAt
          value
        }
        latest
        count
      }
      entryCount
    }
  }
  ${WorksheetScoringFieldsFragmentDoc}
`;

/**
 * __useWorksheetEntriesOverTimeQuery__
 *
 * To run a query within a React component, call `useWorksheetEntriesOverTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorksheetEntriesOverTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorksheetEntriesOverTimeQuery({
 *   variables: {
 *      subject: // value for 'subject'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useWorksheetEntriesOverTimeQuery(
  baseOptions: Apollo.QueryHookOptions<
    WorksheetEntriesOverTimeQuery,
    WorksheetEntriesOverTimeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    WorksheetEntriesOverTimeQuery,
    WorksheetEntriesOverTimeQueryVariables
  >(WorksheetEntriesOverTimeDocument, options);
}
export function useWorksheetEntriesOverTimeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorksheetEntriesOverTimeQuery,
    WorksheetEntriesOverTimeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorksheetEntriesOverTimeQuery,
    WorksheetEntriesOverTimeQueryVariables
  >(WorksheetEntriesOverTimeDocument, options);
}
export type WorksheetEntriesOverTimeQueryHookResult = ReturnType<
  typeof useWorksheetEntriesOverTimeQuery
>;
export type WorksheetEntriesOverTimeLazyQueryHookResult = ReturnType<
  typeof useWorksheetEntriesOverTimeLazyQuery
>;
export type WorksheetEntriesOverTimeQueryResult = Apollo.QueryResult<
  WorksheetEntriesOverTimeQuery,
  WorksheetEntriesOverTimeQueryVariables
>;
export const PublishWorksheetTemplateDocument = gql`
  mutation PublishWorksheetTemplate($input: PublishWorksheetTemplateInput!) {
    publishWorksheetTemplate(input: $input) {
      templateId
      version
      recorded
    }
  }
`;
export type PublishWorksheetTemplateMutationFn = Apollo.MutationFunction<
  PublishWorksheetTemplateMutation,
  PublishWorksheetTemplateMutationVariables
>;

/**
 * __usePublishWorksheetTemplateMutation__
 *
 * To run a mutation, you first call `usePublishWorksheetTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishWorksheetTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishWorksheetTemplateMutation, { data, loading, error }] = usePublishWorksheetTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishWorksheetTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishWorksheetTemplateMutation,
    PublishWorksheetTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishWorksheetTemplateMutation,
    PublishWorksheetTemplateMutationVariables
  >(PublishWorksheetTemplateDocument, options);
}
export type PublishWorksheetTemplateMutationHookResult = ReturnType<
  typeof usePublishWorksheetTemplateMutation
>;
export type PublishWorksheetTemplateMutationResult =
  Apollo.MutationResult<PublishWorksheetTemplateMutation>;
export type PublishWorksheetTemplateMutationOptions =
  Apollo.BaseMutationOptions<
    PublishWorksheetTemplateMutation,
    PublishWorksheetTemplateMutationVariables
  >;
export const DefineWorksheetTemplateDocument = gql`
  mutation DefineWorksheetTemplate($input: DefineWorksheetTemplateInput!) {
    defineWorksheetTemplate(input: $input) {
      templateId
      version
      recorded
    }
  }
`;
export type DefineWorksheetTemplateMutationFn = Apollo.MutationFunction<
  DefineWorksheetTemplateMutation,
  DefineWorksheetTemplateMutationVariables
>;

/**
 * __useDefineWorksheetTemplateMutation__
 *
 * To run a mutation, you first call `useDefineWorksheetTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDefineWorksheetTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [defineWorksheetTemplateMutation, { data, loading, error }] = useDefineWorksheetTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefineWorksheetTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DefineWorksheetTemplateMutation,
    DefineWorksheetTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DefineWorksheetTemplateMutation,
    DefineWorksheetTemplateMutationVariables
  >(DefineWorksheetTemplateDocument, options);
}
export type DefineWorksheetTemplateMutationHookResult = ReturnType<
  typeof useDefineWorksheetTemplateMutation
>;
export type DefineWorksheetTemplateMutationResult =
  Apollo.MutationResult<DefineWorksheetTemplateMutation>;
export type DefineWorksheetTemplateMutationOptions = Apollo.BaseMutationOptions<
  DefineWorksheetTemplateMutation,
  DefineWorksheetTemplateMutationVariables
>;
export const ReviseWorksheetTemplateDocument = gql`
  mutation ReviseWorksheetTemplate($input: ReviseWorksheetTemplateInput!) {
    reviseWorksheetTemplate(input: $input) {
      templateId
      version
      recorded
    }
  }
`;
export type ReviseWorksheetTemplateMutationFn = Apollo.MutationFunction<
  ReviseWorksheetTemplateMutation,
  ReviseWorksheetTemplateMutationVariables
>;

/**
 * __useReviseWorksheetTemplateMutation__
 *
 * To run a mutation, you first call `useReviseWorksheetTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviseWorksheetTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviseWorksheetTemplateMutation, { data, loading, error }] = useReviseWorksheetTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviseWorksheetTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReviseWorksheetTemplateMutation,
    ReviseWorksheetTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReviseWorksheetTemplateMutation,
    ReviseWorksheetTemplateMutationVariables
  >(ReviseWorksheetTemplateDocument, options);
}
export type ReviseWorksheetTemplateMutationHookResult = ReturnType<
  typeof useReviseWorksheetTemplateMutation
>;
export type ReviseWorksheetTemplateMutationResult =
  Apollo.MutationResult<ReviseWorksheetTemplateMutation>;
export type ReviseWorksheetTemplateMutationOptions = Apollo.BaseMutationOptions<
  ReviseWorksheetTemplateMutation,
  ReviseWorksheetTemplateMutationVariables
>;
export const RetireWorksheetTemplateDocument = gql`
  mutation RetireWorksheetTemplate($input: RetireWorksheetTemplateInput!) {
    retireWorksheetTemplate(input: $input) {
      templateId
      version
      recorded
    }
  }
`;
export type RetireWorksheetTemplateMutationFn = Apollo.MutationFunction<
  RetireWorksheetTemplateMutation,
  RetireWorksheetTemplateMutationVariables
>;

/**
 * __useRetireWorksheetTemplateMutation__
 *
 * To run a mutation, you first call `useRetireWorksheetTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetireWorksheetTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retireWorksheetTemplateMutation, { data, loading, error }] = useRetireWorksheetTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetireWorksheetTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RetireWorksheetTemplateMutation,
    RetireWorksheetTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RetireWorksheetTemplateMutation,
    RetireWorksheetTemplateMutationVariables
  >(RetireWorksheetTemplateDocument, options);
}
export type RetireWorksheetTemplateMutationHookResult = ReturnType<
  typeof useRetireWorksheetTemplateMutation
>;
export type RetireWorksheetTemplateMutationResult =
  Apollo.MutationResult<RetireWorksheetTemplateMutation>;
export type RetireWorksheetTemplateMutationOptions = Apollo.BaseMutationOptions<
  RetireWorksheetTemplateMutation,
  RetireWorksheetTemplateMutationVariables
>;
export const SubmitWorksheetDocument = gql`
  mutation SubmitWorksheet($input: SubmitWorksheetInput!) {
    submitWorksheet(input: $input) {
      assignmentId
      submissionId
      recorded
    }
  }
`;
export type SubmitWorksheetMutationFn = Apollo.MutationFunction<
  SubmitWorksheetMutation,
  SubmitWorksheetMutationVariables
>;

/**
 * __useSubmitWorksheetMutation__
 *
 * To run a mutation, you first call `useSubmitWorksheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitWorksheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitWorksheetMutation, { data, loading, error }] = useSubmitWorksheetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitWorksheetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SubmitWorksheetMutation,
    SubmitWorksheetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SubmitWorksheetMutation,
    SubmitWorksheetMutationVariables
  >(SubmitWorksheetDocument, options);
}
export type SubmitWorksheetMutationHookResult = ReturnType<
  typeof useSubmitWorksheetMutation
>;
export type SubmitWorksheetMutationResult =
  Apollo.MutationResult<SubmitWorksheetMutation>;
export type SubmitWorksheetMutationOptions = Apollo.BaseMutationOptions<
  SubmitWorksheetMutation,
  SubmitWorksheetMutationVariables
>;
export const SignWorksheetDocument = gql`
  mutation SignWorksheet($input: SignWorksheetInput!) {
    signWorksheet(input: $input) {
      assignmentId
      submissionId
      recorded
    }
  }
`;
export type SignWorksheetMutationFn = Apollo.MutationFunction<
  SignWorksheetMutation,
  SignWorksheetMutationVariables
>;

/**
 * __useSignWorksheetMutation__
 *
 * To run a mutation, you first call `useSignWorksheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignWorksheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signWorksheetMutation, { data, loading, error }] = useSignWorksheetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignWorksheetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignWorksheetMutation,
    SignWorksheetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SignWorksheetMutation,
    SignWorksheetMutationVariables
  >(SignWorksheetDocument, options);
}
export type SignWorksheetMutationHookResult = ReturnType<
  typeof useSignWorksheetMutation
>;
export type SignWorksheetMutationResult =
  Apollo.MutationResult<SignWorksheetMutation>;
export type SignWorksheetMutationOptions = Apollo.BaseMutationOptions<
  SignWorksheetMutation,
  SignWorksheetMutationVariables
>;
export const ImportWorksheetTemplateDocument = gql`
  mutation ImportWorksheetTemplate($input: ImportWorksheetTemplateInput!) {
    importWorksheetTemplate(input: $input) {
      importId
      practiceId
      importedFrom {
        format
        pages
      }
      documents {
        templates
        knownInstruments
        skipped
      }
      drafts {
        kind
        pages
        draft {
          name
          category
          language
          sections {
            ...WorksheetSectionFields
          }
          scoring {
            ...WorksheetScoringFields
          }
          signatureRequired
          repeatable
        }
        notes {
          code
          pages
          source
          ref
          count
        }
        instrumentId
        instrument
        inCatalogue
        reason
      }
      instrumentIds
      code
    }
  }
  ${WorksheetSectionFieldsFragmentDoc}
  ${WorksheetScoringFieldsFragmentDoc}
`;
export type ImportWorksheetTemplateMutationFn = Apollo.MutationFunction<
  ImportWorksheetTemplateMutation,
  ImportWorksheetTemplateMutationVariables
>;

/**
 * __useImportWorksheetTemplateMutation__
 *
 * To run a mutation, you first call `useImportWorksheetTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportWorksheetTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importWorksheetTemplateMutation, { data, loading, error }] = useImportWorksheetTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportWorksheetTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ImportWorksheetTemplateMutation,
    ImportWorksheetTemplateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ImportWorksheetTemplateMutation,
    ImportWorksheetTemplateMutationVariables
  >(ImportWorksheetTemplateDocument, options);
}
export type ImportWorksheetTemplateMutationHookResult = ReturnType<
  typeof useImportWorksheetTemplateMutation
>;
export type ImportWorksheetTemplateMutationResult =
  Apollo.MutationResult<ImportWorksheetTemplateMutation>;
export type ImportWorksheetTemplateMutationOptions = Apollo.BaseMutationOptions<
  ImportWorksheetTemplateMutation,
  ImportWorksheetTemplateMutationVariables
>;
export const WorryTreesDocument = gql`
  query WorryTrees($sort: String, $where: JSON, $start: Int, $limit: Int) {
    worryTrees(sort: $sort, where: $where, start: $start, limit: $limit) {
      data {
        _id
        ...WorryTreeData
      }
      count
    }
  }
  ${WorryTreeDataFragmentDoc}
`;

/**
 * __useWorryTreesQuery__
 *
 * To run a query within a React component, call `useWorryTreesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorryTreesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorryTreesQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      where: // value for 'where'
 *      start: // value for 'start'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useWorryTreesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WorryTreesQuery,
    WorryTreesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorryTreesQuery, WorryTreesQueryVariables>(
    WorryTreesDocument,
    options,
  );
}
export function useWorryTreesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorryTreesQuery,
    WorryTreesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorryTreesQuery, WorryTreesQueryVariables>(
    WorryTreesDocument,
    options,
  );
}
export type WorryTreesQueryHookResult = ReturnType<typeof useWorryTreesQuery>;
export type WorryTreesLazyQueryHookResult = ReturnType<
  typeof useWorryTreesLazyQuery
>;
export type WorryTreesQueryResult = Apollo.QueryResult<
  WorryTreesQuery,
  WorryTreesQueryVariables
>;
export const WorryTreeDocument = gql`
  query WorryTree($_id: ID) {
    worryTree(_id: $_id) {
      _id
      ...WorryTreeData
    }
  }
  ${WorryTreeDataFragmentDoc}
`;

/**
 * __useWorryTreeQuery__
 *
 * To run a query within a React component, call `useWorryTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorryTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorryTreeQuery({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useWorryTreeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    WorryTreeQuery,
    WorryTreeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WorryTreeQuery, WorryTreeQueryVariables>(
    WorryTreeDocument,
    options,
  );
}
export function useWorryTreeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    WorryTreeQuery,
    WorryTreeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WorryTreeQuery, WorryTreeQueryVariables>(
    WorryTreeDocument,
    options,
  );
}
export type WorryTreeQueryHookResult = ReturnType<typeof useWorryTreeQuery>;
export type WorryTreeLazyQueryHookResult = ReturnType<
  typeof useWorryTreeLazyQuery
>;
export type WorryTreeQueryResult = Apollo.QueryResult<
  WorryTreeQuery,
  WorryTreeQueryVariables
>;
export const DeleteWorryTreeDocument = gql`
  mutation DeleteWorryTree($_id: ID) {
    deleteWorryTree(_id: $_id) {
      _id
      ...WorryTreeData
    }
  }
  ${WorryTreeDataFragmentDoc}
`;
export type DeleteWorryTreeMutationFn = Apollo.MutationFunction<
  DeleteWorryTreeMutation,
  DeleteWorryTreeMutationVariables
>;

/**
 * __useDeleteWorryTreeMutation__
 *
 * To run a mutation, you first call `useDeleteWorryTreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorryTreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorryTreeMutation, { data, loading, error }] = useDeleteWorryTreeMutation({
 *   variables: {
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useDeleteWorryTreeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWorryTreeMutation,
    DeleteWorryTreeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteWorryTreeMutation,
    DeleteWorryTreeMutationVariables
  >(DeleteWorryTreeDocument, options);
}
export type DeleteWorryTreeMutationHookResult = ReturnType<
  typeof useDeleteWorryTreeMutation
>;
export type DeleteWorryTreeMutationResult =
  Apollo.MutationResult<DeleteWorryTreeMutation>;
export type DeleteWorryTreeMutationOptions = Apollo.BaseMutationOptions<
  DeleteWorryTreeMutation,
  DeleteWorryTreeMutationVariables
>;
export const CreateWorryTreeDocument = gql`
  mutation CreateWorryTree($input: WorryTreeInput) {
    createWorryTree(input: $input) {
      _id
      ...WorryTreeData
    }
  }
  ${WorryTreeDataFragmentDoc}
`;
export type CreateWorryTreeMutationFn = Apollo.MutationFunction<
  CreateWorryTreeMutation,
  CreateWorryTreeMutationVariables
>;

/**
 * __useCreateWorryTreeMutation__
 *
 * To run a mutation, you first call `useCreateWorryTreeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorryTreeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorryTreeMutation, { data, loading, error }] = useCreateWorryTreeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorryTreeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorryTreeMutation,
    CreateWorryTreeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorryTreeMutation,
    CreateWorryTreeMutationVariables
  >(CreateWorryTreeDocument, options);
}
export type CreateWorryTreeMutationHookResult = ReturnType<
  typeof useCreateWorryTreeMutation
>;
export type CreateWorryTreeMutationResult =
  Apollo.MutationResult<CreateWorryTreeMutation>;
export type CreateWorryTreeMutationOptions = Apollo.BaseMutationOptions<
  CreateWorryTreeMutation,
  CreateWorryTreeMutationVariables
>;
